/*! For license information please see apple360spin.js.LICENSE.txt */
/*! 58cf3f3312cd7fd757a20f76920b14aa1adb513b */
(() => {
  var e = {
      8142: (e, t, n) => {
        "use strict";
        var i = n(9697),
          r = n(4423),
          a = n(5938),
          o = function (e, t) {
            (t = t || {}),
              (this._tabbables = null),
              (this._excludeHidden = t.excludeHidden),
              (this._firstTabbableElement = t.firstFocusElement),
              (this._lastTabbableElement = null),
              (this._relatedTarget = null),
              (this.el = e),
              (this._handleOnFocus = this._handleOnFocus.bind(this));
          },
          s = o.prototype;
        (s.start = function (e) {
          this.updateTabbables(), r(this.el, null, this._excludeHidden);
          let t = document.activeElement;
          this._firstTabbableElement
            ? this.el.contains(document.activeElement) ||
              e ||
              (this._firstTabbableElement.focus(),
              (t = this._firstTabbableElement))
            : console.warn(
                "this._firstTabbableElement is null, CircularTab needs at least one tabbable element."
              ),
            (this._relatedTarget = t),
            document.addEventListener("focus", this._handleOnFocus, !0);
        }),
          (s.stop = function () {
            a(this.el),
              document.removeEventListener("focus", this._handleOnFocus, !0);
          }),
          (s.updateTabbables = function () {
            (this._tabbables = i.getTabbableElements(
              this.el,
              this._excludeHidden
            )),
              (this._firstTabbableElement =
                this._firstTabbableElement || this._tabbables[0]),
              (this._lastTabbableElement =
                this._tabbables[this._tabbables.length - 1]);
          }),
          (s._handleOnFocus = function (e) {
            if (this.el.contains(e.target)) this._relatedTarget = e.target;
            else {
              if (
                (e.preventDefault(),
                this.updateTabbables(),
                this._relatedTarget === this._lastTabbableElement ||
                  null === this._relatedTarget)
              )
                return (
                  this._firstTabbableElement.focus(),
                  void (this._relatedTarget = this._firstTabbableElement)
                );
              if (
                this._relatedTarget === this._firstTabbableElement &&
                this._lastTabbableElement
              )
                return (
                  this._lastTabbableElement.focus(),
                  void (this._relatedTarget = this._lastTabbableElement)
                );
            }
          }),
          (s.destroy = function () {
            this.stop(),
              (this.el = null),
              (this._tabbables = null),
              (this._firstTabbableElement = null),
              (this._lastTabbableElement = null),
              (this._relatedTarget = null),
              (this._handleOnFocus = null);
          }),
          (e.exports = o);
      },
      9697: (e, t, n) => {
        "use strict";
        var i = n(9073),
          r = function () {
            this.focusableSelectors = i.selectors;
          },
          a = r.prototype;
        (a.isFocusableElement = function (e, t, n) {
          return (
            !(t && !this._isDisplayed(e)) &&
            (i.nodeName[e.nodeName]
              ? !e.disabled
              : !e.contentEditable ||
                ((n = n || parseFloat(e.getAttribute("tabindex"))), !isNaN(n)))
          );
        }),
          (a.isTabbableElement = function (e, t) {
            if (t && !this._isDisplayed(e)) return !1;
            var n = e.getAttribute("tabindex");
            return (
              (n = parseFloat(n)),
              isNaN(n) ? this.isFocusableElement(e, t, n) : n >= 0
            );
          }),
          (a._isDisplayed = function (e) {
            var t = e.getBoundingClientRect();
            return (
              (0 !== t.top ||
                0 !== t.left ||
                0 !== t.width ||
                0 !== t.height) &&
              "hidden" !== window.getComputedStyle(e).visibility
            );
          }),
          (a.getTabbableElements = function (e, t) {
            for (
              var n = e.querySelectorAll(this.focusableSelectors),
                i = n.length,
                r = [],
                a = 0;
              a < i;
              a++
            )
              this.isTabbableElement(n[a], t) && r.push(n[a]);
            return r;
          }),
          (a.getFocusableElements = function (e, t) {
            for (
              var n = e.querySelectorAll(this.focusableSelectors),
                i = n.length,
                r = [],
                a = 0;
              a < i;
              a++
            )
              this.isFocusableElement(n[a], t) && r.push(n[a]);
            return r;
          }),
          (e.exports = new r());
      },
      6815: (e, t, n) => {
        "use strict";
        var i = n(1302),
          r = n(9697),
          a = "data-original-",
          o = "tabindex",
          s = function (e, t) {
            var n = e.getAttribute(a + t);
            n || ((n = e.getAttribute(t) || ""), e.setAttribute(a + t, n));
          };
        e.exports = function (e, t) {
          if (r.isFocusableElement(e, t)) s(e, o), e.setAttribute(o, "-1");
          else
            for (var n = r.getTabbableElements(e, t), a = n.length; a--; )
              s(n[a], o), n[a].setAttribute(o, "-1");
          s(e, i.HIDDEN), e.setAttribute(i.HIDDEN, "true");
        };
      },
      4423: (e, t, n) => {
        "use strict";
        var i = n(6815);
        e.exports = function e(t, n, r) {
          n = n || document.body;
          for (var a = t, o = t; (a = a.previousElementSibling); ) i(a, r);
          for (; (o = o.nextElementSibling); ) i(o, r);
          t.parentElement && t.parentElement !== n && e(t.parentElement, n, r);
        };
      },
      1401: (e) => {
        "use strict";
        e.exports = function (e, t) {
          let n;
          (n = e instanceof NodeList ? e : [].concat(e)),
            (t = Array.isArray(t) ? t : [].concat(t)),
            n.forEach((e) => {
              t.forEach((t) => {
                e.removeAttribute(t);
              });
            });
        };
      },
      2173: (e, t, n) => {
        "use strict";
        var i = n(1401),
          r = n(1302),
          a = "data-original-",
          o = "tabindex",
          s = function (e, t) {
            var n = e.getAttribute(a + t);
            null !== n &&
              ("" === n ? i(e, t) : e.setAttribute(t, n), i(e, a + t));
          };
        e.exports = function (e) {
          s(e, o), s(e, r.HIDDEN);
          for (var t = e.querySelectorAll(`[${a + o}]`), n = t.length; n--; )
            s(t[n], o);
        };
      },
      5938: (e, t, n) => {
        "use strict";
        var i = n(2173);
        e.exports = function e(t, n) {
          n = n || document.body;
          for (var r = t, a = t; (r = r.previousElementSibling); ) i(r);
          for (; (a = a.nextElementSibling); ) i(a);
          t.parentElement && t.parentElement !== n && e(t.parentElement, n);
        };
      },
      1302: (e) => {
        "use strict";
        e.exports = {
          AUTOCOMPLETE: "aria-autocomplete",
          CHECKED: "aria-checked",
          DISABLED: "aria-disabled",
          EXPANDED: "aria-expanded",
          HASPOPUP: "aria-haspopup",
          HIDDEN: "aria-hidden",
          INVALID: "aria-invalid",
          LABEL: "aria-label",
          LEVEL: "aria-level",
          MULTILINE: "aria-multiline",
          MULTISELECTABLE: "aria-multiselectable",
          ORIENTATION: "aria-orientation",
          PRESSED: "aria-pressed",
          READONLY: "aria-readonly",
          REQUIRED: "aria-required",
          SELECTED: "aria-selected",
          SORT: "aria-sort",
          VALUEMAX: "aria-valuemax",
          VALUEMIN: "aria-valuemin",
          VALUENOW: "aria-valuenow",
          VALUETEXT: "aria-valuetext",
          ATOMIC: "aria-atomic",
          BUSY: "aria-busy",
          LIVE: "aria-live",
          RELEVANT: "aria-relevant",
          DROPEFFECT: "aria-dropeffect",
          GRABBED: "aria-grabbed",
          ACTIVEDESCENDANT: "aria-activedescendant",
          CONTROLS: "aria-controls",
          DESCRIBEDBY: "aria-describedby",
          FLOWTO: "aria-flowto",
          LABELLEDBY: "aria-labelledby",
          OWNS: "aria-owns",
          POSINSET: "aria-posinset",
          SETSIZE: "aria-setsize",
        };
      },
      9073: (e) => {
        "use strict";
        e.exports = {
          selectors: [
            "input",
            "select",
            "textarea",
            "button",
            "optgroup",
            "option",
            "menuitem",
            "fieldset",
            "object",
            "a[href]",
            "[tabindex]",
            "[contenteditable]",
          ].join(","),
          nodeName: {
            INPUT: "input",
            SELECT: "select",
            TEXTAREA: "textarea",
            BUTTON: "button",
            OPTGROUP: "optgroup",
            OPTION: "option",
            MENUITEM: "menuitem",
            FIELDSET: "fieldset",
            OBJECT: "object",
            A: "a",
          },
        };
      },
      44: (e) => {
        "use strict";
        e.exports = function (e) {
          return !(!e || !e.nodeType);
        };
      },
      5350: (e, t, n) => {
        "use strict";
        e.exports = { EventEmitterMicro: n(8010) };
      },
      8010: (e) => {
        "use strict";
        function t() {
          this._events = {};
        }
        let n = t.prototype;
        (n.on = function (e, t) {
          return (
            (this._events[e] = this._events[e] || []),
            this._events[e].unshift(t),
            t
          );
        }),
          (n.once = function (e, t) {
            let n = this;
            return this.on(e, function i(r) {
              n.off(e, i), void 0 !== r ? t(r) : t();
            });
          }),
          (n.off = function (e, t) {
            if (!this.has(e)) return;
            if (1 === arguments.length)
              return (this._events[e] = null), void delete this._events[e];
            let n = this._events[e].indexOf(t);
            -1 !== n && this._events[e].splice(n, 1);
          }),
          (n.trigger = function (e, t) {
            if (this.has(e))
              for (let n = this._events[e].length - 1; n >= 0; n--)
                void 0 !== t ? this._events[e][n](t) : this._events[e][n]();
          }),
          (n.has = function (e) {
            return e in this._events != !1 && 0 !== this._events[e].length;
          }),
          (n.destroy = function () {
            for (let e in this._events) this._events[e] = null;
            this._events = null;
          }),
          (e.exports = t);
      },
      1704: (e, t, n) => {
        const i = n(8010),
          r = n(8163),
          a = "keydown",
          o = "keyup";
        e.exports = class extends i {
          constructor(e) {
            super(),
              (this._keysDown = {}),
              (this._DOMKeyDown = this._DOMKeyDown.bind(this)),
              (this._DOMKeyUp = this._DOMKeyUp.bind(this)),
              (this._context = e || document),
              this._context.addEventListener(a, this._DOMKeyDown, !0),
              this._context.addEventListener(o, this._DOMKeyUp, !0);
          }
          onDown(e, t) {
            return this.on(a + ":" + e, t);
          }
          onceDown(e, t) {
            return this.once(a + ":" + e, t);
          }
          offDown(e, t) {
            return this.off(a + ":" + e, t);
          }
          onUp(e, t) {
            return this.on(o + ":" + e, t);
          }
          onceUp(e, t) {
            return this.once(o + ":" + e, t);
          }
          offUp(e, t) {
            return this.off(o + ":" + e, t);
          }
          isDown(e) {
            return (e += ""), this._keysDown[e] || !1;
          }
          isUp(e) {
            return !this.isDown(e);
          }
          destroy() {
            return (
              this._context.removeEventListener(a, this._DOMKeyDown, !0),
              this._context.removeEventListener(o, this._DOMKeyUp, !0),
              (this._keysDown = null),
              (this._context = null),
              super.destroy(),
              this
            );
          }
          _DOMKeyDown(e) {
            var t = this._normalizeKeyboardEvent(e),
              n = (t.keyCode += "");
            this._trackKeyDown(n), this.trigger(a + ":" + n, t);
          }
          _DOMKeyUp(e) {
            var t = this._normalizeKeyboardEvent(e),
              n = (t.keyCode += "");
            this._trackKeyUp(n), this.trigger(o + ":" + n, t);
          }
          _normalizeKeyboardEvent(e) {
            return new r(e);
          }
          _trackKeyUp(e) {
            this._keysDown[e] && (this._keysDown[e] = !1);
          }
          _trackKeyDown(e) {
            this._keysDown[e] || (this._keysDown[e] = !0);
          }
        };
      },
      6266: (e, t, n) => {
        "use strict";
        const i = n(1704);
        e.exports = new i();
      },
      8163: (e, t, n) => {
        "use strict";
        const i = n(2312),
          r = ["keyLocation", "keyIdentifier"],
          a = "keyCode";
        e.exports = class {
          constructor(e) {
            this.originalEvent = e;
            for (let t in e)
              -1 === r.indexOf(t) &&
                "function" != typeof e[t] &&
                (this[t] = e[t]);
            this[a] || (this[a] = this._getKeyCode()),
              (this.location =
                void 0 !== this.originalEvent.location
                  ? this.originalEvent.location
                  : this.originalEvent.keyLocation);
          }
          preventDefault() {
            if ("function" == typeof this.originalEvent.preventDefault)
              return this.originalEvent.preventDefault();
            this.originalEvent.returnValue = !1;
          }
          stopPropagation() {
            return this.originalEvent.stopPropagation();
          }
          _getKeyCode() {
            return i[this.code] || -1;
          }
        };
      },
      2312: (e) => {
        "use strict";
        e.exports = {
          Backspace: 8,
          Tab: 9,
          Enter: 13,
          NumpadEnter: 13,
          ShiftLeft: 16,
          ShiftRight: 16,
          ControlLeft: 17,
          ControlRight: 17,
          AltLeft: 18,
          AltRight: 18,
          CapsLock: 20,
          Escape: 27,
          PageUp: 33,
          PageDown: 34,
          End: 35,
          Home: 36,
          ArrowLeft: 37,
          ArrowUp: 38,
          ArrowRight: 39,
          ArrowDown: 40,
          Delete: 46,
          Digit0: 48,
          Digit1: 49,
          Digit2: 50,
          Digit3: 51,
          Digit4: 52,
          Digit5: 53,
          Digit6: 54,
          Digit7: 55,
          Digit8: 56,
          Digit9: 57,
          KeyA: 65,
          KeyB: 66,
          KeyC: 67,
          KeyD: 68,
          KeyE: 69,
          KeyF: 70,
          KeyG: 71,
          KeyH: 72,
          KeyI: 73,
          KeyJ: 74,
          KeyK: 75,
          KeyL: 76,
          KeyM: 77,
          KeyN: 78,
          KeyO: 79,
          KeyP: 80,
          KeyQ: 81,
          KeyR: 82,
          KeyS: 83,
          KeyT: 84,
          KeyU: 85,
          KeyV: 86,
          KeyW: 87,
          KeyX: 88,
          KeyY: 89,
          KeyZ: 90,
          Numpad0: 96,
          Numpad1: 97,
          Numpad2: 98,
          Numpad3: 99,
          Numpad4: 100,
          Numpad5: 101,
          Numpad6: 102,
          Numpad7: 103,
          Numpad8: 104,
          Numpad9: 105,
          NumpadMultiply: 106,
          NumpadAdd: 107,
          NumpadSubtract: 109,
          NumpadDecimal: 110,
          NumpadDivide: 111,
          NumpadEqual: 187,
          Backquote: 192,
          BracketLeft: 219,
          BracketRight: 221,
          Backslash: 220,
          Semicolon: 186,
          Quote: 222,
          Space: 32,
          Equal: 187,
          Comma: 188,
          Minus: 189,
          Period: 190,
          Slash: 191,
        };
      },
      4472: (e) => {
        "use strict";
        e.exports = {
          BACKSPACE: 8,
          TAB: 9,
          ENTER: 13,
          SHIFT: 16,
          CONTROL: 17,
          ALT: 18,
          COMMAND: 91,
          CAPSLOCK: 20,
          ESCAPE: 27,
          PAGE_UP: 33,
          PAGE_DOWN: 34,
          END: 35,
          HOME: 36,
          ARROW_LEFT: 37,
          ARROW_UP: 38,
          ARROW_RIGHT: 39,
          ARROW_DOWN: 40,
          DELETE: 46,
          ZERO: 48,
          ONE: 49,
          TWO: 50,
          THREE: 51,
          FOUR: 52,
          FIVE: 53,
          SIX: 54,
          SEVEN: 55,
          EIGHT: 56,
          NINE: 57,
          A: 65,
          B: 66,
          C: 67,
          D: 68,
          E: 69,
          F: 70,
          G: 71,
          H: 72,
          I: 73,
          J: 74,
          K: 75,
          L: 76,
          M: 77,
          N: 78,
          O: 79,
          P: 80,
          Q: 81,
          R: 82,
          S: 83,
          T: 84,
          U: 85,
          V: 86,
          W: 87,
          X: 88,
          Y: 89,
          Z: 90,
          NUMPAD_ZERO: 96,
          NUMPAD_ONE: 97,
          NUMPAD_TWO: 98,
          NUMPAD_THREE: 99,
          NUMPAD_FOUR: 100,
          NUMPAD_FIVE: 101,
          NUMPAD_SIX: 102,
          NUMPAD_SEVEN: 103,
          NUMPAD_EIGHT: 104,
          NUMPAD_NINE: 105,
          NUMPAD_ASTERISK: 106,
          NUMPAD_PLUS: 107,
          NUMPAD_DASH: 109,
          NUMPAD_DOT: 110,
          NUMPAD_SLASH: 111,
          NUMPAD_EQUALS: 187,
          TICK: 192,
          LEFT_BRACKET: 219,
          RIGHT_BRACKET: 221,
          BACKSLASH: 220,
          SEMICOLON: 186,
          APOSTROPHE: 222,
          SPACEBAR: 32,
          CLEAR: 12,
          COMMA: 188,
          DOT: 190,
          SLASH: 191,
        };
      },
      2405: (e, t, n) => {
        const i = n(6266);
        e.exports = {
          beforeCreate() {
            (this._keysToOpen = this.model.Keyboard.open.keys),
              (this._keysToClose = this.model.Keyboard.close.keys),
              (this._enabledKeysToOpen = []),
              (this._enabledKeysToClose = []);
          },
          onWillOpen() {
            this._keysToOpen.forEach(this.disableKeyToOpen, this),
              this._keysToClose.forEach(this.enableKeyToClose, this);
          },
          onWillClose() {
            this._keysToOpen.forEach(this.enableKeyToOpen, this),
              this._keysToClose.forEach(this.disableKeyToClose, this);
          },
          destroy() {
            this._keysToOpen.forEach(this.disableKeyToOpen, this),
              this._keysToClose.forEach(this.disableKeyToClose, this);
          },
          addKeyToOpen(e) {
            -1 === this._keysToOpen.indexOf(e) &&
              (this._keysToOpen.push(e), this.enableKeyToOpen(e));
          },
          addKeyToClose(e) {
            -1 === this._keysToClose.indexOf(e) &&
              (this._keysToClose.push(e), this.enableKeyToClose(e));
          },
          removeKeyToOpen(e) {
            const t = this._keysToOpen.indexOf(e);
            -1 !== t &&
              (this._keysToOpen.splice(t, 1), this.disableKeyToOpen(e));
          },
          removeAllKeysToOpen() {
            this._keysToOpen.forEach(this.disableKeyToOpen, this),
              this._keysToOpen.splice(0, this._keysToOpen.length);
          },
          removeKeyToClose(e) {
            const t = this._keysToClose.indexOf(e);
            -1 !== t &&
              (this._keysToClose.splice(t, 1), this.disableKeyToClose(e));
          },
          removeAllKeysToClose() {
            this._keysToClose.forEach(this.disableKeyToClose, this),
              this._keysToClose.splice(0, this._keysToClose.length);
          },
          enableKeyToOpen(e) {
            -1 === this._enabledKeysToOpen.indexOf(e) &&
              (i.onUp(e, this.open, this), this._enabledKeysToOpen.push(e));
          },
          enableKeyToClose(e) {
            -1 === this._enabledKeysToClose.indexOf(e) &&
              (i.onUp(e, this.close, this), this._enabledKeysToClose.push(e));
          },
          disableKeyToOpen(e) {
            const t = this._enabledKeysToOpen.indexOf(e);
            -1 !== t &&
              (i.offUp(e, this.open, this),
              this._enabledKeysToOpen.splice(t, 1));
          },
          disableKeyToClose(e) {
            const t = this._enabledKeysToClose.indexOf(e);
            -1 !== t &&
              (i.offUp(e, this.close, this),
              this._enabledKeysToClose.splice(t, 1));
          },
        };
      },
      4972: (e, t, n) => {
        "use strict";
        var i = n(7624),
          r = n(2137),
          a = n(6063),
          o = n(8673),
          s = {};
        e.exports = function e(t, n) {
          var l, c, u;
          if (
            ((n = n || "div"),
            (t = t.toLowerCase()),
            n in s || (s[n] = {}),
            t in (c = s[n]))
          )
            return c[t];
          if (i(t, n)) return (c[t] = t);
          if (t in r)
            for (u = 0; u < r[t].length; u++)
              if (((l = r[t][u]), i(l.toLowerCase(), n))) return (c[t] = l);
          for (u = 0; u < o.evt.length; u++)
            if (((l = o.evt[u] + t), i(l, n))) return o.reduce(u), (c[t] = l);
          return "window" !== n && a.indexOf(t)
            ? (c[t] = e(t, "window"))
            : (c[t] = !1);
        };
      },
      1286: (e, t, n) => {
        "use strict";
        var i = n(5123),
          r = n(9909),
          a = n(6733),
          o = n(6181),
          s = n(8673),
          l = function (e, t) {
            var n = a(e),
              r = !1 !== t && a(t);
            return (i[e] = i[t] = i[n] = i[r] = { dom: t, css: r }), t;
          };
        e.exports = function (e) {
          var t, n, a, c;
          if ((e += "") in i) return i[e].dom;
          for (
            a = r(),
              n = (e = o(e)).charAt(0).toUpperCase() + e.substring(1),
              t =
                "filter" === e
                  ? ["WebkitFilter", "filter"]
                  : (e + " " + s.dom.join(n + " ") + n).split(" "),
              c = 0;
            c < t.length;
            c++
          )
            if (void 0 !== a.style[t[c]])
              return 0 !== c && s.reduce(c - 1), l(e, t[c]);
          return l(e, !1);
        };
      },
      1578: (e, t, n) => {
        "use strict";
        var i = n(1286),
          r = n(7747),
          a = n(8673),
          o = n(5123),
          s = {},
          l = /(\([^\)]+\))/gi,
          c = /([^ ,;\(]+(\([^\)]+\))?)/gi;
        e.exports = function (e, t) {
          var n;
          return (
            (t += ""),
            !!(e = i(e)) &&
              (r(e, t)
                ? t
                : ((n = o[e].css),
                  "" !==
                    (t = (t = t.replace(c, function (t) {
                      var i, o, c, u;
                      if ("#" === t[0] || !isNaN(t[0])) return t;
                      if (((o = t.replace(l, "")), (c = n + ":" + o) in s))
                        return !1 === s[c] ? "" : t.replace(o, s[c]);
                      for (
                        i = a.css.map(function (e) {
                          return e + t;
                        }),
                          i = [t].concat(i),
                          u = 0;
                        u < i.length;
                        u++
                      )
                        if (r(e, i[u]))
                          return (
                            0 !== u && a.reduce(u - 1),
                            (s[c] = i[u].replace(l, "")),
                            i[u]
                          );
                      return (s[c] = !1), "";
                    })).trim()) && t))
          );
        };
      },
      2137: (e) => {
        "use strict";
        e.exports = {
          transitionend: ["webkitTransitionEnd", "MSTransitionEnd"],
          animationstart: ["webkitAnimationStart", "MSAnimationStart"],
          animationend: ["webkitAnimationEnd", "MSAnimationEnd"],
          animationiteration: [
            "webkitAnimationIteration",
            "MSAnimationIteration",
          ],
          fullscreenchange: ["MSFullscreenChange"],
          fullscreenerror: ["MSFullscreenError"],
        };
      },
      9909: (e) => {
        "use strict";
        var t;
        (e.exports = function () {
          return (
            t
              ? ((t.style.cssText = ""), t.removeAttribute("style"))
              : (t = document.createElement("_")),
            t
          );
        }),
          (e.exports.resetElement = function () {
            t = null;
          });
      },
      8673: (e) => {
        "use strict";
        var t = ["-webkit-", "-moz-", "-ms-"],
          n = ["Webkit", "Moz", "ms"],
          i = ["webkit", "moz", "ms"],
          r = function () {
            this.initialize();
          },
          a = r.prototype;
        (a.initialize = function () {
          (this.reduced = !1), (this.css = t), (this.dom = n), (this.evt = i);
        }),
          (a.reduce = function (e) {
            this.reduced ||
              ((this.reduced = !0),
              (this.css = [this.css[e]]),
              (this.dom = [this.dom[e]]),
              (this.evt = [this.evt[e]]));
          }),
          (e.exports = new r());
      },
      5123: (e) => {
        "use strict";
        e.exports = {};
      },
      7747: (e, t, n) => {
        "use strict";
        var i,
          r,
          a = n(5123),
          o = n(9909),
          s = !1;
        (e.exports = function (e, t) {
          var n, l;
          if (
            ((function () {
              var e;
              if (!s) {
                (s = !0),
                  (i = "CSS" in window && "supports" in window.CSS),
                  (r = !1),
                  (e = o());
                try {
                  e.style.width = "invalid";
                } catch (e) {
                  r = !0;
                }
              }
            })(),
            i)
          )
            return (e = a[e].css), CSS.supports(e, t);
          if (((n = (l = o()).style[e]), r))
            try {
              l.style[e] = t;
            } catch (e) {
              return !1;
            }
          else l.style[e] = t;
          return l.style[e] && l.style[e] !== n;
        }),
          (e.exports.resetFlags = function () {
            s = !1;
          });
      },
      6063: (e) => {
        "use strict";
        e.exports = [
          "transitionend",
          "animationstart",
          "animationend",
          "animationiteration",
        ];
      },
      7624: (e) => {
        "use strict";
        var t = { window, document };
        e.exports = function (e, n) {
          var i;
          return (
            (e = "on" + e),
            n in t || (t[n] = document.createElement(n)),
            e in (i = t[n]) ||
              ("setAttribute" in i &&
                (i.setAttribute(e, "return;"), "function" == typeof i[e]))
          );
        };
      },
      6733: (e) => {
        "use strict";
        var t = /^(webkit|moz|ms)/gi;
        e.exports = function (e) {
          return "cssfloat" === e.toLowerCase()
            ? "float"
            : (t.test(e) && (e = "-" + e),
              e
                .replace(/([A-Z]+)([A-Z][a-z])/g, "$1-$2")
                .replace(/([a-z\d])([A-Z])/g, "$1-$2")
                .toLowerCase());
        };
      },
      6181: (e) => {
        "use strict";
        var t = /-([a-z])/g;
        e.exports = function (e) {
          return "float" === e.toLowerCase()
            ? "cssFloat"
            : ("Ms" ===
                (e = e.replace(t, function (e, t) {
                  return t.toUpperCase();
                })).substr(0, 2) && (e = "ms" + e.substring(2)),
              e);
        };
      },
      7503: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579),
          a = function () {
            var e = i.getDocument().createElement("canvas");
            return !("function" != typeof e.getContext || !e.getContext("2d"));
          };
        (e.exports = r(a)), (e.exports.original = a);
      },
      1606: (e, t, n) => {
        "use strict";
        var i = n(820),
          r = n(1843).original,
          a = n(8579);
        function o() {
          return (
            !r() || (i.os.ios && i.os.version.major >= 8) || i.browser.chrome
          );
        }
        (e.exports = a(o)), (e.exports.original = o);
      },
      4138: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          var e = !1,
            t = i.getDocument(),
            n = i.getNavigator();
          try {
            "cookie" in t &&
              n.cookieEnabled &&
              ((t.cookie = "ac_feature_cookie=1"),
              (e = -1 !== t.cookie.indexOf("ac_feature_cookie")),
              (t.cookie =
                "ac_feature_cookie=; expires=Thu, 01 Jan 1970 00:00:01 GMT;"));
          } catch (e) {}
          return e;
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      6762: (e, t, n) => {
        "use strict";
        var i = n(1578),
          r = n(8579);
        function a() {
          return [
            "linear-gradient(to bottom right, #9f9, white)",
            "linear-gradient(top left, #9f9, white)",
            "gradient(linear, left top, right bottom, from(#9f9), to(white))",
          ].some(function (e) {
            return !!i("background-image", e);
          });
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      3900: (e, t, n) => {
        "use strict";
        var i = n(1578),
          r = n(1286),
          a = n(2708);
        function o(e, t) {
          return void 0 !== t ? !!i(e, t) : !!r(e);
        }
        (e.exports = a(o)), (e.exports.original = o);
      },
      688: (e, t, n) => {
        "use strict";
        var i = n(1578),
          r = n(8579);
        function a() {
          return !!i("margin", "1vw 1vh");
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      2549: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(2708);
        function a(e, t) {
          return (t = t || "div"), e in i.getDocument().createElement(t);
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      8396: (e, t, n) => {
        "use strict";
        var i = n(4972),
          r = n(2708);
        function a(e, t) {
          return !!i(e, t);
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      3251: (e, t, n) => {
        "use strict";
        e.exports = {
          canvasAvailable: n(7503),
          continuousScrollEventsAvailable: n(1606),
          cookiesAvailable: n(4138),
          cssLinearGradientAvailable: n(6762),
          cssPropertyAvailable: n(3900),
          cssViewportUnitsAvailable: n(688),
          elementAttributeAvailable: n(2549),
          eventTypeAvailable: n(8396),
          isDesktop: n(9333),
          isHandheld: n(85),
          isRetina: n(7665),
          isTablet: n(2915),
          localStorageAvailable: n(1073),
          mediaElementsAvailable: n(2846),
          mediaQueriesAvailable: n(6334),
          prefersReducedMotion: n(6028),
          sessionStorageAvailable: n(2538),
          svgAvailable: n(9007),
          threeDTransformsAvailable: n(7151),
          touchAvailable: n(1843),
          webGLAvailable: n(2299),
        };
      },
      9846: (e) => {
        "use strict";
        e.exports = {
          getWindow: function () {
            return window;
          },
          getDocument: function () {
            return document;
          },
          getNavigator: function () {
            return navigator;
          },
        };
      },
      9333: (e, t, n) => {
        "use strict";
        var i = n(820).os,
          r = n(1843).original,
          a = n(9846),
          o = n(8579);
        function s() {
          var e = a.getWindow();
          return (!r() && !e.orientation) || i.windows;
        }
        (e.exports = o(s)), (e.exports.original = s);
      },
      85: (e, t, n) => {
        "use strict";
        var i = n(9333).original,
          r = n(2915).original,
          a = n(8579);
        function o() {
          return !i() && !r();
        }
        (e.exports = a(o)), (e.exports.original = o);
      },
      7665: (e, t, n) => {
        "use strict";
        var i = n(9846);
        e.exports = function () {
          var e = i.getWindow();
          return "devicePixelRatio" in e && e.devicePixelRatio >= 1.5;
        };
      },
      2915: (e, t, n) => {
        "use strict";
        var i = n(9333).original,
          r = n(9846),
          a = n(8579);
        function o() {
          var e = r.getWindow(),
            t = e.screen.width;
          return (
            e.orientation && e.screen.height < t && (t = e.screen.height),
            !i() && t >= 600
          );
        }
        (e.exports = a(o)), (e.exports.original = o);
      },
      1073: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          var e = i.getWindow(),
            t = !1;
          try {
            t = !(!e.localStorage || null === e.localStorage.non_existent);
          } catch (e) {}
          return t;
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      2846: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          return "HTMLMediaElement" in i.getWindow();
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      6334: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          var e = i.getWindow().matchMedia("only all");
          return !(!e || !e.matches);
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      6028: (e, t, n) => {
        "use strict";
        var i = n(9846);
        e.exports = function () {
          var e = i.getWindow().matchMedia("(prefers-reduced-motion)");
          return !(!e || !e.matches);
        };
      },
      2538: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          var e = i.getWindow(),
            t = !1;
          try {
            "sessionStorage" in e &&
              "function" == typeof e.sessionStorage.setItem &&
              (e.sessionStorage.setItem("ac_feature", "test"),
              (t = !0),
              e.sessionStorage.removeItem("ac_feature", "test"));
          } catch (e) {}
          return t;
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      9007: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          return !!i
            .getDocument()
            .implementation.hasFeature(
              "http://www.w3.org/TR/SVG11/feature#Image",
              "1.1"
            );
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      7151: (e, t, n) => {
        "use strict";
        var i = n(1578),
          r = n(8579);
        function a() {
          return !(
            !i("perspective", "1px") || !i("transform", "translateZ(0)")
          );
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      1843: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          var e = i.getWindow(),
            t = i.getDocument(),
            n = i.getNavigator();
          return !!(
            "ontouchstart" in e ||
            (e.DocumentTouch && t instanceof e.DocumentTouch) ||
            n.maxTouchPoints > 0 ||
            n.msMaxTouchPoints > 0
          );
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      2299: (e, t, n) => {
        "use strict";
        var i = n(9846),
          r = n(8579);
        function a() {
          var e = i.getDocument().createElement("canvas");
          return (
            "function" == typeof e.getContext &&
            !(!e.getContext("webgl") && !e.getContext("experimental-webgl"))
          );
        }
        (e.exports = r(a)), (e.exports.original = a);
      },
      2708: (e) => {
        "use strict";
        var t = function () {
          var e,
            t = "";
          for (e = 0; e < arguments.length; e++)
            e > 0 && (t += ","), (t += arguments[e]);
          return t;
        };
        e.exports = function (e, n) {
          n = n || t;
          var i = function () {
            var t = arguments,
              r = n.apply(this, t);
            return r in i.cache || (i.cache[r] = e.apply(this, t)), i.cache[r];
          };
          return (i.cache = {}), i;
        };
      },
      8579: (e) => {
        "use strict";
        e.exports = function (e) {
          var t;
          return function () {
            return void 0 === t && (t = e.apply(this, arguments)), t;
          };
        };
      },
      2324: (e) => {
        "use strict";
        e.exports = {
          browser: {
            safari: !1,
            chrome: !1,
            firefox: !1,
            ie: !1,
            opera: !1,
            android: !1,
            edge: !1,
            edgeChromium: !1,
            samsung: !1,
            version: {
              string: "",
              major: 0,
              minor: 0,
              patch: 0,
              documentMode: !1,
            },
          },
          os: {
            osx: !1,
            ios: !1,
            android: !1,
            windows: !1,
            linux: !1,
            fireos: !1,
            chromeos: !1,
            version: { string: "", major: 0, minor: 0, patch: 0 },
          },
        };
      },
      7106: (e) => {
        "use strict";
        e.exports = {
          browser: [
            {
              name: "edge",
              userAgent: "Edge",
              version: ["rv", "Edge"],
              test: function (e) {
                return (
                  e.ua.indexOf("Edge") > -1 ||
                  "Mozilla/5.0 (Windows NT 10.0; Win64; x64)" === e.ua
                );
              },
            },
            {
              name: "edgeChromium",
              userAgent: "Edge",
              version: ["rv", "Edg"],
              test: function (e) {
                return e.ua.indexOf("Edg") > -1 && -1 === e.ua.indexOf("Edge");
              },
            },
            { name: "chrome", userAgent: "Chrome" },
            {
              name: "firefox",
              test: function (e) {
                return (
                  e.ua.indexOf("Firefox") > -1 && -1 === e.ua.indexOf("Opera")
                );
              },
              version: "Firefox",
            },
            { name: "android", userAgent: "Android" },
            {
              name: "safari",
              test: function (e) {
                return (
                  e.ua.indexOf("Safari") > -1 && e.vendor.indexOf("Apple") > -1
                );
              },
              version: "Version",
            },
            {
              name: "ie",
              test: function (e) {
                return e.ua.indexOf("IE") > -1 || e.ua.indexOf("Trident") > -1;
              },
              version: ["MSIE", "rv"],
              parseDocumentMode: function () {
                var e = !1;
                return (
                  document.documentMode &&
                    (e = parseInt(document.documentMode, 10)),
                  e
                );
              },
            },
            {
              name: "opera",
              userAgent: "Opera",
              version: ["Version", "Opera"],
            },
            { name: "samsung", userAgent: "SamsungBrowser" },
          ],
          os: [
            {
              name: "windows",
              test: function (e) {
                return e.ua.indexOf("Windows") > -1;
              },
              version: "Windows NT",
            },
            {
              name: "osx",
              userAgent: "Mac",
              test: function (e) {
                return e.ua.indexOf("Macintosh") > -1;
              },
            },
            {
              name: "ios",
              test: function (e) {
                return e.ua.indexOf("iPhone") > -1 || e.ua.indexOf("iPad") > -1;
              },
              version: ["iPhone OS", "CPU OS"],
            },
            {
              name: "linux",
              userAgent: "Linux",
              test: function (e) {
                return (
                  (e.ua.indexOf("Linux") > -1 ||
                    e.platform.indexOf("Linux") > -1) &&
                  -1 === e.ua.indexOf("Android")
                );
              },
            },
            {
              name: "fireos",
              test: function (e) {
                return (
                  e.ua.indexOf("Firefox") > -1 && e.ua.indexOf("Mobile") > -1
                );
              },
              version: "rv",
            },
            {
              name: "android",
              userAgent: "Android",
              test: function (e) {
                return e.ua.indexOf("Android") > -1;
              },
            },
            { name: "chromeos", userAgent: "CrOS" },
          ],
        };
      },
      1620: (e, t, n) => {
        "use strict";
        var i = n(2324),
          r = n(7106);
        function a(e, t) {
          if ("function" == typeof e.parseVersion) return e.parseVersion(t);
          var n,
            i = e.version || e.userAgent;
          "string" == typeof i && (i = [i]);
          for (var r, a = i.length, o = 0; o < a; o++)
            if (
              (r = t.match(
                ((n = i[o]), new RegExp(n + "[a-zA-Z\\s/:]+([0-9_.]+)", "i"))
              )) &&
              r.length > 1
            )
              return r[1].replace(/_/g, ".");
          return !1;
        }
        function o(e, t, n) {
          for (var i, r, o = e.length, s = 0; s < o; s++)
            if (
              ("function" == typeof e[s].test
                ? !0 === e[s].test(n) && (i = e[s].name)
                : n.ua.indexOf(e[s].userAgent) > -1 && (i = e[s].name),
              i)
            ) {
              if (((t[i] = !0), "string" == typeof (r = a(e[s], n.ua)))) {
                var l = r.split(".");
                (t.version.string = r),
                  l &&
                    l.length > 0 &&
                    ((t.version.major = parseInt(l[0] || 0)),
                    (t.version.minor = parseInt(l[1] || 0)),
                    (t.version.patch = parseInt(l[2] || 0)));
              } else
                "edge" === i &&
                  ((t.version.string = "12.0.0"),
                  (t.version.major = "12"),
                  (t.version.minor = "0"),
                  (t.version.patch = "0"));
              return (
                "function" == typeof e[s].parseDocumentMode &&
                  (t.version.documentMode = e[s].parseDocumentMode()),
                t
              );
            }
          return t;
        }
        e.exports = function (e) {
          var t = {};
          return (
            (t.browser = o(r.browser, i.browser, e)),
            (t.os = o(r.os, i.os, e)),
            t
          );
        };
      },
      820: (e, t, n) => {
        "use strict";
        var i = {
          ua: window.navigator.userAgent,
          platform: window.navigator.platform,
          vendor: window.navigator.vendor,
        };
        e.exports = n(1620)(i);
      },
      9946: (e, t, n) => {
        "use strict";
        const i = n(5350).EventEmitterMicro,
          r = [
            { name: "S", mediaQuery: "only screen and (max-width: 734px)" },
            {
              name: "M",
              mediaQuery:
                "only screen and (min-width: 735px) and (max-width: 1068px)",
            },
            {
              name: "L",
              mediaQuery:
                "only screen and (min-width: 1069px) and (max-width: 1440px)",
            },
            { name: "X", mediaQuery: "only screen and (min-width: 1441px)" },
          ],
          a =
            "only screen and (-webkit-min-device-pixel-ratio: 1.5), screen and (min-resolution: 1.5dppx), screen and (min-resolution: 144dpi)",
          o = "only screen and (orientation: portrait)";
        class s extends i {
          constructor(e = {}) {
            super(),
              (this.BREAKPOINTS = e.breakpoints || r),
              this._setupProperties(),
              (this._onRetinaChange = this._onRetinaChange.bind(this)),
              (this._onOrientationChange =
                this._onOrientationChange.bind(this)),
              (this.listenersAdded = {
                orientation: !1,
                retina: !1,
                viewport: !1,
              });
          }
          static get CHANGE_EVENTS() {
            return {
              ORIENTATION: "change:orientation",
              RETINA: "change:retina",
              VIEWPORT: "change:viewport",
            };
          }
          on() {
            this._setupListeners(arguments[0]), super.on.apply(this, arguments);
          }
          _onRetinaChange() {
            this.trigger(s.CHANGE_EVENTS.RETINA, this);
          }
          _onOrientationChange() {
            this.trigger(s.CHANGE_EVENTS.ORIENTATION, this);
          }
          _setupProperties() {
            Object.defineProperty(this, "retina", {
              get: () => window.matchMedia(a).matches,
            }),
              Object.defineProperty(this, "orientation", {
                get: () =>
                  window.matchMedia(o).matches ? "portrait" : "landscape",
              }),
              (this.viewport = this.getBreakpoint());
          }
          _setupListeners(e) {
            if (
              (e !== s.CHANGE_EVENTS.RETINA ||
                this.listenersAdded.retina ||
                (window.matchMedia(a).addListener(this._onRetinaChange),
                (this.listenersAdded.retina = !0)),
              e !== s.CHANGE_EVENTS.ORIENTATION ||
                this.listenersAdded.orientation ||
                (window.matchMedia(o).addListener(this._onOrientationChange),
                (this.listenersAdded.orientation = !0)),
              e === s.CHANGE_EVENTS.VIEWPORT && !this.listenersAdded.viewport)
            ) {
              for (let e = 0; e < this.BREAKPOINTS.length; e++) {
                let t = this.BREAKPOINTS[e];
                window.matchMedia(t.mediaQuery).addListener((e) => {
                  e.matches &&
                    ((this.oldViewport = this.viewport),
                    (this.viewport = t.name),
                    this.trigger(s.CHANGE_EVENTS.VIEWPORT, this));
                });
              }
              this.listenersAdded.viewport = !0;
            }
          }
          getBreakpoint() {
            for (let e = 0; e < this.BREAKPOINTS.length; e++) {
              let t = this.BREAKPOINTS[e];
              if (window.matchMedia(t.mediaQuery).matches) return t.name;
            }
          }
        }
        e.exports = s;
      },
      9241: (e, t, n) => {
        "use strict";
        n.d(t, { Z: () => s });
        var i = n(8081),
          r = n.n(i),
          a = n(3645),
          o = n.n(a)()(r());
        o.push([
          e.id,
          '.button{background:var(--sk-button-background);color:var(--sk-button-color);cursor:pointer;display:inline-block;text-align:center;white-space:nowrap;font-size:17px;line-height:1.1764805882;font-weight:400;letter-spacing:-0.022em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;min-width:28px;padding-left:16px;padding-right:16px;padding-top:8px;padding-bottom:8px;border-radius:980px;--sk-button-background: rgb(0, 113, 227);--sk-button-background-hover: #0077ED;--sk-button-background-active: #006EDB;--sk-button-color: rgb(255, 255, 255);--sk-button-disabled-opacity: 0.32;--sk-button-margin-horizontal: 14px;--sk-button-margin-vertical: 14px}.button:hover{background:var(--sk-button-background-hover, var(--sk-button-background));color:var(--sk-button-color-hover, var(--sk-button-color));text-decoration:none}.button:focus{box-shadow:0 0 0 4px rgba(0,125,250,.6);outline:none}.button:focus[data-focus-method=mouse]:not(input):not(textarea):not(select),.button:focus[data-focus-method=touch]:not(input):not(textarea):not(select){box-shadow:none}.button:active{background:var(--sk-button-background-active, var(--sk-button-background));color:var(--sk-button-color-active, var(--sk-button-color));outline:none}.button:disabled,.button.disabled{background:var(--sk-button-background);color:var(--sk-button-color);opacity:var(--sk-button-disabled-opacity);cursor:default}.button:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(zh){letter-spacing:0em}.button:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-block{box-sizing:border-box;display:block;width:100%;border-radius:8px;--sk-button-margin-horizontal: 9px;--sk-button-margin-vertical: 9px}.button-neutral{--sk-button-background: rgb(29, 29, 31);--sk-button-background-hover: #272729;--sk-button-background-active: #18181A;--sk-button-color: rgb(255, 255, 255);--sk-button-disabled-opacity: 0.32}.button-secondary{--sk-button-background: rgb(232, 232, 237);--sk-button-background-hover: #EBEBF0;--sk-button-background-active: #E6E6EB;--sk-button-color: rgb(0, 0, 0);--sk-button-disabled-opacity: 0.56}.button-secondary-alpha{--sk-button-background: rgba(0, 0, 0, 0.08);--sk-button-background-hover: rgba(0, 0, 0, 0.07);--sk-button-background-active: rgba(0, 0, 0, 0.09);--sk-button-color: rgb(0, 0, 0);--sk-button-disabled-opacity: 0.56}.button-super{font-size:17px;line-height:1.1764805882;font-weight:400;letter-spacing:-0.022em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;min-width:28px;padding-left:31px;padding-right:31px;padding-top:18px;padding-bottom:18px;--sk-button-margin-horizontal: 22px;--sk-button-margin-vertical: 22px}.button-super:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(zh){letter-spacing:0em}.button-super:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-super.button-block{border-radius:12px;--sk-button-margin-horizontal: 14px;--sk-button-margin-vertical: 14px}.button-elevated{font-size:17px;line-height:1.1764805882;font-weight:400;letter-spacing:-0.022em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;min-width:26px;padding-left:22px;padding-right:22px;padding-top:12px;padding-bottom:12px;--sk-button-margin-horizontal: 18px;--sk-button-margin-vertical: 18px}.button-elevated:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(zh){letter-spacing:0em}.button-elevated:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-elevated.button-block{border-radius:10px;--sk-button-margin-horizontal: 11px;--sk-button-margin-vertical: 11px}.button-reduced{font-size:12px;line-height:1.3333733333;font-weight:400;letter-spacing:-0.01em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;min-width:23px;padding-left:11px;padding-right:11px;padding-top:4px;padding-bottom:4px;--sk-button-margin-horizontal: 10px;--sk-button-margin-vertical: 10px}.button-reduced:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(zh){letter-spacing:0em}.button-reduced:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}.button-reduced.button-block{border-radius:5px;--sk-button-margin-horizontal: 6px;--sk-button-margin-vertical: 6px}.button-margin{margin-inline-end:var(--sk-button-margin-horizontal);margin-bottom:var(--sk-button-margin-vertical)}.colornav{display:inline-block;text-align:center}.colornav-title{font-size:17px;line-height:1.2353641176;font-weight:400;letter-spacing:-0.022em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;border-bottom:1px solid #d2d2d7;margin:0;padding:12px 0;width:100%}.colornav-title:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(zh){letter-spacing:0em}.colornav-title:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-title:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-items{display:inline-block;list-style:none;margin:0 -1px;padding-top:17px}@media only screen and (max-width: 1068px){.colornav-items{margin-left:2px;margin-right:2px;padding-top:13px}}.colornav-item{float:left;margin:-1px 5px}@media only screen and (max-width: 1068px){.colornav-item{margin-left:4px;margin-right:4px}}.colornav-value{position:absolute;clip:rect(1px, 1px, 1px, 1px);clip-path:inset(0px 0px 99.9% 99.9%);overflow:hidden;height:1px;width:1px;padding:0;border:0}.colornav-link{border:2px solid rgba(0,0,0,0);border-radius:50%;box-sizing:border-box;color:#1d1d1f;cursor:pointer;float:left;margin-bottom:2.4705882353em;padding:3px;position:relative;width:42px;height:42px;z-index:1}@media only screen and (max-width: 1068px){.colornav-link{margin-bottom:2.5882352941em;padding:2px;width:36px;height:36px}}.colornav-link.current,.colornav-value:checked~.colornav-link{border-color:#0071e3;cursor:default}.colornav-link:focus,.colornav-value:focus~.colornav-link{box-shadow:0 0 0 4px rgba(0,125,250,.6);outline:none}.colornav-link:focus[data-focus-method=mouse]:not(input):not(textarea):not(select),.colornav-link:focus[data-focus-method=touch]:not(input):not(textarea):not(select),.colornav-value:focus~.colornav-link[data-focus-method=mouse]:not(input):not(textarea):not(select),.colornav-value:focus~.colornav-link[data-focus-method=touch]:not(input):not(textarea):not(select){box-shadow:none}.colornav-swatch{background:#f5f5f7 center center;border-radius:50%;display:block;width:32px;height:32px}@media only screen and (max-width: 1068px){.colornav-swatch{width:28px;height:28px}}.colornav-swatch:after{border-radius:inherit;box-shadow:inset 0 1px 1px rgba(0,0,0,.1);content:"";display:block;height:inherit;position:absolute;width:inherit}.colornav-label,.colornav-label-hidden{position:absolute;clip:rect(1px, 1px, 1px, 1px);clip-path:inset(0px 0px 99.9% 99.9%);overflow:hidden;height:1px;width:1px;padding:0;border:0}.colornav-label{overflow:visible}.colornav-link.current .colornav-label,.colornav-value:checked~.colornav-link .colornav-label{font-size:12px;line-height:1.3333733333;font-weight:400;letter-spacing:-0.01em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;clip:auto;clip-path:none;margin-left:-50px;padding-top:7px;position:absolute;top:100%;left:50%;text-align:center;white-space:nowrap;width:100px;height:auto;z-index:1}.colornav-link.current .colornav-label:lang(ar),.colornav-value:checked~.colornav-link .colornav-label:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(ja),.colornav-value:checked~.colornav-link .colornav-label:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(ko),.colornav-value:checked~.colornav-link .colornav-label:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(zh),.colornav-value:checked~.colornav-link .colornav-label:lang(zh){letter-spacing:0em}.colornav-link.current .colornav-label:lang(th),.colornav-value:checked~.colornav-link .colornav-label:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(zh-CN),.colornav-value:checked~.colornav-link .colornav-label:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(zh-HK),.colornav-value:checked~.colornav-link .colornav-label:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(zh-MO),.colornav-value:checked~.colornav-link .colornav-label:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.colornav-link.current .colornav-label:lang(zh-TW),.colornav-value:checked~.colornav-link .colornav-label:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}@media only screen and (max-width: 1068px){.colornav-link.current .colornav-label,.colornav-value:checked~.colornav-link .colornav-label{padding-top:4px}}.colornav-neutral .colornav-title{border-color:#d2d2d7}.colornav-neutral .colornav-link{color:#1d1d1f}.colornav-neutral .colornav-link.current,.colornav-neutral .colornav-value:checked~.colornav-link{border-color:#1d1d1f}.theme-dark .colornav .colornav-title{border-color:#424245}.theme-dark .colornav .colornav-link{color:#f5f5f7}.theme-dark .colornav .colornav-link.current,.theme-dark .colornav .colornav-value:checked~.colornav-link{border-color:#0071e3}.theme-dark .colornav-neutral .colornav-title{border-color:#424245}.theme-dark .colornav-neutral .colornav-link{color:#f5f5f7}.theme-dark .colornav-neutral .colornav-link.current,.theme-dark .colornav-neutral .colornav-value:checked~.colornav-link{border-color:#f5f5f7}.theme-dark .colornav-link:focus,.theme-dark .colornav-value:focus~.colornav-link{box-shadow:0 0 0 4px rgba(0,125,250,.6);outline:none}.theme-dark .colornav-link:focus[data-focus-method=mouse]:not(input):not(textarea):not(select),.theme-dark .colornav-link:focus[data-focus-method=touch]:not(input):not(textarea):not(select),.theme-dark .colornav-value:focus~.colornav-link[data-focus-method=mouse]:not(input):not(textarea):not(select),.theme-dark .colornav-value:focus~.colornav-link[data-focus-method=touch]:not(input):not(textarea):not(select){box-shadow:none}.modal-close-button{cursor:auto;position:var(--modal-close-button-position);order:1;display:flex;align-self:flex-start;justify-content:center;align-items:center;z-index:9999;height:var(--modal-close-button-size);width:var(--modal-close-button-size);margin:0;padding:0;border:0;margin-inline-start:var(--modal-close-button-offset-inline-start);margin-top:var(--modal-close-button-offset-top);top:var(--modal-close-button-offset-top)}html.has-modal .modal-close-button{cursor:pointer}.modal-close-button:focus{outline:none}.modal-close-button:focus .modal-close-icon{box-shadow:0 0 0 4px rgba(0,125,250,.6);outline:none}.modal-close-button:focus .modal-close-icon[data-focus-method=mouse]:not(input):not(textarea):not(select),.modal-close-button:focus .modal-close-icon[data-focus-method=touch]:not(input):not(textarea):not(select){box-shadow:none}.modal-close-button:focus[data-focus-method=mouse]:not(input):not(textarea):not(select) .modal-close-icon,.modal-close-button:focus[data-focus-method=touch]:not(input):not(textarea):not(select) .modal-close-icon{box-shadow:none}.modal-close-button:hover .modal-close-icon{background:var(--modal-close-background-hover);color:var(--modal-close-color-hover)}.modal-close-button:active .modal-close-icon{background:var(--modal-close-background-active)}.modal-close-button .modal-close-icon{background:var(--modal-close-background);border-radius:var(--modal-close-border-radius);color:var(--modal-close-color);display:flex;align-items:center;height:var(--modal-close-icon-size);width:var(--modal-close-icon-size);outline:none;transition:color 100ms linear,background 100ms linear;position:relative}.modal-close-button .modal-close-icon svg{fill:currentColor;position:absolute;left:50%;transform:translateX(-50%);height:var(--modal-close-icon-svg-size);width:var(--modal-close-icon-svg-size)}.modal-close-button .modal-close-icon *{pointer-events:none}.modal{--modal-overlay-background: rgb(255, 255, 255);--modal-overlay-padding-top: 76px;--modal-overlay-padding-bottom: 76px;--modal-overlay-padding-inline: 76px;--modal-close-button-offset-top: 16px;--modal-close-button-offset-inline-start: 16px;--modal-close-button-size: 44px;--modal-close-background: rgb(232, 232, 237);--modal-close-background-hover: #ececf0;--modal-close-background-active: #dfdfe4;--modal-close-color: rgba(0, 0, 0, 0.56);--modal-close-color-hover: rgba(0, 0, 0, 0.72);--modal-close-border-radius: 50%;--modal-close-button-position: sticky;--modal-close-icon-size: 36px;--modal-close-icon-svg-size: 20px;--modal-close-focus-offset: var(--modal-overlay-background);background:var(--modal-scrim-background, var(--modal-overlay-background));position:fixed;z-index:-1;left:0;right:0;top:0;bottom:0;display:none;overflow:auto}.theme-dark .modal,.modal.theme-dark{--modal-overlay-background: rgb(29, 29, 31);--modal-close-background: rgb(51, 51, 54);--modal-close-background-hover: #37373a;--modal-close-background-active: #2f2f32;--modal-close-color: rgba(255, 255, 255, 0.8);--modal-close-color-hover: rgb(255, 255, 255)}@media only screen and (max-width: 480px){.modal{--modal-overlay-padding-inline: 6.25%}}.modal .modal-overlay-container{box-sizing:border-box;display:flex;align-items:center;min-height:100%}.modal .modal-overlay{position:relative;z-index:1;display:flex;flex-direction:column}.modal .modal-content-container{background:var(--modal-overlay-background);order:2;box-sizing:border-box;padding-inline-start:var(--modal-overlay-padding-inline);padding-inline-end:var(--modal-overlay-padding-inline);padding-top:var(--modal-overlay-padding-top);padding-bottom:var(--modal-overlay-padding-bottom);margin-top:calc(-1*(44px + var(--modal-close-button-offset-top)))}.modal-open{display:block;z-index:11000}.modal-touch-lock{touch-action:none}.has-modal{overflow:hidden}.has-modal body{padding-inline-end:var(--modal-scrollbar-buffer)}.modal-full-bleed{--modal-scrim-background: var(--modal-overlay-background);--modal-overlay-padding-top: 96px;--modal-overlay-padding-bottom: 96px;--modal-close-button-offset-top: max(16px, env(safe-area-inset-top));--modal-close-button-offset-inline-start: max(16px, env(safe-area-inset-left))}@media only screen and (max-width: 1068px){.modal-full-bleed{--modal-overlay-padding-top: 76px;--modal-overlay-padding-bottom: 76px}}.modal-full-bleed .modal-overlay-container{flex-direction:column}.modal-full-bleed .modal-overlay{flex-grow:1;width:100%}.modal-full-bleed .modal-overlay:focus{outline-offset:-4px}.modal-full-bleed .modal-content-container{flex-grow:1}.modal-page-overlay{--modal-scrim-background: rgba(0, 0, 0, 0.48);--modal-overlay-margin-top: 40px;--modal-overlay-margin-bottom: var(--modal-overlay-margin-top);--modal-overlay-border-radius-top: 18px;--modal-overlay-border-radius-bottom: var(--modal-overlay-border-radius-top);--modal-overlay-width: 816.6666666667px}@media only screen and (max-width: 1068px){.modal-page-overlay{--modal-overlay-width: 692px}}@media only screen and (max-width: 734px){.modal-page-overlay{--modal-overlay-width: max(87.5%, 480px);--modal-overlay-padding-bottom: 60px}}@media only screen and (max-width: 480px){.modal-page-overlay{--modal-overlay-border-radius-bottom: 0;--modal-overlay-width: 100%;--modal-close-button-offset-top: max(16px, env(safe-area-inset-top));--modal-close-button-offset-inline-start: max(16px, env(safe-area-inset-left))}}@media only screen and (max-width: 480px){.modal-page-overlay .modal-overlay-container{flex-direction:column}}.modal-page-overlay .modal-overlay{margin-left:auto;margin-right:auto;box-sizing:border-box;border-radius:var(--modal-overlay-border-radius-top) var(--modal-overlay-border-radius-top) var(--modal-overlay-border-radius-bottom) var(--modal-overlay-border-radius-bottom);width:var(--modal-overlay-width);margin-top:var(--modal-overlay-margin-top);margin-bottom:var(--modal-overlay-margin-bottom)}.modal-page-overlay .modal-overlay:focus{box-shadow:0 0 0 4px rgba(0,125,250,.6);outline:none}.modal-page-overlay .modal-overlay:focus[data-focus-method=mouse]:not(input):not(textarea):not(select),.modal-page-overlay .modal-overlay:focus[data-focus-method=touch]:not(input):not(textarea):not(select){box-shadow:none}@media only screen and (max-width: 480px){.modal-page-overlay .modal-overlay{--modal-overlay-margin-top: 20px;--modal-overlay-margin-bottom: 0;flex-grow:1}.modal-page-overlay .modal-overlay .modal-content-container{flex-grow:1}}.modal-page-overlay .modal-overlay .modal-content-container{border-radius:inherit;mask-image:radial-gradient(white, black)}@media only screen and (min-width: 1069px){.modal-wide{--modal-overlay-width: 1029px}}.modal-crossfade{display:block;visibility:hidden;opacity:0;transition:opacity .4s ease,visibility 0s linear .4s,z-index 0s linear .4s}@media(prefers-reduced-motion){.modal-crossfade{transition:none}}.modal-crossfade.modal-open{visibility:visible;opacity:1;transition-delay:0s}.modal-fixed-height{overflow:initial;--modal-close-button-position: static}.modal-curtain-white{--modal-scrim-background: rgba(255, 255, 255, 0.48)}.modal-curtain-blur{backdrop-filter:blur(20px)}.modal-close-button-static{--modal-close-button-position: static}.modal-close-button{background:none;border:0;box-sizing:content-box;color:inherit;cursor:pointer;font:inherit;line-height:inherit;overflow:visible;vertical-align:inherit}.channel-3d-product-viewer_colornav{border:0;margin:0;padding:0}.channel-3d-product-viewer_colornav-items{padding-right:0;padding-bottom:0;padding-left:0}.channel-3d-product-viewer_prompt,.channel-3d-product-viewer_colornav-label,.channel-3d-product-viewer_landscape-alert{font-synthesis:none;-moz-font-feature-settings:"kern";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.channel-3d-product-viewer_landscape-alert{line-height:1.4705882353;letter-spacing:-0.022em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;color:var(--sk-body-text-color, rgb(29, 29, 31));font-style:normal}:root{--product-viewer-max-height: 1024px;--product-viewer-min-width: calc(320px - (2 * var(--modal-overlay-padding-inline)));--product-viewer-model-min-height: 70vh;--product-viewer-model-height: min(var(--product-viewer-model-min-height), calc(0.7 * var(--product-viewer-max-height)));--product-viewer-container-width: clamp(var(--product-viewer-min-width, 320px), 100%, 1920px);--product-viewer-container-height: var(--product-viewer-model-height, 70%);--product-viewer-landscape-height: 85vh;--ui-container-start-y: 2px;--ui-container-move-by: 12px;--ui-container-end-y: calc(var(--ui-container-start-y) - var(--ui-container-move-by))}@supports(-webkit-touch-callout: none){:root{--product-viewer-model-min-height: 65vh;--ui-container-move-by: 22px}}@media(min-height: 1024px){:root{--ui-container-start-y: 0px}}@media only screen and (max-width: 734px){:root{--ui-container-move-by: 22px}}.channel-3d-product-viewer_section{width:100%;display:grid;justify-content:center;grid-template-columns:[col1] var(--product-viewer-container-width);grid-template-rows:[row1] var(--product-viewer-container-height) [row2] 0px}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_section{display:flex;justify-content:center;align-items:center;text-align:center;font-size:40px;font-weight:600}}@media only screen and (max-width: 734px){.channel-3d-product-viewer_section{justify-content:initial}}.channel-3d-product-viewer_section:focus{outline:none}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_modal .modal-close-button{padding-bottom:40px}}.channel-3d-product-viewer_modal-content{width:100%}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_modal-content{max-height:var(--product-viewer-landscape-height);overflow:hidden;position:absolute;top:50%;transform:translate(0%, -70%)}}.channel-3d-product-viewer_modal-content:focus{outline:none}.channel-3d-product-viewer-legend{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border:0}.channel-3d-product-viewer_canvas{position:absolute;left:0;top:0}.modal-content-container{user-select:none;position:relative;display:flex;justify-content:center;align-items:center}@media only screen and (orientation: landscape){.channel-3d-is-landscape .modal-content-container{overflow:hidden}}.modal-content-container:focus{outline:none}.channel-3d-product-viewer_landscape-alert{display:none;opacity:0}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_landscape-alert{display:block;animation:fadeIn 1s;opacity:1}}.channel-3d-product-viewer_view-container{opacity:0;cursor:grab;position:relative;align-self:stretch;justify-self:stretch;grid-column:auto;grid-row:auto;width:100%}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_view-container{display:none;visibility:hidden}}@media only screen and (max-width: 734px){.channel-3d-product-viewer_view-container{width:calc(100vw - 2*var(--modal-overlay-padding-inline))}}.channel-3d-product-viewer_ui-container{transform:translateY(var(--ui-container-end-y));display:flex;justify-content:center;align-items:center;flex-direction:column;pointer-events:none;opacity:0;grid-column:auto;grid-row:auto;width:100%}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_ui-container{display:none;visibility:hidden}}@media only screen and (max-width: 734px){.channel-3d-product-viewer_ui-container{width:calc(100vw - 2*var(--modal-overlay-padding-inline))}}.channel-3d-product-viewer_modal.modal-full-bleed .modal-overlay:focus{outline-offset:0}.channel-3d-product-viewer_spinner::before{animation:1.5s linear infinite channel-3d-product-viewer_spinner;animation-play-state:inherit;border:solid 4px #cfd0d1;border-top-color:#0279ff;border-bottom-color:#0279ff;border-radius:45%;content:"";height:35px;width:35px;position:absolute;top:50%;left:50%;transform:translate3d(-50%, -50%, 0);will-change:transform}@keyframes channel-3d-product-viewer_spinner{0%{transform:translate3d(-50%, -50%, 0) rotate(0deg)}100%{transform:translate3d(-50%, -50%, 0) rotate(360deg)}}.channel-3d-product-viewer_modal.modal-full-bleed .modal-overlay:focus{outline-offset:0}.channel-3d-product-viewer_colornav{display:flex;justify-content:center;list-style:none;pointer-events:auto}.channel-3d-product-viewer_colornav-item{-webkit-tap-highlight-color:rgba(0,0,0,0);width:32px}@media only screen and (max-width: 1068px){.channel-3d-product-viewer_colornav-item{width:32px}}@media only screen and (max-width: 734px){.channel-3d-product-viewer_colornav-item{width:29px}}[class^=channel-3d-product-viewer_swatch]{width:21px;height:21px}.channel-3d-product-viewer_colornav-item .channel-3d-product-viewer_colornav-link{margin-bottom:0}.channel-3d-product-viewer_colornav-link{width:31px;height:31px}@media only screen and (max-width: 1068px){.channel-3d-product-viewer_colornav-link{width:29px;height:29px}}@media only screen and (max-width: 734px){.channel-3d-product-viewer_colornav-link{width:29px;height:29px}}.colornav-value:checked~.channel-3d-product-viewer_colornav-link .channel-3d-product-viewer_colornav-label{padding-top:10px}.channel-3d-product-viewer_colornav-value:disabled+.channel-3d-product-viewer_colornav-link{cursor:not-allowed}.channel-3d-product-viewer_modal-entry{-webkit-tap-highlight-color:rgba(0,0,0,0)}.channel-3d-product-viewer_prompt{z-index:1;background:var(--sk-button-background);color:var(--sk-button-color);cursor:pointer;display:inline-block;text-align:center;white-space:nowrap;font-size:17px;line-height:1.1764805882;font-weight:400;letter-spacing:-0.022em;font-family:"SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif;min-width:28px;padding-left:16px;padding-right:16px;padding-top:8px;padding-bottom:8px;border-radius:980px;--sk-button-background: rgb(0, 113, 227);--sk-button-background-hover: #0077ED;--sk-button-background-active: #006EDB;--sk-button-color: rgb(255, 255, 255);--sk-button-disabled-opacity: 0.32;--sk-button-margin-horizontal: 14px;--sk-button-margin-vertical: 14px;--sk-button-background: rgb(232, 232, 237);--sk-button-background-hover: #EBEBF0;--sk-button-background-active: #E6E6EB;--sk-button-color: rgb(0, 0, 0);--sk-button-disabled-opacity: 0.56;margin:0 0 33px}.channel-3d-product-viewer_prompt:hover{background:var(--sk-button-background-hover, var(--sk-button-background));color:var(--sk-button-color-hover, var(--sk-button-color));text-decoration:none}.channel-3d-product-viewer_prompt:focus{box-shadow:0 0 0 4px rgba(0,125,250,.6);outline:none}.channel-3d-product-viewer_prompt:focus[data-focus-method=mouse]:not(input):not(textarea):not(select),.channel-3d-product-viewer_prompt:focus[data-focus-method=touch]:not(input):not(textarea):not(select){box-shadow:none}.channel-3d-product-viewer_prompt:active{background:var(--sk-button-background-active, var(--sk-button-background));color:var(--sk-button-color-active, var(--sk-button-color));outline:none}.channel-3d-product-viewer_prompt:disabled,.channel-3d-product-viewer_prompt.disabled{background:var(--sk-button-background);color:var(--sk-button-color);opacity:var(--sk-button-disabled-opacity);cursor:default}.channel-3d-product-viewer_prompt:lang(ar){letter-spacing:0em;font-family:"SF Pro AR","SF Pro Gulf","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(ja){letter-spacing:0em;font-family:"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(ko){letter-spacing:0em;font-family:"SF Pro KR","SF Pro Text","SF Pro Icons","Apple Gothic","HY Gulim","MalgunGothic","HY Dotum","Lexi Gulim","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(zh){letter-spacing:0em}.channel-3d-product-viewer_prompt:lang(th){font-family:"SF Pro TH","SF Pro Text","SF Pro Icons","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(zh-CN){font-family:"SF Pro SC","SF Pro Text","SF Pro Icons","PingFang SC","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(zh-HK){font-family:"SF Pro HK","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(zh-MO){font-family:"SF Pro HK","SF Pro TC","SF Pro Text","SF Pro Icons","PingFang HK","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:lang(zh-TW){font-family:"SF Pro TC","SF Pro Text","SF Pro Icons","PingFang TC","Helvetica Neue","Helvetica","Arial",sans-serif}.channel-3d-product-viewer_prompt:hover{background-color:var(--sk-button-background);color:var(--sk-button-color)}.channel-3d-product-viewer_prompt::before{background:var(--background);background-size:18px;content:"";padding:0 0 0 18px;margin-right:9px;position:relative}@media only screen and (max-width: 734px){.channel-3d-product-viewer_prompt{margin:0 0 37px}}.channel-3d-product-viewer_fade-in{animation:fadeIn 1.7s;opacity:1}.channel-3d-product-viewer_fade-out{animation:fadeOut .5s;opacity:0}.channel-3d-product-viewer_fade-up{animation:fadeInUp 1.5s;opacity:1}@keyframes fadeIn{0%{opacity:0}100%{opacity:1}}@keyframes fadeOut{0%{opacity:1}100%{opacity:0}}@keyframes fadeInUp{0%{opacity:0;transform:translateY(var(--ui-container-start-y))}50%{opacity:0;transform:translateY(var(--ui-container-start-y))}100%{opacity:1;transform:translateY(var(--ui-container-end-y))}}.channel-3d-product-viewer_progress-indicator{position:absolute;left:0;top:0;display:flex;flex-grow:1;justify-content:center;align-items:center;height:100%;width:100%;opacity:0;pointer-events:none;z-index:2}@media only screen and (orientation: landscape){.channel-3d-is-landscape .channel-3d-product-viewer_progress-indicator{display:none;visibility:hidden}}.channel-3d-product-viewer_progress-indicator.visible{opacity:1}.channel-3d-product-viewer_progress-indicator_container{position:relative;display:flex;justify-content:center;align-items:center;margin-top:19px;width:39px;height:39px}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke0{transform:rotate(-45deg) translate(0, -10px);animation-delay:-1s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke1{transform:rotate(0deg) translate(0, -10px);animation-delay:-0.875s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke2{transform:rotate(45deg) translate(0, -10px);animation-delay:-0.75s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke3{transform:rotate(90deg) translate(0, -10px);animation-delay:-0.625s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke4{transform:rotate(135deg) translate(0, -10px);animation-delay:-0.5s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke5{transform:rotate(180deg) translate(0, -10px);animation-delay:-0.375s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke6{transform:rotate(225deg) translate(0, -10px);animation-delay:-0.25s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke7{transform:rotate(270deg) translate(0, -10px);animation-delay:-0.125s}.channel-3d-product-viewer_progress-indicator .channel-3d-product-viewer_progress-indicator_spoke8{transform:rotate(315deg) translate(0, -10px);animation-delay:0s}[class^=channel-3d-product-viewer_progress-indicator_spoke]{position:absolute;margin:0;width:3px;height:8px;border-radius:10px;background:rgba(0,0,0,.56);opacity:0;animation:fadeOut 1s linear infinite}.channel-3d-product-viewer_colornav-link,.channel-3d-product-viewer_colornav-label{box-shadow:none !important;border-color:rgba(0,0,0,0)}',
          "",
        ]);
        const s = o;
      },
      3645: (e) => {
        "use strict";
        e.exports = function (e) {
          var t = [];
          return (
            (t.toString = function () {
              return this.map(function (t) {
                var n = "",
                  i = void 0 !== t[5];
                return (
                  t[4] && (n += "@supports (".concat(t[4], ") {")),
                  t[2] && (n += "@media ".concat(t[2], " {")),
                  i &&
                    (n += "@layer".concat(
                      t[5].length > 0 ? " ".concat(t[5]) : "",
                      " {"
                    )),
                  (n += e(t)),
                  i && (n += "}"),
                  t[2] && (n += "}"),
                  t[4] && (n += "}"),
                  n
                );
              }).join("");
            }),
            (t.i = function (e, n, i, r, a) {
              "string" == typeof e && (e = [[null, e, void 0]]);
              var o = {};
              if (i)
                for (var s = 0; s < this.length; s++) {
                  var l = this[s][0];
                  null != l && (o[l] = !0);
                }
              for (var c = 0; c < e.length; c++) {
                var u = [].concat(e[c]);
                (i && o[u[0]]) ||
                  (void 0 !== a &&
                    (void 0 === u[5] ||
                      (u[1] = "@layer"
                        .concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {")
                        .concat(u[1], "}")),
                    (u[5] = a)),
                  n &&
                    (u[2]
                      ? ((u[1] = "@media "
                          .concat(u[2], " {")
                          .concat(u[1], "}")),
                        (u[2] = n))
                      : (u[2] = n)),
                  r &&
                    (u[4]
                      ? ((u[1] = "@supports ("
                          .concat(u[4], ") {")
                          .concat(u[1], "}")),
                        (u[4] = r))
                      : (u[4] = "".concat(r))),
                  t.push(u));
              }
            }),
            t
          );
        };
      },
      8081: (e) => {
        "use strict";
        e.exports = function (e) {
          return e[1];
        };
      },
      3379: (e) => {
        "use strict";
        var t = [];
        function n(e) {
          for (var n = -1, i = 0; i < t.length; i++)
            if (t[i].identifier === e) {
              n = i;
              break;
            }
          return n;
        }
        function i(e, i) {
          for (var a = {}, o = [], s = 0; s < e.length; s++) {
            var l = e[s],
              c = i.base ? l[0] + i.base : l[0],
              u = a[c] || 0,
              h = "".concat(c, " ").concat(u);
            a[c] = u + 1;
            var d = n(h),
              p = {
                css: l[1],
                media: l[2],
                sourceMap: l[3],
                supports: l[4],
                layer: l[5],
              };
            if (-1 !== d) t[d].references++, t[d].updater(p);
            else {
              var m = r(p, i);
              (i.byIndex = s),
                t.splice(s, 0, { identifier: h, updater: m, references: 1 });
            }
            o.push(h);
          }
          return o;
        }
        function r(e, t) {
          var n = t.domAPI(t);
          n.update(e);
          return function (t) {
            if (t) {
              if (
                t.css === e.css &&
                t.media === e.media &&
                t.sourceMap === e.sourceMap &&
                t.supports === e.supports &&
                t.layer === e.layer
              )
                return;
              n.update((e = t));
            } else n.remove();
          };
        }
        e.exports = function (e, r) {
          var a = i((e = e || []), (r = r || {}));
          return function (e) {
            e = e || [];
            for (var o = 0; o < a.length; o++) {
              var s = n(a[o]);
              t[s].references--;
            }
            for (var l = i(e, r), c = 0; c < a.length; c++) {
              var u = n(a[c]);
              0 === t[u].references && (t[u].updater(), t.splice(u, 1));
            }
            a = l;
          };
        };
      },
      569: (e) => {
        "use strict";
        var t = {};
        e.exports = function (e, n) {
          var i = (function (e) {
            if (void 0 === t[e]) {
              var n = document.querySelector(e);
              if (
                window.HTMLIFrameElement &&
                n instanceof window.HTMLIFrameElement
              )
                try {
                  n = n.contentDocument.head;
                } catch (e) {
                  n = null;
                }
              t[e] = n;
            }
            return t[e];
          })(e);
          if (!i)
            throw new Error(
              "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
            );
          i.appendChild(n);
        };
      },
      9216: (e) => {
        "use strict";
        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      3565: (e, t, n) => {
        "use strict";
        e.exports = function (e) {
          var t = n.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      7795: (e) => {
        "use strict";
        e.exports = function (e) {
          if ("undefined" == typeof document)
            return { update: function () {}, remove: function () {} };
          var t = e.insertStyleElement(e);
          return {
            update: function (n) {
              !(function (e, t, n) {
                var i = "";
                n.supports && (i += "@supports (".concat(n.supports, ") {")),
                  n.media && (i += "@media ".concat(n.media, " {"));
                var r = void 0 !== n.layer;
                r &&
                  (i += "@layer".concat(
                    n.layer.length > 0 ? " ".concat(n.layer) : "",
                    " {"
                  )),
                  (i += n.css),
                  r && (i += "}"),
                  n.media && (i += "}"),
                  n.supports && (i += "}");
                var a = n.sourceMap;
                a &&
                  "undefined" != typeof btoa &&
                  (i +=
                    "\n/*# sourceMappingURL=data:application/json;base64,".concat(
                      btoa(unescape(encodeURIComponent(JSON.stringify(a)))),
                      " */"
                    )),
                  t.styleTagTransform(i, e, t.options);
              })(t, e, n);
            },
            remove: function () {
              !(function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              })(t);
            },
          };
        };
      },
      4589: (e) => {
        "use strict";
        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;
          else {
            for (; t.firstChild; ) t.removeChild(t.firstChild);
            t.appendChild(document.createTextNode(e));
          }
        };
      },
    },
    t = {};
  function n(i) {
    var r = t[i];
    if (void 0 !== r) return r.exports;
    var a = (t[i] = { id: i, exports: {} });
    return e[i](a, a.exports, n), a.exports;
  }
  (n.n = (e) => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, { a: t }), t;
  }),
    (n.d = (e, t) => {
      for (var i in t)
        n.o(t, i) &&
          !n.o(e, i) &&
          Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
    }),
    (n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (n.nc = void 0),
    (() => {
      "use strict";
      var e = n(3379),
        t = n.n(e),
        i = n(7795),
        r = n.n(i),
        a = n(569),
        o = n.n(a),
        s = n(3565),
        l = n.n(s),
        c = n(9216),
        u = n.n(c),
        h = n(4589),
        d = n.n(h),
        p = n(9241),
        m = {};
      (m.styleTagTransform = d()),
        (m.setAttributes = l()),
        (m.insert = o().bind(null, "head")),
        (m.domAPI = r()),
        (m.insertStyleElement = u());
      t()(p.Z, m);
      p.Z && p.Z.locals && p.Z.locals;
      var f = n(820),
        g = n(3251);
      const v = 0,
        y = 1,
        x = 2,
        b = 0,
        _ = 1,
        w = 2,
        M = 3,
        S = 0,
        T = 1,
        E = 2,
        A = 1,
        L = 2,
        P = 3,
        R = 0,
        C = 1,
        I = 2,
        N = 0,
        D = 1,
        O = 2,
        F = 3,
        k = 4,
        H = 5,
        z = 100,
        U = 101,
        B = 102,
        G = 103,
        V = 104,
        W = 200,
        j = 201,
        X = 202,
        q = 203,
        Y = 204,
        K = 205,
        Z = 206,
        J = 207,
        Q = 208,
        $ = 209,
        ee = 210,
        te = 0,
        ne = 1,
        ie = 2,
        re = 3,
        ae = 4,
        oe = 5,
        se = 6,
        le = 7,
        ce = 0,
        ue = 1,
        he = 2,
        de = 0,
        pe = 1,
        me = 2,
        fe = 3,
        ge = 4,
        ve = 5,
        ye = 301,
        xe = 302,
        be = 303,
        _e = 304,
        we = 306,
        Me = 307,
        Se = 1e3,
        Te = 1001,
        Ee = 1002,
        Ae = 1003,
        Le = 1004,
        Pe = 1005,
        Re = 1006,
        Ce = 1007,
        Ie = 1008,
        Ne = 1009,
        De = 1010,
        Oe = 1011,
        Fe = 1012,
        ke = 1013,
        He = 1014,
        ze = 1015,
        Ue = 1016,
        Be = 1017,
        Ge = 1018,
        Ve = 1019,
        We = 1020,
        je = 1021,
        Xe = 1022,
        qe = 1023,
        Ye = 1024,
        Ke = 1025,
        Ze = qe,
        Je = 1026,
        Qe = 1027,
        $e = 1028,
        et = 1029,
        tt = 1030,
        nt = 1031,
        it = 1032,
        rt = 1033,
        at = 33776,
        ot = 33777,
        st = 33778,
        lt = 33779,
        ct = 35840,
        ut = 35841,
        ht = 35842,
        dt = 35843,
        pt = 36196,
        mt = 37492,
        ft = 37496,
        gt = 37808,
        vt = 37809,
        yt = 37810,
        xt = 37811,
        bt = 37812,
        _t = 37813,
        wt = 37814,
        Mt = 37815,
        St = 37816,
        Tt = 37817,
        Et = 37818,
        At = 37819,
        Lt = 37820,
        Pt = 37821,
        Rt = 36492,
        Ct = 37840,
        It = 37841,
        Nt = 37842,
        Dt = 37843,
        Ot = 37844,
        Ft = 37845,
        kt = 37846,
        Ht = 37847,
        zt = 37848,
        Ut = 37849,
        Bt = 37850,
        Gt = 37851,
        Vt = 37852,
        Wt = 37853,
        jt = 2300,
        Xt = 2301,
        qt = 2302,
        Yt = 2400,
        Kt = 2401,
        Zt = 2402,
        Jt = 2500,
        Qt = 2,
        $t = 3e3,
        en = 3001,
        tn = 3007,
        nn = 3002,
        rn = 3003,
        an = 3004,
        on = 3005,
        sn = 3006,
        ln = 3201,
        cn = 0,
        un = 1,
        hn = 7680,
        dn = 35044,
        pn = 35048,
        mn = "300 es";
      class fn {
        addEventListener(e, t) {
          void 0 === this._listeners && (this._listeners = {});
          const n = this._listeners;
          void 0 === n[e] && (n[e] = []),
            -1 === n[e].indexOf(t) && n[e].push(t);
        }
        hasEventListener(e, t) {
          if (void 0 === this._listeners) return !1;
          const n = this._listeners;
          return void 0 !== n[e] && -1 !== n[e].indexOf(t);
        }
        removeEventListener(e, t) {
          if (void 0 === this._listeners) return;
          const n = this._listeners[e];
          if (void 0 !== n) {
            const e = n.indexOf(t);
            -1 !== e && n.splice(e, 1);
          }
        }
        dispatchEvent(e) {
          if (void 0 === this._listeners) return;
          const t = this._listeners[e.type];
          if (void 0 !== t) {
            e.target = this;
            const n = t.slice(0);
            for (let t = 0, i = n.length; t < i; t++) n[t].call(this, e);
            e.target = null;
          }
        }
      }
      const gn = [];
      for (let e = 0; e < 256; e++)
        gn[e] = (e < 16 ? "0" : "") + e.toString(16);
      let vn = 1234567;
      const yn = Math.PI / 180,
        xn = 180 / Math.PI;
      function bn() {
        const e = (4294967295 * Math.random()) | 0,
          t = (4294967295 * Math.random()) | 0,
          n = (4294967295 * Math.random()) | 0,
          i = (4294967295 * Math.random()) | 0;
        return (
          gn[255 & e] +
          gn[(e >> 8) & 255] +
          gn[(e >> 16) & 255] +
          gn[(e >> 24) & 255] +
          "-" +
          gn[255 & t] +
          gn[(t >> 8) & 255] +
          "-" +
          gn[((t >> 16) & 15) | 64] +
          gn[(t >> 24) & 255] +
          "-" +
          gn[(63 & n) | 128] +
          gn[(n >> 8) & 255] +
          "-" +
          gn[(n >> 16) & 255] +
          gn[(n >> 24) & 255] +
          gn[255 & i] +
          gn[(i >> 8) & 255] +
          gn[(i >> 16) & 255] +
          gn[(i >> 24) & 255]
        ).toUpperCase();
      }
      function _n(e, t, n) {
        return Math.max(t, Math.min(n, e));
      }
      function wn(e, t) {
        return ((e % t) + t) % t;
      }
      function Mn(e, t, n) {
        return (1 - n) * e + n * t;
      }
      function Sn(e) {
        return 0 == (e & (e - 1)) && 0 !== e;
      }
      function Tn(e) {
        return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
      }
      function En(e) {
        return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
      }
      var An = Object.freeze({
        __proto__: null,
        DEG2RAD: yn,
        RAD2DEG: xn,
        generateUUID: bn,
        clamp: _n,
        euclideanModulo: wn,
        mapLinear: function (e, t, n, i, r) {
          return i + ((e - t) * (r - i)) / (n - t);
        },
        inverseLerp: function (e, t, n) {
          return e !== t ? (n - e) / (t - e) : 0;
        },
        lerp: Mn,
        damp: function (e, t, n, i) {
          return Mn(e, t, 1 - Math.exp(-n * i));
        },
        pingpong: function (e, t = 1) {
          return t - Math.abs(wn(e, 2 * t) - t);
        },
        smoothstep: function (e, t, n) {
          return e <= t
            ? 0
            : e >= n
            ? 1
            : (e = (e - t) / (n - t)) * e * (3 - 2 * e);
        },
        smootherstep: function (e, t, n) {
          return e <= t
            ? 0
            : e >= n
            ? 1
            : (e = (e - t) / (n - t)) * e * e * (e * (6 * e - 15) + 10);
        },
        randInt: function (e, t) {
          return e + Math.floor(Math.random() * (t - e + 1));
        },
        randFloat: function (e, t) {
          return e + Math.random() * (t - e);
        },
        randFloatSpread: function (e) {
          return e * (0.5 - Math.random());
        },
        seededRandom: function (e) {
          return (
            void 0 !== e && (vn = e % 2147483647),
            (vn = (16807 * vn) % 2147483647),
            (vn - 1) / 2147483646
          );
        },
        degToRad: function (e) {
          return e * yn;
        },
        radToDeg: function (e) {
          return e * xn;
        },
        isPowerOfTwo: Sn,
        ceilPowerOfTwo: Tn,
        floorPowerOfTwo: En,
        setQuaternionFromProperEuler: function (e, t, n, i, r) {
          const a = Math.cos,
            o = Math.sin,
            s = a(n / 2),
            l = o(n / 2),
            c = a((t + i) / 2),
            u = o((t + i) / 2),
            h = a((t - i) / 2),
            d = o((t - i) / 2),
            p = a((i - t) / 2),
            m = o((i - t) / 2);
          switch (r) {
            case "XYX":
              e.set(s * u, l * h, l * d, s * c);
              break;
            case "YZY":
              e.set(l * d, s * u, l * h, s * c);
              break;
            case "ZXZ":
              e.set(l * h, l * d, s * u, s * c);
              break;
            case "XZX":
              e.set(s * u, l * m, l * p, s * c);
              break;
            case "YXY":
              e.set(l * p, s * u, l * m, s * c);
              break;
            case "ZYZ":
              e.set(l * m, l * p, s * u, s * c);
              break;
            default:
              console.warn(
                "THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " +
                  r
              );
          }
        },
      });
      class Ln {
        constructor(e = 0, t = 0) {
          (this.x = e), (this.y = t);
        }
        get width() {
          return this.x;
        }
        set width(e) {
          this.x = e;
        }
        get height() {
          return this.y;
        }
        set height(e) {
          this.y = e;
        }
        set(e, t) {
          return (this.x = e), (this.y = t), this;
        }
        setScalar(e) {
          return (this.x = e), (this.y = e), this;
        }
        setX(e) {
          return (this.x = e), this;
        }
        setY(e) {
          return (this.y = e), this;
        }
        setComponent(e, t) {
          switch (e) {
            case 0:
              this.x = t;
              break;
            case 1:
              this.y = t;
              break;
            default:
              throw new Error("index is out of range: " + e);
          }
          return this;
        }
        getComponent(e) {
          switch (e) {
            case 0:
              return this.x;
            case 1:
              return this.y;
            default:
              throw new Error("index is out of range: " + e);
          }
        }
        clone() {
          return new this.constructor(this.x, this.y);
        }
        copy(e) {
          return (this.x = e.x), (this.y = e.y), this;
        }
        add(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."
              ),
              this.addVectors(e, t))
            : ((this.x += e.x), (this.y += e.y), this);
        }
        addScalar(e) {
          return (this.x += e), (this.y += e), this;
        }
        addVectors(e, t) {
          return (this.x = e.x + t.x), (this.y = e.y + t.y), this;
        }
        addScaledVector(e, t) {
          return (this.x += e.x * t), (this.y += e.y * t), this;
        }
        sub(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."
              ),
              this.subVectors(e, t))
            : ((this.x -= e.x), (this.y -= e.y), this);
        }
        subScalar(e) {
          return (this.x -= e), (this.y -= e), this;
        }
        subVectors(e, t) {
          return (this.x = e.x - t.x), (this.y = e.y - t.y), this;
        }
        multiply(e) {
          return (this.x *= e.x), (this.y *= e.y), this;
        }
        multiplyScalar(e) {
          return (this.x *= e), (this.y *= e), this;
        }
        divide(e) {
          return (this.x /= e.x), (this.y /= e.y), this;
        }
        divideScalar(e) {
          return this.multiplyScalar(1 / e);
        }
        applyMatrix3(e) {
          const t = this.x,
            n = this.y,
            i = e.elements;
          return (
            (this.x = i[0] * t + i[3] * n + i[6]),
            (this.y = i[1] * t + i[4] * n + i[7]),
            this
          );
        }
        min(e) {
          return (
            (this.x = Math.min(this.x, e.x)),
            (this.y = Math.min(this.y, e.y)),
            this
          );
        }
        max(e) {
          return (
            (this.x = Math.max(this.x, e.x)),
            (this.y = Math.max(this.y, e.y)),
            this
          );
        }
        clamp(e, t) {
          return (
            (this.x = Math.max(e.x, Math.min(t.x, this.x))),
            (this.y = Math.max(e.y, Math.min(t.y, this.y))),
            this
          );
        }
        clampScalar(e, t) {
          return (
            (this.x = Math.max(e, Math.min(t, this.x))),
            (this.y = Math.max(e, Math.min(t, this.y))),
            this
          );
        }
        clampLength(e, t) {
          const n = this.length();
          return this.divideScalar(n || 1).multiplyScalar(
            Math.max(e, Math.min(t, n))
          );
        }
        floor() {
          return (
            (this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), this
          );
        }
        ceil() {
          return (
            (this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), this
          );
        }
        round() {
          return (
            (this.x = Math.round(this.x)), (this.y = Math.round(this.y)), this
          );
        }
        roundToZero() {
          return (
            (this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x)),
            (this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y)),
            this
          );
        }
        negate() {
          return (this.x = -this.x), (this.y = -this.y), this;
        }
        dot(e) {
          return this.x * e.x + this.y * e.y;
        }
        cross(e) {
          return this.x * e.y - this.y * e.x;
        }
        lengthSq() {
          return this.x * this.x + this.y * this.y;
        }
        length() {
          return Math.sqrt(this.x * this.x + this.y * this.y);
        }
        manhattanLength() {
          return Math.abs(this.x) + Math.abs(this.y);
        }
        normalize() {
          return this.divideScalar(this.length() || 1);
        }
        angle() {
          return Math.atan2(-this.y, -this.x) + Math.PI;
        }
        distanceTo(e) {
          return Math.sqrt(this.distanceToSquared(e));
        }
        distanceToSquared(e) {
          const t = this.x - e.x,
            n = this.y - e.y;
          return t * t + n * n;
        }
        manhattanDistanceTo(e) {
          return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
        }
        setLength(e) {
          return this.normalize().multiplyScalar(e);
        }
        lerp(e, t) {
          return (
            (this.x += (e.x - this.x) * t), (this.y += (e.y - this.y) * t), this
          );
        }
        lerpVectors(e, t, n) {
          return (
            (this.x = e.x + (t.x - e.x) * n),
            (this.y = e.y + (t.y - e.y) * n),
            this
          );
        }
        equals(e) {
          return e.x === this.x && e.y === this.y;
        }
        fromArray(e, t = 0) {
          return (this.x = e[t]), (this.y = e[t + 1]), this;
        }
        toArray(e = [], t = 0) {
          return (e[t] = this.x), (e[t + 1] = this.y), e;
        }
        fromBufferAttribute(e, t, n) {
          return (
            void 0 !== n &&
              console.warn(
                "THREE.Vector2: offset has been removed from .fromBufferAttribute()."
              ),
            (this.x = e.getX(t)),
            (this.y = e.getY(t)),
            this
          );
        }
        rotateAround(e, t) {
          const n = Math.cos(t),
            i = Math.sin(t),
            r = this.x - e.x,
            a = this.y - e.y;
          return (
            (this.x = r * n - a * i + e.x), (this.y = r * i + a * n + e.y), this
          );
        }
        random() {
          return (this.x = Math.random()), (this.y = Math.random()), this;
        }
      }
      Ln.prototype.isVector2 = !0;
      class Pn {
        constructor() {
          (this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
            arguments.length > 0 &&
              console.error(
                "THREE.Matrix3: the constructor no longer reads arguments. use .set() instead."
              );
        }
        set(e, t, n, i, r, a, o, s, l) {
          const c = this.elements;
          return (
            (c[0] = e),
            (c[1] = i),
            (c[2] = o),
            (c[3] = t),
            (c[4] = r),
            (c[5] = s),
            (c[6] = n),
            (c[7] = a),
            (c[8] = l),
            this
          );
        }
        identity() {
          return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
        }
        copy(e) {
          const t = this.elements,
            n = e.elements;
          return (
            (t[0] = n[0]),
            (t[1] = n[1]),
            (t[2] = n[2]),
            (t[3] = n[3]),
            (t[4] = n[4]),
            (t[5] = n[5]),
            (t[6] = n[6]),
            (t[7] = n[7]),
            (t[8] = n[8]),
            this
          );
        }
        extractBasis(e, t, n) {
          return (
            e.setFromMatrix3Column(this, 0),
            t.setFromMatrix3Column(this, 1),
            n.setFromMatrix3Column(this, 2),
            this
          );
        }
        setFromMatrix4(e) {
          const t = e.elements;
          return (
            this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]),
            this
          );
        }
        multiply(e) {
          return this.multiplyMatrices(this, e);
        }
        premultiply(e) {
          return this.multiplyMatrices(e, this);
        }
        multiplyMatrices(e, t) {
          const n = e.elements,
            i = t.elements,
            r = this.elements,
            a = n[0],
            o = n[3],
            s = n[6],
            l = n[1],
            c = n[4],
            u = n[7],
            h = n[2],
            d = n[5],
            p = n[8],
            m = i[0],
            f = i[3],
            g = i[6],
            v = i[1],
            y = i[4],
            x = i[7],
            b = i[2],
            _ = i[5],
            w = i[8];
          return (
            (r[0] = a * m + o * v + s * b),
            (r[3] = a * f + o * y + s * _),
            (r[6] = a * g + o * x + s * w),
            (r[1] = l * m + c * v + u * b),
            (r[4] = l * f + c * y + u * _),
            (r[7] = l * g + c * x + u * w),
            (r[2] = h * m + d * v + p * b),
            (r[5] = h * f + d * y + p * _),
            (r[8] = h * g + d * x + p * w),
            this
          );
        }
        multiplyScalar(e) {
          const t = this.elements;
          return (
            (t[0] *= e),
            (t[3] *= e),
            (t[6] *= e),
            (t[1] *= e),
            (t[4] *= e),
            (t[7] *= e),
            (t[2] *= e),
            (t[5] *= e),
            (t[8] *= e),
            this
          );
        }
        determinant() {
          const e = this.elements,
            t = e[0],
            n = e[1],
            i = e[2],
            r = e[3],
            a = e[4],
            o = e[5],
            s = e[6],
            l = e[7],
            c = e[8];
          return (
            t * a * c -
            t * o * l -
            n * r * c +
            n * o * s +
            i * r * l -
            i * a * s
          );
        }
        invert() {
          const e = this.elements,
            t = e[0],
            n = e[1],
            i = e[2],
            r = e[3],
            a = e[4],
            o = e[5],
            s = e[6],
            l = e[7],
            c = e[8],
            u = c * a - o * l,
            h = o * s - c * r,
            d = l * r - a * s,
            p = t * u + n * h + i * d;
          if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
          const m = 1 / p;
          return (
            (e[0] = u * m),
            (e[1] = (i * l - c * n) * m),
            (e[2] = (o * n - i * a) * m),
            (e[3] = h * m),
            (e[4] = (c * t - i * s) * m),
            (e[5] = (i * r - o * t) * m),
            (e[6] = d * m),
            (e[7] = (n * s - l * t) * m),
            (e[8] = (a * t - n * r) * m),
            this
          );
        }
        transpose() {
          let e;
          const t = this.elements;
          return (
            (e = t[1]),
            (t[1] = t[3]),
            (t[3] = e),
            (e = t[2]),
            (t[2] = t[6]),
            (t[6] = e),
            (e = t[5]),
            (t[5] = t[7]),
            (t[7] = e),
            this
          );
        }
        getNormalMatrix(e) {
          return this.setFromMatrix4(e).invert().transpose();
        }
        transposeIntoArray(e) {
          const t = this.elements;
          return (
            (e[0] = t[0]),
            (e[1] = t[3]),
            (e[2] = t[6]),
            (e[3] = t[1]),
            (e[4] = t[4]),
            (e[5] = t[7]),
            (e[6] = t[2]),
            (e[7] = t[5]),
            (e[8] = t[8]),
            this
          );
        }
        setUvTransform(e, t, n, i, r, a, o) {
          const s = Math.cos(r),
            l = Math.sin(r);
          return (
            this.set(
              n * s,
              n * l,
              -n * (s * a + l * o) + a + e,
              -i * l,
              i * s,
              -i * (-l * a + s * o) + o + t,
              0,
              0,
              1
            ),
            this
          );
        }
        scale(e, t) {
          const n = this.elements;
          return (
            (n[0] *= e),
            (n[3] *= e),
            (n[6] *= e),
            (n[1] *= t),
            (n[4] *= t),
            (n[7] *= t),
            this
          );
        }
        rotate(e) {
          const t = Math.cos(e),
            n = Math.sin(e),
            i = this.elements,
            r = i[0],
            a = i[3],
            o = i[6],
            s = i[1],
            l = i[4],
            c = i[7];
          return (
            (i[0] = t * r + n * s),
            (i[3] = t * a + n * l),
            (i[6] = t * o + n * c),
            (i[1] = -n * r + t * s),
            (i[4] = -n * a + t * l),
            (i[7] = -n * o + t * c),
            this
          );
        }
        translate(e, t) {
          const n = this.elements;
          return (
            (n[0] += e * n[2]),
            (n[3] += e * n[5]),
            (n[6] += e * n[8]),
            (n[1] += t * n[2]),
            (n[4] += t * n[5]),
            (n[7] += t * n[8]),
            this
          );
        }
        equals(e) {
          const t = this.elements,
            n = e.elements;
          for (let e = 0; e < 9; e++) if (t[e] !== n[e]) return !1;
          return !0;
        }
        fromArray(e, t = 0) {
          for (let n = 0; n < 9; n++) this.elements[n] = e[n + t];
          return this;
        }
        toArray(e = [], t = 0) {
          const n = this.elements;
          return (
            (e[t] = n[0]),
            (e[t + 1] = n[1]),
            (e[t + 2] = n[2]),
            (e[t + 3] = n[3]),
            (e[t + 4] = n[4]),
            (e[t + 5] = n[5]),
            (e[t + 6] = n[6]),
            (e[t + 7] = n[7]),
            (e[t + 8] = n[8]),
            e
          );
        }
        clone() {
          return new this.constructor().fromArray(this.elements);
        }
      }
      let Rn;
      Pn.prototype.isMatrix3 = !0;
      class Cn {
        static getDataURL(e) {
          if (/^data:/i.test(e.src)) return e.src;
          if ("undefined" == typeof HTMLCanvasElement) return e.src;
          let t;
          if (e instanceof HTMLCanvasElement) t = e;
          else {
            void 0 === Rn &&
              (Rn = document.createElementNS(
                "http://www.w3.org/1999/xhtml",
                "canvas"
              )),
              (Rn.width = e.width),
              (Rn.height = e.height);
            const n = Rn.getContext("2d");
            e instanceof ImageData
              ? n.putImageData(e, 0, 0)
              : n.drawImage(e, 0, 0, e.width, e.height),
              (t = Rn);
          }
          return t.width > 2048 || t.height > 2048
            ? (console.warn(
                "THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons",
                e
              ),
              t.toDataURL("image/jpeg", 0.6))
            : t.toDataURL("image/png");
        }
      }
      let In = 0;
      class Nn extends fn {
        constructor(
          e = Nn.DEFAULT_IMAGE,
          t = Nn.DEFAULT_MAPPING,
          n = Te,
          i = Te,
          r = Re,
          a = Ie,
          o = qe,
          s = Ne,
          l = 1,
          c = $t
        ) {
          super(),
            Object.defineProperty(this, "id", { value: In++ }),
            (this.uuid = bn()),
            (this.name = ""),
            (this.image = e),
            (this.mipmaps = []),
            (this.mapping = t),
            (this.wrapS = n),
            (this.wrapT = i),
            (this.magFilter = r),
            (this.minFilter = a),
            (this.anisotropy = l),
            (this.format = o),
            (this.internalFormat = null),
            (this.type = s),
            (this.offset = new Ln(0, 0)),
            (this.repeat = new Ln(1, 1)),
            (this.center = new Ln(0, 0)),
            (this.rotation = 0),
            (this.matrixAutoUpdate = !0),
            (this.matrix = new Pn()),
            (this.generateMipmaps = !0),
            (this.premultiplyAlpha = !1),
            (this.flipY = !0),
            (this.unpackAlignment = 4),
            (this.encoding = c),
            (this.version = 0),
            (this.onUpdate = null),
            (this.isRenderTargetTexture = !1);
        }
        updateMatrix() {
          this.matrix.setUvTransform(
            this.offset.x,
            this.offset.y,
            this.repeat.x,
            this.repeat.y,
            this.rotation,
            this.center.x,
            this.center.y
          );
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          return (
            (this.name = e.name),
            (this.image = e.image),
            (this.mipmaps = e.mipmaps.slice(0)),
            (this.mapping = e.mapping),
            (this.wrapS = e.wrapS),
            (this.wrapT = e.wrapT),
            (this.magFilter = e.magFilter),
            (this.minFilter = e.minFilter),
            (this.anisotropy = e.anisotropy),
            (this.format = e.format),
            (this.internalFormat = e.internalFormat),
            (this.type = e.type),
            this.offset.copy(e.offset),
            this.repeat.copy(e.repeat),
            this.center.copy(e.center),
            (this.rotation = e.rotation),
            (this.matrixAutoUpdate = e.matrixAutoUpdate),
            this.matrix.copy(e.matrix),
            (this.generateMipmaps = e.generateMipmaps),
            (this.premultiplyAlpha = e.premultiplyAlpha),
            (this.flipY = e.flipY),
            (this.unpackAlignment = e.unpackAlignment),
            (this.encoding = e.encoding),
            this
          );
        }
        toJSON(e) {
          const t = void 0 === e || "string" == typeof e;
          if (!t && void 0 !== e.textures[this.uuid])
            return e.textures[this.uuid];
          const n = {
            metadata: {
              version: 4.5,
              type: "Texture",
              generator: "Texture.toJSON",
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [this.repeat.x, this.repeat.y],
            offset: [this.offset.x, this.offset.y],
            center: [this.center.x, this.center.y],
            rotation: this.rotation,
            wrap: [this.wrapS, this.wrapT],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment,
          };
          if (void 0 !== this.image) {
            const i = this.image;
            if (
              (void 0 === i.uuid && (i.uuid = bn()),
              !t && void 0 === e.images[i.uuid])
            ) {
              let t;
              if (Array.isArray(i)) {
                t = [];
                for (let e = 0, n = i.length; e < n; e++)
                  i[e].isDataTexture
                    ? t.push(Dn(i[e].image))
                    : t.push(Dn(i[e]));
              } else t = Dn(i);
              e.images[i.uuid] = { uuid: i.uuid, url: t };
            }
            n.image = i.uuid;
          }
          return t || (e.textures[this.uuid] = n), n;
        }
        dispose() {
          this.dispatchEvent({ type: "dispose" });
        }
        transformUv(e) {
          if (300 !== this.mapping) return e;
          if ((e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1))
            switch (this.wrapS) {
              case Se:
                e.x = e.x - Math.floor(e.x);
                break;
              case Te:
                e.x = e.x < 0 ? 0 : 1;
                break;
              case Ee:
                1 === Math.abs(Math.floor(e.x) % 2)
                  ? (e.x = Math.ceil(e.x) - e.x)
                  : (e.x = e.x - Math.floor(e.x));
            }
          if (e.y < 0 || e.y > 1)
            switch (this.wrapT) {
              case Se:
                e.y = e.y - Math.floor(e.y);
                break;
              case Te:
                e.y = e.y < 0 ? 0 : 1;
                break;
              case Ee:
                1 === Math.abs(Math.floor(e.y) % 2)
                  ? (e.y = Math.ceil(e.y) - e.y)
                  : (e.y = e.y - Math.floor(e.y));
            }
          return this.flipY && (e.y = 1 - e.y), e;
        }
        set needsUpdate(e) {
          !0 === e && this.version++;
        }
      }
      function Dn(e) {
        return ("undefined" != typeof HTMLImageElement &&
          e instanceof HTMLImageElement) ||
          ("undefined" != typeof HTMLCanvasElement &&
            e instanceof HTMLCanvasElement) ||
          ("undefined" != typeof ImageBitmap && e instanceof ImageBitmap)
          ? Cn.getDataURL(e)
          : e.data
          ? {
              data: Array.prototype.slice.call(e.data),
              width: e.width,
              height: e.height,
              type: e.data.constructor.name,
            }
          : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
      }
      (Nn.DEFAULT_IMAGE = void 0),
        (Nn.DEFAULT_MAPPING = 300),
        (Nn.prototype.isTexture = !0);
      class On {
        constructor(e = 0, t = 0, n = 0, i = 1) {
          (this.x = e), (this.y = t), (this.z = n), (this.w = i);
        }
        get width() {
          return this.z;
        }
        set width(e) {
          this.z = e;
        }
        get height() {
          return this.w;
        }
        set height(e) {
          this.w = e;
        }
        set(e, t, n, i) {
          return (this.x = e), (this.y = t), (this.z = n), (this.w = i), this;
        }
        setScalar(e) {
          return (this.x = e), (this.y = e), (this.z = e), (this.w = e), this;
        }
        setX(e) {
          return (this.x = e), this;
        }
        setY(e) {
          return (this.y = e), this;
        }
        setZ(e) {
          return (this.z = e), this;
        }
        setW(e) {
          return (this.w = e), this;
        }
        setComponent(e, t) {
          switch (e) {
            case 0:
              this.x = t;
              break;
            case 1:
              this.y = t;
              break;
            case 2:
              this.z = t;
              break;
            case 3:
              this.w = t;
              break;
            default:
              throw new Error("index is out of range: " + e);
          }
          return this;
        }
        getComponent(e) {
          switch (e) {
            case 0:
              return this.x;
            case 1:
              return this.y;
            case 2:
              return this.z;
            case 3:
              return this.w;
            default:
              throw new Error("index is out of range: " + e);
          }
        }
        clone() {
          return new this.constructor(this.x, this.y, this.z, this.w);
        }
        copy(e) {
          return (
            (this.x = e.x),
            (this.y = e.y),
            (this.z = e.z),
            (this.w = void 0 !== e.w ? e.w : 1),
            this
          );
        }
        add(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."
              ),
              this.addVectors(e, t))
            : ((this.x += e.x),
              (this.y += e.y),
              (this.z += e.z),
              (this.w += e.w),
              this);
        }
        addScalar(e) {
          return (
            (this.x += e), (this.y += e), (this.z += e), (this.w += e), this
          );
        }
        addVectors(e, t) {
          return (
            (this.x = e.x + t.x),
            (this.y = e.y + t.y),
            (this.z = e.z + t.z),
            (this.w = e.w + t.w),
            this
          );
        }
        addScaledVector(e, t) {
          return (
            (this.x += e.x * t),
            (this.y += e.y * t),
            (this.z += e.z * t),
            (this.w += e.w * t),
            this
          );
        }
        sub(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."
              ),
              this.subVectors(e, t))
            : ((this.x -= e.x),
              (this.y -= e.y),
              (this.z -= e.z),
              (this.w -= e.w),
              this);
        }
        subScalar(e) {
          return (
            (this.x -= e), (this.y -= e), (this.z -= e), (this.w -= e), this
          );
        }
        subVectors(e, t) {
          return (
            (this.x = e.x - t.x),
            (this.y = e.y - t.y),
            (this.z = e.z - t.z),
            (this.w = e.w - t.w),
            this
          );
        }
        multiply(e) {
          return (
            (this.x *= e.x),
            (this.y *= e.y),
            (this.z *= e.z),
            (this.w *= e.w),
            this
          );
        }
        multiplyScalar(e) {
          return (
            (this.x *= e), (this.y *= e), (this.z *= e), (this.w *= e), this
          );
        }
        applyMatrix4(e) {
          const t = this.x,
            n = this.y,
            i = this.z,
            r = this.w,
            a = e.elements;
          return (
            (this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r),
            (this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r),
            (this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r),
            (this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r),
            this
          );
        }
        divideScalar(e) {
          return this.multiplyScalar(1 / e);
        }
        setAxisAngleFromQuaternion(e) {
          this.w = 2 * Math.acos(e.w);
          const t = Math.sqrt(1 - e.w * e.w);
          return (
            t < 1e-4
              ? ((this.x = 1), (this.y = 0), (this.z = 0))
              : ((this.x = e.x / t), (this.y = e.y / t), (this.z = e.z / t)),
            this
          );
        }
        setAxisAngleFromRotationMatrix(e) {
          let t, n, i, r;
          const a = 0.01,
            o = 0.1,
            s = e.elements,
            l = s[0],
            c = s[4],
            u = s[8],
            h = s[1],
            d = s[5],
            p = s[9],
            m = s[2],
            f = s[6],
            g = s[10];
          if (
            Math.abs(c - h) < a &&
            Math.abs(u - m) < a &&
            Math.abs(p - f) < a
          ) {
            if (
              Math.abs(c + h) < o &&
              Math.abs(u + m) < o &&
              Math.abs(p + f) < o &&
              Math.abs(l + d + g - 3) < o
            )
              return this.set(1, 0, 0, 0), this;
            t = Math.PI;
            const e = (l + 1) / 2,
              s = (d + 1) / 2,
              v = (g + 1) / 2,
              y = (c + h) / 4,
              x = (u + m) / 4,
              b = (p + f) / 4;
            return (
              e > s && e > v
                ? e < a
                  ? ((n = 0), (i = 0.707106781), (r = 0.707106781))
                  : ((n = Math.sqrt(e)), (i = y / n), (r = x / n))
                : s > v
                ? s < a
                  ? ((n = 0.707106781), (i = 0), (r = 0.707106781))
                  : ((i = Math.sqrt(s)), (n = y / i), (r = b / i))
                : v < a
                ? ((n = 0.707106781), (i = 0.707106781), (r = 0))
                : ((r = Math.sqrt(v)), (n = x / r), (i = b / r)),
              this.set(n, i, r, t),
              this
            );
          }
          let v = Math.sqrt(
            (f - p) * (f - p) + (u - m) * (u - m) + (h - c) * (h - c)
          );
          return (
            Math.abs(v) < 0.001 && (v = 1),
            (this.x = (f - p) / v),
            (this.y = (u - m) / v),
            (this.z = (h - c) / v),
            (this.w = Math.acos((l + d + g - 1) / 2)),
            this
          );
        }
        min(e) {
          return (
            (this.x = Math.min(this.x, e.x)),
            (this.y = Math.min(this.y, e.y)),
            (this.z = Math.min(this.z, e.z)),
            (this.w = Math.min(this.w, e.w)),
            this
          );
        }
        max(e) {
          return (
            (this.x = Math.max(this.x, e.x)),
            (this.y = Math.max(this.y, e.y)),
            (this.z = Math.max(this.z, e.z)),
            (this.w = Math.max(this.w, e.w)),
            this
          );
        }
        clamp(e, t) {
          return (
            (this.x = Math.max(e.x, Math.min(t.x, this.x))),
            (this.y = Math.max(e.y, Math.min(t.y, this.y))),
            (this.z = Math.max(e.z, Math.min(t.z, this.z))),
            (this.w = Math.max(e.w, Math.min(t.w, this.w))),
            this
          );
        }
        clampScalar(e, t) {
          return (
            (this.x = Math.max(e, Math.min(t, this.x))),
            (this.y = Math.max(e, Math.min(t, this.y))),
            (this.z = Math.max(e, Math.min(t, this.z))),
            (this.w = Math.max(e, Math.min(t, this.w))),
            this
          );
        }
        clampLength(e, t) {
          const n = this.length();
          return this.divideScalar(n || 1).multiplyScalar(
            Math.max(e, Math.min(t, n))
          );
        }
        floor() {
          return (
            (this.x = Math.floor(this.x)),
            (this.y = Math.floor(this.y)),
            (this.z = Math.floor(this.z)),
            (this.w = Math.floor(this.w)),
            this
          );
        }
        ceil() {
          return (
            (this.x = Math.ceil(this.x)),
            (this.y = Math.ceil(this.y)),
            (this.z = Math.ceil(this.z)),
            (this.w = Math.ceil(this.w)),
            this
          );
        }
        round() {
          return (
            (this.x = Math.round(this.x)),
            (this.y = Math.round(this.y)),
            (this.z = Math.round(this.z)),
            (this.w = Math.round(this.w)),
            this
          );
        }
        roundToZero() {
          return (
            (this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x)),
            (this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y)),
            (this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z)),
            (this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w)),
            this
          );
        }
        negate() {
          return (
            (this.x = -this.x),
            (this.y = -this.y),
            (this.z = -this.z),
            (this.w = -this.w),
            this
          );
        }
        dot(e) {
          return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
        }
        lengthSq() {
          return (
            this.x * this.x +
            this.y * this.y +
            this.z * this.z +
            this.w * this.w
          );
        }
        length() {
          return Math.sqrt(
            this.x * this.x +
              this.y * this.y +
              this.z * this.z +
              this.w * this.w
          );
        }
        manhattanLength() {
          return (
            Math.abs(this.x) +
            Math.abs(this.y) +
            Math.abs(this.z) +
            Math.abs(this.w)
          );
        }
        normalize() {
          return this.divideScalar(this.length() || 1);
        }
        setLength(e) {
          return this.normalize().multiplyScalar(e);
        }
        lerp(e, t) {
          return (
            (this.x += (e.x - this.x) * t),
            (this.y += (e.y - this.y) * t),
            (this.z += (e.z - this.z) * t),
            (this.w += (e.w - this.w) * t),
            this
          );
        }
        lerpVectors(e, t, n) {
          return (
            (this.x = e.x + (t.x - e.x) * n),
            (this.y = e.y + (t.y - e.y) * n),
            (this.z = e.z + (t.z - e.z) * n),
            (this.w = e.w + (t.w - e.w) * n),
            this
          );
        }
        equals(e) {
          return (
            e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w
          );
        }
        fromArray(e, t = 0) {
          return (
            (this.x = e[t]),
            (this.y = e[t + 1]),
            (this.z = e[t + 2]),
            (this.w = e[t + 3]),
            this
          );
        }
        toArray(e = [], t = 0) {
          return (
            (e[t] = this.x),
            (e[t + 1] = this.y),
            (e[t + 2] = this.z),
            (e[t + 3] = this.w),
            e
          );
        }
        fromBufferAttribute(e, t, n) {
          return (
            void 0 !== n &&
              console.warn(
                "THREE.Vector4: offset has been removed from .fromBufferAttribute()."
              ),
            (this.x = e.getX(t)),
            (this.y = e.getY(t)),
            (this.z = e.getZ(t)),
            (this.w = e.getW(t)),
            this
          );
        }
        random() {
          return (
            (this.x = Math.random()),
            (this.y = Math.random()),
            (this.z = Math.random()),
            (this.w = Math.random()),
            this
          );
        }
      }
      On.prototype.isVector4 = !0;
      class Fn extends fn {
        constructor(e, t, n = {}) {
          super(),
            (this.width = e),
            (this.height = t),
            (this.depth = 1),
            (this.scissor = new On(0, 0, e, t)),
            (this.scissorTest = !1),
            (this.viewport = new On(0, 0, e, t)),
            (this.texture = new Nn(
              void 0,
              n.mapping,
              n.wrapS,
              n.wrapT,
              n.magFilter,
              n.minFilter,
              n.format,
              n.type,
              n.anisotropy,
              n.encoding
            )),
            (this.texture.isRenderTargetTexture = !0),
            (this.texture.image = { width: e, height: t, depth: 1 }),
            (this.texture.generateMipmaps =
              void 0 !== n.generateMipmaps && n.generateMipmaps),
            (this.texture.internalFormat =
              void 0 !== n.internalFormat ? n.internalFormat : null),
            (this.texture.minFilter =
              void 0 !== n.minFilter ? n.minFilter : Re),
            (this.depthBuffer = void 0 === n.depthBuffer || n.depthBuffer),
            (this.stencilBuffer =
              void 0 !== n.stencilBuffer && n.stencilBuffer),
            (this.depthTexture =
              void 0 !== n.depthTexture ? n.depthTexture : null);
        }
        setTexture(e) {
          (e.image = {
            width: this.width,
            height: this.height,
            depth: this.depth,
          }),
            (this.texture = e);
        }
        setSize(e, t, n = 1) {
          (this.width === e && this.height === t && this.depth === n) ||
            ((this.width = e),
            (this.height = t),
            (this.depth = n),
            (this.texture.image.width = e),
            (this.texture.image.height = t),
            (this.texture.image.depth = n),
            this.dispose()),
            this.viewport.set(0, 0, e, t),
            this.scissor.set(0, 0, e, t);
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          return (
            (this.width = e.width),
            (this.height = e.height),
            (this.depth = e.depth),
            this.viewport.copy(e.viewport),
            (this.texture = e.texture.clone()),
            (this.texture.image = { ...this.texture.image }),
            (this.depthBuffer = e.depthBuffer),
            (this.stencilBuffer = e.stencilBuffer),
            (this.depthTexture = e.depthTexture),
            this
          );
        }
        dispose() {
          this.dispatchEvent({ type: "dispose" });
        }
      }
      Fn.prototype.isWebGLRenderTarget = !0;
      (class extends Fn {
        constructor(e, t, n) {
          super(e, t);
          const i = this.texture;
          this.texture = [];
          for (let e = 0; e < n; e++) this.texture[e] = i.clone();
        }
        setSize(e, t, n = 1) {
          if (this.width !== e || this.height !== t || this.depth !== n) {
            (this.width = e), (this.height = t), (this.depth = n);
            for (let i = 0, r = this.texture.length; i < r; i++)
              (this.texture[i].image.width = e),
                (this.texture[i].image.height = t),
                (this.texture[i].image.depth = n);
            this.dispose();
          }
          return (
            this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t), this
          );
        }
        copy(e) {
          this.dispose(),
            (this.width = e.width),
            (this.height = e.height),
            (this.depth = e.depth),
            this.viewport.set(0, 0, this.width, this.height),
            this.scissor.set(0, 0, this.width, this.height),
            (this.depthBuffer = e.depthBuffer),
            (this.stencilBuffer = e.stencilBuffer),
            (this.depthTexture = e.depthTexture),
            (this.texture.length = 0);
          for (let t = 0, n = e.texture.length; t < n; t++)
            this.texture[t] = e.texture[t].clone();
          return this;
        }
      }).prototype.isWebGLMultipleRenderTargets = !0;
      class kn extends Fn {
        constructor(e, t, n) {
          super(e, t, n), (this.samples = 4);
        }
        copy(e) {
          return super.copy.call(this, e), (this.samples = e.samples), this;
        }
      }
      kn.prototype.isWebGLMultisampleRenderTarget = !0;
      class Hn {
        constructor(e = 0, t = 0, n = 0, i = 1) {
          (this._x = e), (this._y = t), (this._z = n), (this._w = i);
        }
        static slerp(e, t, n, i) {
          return (
            console.warn(
              "THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead."
            ),
            n.slerpQuaternions(e, t, i)
          );
        }
        static slerpFlat(e, t, n, i, r, a, o) {
          let s = n[i + 0],
            l = n[i + 1],
            c = n[i + 2],
            u = n[i + 3];
          const h = r[a + 0],
            d = r[a + 1],
            p = r[a + 2],
            m = r[a + 3];
          if (0 === o)
            return (
              (e[t + 0] = s),
              (e[t + 1] = l),
              (e[t + 2] = c),
              void (e[t + 3] = u)
            );
          if (1 === o)
            return (
              (e[t + 0] = h),
              (e[t + 1] = d),
              (e[t + 2] = p),
              void (e[t + 3] = m)
            );
          if (u !== m || s !== h || l !== d || c !== p) {
            let e = 1 - o;
            const t = s * h + l * d + c * p + u * m,
              n = t >= 0 ? 1 : -1,
              i = 1 - t * t;
            if (i > Number.EPSILON) {
              const r = Math.sqrt(i),
                a = Math.atan2(r, t * n);
              (e = Math.sin(e * a) / r), (o = Math.sin(o * a) / r);
            }
            const r = o * n;
            if (
              ((s = s * e + h * r),
              (l = l * e + d * r),
              (c = c * e + p * r),
              (u = u * e + m * r),
              e === 1 - o)
            ) {
              const e = 1 / Math.sqrt(s * s + l * l + c * c + u * u);
              (s *= e), (l *= e), (c *= e), (u *= e);
            }
          }
          (e[t] = s), (e[t + 1] = l), (e[t + 2] = c), (e[t + 3] = u);
        }
        static multiplyQuaternionsFlat(e, t, n, i, r, a) {
          const o = n[i],
            s = n[i + 1],
            l = n[i + 2],
            c = n[i + 3],
            u = r[a],
            h = r[a + 1],
            d = r[a + 2],
            p = r[a + 3];
          return (
            (e[t] = o * p + c * u + s * d - l * h),
            (e[t + 1] = s * p + c * h + l * u - o * d),
            (e[t + 2] = l * p + c * d + o * h - s * u),
            (e[t + 3] = c * p - o * u - s * h - l * d),
            e
          );
        }
        get x() {
          return this._x;
        }
        set x(e) {
          (this._x = e), this._onChangeCallback();
        }
        get y() {
          return this._y;
        }
        set y(e) {
          (this._y = e), this._onChangeCallback();
        }
        get z() {
          return this._z;
        }
        set z(e) {
          (this._z = e), this._onChangeCallback();
        }
        get w() {
          return this._w;
        }
        set w(e) {
          (this._w = e), this._onChangeCallback();
        }
        set(e, t, n, i) {
          return (
            (this._x = e),
            (this._y = t),
            (this._z = n),
            (this._w = i),
            this._onChangeCallback(),
            this
          );
        }
        clone() {
          return new this.constructor(this._x, this._y, this._z, this._w);
        }
        copy(e) {
          return (
            (this._x = e.x),
            (this._y = e.y),
            (this._z = e.z),
            (this._w = e.w),
            this._onChangeCallback(),
            this
          );
        }
        setFromEuler(e, t) {
          if (!e || !e.isEuler)
            throw new Error(
              "THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order."
            );
          const n = e._x,
            i = e._y,
            r = e._z,
            a = e._order,
            o = Math.cos,
            s = Math.sin,
            l = o(n / 2),
            c = o(i / 2),
            u = o(r / 2),
            h = s(n / 2),
            d = s(i / 2),
            p = s(r / 2);
          switch (a) {
            case "XYZ":
              (this._x = h * c * u + l * d * p),
                (this._y = l * d * u - h * c * p),
                (this._z = l * c * p + h * d * u),
                (this._w = l * c * u - h * d * p);
              break;
            case "YXZ":
              (this._x = h * c * u + l * d * p),
                (this._y = l * d * u - h * c * p),
                (this._z = l * c * p - h * d * u),
                (this._w = l * c * u + h * d * p);
              break;
            case "ZXY":
              (this._x = h * c * u - l * d * p),
                (this._y = l * d * u + h * c * p),
                (this._z = l * c * p + h * d * u),
                (this._w = l * c * u - h * d * p);
              break;
            case "ZYX":
              (this._x = h * c * u - l * d * p),
                (this._y = l * d * u + h * c * p),
                (this._z = l * c * p - h * d * u),
                (this._w = l * c * u + h * d * p);
              break;
            case "YZX":
              (this._x = h * c * u + l * d * p),
                (this._y = l * d * u + h * c * p),
                (this._z = l * c * p - h * d * u),
                (this._w = l * c * u - h * d * p);
              break;
            case "XZY":
              (this._x = h * c * u - l * d * p),
                (this._y = l * d * u - h * c * p),
                (this._z = l * c * p + h * d * u),
                (this._w = l * c * u + h * d * p);
              break;
            default:
              console.warn(
                "THREE.Quaternion: .setFromEuler() encountered an unknown order: " +
                  a
              );
          }
          return !1 !== t && this._onChangeCallback(), this;
        }
        setFromAxisAngle(e, t) {
          const n = t / 2,
            i = Math.sin(n);
          return (
            (this._x = e.x * i),
            (this._y = e.y * i),
            (this._z = e.z * i),
            (this._w = Math.cos(n)),
            this._onChangeCallback(),
            this
          );
        }
        setFromRotationMatrix(e) {
          const t = e.elements,
            n = t[0],
            i = t[4],
            r = t[8],
            a = t[1],
            o = t[5],
            s = t[9],
            l = t[2],
            c = t[6],
            u = t[10],
            h = n + o + u;
          if (h > 0) {
            const e = 0.5 / Math.sqrt(h + 1);
            (this._w = 0.25 / e),
              (this._x = (c - s) * e),
              (this._y = (r - l) * e),
              (this._z = (a - i) * e);
          } else if (n > o && n > u) {
            const e = 2 * Math.sqrt(1 + n - o - u);
            (this._w = (c - s) / e),
              (this._x = 0.25 * e),
              (this._y = (i + a) / e),
              (this._z = (r + l) / e);
          } else if (o > u) {
            const e = 2 * Math.sqrt(1 + o - n - u);
            (this._w = (r - l) / e),
              (this._x = (i + a) / e),
              (this._y = 0.25 * e),
              (this._z = (s + c) / e);
          } else {
            const e = 2 * Math.sqrt(1 + u - n - o);
            (this._w = (a - i) / e),
              (this._x = (r + l) / e),
              (this._y = (s + c) / e),
              (this._z = 0.25 * e);
          }
          return this._onChangeCallback(), this;
        }
        setFromUnitVectors(e, t) {
          let n = e.dot(t) + 1;
          return (
            n < Number.EPSILON
              ? ((n = 0),
                Math.abs(e.x) > Math.abs(e.z)
                  ? ((this._x = -e.y),
                    (this._y = e.x),
                    (this._z = 0),
                    (this._w = n))
                  : ((this._x = 0),
                    (this._y = -e.z),
                    (this._z = e.y),
                    (this._w = n)))
              : ((this._x = e.y * t.z - e.z * t.y),
                (this._y = e.z * t.x - e.x * t.z),
                (this._z = e.x * t.y - e.y * t.x),
                (this._w = n)),
            this.normalize()
          );
        }
        angleTo(e) {
          return 2 * Math.acos(Math.abs(_n(this.dot(e), -1, 1)));
        }
        rotateTowards(e, t) {
          const n = this.angleTo(e);
          if (0 === n) return this;
          const i = Math.min(1, t / n);
          return this.slerp(e, i), this;
        }
        identity() {
          return this.set(0, 0, 0, 1);
        }
        invert() {
          return this.conjugate();
        }
        conjugate() {
          return (
            (this._x *= -1),
            (this._y *= -1),
            (this._z *= -1),
            this._onChangeCallback(),
            this
          );
        }
        dot(e) {
          return (
            this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w
          );
        }
        lengthSq() {
          return (
            this._x * this._x +
            this._y * this._y +
            this._z * this._z +
            this._w * this._w
          );
        }
        length() {
          return Math.sqrt(
            this._x * this._x +
              this._y * this._y +
              this._z * this._z +
              this._w * this._w
          );
        }
        normalize() {
          let e = this.length();
          return (
            0 === e
              ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
              : ((e = 1 / e),
                (this._x = this._x * e),
                (this._y = this._y * e),
                (this._z = this._z * e),
                (this._w = this._w * e)),
            this._onChangeCallback(),
            this
          );
        }
        multiply(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."
              ),
              this.multiplyQuaternions(e, t))
            : this.multiplyQuaternions(this, e);
        }
        premultiply(e) {
          return this.multiplyQuaternions(e, this);
        }
        multiplyQuaternions(e, t) {
          const n = e._x,
            i = e._y,
            r = e._z,
            a = e._w,
            o = t._x,
            s = t._y,
            l = t._z,
            c = t._w;
          return (
            (this._x = n * c + a * o + i * l - r * s),
            (this._y = i * c + a * s + r * o - n * l),
            (this._z = r * c + a * l + n * s - i * o),
            (this._w = a * c - n * o - i * s - r * l),
            this._onChangeCallback(),
            this
          );
        }
        slerp(e, t) {
          if (0 === t) return this;
          if (1 === t) return this.copy(e);
          const n = this._x,
            i = this._y,
            r = this._z,
            a = this._w;
          let o = a * e._w + n * e._x + i * e._y + r * e._z;
          if (
            (o < 0
              ? ((this._w = -e._w),
                (this._x = -e._x),
                (this._y = -e._y),
                (this._z = -e._z),
                (o = -o))
              : this.copy(e),
            o >= 1)
          )
            return (
              (this._w = a), (this._x = n), (this._y = i), (this._z = r), this
            );
          const s = 1 - o * o;
          if (s <= Number.EPSILON) {
            const e = 1 - t;
            return (
              (this._w = e * a + t * this._w),
              (this._x = e * n + t * this._x),
              (this._y = e * i + t * this._y),
              (this._z = e * r + t * this._z),
              this.normalize(),
              this._onChangeCallback(),
              this
            );
          }
          const l = Math.sqrt(s),
            c = Math.atan2(l, o),
            u = Math.sin((1 - t) * c) / l,
            h = Math.sin(t * c) / l;
          return (
            (this._w = a * u + this._w * h),
            (this._x = n * u + this._x * h),
            (this._y = i * u + this._y * h),
            (this._z = r * u + this._z * h),
            this._onChangeCallback(),
            this
          );
        }
        slerpQuaternions(e, t, n) {
          this.copy(e).slerp(t, n);
        }
        equals(e) {
          return (
            e._x === this._x &&
            e._y === this._y &&
            e._z === this._z &&
            e._w === this._w
          );
        }
        fromArray(e, t = 0) {
          return (
            (this._x = e[t]),
            (this._y = e[t + 1]),
            (this._z = e[t + 2]),
            (this._w = e[t + 3]),
            this._onChangeCallback(),
            this
          );
        }
        toArray(e = [], t = 0) {
          return (
            (e[t] = this._x),
            (e[t + 1] = this._y),
            (e[t + 2] = this._z),
            (e[t + 3] = this._w),
            e
          );
        }
        fromBufferAttribute(e, t) {
          return (
            (this._x = e.getX(t)),
            (this._y = e.getY(t)),
            (this._z = e.getZ(t)),
            (this._w = e.getW(t)),
            this
          );
        }
        _onChange(e) {
          return (this._onChangeCallback = e), this;
        }
        _onChangeCallback() {}
      }
      Hn.prototype.isQuaternion = !0;
      class zn {
        constructor(e = 0, t = 0, n = 0) {
          (this.x = e), (this.y = t), (this.z = n);
        }
        set(e, t, n) {
          return (
            void 0 === n && (n = this.z),
            (this.x = e),
            (this.y = t),
            (this.z = n),
            this
          );
        }
        setScalar(e) {
          return (this.x = e), (this.y = e), (this.z = e), this;
        }
        setX(e) {
          return (this.x = e), this;
        }
        setY(e) {
          return (this.y = e), this;
        }
        setZ(e) {
          return (this.z = e), this;
        }
        setComponent(e, t) {
          switch (e) {
            case 0:
              this.x = t;
              break;
            case 1:
              this.y = t;
              break;
            case 2:
              this.z = t;
              break;
            default:
              throw new Error("index is out of range: " + e);
          }
          return this;
        }
        getComponent(e) {
          switch (e) {
            case 0:
              return this.x;
            case 1:
              return this.y;
            case 2:
              return this.z;
            default:
              throw new Error("index is out of range: " + e);
          }
        }
        clone() {
          return new this.constructor(this.x, this.y, this.z);
        }
        copy(e) {
          return (this.x = e.x), (this.y = e.y), (this.z = e.z), this;
        }
        add(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."
              ),
              this.addVectors(e, t))
            : ((this.x += e.x), (this.y += e.y), (this.z += e.z), this);
        }
        addScalar(e) {
          return (this.x += e), (this.y += e), (this.z += e), this;
        }
        addVectors(e, t) {
          return (
            (this.x = e.x + t.x),
            (this.y = e.y + t.y),
            (this.z = e.z + t.z),
            this
          );
        }
        addScaledVector(e, t) {
          return (
            (this.x += e.x * t), (this.y += e.y * t), (this.z += e.z * t), this
          );
        }
        sub(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."
              ),
              this.subVectors(e, t))
            : ((this.x -= e.x), (this.y -= e.y), (this.z -= e.z), this);
        }
        subScalar(e) {
          return (this.x -= e), (this.y -= e), (this.z -= e), this;
        }
        subVectors(e, t) {
          return (
            (this.x = e.x - t.x),
            (this.y = e.y - t.y),
            (this.z = e.z - t.z),
            this
          );
        }
        multiply(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."
              ),
              this.multiplyVectors(e, t))
            : ((this.x *= e.x), (this.y *= e.y), (this.z *= e.z), this);
        }
        multiplyScalar(e) {
          return (this.x *= e), (this.y *= e), (this.z *= e), this;
        }
        multiplyVectors(e, t) {
          return (
            (this.x = e.x * t.x),
            (this.y = e.y * t.y),
            (this.z = e.z * t.z),
            this
          );
        }
        applyEuler(e) {
          return (
            (e && e.isEuler) ||
              console.error(
                "THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."
              ),
            this.applyQuaternion(Bn.setFromEuler(e))
          );
        }
        applyAxisAngle(e, t) {
          return this.applyQuaternion(Bn.setFromAxisAngle(e, t));
        }
        applyMatrix3(e) {
          const t = this.x,
            n = this.y,
            i = this.z,
            r = e.elements;
          return (
            (this.x = r[0] * t + r[3] * n + r[6] * i),
            (this.y = r[1] * t + r[4] * n + r[7] * i),
            (this.z = r[2] * t + r[5] * n + r[8] * i),
            this
          );
        }
        applyNormalMatrix(e) {
          return this.applyMatrix3(e).normalize();
        }
        applyMatrix4(e) {
          const t = this.x,
            n = this.y,
            i = this.z,
            r = e.elements,
            a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
          return (
            (this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a),
            (this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a),
            (this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a),
            this
          );
        }
        applyQuaternion(e) {
          const t = this.x,
            n = this.y,
            i = this.z,
            r = e.x,
            a = e.y,
            o = e.z,
            s = e.w,
            l = s * t + a * i - o * n,
            c = s * n + o * t - r * i,
            u = s * i + r * n - a * t,
            h = -r * t - a * n - o * i;
          return (
            (this.x = l * s + h * -r + c * -o - u * -a),
            (this.y = c * s + h * -a + u * -r - l * -o),
            (this.z = u * s + h * -o + l * -a - c * -r),
            this
          );
        }
        project(e) {
          return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(
            e.projectionMatrix
          );
        }
        unproject(e) {
          return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(
            e.matrixWorld
          );
        }
        transformDirection(e) {
          const t = this.x,
            n = this.y,
            i = this.z,
            r = e.elements;
          return (
            (this.x = r[0] * t + r[4] * n + r[8] * i),
            (this.y = r[1] * t + r[5] * n + r[9] * i),
            (this.z = r[2] * t + r[6] * n + r[10] * i),
            this.normalize()
          );
        }
        divide(e) {
          return (this.x /= e.x), (this.y /= e.y), (this.z /= e.z), this;
        }
        divideScalar(e) {
          return this.multiplyScalar(1 / e);
        }
        min(e) {
          return (
            (this.x = Math.min(this.x, e.x)),
            (this.y = Math.min(this.y, e.y)),
            (this.z = Math.min(this.z, e.z)),
            this
          );
        }
        max(e) {
          return (
            (this.x = Math.max(this.x, e.x)),
            (this.y = Math.max(this.y, e.y)),
            (this.z = Math.max(this.z, e.z)),
            this
          );
        }
        clamp(e, t) {
          return (
            (this.x = Math.max(e.x, Math.min(t.x, this.x))),
            (this.y = Math.max(e.y, Math.min(t.y, this.y))),
            (this.z = Math.max(e.z, Math.min(t.z, this.z))),
            this
          );
        }
        clampScalar(e, t) {
          return (
            (this.x = Math.max(e, Math.min(t, this.x))),
            (this.y = Math.max(e, Math.min(t, this.y))),
            (this.z = Math.max(e, Math.min(t, this.z))),
            this
          );
        }
        clampLength(e, t) {
          const n = this.length();
          return this.divideScalar(n || 1).multiplyScalar(
            Math.max(e, Math.min(t, n))
          );
        }
        floor() {
          return (
            (this.x = Math.floor(this.x)),
            (this.y = Math.floor(this.y)),
            (this.z = Math.floor(this.z)),
            this
          );
        }
        ceil() {
          return (
            (this.x = Math.ceil(this.x)),
            (this.y = Math.ceil(this.y)),
            (this.z = Math.ceil(this.z)),
            this
          );
        }
        round() {
          return (
            (this.x = Math.round(this.x)),
            (this.y = Math.round(this.y)),
            (this.z = Math.round(this.z)),
            this
          );
        }
        roundToZero() {
          return (
            (this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x)),
            (this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y)),
            (this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z)),
            this
          );
        }
        negate() {
          return (
            (this.x = -this.x), (this.y = -this.y), (this.z = -this.z), this
          );
        }
        dot(e) {
          return this.x * e.x + this.y * e.y + this.z * e.z;
        }
        lengthSq() {
          return this.x * this.x + this.y * this.y + this.z * this.z;
        }
        length() {
          return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        }
        manhattanLength() {
          return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
        }
        normalize() {
          return this.divideScalar(this.length() || 1);
        }
        setLength(e) {
          return this.normalize().multiplyScalar(e);
        }
        lerp(e, t) {
          return (
            (this.x += (e.x - this.x) * t),
            (this.y += (e.y - this.y) * t),
            (this.z += (e.z - this.z) * t),
            this
          );
        }
        lerpVectors(e, t, n) {
          return (
            (this.x = e.x + (t.x - e.x) * n),
            (this.y = e.y + (t.y - e.y) * n),
            (this.z = e.z + (t.z - e.z) * n),
            this
          );
        }
        cross(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."
              ),
              this.crossVectors(e, t))
            : this.crossVectors(this, e);
        }
        crossVectors(e, t) {
          const n = e.x,
            i = e.y,
            r = e.z,
            a = t.x,
            o = t.y,
            s = t.z;
          return (
            (this.x = i * s - r * o),
            (this.y = r * a - n * s),
            (this.z = n * o - i * a),
            this
          );
        }
        projectOnVector(e) {
          const t = e.lengthSq();
          if (0 === t) return this.set(0, 0, 0);
          const n = e.dot(this) / t;
          return this.copy(e).multiplyScalar(n);
        }
        projectOnPlane(e) {
          return Un.copy(this).projectOnVector(e), this.sub(Un);
        }
        reflect(e) {
          return this.sub(Un.copy(e).multiplyScalar(2 * this.dot(e)));
        }
        angleTo(e) {
          const t = Math.sqrt(this.lengthSq() * e.lengthSq());
          if (0 === t) return Math.PI / 2;
          const n = this.dot(e) / t;
          return Math.acos(_n(n, -1, 1));
        }
        distanceTo(e) {
          return Math.sqrt(this.distanceToSquared(e));
        }
        distanceToSquared(e) {
          const t = this.x - e.x,
            n = this.y - e.y,
            i = this.z - e.z;
          return t * t + n * n + i * i;
        }
        manhattanDistanceTo(e) {
          return (
            Math.abs(this.x - e.x) +
            Math.abs(this.y - e.y) +
            Math.abs(this.z - e.z)
          );
        }
        setFromSpherical(e) {
          return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
        }
        setFromSphericalCoords(e, t, n) {
          const i = Math.sin(t) * e;
          return (
            (this.x = i * Math.sin(n)),
            (this.y = Math.cos(t) * e),
            (this.z = i * Math.cos(n)),
            this
          );
        }
        setFromCylindrical(e) {
          return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
        }
        setFromCylindricalCoords(e, t, n) {
          return (
            (this.x = e * Math.sin(t)),
            (this.y = n),
            (this.z = e * Math.cos(t)),
            this
          );
        }
        setFromMatrixPosition(e) {
          const t = e.elements;
          return (this.x = t[12]), (this.y = t[13]), (this.z = t[14]), this;
        }
        setFromMatrixScale(e) {
          const t = this.setFromMatrixColumn(e, 0).length(),
            n = this.setFromMatrixColumn(e, 1).length(),
            i = this.setFromMatrixColumn(e, 2).length();
          return (this.x = t), (this.y = n), (this.z = i), this;
        }
        setFromMatrixColumn(e, t) {
          return this.fromArray(e.elements, 4 * t);
        }
        setFromMatrix3Column(e, t) {
          return this.fromArray(e.elements, 3 * t);
        }
        equals(e) {
          return e.x === this.x && e.y === this.y && e.z === this.z;
        }
        fromArray(e, t = 0) {
          return (
            (this.x = e[t]), (this.y = e[t + 1]), (this.z = e[t + 2]), this
          );
        }
        toArray(e = [], t = 0) {
          return (e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), e;
        }
        fromBufferAttribute(e, t, n) {
          return (
            void 0 !== n &&
              console.warn(
                "THREE.Vector3: offset has been removed from .fromBufferAttribute()."
              ),
            (this.x = e.getX(t)),
            (this.y = e.getY(t)),
            (this.z = e.getZ(t)),
            this
          );
        }
        random() {
          return (
            (this.x = Math.random()),
            (this.y = Math.random()),
            (this.z = Math.random()),
            this
          );
        }
      }
      zn.prototype.isVector3 = !0;
      const Un = new zn(),
        Bn = new Hn();
      class Gn {
        constructor(
          e = new zn(1 / 0, 1 / 0, 1 / 0),
          t = new zn(-1 / 0, -1 / 0, -1 / 0)
        ) {
          (this.min = e), (this.max = t);
        }
        set(e, t) {
          return this.min.copy(e), this.max.copy(t), this;
        }
        setFromArray(e) {
          let t = 1 / 0,
            n = 1 / 0,
            i = 1 / 0,
            r = -1 / 0,
            a = -1 / 0,
            o = -1 / 0;
          for (let s = 0, l = e.length; s < l; s += 3) {
            const l = e[s],
              c = e[s + 1],
              u = e[s + 2];
            l < t && (t = l),
              c < n && (n = c),
              u < i && (i = u),
              l > r && (r = l),
              c > a && (a = c),
              u > o && (o = u);
          }
          return this.min.set(t, n, i), this.max.set(r, a, o), this;
        }
        setFromBufferAttribute(e) {
          let t = 1 / 0,
            n = 1 / 0,
            i = 1 / 0,
            r = -1 / 0,
            a = -1 / 0,
            o = -1 / 0;
          for (let s = 0, l = e.count; s < l; s++) {
            const l = e.getX(s),
              c = e.getY(s),
              u = e.getZ(s);
            l < t && (t = l),
              c < n && (n = c),
              u < i && (i = u),
              l > r && (r = l),
              c > a && (a = c),
              u > o && (o = u);
          }
          return this.min.set(t, n, i), this.max.set(r, a, o), this;
        }
        setFromPoints(e) {
          this.makeEmpty();
          for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
          return this;
        }
        setFromCenterAndSize(e, t) {
          const n = Wn.copy(t).multiplyScalar(0.5);
          return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
        }
        setFromObject(e) {
          return this.makeEmpty(), this.expandByObject(e);
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          return this.min.copy(e.min), this.max.copy(e.max), this;
        }
        makeEmpty() {
          return (
            (this.min.x = this.min.y = this.min.z = 1 / 0),
            (this.max.x = this.max.y = this.max.z = -1 / 0),
            this
          );
        }
        isEmpty() {
          return (
            this.max.x < this.min.x ||
            this.max.y < this.min.y ||
            this.max.z < this.min.z
          );
        }
        getCenter(e) {
          return this.isEmpty()
            ? e.set(0, 0, 0)
            : e.addVectors(this.min, this.max).multiplyScalar(0.5);
        }
        getSize(e) {
          return this.isEmpty()
            ? e.set(0, 0, 0)
            : e.subVectors(this.max, this.min);
        }
        expandByPoint(e) {
          return this.min.min(e), this.max.max(e), this;
        }
        expandByVector(e) {
          return this.min.sub(e), this.max.add(e), this;
        }
        expandByScalar(e) {
          return this.min.addScalar(-e), this.max.addScalar(e), this;
        }
        expandByObject(e) {
          e.updateWorldMatrix(!1, !1);
          const t = e.geometry;
          void 0 !== t &&
            (null === t.boundingBox && t.computeBoundingBox(),
            jn.copy(t.boundingBox),
            jn.applyMatrix4(e.matrixWorld),
            this.union(jn));
          const n = e.children;
          for (let e = 0, t = n.length; e < t; e++) this.expandByObject(n[e]);
          return this;
        }
        containsPoint(e) {
          return !(
            e.x < this.min.x ||
            e.x > this.max.x ||
            e.y < this.min.y ||
            e.y > this.max.y ||
            e.z < this.min.z ||
            e.z > this.max.z
          );
        }
        containsBox(e) {
          return (
            this.min.x <= e.min.x &&
            e.max.x <= this.max.x &&
            this.min.y <= e.min.y &&
            e.max.y <= this.max.y &&
            this.min.z <= e.min.z &&
            e.max.z <= this.max.z
          );
        }
        getParameter(e, t) {
          return t.set(
            (e.x - this.min.x) / (this.max.x - this.min.x),
            (e.y - this.min.y) / (this.max.y - this.min.y),
            (e.z - this.min.z) / (this.max.z - this.min.z)
          );
        }
        intersectsBox(e) {
          return !(
            e.max.x < this.min.x ||
            e.min.x > this.max.x ||
            e.max.y < this.min.y ||
            e.min.y > this.max.y ||
            e.max.z < this.min.z ||
            e.min.z > this.max.z
          );
        }
        intersectsSphere(e) {
          return (
            this.clampPoint(e.center, Wn),
            Wn.distanceToSquared(e.center) <= e.radius * e.radius
          );
        }
        intersectsPlane(e) {
          let t, n;
          return (
            e.normal.x > 0
              ? ((t = e.normal.x * this.min.x), (n = e.normal.x * this.max.x))
              : ((t = e.normal.x * this.max.x), (n = e.normal.x * this.min.x)),
            e.normal.y > 0
              ? ((t += e.normal.y * this.min.y), (n += e.normal.y * this.max.y))
              : ((t += e.normal.y * this.max.y),
                (n += e.normal.y * this.min.y)),
            e.normal.z > 0
              ? ((t += e.normal.z * this.min.z), (n += e.normal.z * this.max.z))
              : ((t += e.normal.z * this.max.z),
                (n += e.normal.z * this.min.z)),
            t <= -e.constant && n >= -e.constant
          );
        }
        intersectsTriangle(e) {
          if (this.isEmpty()) return !1;
          this.getCenter(Qn),
            $n.subVectors(this.max, Qn),
            Xn.subVectors(e.a, Qn),
            qn.subVectors(e.b, Qn),
            Yn.subVectors(e.c, Qn),
            Kn.subVectors(qn, Xn),
            Zn.subVectors(Yn, qn),
            Jn.subVectors(Xn, Yn);
          let t = [
            0,
            -Kn.z,
            Kn.y,
            0,
            -Zn.z,
            Zn.y,
            0,
            -Jn.z,
            Jn.y,
            Kn.z,
            0,
            -Kn.x,
            Zn.z,
            0,
            -Zn.x,
            Jn.z,
            0,
            -Jn.x,
            -Kn.y,
            Kn.x,
            0,
            -Zn.y,
            Zn.x,
            0,
            -Jn.y,
            Jn.x,
            0,
          ];
          return (
            !!ni(t, Xn, qn, Yn, $n) &&
            ((t = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
            !!ni(t, Xn, qn, Yn, $n) &&
              (ei.crossVectors(Kn, Zn),
              (t = [ei.x, ei.y, ei.z]),
              ni(t, Xn, qn, Yn, $n)))
          );
        }
        clampPoint(e, t) {
          return t.copy(e).clamp(this.min, this.max);
        }
        distanceToPoint(e) {
          return Wn.copy(e).clamp(this.min, this.max).sub(e).length();
        }
        getBoundingSphere(e) {
          return (
            this.getCenter(e.center),
            (e.radius = 0.5 * this.getSize(Wn).length()),
            e
          );
        }
        intersect(e) {
          return (
            this.min.max(e.min),
            this.max.min(e.max),
            this.isEmpty() && this.makeEmpty(),
            this
          );
        }
        union(e) {
          return this.min.min(e.min), this.max.max(e.max), this;
        }
        applyMatrix4(e) {
          return (
            this.isEmpty() ||
              (Vn[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e),
              Vn[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e),
              Vn[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e),
              Vn[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e),
              Vn[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e),
              Vn[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e),
              Vn[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e),
              Vn[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e),
              this.setFromPoints(Vn)),
            this
          );
        }
        translate(e) {
          return this.min.add(e), this.max.add(e), this;
        }
        equals(e) {
          return e.min.equals(this.min) && e.max.equals(this.max);
        }
      }
      Gn.prototype.isBox3 = !0;
      const Vn = [
          new zn(),
          new zn(),
          new zn(),
          new zn(),
          new zn(),
          new zn(),
          new zn(),
          new zn(),
        ],
        Wn = new zn(),
        jn = new Gn(),
        Xn = new zn(),
        qn = new zn(),
        Yn = new zn(),
        Kn = new zn(),
        Zn = new zn(),
        Jn = new zn(),
        Qn = new zn(),
        $n = new zn(),
        ei = new zn(),
        ti = new zn();
      function ni(e, t, n, i, r) {
        for (let a = 0, o = e.length - 3; a <= o; a += 3) {
          ti.fromArray(e, a);
          const o =
              r.x * Math.abs(ti.x) +
              r.y * Math.abs(ti.y) +
              r.z * Math.abs(ti.z),
            s = t.dot(ti),
            l = n.dot(ti),
            c = i.dot(ti);
          if (Math.max(-Math.max(s, l, c), Math.min(s, l, c)) > o) return !1;
        }
        return !0;
      }
      const ii = new Gn(),
        ri = new zn(),
        ai = new zn(),
        oi = new zn();
      class si {
        constructor(e = new zn(), t = -1) {
          (this.center = e), (this.radius = t);
        }
        set(e, t) {
          return this.center.copy(e), (this.radius = t), this;
        }
        setFromPoints(e, t) {
          const n = this.center;
          void 0 !== t ? n.copy(t) : ii.setFromPoints(e).getCenter(n);
          let i = 0;
          for (let t = 0, r = e.length; t < r; t++)
            i = Math.max(i, n.distanceToSquared(e[t]));
          return (this.radius = Math.sqrt(i)), this;
        }
        copy(e) {
          return this.center.copy(e.center), (this.radius = e.radius), this;
        }
        isEmpty() {
          return this.radius < 0;
        }
        makeEmpty() {
          return this.center.set(0, 0, 0), (this.radius = -1), this;
        }
        containsPoint(e) {
          return e.distanceToSquared(this.center) <= this.radius * this.radius;
        }
        distanceToPoint(e) {
          return e.distanceTo(this.center) - this.radius;
        }
        intersectsSphere(e) {
          const t = this.radius + e.radius;
          return e.center.distanceToSquared(this.center) <= t * t;
        }
        intersectsBox(e) {
          return e.intersectsSphere(this);
        }
        intersectsPlane(e) {
          return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
        }
        clampPoint(e, t) {
          const n = this.center.distanceToSquared(e);
          return (
            t.copy(e),
            n > this.radius * this.radius &&
              (t.sub(this.center).normalize(),
              t.multiplyScalar(this.radius).add(this.center)),
            t
          );
        }
        getBoundingBox(e) {
          return this.isEmpty()
            ? (e.makeEmpty(), e)
            : (e.set(this.center, this.center),
              e.expandByScalar(this.radius),
              e);
        }
        applyMatrix4(e) {
          return (
            this.center.applyMatrix4(e),
            (this.radius = this.radius * e.getMaxScaleOnAxis()),
            this
          );
        }
        translate(e) {
          return this.center.add(e), this;
        }
        expandByPoint(e) {
          oi.subVectors(e, this.center);
          const t = oi.lengthSq();
          if (t > this.radius * this.radius) {
            const e = Math.sqrt(t),
              n = 0.5 * (e - this.radius);
            this.center.add(oi.multiplyScalar(n / e)), (this.radius += n);
          }
          return this;
        }
        union(e) {
          return (
            ai
              .subVectors(e.center, this.center)
              .normalize()
              .multiplyScalar(e.radius),
            this.expandByPoint(ri.copy(e.center).add(ai)),
            this.expandByPoint(ri.copy(e.center).sub(ai)),
            this
          );
        }
        equals(e) {
          return e.center.equals(this.center) && e.radius === this.radius;
        }
        clone() {
          return new this.constructor().copy(this);
        }
      }
      const li = new zn(),
        ci = new zn(),
        ui = new zn(),
        hi = new zn(),
        di = new zn(),
        pi = new zn(),
        mi = new zn();
      class fi {
        constructor(e = new zn(), t = new zn(0, 0, -1)) {
          (this.origin = e), (this.direction = t);
        }
        set(e, t) {
          return this.origin.copy(e), this.direction.copy(t), this;
        }
        copy(e) {
          return (
            this.origin.copy(e.origin), this.direction.copy(e.direction), this
          );
        }
        at(e, t) {
          return t.copy(this.direction).multiplyScalar(e).add(this.origin);
        }
        lookAt(e) {
          return this.direction.copy(e).sub(this.origin).normalize(), this;
        }
        recast(e) {
          return this.origin.copy(this.at(e, li)), this;
        }
        closestPointToPoint(e, t) {
          t.subVectors(e, this.origin);
          const n = t.dot(this.direction);
          return n < 0
            ? t.copy(this.origin)
            : t.copy(this.direction).multiplyScalar(n).add(this.origin);
        }
        distanceToPoint(e) {
          return Math.sqrt(this.distanceSqToPoint(e));
        }
        distanceSqToPoint(e) {
          const t = li.subVectors(e, this.origin).dot(this.direction);
          return t < 0
            ? this.origin.distanceToSquared(e)
            : (li.copy(this.direction).multiplyScalar(t).add(this.origin),
              li.distanceToSquared(e));
        }
        distanceSqToSegment(e, t, n, i) {
          ci.copy(e).add(t).multiplyScalar(0.5),
            ui.copy(t).sub(e).normalize(),
            hi.copy(this.origin).sub(ci);
          const r = 0.5 * e.distanceTo(t),
            a = -this.direction.dot(ui),
            o = hi.dot(this.direction),
            s = -hi.dot(ui),
            l = hi.lengthSq(),
            c = Math.abs(1 - a * a);
          let u, h, d, p;
          if (c > 0)
            if (((u = a * s - o), (h = a * o - s), (p = r * c), u >= 0))
              if (h >= -p)
                if (h <= p) {
                  const e = 1 / c;
                  (u *= e),
                    (h *= e),
                    (d = u * (u + a * h + 2 * o) + h * (a * u + h + 2 * s) + l);
                } else
                  (h = r),
                    (u = Math.max(0, -(a * h + o))),
                    (d = -u * u + h * (h + 2 * s) + l);
              else
                (h = -r),
                  (u = Math.max(0, -(a * h + o))),
                  (d = -u * u + h * (h + 2 * s) + l);
            else
              h <= -p
                ? ((u = Math.max(0, -(-a * r + o))),
                  (h = u > 0 ? -r : Math.min(Math.max(-r, -s), r)),
                  (d = -u * u + h * (h + 2 * s) + l))
                : h <= p
                ? ((u = 0),
                  (h = Math.min(Math.max(-r, -s), r)),
                  (d = h * (h + 2 * s) + l))
                : ((u = Math.max(0, -(a * r + o))),
                  (h = u > 0 ? r : Math.min(Math.max(-r, -s), r)),
                  (d = -u * u + h * (h + 2 * s) + l));
          else
            (h = a > 0 ? -r : r),
              (u = Math.max(0, -(a * h + o))),
              (d = -u * u + h * (h + 2 * s) + l);
          return (
            n && n.copy(this.direction).multiplyScalar(u).add(this.origin),
            i && i.copy(ui).multiplyScalar(h).add(ci),
            d
          );
        }
        intersectSphere(e, t) {
          li.subVectors(e.center, this.origin);
          const n = li.dot(this.direction),
            i = li.dot(li) - n * n,
            r = e.radius * e.radius;
          if (i > r) return null;
          const a = Math.sqrt(r - i),
            o = n - a,
            s = n + a;
          return o < 0 && s < 0 ? null : o < 0 ? this.at(s, t) : this.at(o, t);
        }
        intersectsSphere(e) {
          return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
        }
        distanceToPlane(e) {
          const t = e.normal.dot(this.direction);
          if (0 === t) return 0 === e.distanceToPoint(this.origin) ? 0 : null;
          const n = -(this.origin.dot(e.normal) + e.constant) / t;
          return n >= 0 ? n : null;
        }
        intersectPlane(e, t) {
          const n = this.distanceToPlane(e);
          return null === n ? null : this.at(n, t);
        }
        intersectsPlane(e) {
          const t = e.distanceToPoint(this.origin);
          if (0 === t) return !0;
          return e.normal.dot(this.direction) * t < 0;
        }
        intersectBox(e, t) {
          let n, i, r, a, o, s;
          const l = 1 / this.direction.x,
            c = 1 / this.direction.y,
            u = 1 / this.direction.z,
            h = this.origin;
          return (
            l >= 0
              ? ((n = (e.min.x - h.x) * l), (i = (e.max.x - h.x) * l))
              : ((n = (e.max.x - h.x) * l), (i = (e.min.x - h.x) * l)),
            c >= 0
              ? ((r = (e.min.y - h.y) * c), (a = (e.max.y - h.y) * c))
              : ((r = (e.max.y - h.y) * c), (a = (e.min.y - h.y) * c)),
            n > a || r > i
              ? null
              : ((r > n || n != n) && (n = r),
                (a < i || i != i) && (i = a),
                u >= 0
                  ? ((o = (e.min.z - h.z) * u), (s = (e.max.z - h.z) * u))
                  : ((o = (e.max.z - h.z) * u), (s = (e.min.z - h.z) * u)),
                n > s || o > i
                  ? null
                  : ((o > n || n != n) && (n = o),
                    (s < i || i != i) && (i = s),
                    i < 0 ? null : this.at(n >= 0 ? n : i, t)))
          );
        }
        intersectsBox(e) {
          return null !== this.intersectBox(e, li);
        }
        intersectTriangle(e, t, n, i, r) {
          di.subVectors(t, e), pi.subVectors(n, e), mi.crossVectors(di, pi);
          let a,
            o = this.direction.dot(mi);
          if (o > 0) {
            if (i) return null;
            a = 1;
          } else {
            if (!(o < 0)) return null;
            (a = -1), (o = -o);
          }
          hi.subVectors(this.origin, e);
          const s = a * this.direction.dot(pi.crossVectors(hi, pi));
          if (s < 0) return null;
          const l = a * this.direction.dot(di.cross(hi));
          if (l < 0) return null;
          if (s + l > o) return null;
          const c = -a * hi.dot(mi);
          return c < 0 ? null : this.at(c / o, r);
        }
        applyMatrix4(e) {
          return (
            this.origin.applyMatrix4(e),
            this.direction.transformDirection(e),
            this
          );
        }
        equals(e) {
          return (
            e.origin.equals(this.origin) && e.direction.equals(this.direction)
          );
        }
        clone() {
          return new this.constructor().copy(this);
        }
      }
      class gi {
        constructor() {
          (this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
            arguments.length > 0 &&
              console.error(
                "THREE.Matrix4: the constructor no longer reads arguments. use .set() instead."
              );
        }
        set(e, t, n, i, r, a, o, s, l, c, u, h, d, p, m, f) {
          const g = this.elements;
          return (
            (g[0] = e),
            (g[4] = t),
            (g[8] = n),
            (g[12] = i),
            (g[1] = r),
            (g[5] = a),
            (g[9] = o),
            (g[13] = s),
            (g[2] = l),
            (g[6] = c),
            (g[10] = u),
            (g[14] = h),
            (g[3] = d),
            (g[7] = p),
            (g[11] = m),
            (g[15] = f),
            this
          );
        }
        identity() {
          return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
        }
        clone() {
          return new gi().fromArray(this.elements);
        }
        copy(e) {
          const t = this.elements,
            n = e.elements;
          return (
            (t[0] = n[0]),
            (t[1] = n[1]),
            (t[2] = n[2]),
            (t[3] = n[3]),
            (t[4] = n[4]),
            (t[5] = n[5]),
            (t[6] = n[6]),
            (t[7] = n[7]),
            (t[8] = n[8]),
            (t[9] = n[9]),
            (t[10] = n[10]),
            (t[11] = n[11]),
            (t[12] = n[12]),
            (t[13] = n[13]),
            (t[14] = n[14]),
            (t[15] = n[15]),
            this
          );
        }
        copyPosition(e) {
          const t = this.elements,
            n = e.elements;
          return (t[12] = n[12]), (t[13] = n[13]), (t[14] = n[14]), this;
        }
        setFromMatrix3(e) {
          const t = e.elements;
          return (
            this.set(
              t[0],
              t[3],
              t[6],
              0,
              t[1],
              t[4],
              t[7],
              0,
              t[2],
              t[5],
              t[8],
              0,
              0,
              0,
              0,
              1
            ),
            this
          );
        }
        extractBasis(e, t, n) {
          return (
            e.setFromMatrixColumn(this, 0),
            t.setFromMatrixColumn(this, 1),
            n.setFromMatrixColumn(this, 2),
            this
          );
        }
        makeBasis(e, t, n) {
          return (
            this.set(
              e.x,
              t.x,
              n.x,
              0,
              e.y,
              t.y,
              n.y,
              0,
              e.z,
              t.z,
              n.z,
              0,
              0,
              0,
              0,
              1
            ),
            this
          );
        }
        extractRotation(e) {
          const t = this.elements,
            n = e.elements,
            i = 1 / vi.setFromMatrixColumn(e, 0).length(),
            r = 1 / vi.setFromMatrixColumn(e, 1).length(),
            a = 1 / vi.setFromMatrixColumn(e, 2).length();
          return (
            (t[0] = n[0] * i),
            (t[1] = n[1] * i),
            (t[2] = n[2] * i),
            (t[3] = 0),
            (t[4] = n[4] * r),
            (t[5] = n[5] * r),
            (t[6] = n[6] * r),
            (t[7] = 0),
            (t[8] = n[8] * a),
            (t[9] = n[9] * a),
            (t[10] = n[10] * a),
            (t[11] = 0),
            (t[12] = 0),
            (t[13] = 0),
            (t[14] = 0),
            (t[15] = 1),
            this
          );
        }
        makeRotationFromEuler(e) {
          (e && e.isEuler) ||
            console.error(
              "THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order."
            );
          const t = this.elements,
            n = e.x,
            i = e.y,
            r = e.z,
            a = Math.cos(n),
            o = Math.sin(n),
            s = Math.cos(i),
            l = Math.sin(i),
            c = Math.cos(r),
            u = Math.sin(r);
          if ("XYZ" === e.order) {
            const e = a * c,
              n = a * u,
              i = o * c,
              r = o * u;
            (t[0] = s * c),
              (t[4] = -s * u),
              (t[8] = l),
              (t[1] = n + i * l),
              (t[5] = e - r * l),
              (t[9] = -o * s),
              (t[2] = r - e * l),
              (t[6] = i + n * l),
              (t[10] = a * s);
          } else if ("YXZ" === e.order) {
            const e = s * c,
              n = s * u,
              i = l * c,
              r = l * u;
            (t[0] = e + r * o),
              (t[4] = i * o - n),
              (t[8] = a * l),
              (t[1] = a * u),
              (t[5] = a * c),
              (t[9] = -o),
              (t[2] = n * o - i),
              (t[6] = r + e * o),
              (t[10] = a * s);
          } else if ("ZXY" === e.order) {
            const e = s * c,
              n = s * u,
              i = l * c,
              r = l * u;
            (t[0] = e - r * o),
              (t[4] = -a * u),
              (t[8] = i + n * o),
              (t[1] = n + i * o),
              (t[5] = a * c),
              (t[9] = r - e * o),
              (t[2] = -a * l),
              (t[6] = o),
              (t[10] = a * s);
          } else if ("ZYX" === e.order) {
            const e = a * c,
              n = a * u,
              i = o * c,
              r = o * u;
            (t[0] = s * c),
              (t[4] = i * l - n),
              (t[8] = e * l + r),
              (t[1] = s * u),
              (t[5] = r * l + e),
              (t[9] = n * l - i),
              (t[2] = -l),
              (t[6] = o * s),
              (t[10] = a * s);
          } else if ("YZX" === e.order) {
            const e = a * s,
              n = a * l,
              i = o * s,
              r = o * l;
            (t[0] = s * c),
              (t[4] = r - e * u),
              (t[8] = i * u + n),
              (t[1] = u),
              (t[5] = a * c),
              (t[9] = -o * c),
              (t[2] = -l * c),
              (t[6] = n * u + i),
              (t[10] = e - r * u);
          } else if ("XZY" === e.order) {
            const e = a * s,
              n = a * l,
              i = o * s,
              r = o * l;
            (t[0] = s * c),
              (t[4] = -u),
              (t[8] = l * c),
              (t[1] = e * u + r),
              (t[5] = a * c),
              (t[9] = n * u - i),
              (t[2] = i * u - n),
              (t[6] = o * c),
              (t[10] = r * u + e);
          }
          return (
            (t[3] = 0),
            (t[7] = 0),
            (t[11] = 0),
            (t[12] = 0),
            (t[13] = 0),
            (t[14] = 0),
            (t[15] = 1),
            this
          );
        }
        makeRotationFromQuaternion(e) {
          return this.compose(xi, e, bi);
        }
        lookAt(e, t, n) {
          const i = this.elements;
          return (
            Mi.subVectors(e, t),
            0 === Mi.lengthSq() && (Mi.z = 1),
            Mi.normalize(),
            _i.crossVectors(n, Mi),
            0 === _i.lengthSq() &&
              (1 === Math.abs(n.z) ? (Mi.x += 1e-4) : (Mi.z += 1e-4),
              Mi.normalize(),
              _i.crossVectors(n, Mi)),
            _i.normalize(),
            wi.crossVectors(Mi, _i),
            (i[0] = _i.x),
            (i[4] = wi.x),
            (i[8] = Mi.x),
            (i[1] = _i.y),
            (i[5] = wi.y),
            (i[9] = Mi.y),
            (i[2] = _i.z),
            (i[6] = wi.z),
            (i[10] = Mi.z),
            this
          );
        }
        multiply(e, t) {
          return void 0 !== t
            ? (console.warn(
                "THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."
              ),
              this.multiplyMatrices(e, t))
            : this.multiplyMatrices(this, e);
        }
        premultiply(e) {
          return this.multiplyMatrices(e, this);
        }
        multiplyMatrices(e, t) {
          const n = e.elements,
            i = t.elements,
            r = this.elements,
            a = n[0],
            o = n[4],
            s = n[8],
            l = n[12],
            c = n[1],
            u = n[5],
            h = n[9],
            d = n[13],
            p = n[2],
            m = n[6],
            f = n[10],
            g = n[14],
            v = n[3],
            y = n[7],
            x = n[11],
            b = n[15],
            _ = i[0],
            w = i[4],
            M = i[8],
            S = i[12],
            T = i[1],
            E = i[5],
            A = i[9],
            L = i[13],
            P = i[2],
            R = i[6],
            C = i[10],
            I = i[14],
            N = i[3],
            D = i[7],
            O = i[11],
            F = i[15];
          return (
            (r[0] = a * _ + o * T + s * P + l * N),
            (r[4] = a * w + o * E + s * R + l * D),
            (r[8] = a * M + o * A + s * C + l * O),
            (r[12] = a * S + o * L + s * I + l * F),
            (r[1] = c * _ + u * T + h * P + d * N),
            (r[5] = c * w + u * E + h * R + d * D),
            (r[9] = c * M + u * A + h * C + d * O),
            (r[13] = c * S + u * L + h * I + d * F),
            (r[2] = p * _ + m * T + f * P + g * N),
            (r[6] = p * w + m * E + f * R + g * D),
            (r[10] = p * M + m * A + f * C + g * O),
            (r[14] = p * S + m * L + f * I + g * F),
            (r[3] = v * _ + y * T + x * P + b * N),
            (r[7] = v * w + y * E + x * R + b * D),
            (r[11] = v * M + y * A + x * C + b * O),
            (r[15] = v * S + y * L + x * I + b * F),
            this
          );
        }
        multiplyScalar(e) {
          const t = this.elements;
          return (
            (t[0] *= e),
            (t[4] *= e),
            (t[8] *= e),
            (t[12] *= e),
            (t[1] *= e),
            (t[5] *= e),
            (t[9] *= e),
            (t[13] *= e),
            (t[2] *= e),
            (t[6] *= e),
            (t[10] *= e),
            (t[14] *= e),
            (t[3] *= e),
            (t[7] *= e),
            (t[11] *= e),
            (t[15] *= e),
            this
          );
        }
        determinant() {
          const e = this.elements,
            t = e[0],
            n = e[4],
            i = e[8],
            r = e[12],
            a = e[1],
            o = e[5],
            s = e[9],
            l = e[13],
            c = e[2],
            u = e[6],
            h = e[10],
            d = e[14];
          return (
            e[3] *
              (+r * s * u -
                i * l * u -
                r * o * h +
                n * l * h +
                i * o * d -
                n * s * d) +
            e[7] *
              (+t * s * d -
                t * l * h +
                r * a * h -
                i * a * d +
                i * l * c -
                r * s * c) +
            e[11] *
              (+t * l * u -
                t * o * d -
                r * a * u +
                n * a * d +
                r * o * c -
                n * l * c) +
            e[15] *
              (-i * o * c -
                t * s * u +
                t * o * h +
                i * a * u -
                n * a * h +
                n * s * c)
          );
        }
        transpose() {
          const e = this.elements;
          let t;
          return (
            (t = e[1]),
            (e[1] = e[4]),
            (e[4] = t),
            (t = e[2]),
            (e[2] = e[8]),
            (e[8] = t),
            (t = e[6]),
            (e[6] = e[9]),
            (e[9] = t),
            (t = e[3]),
            (e[3] = e[12]),
            (e[12] = t),
            (t = e[7]),
            (e[7] = e[13]),
            (e[13] = t),
            (t = e[11]),
            (e[11] = e[14]),
            (e[14] = t),
            this
          );
        }
        setPosition(e, t, n) {
          const i = this.elements;
          return (
            e.isVector3
              ? ((i[12] = e.x), (i[13] = e.y), (i[14] = e.z))
              : ((i[12] = e), (i[13] = t), (i[14] = n)),
            this
          );
        }
        invert() {
          const e = this.elements,
            t = e[0],
            n = e[1],
            i = e[2],
            r = e[3],
            a = e[4],
            o = e[5],
            s = e[6],
            l = e[7],
            c = e[8],
            u = e[9],
            h = e[10],
            d = e[11],
            p = e[12],
            m = e[13],
            f = e[14],
            g = e[15],
            v =
              u * f * l -
              m * h * l +
              m * s * d -
              o * f * d -
              u * s * g +
              o * h * g,
            y =
              p * h * l -
              c * f * l -
              p * s * d +
              a * f * d +
              c * s * g -
              a * h * g,
            x =
              c * m * l -
              p * u * l +
              p * o * d -
              a * m * d -
              c * o * g +
              a * u * g,
            b =
              p * u * s -
              c * m * s -
              p * o * h +
              a * m * h +
              c * o * f -
              a * u * f,
            _ = t * v + n * y + i * x + r * b;
          if (0 === _)
            return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
          const w = 1 / _;
          return (
            (e[0] = v * w),
            (e[1] =
              (m * h * r -
                u * f * r -
                m * i * d +
                n * f * d +
                u * i * g -
                n * h * g) *
              w),
            (e[2] =
              (o * f * r -
                m * s * r +
                m * i * l -
                n * f * l -
                o * i * g +
                n * s * g) *
              w),
            (e[3] =
              (u * s * r -
                o * h * r -
                u * i * l +
                n * h * l +
                o * i * d -
                n * s * d) *
              w),
            (e[4] = y * w),
            (e[5] =
              (c * f * r -
                p * h * r +
                p * i * d -
                t * f * d -
                c * i * g +
                t * h * g) *
              w),
            (e[6] =
              (p * s * r -
                a * f * r -
                p * i * l +
                t * f * l +
                a * i * g -
                t * s * g) *
              w),
            (e[7] =
              (a * h * r -
                c * s * r +
                c * i * l -
                t * h * l -
                a * i * d +
                t * s * d) *
              w),
            (e[8] = x * w),
            (e[9] =
              (p * u * r -
                c * m * r -
                p * n * d +
                t * m * d +
                c * n * g -
                t * u * g) *
              w),
            (e[10] =
              (a * m * r -
                p * o * r +
                p * n * l -
                t * m * l -
                a * n * g +
                t * o * g) *
              w),
            (e[11] =
              (c * o * r -
                a * u * r -
                c * n * l +
                t * u * l +
                a * n * d -
                t * o * d) *
              w),
            (e[12] = b * w),
            (e[13] =
              (c * m * i -
                p * u * i +
                p * n * h -
                t * m * h -
                c * n * f +
                t * u * f) *
              w),
            (e[14] =
              (p * o * i -
                a * m * i -
                p * n * s +
                t * m * s +
                a * n * f -
                t * o * f) *
              w),
            (e[15] =
              (a * u * i -
                c * o * i +
                c * n * s -
                t * u * s -
                a * n * h +
                t * o * h) *
              w),
            this
          );
        }
        scale(e) {
          const t = this.elements,
            n = e.x,
            i = e.y,
            r = e.z;
          return (
            (t[0] *= n),
            (t[4] *= i),
            (t[8] *= r),
            (t[1] *= n),
            (t[5] *= i),
            (t[9] *= r),
            (t[2] *= n),
            (t[6] *= i),
            (t[10] *= r),
            (t[3] *= n),
            (t[7] *= i),
            (t[11] *= r),
            this
          );
        }
        getMaxScaleOnAxis() {
          const e = this.elements,
            t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
            n = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
            i = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
          return Math.sqrt(Math.max(t, n, i));
        }
        makeTranslation(e, t, n) {
          return this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
        }
        makeRotationX(e) {
          const t = Math.cos(e),
            n = Math.sin(e);
          return (
            this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this
          );
        }
        makeRotationY(e) {
          const t = Math.cos(e),
            n = Math.sin(e);
          return (
            this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this
          );
        }
        makeRotationZ(e) {
          const t = Math.cos(e),
            n = Math.sin(e);
          return (
            this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this
          );
        }
        makeRotationAxis(e, t) {
          const n = Math.cos(t),
            i = Math.sin(t),
            r = 1 - n,
            a = e.x,
            o = e.y,
            s = e.z,
            l = r * a,
            c = r * o;
          return (
            this.set(
              l * a + n,
              l * o - i * s,
              l * s + i * o,
              0,
              l * o + i * s,
              c * o + n,
              c * s - i * a,
              0,
              l * s - i * o,
              c * s + i * a,
              r * s * s + n,
              0,
              0,
              0,
              0,
              1
            ),
            this
          );
        }
        makeScale(e, t, n) {
          return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
        }
        makeShear(e, t, n, i, r, a) {
          return this.set(1, n, r, 0, e, 1, a, 0, t, i, 1, 0, 0, 0, 0, 1), this;
        }
        compose(e, t, n) {
          const i = this.elements,
            r = t._x,
            a = t._y,
            o = t._z,
            s = t._w,
            l = r + r,
            c = a + a,
            u = o + o,
            h = r * l,
            d = r * c,
            p = r * u,
            m = a * c,
            f = a * u,
            g = o * u,
            v = s * l,
            y = s * c,
            x = s * u,
            b = n.x,
            _ = n.y,
            w = n.z;
          return (
            (i[0] = (1 - (m + g)) * b),
            (i[1] = (d + x) * b),
            (i[2] = (p - y) * b),
            (i[3] = 0),
            (i[4] = (d - x) * _),
            (i[5] = (1 - (h + g)) * _),
            (i[6] = (f + v) * _),
            (i[7] = 0),
            (i[8] = (p + y) * w),
            (i[9] = (f - v) * w),
            (i[10] = (1 - (h + m)) * w),
            (i[11] = 0),
            (i[12] = e.x),
            (i[13] = e.y),
            (i[14] = e.z),
            (i[15] = 1),
            this
          );
        }
        decompose(e, t, n) {
          const i = this.elements;
          let r = vi.set(i[0], i[1], i[2]).length();
          const a = vi.set(i[4], i[5], i[6]).length(),
            o = vi.set(i[8], i[9], i[10]).length();
          this.determinant() < 0 && (r = -r),
            (e.x = i[12]),
            (e.y = i[13]),
            (e.z = i[14]),
            yi.copy(this);
          const s = 1 / r,
            l = 1 / a,
            c = 1 / o;
          return (
            (yi.elements[0] *= s),
            (yi.elements[1] *= s),
            (yi.elements[2] *= s),
            (yi.elements[4] *= l),
            (yi.elements[5] *= l),
            (yi.elements[6] *= l),
            (yi.elements[8] *= c),
            (yi.elements[9] *= c),
            (yi.elements[10] *= c),
            t.setFromRotationMatrix(yi),
            (n.x = r),
            (n.y = a),
            (n.z = o),
            this
          );
        }
        makePerspective(e, t, n, i, r, a) {
          void 0 === a &&
            console.warn(
              "THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs."
            );
          const o = this.elements,
            s = (2 * r) / (t - e),
            l = (2 * r) / (n - i),
            c = (t + e) / (t - e),
            u = (n + i) / (n - i),
            h = -(a + r) / (a - r),
            d = (-2 * a * r) / (a - r);
          return (
            (o[0] = s),
            (o[4] = 0),
            (o[8] = c),
            (o[12] = 0),
            (o[1] = 0),
            (o[5] = l),
            (o[9] = u),
            (o[13] = 0),
            (o[2] = 0),
            (o[6] = 0),
            (o[10] = h),
            (o[14] = d),
            (o[3] = 0),
            (o[7] = 0),
            (o[11] = -1),
            (o[15] = 0),
            this
          );
        }
        makeOrthographic(e, t, n, i, r, a) {
          const o = this.elements,
            s = 1 / (t - e),
            l = 1 / (n - i),
            c = 1 / (a - r),
            u = (t + e) * s,
            h = (n + i) * l,
            d = (a + r) * c;
          return (
            (o[0] = 2 * s),
            (o[4] = 0),
            (o[8] = 0),
            (o[12] = -u),
            (o[1] = 0),
            (o[5] = 2 * l),
            (o[9] = 0),
            (o[13] = -h),
            (o[2] = 0),
            (o[6] = 0),
            (o[10] = -2 * c),
            (o[14] = -d),
            (o[3] = 0),
            (o[7] = 0),
            (o[11] = 0),
            (o[15] = 1),
            this
          );
        }
        equals(e) {
          const t = this.elements,
            n = e.elements;
          for (let e = 0; e < 16; e++) if (t[e] !== n[e]) return !1;
          return !0;
        }
        fromArray(e, t = 0) {
          for (let n = 0; n < 16; n++) this.elements[n] = e[n + t];
          return this;
        }
        toArray(e = [], t = 0) {
          const n = this.elements;
          return (
            (e[t] = n[0]),
            (e[t + 1] = n[1]),
            (e[t + 2] = n[2]),
            (e[t + 3] = n[3]),
            (e[t + 4] = n[4]),
            (e[t + 5] = n[5]),
            (e[t + 6] = n[6]),
            (e[t + 7] = n[7]),
            (e[t + 8] = n[8]),
            (e[t + 9] = n[9]),
            (e[t + 10] = n[10]),
            (e[t + 11] = n[11]),
            (e[t + 12] = n[12]),
            (e[t + 13] = n[13]),
            (e[t + 14] = n[14]),
            (e[t + 15] = n[15]),
            e
          );
        }
      }
      gi.prototype.isMatrix4 = !0;
      const vi = new zn(),
        yi = new gi(),
        xi = new zn(0, 0, 0),
        bi = new zn(1, 1, 1),
        _i = new zn(),
        wi = new zn(),
        Mi = new zn(),
        Si = new gi(),
        Ti = new Hn();
      class Ei {
        constructor(e = 0, t = 0, n = 0, i = Ei.DefaultOrder) {
          (this._x = e), (this._y = t), (this._z = n), (this._order = i);
        }
        get x() {
          return this._x;
        }
        set x(e) {
          (this._x = e), this._onChangeCallback();
        }
        get y() {
          return this._y;
        }
        set y(e) {
          (this._y = e), this._onChangeCallback();
        }
        get z() {
          return this._z;
        }
        set z(e) {
          (this._z = e), this._onChangeCallback();
        }
        get order() {
          return this._order;
        }
        set order(e) {
          (this._order = e), this._onChangeCallback();
        }
        set(e, t, n, i = this._order) {
          return (
            (this._x = e),
            (this._y = t),
            (this._z = n),
            (this._order = i),
            this._onChangeCallback(),
            this
          );
        }
        clone() {
          return new this.constructor(this._x, this._y, this._z, this._order);
        }
        copy(e) {
          return (
            (this._x = e._x),
            (this._y = e._y),
            (this._z = e._z),
            (this._order = e._order),
            this._onChangeCallback(),
            this
          );
        }
        setFromRotationMatrix(e, t = this._order, n = !0) {
          const i = e.elements,
            r = i[0],
            a = i[4],
            o = i[8],
            s = i[1],
            l = i[5],
            c = i[9],
            u = i[2],
            h = i[6],
            d = i[10];
          switch (t) {
            case "XYZ":
              (this._y = Math.asin(_n(o, -1, 1))),
                Math.abs(o) < 0.9999999
                  ? ((this._x = Math.atan2(-c, d)),
                    (this._z = Math.atan2(-a, r)))
                  : ((this._x = Math.atan2(h, l)), (this._z = 0));
              break;
            case "YXZ":
              (this._x = Math.asin(-_n(c, -1, 1))),
                Math.abs(c) < 0.9999999
                  ? ((this._y = Math.atan2(o, d)), (this._z = Math.atan2(s, l)))
                  : ((this._y = Math.atan2(-u, r)), (this._z = 0));
              break;
            case "ZXY":
              (this._x = Math.asin(_n(h, -1, 1))),
                Math.abs(h) < 0.9999999
                  ? ((this._y = Math.atan2(-u, d)),
                    (this._z = Math.atan2(-a, l)))
                  : ((this._y = 0), (this._z = Math.atan2(s, r)));
              break;
            case "ZYX":
              (this._y = Math.asin(-_n(u, -1, 1))),
                Math.abs(u) < 0.9999999
                  ? ((this._x = Math.atan2(h, d)), (this._z = Math.atan2(s, r)))
                  : ((this._x = 0), (this._z = Math.atan2(-a, l)));
              break;
            case "YZX":
              (this._z = Math.asin(_n(s, -1, 1))),
                Math.abs(s) < 0.9999999
                  ? ((this._x = Math.atan2(-c, l)),
                    (this._y = Math.atan2(-u, r)))
                  : ((this._x = 0), (this._y = Math.atan2(o, d)));
              break;
            case "XZY":
              (this._z = Math.asin(-_n(a, -1, 1))),
                Math.abs(a) < 0.9999999
                  ? ((this._x = Math.atan2(h, l)), (this._y = Math.atan2(o, r)))
                  : ((this._x = Math.atan2(-c, d)), (this._y = 0));
              break;
            default:
              console.warn(
                "THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " +
                  t
              );
          }
          return (this._order = t), !0 === n && this._onChangeCallback(), this;
        }
        setFromQuaternion(e, t, n) {
          return (
            Si.makeRotationFromQuaternion(e),
            this.setFromRotationMatrix(Si, t, n)
          );
        }
        setFromVector3(e, t = this._order) {
          return this.set(e.x, e.y, e.z, t);
        }
        reorder(e) {
          return Ti.setFromEuler(this), this.setFromQuaternion(Ti, e);
        }
        equals(e) {
          return (
            e._x === this._x &&
            e._y === this._y &&
            e._z === this._z &&
            e._order === this._order
          );
        }
        fromArray(e) {
          return (
            (this._x = e[0]),
            (this._y = e[1]),
            (this._z = e[2]),
            void 0 !== e[3] && (this._order = e[3]),
            this._onChangeCallback(),
            this
          );
        }
        toArray(e = [], t = 0) {
          return (
            (e[t] = this._x),
            (e[t + 1] = this._y),
            (e[t + 2] = this._z),
            (e[t + 3] = this._order),
            e
          );
        }
        toVector3(e) {
          return e
            ? e.set(this._x, this._y, this._z)
            : new zn(this._x, this._y, this._z);
        }
        _onChange(e) {
          return (this._onChangeCallback = e), this;
        }
        _onChangeCallback() {}
      }
      (Ei.prototype.isEuler = !0),
        (Ei.DefaultOrder = "XYZ"),
        (Ei.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"]);
      class Ai {
        constructor() {
          this.mask = 1;
        }
        set(e) {
          this.mask = (1 << e) | 0;
        }
        enable(e) {
          this.mask |= (1 << e) | 0;
        }
        enableAll() {
          this.mask = -1;
        }
        toggle(e) {
          this.mask ^= (1 << e) | 0;
        }
        disable(e) {
          this.mask &= ~((1 << e) | 0);
        }
        disableAll() {
          this.mask = 0;
        }
        test(e) {
          return 0 != (this.mask & e.mask);
        }
      }
      let Li = 0;
      const Pi = new zn(),
        Ri = new Hn(),
        Ci = new gi(),
        Ii = new zn(),
        Ni = new zn(),
        Di = new zn(),
        Oi = new Hn(),
        Fi = new zn(1, 0, 0),
        ki = new zn(0, 1, 0),
        Hi = new zn(0, 0, 1),
        zi = { type: "added" },
        Ui = { type: "removed" };
      class Bi extends fn {
        constructor() {
          super(),
            Object.defineProperty(this, "id", { value: Li++ }),
            (this.uuid = bn()),
            (this.name = ""),
            (this.type = "Object3D"),
            (this.parent = null),
            (this.children = []),
            (this.up = Bi.DefaultUp.clone());
          const e = new zn(),
            t = new Ei(),
            n = new Hn(),
            i = new zn(1, 1, 1);
          t._onChange(function () {
            n.setFromEuler(t, !1);
          }),
            n._onChange(function () {
              t.setFromQuaternion(n, void 0, !1);
            }),
            Object.defineProperties(this, {
              position: { configurable: !0, enumerable: !0, value: e },
              rotation: { configurable: !0, enumerable: !0, value: t },
              quaternion: { configurable: !0, enumerable: !0, value: n },
              scale: { configurable: !0, enumerable: !0, value: i },
              modelViewMatrix: { value: new gi() },
              normalMatrix: { value: new Pn() },
            }),
            (this.matrix = new gi()),
            (this.matrixWorld = new gi()),
            (this.matrixAutoUpdate = Bi.DefaultMatrixAutoUpdate),
            (this.matrixWorldNeedsUpdate = !1),
            (this.layers = new Ai()),
            (this.visible = !0),
            (this.castShadow = !1),
            (this.receiveShadow = !1),
            (this.frustumCulled = !0),
            (this.renderOrder = 0),
            (this.animations = []),
            (this.userData = {});
        }
        onBeforeRender() {}
        onAfterRender() {}
        applyMatrix4(e) {
          this.matrixAutoUpdate && this.updateMatrix(),
            this.matrix.premultiply(e),
            this.matrix.decompose(this.position, this.quaternion, this.scale);
        }
        applyQuaternion(e) {
          return this.quaternion.premultiply(e), this;
        }
        setRotationFromAxisAngle(e, t) {
          this.quaternion.setFromAxisAngle(e, t);
        }
        setRotationFromEuler(e) {
          this.quaternion.setFromEuler(e, !0);
        }
        setRotationFromMatrix(e) {
          this.quaternion.setFromRotationMatrix(e);
        }
        setRotationFromQuaternion(e) {
          this.quaternion.copy(e);
        }
        rotateOnAxis(e, t) {
          return Ri.setFromAxisAngle(e, t), this.quaternion.multiply(Ri), this;
        }
        rotateOnWorldAxis(e, t) {
          return (
            Ri.setFromAxisAngle(e, t), this.quaternion.premultiply(Ri), this
          );
        }
        rotateX(e) {
          return this.rotateOnAxis(Fi, e);
        }
        rotateY(e) {
          return this.rotateOnAxis(ki, e);
        }
        rotateZ(e) {
          return this.rotateOnAxis(Hi, e);
        }
        translateOnAxis(e, t) {
          return (
            Pi.copy(e).applyQuaternion(this.quaternion),
            this.position.add(Pi.multiplyScalar(t)),
            this
          );
        }
        translateX(e) {
          return this.translateOnAxis(Fi, e);
        }
        translateY(e) {
          return this.translateOnAxis(ki, e);
        }
        translateZ(e) {
          return this.translateOnAxis(Hi, e);
        }
        localToWorld(e) {
          return e.applyMatrix4(this.matrixWorld);
        }
        worldToLocal(e) {
          return e.applyMatrix4(Ci.copy(this.matrixWorld).invert());
        }
        lookAt(e, t, n) {
          e.isVector3 ? Ii.copy(e) : Ii.set(e, t, n);
          const i = this.parent;
          this.updateWorldMatrix(!0, !1),
            Ni.setFromMatrixPosition(this.matrixWorld),
            this.isCamera || this.isLight
              ? Ci.lookAt(Ni, Ii, this.up)
              : Ci.lookAt(Ii, Ni, this.up),
            this.quaternion.setFromRotationMatrix(Ci),
            i &&
              (Ci.extractRotation(i.matrixWorld),
              Ri.setFromRotationMatrix(Ci),
              this.quaternion.premultiply(Ri.invert()));
        }
        add(e) {
          if (arguments.length > 1) {
            for (let e = 0; e < arguments.length; e++) this.add(arguments[e]);
            return this;
          }
          return e === this
            ? (console.error(
                "THREE.Object3D.add: object can't be added as a child of itself.",
                e
              ),
              this)
            : (e && e.isObject3D
                ? (null !== e.parent && e.parent.remove(e),
                  (e.parent = this),
                  this.children.push(e),
                  e.dispatchEvent(zi))
                : console.error(
                    "THREE.Object3D.add: object not an instance of THREE.Object3D.",
                    e
                  ),
              this);
        }
        remove(e) {
          if (arguments.length > 1) {
            for (let e = 0; e < arguments.length; e++)
              this.remove(arguments[e]);
            return this;
          }
          const t = this.children.indexOf(e);
          return (
            -1 !== t &&
              ((e.parent = null),
              this.children.splice(t, 1),
              e.dispatchEvent(Ui)),
            this
          );
        }
        removeFromParent() {
          const e = this.parent;
          return null !== e && e.remove(this), this;
        }
        clear() {
          for (let e = 0; e < this.children.length; e++) {
            const t = this.children[e];
            (t.parent = null), t.dispatchEvent(Ui);
          }
          return (this.children.length = 0), this;
        }
        attach(e) {
          return (
            this.updateWorldMatrix(!0, !1),
            Ci.copy(this.matrixWorld).invert(),
            null !== e.parent &&
              (e.parent.updateWorldMatrix(!0, !1),
              Ci.multiply(e.parent.matrixWorld)),
            e.applyMatrix4(Ci),
            this.add(e),
            e.updateWorldMatrix(!1, !0),
            this
          );
        }
        getObjectById(e) {
          return this.getObjectByProperty("id", e);
        }
        getObjectByName(e) {
          return this.getObjectByProperty("name", e);
        }
        getObjectByProperty(e, t) {
          if (this[e] === t) return this;
          for (let n = 0, i = this.children.length; n < i; n++) {
            const i = this.children[n].getObjectByProperty(e, t);
            if (void 0 !== i) return i;
          }
        }
        getWorldPosition(e) {
          return (
            this.updateWorldMatrix(!0, !1),
            e.setFromMatrixPosition(this.matrixWorld)
          );
        }
        getWorldQuaternion(e) {
          return (
            this.updateWorldMatrix(!0, !1),
            this.matrixWorld.decompose(Ni, e, Di),
            e
          );
        }
        getWorldScale(e) {
          return (
            this.updateWorldMatrix(!0, !1),
            this.matrixWorld.decompose(Ni, Oi, e),
            e
          );
        }
        getWorldDirection(e) {
          this.updateWorldMatrix(!0, !1);
          const t = this.matrixWorld.elements;
          return e.set(t[8], t[9], t[10]).normalize();
        }
        raycast() {}
        traverse(e) {
          e(this);
          const t = this.children;
          for (let n = 0, i = t.length; n < i; n++) t[n].traverse(e);
        }
        traverseVisible(e) {
          if (!1 === this.visible) return;
          e(this);
          const t = this.children;
          for (let n = 0, i = t.length; n < i; n++) t[n].traverseVisible(e);
        }
        traverseAncestors(e) {
          const t = this.parent;
          null !== t && (e(t), t.traverseAncestors(e));
        }
        updateMatrix() {
          this.matrix.compose(this.position, this.quaternion, this.scale),
            (this.matrixWorldNeedsUpdate = !0);
        }
        updateMatrixWorld(e) {
          this.matrixAutoUpdate && this.updateMatrix(),
            (this.matrixWorldNeedsUpdate || e) &&
              (null === this.parent
                ? this.matrixWorld.copy(this.matrix)
                : this.matrixWorld.multiplyMatrices(
                    this.parent.matrixWorld,
                    this.matrix
                  ),
              (this.matrixWorldNeedsUpdate = !1),
              (e = !0));
          const t = this.children;
          for (let n = 0, i = t.length; n < i; n++) t[n].updateMatrixWorld(e);
        }
        updateWorldMatrix(e, t) {
          const n = this.parent;
          if (
            (!0 === e && null !== n && n.updateWorldMatrix(!0, !1),
            this.matrixAutoUpdate && this.updateMatrix(),
            null === this.parent
              ? this.matrixWorld.copy(this.matrix)
              : this.matrixWorld.multiplyMatrices(
                  this.parent.matrixWorld,
                  this.matrix
                ),
            !0 === t)
          ) {
            const e = this.children;
            for (let t = 0, n = e.length; t < n; t++)
              e[t].updateWorldMatrix(!1, !0);
          }
        }
        toJSON(e) {
          const t = void 0 === e || "string" == typeof e,
            n = {};
          t &&
            ((e = {
              geometries: {},
              materials: {},
              textures: {},
              images: {},
              shapes: {},
              skeletons: {},
              animations: {},
            }),
            (n.metadata = {
              version: 4.5,
              type: "Object",
              generator: "Object3D.toJSON",
            }));
          const i = {};
          function r(t, n) {
            return void 0 === t[n.uuid] && (t[n.uuid] = n.toJSON(e)), n.uuid;
          }
          if (
            ((i.uuid = this.uuid),
            (i.type = this.type),
            "" !== this.name && (i.name = this.name),
            !0 === this.castShadow && (i.castShadow = !0),
            !0 === this.receiveShadow && (i.receiveShadow = !0),
            !1 === this.visible && (i.visible = !1),
            !1 === this.frustumCulled && (i.frustumCulled = !1),
            0 !== this.renderOrder && (i.renderOrder = this.renderOrder),
            "{}" !== JSON.stringify(this.userData) &&
              (i.userData = this.userData),
            (i.layers = this.layers.mask),
            (i.matrix = this.matrix.toArray()),
            !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1),
            this.isInstancedMesh &&
              ((i.type = "InstancedMesh"),
              (i.count = this.count),
              (i.instanceMatrix = this.instanceMatrix.toJSON()),
              null !== this.instanceColor &&
                (i.instanceColor = this.instanceColor.toJSON())),
            this.isScene)
          )
            this.background &&
              (this.background.isColor
                ? (i.background = this.background.toJSON())
                : this.background.isTexture &&
                  (i.background = this.background.toJSON(e).uuid)),
              this.environment &&
                this.environment.isTexture &&
                (i.environment = this.environment.toJSON(e).uuid);
          else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = r(e.geometries, this.geometry);
            const t = this.geometry.parameters;
            if (void 0 !== t && void 0 !== t.shapes) {
              const n = t.shapes;
              if (Array.isArray(n))
                for (let t = 0, i = n.length; t < i; t++) {
                  const i = n[t];
                  r(e.shapes, i);
                }
              else r(e.shapes, n);
            }
          }
          if (
            (this.isSkinnedMesh &&
              ((i.bindMode = this.bindMode),
              (i.bindMatrix = this.bindMatrix.toArray()),
              void 0 !== this.skeleton &&
                (r(e.skeletons, this.skeleton),
                (i.skeleton = this.skeleton.uuid))),
            void 0 !== this.material)
          )
            if (Array.isArray(this.material)) {
              const t = [];
              for (let n = 0, i = this.material.length; n < i; n++)
                t.push(r(e.materials, this.material[n]));
              i.material = t;
            } else i.material = r(e.materials, this.material);
          if (this.children.length > 0) {
            i.children = [];
            for (let t = 0; t < this.children.length; t++)
              i.children.push(this.children[t].toJSON(e).object);
          }
          if (this.animations.length > 0) {
            i.animations = [];
            for (let t = 0; t < this.animations.length; t++) {
              const n = this.animations[t];
              i.animations.push(r(e.animations, n));
            }
          }
          if (t) {
            const t = a(e.geometries),
              i = a(e.materials),
              r = a(e.textures),
              o = a(e.images),
              s = a(e.shapes),
              l = a(e.skeletons),
              c = a(e.animations);
            t.length > 0 && (n.geometries = t),
              i.length > 0 && (n.materials = i),
              r.length > 0 && (n.textures = r),
              o.length > 0 && (n.images = o),
              s.length > 0 && (n.shapes = s),
              l.length > 0 && (n.skeletons = l),
              c.length > 0 && (n.animations = c);
          }
          return (n.object = i), n;
          function a(e) {
            const t = [];
            for (const n in e) {
              const i = e[n];
              delete i.metadata, t.push(i);
            }
            return t;
          }
        }
        clone(e) {
          return new this.constructor().copy(this, e);
        }
        copy(e, t = !0) {
          if (
            ((this.name = e.name),
            this.up.copy(e.up),
            this.position.copy(e.position),
            (this.rotation.order = e.rotation.order),
            this.quaternion.copy(e.quaternion),
            this.scale.copy(e.scale),
            this.matrix.copy(e.matrix),
            this.matrixWorld.copy(e.matrixWorld),
            (this.matrixAutoUpdate = e.matrixAutoUpdate),
            (this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate),
            (this.layers.mask = e.layers.mask),
            (this.visible = e.visible),
            (this.castShadow = e.castShadow),
            (this.receiveShadow = e.receiveShadow),
            (this.frustumCulled = e.frustumCulled),
            (this.renderOrder = e.renderOrder),
            (this.userData = JSON.parse(JSON.stringify(e.userData))),
            !0 === t)
          )
            for (let t = 0; t < e.children.length; t++) {
              const n = e.children[t];
              this.add(n.clone());
            }
          return this;
        }
      }
      (Bi.DefaultUp = new zn(0, 1, 0)),
        (Bi.DefaultMatrixAutoUpdate = !0),
        (Bi.prototype.isObject3D = !0);
      const Gi = new zn(),
        Vi = new zn(),
        Wi = new zn(),
        ji = new zn(),
        Xi = new zn(),
        qi = new zn(),
        Yi = new zn(),
        Ki = new zn(),
        Zi = new zn(),
        Ji = new zn();
      class Qi {
        constructor(e = new zn(), t = new zn(), n = new zn()) {
          (this.a = e), (this.b = t), (this.c = n);
        }
        static getNormal(e, t, n, i) {
          i.subVectors(n, t), Gi.subVectors(e, t), i.cross(Gi);
          const r = i.lengthSq();
          return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
        }
        static getBarycoord(e, t, n, i, r) {
          Gi.subVectors(i, t), Vi.subVectors(n, t), Wi.subVectors(e, t);
          const a = Gi.dot(Gi),
            o = Gi.dot(Vi),
            s = Gi.dot(Wi),
            l = Vi.dot(Vi),
            c = Vi.dot(Wi),
            u = a * l - o * o;
          if (0 === u) return r.set(-2, -1, -1);
          const h = 1 / u,
            d = (l * s - o * c) * h,
            p = (a * c - o * s) * h;
          return r.set(1 - d - p, p, d);
        }
        static containsPoint(e, t, n, i) {
          return (
            this.getBarycoord(e, t, n, i, ji),
            ji.x >= 0 && ji.y >= 0 && ji.x + ji.y <= 1
          );
        }
        static getUV(e, t, n, i, r, a, o, s) {
          return (
            this.getBarycoord(e, t, n, i, ji),
            s.set(0, 0),
            s.addScaledVector(r, ji.x),
            s.addScaledVector(a, ji.y),
            s.addScaledVector(o, ji.z),
            s
          );
        }
        static isFrontFacing(e, t, n, i) {
          return (
            Gi.subVectors(n, t), Vi.subVectors(e, t), Gi.cross(Vi).dot(i) < 0
          );
        }
        set(e, t, n) {
          return this.a.copy(e), this.b.copy(t), this.c.copy(n), this;
        }
        setFromPointsAndIndices(e, t, n, i) {
          return this.a.copy(e[t]), this.b.copy(e[n]), this.c.copy(e[i]), this;
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
        }
        getArea() {
          return (
            Gi.subVectors(this.c, this.b),
            Vi.subVectors(this.a, this.b),
            0.5 * Gi.cross(Vi).length()
          );
        }
        getMidpoint(e) {
          return e
            .addVectors(this.a, this.b)
            .add(this.c)
            .multiplyScalar(1 / 3);
        }
        getNormal(e) {
          return Qi.getNormal(this.a, this.b, this.c, e);
        }
        getPlane(e) {
          return e.setFromCoplanarPoints(this.a, this.b, this.c);
        }
        getBarycoord(e, t) {
          return Qi.getBarycoord(e, this.a, this.b, this.c, t);
        }
        getUV(e, t, n, i, r) {
          return Qi.getUV(e, this.a, this.b, this.c, t, n, i, r);
        }
        containsPoint(e) {
          return Qi.containsPoint(e, this.a, this.b, this.c);
        }
        isFrontFacing(e) {
          return Qi.isFrontFacing(this.a, this.b, this.c, e);
        }
        intersectsBox(e) {
          return e.intersectsTriangle(this);
        }
        closestPointToPoint(e, t) {
          const n = this.a,
            i = this.b,
            r = this.c;
          let a, o;
          Xi.subVectors(i, n), qi.subVectors(r, n), Ki.subVectors(e, n);
          const s = Xi.dot(Ki),
            l = qi.dot(Ki);
          if (s <= 0 && l <= 0) return t.copy(n);
          Zi.subVectors(e, i);
          const c = Xi.dot(Zi),
            u = qi.dot(Zi);
          if (c >= 0 && u <= c) return t.copy(i);
          const h = s * u - c * l;
          if (h <= 0 && s >= 0 && c <= 0)
            return (a = s / (s - c)), t.copy(n).addScaledVector(Xi, a);
          Ji.subVectors(e, r);
          const d = Xi.dot(Ji),
            p = qi.dot(Ji);
          if (p >= 0 && d <= p) return t.copy(r);
          const m = d * l - s * p;
          if (m <= 0 && l >= 0 && p <= 0)
            return (o = l / (l - p)), t.copy(n).addScaledVector(qi, o);
          const f = c * p - d * u;
          if (f <= 0 && u - c >= 0 && d - p >= 0)
            return (
              Yi.subVectors(r, i),
              (o = (u - c) / (u - c + (d - p))),
              t.copy(i).addScaledVector(Yi, o)
            );
          const g = 1 / (f + m + h);
          return (
            (a = m * g),
            (o = h * g),
            t.copy(n).addScaledVector(Xi, a).addScaledVector(qi, o)
          );
        }
        equals(e) {
          return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
        }
      }
      let $i = 0;
      class er extends fn {
        constructor() {
          super(),
            Object.defineProperty(this, "id", { value: $i++ }),
            (this.uuid = bn()),
            (this.name = ""),
            (this.type = "Material"),
            (this.fog = !0),
            (this.blending = D),
            (this.side = R),
            (this.vertexColors = !1),
            (this.opacity = 1),
            (this.format = qe),
            (this.transparent = !1),
            (this.blendSrc = Y),
            (this.blendDst = K),
            (this.blendEquation = z),
            (this.blendSrcAlpha = null),
            (this.blendDstAlpha = null),
            (this.blendEquationAlpha = null),
            (this.depthFunc = re),
            (this.depthTest = !0),
            (this.depthWrite = !0),
            (this.stencilWriteMask = 255),
            (this.stencilFunc = 519),
            (this.stencilRef = 0),
            (this.stencilFuncMask = 255),
            (this.stencilFail = hn),
            (this.stencilZFail = hn),
            (this.stencilZPass = hn),
            (this.stencilWrite = !1),
            (this.clippingPlanes = null),
            (this.clipIntersection = !1),
            (this.clipShadows = !1),
            (this.shadowSide = null),
            (this.colorWrite = !0),
            (this.precision = null),
            (this.polygonOffset = !1),
            (this.polygonOffsetFactor = 0),
            (this.polygonOffsetUnits = 0),
            (this.dithering = !1),
            (this.alphaToCoverage = !1),
            (this.premultipliedAlpha = !1),
            (this.visible = !0),
            (this.toneMapped = !0),
            (this.userData = {}),
            (this.version = 0),
            (this._alphaTest = 0);
        }
        get alphaTest() {
          return this._alphaTest;
        }
        set alphaTest(e) {
          this._alphaTest > 0 != e > 0 && this.version++, (this._alphaTest = e);
        }
        onBuild() {}
        onBeforeCompile() {}
        customProgramCacheKey() {
          return this.onBeforeCompile.toString();
        }
        setValues(e) {
          if (void 0 !== e)
            for (const t in e) {
              const n = e[t];
              if (void 0 === n) {
                console.warn(
                  "THREE.Material: '" + t + "' parameter is undefined."
                );
                continue;
              }
              if ("shading" === t) {
                console.warn(
                  "THREE." +
                    this.type +
                    ": .shading has been removed. Use the boolean .flatShading instead."
                ),
                  (this.flatShading = 1 === n);
                continue;
              }
              const i = this[t];
              void 0 !== i
                ? i && i.isColor
                  ? i.set(n)
                  : i && i.isVector3 && n && n.isVector3
                  ? i.copy(n)
                  : (this[t] = n)
                : console.warn(
                    "THREE." +
                      this.type +
                      ": '" +
                      t +
                      "' is not a property of this material."
                  );
            }
        }
        toJSON(e) {
          const t = void 0 === e || "string" == typeof e;
          t && (e = { textures: {}, images: {} });
          const n = {
            metadata: {
              version: 4.5,
              type: "Material",
              generator: "Material.toJSON",
            },
          };
          function i(e) {
            const t = [];
            for (const n in e) {
              const i = e[n];
              delete i.metadata, t.push(i);
            }
            return t;
          }
          if (
            ((n.uuid = this.uuid),
            (n.type = this.type),
            "" !== this.name && (n.name = this.name),
            this.color && this.color.isColor && (n.color = this.color.getHex()),
            void 0 !== this.roughness && (n.roughness = this.roughness),
            void 0 !== this.metalness && (n.metalness = this.metalness),
            this.sheenTint &&
              this.sheenTint.isColor &&
              (n.sheenTint = this.sheenTint.getHex()),
            this.emissive &&
              this.emissive.isColor &&
              (n.emissive = this.emissive.getHex()),
            this.emissiveIntensity &&
              1 !== this.emissiveIntensity &&
              (n.emissiveIntensity = this.emissiveIntensity),
            this.specular &&
              this.specular.isColor &&
              (n.specular = this.specular.getHex()),
            void 0 !== this.specularIntensity &&
              (n.specularIntensity = this.specularIntensity),
            this.specularTint &&
              this.specularTint.isColor &&
              (n.specularTint = this.specularTint.getHex()),
            void 0 !== this.shininess && (n.shininess = this.shininess),
            void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat),
            void 0 !== this.clearcoatRoughness &&
              (n.clearcoatRoughness = this.clearcoatRoughness),
            this.clearcoatMap &&
              this.clearcoatMap.isTexture &&
              (n.clearcoatMap = this.clearcoatMap.toJSON(e).uuid),
            this.clearcoatRoughnessMap &&
              this.clearcoatRoughnessMap.isTexture &&
              (n.clearcoatRoughnessMap =
                this.clearcoatRoughnessMap.toJSON(e).uuid),
            this.clearcoatNormalMap &&
              this.clearcoatNormalMap.isTexture &&
              ((n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid),
              (n.clearcoatNormalScale = this.clearcoatNormalScale.toArray())),
            this.map && this.map.isTexture && (n.map = this.map.toJSON(e).uuid),
            this.matcap &&
              this.matcap.isTexture &&
              (n.matcap = this.matcap.toJSON(e).uuid),
            this.alphaMap &&
              this.alphaMap.isTexture &&
              (n.alphaMap = this.alphaMap.toJSON(e).uuid),
            this.lightMap &&
              this.lightMap.isTexture &&
              ((n.lightMap = this.lightMap.toJSON(e).uuid),
              (n.lightMapIntensity = this.lightMapIntensity)),
            this.aoMap &&
              this.aoMap.isTexture &&
              ((n.aoMap = this.aoMap.toJSON(e).uuid),
              (n.aoMapIntensity = this.aoMapIntensity)),
            this.bumpMap &&
              this.bumpMap.isTexture &&
              ((n.bumpMap = this.bumpMap.toJSON(e).uuid),
              (n.bumpScale = this.bumpScale)),
            this.normalMap &&
              this.normalMap.isTexture &&
              ((n.normalMap = this.normalMap.toJSON(e).uuid),
              (n.normalMapType = this.normalMapType),
              (n.normalScale = this.normalScale.toArray())),
            this.displacementMap &&
              this.displacementMap.isTexture &&
              ((n.displacementMap = this.displacementMap.toJSON(e).uuid),
              (n.displacementScale = this.displacementScale),
              (n.displacementBias = this.displacementBias)),
            this.roughnessMap &&
              this.roughnessMap.isTexture &&
              (n.roughnessMap = this.roughnessMap.toJSON(e).uuid),
            this.metalnessMap &&
              this.metalnessMap.isTexture &&
              (n.metalnessMap = this.metalnessMap.toJSON(e).uuid),
            this.emissiveMap &&
              this.emissiveMap.isTexture &&
              (n.emissiveMap = this.emissiveMap.toJSON(e).uuid),
            this.specularMap &&
              this.specularMap.isTexture &&
              (n.specularMap = this.specularMap.toJSON(e).uuid),
            this.specularIntensityMap &&
              this.specularIntensityMap.isTexture &&
              (n.specularIntensityMap =
                this.specularIntensityMap.toJSON(e).uuid),
            this.specularTintMap &&
              this.specularTintMap.isTexture &&
              (n.specularTintMap = this.specularTintMap.toJSON(e).uuid),
            this.envMap &&
              this.envMap.isTexture &&
              ((n.envMap = this.envMap.toJSON(e).uuid),
              void 0 !== this.combine && (n.combine = this.combine)),
            void 0 !== this.envMapIntensity &&
              (n.envMapIntensity = this.envMapIntensity),
            void 0 !== this.reflectivity &&
              (n.reflectivity = this.reflectivity),
            void 0 !== this.refractionRatio &&
              (n.refractionRatio = this.refractionRatio),
            this.gradientMap &&
              this.gradientMap.isTexture &&
              (n.gradientMap = this.gradientMap.toJSON(e).uuid),
            void 0 !== this.transmission &&
              (n.transmission = this.transmission),
            this.transmissionMap &&
              this.transmissionMap.isTexture &&
              (n.transmissionMap = this.transmissionMap.toJSON(e).uuid),
            void 0 !== this.thickness && (n.thickness = this.thickness),
            this.thicknessMap &&
              this.thicknessMap.isTexture &&
              (n.thicknessMap = this.thicknessMap.toJSON(e).uuid),
            void 0 !== this.attenuationDistance &&
              (n.attenuationDistance = this.attenuationDistance),
            void 0 !== this.attenuationTint &&
              (n.attenuationTint = this.attenuationTint.getHex()),
            void 0 !== this.size && (n.size = this.size),
            null !== this.shadowSide && (n.shadowSide = this.shadowSide),
            void 0 !== this.sizeAttenuation &&
              (n.sizeAttenuation = this.sizeAttenuation),
            this.blending !== D && (n.blending = this.blending),
            this.side !== R && (n.side = this.side),
            this.vertexColors && (n.vertexColors = !0),
            this.opacity < 1 && (n.opacity = this.opacity),
            this.format !== qe && (n.format = this.format),
            !0 === this.transparent && (n.transparent = this.transparent),
            (n.depthFunc = this.depthFunc),
            (n.depthTest = this.depthTest),
            (n.depthWrite = this.depthWrite),
            (n.colorWrite = this.colorWrite),
            (n.stencilWrite = this.stencilWrite),
            (n.stencilWriteMask = this.stencilWriteMask),
            (n.stencilFunc = this.stencilFunc),
            (n.stencilRef = this.stencilRef),
            (n.stencilFuncMask = this.stencilFuncMask),
            (n.stencilFail = this.stencilFail),
            (n.stencilZFail = this.stencilZFail),
            (n.stencilZPass = this.stencilZPass),
            this.rotation &&
              0 !== this.rotation &&
              (n.rotation = this.rotation),
            !0 === this.polygonOffset && (n.polygonOffset = !0),
            0 !== this.polygonOffsetFactor &&
              (n.polygonOffsetFactor = this.polygonOffsetFactor),
            0 !== this.polygonOffsetUnits &&
              (n.polygonOffsetUnits = this.polygonOffsetUnits),
            this.linewidth &&
              1 !== this.linewidth &&
              (n.linewidth = this.linewidth),
            void 0 !== this.dashSize && (n.dashSize = this.dashSize),
            void 0 !== this.gapSize && (n.gapSize = this.gapSize),
            void 0 !== this.scale && (n.scale = this.scale),
            !0 === this.dithering && (n.dithering = !0),
            this.alphaTest > 0 && (n.alphaTest = this.alphaTest),
            !0 === this.alphaToCoverage &&
              (n.alphaToCoverage = this.alphaToCoverage),
            !0 === this.premultipliedAlpha &&
              (n.premultipliedAlpha = this.premultipliedAlpha),
            !0 === this.wireframe && (n.wireframe = this.wireframe),
            this.wireframeLinewidth > 1 &&
              (n.wireframeLinewidth = this.wireframeLinewidth),
            "round" !== this.wireframeLinecap &&
              (n.wireframeLinecap = this.wireframeLinecap),
            "round" !== this.wireframeLinejoin &&
              (n.wireframeLinejoin = this.wireframeLinejoin),
            !0 === this.flatShading && (n.flatShading = this.flatShading),
            !1 === this.visible && (n.visible = !1),
            !1 === this.toneMapped && (n.toneMapped = !1),
            "{}" !== JSON.stringify(this.userData) &&
              (n.userData = this.userData),
            t)
          ) {
            const t = i(e.textures),
              r = i(e.images);
            t.length > 0 && (n.textures = t), r.length > 0 && (n.images = r);
          }
          return n;
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          (this.name = e.name),
            (this.fog = e.fog),
            (this.blending = e.blending),
            (this.side = e.side),
            (this.vertexColors = e.vertexColors),
            (this.opacity = e.opacity),
            (this.format = e.format),
            (this.transparent = e.transparent),
            (this.blendSrc = e.blendSrc),
            (this.blendDst = e.blendDst),
            (this.blendEquation = e.blendEquation),
            (this.blendSrcAlpha = e.blendSrcAlpha),
            (this.blendDstAlpha = e.blendDstAlpha),
            (this.blendEquationAlpha = e.blendEquationAlpha),
            (this.depthFunc = e.depthFunc),
            (this.depthTest = e.depthTest),
            (this.depthWrite = e.depthWrite),
            (this.stencilWriteMask = e.stencilWriteMask),
            (this.stencilFunc = e.stencilFunc),
            (this.stencilRef = e.stencilRef),
            (this.stencilFuncMask = e.stencilFuncMask),
            (this.stencilFail = e.stencilFail),
            (this.stencilZFail = e.stencilZFail),
            (this.stencilZPass = e.stencilZPass),
            (this.stencilWrite = e.stencilWrite);
          const t = e.clippingPlanes;
          let n = null;
          if (null !== t) {
            const e = t.length;
            n = new Array(e);
            for (let i = 0; i !== e; ++i) n[i] = t[i].clone();
          }
          return (
            (this.clippingPlanes = n),
            (this.clipIntersection = e.clipIntersection),
            (this.clipShadows = e.clipShadows),
            (this.shadowSide = e.shadowSide),
            (this.colorWrite = e.colorWrite),
            (this.precision = e.precision),
            (this.polygonOffset = e.polygonOffset),
            (this.polygonOffsetFactor = e.polygonOffsetFactor),
            (this.polygonOffsetUnits = e.polygonOffsetUnits),
            (this.dithering = e.dithering),
            (this.alphaTest = e.alphaTest),
            (this.alphaToCoverage = e.alphaToCoverage),
            (this.premultipliedAlpha = e.premultipliedAlpha),
            (this.visible = e.visible),
            (this.toneMapped = e.toneMapped),
            (this.userData = JSON.parse(JSON.stringify(e.userData))),
            this
          );
        }
        dispose() {
          this.dispatchEvent({ type: "dispose" });
        }
        set needsUpdate(e) {
          !0 === e && this.version++;
        }
      }
      er.prototype.isMaterial = !0;
      const tr = {
          aliceblue: 15792383,
          antiquewhite: 16444375,
          aqua: 65535,
          aquamarine: 8388564,
          azure: 15794175,
          beige: 16119260,
          bisque: 16770244,
          black: 0,
          blanchedalmond: 16772045,
          blue: 255,
          blueviolet: 9055202,
          brown: 10824234,
          burlywood: 14596231,
          cadetblue: 6266528,
          chartreuse: 8388352,
          chocolate: 13789470,
          coral: 16744272,
          cornflowerblue: 6591981,
          cornsilk: 16775388,
          crimson: 14423100,
          cyan: 65535,
          darkblue: 139,
          darkcyan: 35723,
          darkgoldenrod: 12092939,
          darkgray: 11119017,
          darkgreen: 25600,
          darkgrey: 11119017,
          darkkhaki: 12433259,
          darkmagenta: 9109643,
          darkolivegreen: 5597999,
          darkorange: 16747520,
          darkorchid: 10040012,
          darkred: 9109504,
          darksalmon: 15308410,
          darkseagreen: 9419919,
          darkslateblue: 4734347,
          darkslategray: 3100495,
          darkslategrey: 3100495,
          darkturquoise: 52945,
          darkviolet: 9699539,
          deeppink: 16716947,
          deepskyblue: 49151,
          dimgray: 6908265,
          dimgrey: 6908265,
          dodgerblue: 2003199,
          firebrick: 11674146,
          floralwhite: 16775920,
          forestgreen: 2263842,
          fuchsia: 16711935,
          gainsboro: 14474460,
          ghostwhite: 16316671,
          gold: 16766720,
          goldenrod: 14329120,
          gray: 8421504,
          green: 32768,
          greenyellow: 11403055,
          grey: 8421504,
          honeydew: 15794160,
          hotpink: 16738740,
          indianred: 13458524,
          indigo: 4915330,
          ivory: 16777200,
          khaki: 15787660,
          lavender: 15132410,
          lavenderblush: 16773365,
          lawngreen: 8190976,
          lemonchiffon: 16775885,
          lightblue: 11393254,
          lightcoral: 15761536,
          lightcyan: 14745599,
          lightgoldenrodyellow: 16448210,
          lightgray: 13882323,
          lightgreen: 9498256,
          lightgrey: 13882323,
          lightpink: 16758465,
          lightsalmon: 16752762,
          lightseagreen: 2142890,
          lightskyblue: 8900346,
          lightslategray: 7833753,
          lightslategrey: 7833753,
          lightsteelblue: 11584734,
          lightyellow: 16777184,
          lime: 65280,
          limegreen: 3329330,
          linen: 16445670,
          magenta: 16711935,
          maroon: 8388608,
          mediumaquamarine: 6737322,
          mediumblue: 205,
          mediumorchid: 12211667,
          mediumpurple: 9662683,
          mediumseagreen: 3978097,
          mediumslateblue: 8087790,
          mediumspringgreen: 64154,
          mediumturquoise: 4772300,
          mediumvioletred: 13047173,
          midnightblue: 1644912,
          mintcream: 16121850,
          mistyrose: 16770273,
          moccasin: 16770229,
          navajowhite: 16768685,
          navy: 128,
          oldlace: 16643558,
          olive: 8421376,
          olivedrab: 7048739,
          orange: 16753920,
          orangered: 16729344,
          orchid: 14315734,
          palegoldenrod: 15657130,
          palegreen: 10025880,
          paleturquoise: 11529966,
          palevioletred: 14381203,
          papayawhip: 16773077,
          peachpuff: 16767673,
          peru: 13468991,
          pink: 16761035,
          plum: 14524637,
          powderblue: 11591910,
          purple: 8388736,
          rebeccapurple: 6697881,
          red: 16711680,
          rosybrown: 12357519,
          royalblue: 4286945,
          saddlebrown: 9127187,
          salmon: 16416882,
          sandybrown: 16032864,
          seagreen: 3050327,
          seashell: 16774638,
          sienna: 10506797,
          silver: 12632256,
          skyblue: 8900331,
          slateblue: 6970061,
          slategray: 7372944,
          slategrey: 7372944,
          snow: 16775930,
          springgreen: 65407,
          steelblue: 4620980,
          tan: 13808780,
          teal: 32896,
          thistle: 14204888,
          tomato: 16737095,
          turquoise: 4251856,
          violet: 15631086,
          wheat: 16113331,
          white: 16777215,
          whitesmoke: 16119285,
          yellow: 16776960,
          yellowgreen: 10145074,
        },
        nr = { h: 0, s: 0, l: 0 },
        ir = { h: 0, s: 0, l: 0 };
      function rr(e, t, n) {
        return (
          n < 0 && (n += 1),
          n > 1 && (n -= 1),
          n < 1 / 6
            ? e + 6 * (t - e) * n
            : n < 0.5
            ? t
            : n < 2 / 3
            ? e + 6 * (t - e) * (2 / 3 - n)
            : e
        );
      }
      function ar(e) {
        return e < 0.04045
          ? 0.0773993808 * e
          : Math.pow(0.9478672986 * e + 0.0521327014, 2.4);
      }
      function or(e) {
        return e < 0.0031308 ? 12.92 * e : 1.055 * Math.pow(e, 0.41666) - 0.055;
      }
      class sr {
        constructor(e, t, n) {
          return void 0 === t && void 0 === n
            ? this.set(e)
            : this.setRGB(e, t, n);
        }
        set(e) {
          return (
            e && e.isColor
              ? this.copy(e)
              : "number" == typeof e
              ? this.setHex(e)
              : "string" == typeof e && this.setStyle(e),
            this
          );
        }
        setScalar(e) {
          return (this.r = e), (this.g = e), (this.b = e), this;
        }
        setHex(e) {
          return (
            (e = Math.floor(e)),
            (this.r = ((e >> 16) & 255) / 255),
            (this.g = ((e >> 8) & 255) / 255),
            (this.b = (255 & e) / 255),
            this
          );
        }
        setRGB(e, t, n) {
          return (this.r = e), (this.g = t), (this.b = n), this;
        }
        setHSL(e, t, n) {
          if (((e = wn(e, 1)), (t = _n(t, 0, 1)), (n = _n(n, 0, 1)), 0 === t))
            this.r = this.g = this.b = n;
          else {
            const i = n <= 0.5 ? n * (1 + t) : n + t - n * t,
              r = 2 * n - i;
            (this.r = rr(r, i, e + 1 / 3)),
              (this.g = rr(r, i, e)),
              (this.b = rr(r, i, e - 1 / 3));
          }
          return this;
        }
        setStyle(e) {
          function t(t) {
            void 0 !== t &&
              parseFloat(t) < 1 &&
              console.warn(
                "THREE.Color: Alpha component of " + e + " will be ignored."
              );
          }
          let n;
          if ((n = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(e))) {
            let e;
            const i = n[1],
              r = n[2];
            switch (i) {
              case "rgb":
              case "rgba":
                if (
                  (e =
                    /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                      r
                    ))
                )
                  return (
                    (this.r = Math.min(255, parseInt(e[1], 10)) / 255),
                    (this.g = Math.min(255, parseInt(e[2], 10)) / 255),
                    (this.b = Math.min(255, parseInt(e[3], 10)) / 255),
                    t(e[4]),
                    this
                  );
                if (
                  (e =
                    /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                      r
                    ))
                )
                  return (
                    (this.r = Math.min(100, parseInt(e[1], 10)) / 100),
                    (this.g = Math.min(100, parseInt(e[2], 10)) / 100),
                    (this.b = Math.min(100, parseInt(e[3], 10)) / 100),
                    t(e[4]),
                    this
                  );
                break;
              case "hsl":
              case "hsla":
                if (
                  (e =
                    /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                      r
                    ))
                ) {
                  const n = parseFloat(e[1]) / 360,
                    i = parseInt(e[2], 10) / 100,
                    r = parseInt(e[3], 10) / 100;
                  return t(e[4]), this.setHSL(n, i, r);
                }
            }
          } else if ((n = /^\#([A-Fa-f\d]+)$/.exec(e))) {
            const e = n[1],
              t = e.length;
            if (3 === t)
              return (
                (this.r = parseInt(e.charAt(0) + e.charAt(0), 16) / 255),
                (this.g = parseInt(e.charAt(1) + e.charAt(1), 16) / 255),
                (this.b = parseInt(e.charAt(2) + e.charAt(2), 16) / 255),
                this
              );
            if (6 === t)
              return (
                (this.r = parseInt(e.charAt(0) + e.charAt(1), 16) / 255),
                (this.g = parseInt(e.charAt(2) + e.charAt(3), 16) / 255),
                (this.b = parseInt(e.charAt(4) + e.charAt(5), 16) / 255),
                this
              );
          }
          return e && e.length > 0 ? this.setColorName(e) : this;
        }
        setColorName(e) {
          const t = tr[e.toLowerCase()];
          return (
            void 0 !== t
              ? this.setHex(t)
              : console.warn("THREE.Color: Unknown color " + e),
            this
          );
        }
        clone() {
          return new this.constructor(this.r, this.g, this.b);
        }
        copy(e) {
          return (this.r = e.r), (this.g = e.g), (this.b = e.b), this;
        }
        copyGammaToLinear(e, t = 2) {
          return (
            (this.r = Math.pow(e.r, t)),
            (this.g = Math.pow(e.g, t)),
            (this.b = Math.pow(e.b, t)),
            this
          );
        }
        copyLinearToGamma(e, t = 2) {
          const n = t > 0 ? 1 / t : 1;
          return (
            (this.r = Math.pow(e.r, n)),
            (this.g = Math.pow(e.g, n)),
            (this.b = Math.pow(e.b, n)),
            this
          );
        }
        convertGammaToLinear(e) {
          return this.copyGammaToLinear(this, e), this;
        }
        convertLinearToGamma(e) {
          return this.copyLinearToGamma(this, e), this;
        }
        copySRGBToLinear(e) {
          return (
            (this.r = ar(e.r)), (this.g = ar(e.g)), (this.b = ar(e.b)), this
          );
        }
        copyLinearToSRGB(e) {
          return (
            (this.r = or(e.r)), (this.g = or(e.g)), (this.b = or(e.b)), this
          );
        }
        convertSRGBToLinear() {
          return this.copySRGBToLinear(this), this;
        }
        convertLinearToSRGB() {
          return this.copyLinearToSRGB(this), this;
        }
        getHex() {
          return (
            ((255 * this.r) << 16) ^
            ((255 * this.g) << 8) ^
            ((255 * this.b) << 0)
          );
        }
        getHexString() {
          return ("000000" + this.getHex().toString(16)).slice(-6);
        }
        getHSL(e) {
          const t = this.r,
            n = this.g,
            i = this.b,
            r = Math.max(t, n, i),
            a = Math.min(t, n, i);
          let o, s;
          const l = (a + r) / 2;
          if (a === r) (o = 0), (s = 0);
          else {
            const e = r - a;
            switch (((s = l <= 0.5 ? e / (r + a) : e / (2 - r - a)), r)) {
              case t:
                o = (n - i) / e + (n < i ? 6 : 0);
                break;
              case n:
                o = (i - t) / e + 2;
                break;
              case i:
                o = (t - n) / e + 4;
            }
            o /= 6;
          }
          return (e.h = o), (e.s = s), (e.l = l), e;
        }
        getStyle() {
          return (
            "rgb(" +
            ((255 * this.r) | 0) +
            "," +
            ((255 * this.g) | 0) +
            "," +
            ((255 * this.b) | 0) +
            ")"
          );
        }
        offsetHSL(e, t, n) {
          return (
            this.getHSL(nr),
            (nr.h += e),
            (nr.s += t),
            (nr.l += n),
            this.setHSL(nr.h, nr.s, nr.l),
            this
          );
        }
        add(e) {
          return (this.r += e.r), (this.g += e.g), (this.b += e.b), this;
        }
        addColors(e, t) {
          return (
            (this.r = e.r + t.r),
            (this.g = e.g + t.g),
            (this.b = e.b + t.b),
            this
          );
        }
        addScalar(e) {
          return (this.r += e), (this.g += e), (this.b += e), this;
        }
        sub(e) {
          return (
            (this.r = Math.max(0, this.r - e.r)),
            (this.g = Math.max(0, this.g - e.g)),
            (this.b = Math.max(0, this.b - e.b)),
            this
          );
        }
        multiply(e) {
          return (this.r *= e.r), (this.g *= e.g), (this.b *= e.b), this;
        }
        multiplyScalar(e) {
          return (this.r *= e), (this.g *= e), (this.b *= e), this;
        }
        lerp(e, t) {
          return (
            (this.r += (e.r - this.r) * t),
            (this.g += (e.g - this.g) * t),
            (this.b += (e.b - this.b) * t),
            this
          );
        }
        lerpColors(e, t, n) {
          return (
            (this.r = e.r + (t.r - e.r) * n),
            (this.g = e.g + (t.g - e.g) * n),
            (this.b = e.b + (t.b - e.b) * n),
            this
          );
        }
        lerpHSL(e, t) {
          this.getHSL(nr), e.getHSL(ir);
          const n = Mn(nr.h, ir.h, t),
            i = Mn(nr.s, ir.s, t),
            r = Mn(nr.l, ir.l, t);
          return this.setHSL(n, i, r), this;
        }
        equals(e) {
          return e.r === this.r && e.g === this.g && e.b === this.b;
        }
        fromArray(e, t = 0) {
          return (
            (this.r = e[t]), (this.g = e[t + 1]), (this.b = e[t + 2]), this
          );
        }
        toArray(e = [], t = 0) {
          return (e[t] = this.r), (e[t + 1] = this.g), (e[t + 2] = this.b), e;
        }
        fromBufferAttribute(e, t) {
          return (
            (this.r = e.getX(t)),
            (this.g = e.getY(t)),
            (this.b = e.getZ(t)),
            !0 === e.normalized &&
              ((this.r /= 255), (this.g /= 255), (this.b /= 255)),
            this
          );
        }
        toJSON() {
          return this.getHex();
        }
      }
      (sr.NAMES = tr),
        (sr.prototype.isColor = !0),
        (sr.prototype.r = 1),
        (sr.prototype.g = 1),
        (sr.prototype.b = 1);
      class lr extends er {
        constructor(e) {
          super(),
            (this.type = "MeshBasicMaterial"),
            (this.color = new sr(16777215)),
            (this.map = null),
            (this.lightMap = null),
            (this.lightMapIntensity = 1),
            (this.aoMap = null),
            (this.aoMapIntensity = 1),
            (this.specularMap = null),
            (this.alphaMap = null),
            (this.envMap = null),
            (this.combine = ce),
            (this.reflectivity = 1),
            (this.refractionRatio = 0.98),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.wireframeLinecap = "round"),
            (this.wireframeLinejoin = "round"),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.map = e.map),
            (this.lightMap = e.lightMap),
            (this.lightMapIntensity = e.lightMapIntensity),
            (this.aoMap = e.aoMap),
            (this.aoMapIntensity = e.aoMapIntensity),
            (this.specularMap = e.specularMap),
            (this.alphaMap = e.alphaMap),
            (this.envMap = e.envMap),
            (this.combine = e.combine),
            (this.reflectivity = e.reflectivity),
            (this.refractionRatio = e.refractionRatio),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.wireframeLinecap = e.wireframeLinecap),
            (this.wireframeLinejoin = e.wireframeLinejoin),
            this
          );
        }
      }
      lr.prototype.isMeshBasicMaterial = !0;
      const cr = new zn(),
        ur = new Ln();
      class hr {
        constructor(e, t, n) {
          if (Array.isArray(e))
            throw new TypeError(
              "THREE.BufferAttribute: array should be a Typed Array."
            );
          (this.name = ""),
            (this.array = e),
            (this.itemSize = t),
            (this.count = void 0 !== e ? e.length / t : 0),
            (this.normalized = !0 === n),
            (this.usage = dn),
            (this.updateRange = { offset: 0, count: -1 }),
            (this.version = 0);
        }
        onUploadCallback() {}
        set needsUpdate(e) {
          !0 === e && this.version++;
        }
        setUsage(e) {
          return (this.usage = e), this;
        }
        copy(e) {
          return (
            (this.name = e.name),
            (this.array = new e.array.constructor(e.array)),
            (this.itemSize = e.itemSize),
            (this.count = e.count),
            (this.normalized = e.normalized),
            (this.usage = e.usage),
            this
          );
        }
        copyAt(e, t, n) {
          (e *= this.itemSize), (n *= t.itemSize);
          for (let i = 0, r = this.itemSize; i < r; i++)
            this.array[e + i] = t.array[n + i];
          return this;
        }
        copyArray(e) {
          return this.array.set(e), this;
        }
        copyColorsArray(e) {
          const t = this.array;
          let n = 0;
          for (let i = 0, r = e.length; i < r; i++) {
            let r = e[i];
            void 0 === r &&
              (console.warn(
                "THREE.BufferAttribute.copyColorsArray(): color is undefined",
                i
              ),
              (r = new sr())),
              (t[n++] = r.r),
              (t[n++] = r.g),
              (t[n++] = r.b);
          }
          return this;
        }
        copyVector2sArray(e) {
          const t = this.array;
          let n = 0;
          for (let i = 0, r = e.length; i < r; i++) {
            let r = e[i];
            void 0 === r &&
              (console.warn(
                "THREE.BufferAttribute.copyVector2sArray(): vector is undefined",
                i
              ),
              (r = new Ln())),
              (t[n++] = r.x),
              (t[n++] = r.y);
          }
          return this;
        }
        copyVector3sArray(e) {
          const t = this.array;
          let n = 0;
          for (let i = 0, r = e.length; i < r; i++) {
            let r = e[i];
            void 0 === r &&
              (console.warn(
                "THREE.BufferAttribute.copyVector3sArray(): vector is undefined",
                i
              ),
              (r = new zn())),
              (t[n++] = r.x),
              (t[n++] = r.y),
              (t[n++] = r.z);
          }
          return this;
        }
        copyVector4sArray(e) {
          const t = this.array;
          let n = 0;
          for (let i = 0, r = e.length; i < r; i++) {
            let r = e[i];
            void 0 === r &&
              (console.warn(
                "THREE.BufferAttribute.copyVector4sArray(): vector is undefined",
                i
              ),
              (r = new On())),
              (t[n++] = r.x),
              (t[n++] = r.y),
              (t[n++] = r.z),
              (t[n++] = r.w);
          }
          return this;
        }
        applyMatrix3(e) {
          if (2 === this.itemSize)
            for (let t = 0, n = this.count; t < n; t++)
              ur.fromBufferAttribute(this, t),
                ur.applyMatrix3(e),
                this.setXY(t, ur.x, ur.y);
          else if (3 === this.itemSize)
            for (let t = 0, n = this.count; t < n; t++)
              cr.fromBufferAttribute(this, t),
                cr.applyMatrix3(e),
                this.setXYZ(t, cr.x, cr.y, cr.z);
          return this;
        }
        applyMatrix4(e) {
          for (let t = 0, n = this.count; t < n; t++)
            (cr.x = this.getX(t)),
              (cr.y = this.getY(t)),
              (cr.z = this.getZ(t)),
              cr.applyMatrix4(e),
              this.setXYZ(t, cr.x, cr.y, cr.z);
          return this;
        }
        applyNormalMatrix(e) {
          for (let t = 0, n = this.count; t < n; t++)
            (cr.x = this.getX(t)),
              (cr.y = this.getY(t)),
              (cr.z = this.getZ(t)),
              cr.applyNormalMatrix(e),
              this.setXYZ(t, cr.x, cr.y, cr.z);
          return this;
        }
        transformDirection(e) {
          for (let t = 0, n = this.count; t < n; t++)
            (cr.x = this.getX(t)),
              (cr.y = this.getY(t)),
              (cr.z = this.getZ(t)),
              cr.transformDirection(e),
              this.setXYZ(t, cr.x, cr.y, cr.z);
          return this;
        }
        set(e, t = 0) {
          return this.array.set(e, t), this;
        }
        getX(e) {
          return this.array[e * this.itemSize];
        }
        setX(e, t) {
          return (this.array[e * this.itemSize] = t), this;
        }
        getY(e) {
          return this.array[e * this.itemSize + 1];
        }
        setY(e, t) {
          return (this.array[e * this.itemSize + 1] = t), this;
        }
        getZ(e) {
          return this.array[e * this.itemSize + 2];
        }
        setZ(e, t) {
          return (this.array[e * this.itemSize + 2] = t), this;
        }
        getW(e) {
          return this.array[e * this.itemSize + 3];
        }
        setW(e, t) {
          return (this.array[e * this.itemSize + 3] = t), this;
        }
        setXY(e, t, n) {
          return (
            (e *= this.itemSize),
            (this.array[e + 0] = t),
            (this.array[e + 1] = n),
            this
          );
        }
        setXYZ(e, t, n, i) {
          return (
            (e *= this.itemSize),
            (this.array[e + 0] = t),
            (this.array[e + 1] = n),
            (this.array[e + 2] = i),
            this
          );
        }
        setXYZW(e, t, n, i, r) {
          return (
            (e *= this.itemSize),
            (this.array[e + 0] = t),
            (this.array[e + 1] = n),
            (this.array[e + 2] = i),
            (this.array[e + 3] = r),
            this
          );
        }
        onUpload(e) {
          return (this.onUploadCallback = e), this;
        }
        clone() {
          return new this.constructor(this.array, this.itemSize).copy(this);
        }
        toJSON() {
          const e = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized,
          };
          return (
            "" !== this.name && (e.name = this.name),
            this.usage !== dn && (e.usage = this.usage),
            (0 === this.updateRange.offset && -1 === this.updateRange.count) ||
              (e.updateRange = this.updateRange),
            e
          );
        }
      }
      hr.prototype.isBufferAttribute = !0;
      class dr extends hr {
        constructor(e, t, n) {
          super(new Uint16Array(e), t, n);
        }
      }
      class pr extends hr {
        constructor(e, t, n) {
          super(new Uint32Array(e), t, n);
        }
      }
      (class extends hr {
        constructor(e, t, n) {
          super(new Uint16Array(e), t, n);
        }
      }).prototype.isFloat16BufferAttribute = !0;
      class mr extends hr {
        constructor(e, t, n) {
          super(new Float32Array(e), t, n);
        }
      }
      function fr(e) {
        if (0 === e.length) return -1 / 0;
        let t = e[0];
        for (let n = 1, i = e.length; n < i; ++n) e[n] > t && (t = e[n]);
        return t;
      }
      Int8Array,
        Uint8Array,
        Uint8ClampedArray,
        Int16Array,
        Uint16Array,
        Int32Array,
        Uint32Array,
        Float32Array,
        Float64Array;
      let gr = 0;
      const vr = new gi(),
        yr = new Bi(),
        xr = new zn(),
        br = new Gn(),
        _r = new Gn(),
        wr = new zn();
      class Mr extends fn {
        constructor() {
          super(),
            Object.defineProperty(this, "id", { value: gr++ }),
            (this.uuid = bn()),
            (this.name = ""),
            (this.type = "BufferGeometry"),
            (this.index = null),
            (this.attributes = {}),
            (this.morphAttributes = {}),
            (this.morphTargetsRelative = !1),
            (this.groups = []),
            (this.boundingBox = null),
            (this.boundingSphere = null),
            (this.drawRange = { start: 0, count: 1 / 0 }),
            (this.userData = {});
        }
        getIndex() {
          return this.index;
        }
        setIndex(e) {
          return (
            Array.isArray(e)
              ? (this.index = new (fr(e) > 65535 ? pr : dr)(e, 1))
              : (this.index = e),
            this
          );
        }
        getAttribute(e) {
          return this.attributes[e];
        }
        setAttribute(e, t) {
          return (this.attributes[e] = t), this;
        }
        deleteAttribute(e) {
          return delete this.attributes[e], this;
        }
        hasAttribute(e) {
          return void 0 !== this.attributes[e];
        }
        addGroup(e, t, n = 0) {
          this.groups.push({ start: e, count: t, materialIndex: n });
        }
        clearGroups() {
          this.groups = [];
        }
        setDrawRange(e, t) {
          (this.drawRange.start = e), (this.drawRange.count = t);
        }
        applyMatrix4(e) {
          const t = this.attributes.position;
          void 0 !== t && (t.applyMatrix4(e), (t.needsUpdate = !0));
          const n = this.attributes.normal;
          if (void 0 !== n) {
            const t = new Pn().getNormalMatrix(e);
            n.applyNormalMatrix(t), (n.needsUpdate = !0);
          }
          const i = this.attributes.tangent;
          return (
            void 0 !== i && (i.transformDirection(e), (i.needsUpdate = !0)),
            null !== this.boundingBox && this.computeBoundingBox(),
            null !== this.boundingSphere && this.computeBoundingSphere(),
            this
          );
        }
        applyQuaternion(e) {
          return vr.makeRotationFromQuaternion(e), this.applyMatrix4(vr), this;
        }
        rotateX(e) {
          return vr.makeRotationX(e), this.applyMatrix4(vr), this;
        }
        rotateY(e) {
          return vr.makeRotationY(e), this.applyMatrix4(vr), this;
        }
        rotateZ(e) {
          return vr.makeRotationZ(e), this.applyMatrix4(vr), this;
        }
        translate(e, t, n) {
          return vr.makeTranslation(e, t, n), this.applyMatrix4(vr), this;
        }
        scale(e, t, n) {
          return vr.makeScale(e, t, n), this.applyMatrix4(vr), this;
        }
        lookAt(e) {
          return (
            yr.lookAt(e), yr.updateMatrix(), this.applyMatrix4(yr.matrix), this
          );
        }
        center() {
          return (
            this.computeBoundingBox(),
            this.boundingBox.getCenter(xr).negate(),
            this.translate(xr.x, xr.y, xr.z),
            this
          );
        }
        setFromPoints(e) {
          const t = [];
          for (let n = 0, i = e.length; n < i; n++) {
            const i = e[n];
            t.push(i.x, i.y, i.z || 0);
          }
          return this.setAttribute("position", new mr(t, 3)), this;
        }
        computeBoundingBox() {
          null === this.boundingBox && (this.boundingBox = new Gn());
          const e = this.attributes.position,
            t = this.morphAttributes.position;
          if (e && e.isGLBufferAttribute)
            return (
              console.error(
                'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".',
                this
              ),
              void this.boundingBox.set(
                new zn(-1 / 0, -1 / 0, -1 / 0),
                new zn(1 / 0, 1 / 0, 1 / 0)
              )
            );
          if (void 0 !== e) {
            if ((this.boundingBox.setFromBufferAttribute(e), t))
              for (let e = 0, n = t.length; e < n; e++) {
                const n = t[e];
                br.setFromBufferAttribute(n),
                  this.morphTargetsRelative
                    ? (wr.addVectors(this.boundingBox.min, br.min),
                      this.boundingBox.expandByPoint(wr),
                      wr.addVectors(this.boundingBox.max, br.max),
                      this.boundingBox.expandByPoint(wr))
                    : (this.boundingBox.expandByPoint(br.min),
                      this.boundingBox.expandByPoint(br.max));
              }
          } else this.boundingBox.makeEmpty();
          (isNaN(this.boundingBox.min.x) ||
            isNaN(this.boundingBox.min.y) ||
            isNaN(this.boundingBox.min.z)) &&
            console.error(
              'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',
              this
            );
        }
        computeBoundingSphere() {
          null === this.boundingSphere && (this.boundingSphere = new si());
          const e = this.attributes.position,
            t = this.morphAttributes.position;
          if (e && e.isGLBufferAttribute)
            return (
              console.error(
                'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".',
                this
              ),
              void this.boundingSphere.set(new zn(), 1 / 0)
            );
          if (e) {
            const n = this.boundingSphere.center;
            if ((br.setFromBufferAttribute(e), t))
              for (let e = 0, n = t.length; e < n; e++) {
                const n = t[e];
                _r.setFromBufferAttribute(n),
                  this.morphTargetsRelative
                    ? (wr.addVectors(br.min, _r.min),
                      br.expandByPoint(wr),
                      wr.addVectors(br.max, _r.max),
                      br.expandByPoint(wr))
                    : (br.expandByPoint(_r.min), br.expandByPoint(_r.max));
              }
            br.getCenter(n);
            let i = 0;
            for (let t = 0, r = e.count; t < r; t++)
              wr.fromBufferAttribute(e, t),
                (i = Math.max(i, n.distanceToSquared(wr)));
            if (t)
              for (let r = 0, a = t.length; r < a; r++) {
                const a = t[r],
                  o = this.morphTargetsRelative;
                for (let t = 0, r = a.count; t < r; t++)
                  wr.fromBufferAttribute(a, t),
                    o && (xr.fromBufferAttribute(e, t), wr.add(xr)),
                    (i = Math.max(i, n.distanceToSquared(wr)));
              }
            (this.boundingSphere.radius = Math.sqrt(i)),
              isNaN(this.boundingSphere.radius) &&
                console.error(
                  'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
                  this
                );
          }
        }
        computeTangents() {
          const e = this.index,
            t = this.attributes;
          if (
            null === e ||
            void 0 === t.position ||
            void 0 === t.normal ||
            void 0 === t.uv
          )
            return void console.error(
              "THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)"
            );
          const n = e.array,
            i = t.position.array,
            r = t.normal.array,
            a = t.uv.array,
            o = i.length / 3;
          void 0 === t.tangent &&
            this.setAttribute("tangent", new hr(new Float32Array(4 * o), 4));
          const s = t.tangent.array,
            l = [],
            c = [];
          for (let e = 0; e < o; e++) (l[e] = new zn()), (c[e] = new zn());
          const u = new zn(),
            h = new zn(),
            d = new zn(),
            p = new Ln(),
            m = new Ln(),
            f = new Ln(),
            g = new zn(),
            v = new zn();
          function y(e, t, n) {
            u.fromArray(i, 3 * e),
              h.fromArray(i, 3 * t),
              d.fromArray(i, 3 * n),
              p.fromArray(a, 2 * e),
              m.fromArray(a, 2 * t),
              f.fromArray(a, 2 * n),
              h.sub(u),
              d.sub(u),
              m.sub(p),
              f.sub(p);
            const r = 1 / (m.x * f.y - f.x * m.y);
            isFinite(r) &&
              (g
                .copy(h)
                .multiplyScalar(f.y)
                .addScaledVector(d, -m.y)
                .multiplyScalar(r),
              v
                .copy(d)
                .multiplyScalar(m.x)
                .addScaledVector(h, -f.x)
                .multiplyScalar(r),
              l[e].add(g),
              l[t].add(g),
              l[n].add(g),
              c[e].add(v),
              c[t].add(v),
              c[n].add(v));
          }
          let x = this.groups;
          0 === x.length && (x = [{ start: 0, count: n.length }]);
          for (let e = 0, t = x.length; e < t; ++e) {
            const t = x[e],
              i = t.start;
            for (let e = i, r = i + t.count; e < r; e += 3)
              y(n[e + 0], n[e + 1], n[e + 2]);
          }
          const b = new zn(),
            _ = new zn(),
            w = new zn(),
            M = new zn();
          function S(e) {
            w.fromArray(r, 3 * e), M.copy(w);
            const t = l[e];
            b.copy(t),
              b.sub(w.multiplyScalar(w.dot(t))).normalize(),
              _.crossVectors(M, t);
            const n = _.dot(c[e]) < 0 ? -1 : 1;
            (s[4 * e] = b.x),
              (s[4 * e + 1] = b.y),
              (s[4 * e + 2] = b.z),
              (s[4 * e + 3] = n);
          }
          for (let e = 0, t = x.length; e < t; ++e) {
            const t = x[e],
              i = t.start;
            for (let e = i, r = i + t.count; e < r; e += 3)
              S(n[e + 0]), S(n[e + 1]), S(n[e + 2]);
          }
        }
        computeVertexNormals() {
          const e = this.index,
            t = this.getAttribute("position");
          if (void 0 !== t) {
            let n = this.getAttribute("normal");
            if (void 0 === n)
              (n = new hr(new Float32Array(3 * t.count), 3)),
                this.setAttribute("normal", n);
            else for (let e = 0, t = n.count; e < t; e++) n.setXYZ(e, 0, 0, 0);
            const i = new zn(),
              r = new zn(),
              a = new zn(),
              o = new zn(),
              s = new zn(),
              l = new zn(),
              c = new zn(),
              u = new zn();
            if (e)
              for (let h = 0, d = e.count; h < d; h += 3) {
                const d = e.getX(h + 0),
                  p = e.getX(h + 1),
                  m = e.getX(h + 2);
                i.fromBufferAttribute(t, d),
                  r.fromBufferAttribute(t, p),
                  a.fromBufferAttribute(t, m),
                  c.subVectors(a, r),
                  u.subVectors(i, r),
                  c.cross(u),
                  o.fromBufferAttribute(n, d),
                  s.fromBufferAttribute(n, p),
                  l.fromBufferAttribute(n, m),
                  o.add(c),
                  s.add(c),
                  l.add(c),
                  n.setXYZ(d, o.x, o.y, o.z),
                  n.setXYZ(p, s.x, s.y, s.z),
                  n.setXYZ(m, l.x, l.y, l.z);
              }
            else
              for (let e = 0, o = t.count; e < o; e += 3)
                i.fromBufferAttribute(t, e + 0),
                  r.fromBufferAttribute(t, e + 1),
                  a.fromBufferAttribute(t, e + 2),
                  c.subVectors(a, r),
                  u.subVectors(i, r),
                  c.cross(u),
                  n.setXYZ(e + 0, c.x, c.y, c.z),
                  n.setXYZ(e + 1, c.x, c.y, c.z),
                  n.setXYZ(e + 2, c.x, c.y, c.z);
            this.normalizeNormals(), (n.needsUpdate = !0);
          }
        }
        merge(e, t) {
          if (!e || !e.isBufferGeometry)
            return void console.error(
              "THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.",
              e
            );
          void 0 === t &&
            ((t = 0),
            console.warn(
              "THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."
            ));
          const n = this.attributes;
          for (const i in n) {
            if (void 0 === e.attributes[i]) continue;
            const r = n[i].array,
              a = e.attributes[i],
              o = a.array,
              s = a.itemSize * t,
              l = Math.min(o.length, r.length - s);
            for (let e = 0, t = s; e < l; e++, t++) r[t] = o[e];
          }
          return this;
        }
        normalizeNormals() {
          const e = this.attributes.normal;
          for (let t = 0, n = e.count; t < n; t++)
            wr.fromBufferAttribute(e, t),
              wr.normalize(),
              e.setXYZ(t, wr.x, wr.y, wr.z);
        }
        toNonIndexed() {
          function e(e, t) {
            const n = e.array,
              i = e.itemSize,
              r = e.normalized,
              a = new n.constructor(t.length * i);
            let o = 0,
              s = 0;
            for (let r = 0, l = t.length; r < l; r++) {
              o = e.isInterleavedBufferAttribute
                ? t[r] * e.data.stride + e.offset
                : t[r] * i;
              for (let e = 0; e < i; e++) a[s++] = n[o++];
            }
            return new hr(a, i, r);
          }
          if (null === this.index)
            return (
              console.warn(
                "THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."
              ),
              this
            );
          const t = new Mr(),
            n = this.index.array,
            i = this.attributes;
          for (const r in i) {
            const a = e(i[r], n);
            t.setAttribute(r, a);
          }
          const r = this.morphAttributes;
          for (const i in r) {
            const a = [],
              o = r[i];
            for (let t = 0, i = o.length; t < i; t++) {
              const i = e(o[t], n);
              a.push(i);
            }
            t.morphAttributes[i] = a;
          }
          t.morphTargetsRelative = this.morphTargetsRelative;
          const a = this.groups;
          for (let e = 0, n = a.length; e < n; e++) {
            const n = a[e];
            t.addGroup(n.start, n.count, n.materialIndex);
          }
          return t;
        }
        toJSON() {
          const e = {
            metadata: {
              version: 4.5,
              type: "BufferGeometry",
              generator: "BufferGeometry.toJSON",
            },
          };
          if (
            ((e.uuid = this.uuid),
            (e.type = this.type),
            "" !== this.name && (e.name = this.name),
            Object.keys(this.userData).length > 0 &&
              (e.userData = this.userData),
            void 0 !== this.parameters)
          ) {
            const t = this.parameters;
            for (const n in t) void 0 !== t[n] && (e[n] = t[n]);
            return e;
          }
          e.data = { attributes: {} };
          const t = this.index;
          null !== t &&
            (e.data.index = {
              type: t.array.constructor.name,
              array: Array.prototype.slice.call(t.array),
            });
          const n = this.attributes;
          for (const t in n) {
            const i = n[t];
            e.data.attributes[t] = i.toJSON(e.data);
          }
          const i = {};
          let r = !1;
          for (const t in this.morphAttributes) {
            const n = this.morphAttributes[t],
              a = [];
            for (let t = 0, i = n.length; t < i; t++) {
              const i = n[t];
              a.push(i.toJSON(e.data));
            }
            a.length > 0 && ((i[t] = a), (r = !0));
          }
          r &&
            ((e.data.morphAttributes = i),
            (e.data.morphTargetsRelative = this.morphTargetsRelative));
          const a = this.groups;
          a.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(a)));
          const o = this.boundingSphere;
          return (
            null !== o &&
              (e.data.boundingSphere = {
                center: o.center.toArray(),
                radius: o.radius,
              }),
            e
          );
        }
        clone() {
          return new Mr().copy(this);
        }
        copy(e) {
          (this.index = null),
            (this.attributes = {}),
            (this.morphAttributes = {}),
            (this.groups = []),
            (this.boundingBox = null),
            (this.boundingSphere = null);
          const t = {};
          this.name = e.name;
          const n = e.index;
          null !== n && this.setIndex(n.clone(t));
          const i = e.attributes;
          for (const e in i) {
            const n = i[e];
            this.setAttribute(e, n.clone(t));
          }
          const r = e.morphAttributes;
          for (const e in r) {
            const n = [],
              i = r[e];
            for (let e = 0, r = i.length; e < r; e++) n.push(i[e].clone(t));
            this.morphAttributes[e] = n;
          }
          this.morphTargetsRelative = e.morphTargetsRelative;
          const a = e.groups;
          for (let e = 0, t = a.length; e < t; e++) {
            const t = a[e];
            this.addGroup(t.start, t.count, t.materialIndex);
          }
          const o = e.boundingBox;
          null !== o && (this.boundingBox = o.clone());
          const s = e.boundingSphere;
          return (
            null !== s && (this.boundingSphere = s.clone()),
            (this.drawRange.start = e.drawRange.start),
            (this.drawRange.count = e.drawRange.count),
            (this.userData = e.userData),
            this
          );
        }
        dispose() {
          this.dispatchEvent({ type: "dispose" });
        }
      }
      Mr.prototype.isBufferGeometry = !0;
      const Sr = new gi(),
        Tr = new fi(),
        Er = new si(),
        Ar = new zn(),
        Lr = new zn(),
        Pr = new zn(),
        Rr = new zn(),
        Cr = new zn(),
        Ir = new zn(),
        Nr = new zn(),
        Dr = new zn(),
        Or = new zn(),
        Fr = new Ln(),
        kr = new Ln(),
        Hr = new Ln(),
        zr = new zn(),
        Ur = new zn();
      class Br extends Bi {
        constructor(e = new Mr(), t = new lr()) {
          super(),
            (this.type = "Mesh"),
            (this.geometry = e),
            (this.material = t),
            this.updateMorphTargets();
        }
        copy(e) {
          return (
            super.copy(e),
            void 0 !== e.morphTargetInfluences &&
              (this.morphTargetInfluences = e.morphTargetInfluences.slice()),
            void 0 !== e.morphTargetDictionary &&
              (this.morphTargetDictionary = Object.assign(
                {},
                e.morphTargetDictionary
              )),
            (this.material = e.material),
            (this.geometry = e.geometry),
            this
          );
        }
        updateMorphTargets() {
          const e = this.geometry;
          if (e.isBufferGeometry) {
            const t = e.morphAttributes,
              n = Object.keys(t);
            if (n.length > 0) {
              const e = t[n[0]];
              if (void 0 !== e) {
                (this.morphTargetInfluences = []),
                  (this.morphTargetDictionary = {});
                for (let t = 0, n = e.length; t < n; t++) {
                  const n = e[t].name || String(t);
                  this.morphTargetInfluences.push(0),
                    (this.morphTargetDictionary[n] = t);
                }
              }
            }
          } else {
            const t = e.morphTargets;
            void 0 !== t &&
              t.length > 0 &&
              console.error(
                "THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead."
              );
          }
        }
        raycast(e, t) {
          const n = this.geometry,
            i = this.material,
            r = this.matrixWorld;
          if (void 0 === i) return;
          if (
            (null === n.boundingSphere && n.computeBoundingSphere(),
            Er.copy(n.boundingSphere),
            Er.applyMatrix4(r),
            !1 === e.ray.intersectsSphere(Er))
          )
            return;
          if (
            (Sr.copy(r).invert(),
            Tr.copy(e.ray).applyMatrix4(Sr),
            null !== n.boundingBox && !1 === Tr.intersectsBox(n.boundingBox))
          )
            return;
          let a;
          if (n.isBufferGeometry) {
            const r = n.index,
              o = n.attributes.position,
              s = n.morphAttributes.position,
              l = n.morphTargetsRelative,
              c = n.attributes.uv,
              u = n.attributes.uv2,
              h = n.groups,
              d = n.drawRange;
            if (null !== r)
              if (Array.isArray(i))
                for (let n = 0, p = h.length; n < p; n++) {
                  const p = h[n],
                    m = i[p.materialIndex];
                  for (
                    let n = Math.max(p.start, d.start),
                      i = Math.min(p.start + p.count, d.start + d.count);
                    n < i;
                    n += 3
                  ) {
                    const i = r.getX(n),
                      h = r.getX(n + 1),
                      d = r.getX(n + 2);
                    (a = Gr(this, m, e, Tr, o, s, l, c, u, i, h, d)),
                      a &&
                        ((a.faceIndex = Math.floor(n / 3)),
                        (a.face.materialIndex = p.materialIndex),
                        t.push(a));
                  }
                }
              else {
                for (
                  let n = Math.max(0, d.start),
                    h = Math.min(r.count, d.start + d.count);
                  n < h;
                  n += 3
                ) {
                  const h = r.getX(n),
                    d = r.getX(n + 1),
                    p = r.getX(n + 2);
                  (a = Gr(this, i, e, Tr, o, s, l, c, u, h, d, p)),
                    a && ((a.faceIndex = Math.floor(n / 3)), t.push(a));
                }
              }
            else if (void 0 !== o)
              if (Array.isArray(i))
                for (let n = 0, r = h.length; n < r; n++) {
                  const r = h[n],
                    p = i[r.materialIndex];
                  for (
                    let n = Math.max(r.start, d.start),
                      i = Math.min(r.start + r.count, d.start + d.count);
                    n < i;
                    n += 3
                  ) {
                    (a = Gr(this, p, e, Tr, o, s, l, c, u, n, n + 1, n + 2)),
                      a &&
                        ((a.faceIndex = Math.floor(n / 3)),
                        (a.face.materialIndex = r.materialIndex),
                        t.push(a));
                  }
                }
              else {
                for (
                  let n = Math.max(0, d.start),
                    r = Math.min(o.count, d.start + d.count);
                  n < r;
                  n += 3
                ) {
                  (a = Gr(this, i, e, Tr, o, s, l, c, u, n, n + 1, n + 2)),
                    a && ((a.faceIndex = Math.floor(n / 3)), t.push(a));
                }
              }
          } else
            n.isGeometry &&
              console.error(
                "THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead."
              );
        }
      }
      function Gr(e, t, n, i, r, a, o, s, l, c, u, h) {
        Ar.fromBufferAttribute(r, c),
          Lr.fromBufferAttribute(r, u),
          Pr.fromBufferAttribute(r, h);
        const d = e.morphTargetInfluences;
        if (a && d) {
          Nr.set(0, 0, 0), Dr.set(0, 0, 0), Or.set(0, 0, 0);
          for (let e = 0, t = a.length; e < t; e++) {
            const t = d[e],
              n = a[e];
            0 !== t &&
              (Rr.fromBufferAttribute(n, c),
              Cr.fromBufferAttribute(n, u),
              Ir.fromBufferAttribute(n, h),
              o
                ? (Nr.addScaledVector(Rr, t),
                  Dr.addScaledVector(Cr, t),
                  Or.addScaledVector(Ir, t))
                : (Nr.addScaledVector(Rr.sub(Ar), t),
                  Dr.addScaledVector(Cr.sub(Lr), t),
                  Or.addScaledVector(Ir.sub(Pr), t)));
          }
          Ar.add(Nr), Lr.add(Dr), Pr.add(Or);
        }
        e.isSkinnedMesh &&
          (e.boneTransform(c, Ar),
          e.boneTransform(u, Lr),
          e.boneTransform(h, Pr));
        const p = (function (e, t, n, i, r, a, o, s) {
          let l;
          if (
            ((l =
              t.side === C
                ? i.intersectTriangle(o, a, r, !0, s)
                : i.intersectTriangle(r, a, o, t.side !== I, s)),
            null === l)
          )
            return null;
          Ur.copy(s), Ur.applyMatrix4(e.matrixWorld);
          const c = n.ray.origin.distanceTo(Ur);
          return c < n.near || c > n.far
            ? null
            : { distance: c, point: Ur.clone(), object: e };
        })(e, t, n, i, Ar, Lr, Pr, zr);
        if (p) {
          s &&
            (Fr.fromBufferAttribute(s, c),
            kr.fromBufferAttribute(s, u),
            Hr.fromBufferAttribute(s, h),
            (p.uv = Qi.getUV(zr, Ar, Lr, Pr, Fr, kr, Hr, new Ln()))),
            l &&
              (Fr.fromBufferAttribute(l, c),
              kr.fromBufferAttribute(l, u),
              Hr.fromBufferAttribute(l, h),
              (p.uv2 = Qi.getUV(zr, Ar, Lr, Pr, Fr, kr, Hr, new Ln())));
          const e = { a: c, b: u, c: h, normal: new zn(), materialIndex: 0 };
          Qi.getNormal(Ar, Lr, Pr, e.normal), (p.face = e);
        }
        return p;
      }
      Br.prototype.isMesh = !0;
      class Vr extends Mr {
        constructor(e = 1, t = 1, n = 1, i = 1, r = 1, a = 1) {
          super(),
            (this.type = "BoxGeometry"),
            (this.parameters = {
              width: e,
              height: t,
              depth: n,
              widthSegments: i,
              heightSegments: r,
              depthSegments: a,
            });
          const o = this;
          (i = Math.floor(i)), (r = Math.floor(r)), (a = Math.floor(a));
          const s = [],
            l = [],
            c = [],
            u = [];
          let h = 0,
            d = 0;
          function p(e, t, n, i, r, a, p, m, f, g, v) {
            const y = a / f,
              x = p / g,
              b = a / 2,
              _ = p / 2,
              w = m / 2,
              M = f + 1,
              S = g + 1;
            let T = 0,
              E = 0;
            const A = new zn();
            for (let a = 0; a < S; a++) {
              const o = a * x - _;
              for (let s = 0; s < M; s++) {
                const h = s * y - b;
                (A[e] = h * i),
                  (A[t] = o * r),
                  (A[n] = w),
                  l.push(A.x, A.y, A.z),
                  (A[e] = 0),
                  (A[t] = 0),
                  (A[n] = m > 0 ? 1 : -1),
                  c.push(A.x, A.y, A.z),
                  u.push(s / f),
                  u.push(1 - a / g),
                  (T += 1);
              }
            }
            for (let e = 0; e < g; e++)
              for (let t = 0; t < f; t++) {
                const n = h + t + M * e,
                  i = h + t + M * (e + 1),
                  r = h + (t + 1) + M * (e + 1),
                  a = h + (t + 1) + M * e;
                s.push(n, i, a), s.push(i, r, a), (E += 6);
              }
            o.addGroup(d, E, v), (d += E), (h += T);
          }
          p("z", "y", "x", -1, -1, n, t, e, a, r, 0),
            p("z", "y", "x", 1, -1, n, t, -e, a, r, 1),
            p("x", "z", "y", 1, 1, e, n, t, i, a, 2),
            p("x", "z", "y", 1, -1, e, n, -t, i, a, 3),
            p("x", "y", "z", 1, -1, e, t, n, i, r, 4),
            p("x", "y", "z", -1, -1, e, t, -n, i, r, 5),
            this.setIndex(s),
            this.setAttribute("position", new mr(l, 3)),
            this.setAttribute("normal", new mr(c, 3)),
            this.setAttribute("uv", new mr(u, 2));
        }
        static fromJSON(e) {
          return new Vr(
            e.width,
            e.height,
            e.depth,
            e.widthSegments,
            e.heightSegments,
            e.depthSegments
          );
        }
      }
      function Wr(e) {
        const t = {};
        for (const n in e) {
          t[n] = {};
          for (const i in e[n]) {
            const r = e[n][i];
            r &&
            (r.isColor ||
              r.isMatrix3 ||
              r.isMatrix4 ||
              r.isVector2 ||
              r.isVector3 ||
              r.isVector4 ||
              r.isTexture ||
              r.isQuaternion)
              ? (t[n][i] = r.clone())
              : Array.isArray(r)
              ? (t[n][i] = r.slice())
              : (t[n][i] = r);
          }
        }
        return t;
      }
      function jr(e) {
        const t = {};
        for (let n = 0; n < e.length; n++) {
          const i = Wr(e[n]);
          for (const e in i) t[e] = i[e];
        }
        return t;
      }
      const Xr = { clone: Wr, merge: jr };
      class qr extends er {
        constructor(e) {
          super(),
            (this.type = "ShaderMaterial"),
            (this.defines = {}),
            (this.uniforms = {}),
            (this.vertexShader =
              "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}"),
            (this.fragmentShader =
              "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}"),
            (this.linewidth = 1),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.fog = !1),
            (this.lights = !1),
            (this.clipping = !1),
            (this.extensions = {
              derivatives: !1,
              fragDepth: !1,
              drawBuffers: !1,
              shaderTextureLOD: !1,
            }),
            (this.defaultAttributeValues = {
              color: [1, 1, 1],
              uv: [0, 0],
              uv2: [0, 0],
            }),
            (this.index0AttributeName = void 0),
            (this.uniformsNeedUpdate = !1),
            (this.glslVersion = null),
            void 0 !== e &&
              (void 0 !== e.attributes &&
                console.error(
                  "THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."
                ),
              this.setValues(e));
        }
        copy(e) {
          return (
            super.copy(e),
            (this.fragmentShader = e.fragmentShader),
            (this.vertexShader = e.vertexShader),
            (this.uniforms = Wr(e.uniforms)),
            (this.defines = Object.assign({}, e.defines)),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.lights = e.lights),
            (this.clipping = e.clipping),
            (this.extensions = Object.assign({}, e.extensions)),
            (this.glslVersion = e.glslVersion),
            this
          );
        }
        toJSON(e) {
          const t = super.toJSON(e);
          (t.glslVersion = this.glslVersion), (t.uniforms = {});
          for (const n in this.uniforms) {
            const i = this.uniforms[n].value;
            i && i.isTexture
              ? (t.uniforms[n] = { type: "t", value: i.toJSON(e).uuid })
              : i && i.isColor
              ? (t.uniforms[n] = { type: "c", value: i.getHex() })
              : i && i.isVector2
              ? (t.uniforms[n] = { type: "v2", value: i.toArray() })
              : i && i.isVector3
              ? (t.uniforms[n] = { type: "v3", value: i.toArray() })
              : i && i.isVector4
              ? (t.uniforms[n] = { type: "v4", value: i.toArray() })
              : i && i.isMatrix3
              ? (t.uniforms[n] = { type: "m3", value: i.toArray() })
              : i && i.isMatrix4
              ? (t.uniforms[n] = { type: "m4", value: i.toArray() })
              : (t.uniforms[n] = { value: i });
          }
          Object.keys(this.defines).length > 0 && (t.defines = this.defines),
            (t.vertexShader = this.vertexShader),
            (t.fragmentShader = this.fragmentShader);
          const n = {};
          for (const e in this.extensions)
            !0 === this.extensions[e] && (n[e] = !0);
          return Object.keys(n).length > 0 && (t.extensions = n), t;
        }
      }
      qr.prototype.isShaderMaterial = !0;
      class Yr extends Bi {
        constructor() {
          super(),
            (this.type = "Camera"),
            (this.matrixWorldInverse = new gi()),
            (this.projectionMatrix = new gi()),
            (this.projectionMatrixInverse = new gi());
        }
        copy(e, t) {
          return (
            super.copy(e, t),
            this.matrixWorldInverse.copy(e.matrixWorldInverse),
            this.projectionMatrix.copy(e.projectionMatrix),
            this.projectionMatrixInverse.copy(e.projectionMatrixInverse),
            this
          );
        }
        getWorldDirection(e) {
          this.updateWorldMatrix(!0, !1);
          const t = this.matrixWorld.elements;
          return e.set(-t[8], -t[9], -t[10]).normalize();
        }
        updateMatrixWorld(e) {
          super.updateMatrixWorld(e),
            this.matrixWorldInverse.copy(this.matrixWorld).invert();
        }
        updateWorldMatrix(e, t) {
          super.updateWorldMatrix(e, t),
            this.matrixWorldInverse.copy(this.matrixWorld).invert();
        }
        clone() {
          return new this.constructor().copy(this);
        }
      }
      Yr.prototype.isCamera = !0;
      class Kr extends Yr {
        constructor(e = 50, t = 1, n = 0.1, i = 2e3) {
          super(),
            (this.type = "PerspectiveCamera"),
            (this.fov = e),
            (this.zoom = 1),
            (this.near = n),
            (this.far = i),
            (this.focus = 10),
            (this.aspect = t),
            (this.view = null),
            (this.filmGauge = 35),
            (this.filmOffset = 0),
            this.updateProjectionMatrix();
        }
        copy(e, t) {
          return (
            super.copy(e, t),
            (this.fov = e.fov),
            (this.zoom = e.zoom),
            (this.near = e.near),
            (this.far = e.far),
            (this.focus = e.focus),
            (this.aspect = e.aspect),
            (this.view = null === e.view ? null : Object.assign({}, e.view)),
            (this.filmGauge = e.filmGauge),
            (this.filmOffset = e.filmOffset),
            this
          );
        }
        setFocalLength(e) {
          const t = (0.5 * this.getFilmHeight()) / e;
          (this.fov = 2 * xn * Math.atan(t)), this.updateProjectionMatrix();
        }
        getFocalLength() {
          const e = Math.tan(0.5 * yn * this.fov);
          return (0.5 * this.getFilmHeight()) / e;
        }
        getEffectiveFOV() {
          return 2 * xn * Math.atan(Math.tan(0.5 * yn * this.fov) / this.zoom);
        }
        getFilmWidth() {
          return this.filmGauge * Math.min(this.aspect, 1);
        }
        getFilmHeight() {
          return this.filmGauge / Math.max(this.aspect, 1);
        }
        setViewOffset(e, t, n, i, r, a) {
          (this.aspect = e / t),
            null === this.view &&
              (this.view = {
                enabled: !0,
                fullWidth: 1,
                fullHeight: 1,
                offsetX: 0,
                offsetY: 0,
                width: 1,
                height: 1,
              }),
            (this.view.enabled = !0),
            (this.view.fullWidth = e),
            (this.view.fullHeight = t),
            (this.view.offsetX = n),
            (this.view.offsetY = i),
            (this.view.width = r),
            (this.view.height = a),
            this.updateProjectionMatrix();
        }
        clearViewOffset() {
          null !== this.view && (this.view.enabled = !1),
            this.updateProjectionMatrix();
        }
        updateProjectionMatrix() {
          const e = this.near;
          let t = (e * Math.tan(0.5 * yn * this.fov)) / this.zoom,
            n = 2 * t,
            i = this.aspect * n,
            r = -0.5 * i;
          const a = this.view;
          if (null !== this.view && this.view.enabled) {
            const e = a.fullWidth,
              o = a.fullHeight;
            (r += (a.offsetX * i) / e),
              (t -= (a.offsetY * n) / o),
              (i *= a.width / e),
              (n *= a.height / o);
          }
          const o = this.filmOffset;
          0 !== o && (r += (e * o) / this.getFilmWidth()),
            this.projectionMatrix.makePerspective(
              r,
              r + i,
              t,
              t - n,
              e,
              this.far
            ),
            this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return (
            (t.object.fov = this.fov),
            (t.object.zoom = this.zoom),
            (t.object.near = this.near),
            (t.object.far = this.far),
            (t.object.focus = this.focus),
            (t.object.aspect = this.aspect),
            null !== this.view &&
              (t.object.view = Object.assign({}, this.view)),
            (t.object.filmGauge = this.filmGauge),
            (t.object.filmOffset = this.filmOffset),
            t
          );
        }
      }
      Kr.prototype.isPerspectiveCamera = !0;
      const Zr = 90;
      class Jr extends Bi {
        constructor(e, t, n) {
          if (
            (super(),
            (this.type = "CubeCamera"),
            !0 !== n.isWebGLCubeRenderTarget)
          )
            return void console.error(
              "THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter."
            );
          this.renderTarget = n;
          const i = new Kr(Zr, 1, e, t);
          (i.layers = this.layers),
            i.up.set(0, -1, 0),
            i.lookAt(new zn(1, 0, 0)),
            this.add(i);
          const r = new Kr(Zr, 1, e, t);
          (r.layers = this.layers),
            r.up.set(0, -1, 0),
            r.lookAt(new zn(-1, 0, 0)),
            this.add(r);
          const a = new Kr(Zr, 1, e, t);
          (a.layers = this.layers),
            a.up.set(0, 0, 1),
            a.lookAt(new zn(0, 1, 0)),
            this.add(a);
          const o = new Kr(Zr, 1, e, t);
          (o.layers = this.layers),
            o.up.set(0, 0, -1),
            o.lookAt(new zn(0, -1, 0)),
            this.add(o);
          const s = new Kr(Zr, 1, e, t);
          (s.layers = this.layers),
            s.up.set(0, -1, 0),
            s.lookAt(new zn(0, 0, 1)),
            this.add(s);
          const l = new Kr(Zr, 1, e, t);
          (l.layers = this.layers),
            l.up.set(0, -1, 0),
            l.lookAt(new zn(0, 0, -1)),
            this.add(l);
        }
        update(e, t) {
          null === this.parent && this.updateMatrixWorld();
          const n = this.renderTarget,
            [i, r, a, o, s, l] = this.children,
            c = e.xr.enabled,
            u = e.getRenderTarget();
          e.xr.enabled = !1;
          const h = n.texture.generateMipmaps;
          (n.texture.generateMipmaps = !1),
            e.setRenderTarget(n, 0),
            e.render(t, i),
            e.setRenderTarget(n, 1),
            e.render(t, r),
            e.setRenderTarget(n, 2),
            e.render(t, a),
            e.setRenderTarget(n, 3),
            e.render(t, o),
            e.setRenderTarget(n, 4),
            e.render(t, s),
            (n.texture.generateMipmaps = h),
            e.setRenderTarget(n, 5),
            e.render(t, l),
            e.setRenderTarget(u),
            (e.xr.enabled = c);
        }
      }
      class Qr extends Nn {
        constructor(e, t, n, i, r, a, o, s, l, c) {
          super(
            (e = void 0 !== e ? e : []),
            (t = void 0 !== t ? t : ye),
            n,
            i,
            r,
            a,
            (o = void 0 !== o ? o : Xe),
            s,
            l,
            c
          ),
            (this.flipY = !1);
        }
        get images() {
          return this.image;
        }
        set images(e) {
          this.image = e;
        }
      }
      Qr.prototype.isCubeTexture = !0;
      class $r extends Fn {
        constructor(e, t, n) {
          Number.isInteger(t) &&
            (console.warn(
              "THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )"
            ),
            (t = n)),
            super(e, e, t),
            (t = t || {}),
            (this.texture = new Qr(
              void 0,
              t.mapping,
              t.wrapS,
              t.wrapT,
              t.magFilter,
              t.minFilter,
              t.format,
              t.type,
              t.anisotropy,
              t.encoding
            )),
            (this.texture.isRenderTargetTexture = !0),
            (this.texture.generateMipmaps =
              void 0 !== t.generateMipmaps && t.generateMipmaps),
            (this.texture.minFilter =
              void 0 !== t.minFilter ? t.minFilter : Re),
            (this.texture._needsFlipEnvMap = !1);
        }
        fromEquirectangularTexture(e, t) {
          (this.texture.type = t.type),
            (this.texture.format = qe),
            (this.texture.encoding = t.encoding),
            (this.texture.generateMipmaps = t.generateMipmaps),
            (this.texture.minFilter = t.minFilter),
            (this.texture.magFilter = t.magFilter);
          const n = {
              uniforms: { tEquirect: { value: null } },
              vertexShader:
                "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
              fragmentShader:
                "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t",
            },
            i = new Vr(5, 5, 5),
            r = new qr({
              name: "CubemapFromEquirect",
              uniforms: Wr(n.uniforms),
              vertexShader: n.vertexShader,
              fragmentShader: n.fragmentShader,
              side: C,
              blending: N,
            });
          r.uniforms.tEquirect.value = t;
          const a = new Br(i, r),
            o = t.minFilter;
          t.minFilter === Ie && (t.minFilter = Re);
          return (
            new Jr(1, 10, this).update(e, a),
            (t.minFilter = o),
            a.geometry.dispose(),
            a.material.dispose(),
            this
          );
        }
        clear(e, t, n, i) {
          const r = e.getRenderTarget();
          for (let r = 0; r < 6; r++)
            e.setRenderTarget(this, r), e.clear(t, n, i);
          e.setRenderTarget(r);
        }
      }
      $r.prototype.isWebGLCubeRenderTarget = !0;
      const ea = new zn(),
        ta = new zn(),
        na = new Pn();
      class ia {
        constructor(e = new zn(1, 0, 0), t = 0) {
          (this.normal = e), (this.constant = t);
        }
        set(e, t) {
          return this.normal.copy(e), (this.constant = t), this;
        }
        setComponents(e, t, n, i) {
          return this.normal.set(e, t, n), (this.constant = i), this;
        }
        setFromNormalAndCoplanarPoint(e, t) {
          return (
            this.normal.copy(e), (this.constant = -t.dot(this.normal)), this
          );
        }
        setFromCoplanarPoints(e, t, n) {
          const i = ea.subVectors(n, t).cross(ta.subVectors(e, t)).normalize();
          return this.setFromNormalAndCoplanarPoint(i, e), this;
        }
        copy(e) {
          return this.normal.copy(e.normal), (this.constant = e.constant), this;
        }
        normalize() {
          const e = 1 / this.normal.length();
          return this.normal.multiplyScalar(e), (this.constant *= e), this;
        }
        negate() {
          return (this.constant *= -1), this.normal.negate(), this;
        }
        distanceToPoint(e) {
          return this.normal.dot(e) + this.constant;
        }
        distanceToSphere(e) {
          return this.distanceToPoint(e.center) - e.radius;
        }
        projectPoint(e, t) {
          return t
            .copy(this.normal)
            .multiplyScalar(-this.distanceToPoint(e))
            .add(e);
        }
        intersectLine(e, t) {
          const n = e.delta(ea),
            i = this.normal.dot(n);
          if (0 === i)
            return 0 === this.distanceToPoint(e.start) ? t.copy(e.start) : null;
          const r = -(e.start.dot(this.normal) + this.constant) / i;
          return r < 0 || r > 1
            ? null
            : t.copy(n).multiplyScalar(r).add(e.start);
        }
        intersectsLine(e) {
          const t = this.distanceToPoint(e.start),
            n = this.distanceToPoint(e.end);
          return (t < 0 && n > 0) || (n < 0 && t > 0);
        }
        intersectsBox(e) {
          return e.intersectsPlane(this);
        }
        intersectsSphere(e) {
          return e.intersectsPlane(this);
        }
        coplanarPoint(e) {
          return e.copy(this.normal).multiplyScalar(-this.constant);
        }
        applyMatrix4(e, t) {
          const n = t || na.getNormalMatrix(e),
            i = this.coplanarPoint(ea).applyMatrix4(e),
            r = this.normal.applyMatrix3(n).normalize();
          return (this.constant = -i.dot(r)), this;
        }
        translate(e) {
          return (this.constant -= e.dot(this.normal)), this;
        }
        equals(e) {
          return e.normal.equals(this.normal) && e.constant === this.constant;
        }
        clone() {
          return new this.constructor().copy(this);
        }
      }
      ia.prototype.isPlane = !0;
      const ra = new si(),
        aa = new zn();
      class oa {
        constructor(
          e = new ia(),
          t = new ia(),
          n = new ia(),
          i = new ia(),
          r = new ia(),
          a = new ia()
        ) {
          this.planes = [e, t, n, i, r, a];
        }
        set(e, t, n, i, r, a) {
          const o = this.planes;
          return (
            o[0].copy(e),
            o[1].copy(t),
            o[2].copy(n),
            o[3].copy(i),
            o[4].copy(r),
            o[5].copy(a),
            this
          );
        }
        copy(e) {
          const t = this.planes;
          for (let n = 0; n < 6; n++) t[n].copy(e.planes[n]);
          return this;
        }
        setFromProjectionMatrix(e) {
          const t = this.planes,
            n = e.elements,
            i = n[0],
            r = n[1],
            a = n[2],
            o = n[3],
            s = n[4],
            l = n[5],
            c = n[6],
            u = n[7],
            h = n[8],
            d = n[9],
            p = n[10],
            m = n[11],
            f = n[12],
            g = n[13],
            v = n[14],
            y = n[15];
          return (
            t[0].setComponents(o - i, u - s, m - h, y - f).normalize(),
            t[1].setComponents(o + i, u + s, m + h, y + f).normalize(),
            t[2].setComponents(o + r, u + l, m + d, y + g).normalize(),
            t[3].setComponents(o - r, u - l, m - d, y - g).normalize(),
            t[4].setComponents(o - a, u - c, m - p, y - v).normalize(),
            t[5].setComponents(o + a, u + c, m + p, y + v).normalize(),
            this
          );
        }
        intersectsObject(e) {
          const t = e.geometry;
          return (
            null === t.boundingSphere && t.computeBoundingSphere(),
            ra.copy(t.boundingSphere).applyMatrix4(e.matrixWorld),
            this.intersectsSphere(ra)
          );
        }
        intersectsSprite(e) {
          return (
            ra.center.set(0, 0, 0),
            (ra.radius = 0.7071067811865476),
            ra.applyMatrix4(e.matrixWorld),
            this.intersectsSphere(ra)
          );
        }
        intersectsSphere(e) {
          const t = this.planes,
            n = e.center,
            i = -e.radius;
          for (let e = 0; e < 6; e++) {
            if (t[e].distanceToPoint(n) < i) return !1;
          }
          return !0;
        }
        intersectsBox(e) {
          const t = this.planes;
          for (let n = 0; n < 6; n++) {
            const i = t[n];
            if (
              ((aa.x = i.normal.x > 0 ? e.max.x : e.min.x),
              (aa.y = i.normal.y > 0 ? e.max.y : e.min.y),
              (aa.z = i.normal.z > 0 ? e.max.z : e.min.z),
              i.distanceToPoint(aa) < 0)
            )
              return !1;
          }
          return !0;
        }
        containsPoint(e) {
          const t = this.planes;
          for (let n = 0; n < 6; n++)
            if (t[n].distanceToPoint(e) < 0) return !1;
          return !0;
        }
        clone() {
          return new this.constructor().copy(this);
        }
      }
      function sa() {
        let e = null,
          t = !1,
          n = null,
          i = null;
        function r(t, a) {
          n(t, a), (i = e.requestAnimationFrame(r));
        }
        return {
          start: function () {
            !0 !== t &&
              null !== n &&
              ((i = e.requestAnimationFrame(r)), (t = !0));
          },
          stop: function () {
            e.cancelAnimationFrame(i), (t = !1);
          },
          setAnimationLoop: function (e) {
            n = e;
          },
          setContext: function (t) {
            e = t;
          },
        };
      }
      function la(e, t) {
        const n = t.isWebGL2,
          i = new WeakMap();
        return {
          get: function (e) {
            return e.isInterleavedBufferAttribute && (e = e.data), i.get(e);
          },
          remove: function (t) {
            t.isInterleavedBufferAttribute && (t = t.data);
            const n = i.get(t);
            n && (e.deleteBuffer(n.buffer), i.delete(t));
          },
          update: function (t, r) {
            if (t.isGLBufferAttribute) {
              const e = i.get(t);
              return void (
                (!e || e.version < t.version) &&
                i.set(t, {
                  buffer: t.buffer,
                  type: t.type,
                  bytesPerElement: t.elementSize,
                  version: t.version,
                })
              );
            }
            t.isInterleavedBufferAttribute && (t = t.data);
            const a = i.get(t);
            void 0 === a
              ? i.set(
                  t,
                  (function (t, i) {
                    const r = t.array,
                      a = t.usage,
                      o = e.createBuffer();
                    e.bindBuffer(i, o),
                      e.bufferData(i, r, a),
                      t.onUploadCallback();
                    let s = 5126;
                    return (
                      r instanceof Float32Array
                        ? (s = 5126)
                        : r instanceof Float64Array
                        ? console.warn(
                            "THREE.WebGLAttributes: Unsupported data buffer format: Float64Array."
                          )
                        : r instanceof Uint16Array
                        ? t.isFloat16BufferAttribute
                          ? n
                            ? (s = 5131)
                            : console.warn(
                                "THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2."
                              )
                          : (s = 5123)
                        : r instanceof Int16Array
                        ? (s = 5122)
                        : r instanceof Uint32Array
                        ? (s = 5125)
                        : r instanceof Int32Array
                        ? (s = 5124)
                        : r instanceof Int8Array
                        ? (s = 5120)
                        : (r instanceof Uint8Array ||
                            r instanceof Uint8ClampedArray) &&
                          (s = 5121),
                      {
                        buffer: o,
                        type: s,
                        bytesPerElement: r.BYTES_PER_ELEMENT,
                        version: t.version,
                      }
                    );
                  })(t, r)
                )
              : a.version < t.version &&
                (!(function (t, i, r) {
                  const a = i.array,
                    o = i.updateRange;
                  e.bindBuffer(r, t),
                    -1 === o.count
                      ? e.bufferSubData(r, 0, a)
                      : (n
                          ? e.bufferSubData(
                              r,
                              o.offset * a.BYTES_PER_ELEMENT,
                              a,
                              o.offset,
                              o.count
                            )
                          : e.bufferSubData(
                              r,
                              o.offset * a.BYTES_PER_ELEMENT,
                              a.subarray(o.offset, o.offset + o.count)
                            ),
                        (o.count = -1));
                })(a.buffer, t, r),
                (a.version = t.version));
          },
        };
      }
      class ca extends Mr {
        constructor(e = 1, t = 1, n = 1, i = 1) {
          super(),
            (this.type = "PlaneGeometry"),
            (this.parameters = {
              width: e,
              height: t,
              widthSegments: n,
              heightSegments: i,
            });
          const r = e / 2,
            a = t / 2,
            o = Math.floor(n),
            s = Math.floor(i),
            l = o + 1,
            c = s + 1,
            u = e / o,
            h = t / s,
            d = [],
            p = [],
            m = [],
            f = [];
          for (let e = 0; e < c; e++) {
            const t = e * h - a;
            for (let n = 0; n < l; n++) {
              const i = n * u - r;
              p.push(i, -t, 0),
                m.push(0, 0, 1),
                f.push(n / o),
                f.push(1 - e / s);
            }
          }
          for (let e = 0; e < s; e++)
            for (let t = 0; t < o; t++) {
              const n = t + l * e,
                i = t + l * (e + 1),
                r = t + 1 + l * (e + 1),
                a = t + 1 + l * e;
              d.push(n, i, a), d.push(i, r, a);
            }
          this.setIndex(d),
            this.setAttribute("position", new mr(p, 3)),
            this.setAttribute("normal", new mr(m, 3)),
            this.setAttribute("uv", new mr(f, 2));
        }
        static fromJSON(e) {
          return new ca(e.width, e.height, e.widthSegments, e.heightSegments);
        }
      }
      const ua = {
          alphamap_fragment:
            "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif",
          alphamap_pars_fragment:
            "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
          alphatest_fragment:
            "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif",
          alphatest_pars_fragment:
            "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
          aomap_fragment:
            "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
          aomap_pars_fragment:
            "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
          begin_vertex: "vec3 transformed = vec3( position );",
          beginnormal_vertex:
            "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
          bsdfs:
            "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotVH = saturate( dot( geometry.viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float NoH ) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float NoV, float NoL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( NoL + NoV - NoL * NoV ) ) );\n}\nvec3 BRDF_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif",
          bumpmap_pars_fragment:
            "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
          clipping_planes_fragment:
            "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif",
          clipping_planes_pars_fragment:
            "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
          clipping_planes_pars_vertex:
            "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
          clipping_planes_vertex:
            "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
          color_fragment:
            "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
          color_pars_fragment:
            "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
          color_pars_vertex:
            "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif",
          color_vertex:
            "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif",
          common:
            "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}",
          cube_uv_reflection_fragment:
            "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
          defaultnormal_vertex:
            "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
          displacementmap_pars_vertex:
            "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
          displacementmap_vertex:
            "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif",
          emissivemap_fragment:
            "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
          emissivemap_pars_fragment:
            "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
          encodings_fragment:
            "gl_FragColor = linearToOutputTexel( gl_FragColor );",
          encodings_pars_fragment:
            "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}",
          envmap_fragment:
            "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
          envmap_common_pars_fragment:
            "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
          envmap_pars_fragment:
            "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
          envmap_pars_vertex:
            "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
          envmap_physical_pars_fragment:
            "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getIBLIrradiance( const in GeometricContext geometry ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec;\n\t\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\t\treflectVec = reflect( - viewDir, normal );\n\t\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\t#else\n\t\t\t\treflectVec = refract( - viewDir, normal, refractionRatio );\n\t\t\t#endif\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif",
          envmap_vertex:
            "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
          fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
          fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
          fog_fragment:
            "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
          fog_pars_fragment:
            "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
          gradientmap_pars_fragment:
            "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}",
          lightmap_fragment:
            "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tlightMapIrradiance *= PI;\n\t#endif\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
          lightmap_pars_fragment:
            "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
          lights_lambert_vertex:
            "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointLightInfo( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotLightInfo( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif",
          lights_pars_begin:
            "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
          lights_toon_fragment:
            "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
          lights_toon_pars_fragment:
            "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)",
          lights_phong_fragment:
            "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
          lights_phong_pars_fragment:
            "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)",
          lights_physical_fragment:
            "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularTintFactor = specularTint;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARTINTMAP\n\t\t\tspecularTintFactor *= specularTintMapTexelToLinear( texture2D( specularTintMap, vUv ) ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularTintFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularTintFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenTint = sheenTint;\n#endif",
          lights_physical_pars_fragment:
            "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenTint;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\tvec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += irradiance * BRDF_Sheen( material.roughness, directLight.direction, geometry, material.sheenTint );\n\t#else\n\t\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
          lights_fragment_begin:
            "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
          lights_fragment_maps:
            "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
          lights_fragment_end:
            "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif",
          logdepthbuf_fragment:
            "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
          logdepthbuf_pars_fragment:
            "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
          logdepthbuf_pars_vertex:
            "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif",
          logdepthbuf_vertex:
            "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif",
          map_fragment:
            "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif",
          map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
          map_particle_fragment:
            "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
          map_particle_pars_fragment:
            "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
          metalnessmap_fragment:
            "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
          metalnessmap_pars_fragment:
            "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
          morphnormal_vertex:
            "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif",
          morphtarget_pars_vertex:
            "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif",
          morphtarget_vertex:
            "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif",
          normal_fragment_begin:
            "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;",
          normal_fragment_maps:
            "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
          normal_pars_fragment:
            "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
          normal_pars_vertex:
            "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
          normal_vertex:
            "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
          normalmap_pars_fragment:
            "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif",
          clearcoat_normal_fragment_begin:
            "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif",
          clearcoat_normal_fragment_maps:
            "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif",
          clearcoat_pars_fragment:
            "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif",
          output_fragment:
            "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
          packing:
            "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}",
          premultiplied_alpha_fragment:
            "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
          project_vertex:
            "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
          dithering_fragment:
            "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
          dithering_pars_fragment:
            "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
          roughnessmap_fragment:
            "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
          roughnessmap_pars_fragment:
            "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
          shadowmap_pars_fragment:
            "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif",
          shadowmap_pars_vertex:
            "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
          shadowmap_vertex:
            "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif",
          shadowmask_pars_fragment:
            "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
          skinbase_vertex:
            "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
          skinning_pars_vertex:
            "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif",
          skinning_vertex:
            "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
          skinnormal_vertex:
            "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
          specularmap_fragment:
            "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
          specularmap_pars_fragment:
            "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
          tonemapping_fragment:
            "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
          tonemapping_pars_fragment:
            "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
          transmission_fragment:
            "#ifdef USE_TRANSMISSION\n\tfloat transmissionAlpha = 1.0;\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationTint, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n\ttransmissionAlpha = transmission.a;\n#endif",
          transmission_pars_fragment:
            "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationTint;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( float roughness, float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( vec2 fragCoord, float roughness, float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( vec3 radiance, float transmissionDistance, vec3 attenuationColor, float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( vec3 n, vec3 v, float roughness, vec3 diffuseColor, vec3 specularColor, float specularF90,\n\t\tvec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness,\n\t\tvec3 attenuationColor, float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif",
          uv_pars_fragment:
            "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif",
          uv_pars_vertex:
            "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif",
          uv_vertex:
            "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif",
          uv2_pars_fragment:
            "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif",
          uv2_pars_vertex:
            "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif",
          uv2_vertex:
            "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif",
          worldpos_vertex:
            "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
          background_frag:
            "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
          background_vert:
            "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
          cube_frag:
            "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
          cube_vert:
            "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
          depth_frag:
            "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}",
          depth_vert:
            "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
          distanceRGBA_frag:
            "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
          distanceRGBA_vert:
            "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
          equirect_frag:
            "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}",
          equirect_vert:
            "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
          linedashed_frag:
            "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
          linedashed_vert:
            "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
          meshbasic_frag:
            "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
          meshbasic_vert:
            "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
          meshlambert_frag:
            "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
          meshlambert_vert:
            "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
          meshmatcap_frag:
            "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
          meshmatcap_vert:
            "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
          meshnormal_frag:
            "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}",
          meshnormal_vert:
            "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
          meshphong_frag:
            "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
          meshphong_vert:
            "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
          meshphysical_frag:
            "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularTint;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARTINTMAP\n\t\tuniform sampler2D specularTintMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenTint;\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - clearcoat * Fcc ) + clearcoatSpecular * clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
          meshphysical_vert:
            "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
          meshtoon_frag:
            "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
          meshtoon_vert:
            "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
          points_frag:
            "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
          points_vert:
            "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
          shadow_frag:
            "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
          shadow_vert:
            "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
          sprite_frag:
            "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}",
          sprite_vert:
            "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
        },
        ha = {
          common: {
            diffuse: { value: new sr(16777215) },
            opacity: { value: 1 },
            map: { value: null },
            uvTransform: { value: new Pn() },
            uv2Transform: { value: new Pn() },
            alphaMap: { value: null },
            alphaTest: { value: 0 },
          },
          specularmap: { specularMap: { value: null } },
          envmap: {
            envMap: { value: null },
            flipEnvMap: { value: -1 },
            reflectivity: { value: 1 },
            ior: { value: 1.5 },
            refractionRatio: { value: 0.98 },
            maxMipLevel: { value: 0 },
          },
          aomap: { aoMap: { value: null }, aoMapIntensity: { value: 1 } },
          lightmap: {
            lightMap: { value: null },
            lightMapIntensity: { value: 1 },
          },
          emissivemap: { emissiveMap: { value: null } },
          bumpmap: { bumpMap: { value: null }, bumpScale: { value: 1 } },
          normalmap: {
            normalMap: { value: null },
            normalScale: { value: new Ln(1, 1) },
          },
          displacementmap: {
            displacementMap: { value: null },
            displacementScale: { value: 1 },
            displacementBias: { value: 0 },
          },
          roughnessmap: { roughnessMap: { value: null } },
          metalnessmap: { metalnessMap: { value: null } },
          gradientmap: { gradientMap: { value: null } },
          fog: {
            fogDensity: { value: 25e-5 },
            fogNear: { value: 1 },
            fogFar: { value: 2e3 },
            fogColor: { value: new sr(16777215) },
          },
          lights: {
            ambientLightColor: { value: [] },
            lightProbe: { value: [] },
            directionalLights: {
              value: [],
              properties: { direction: {}, color: {} },
            },
            directionalLightShadows: {
              value: [],
              properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
              },
            },
            directionalShadowMap: { value: [] },
            directionalShadowMatrix: { value: [] },
            spotLights: {
              value: [],
              properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {},
              },
            },
            spotLightShadows: {
              value: [],
              properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
              },
            },
            spotShadowMap: { value: [] },
            spotShadowMatrix: { value: [] },
            pointLights: {
              value: [],
              properties: { color: {}, position: {}, decay: {}, distance: {} },
            },
            pointLightShadows: {
              value: [],
              properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {},
              },
            },
            pointShadowMap: { value: [] },
            pointShadowMatrix: { value: [] },
            hemisphereLights: {
              value: [],
              properties: { direction: {}, skyColor: {}, groundColor: {} },
            },
            rectAreaLights: {
              value: [],
              properties: { color: {}, position: {}, width: {}, height: {} },
            },
            ltc_1: { value: null },
            ltc_2: { value: null },
          },
          points: {
            diffuse: { value: new sr(16777215) },
            opacity: { value: 1 },
            size: { value: 1 },
            scale: { value: 1 },
            map: { value: null },
            alphaMap: { value: null },
            alphaTest: { value: 0 },
            uvTransform: { value: new Pn() },
          },
          sprite: {
            diffuse: { value: new sr(16777215) },
            opacity: { value: 1 },
            center: { value: new Ln(0.5, 0.5) },
            rotation: { value: 0 },
            map: { value: null },
            alphaMap: { value: null },
            alphaTest: { value: 0 },
            uvTransform: { value: new Pn() },
          },
        },
        da = {
          basic: {
            uniforms: jr([
              ha.common,
              ha.specularmap,
              ha.envmap,
              ha.aomap,
              ha.lightmap,
              ha.fog,
            ]),
            vertexShader: ua.meshbasic_vert,
            fragmentShader: ua.meshbasic_frag,
          },
          lambert: {
            uniforms: jr([
              ha.common,
              ha.specularmap,
              ha.envmap,
              ha.aomap,
              ha.lightmap,
              ha.emissivemap,
              ha.fog,
              ha.lights,
              { emissive: { value: new sr(0) } },
            ]),
            vertexShader: ua.meshlambert_vert,
            fragmentShader: ua.meshlambert_frag,
          },
          phong: {
            uniforms: jr([
              ha.common,
              ha.specularmap,
              ha.envmap,
              ha.aomap,
              ha.lightmap,
              ha.emissivemap,
              ha.bumpmap,
              ha.normalmap,
              ha.displacementmap,
              ha.fog,
              ha.lights,
              {
                emissive: { value: new sr(0) },
                specular: { value: new sr(1118481) },
                shininess: { value: 30 },
              },
            ]),
            vertexShader: ua.meshphong_vert,
            fragmentShader: ua.meshphong_frag,
          },
          standard: {
            uniforms: jr([
              ha.common,
              ha.envmap,
              ha.aomap,
              ha.lightmap,
              ha.emissivemap,
              ha.bumpmap,
              ha.normalmap,
              ha.displacementmap,
              ha.roughnessmap,
              ha.metalnessmap,
              ha.fog,
              ha.lights,
              {
                emissive: { value: new sr(0) },
                roughness: { value: 1 },
                metalness: { value: 0 },
                envMapIntensity: { value: 1 },
              },
            ]),
            vertexShader: ua.meshphysical_vert,
            fragmentShader: ua.meshphysical_frag,
          },
          toon: {
            uniforms: jr([
              ha.common,
              ha.aomap,
              ha.lightmap,
              ha.emissivemap,
              ha.bumpmap,
              ha.normalmap,
              ha.displacementmap,
              ha.gradientmap,
              ha.fog,
              ha.lights,
              { emissive: { value: new sr(0) } },
            ]),
            vertexShader: ua.meshtoon_vert,
            fragmentShader: ua.meshtoon_frag,
          },
          matcap: {
            uniforms: jr([
              ha.common,
              ha.bumpmap,
              ha.normalmap,
              ha.displacementmap,
              ha.fog,
              { matcap: { value: null } },
            ]),
            vertexShader: ua.meshmatcap_vert,
            fragmentShader: ua.meshmatcap_frag,
          },
          points: {
            uniforms: jr([ha.points, ha.fog]),
            vertexShader: ua.points_vert,
            fragmentShader: ua.points_frag,
          },
          dashed: {
            uniforms: jr([
              ha.common,
              ha.fog,
              {
                scale: { value: 1 },
                dashSize: { value: 1 },
                totalSize: { value: 2 },
              },
            ]),
            vertexShader: ua.linedashed_vert,
            fragmentShader: ua.linedashed_frag,
          },
          depth: {
            uniforms: jr([ha.common, ha.displacementmap]),
            vertexShader: ua.depth_vert,
            fragmentShader: ua.depth_frag,
          },
          normal: {
            uniforms: jr([
              ha.common,
              ha.bumpmap,
              ha.normalmap,
              ha.displacementmap,
              { opacity: { value: 1 } },
            ]),
            vertexShader: ua.meshnormal_vert,
            fragmentShader: ua.meshnormal_frag,
          },
          sprite: {
            uniforms: jr([ha.sprite, ha.fog]),
            vertexShader: ua.sprite_vert,
            fragmentShader: ua.sprite_frag,
          },
          background: {
            uniforms: {
              uvTransform: { value: new Pn() },
              t2D: { value: null },
            },
            vertexShader: ua.background_vert,
            fragmentShader: ua.background_frag,
          },
          cube: {
            uniforms: jr([ha.envmap, { opacity: { value: 1 } }]),
            vertexShader: ua.cube_vert,
            fragmentShader: ua.cube_frag,
          },
          equirect: {
            uniforms: { tEquirect: { value: null } },
            vertexShader: ua.equirect_vert,
            fragmentShader: ua.equirect_frag,
          },
          distanceRGBA: {
            uniforms: jr([
              ha.common,
              ha.displacementmap,
              {
                referencePosition: { value: new zn() },
                nearDistance: { value: 1 },
                farDistance: { value: 1e3 },
              },
            ]),
            vertexShader: ua.distanceRGBA_vert,
            fragmentShader: ua.distanceRGBA_frag,
          },
          shadow: {
            uniforms: jr([
              ha.lights,
              ha.fog,
              { color: { value: new sr(0) }, opacity: { value: 1 } },
            ]),
            vertexShader: ua.shadow_vert,
            fragmentShader: ua.shadow_frag,
          },
        };
      function pa(e, t, n, i, r) {
        const a = new sr(0);
        let o,
          s,
          l = 0,
          c = null,
          u = 0,
          h = null;
        function d(e, t) {
          n.buffers.color.setClear(e.r, e.g, e.b, t, r);
        }
        return {
          getClearColor: function () {
            return a;
          },
          setClearColor: function (e, t = 1) {
            a.set(e), (l = t), d(a, l);
          },
          getClearAlpha: function () {
            return l;
          },
          setClearAlpha: function (e) {
            (l = e), d(a, l);
          },
          render: function (n, r) {
            let p = !1,
              m = !0 === r.isScene ? r.background : null;
            m && m.isTexture && (m = t.get(m));
            const f = e.xr,
              g = f.getSession && f.getSession();
            g && "additive" === g.environmentBlendMode && (m = null),
              null === m ? d(a, l) : m && m.isColor && (d(m, 1), (p = !0)),
              (e.autoClear || p) &&
                e.clear(e.autoClearColor, e.autoClearDepth, e.autoClearStencil),
              m && (m.isCubeTexture || m.mapping === we)
                ? (void 0 === s &&
                    ((s = new Br(
                      new Vr(1, 1, 1),
                      new qr({
                        name: "BackgroundCubeMaterial",
                        uniforms: Wr(da.cube.uniforms),
                        vertexShader: da.cube.vertexShader,
                        fragmentShader: da.cube.fragmentShader,
                        side: C,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1,
                      })
                    )),
                    s.geometry.deleteAttribute("normal"),
                    s.geometry.deleteAttribute("uv"),
                    (s.onBeforeRender = function (e, t, n) {
                      this.matrixWorld.copyPosition(n.matrixWorld);
                    }),
                    Object.defineProperty(s.material, "envMap", {
                      get: function () {
                        return this.uniforms.envMap.value;
                      },
                    }),
                    i.update(s)),
                  (s.material.uniforms.envMap.value = m),
                  (s.material.uniforms.flipEnvMap.value =
                    m.isCubeTexture && !1 === m.isRenderTargetTexture ? -1 : 1),
                  (c === m && u === m.version && h === e.toneMapping) ||
                    ((s.material.needsUpdate = !0),
                    (c = m),
                    (u = m.version),
                    (h = e.toneMapping)),
                  n.unshift(s, s.geometry, s.material, 0, 0, null))
                : m &&
                  m.isTexture &&
                  (void 0 === o &&
                    ((o = new Br(
                      new ca(2, 2),
                      new qr({
                        name: "BackgroundMaterial",
                        uniforms: Wr(da.background.uniforms),
                        vertexShader: da.background.vertexShader,
                        fragmentShader: da.background.fragmentShader,
                        side: R,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1,
                      })
                    )),
                    o.geometry.deleteAttribute("normal"),
                    Object.defineProperty(o.material, "map", {
                      get: function () {
                        return this.uniforms.t2D.value;
                      },
                    }),
                    i.update(o)),
                  (o.material.uniforms.t2D.value = m),
                  !0 === m.matrixAutoUpdate && m.updateMatrix(),
                  o.material.uniforms.uvTransform.value.copy(m.matrix),
                  (c === m && u === m.version && h === e.toneMapping) ||
                    ((o.material.needsUpdate = !0),
                    (c = m),
                    (u = m.version),
                    (h = e.toneMapping)),
                  n.unshift(o, o.geometry, o.material, 0, 0, null));
          },
        };
      }
      function ma(e, t, n, i) {
        const r = e.getParameter(34921),
          a = i.isWebGL2 ? null : t.get("OES_vertex_array_object"),
          o = i.isWebGL2 || null !== a,
          s = {},
          l = d(null);
        let c = l;
        function u(t) {
          return i.isWebGL2 ? e.bindVertexArray(t) : a.bindVertexArrayOES(t);
        }
        function h(t) {
          return i.isWebGL2
            ? e.deleteVertexArray(t)
            : a.deleteVertexArrayOES(t);
        }
        function d(e) {
          const t = [],
            n = [],
            i = [];
          for (let e = 0; e < r; e++) (t[e] = 0), (n[e] = 0), (i[e] = 0);
          return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: t,
            enabledAttributes: n,
            attributeDivisors: i,
            object: e,
            attributes: {},
            index: null,
          };
        }
        function p() {
          const e = c.newAttributes;
          for (let t = 0, n = e.length; t < n; t++) e[t] = 0;
        }
        function m(e) {
          f(e, 0);
        }
        function f(n, r) {
          const a = c.newAttributes,
            o = c.enabledAttributes,
            s = c.attributeDivisors;
          if (
            ((a[n] = 1),
            0 === o[n] && (e.enableVertexAttribArray(n), (o[n] = 1)),
            s[n] !== r)
          ) {
            (i.isWebGL2 ? e : t.get("ANGLE_instanced_arrays"))[
              i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"
            ](n, r),
              (s[n] = r);
          }
        }
        function g() {
          const t = c.newAttributes,
            n = c.enabledAttributes;
          for (let i = 0, r = n.length; i < r; i++)
            n[i] !== t[i] && (e.disableVertexAttribArray(i), (n[i] = 0));
        }
        function v(t, n, r, a, o, s) {
          !0 !== i.isWebGL2 || (5124 !== r && 5125 !== r)
            ? e.vertexAttribPointer(t, n, r, a, o, s)
            : e.vertexAttribIPointer(t, n, r, o, s);
        }
        function y() {
          x(), c !== l && ((c = l), u(c.object));
        }
        function x() {
          (l.geometry = null), (l.program = null), (l.wireframe = !1);
        }
        return {
          setup: function (r, l, h, y, x) {
            let b = !1;
            if (o) {
              const t = (function (t, n, r) {
                const o = !0 === r.wireframe;
                let l = s[t.id];
                void 0 === l && ((l = {}), (s[t.id] = l));
                let c = l[n.id];
                void 0 === c && ((c = {}), (l[n.id] = c));
                let u = c[o];
                void 0 === u &&
                  ((u = d(
                    i.isWebGL2
                      ? e.createVertexArray()
                      : a.createVertexArrayOES()
                  )),
                  (c[o] = u));
                return u;
              })(y, h, l);
              c !== t && ((c = t), u(c.object)),
                (b = (function (e, t) {
                  const n = c.attributes,
                    i = e.attributes;
                  let r = 0;
                  for (const e in i) {
                    const t = n[e],
                      a = i[e];
                    if (void 0 === t) return !0;
                    if (t.attribute !== a) return !0;
                    if (t.data !== a.data) return !0;
                    r++;
                  }
                  return c.attributesNum !== r || c.index !== t;
                })(y, x)),
                b &&
                  (function (e, t) {
                    const n = {},
                      i = e.attributes;
                    let r = 0;
                    for (const e in i) {
                      const t = i[e],
                        a = {};
                      (a.attribute = t),
                        t.data && (a.data = t.data),
                        (n[e] = a),
                        r++;
                    }
                    (c.attributes = n), (c.attributesNum = r), (c.index = t);
                  })(y, x);
            } else {
              const e = !0 === l.wireframe;
              (c.geometry === y.id &&
                c.program === h.id &&
                c.wireframe === e) ||
                ((c.geometry = y.id),
                (c.program = h.id),
                (c.wireframe = e),
                (b = !0));
            }
            !0 === r.isInstancedMesh && (b = !0),
              null !== x && n.update(x, 34963),
              b &&
                (!(function (r, a, o, s) {
                  if (
                    !1 === i.isWebGL2 &&
                    (r.isInstancedMesh || s.isInstancedBufferGeometry) &&
                    null === t.get("ANGLE_instanced_arrays")
                  )
                    return;
                  p();
                  const l = s.attributes,
                    c = o.getAttributes(),
                    u = a.defaultAttributeValues;
                  for (const t in c) {
                    const i = c[t];
                    if (i.location >= 0) {
                      let a = l[t];
                      if (
                        (void 0 === a &&
                          ("instanceMatrix" === t &&
                            r.instanceMatrix &&
                            (a = r.instanceMatrix),
                          "instanceColor" === t &&
                            r.instanceColor &&
                            (a = r.instanceColor)),
                        void 0 !== a)
                      ) {
                        const t = a.normalized,
                          o = a.itemSize,
                          l = n.get(a);
                        if (void 0 === l) continue;
                        const c = l.buffer,
                          u = l.type,
                          h = l.bytesPerElement;
                        if (a.isInterleavedBufferAttribute) {
                          const n = a.data,
                            l = n.stride,
                            d = a.offset;
                          if (n && n.isInstancedInterleavedBuffer) {
                            for (let e = 0; e < i.locationSize; e++)
                              f(i.location + e, n.meshPerAttribute);
                            !0 !== r.isInstancedMesh &&
                              void 0 === s._maxInstanceCount &&
                              (s._maxInstanceCount =
                                n.meshPerAttribute * n.count);
                          } else
                            for (let e = 0; e < i.locationSize; e++)
                              m(i.location + e);
                          e.bindBuffer(34962, c);
                          for (let e = 0; e < i.locationSize; e++)
                            v(
                              i.location + e,
                              o / i.locationSize,
                              u,
                              t,
                              l * h,
                              (d + (o / i.locationSize) * e) * h
                            );
                        } else {
                          if (a.isInstancedBufferAttribute) {
                            for (let e = 0; e < i.locationSize; e++)
                              f(i.location + e, a.meshPerAttribute);
                            !0 !== r.isInstancedMesh &&
                              void 0 === s._maxInstanceCount &&
                              (s._maxInstanceCount =
                                a.meshPerAttribute * a.count);
                          } else
                            for (let e = 0; e < i.locationSize; e++)
                              m(i.location + e);
                          e.bindBuffer(34962, c);
                          for (let e = 0; e < i.locationSize; e++)
                            v(
                              i.location + e,
                              o / i.locationSize,
                              u,
                              t,
                              o * h,
                              (o / i.locationSize) * e * h
                            );
                        }
                      } else if (void 0 !== u) {
                        const n = u[t];
                        if (void 0 !== n)
                          switch (n.length) {
                            case 2:
                              e.vertexAttrib2fv(i.location, n);
                              break;
                            case 3:
                              e.vertexAttrib3fv(i.location, n);
                              break;
                            case 4:
                              e.vertexAttrib4fv(i.location, n);
                              break;
                            default:
                              e.vertexAttrib1fv(i.location, n);
                          }
                      }
                    }
                  }
                  g();
                })(r, l, h, y),
                null !== x && e.bindBuffer(34963, n.get(x).buffer));
          },
          reset: y,
          resetDefaultState: x,
          dispose: function () {
            y();
            for (const e in s) {
              const t = s[e];
              for (const e in t) {
                const n = t[e];
                for (const e in n) h(n[e].object), delete n[e];
                delete t[e];
              }
              delete s[e];
            }
          },
          releaseStatesOfGeometry: function (e) {
            if (void 0 === s[e.id]) return;
            const t = s[e.id];
            for (const e in t) {
              const n = t[e];
              for (const e in n) h(n[e].object), delete n[e];
              delete t[e];
            }
            delete s[e.id];
          },
          releaseStatesOfProgram: function (e) {
            for (const t in s) {
              const n = s[t];
              if (void 0 === n[e.id]) continue;
              const i = n[e.id];
              for (const e in i) h(i[e].object), delete i[e];
              delete n[e.id];
            }
          },
          initAttributes: p,
          enableAttribute: m,
          disableUnusedAttributes: g,
        };
      }
      function fa(e, t, n, i) {
        const r = i.isWebGL2;
        let a;
        (this.setMode = function (e) {
          a = e;
        }),
          (this.render = function (t, i) {
            e.drawArrays(a, t, i), n.update(i, a, 1);
          }),
          (this.renderInstances = function (i, o, s) {
            if (0 === s) return;
            let l, c;
            if (r) (l = e), (c = "drawArraysInstanced");
            else if (
              ((l = t.get("ANGLE_instanced_arrays")),
              (c = "drawArraysInstancedANGLE"),
              null === l)
            )
              return void console.error(
                "THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays."
              );
            l[c](a, i, o, s), n.update(o, a, s);
          });
      }
      function ga(e, t, n) {
        let i;
        function r(t) {
          if ("highp" === t) {
            if (
              e.getShaderPrecisionFormat(35633, 36338).precision > 0 &&
              e.getShaderPrecisionFormat(35632, 36338).precision > 0
            )
              return "highp";
            t = "mediump";
          }
          return "mediump" === t &&
            e.getShaderPrecisionFormat(35633, 36337).precision > 0 &&
            e.getShaderPrecisionFormat(35632, 36337).precision > 0
            ? "mediump"
            : "lowp";
        }
        const a =
          ("undefined" != typeof WebGL2RenderingContext &&
            e instanceof WebGL2RenderingContext) ||
          ("undefined" != typeof WebGL2ComputeRenderingContext &&
            e instanceof WebGL2ComputeRenderingContext);
        let o = void 0 !== n.precision ? n.precision : "highp";
        const s = r(o);
        s !== o &&
          (console.warn(
            "THREE.WebGLRenderer:",
            o,
            "not supported, using",
            s,
            "instead."
          ),
          (o = s));
        const l = a || t.has("WEBGL_draw_buffers"),
          c = !0 === n.logarithmicDepthBuffer,
          u = e.getParameter(34930),
          h = e.getParameter(35660),
          d = e.getParameter(3379),
          p = e.getParameter(34076),
          m = e.getParameter(34921),
          f = e.getParameter(36347),
          g = e.getParameter(36348),
          v = e.getParameter(36349),
          y = h > 0,
          x = a || t.has("OES_texture_float");
        return {
          isWebGL2: a,
          drawBuffers: l,
          getMaxAnisotropy: function () {
            if (void 0 !== i) return i;
            if (!0 === t.has("EXT_texture_filter_anisotropic")) {
              const n = t.get("EXT_texture_filter_anisotropic");
              i = e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
            } else i = 0;
            return i;
          },
          getMaxPrecision: r,
          precision: o,
          logarithmicDepthBuffer: c,
          maxTextures: u,
          maxVertexTextures: h,
          maxTextureSize: d,
          maxCubemapSize: p,
          maxAttributes: m,
          maxVertexUniforms: f,
          maxVaryings: g,
          maxFragmentUniforms: v,
          vertexTextures: y,
          floatFragmentTextures: x,
          floatVertexTextures: y && x,
          maxSamples: a ? e.getParameter(36183) : 0,
        };
      }
      function va(e) {
        const t = this;
        let n = null,
          i = 0,
          r = !1,
          a = !1;
        const o = new ia(),
          s = new Pn(),
          l = { value: null, needsUpdate: !1 };
        function c() {
          l.value !== n && ((l.value = n), (l.needsUpdate = i > 0)),
            (t.numPlanes = i),
            (t.numIntersection = 0);
        }
        function u(e, n, i, r) {
          const a = null !== e ? e.length : 0;
          let c = null;
          if (0 !== a) {
            if (((c = l.value), !0 !== r || null === c)) {
              const t = i + 4 * a,
                r = n.matrixWorldInverse;
              s.getNormalMatrix(r),
                (null === c || c.length < t) && (c = new Float32Array(t));
              for (let t = 0, n = i; t !== a; ++t, n += 4)
                o.copy(e[t]).applyMatrix4(r, s),
                  o.normal.toArray(c, n),
                  (c[n + 3] = o.constant);
            }
            (l.value = c), (l.needsUpdate = !0);
          }
          return (t.numPlanes = a), (t.numIntersection = 0), c;
        }
        (this.uniform = l),
          (this.numPlanes = 0),
          (this.numIntersection = 0),
          (this.init = function (e, t, a) {
            const o = 0 !== e.length || t || 0 !== i || r;
            return (r = t), (n = u(e, a, 0)), (i = e.length), o;
          }),
          (this.beginShadows = function () {
            (a = !0), u(null);
          }),
          (this.endShadows = function () {
            (a = !1), c();
          }),
          (this.setState = function (t, o, s) {
            const h = t.clippingPlanes,
              d = t.clipIntersection,
              p = t.clipShadows,
              m = e.get(t);
            if (!r || null === h || 0 === h.length || (a && !p))
              a ? u(null) : c();
            else {
              const e = a ? 0 : i,
                t = 4 * e;
              let r = m.clippingState || null;
              (l.value = r), (r = u(h, o, t, s));
              for (let e = 0; e !== t; ++e) r[e] = n[e];
              (m.clippingState = r),
                (this.numIntersection = d ? this.numPlanes : 0),
                (this.numPlanes += e);
            }
          });
      }
      function ya(e) {
        let t = new WeakMap();
        function n(e, t) {
          return t === be ? (e.mapping = ye) : t === _e && (e.mapping = xe), e;
        }
        function i(e) {
          const n = e.target;
          n.removeEventListener("dispose", i);
          const r = t.get(n);
          void 0 !== r && (t.delete(n), r.dispose());
        }
        return {
          get: function (r) {
            if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
              const a = r.mapping;
              if (a === be || a === _e) {
                if (t.has(r)) {
                  return n(t.get(r).texture, r.mapping);
                }
                {
                  const a = r.image;
                  if (a && a.height > 0) {
                    const o = e.getRenderTarget(),
                      s = new $r(a.height / 2);
                    return (
                      s.fromEquirectangularTexture(e, r),
                      t.set(r, s),
                      e.setRenderTarget(o),
                      r.addEventListener("dispose", i),
                      n(s.texture, r.mapping)
                    );
                  }
                  return null;
                }
              }
            }
            return r;
          },
          dispose: function () {
            t = new WeakMap();
          },
        };
      }
      da.physical = {
        uniforms: jr([
          da.standard.uniforms,
          {
            clearcoat: { value: 0 },
            clearcoatMap: { value: null },
            clearcoatRoughness: { value: 0 },
            clearcoatRoughnessMap: { value: null },
            clearcoatNormalScale: { value: new Ln(1, 1) },
            clearcoatNormalMap: { value: null },
            sheenTint: { value: new sr(0) },
            transmission: { value: 0 },
            transmissionMap: { value: null },
            transmissionSamplerSize: { value: new Ln() },
            transmissionSamplerMap: { value: null },
            thickness: { value: 0 },
            thicknessMap: { value: null },
            attenuationDistance: { value: 0 },
            attenuationTint: { value: new sr(0) },
            specularIntensity: { value: 0 },
            specularIntensityMap: { value: null },
            specularTint: { value: new sr(1, 1, 1) },
            specularTintMap: { value: null },
          },
        ]),
        vertexShader: ua.meshphysical_vert,
        fragmentShader: ua.meshphysical_frag,
      };
      class xa extends Yr {
        constructor(e = -1, t = 1, n = 1, i = -1, r = 0.1, a = 2e3) {
          super(),
            (this.type = "OrthographicCamera"),
            (this.zoom = 1),
            (this.view = null),
            (this.left = e),
            (this.right = t),
            (this.top = n),
            (this.bottom = i),
            (this.near = r),
            (this.far = a),
            this.updateProjectionMatrix();
        }
        copy(e, t) {
          return (
            super.copy(e, t),
            (this.left = e.left),
            (this.right = e.right),
            (this.top = e.top),
            (this.bottom = e.bottom),
            (this.near = e.near),
            (this.far = e.far),
            (this.zoom = e.zoom),
            (this.view = null === e.view ? null : Object.assign({}, e.view)),
            this
          );
        }
        setViewOffset(e, t, n, i, r, a) {
          null === this.view &&
            (this.view = {
              enabled: !0,
              fullWidth: 1,
              fullHeight: 1,
              offsetX: 0,
              offsetY: 0,
              width: 1,
              height: 1,
            }),
            (this.view.enabled = !0),
            (this.view.fullWidth = e),
            (this.view.fullHeight = t),
            (this.view.offsetX = n),
            (this.view.offsetY = i),
            (this.view.width = r),
            (this.view.height = a),
            this.updateProjectionMatrix();
        }
        clearViewOffset() {
          null !== this.view && (this.view.enabled = !1),
            this.updateProjectionMatrix();
        }
        updateProjectionMatrix() {
          const e = (this.right - this.left) / (2 * this.zoom),
            t = (this.top - this.bottom) / (2 * this.zoom),
            n = (this.right + this.left) / 2,
            i = (this.top + this.bottom) / 2;
          let r = n - e,
            a = n + e,
            o = i + t,
            s = i - t;
          if (null !== this.view && this.view.enabled) {
            const e =
                (this.right - this.left) / this.view.fullWidth / this.zoom,
              t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            (r += e * this.view.offsetX),
              (a = r + e * this.view.width),
              (o -= t * this.view.offsetY),
              (s = o - t * this.view.height);
          }
          this.projectionMatrix.makeOrthographic(
            r,
            a,
            o,
            s,
            this.near,
            this.far
          ),
            this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return (
            (t.object.zoom = this.zoom),
            (t.object.left = this.left),
            (t.object.right = this.right),
            (t.object.top = this.top),
            (t.object.bottom = this.bottom),
            (t.object.near = this.near),
            (t.object.far = this.far),
            null !== this.view &&
              (t.object.view = Object.assign({}, this.view)),
            t
          );
        }
      }
      xa.prototype.isOrthographicCamera = !0;
      class ba extends qr {
        constructor(e) {
          super(e), (this.type = "RawShaderMaterial");
        }
      }
      ba.prototype.isRawShaderMaterial = !0;
      const _a = 4,
        wa = 8,
        Ma = Math.pow(2, wa),
        Sa = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582],
        Ta = wa - _a + 1 + Sa.length,
        Ea = 20,
        Aa = { [$t]: 0, [en]: 1, [nn]: 2, [an]: 3, [on]: 4, [sn]: 5, [tn]: 6 },
        La = new xa(),
        { _lodPlanes: Pa, _sizeLods: Ra, _sigmas: Ca } = za(),
        Ia = new sr();
      let Na = null;
      const Da = (1 + Math.sqrt(5)) / 2,
        Oa = 1 / Da,
        Fa = [
          new zn(1, 1, 1),
          new zn(-1, 1, 1),
          new zn(1, 1, -1),
          new zn(-1, 1, -1),
          new zn(0, Da, Oa),
          new zn(0, Da, -Oa),
          new zn(Oa, 0, Da),
          new zn(-Oa, 0, Da),
          new zn(Da, Oa, 0),
          new zn(-Da, Oa, 0),
        ];
      class ka {
        constructor(e) {
          (this._renderer = e),
            (this._pingPongRenderTarget = null),
            (this._blurMaterial = (function (e) {
              const t = new Float32Array(e),
                n = new zn(0, 1, 0);
              return new ba({
                name: "SphericalGaussianBlur",
                defines: { n: e },
                uniforms: {
                  envMap: { value: null },
                  samples: { value: 1 },
                  weights: { value: t },
                  latitudinal: { value: !1 },
                  dTheta: { value: 0 },
                  mipInt: { value: 0 },
                  poleAxis: { value: n },
                  inputEncoding: { value: Aa[$t] },
                  outputEncoding: { value: Aa[$t] },
                },
                vertexShader: Wa(),
                fragmentShader: `\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t${ja()}\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t\tgl_FragColor = linearToOutputTexel( gl_FragColor );\n\n\t\t\t}\n\t\t`,
                blending: N,
                depthTest: !1,
                depthWrite: !1,
              });
            })(Ea)),
            (this._equirectShader = null),
            (this._cubemapShader = null),
            this._compileMaterial(this._blurMaterial);
        }
        fromScene(e, t = 0, n = 0.1, i = 100) {
          Na = this._renderer.getRenderTarget();
          const r = this._allocateTargets();
          return (
            this._sceneToCubeUV(e, n, i, r),
            t > 0 && this._blur(r, 0, 0, t),
            this._applyPMREM(r),
            this._cleanup(r),
            r
          );
        }
        fromEquirectangular(e) {
          return this._fromTexture(e);
        }
        fromCubemap(e) {
          return this._fromTexture(e);
        }
        compileCubemapShader() {
          null === this._cubemapShader &&
            ((this._cubemapShader = Va()),
            this._compileMaterial(this._cubemapShader));
        }
        compileEquirectangularShader() {
          null === this._equirectShader &&
            ((this._equirectShader = Ga()),
            this._compileMaterial(this._equirectShader));
        }
        dispose() {
          this._blurMaterial.dispose(),
            null !== this._cubemapShader && this._cubemapShader.dispose(),
            null !== this._equirectShader && this._equirectShader.dispose();
          for (let e = 0; e < Pa.length; e++) Pa[e].dispose();
        }
        _cleanup(e) {
          this._pingPongRenderTarget.dispose(),
            this._renderer.setRenderTarget(Na),
            (e.scissorTest = !1),
            Ba(e, 0, 0, e.width, e.height);
        }
        _fromTexture(e) {
          Na = this._renderer.getRenderTarget();
          const t = this._allocateTargets(e);
          return (
            this._textureToCubeUV(e, t),
            this._applyPMREM(t),
            this._cleanup(t),
            t
          );
        }
        _allocateTargets(e) {
          const t = {
              magFilter: Ae,
              minFilter: Ae,
              generateMipmaps: !1,
              type: Ne,
              format: Ze,
              encoding: Ha(e) ? e.encoding : nn,
              depthBuffer: !1,
            },
            n = Ua(t);
          return (n.depthBuffer = !e), (this._pingPongRenderTarget = Ua(t)), n;
        }
        _compileMaterial(e) {
          const t = new Br(Pa[0], e);
          this._renderer.compile(t, La);
        }
        _sceneToCubeUV(e, t, n, i) {
          const r = new Kr(90, 1, t, n),
            a = [1, -1, 1, 1, 1, 1],
            o = [1, 1, 1, -1, -1, -1],
            s = this._renderer,
            l = s.autoClear,
            c = s.outputEncoding,
            u = s.toneMapping;
          s.getClearColor(Ia),
            (s.toneMapping = de),
            (s.outputEncoding = $t),
            (s.autoClear = !1);
          const h = new lr({
              name: "PMREM.Background",
              side: C,
              depthWrite: !1,
              depthTest: !1,
            }),
            d = new Br(new Vr(), h);
          let p = !1;
          const m = e.background;
          m
            ? m.isColor && (h.color.copy(m), (e.background = null), (p = !0))
            : (h.color.copy(Ia), (p = !0));
          for (let t = 0; t < 6; t++) {
            const n = t % 3;
            0 == n
              ? (r.up.set(0, a[t], 0), r.lookAt(o[t], 0, 0))
              : 1 == n
              ? (r.up.set(0, 0, a[t]), r.lookAt(0, o[t], 0))
              : (r.up.set(0, a[t], 0), r.lookAt(0, 0, o[t])),
              Ba(i, n * Ma, t > 2 ? Ma : 0, Ma, Ma),
              s.setRenderTarget(i),
              p && s.render(d, r),
              s.render(e, r);
          }
          d.geometry.dispose(),
            d.material.dispose(),
            (s.toneMapping = u),
            (s.outputEncoding = c),
            (s.autoClear = l),
            (e.background = m);
        }
        _textureToCubeUV(e, t) {
          const n = this._renderer;
          e.isCubeTexture
            ? null == this._cubemapShader && (this._cubemapShader = Va())
            : null == this._equirectShader && (this._equirectShader = Ga());
          const i = e.isCubeTexture
              ? this._cubemapShader
              : this._equirectShader,
            r = new Br(Pa[0], i),
            a = i.uniforms;
          (a.envMap.value = e),
            e.isCubeTexture ||
              a.texelSize.value.set(1 / e.image.width, 1 / e.image.height),
            (a.inputEncoding.value = Aa[e.encoding]),
            (a.outputEncoding.value = Aa[t.texture.encoding]),
            Ba(t, 0, 0, 3 * Ma, 2 * Ma),
            n.setRenderTarget(t),
            n.render(r, La);
        }
        _applyPMREM(e) {
          const t = this._renderer,
            n = t.autoClear;
          t.autoClear = !1;
          for (let t = 1; t < Ta; t++) {
            const n = Math.sqrt(Ca[t] * Ca[t] - Ca[t - 1] * Ca[t - 1]),
              i = Fa[(t - 1) % Fa.length];
            this._blur(e, t - 1, t, n, i);
          }
          t.autoClear = n;
        }
        _blur(e, t, n, i, r) {
          const a = this._pingPongRenderTarget;
          this._halfBlur(e, a, t, n, i, "latitudinal", r),
            this._halfBlur(a, e, n, n, i, "longitudinal", r);
        }
        _halfBlur(e, t, n, i, r, a, o) {
          const s = this._renderer,
            l = this._blurMaterial;
          "latitudinal" !== a &&
            "longitudinal" !== a &&
            console.error(
              "blur direction must be either latitudinal or longitudinal!"
            );
          const c = new Br(Pa[i], l),
            u = l.uniforms,
            h = Ra[n] - 1,
            d = isFinite(r) ? Math.PI / (2 * h) : (2 * Math.PI) / 39,
            p = r / d,
            m = isFinite(r) ? 1 + Math.floor(3 * p) : Ea;
          m > Ea &&
            console.warn(
              `sigmaRadians, ${r}, is too large and will clip, as it requested ${m} samples when the maximum is set to 20`
            );
          const f = [];
          let g = 0;
          for (let e = 0; e < Ea; ++e) {
            const t = e / p,
              n = Math.exp((-t * t) / 2);
            f.push(n), 0 == e ? (g += n) : e < m && (g += 2 * n);
          }
          for (let e = 0; e < f.length; e++) f[e] = f[e] / g;
          (u.envMap.value = e.texture),
            (u.samples.value = m),
            (u.weights.value = f),
            (u.latitudinal.value = "latitudinal" === a),
            o && (u.poleAxis.value = o),
            (u.dTheta.value = d),
            (u.mipInt.value = wa - n),
            (u.inputEncoding.value = Aa[e.texture.encoding]),
            (u.outputEncoding.value = Aa[e.texture.encoding]);
          const v = Ra[i];
          Ba(
            t,
            3 * Math.max(0, Ma - 2 * v),
            (0 === i ? 0 : 2 * Ma) + 2 * v * (i > wa - _a ? i - wa + _a : 0),
            3 * v,
            2 * v
          ),
            s.setRenderTarget(t),
            s.render(c, La);
        }
      }
      function Ha(e) {
        return (
          void 0 !== e &&
          e.type === Ne &&
          (e.encoding === $t || e.encoding === en || e.encoding === tn)
        );
      }
      function za() {
        const e = [],
          t = [],
          n = [];
        let i = wa;
        for (let r = 0; r < Ta; r++) {
          const a = Math.pow(2, i);
          t.push(a);
          let o = 1 / a;
          r > wa - _a ? (o = Sa[r - wa + _a - 1]) : 0 == r && (o = 0),
            n.push(o);
          const s = 1 / (a - 1),
            l = -s / 2,
            c = 1 + s / 2,
            u = [l, l, c, l, c, c, l, l, c, c, l, c],
            h = 6,
            d = 6,
            p = 3,
            m = 2,
            f = 1,
            g = new Float32Array(p * d * h),
            v = new Float32Array(m * d * h),
            y = new Float32Array(f * d * h);
          for (let e = 0; e < h; e++) {
            const t = ((e % 3) * 2) / 3 - 1,
              n = e > 2 ? 0 : -1,
              i = [
                t,
                n,
                0,
                t + 2 / 3,
                n,
                0,
                t + 2 / 3,
                n + 1,
                0,
                t,
                n,
                0,
                t + 2 / 3,
                n + 1,
                0,
                t,
                n + 1,
                0,
              ];
            g.set(i, p * d * e), v.set(u, m * d * e);
            const r = [e, e, e, e, e, e];
            y.set(r, f * d * e);
          }
          const x = new Mr();
          x.setAttribute("position", new hr(g, p)),
            x.setAttribute("uv", new hr(v, m)),
            x.setAttribute("faceIndex", new hr(y, f)),
            e.push(x),
            i > _a && i--;
        }
        return { _lodPlanes: e, _sizeLods: t, _sigmas: n };
      }
      function Ua(e) {
        const t = new Fn(3 * Ma, 3 * Ma, e);
        return (
          (t.texture.mapping = we),
          (t.texture.name = "PMREM.cubeUv"),
          (t.scissorTest = !0),
          t
        );
      }
      function Ba(e, t, n, i, r) {
        e.viewport.set(t, n, i, r), e.scissor.set(t, n, i, r);
      }
      function Ga() {
        const e = new Ln(1, 1);
        return new ba({
          name: "EquirectangularToCubeUV",
          uniforms: {
            envMap: { value: null },
            texelSize: { value: e },
            inputEncoding: { value: Aa[$t] },
            outputEncoding: { value: Aa[$t] },
          },
          vertexShader: Wa(),
          fragmentShader: `\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform vec2 texelSize;\n\n\t\t\t${ja()}\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tvec2 f = fract( uv / texelSize - 0.5 );\n\t\t\t\tuv -= f * texelSize;\n\t\t\t\tvec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\t\t\t\tuv.x += texelSize.x;\n\t\t\t\tvec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\t\t\t\tuv.y += texelSize.y;\n\t\t\t\tvec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\t\t\t\tuv.x -= texelSize.x;\n\t\t\t\tvec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;\n\n\t\t\t\tvec3 tm = mix( tl, tr, f.x );\n\t\t\t\tvec3 bm = mix( bl, br, f.x );\n\t\t\t\tgl_FragColor.rgb = mix( tm, bm, f.y );\n\n\t\t\t\tgl_FragColor = linearToOutputTexel( gl_FragColor );\n\n\t\t\t}\n\t\t`,
          blending: N,
          depthTest: !1,
          depthWrite: !1,
        });
      }
      function Va() {
        return new ba({
          name: "CubemapToCubeUV",
          uniforms: {
            envMap: { value: null },
            inputEncoding: { value: Aa[$t] },
            outputEncoding: { value: Aa[$t] },
          },
          vertexShader: Wa(),
          fragmentShader: `\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\t${ja()}\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;\n\t\t\t\tgl_FragColor = linearToOutputTexel( gl_FragColor );\n\n\t\t\t}\n\t\t`,
          blending: N,
          depthTest: !1,
          depthWrite: !1,
        });
      }
      function Wa() {
        return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute vec3 position;\n\t\tattribute vec2 uv;\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
      }
      function ja() {
        return "\n\n\t\tuniform int inputEncoding;\n\t\tuniform int outputEncoding;\n\n\t\t#include <encodings_pars_fragment>\n\n\t\tvec4 inputTexelToLinear( vec4 value ) {\n\n\t\t\tif ( inputEncoding == 0 ) {\n\n\t\t\t\treturn value;\n\n\t\t\t} else if ( inputEncoding == 1 ) {\n\n\t\t\t\treturn sRGBToLinear( value );\n\n\t\t\t} else if ( inputEncoding == 2 ) {\n\n\t\t\t\treturn RGBEToLinear( value );\n\n\t\t\t} else if ( inputEncoding == 3 ) {\n\n\t\t\t\treturn RGBMToLinear( value, 7.0 );\n\n\t\t\t} else if ( inputEncoding == 4 ) {\n\n\t\t\t\treturn RGBMToLinear( value, 16.0 );\n\n\t\t\t} else if ( inputEncoding == 5 ) {\n\n\t\t\t\treturn RGBDToLinear( value, 256.0 );\n\n\t\t\t} else {\n\n\t\t\t\treturn GammaToLinear( value, 2.2 );\n\n\t\t\t}\n\n\t\t}\n\n\t\tvec4 linearToOutputTexel( vec4 value ) {\n\n\t\t\tif ( outputEncoding == 0 ) {\n\n\t\t\t\treturn value;\n\n\t\t\t} else if ( outputEncoding == 1 ) {\n\n\t\t\t\treturn LinearTosRGB( value );\n\n\t\t\t} else if ( outputEncoding == 2 ) {\n\n\t\t\t\treturn LinearToRGBE( value );\n\n\t\t\t} else if ( outputEncoding == 3 ) {\n\n\t\t\t\treturn LinearToRGBM( value, 7.0 );\n\n\t\t\t} else if ( outputEncoding == 4 ) {\n\n\t\t\t\treturn LinearToRGBM( value, 16.0 );\n\n\t\t\t} else if ( outputEncoding == 5 ) {\n\n\t\t\t\treturn LinearToRGBD( value, 256.0 );\n\n\t\t\t} else {\n\n\t\t\t\treturn LinearToGamma( value, 2.2 );\n\n\t\t\t}\n\n\t\t}\n\n\t\tvec4 envMapTexelToLinear( vec4 color ) {\n\n\t\t\treturn inputTexelToLinear( color );\n\n\t\t}\n\t";
      }
      function Xa(e) {
        let t = new WeakMap(),
          n = null;
        function i(e) {
          const n = e.target;
          n.removeEventListener("dispose", i);
          const r = t.get(n);
          void 0 !== r && (t.delete(n), r.dispose());
        }
        return {
          get: function (r) {
            if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
              const a = r.mapping,
                o = a === be || a === _e,
                s = a === ye || a === xe;
              if (o || s) {
                if (t.has(r)) return t.get(r).texture;
                {
                  const a = r.image;
                  if (
                    (o && a && a.height > 0) ||
                    (s &&
                      a &&
                      (function (e) {
                        let t = 0;
                        const n = 6;
                        for (let i = 0; i < n; i++) void 0 !== e[i] && t++;
                        return t === n;
                      })(a))
                  ) {
                    const a = e.getRenderTarget();
                    null === n && (n = new ka(e));
                    const s = o ? n.fromEquirectangular(r) : n.fromCubemap(r);
                    return (
                      t.set(r, s),
                      e.setRenderTarget(a),
                      r.addEventListener("dispose", i),
                      s.texture
                    );
                  }
                  return null;
                }
              }
            }
            return r;
          },
          dispose: function () {
            (t = new WeakMap()), null !== n && (n.dispose(), (n = null));
          },
        };
      }
      function qa(e) {
        const t = {};
        function n(n) {
          if (void 0 !== t[n]) return t[n];
          let i;
          switch (n) {
            case "WEBGL_depth_texture":
              i =
                e.getExtension("WEBGL_depth_texture") ||
                e.getExtension("MOZ_WEBGL_depth_texture") ||
                e.getExtension("WEBKIT_WEBGL_depth_texture");
              break;
            case "EXT_texture_filter_anisotropic":
              i =
                e.getExtension("EXT_texture_filter_anisotropic") ||
                e.getExtension("MOZ_EXT_texture_filter_anisotropic") ||
                e.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
              break;
            case "WEBGL_compressed_texture_s3tc":
              i =
                e.getExtension("WEBGL_compressed_texture_s3tc") ||
                e.getExtension("MOZ_WEBGL_compressed_texture_s3tc") ||
                e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
              break;
            case "WEBGL_compressed_texture_pvrtc":
              i =
                e.getExtension("WEBGL_compressed_texture_pvrtc") ||
                e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
              break;
            default:
              i = e.getExtension(n);
          }
          return (t[n] = i), i;
        }
        return {
          has: function (e) {
            return null !== n(e);
          },
          init: function (e) {
            e.isWebGL2
              ? n("EXT_color_buffer_float")
              : (n("WEBGL_depth_texture"),
                n("OES_texture_float"),
                n("OES_texture_half_float"),
                n("OES_texture_half_float_linear"),
                n("OES_standard_derivatives"),
                n("OES_element_index_uint"),
                n("OES_vertex_array_object"),
                n("ANGLE_instanced_arrays")),
              n("OES_texture_float_linear"),
              n("EXT_color_buffer_half_float");
          },
          get: function (e) {
            const t = n(e);
            return (
              null === t &&
                console.warn(
                  "THREE.WebGLRenderer: " + e + " extension not supported."
                ),
              t
            );
          },
        };
      }
      function Ya(e, t, n, i) {
        const r = {},
          a = new WeakMap();
        function o(e) {
          const s = e.target;
          null !== s.index && t.remove(s.index);
          for (const e in s.attributes) t.remove(s.attributes[e]);
          s.removeEventListener("dispose", o), delete r[s.id];
          const l = a.get(s);
          l && (t.remove(l), a.delete(s)),
            i.releaseStatesOfGeometry(s),
            !0 === s.isInstancedBufferGeometry && delete s._maxInstanceCount,
            n.memory.geometries--;
        }
        function s(e) {
          const n = [],
            i = e.index,
            r = e.attributes.position;
          let o = 0;
          if (null !== i) {
            const e = i.array;
            o = i.version;
            for (let t = 0, i = e.length; t < i; t += 3) {
              const i = e[t + 0],
                r = e[t + 1],
                a = e[t + 2];
              n.push(i, r, r, a, a, i);
            }
          } else {
            const e = r.array;
            o = r.version;
            for (let t = 0, i = e.length / 3 - 1; t < i; t += 3) {
              const e = t + 0,
                i = t + 1,
                r = t + 2;
              n.push(e, i, i, r, r, e);
            }
          }
          const s = new (fr(n) > 65535 ? pr : dr)(n, 1);
          s.version = o;
          const l = a.get(e);
          l && t.remove(l), a.set(e, s);
        }
        return {
          get: function (e, t) {
            return (
              !0 === r[t.id] ||
                (t.addEventListener("dispose", o),
                (r[t.id] = !0),
                n.memory.geometries++),
              t
            );
          },
          update: function (e) {
            const n = e.attributes;
            for (const e in n) t.update(n[e], 34962);
            const i = e.morphAttributes;
            for (const e in i) {
              const n = i[e];
              for (let e = 0, i = n.length; e < i; e++) t.update(n[e], 34962);
            }
          },
          getWireframeAttribute: function (e) {
            const t = a.get(e);
            if (t) {
              const n = e.index;
              null !== n && t.version < n.version && s(e);
            } else s(e);
            return a.get(e);
          },
        };
      }
      function Ka(e, t, n, i) {
        const r = i.isWebGL2;
        let a, o, s;
        (this.setMode = function (e) {
          a = e;
        }),
          (this.setIndex = function (e) {
            (o = e.type), (s = e.bytesPerElement);
          }),
          (this.render = function (t, i) {
            e.drawElements(a, i, o, t * s), n.update(i, a, 1);
          }),
          (this.renderInstances = function (i, l, c) {
            if (0 === c) return;
            let u, h;
            if (r) (u = e), (h = "drawElementsInstanced");
            else if (
              ((u = t.get("ANGLE_instanced_arrays")),
              (h = "drawElementsInstancedANGLE"),
              null === u)
            )
              return void console.error(
                "THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays."
              );
            u[h](a, l, o, i * s, c), n.update(l, a, c);
          });
      }
      function Za(e) {
        const t = { frame: 0, calls: 0, triangles: 0, points: 0, lines: 0 };
        return {
          memory: { geometries: 0, textures: 0 },
          render: t,
          programs: null,
          autoReset: !0,
          reset: function () {
            t.frame++,
              (t.calls = 0),
              (t.triangles = 0),
              (t.points = 0),
              (t.lines = 0);
          },
          update: function (e, n, i) {
            switch ((t.calls++, n)) {
              case 4:
                t.triangles += i * (e / 3);
                break;
              case 1:
                t.lines += i * (e / 2);
                break;
              case 3:
                t.lines += i * (e - 1);
                break;
              case 2:
                t.lines += i * e;
                break;
              case 0:
                t.points += i * e;
                break;
              default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", n);
            }
          },
        };
      }
      function Ja(e, t) {
        return e[0] - t[0];
      }
      function Qa(e, t) {
        return Math.abs(t[1]) - Math.abs(e[1]);
      }
      function $a(e) {
        const t = {},
          n = new Float32Array(8),
          i = [];
        for (let e = 0; e < 8; e++) i[e] = [e, 0];
        return {
          update: function (r, a, o, s) {
            const l = r.morphTargetInfluences,
              c = void 0 === l ? 0 : l.length;
            let u = t[a.id];
            if (void 0 === u || u.length !== c) {
              u = [];
              for (let e = 0; e < c; e++) u[e] = [e, 0];
              t[a.id] = u;
            }
            for (let e = 0; e < c; e++) {
              const t = u[e];
              (t[0] = e), (t[1] = l[e]);
            }
            u.sort(Qa);
            for (let e = 0; e < 8; e++)
              e < c && u[e][1]
                ? ((i[e][0] = u[e][0]), (i[e][1] = u[e][1]))
                : ((i[e][0] = Number.MAX_SAFE_INTEGER), (i[e][1] = 0));
            i.sort(Ja);
            const h = a.morphAttributes.position,
              d = a.morphAttributes.normal;
            let p = 0;
            for (let e = 0; e < 8; e++) {
              const t = i[e],
                r = t[0],
                o = t[1];
              r !== Number.MAX_SAFE_INTEGER && o
                ? (h &&
                    a.getAttribute("morphTarget" + e) !== h[r] &&
                    a.setAttribute("morphTarget" + e, h[r]),
                  d &&
                    a.getAttribute("morphNormal" + e) !== d[r] &&
                    a.setAttribute("morphNormal" + e, d[r]),
                  (n[e] = o),
                  (p += o))
                : (h &&
                    !0 === a.hasAttribute("morphTarget" + e) &&
                    a.deleteAttribute("morphTarget" + e),
                  d &&
                    !0 === a.hasAttribute("morphNormal" + e) &&
                    a.deleteAttribute("morphNormal" + e),
                  (n[e] = 0));
            }
            const m = a.morphTargetsRelative ? 1 : 1 - p;
            s.getUniforms().setValue(e, "morphTargetBaseInfluence", m),
              s.getUniforms().setValue(e, "morphTargetInfluences", n);
          },
        };
      }
      function eo(e, t, n, i) {
        let r = new WeakMap();
        function a(e) {
          const t = e.target;
          t.removeEventListener("dispose", a),
            n.remove(t.instanceMatrix),
            null !== t.instanceColor && n.remove(t.instanceColor);
        }
        return {
          update: function (e) {
            const o = i.render.frame,
              s = e.geometry,
              l = t.get(e, s);
            return (
              r.get(l) !== o && (t.update(l), r.set(l, o)),
              e.isInstancedMesh &&
                (!1 === e.hasEventListener("dispose", a) &&
                  e.addEventListener("dispose", a),
                n.update(e.instanceMatrix, 34962),
                null !== e.instanceColor && n.update(e.instanceColor, 34962)),
              l
            );
          },
          dispose: function () {
            r = new WeakMap();
          },
        };
      }
      class to extends Nn {
        constructor(e = null, t = 1, n = 1, i = 1) {
          super(null),
            (this.image = { data: e, width: t, height: n, depth: i }),
            (this.magFilter = Ae),
            (this.minFilter = Ae),
            (this.wrapR = Te),
            (this.generateMipmaps = !1),
            (this.flipY = !1),
            (this.unpackAlignment = 1),
            (this.needsUpdate = !0);
        }
      }
      to.prototype.isDataTexture2DArray = !0;
      class no extends Nn {
        constructor(e = null, t = 1, n = 1, i = 1) {
          super(null),
            (this.image = { data: e, width: t, height: n, depth: i }),
            (this.magFilter = Ae),
            (this.minFilter = Ae),
            (this.wrapR = Te),
            (this.generateMipmaps = !1),
            (this.flipY = !1),
            (this.unpackAlignment = 1),
            (this.needsUpdate = !0);
        }
      }
      no.prototype.isDataTexture3D = !0;
      const io = new Nn(),
        ro = new to(),
        ao = new no(),
        oo = new Qr(),
        so = [],
        lo = [],
        co = new Float32Array(16),
        uo = new Float32Array(9),
        ho = new Float32Array(4);
      function po(e, t, n) {
        const i = e[0];
        if (i <= 0 || i > 0) return e;
        const r = t * n;
        let a = so[r];
        if (
          (void 0 === a && ((a = new Float32Array(r)), (so[r] = a)), 0 !== t)
        ) {
          i.toArray(a, 0);
          for (let i = 1, r = 0; i !== t; ++i) (r += n), e[i].toArray(a, r);
        }
        return a;
      }
      function mo(e, t) {
        if (e.length !== t.length) return !1;
        for (let n = 0, i = e.length; n < i; n++) if (e[n] !== t[n]) return !1;
        return !0;
      }
      function fo(e, t) {
        for (let n = 0, i = t.length; n < i; n++) e[n] = t[n];
      }
      function go(e, t) {
        let n = lo[t];
        void 0 === n && ((n = new Int32Array(t)), (lo[t] = n));
        for (let i = 0; i !== t; ++i) n[i] = e.allocateTextureUnit();
        return n;
      }
      function vo(e, t) {
        const n = this.cache;
        n[0] !== t && (e.uniform1f(this.addr, t), (n[0] = t));
      }
      function yo(e, t) {
        const n = this.cache;
        if (void 0 !== t.x)
          (n[0] === t.x && n[1] === t.y) ||
            (e.uniform2f(this.addr, t.x, t.y), (n[0] = t.x), (n[1] = t.y));
        else {
          if (mo(n, t)) return;
          e.uniform2fv(this.addr, t), fo(n, t);
        }
      }
      function xo(e, t) {
        const n = this.cache;
        if (void 0 !== t.x)
          (n[0] === t.x && n[1] === t.y && n[2] === t.z) ||
            (e.uniform3f(this.addr, t.x, t.y, t.z),
            (n[0] = t.x),
            (n[1] = t.y),
            (n[2] = t.z));
        else if (void 0 !== t.r)
          (n[0] === t.r && n[1] === t.g && n[2] === t.b) ||
            (e.uniform3f(this.addr, t.r, t.g, t.b),
            (n[0] = t.r),
            (n[1] = t.g),
            (n[2] = t.b));
        else {
          if (mo(n, t)) return;
          e.uniform3fv(this.addr, t), fo(n, t);
        }
      }
      function bo(e, t) {
        const n = this.cache;
        if (void 0 !== t.x)
          (n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w) ||
            (e.uniform4f(this.addr, t.x, t.y, t.z, t.w),
            (n[0] = t.x),
            (n[1] = t.y),
            (n[2] = t.z),
            (n[3] = t.w));
        else {
          if (mo(n, t)) return;
          e.uniform4fv(this.addr, t), fo(n, t);
        }
      }
      function _o(e, t) {
        const n = this.cache,
          i = t.elements;
        if (void 0 === i) {
          if (mo(n, t)) return;
          e.uniformMatrix2fv(this.addr, !1, t), fo(n, t);
        } else {
          if (mo(n, i)) return;
          ho.set(i), e.uniformMatrix2fv(this.addr, !1, ho), fo(n, i);
        }
      }
      function wo(e, t) {
        const n = this.cache,
          i = t.elements;
        if (void 0 === i) {
          if (mo(n, t)) return;
          e.uniformMatrix3fv(this.addr, !1, t), fo(n, t);
        } else {
          if (mo(n, i)) return;
          uo.set(i), e.uniformMatrix3fv(this.addr, !1, uo), fo(n, i);
        }
      }
      function Mo(e, t) {
        const n = this.cache,
          i = t.elements;
        if (void 0 === i) {
          if (mo(n, t)) return;
          e.uniformMatrix4fv(this.addr, !1, t), fo(n, t);
        } else {
          if (mo(n, i)) return;
          co.set(i), e.uniformMatrix4fv(this.addr, !1, co), fo(n, i);
        }
      }
      function So(e, t) {
        const n = this.cache;
        n[0] !== t && (e.uniform1i(this.addr, t), (n[0] = t));
      }
      function To(e, t) {
        const n = this.cache;
        mo(n, t) || (e.uniform2iv(this.addr, t), fo(n, t));
      }
      function Eo(e, t) {
        const n = this.cache;
        mo(n, t) || (e.uniform3iv(this.addr, t), fo(n, t));
      }
      function Ao(e, t) {
        const n = this.cache;
        mo(n, t) || (e.uniform4iv(this.addr, t), fo(n, t));
      }
      function Lo(e, t) {
        const n = this.cache;
        n[0] !== t && (e.uniform1ui(this.addr, t), (n[0] = t));
      }
      function Po(e, t) {
        const n = this.cache;
        mo(n, t) || (e.uniform2uiv(this.addr, t), fo(n, t));
      }
      function Ro(e, t) {
        const n = this.cache;
        mo(n, t) || (e.uniform3uiv(this.addr, t), fo(n, t));
      }
      function Co(e, t) {
        const n = this.cache;
        mo(n, t) || (e.uniform4uiv(this.addr, t), fo(n, t));
      }
      function Io(e, t, n) {
        const i = this.cache,
          r = n.allocateTextureUnit();
        i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
          n.safeSetTexture2D(t || io, r);
      }
      function No(e, t, n) {
        const i = this.cache,
          r = n.allocateTextureUnit();
        i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
          n.setTexture3D(t || ao, r);
      }
      function Do(e, t, n) {
        const i = this.cache,
          r = n.allocateTextureUnit();
        i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
          n.safeSetTextureCube(t || oo, r);
      }
      function Oo(e, t, n) {
        const i = this.cache,
          r = n.allocateTextureUnit();
        i[0] !== r && (e.uniform1i(this.addr, r), (i[0] = r)),
          n.setTexture2DArray(t || ro, r);
      }
      function Fo(e, t) {
        e.uniform1fv(this.addr, t);
      }
      function ko(e, t) {
        const n = po(t, this.size, 2);
        e.uniform2fv(this.addr, n);
      }
      function Ho(e, t) {
        const n = po(t, this.size, 3);
        e.uniform3fv(this.addr, n);
      }
      function zo(e, t) {
        const n = po(t, this.size, 4);
        e.uniform4fv(this.addr, n);
      }
      function Uo(e, t) {
        const n = po(t, this.size, 4);
        e.uniformMatrix2fv(this.addr, !1, n);
      }
      function Bo(e, t) {
        const n = po(t, this.size, 9);
        e.uniformMatrix3fv(this.addr, !1, n);
      }
      function Go(e, t) {
        const n = po(t, this.size, 16);
        e.uniformMatrix4fv(this.addr, !1, n);
      }
      function Vo(e, t) {
        e.uniform1iv(this.addr, t);
      }
      function Wo(e, t) {
        e.uniform2iv(this.addr, t);
      }
      function jo(e, t) {
        e.uniform3iv(this.addr, t);
      }
      function Xo(e, t) {
        e.uniform4iv(this.addr, t);
      }
      function qo(e, t) {
        e.uniform1uiv(this.addr, t);
      }
      function Yo(e, t) {
        e.uniform2uiv(this.addr, t);
      }
      function Ko(e, t) {
        e.uniform3uiv(this.addr, t);
      }
      function Zo(e, t) {
        e.uniform4uiv(this.addr, t);
      }
      function Jo(e, t, n) {
        const i = t.length,
          r = go(n, i);
        e.uniform1iv(this.addr, r);
        for (let e = 0; e !== i; ++e) n.safeSetTexture2D(t[e] || io, r[e]);
      }
      function Qo(e, t, n) {
        const i = t.length,
          r = go(n, i);
        e.uniform1iv(this.addr, r);
        for (let e = 0; e !== i; ++e) n.safeSetTextureCube(t[e] || oo, r[e]);
      }
      function $o(e, t, n) {
        (this.id = e),
          (this.addr = n),
          (this.cache = []),
          (this.setValue = (function (e) {
            switch (e) {
              case 5126:
                return vo;
              case 35664:
                return yo;
              case 35665:
                return xo;
              case 35666:
                return bo;
              case 35674:
                return _o;
              case 35675:
                return wo;
              case 35676:
                return Mo;
              case 5124:
              case 35670:
                return So;
              case 35667:
              case 35671:
                return To;
              case 35668:
              case 35672:
                return Eo;
              case 35669:
              case 35673:
                return Ao;
              case 5125:
                return Lo;
              case 36294:
                return Po;
              case 36295:
                return Ro;
              case 36296:
                return Co;
              case 35678:
              case 36198:
              case 36298:
              case 36306:
              case 35682:
                return Io;
              case 35679:
              case 36299:
              case 36307:
                return No;
              case 35680:
              case 36300:
              case 36308:
              case 36293:
                return Do;
              case 36289:
              case 36303:
              case 36311:
              case 36292:
                return Oo;
            }
          })(t.type));
      }
      function es(e, t, n) {
        (this.id = e),
          (this.addr = n),
          (this.cache = []),
          (this.size = t.size),
          (this.setValue = (function (e) {
            switch (e) {
              case 5126:
                return Fo;
              case 35664:
                return ko;
              case 35665:
                return Ho;
              case 35666:
                return zo;
              case 35674:
                return Uo;
              case 35675:
                return Bo;
              case 35676:
                return Go;
              case 5124:
              case 35670:
                return Vo;
              case 35667:
              case 35671:
                return Wo;
              case 35668:
              case 35672:
                return jo;
              case 35669:
              case 35673:
                return Xo;
              case 5125:
                return qo;
              case 36294:
                return Yo;
              case 36295:
                return Ko;
              case 36296:
                return Zo;
              case 35678:
              case 36198:
              case 36298:
              case 36306:
              case 35682:
                return Jo;
              case 35680:
              case 36300:
              case 36308:
              case 36293:
                return Qo;
            }
          })(t.type));
      }
      function ts(e) {
        (this.id = e), (this.seq = []), (this.map = {});
      }
      (es.prototype.updateCache = function (e) {
        const t = this.cache;
        e instanceof Float32Array &&
          t.length !== e.length &&
          (this.cache = new Float32Array(e.length)),
          fo(t, e);
      }),
        (ts.prototype.setValue = function (e, t, n) {
          const i = this.seq;
          for (let r = 0, a = i.length; r !== a; ++r) {
            const a = i[r];
            a.setValue(e, t[a.id], n);
          }
        });
      const ns = /(\w+)(\])?(\[|\.)?/g;
      function is(e, t) {
        e.seq.push(t), (e.map[t.id] = t);
      }
      function rs(e, t, n) {
        const i = e.name,
          r = i.length;
        for (ns.lastIndex = 0; ; ) {
          const a = ns.exec(i),
            o = ns.lastIndex;
          let s = a[1];
          const l = "]" === a[2],
            c = a[3];
          if ((l && (s |= 0), void 0 === c || ("[" === c && o + 2 === r))) {
            is(n, void 0 === c ? new $o(s, e, t) : new es(s, e, t));
            break;
          }
          {
            let e = n.map[s];
            void 0 === e && ((e = new ts(s)), is(n, e)), (n = e);
          }
        }
      }
      function as(e, t) {
        (this.seq = []), (this.map = {});
        const n = e.getProgramParameter(t, 35718);
        for (let i = 0; i < n; ++i) {
          const n = e.getActiveUniform(t, i);
          rs(n, e.getUniformLocation(t, n.name), this);
        }
      }
      function os(e, t, n) {
        const i = e.createShader(t);
        return e.shaderSource(i, n), e.compileShader(i), i;
      }
      (as.prototype.setValue = function (e, t, n, i) {
        const r = this.map[t];
        void 0 !== r && r.setValue(e, n, i);
      }),
        (as.prototype.setOptional = function (e, t, n) {
          const i = t[n];
          void 0 !== i && this.setValue(e, n, i);
        }),
        (as.upload = function (e, t, n, i) {
          for (let r = 0, a = t.length; r !== a; ++r) {
            const a = t[r],
              o = n[a.id];
            !1 !== o.needsUpdate && a.setValue(e, o.value, i);
          }
        }),
        (as.seqWithValue = function (e, t) {
          const n = [];
          for (let i = 0, r = e.length; i !== r; ++i) {
            const r = e[i];
            r.id in t && n.push(r);
          }
          return n;
        });
      let ss = 0;
      function ls(e) {
        switch (e) {
          case $t:
            return ["Linear", "( value )"];
          case en:
            return ["sRGB", "( value )"];
          case nn:
            return ["RGBE", "( value )"];
          case an:
            return ["RGBM", "( value, 7.0 )"];
          case on:
            return ["RGBM", "( value, 16.0 )"];
          case sn:
            return ["RGBD", "( value, 256.0 )"];
          case tn:
            return ["Gamma", "( value, float( GAMMA_FACTOR ) )"];
          case rn:
            return ["LogLuv", "( value )"];
          default:
            return (
              console.warn("THREE.WebGLProgram: Unsupported encoding:", e),
              ["Linear", "( value )"]
            );
        }
      }
      function cs(e, t, n) {
        const i = e.getShaderParameter(t, 35713),
          r = e.getShaderInfoLog(t).trim();
        return i && "" === r
          ? ""
          : n.toUpperCase() +
              "\n\n" +
              r +
              "\n\n" +
              (function (e) {
                const t = e.split("\n");
                for (let e = 0; e < t.length; e++) t[e] = e + 1 + ": " + t[e];
                return t.join("\n");
              })(e.getShaderSource(t));
      }
      function us(e, t) {
        const n = ls(t);
        return (
          "vec4 " +
          e +
          "( vec4 value ) { return " +
          n[0] +
          "ToLinear" +
          n[1] +
          "; }"
        );
      }
      function hs(e, t) {
        const n = ls(t);
        return (
          "vec4 " + e + "( vec4 value ) { return LinearTo" + n[0] + n[1] + "; }"
        );
      }
      function ds(e, t) {
        let n;
        switch (t) {
          case pe:
            n = "Linear";
            break;
          case me:
            n = "Reinhard";
            break;
          case fe:
            n = "OptimizedCineon";
            break;
          case ge:
            n = "ACESFilmic";
            break;
          case ve:
            n = "Custom";
            break;
          default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t),
              (n = "Linear");
        }
        return (
          "vec3 " +
          e +
          "( vec3 color ) { return " +
          n +
          "ToneMapping( color ); }"
        );
      }
      function ps(e) {
        return "" !== e;
      }
      function ms(e, t) {
        return e
          .replace(/NUM_DIR_LIGHTS/g, t.numDirLights)
          .replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights)
          .replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights)
          .replace(/NUM_POINT_LIGHTS/g, t.numPointLights)
          .replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights)
          .replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows)
          .replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows)
          .replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
      }
      function fs(e, t) {
        return e
          .replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes)
          .replace(
            /UNION_CLIPPING_PLANES/g,
            t.numClippingPlanes - t.numClipIntersection
          );
      }
      const gs = /^[ \t]*#include +<([\w\d./]+)>/gm;
      function vs(e) {
        return e.replace(gs, ys);
      }
      function ys(e, t) {
        const n = ua[t];
        if (void 0 === n)
          throw new Error("Can not resolve #include <" + t + ">");
        return vs(n);
      }
      const xs =
          /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g,
        bs =
          /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
      function _s(e) {
        return e.replace(bs, Ms).replace(xs, ws);
      }
      function ws(e, t, n, i) {
        return (
          console.warn(
            "WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead."
          ),
          Ms(e, t, n, i)
        );
      }
      function Ms(e, t, n, i) {
        let r = "";
        for (let e = parseInt(t); e < parseInt(n); e++)
          r += i
            .replace(/\[\s*i\s*\]/g, "[ " + e + " ]")
            .replace(/UNROLLED_LOOP_INDEX/g, e);
        return r;
      }
      function Ss(e) {
        let t =
          "precision " +
          e.precision +
          " float;\nprecision " +
          e.precision +
          " int;";
        return (
          "highp" === e.precision
            ? (t += "\n#define HIGH_PRECISION")
            : "mediump" === e.precision
            ? (t += "\n#define MEDIUM_PRECISION")
            : "lowp" === e.precision && (t += "\n#define LOW_PRECISION"),
          t
        );
      }
      function Ts(e, t, n, i) {
        const r = e.getContext(),
          a = n.defines;
        let o = n.vertexShader,
          s = n.fragmentShader;
        const l = (function (e) {
            let t = "SHADOWMAP_TYPE_BASIC";
            return (
              e.shadowMapType === A
                ? (t = "SHADOWMAP_TYPE_PCF")
                : e.shadowMapType === L
                ? (t = "SHADOWMAP_TYPE_PCF_SOFT")
                : e.shadowMapType === P && (t = "SHADOWMAP_TYPE_VSM"),
              t
            );
          })(n),
          c = (function (e) {
            let t = "ENVMAP_TYPE_CUBE";
            if (e.envMap)
              switch (e.envMapMode) {
                case ye:
                case xe:
                  t = "ENVMAP_TYPE_CUBE";
                  break;
                case we:
                case Me:
                  t = "ENVMAP_TYPE_CUBE_UV";
              }
            return t;
          })(n),
          u = (function (e) {
            let t = "ENVMAP_MODE_REFLECTION";
            if (e.envMap)
              switch (e.envMapMode) {
                case xe:
                case Me:
                  t = "ENVMAP_MODE_REFRACTION";
              }
            return t;
          })(n),
          h = (function (e) {
            let t = "ENVMAP_BLENDING_NONE";
            if (e.envMap)
              switch (e.combine) {
                case ce:
                  t = "ENVMAP_BLENDING_MULTIPLY";
                  break;
                case ue:
                  t = "ENVMAP_BLENDING_MIX";
                  break;
                case he:
                  t = "ENVMAP_BLENDING_ADD";
              }
            return t;
          })(n),
          d = e.gammaFactor > 0 ? e.gammaFactor : 1,
          p = n.isWebGL2
            ? ""
            : (function (e) {
                return [
                  e.extensionDerivatives ||
                  e.envMapCubeUV ||
                  e.bumpMap ||
                  e.tangentSpaceNormalMap ||
                  e.clearcoatNormalMap ||
                  e.flatShading ||
                  "physical" === e.shaderID
                    ? "#extension GL_OES_standard_derivatives : enable"
                    : "",
                  (e.extensionFragDepth || e.logarithmicDepthBuffer) &&
                  e.rendererExtensionFragDepth
                    ? "#extension GL_EXT_frag_depth : enable"
                    : "",
                  e.extensionDrawBuffers && e.rendererExtensionDrawBuffers
                    ? "#extension GL_EXT_draw_buffers : require"
                    : "",
                  (e.extensionShaderTextureLOD || e.envMap || e.transmission) &&
                  e.rendererExtensionShaderTextureLod
                    ? "#extension GL_EXT_shader_texture_lod : enable"
                    : "",
                ]
                  .filter(ps)
                  .join("\n");
              })(n),
          m = (function (e) {
            const t = [];
            for (const n in e) {
              const i = e[n];
              !1 !== i && t.push("#define " + n + " " + i);
            }
            return t.join("\n");
          })(a),
          f = r.createProgram();
        let g,
          v,
          y = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
        n.isRawShaderMaterial
          ? ((g = [m].filter(ps).join("\n")),
            g.length > 0 && (g += "\n"),
            (v = [p, m].filter(ps).join("\n")),
            v.length > 0 && (v += "\n"))
          : ((g = [
              Ss(n),
              "#define SHADER_NAME " + n.shaderName,
              m,
              n.instancing ? "#define USE_INSTANCING" : "",
              n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
              n.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
              "#define GAMMA_FACTOR " + d,
              "#define MAX_BONES " + n.maxBones,
              n.useFog && n.fog ? "#define USE_FOG" : "",
              n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
              n.map ? "#define USE_MAP" : "",
              n.envMap ? "#define USE_ENVMAP" : "",
              n.envMap ? "#define " + u : "",
              n.lightMap ? "#define USE_LIGHTMAP" : "",
              n.aoMap ? "#define USE_AOMAP" : "",
              n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
              n.bumpMap ? "#define USE_BUMPMAP" : "",
              n.normalMap ? "#define USE_NORMALMAP" : "",
              n.normalMap && n.objectSpaceNormalMap
                ? "#define OBJECTSPACE_NORMALMAP"
                : "",
              n.normalMap && n.tangentSpaceNormalMap
                ? "#define TANGENTSPACE_NORMALMAP"
                : "",
              n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
              n.clearcoatRoughnessMap
                ? "#define USE_CLEARCOAT_ROUGHNESSMAP"
                : "",
              n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
              n.displacementMap && n.supportsVertexTextures
                ? "#define USE_DISPLACEMENTMAP"
                : "",
              n.specularMap ? "#define USE_SPECULARMAP" : "",
              n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
              n.specularTintMap ? "#define USE_SPECULARTINTMAP" : "",
              n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
              n.metalnessMap ? "#define USE_METALNESSMAP" : "",
              n.alphaMap ? "#define USE_ALPHAMAP" : "",
              n.transmission ? "#define USE_TRANSMISSION" : "",
              n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
              n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
              n.vertexTangents ? "#define USE_TANGENT" : "",
              n.vertexColors ? "#define USE_COLOR" : "",
              n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
              n.vertexUvs ? "#define USE_UV" : "",
              n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
              n.flatShading ? "#define FLAT_SHADED" : "",
              n.skinning ? "#define USE_SKINNING" : "",
              n.useVertexTexture ? "#define BONE_TEXTURE" : "",
              n.morphTargets ? "#define USE_MORPHTARGETS" : "",
              n.morphNormals && !1 === n.flatShading
                ? "#define USE_MORPHNORMALS"
                : "",
              n.doubleSided ? "#define DOUBLE_SIDED" : "",
              n.flipSided ? "#define FLIP_SIDED" : "",
              n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
              n.shadowMapEnabled ? "#define " + l : "",
              n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
              n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
              n.logarithmicDepthBuffer && n.rendererExtensionFragDepth
                ? "#define USE_LOGDEPTHBUF_EXT"
                : "",
              "uniform mat4 modelMatrix;",
              "uniform mat4 modelViewMatrix;",
              "uniform mat4 projectionMatrix;",
              "uniform mat4 viewMatrix;",
              "uniform mat3 normalMatrix;",
              "uniform vec3 cameraPosition;",
              "uniform bool isOrthographic;",
              "#ifdef USE_INSTANCING",
              "\tattribute mat4 instanceMatrix;",
              "#endif",
              "#ifdef USE_INSTANCING_COLOR",
              "\tattribute vec3 instanceColor;",
              "#endif",
              "attribute vec3 position;",
              "attribute vec3 normal;",
              "attribute vec2 uv;",
              "#ifdef USE_TANGENT",
              "\tattribute vec4 tangent;",
              "#endif",
              "#if defined( USE_COLOR_ALPHA )",
              "\tattribute vec4 color;",
              "#elif defined( USE_COLOR )",
              "\tattribute vec3 color;",
              "#endif",
              "#ifdef USE_MORPHTARGETS",
              "\tattribute vec3 morphTarget0;",
              "\tattribute vec3 morphTarget1;",
              "\tattribute vec3 morphTarget2;",
              "\tattribute vec3 morphTarget3;",
              "\t#ifdef USE_MORPHNORMALS",
              "\t\tattribute vec3 morphNormal0;",
              "\t\tattribute vec3 morphNormal1;",
              "\t\tattribute vec3 morphNormal2;",
              "\t\tattribute vec3 morphNormal3;",
              "\t#else",
              "\t\tattribute vec3 morphTarget4;",
              "\t\tattribute vec3 morphTarget5;",
              "\t\tattribute vec3 morphTarget6;",
              "\t\tattribute vec3 morphTarget7;",
              "\t#endif",
              "#endif",
              "#ifdef USE_SKINNING",
              "\tattribute vec4 skinIndex;",
              "\tattribute vec4 skinWeight;",
              "#endif",
              "\n",
            ]
              .filter(ps)
              .join("\n")),
            (v = [
              p,
              Ss(n),
              "#define SHADER_NAME " + n.shaderName,
              m,
              "#define GAMMA_FACTOR " + d,
              n.useFog && n.fog ? "#define USE_FOG" : "",
              n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
              n.map ? "#define USE_MAP" : "",
              n.matcap ? "#define USE_MATCAP" : "",
              n.envMap ? "#define USE_ENVMAP" : "",
              n.envMap ? "#define " + c : "",
              n.envMap ? "#define " + u : "",
              n.envMap ? "#define " + h : "",
              n.lightMap ? "#define USE_LIGHTMAP" : "",
              n.aoMap ? "#define USE_AOMAP" : "",
              n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
              n.bumpMap ? "#define USE_BUMPMAP" : "",
              n.normalMap ? "#define USE_NORMALMAP" : "",
              n.normalMap && n.objectSpaceNormalMap
                ? "#define OBJECTSPACE_NORMALMAP"
                : "",
              n.normalMap && n.tangentSpaceNormalMap
                ? "#define TANGENTSPACE_NORMALMAP"
                : "",
              n.clearcoat ? "#define USE_CLEARCOAT" : "",
              n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
              n.clearcoatRoughnessMap
                ? "#define USE_CLEARCOAT_ROUGHNESSMAP"
                : "",
              n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
              n.specularMap ? "#define USE_SPECULARMAP" : "",
              n.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
              n.specularTintMap ? "#define USE_SPECULARTINTMAP" : "",
              n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
              n.metalnessMap ? "#define USE_METALNESSMAP" : "",
              n.alphaMap ? "#define USE_ALPHAMAP" : "",
              n.alphaTest ? "#define USE_ALPHATEST" : "",
              n.sheenTint ? "#define USE_SHEEN" : "",
              n.transmission ? "#define USE_TRANSMISSION" : "",
              n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
              n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
              n.vertexTangents ? "#define USE_TANGENT" : "",
              n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
              n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
              n.vertexUvs ? "#define USE_UV" : "",
              n.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
              n.gradientMap ? "#define USE_GRADIENTMAP" : "",
              n.flatShading ? "#define FLAT_SHADED" : "",
              n.doubleSided ? "#define DOUBLE_SIDED" : "",
              n.flipSided ? "#define FLIP_SIDED" : "",
              n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
              n.shadowMapEnabled ? "#define " + l : "",
              n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
              n.physicallyCorrectLights
                ? "#define PHYSICALLY_CORRECT_LIGHTS"
                : "",
              n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
              n.logarithmicDepthBuffer && n.rendererExtensionFragDepth
                ? "#define USE_LOGDEPTHBUF_EXT"
                : "",
              (n.extensionShaderTextureLOD || n.envMap) &&
              n.rendererExtensionShaderTextureLod
                ? "#define TEXTURE_LOD_EXT"
                : "",
              "uniform mat4 viewMatrix;",
              "uniform vec3 cameraPosition;",
              "uniform bool isOrthographic;",
              n.toneMapping !== de ? "#define TONE_MAPPING" : "",
              n.toneMapping !== de ? ua.tonemapping_pars_fragment : "",
              n.toneMapping !== de ? ds("toneMapping", n.toneMapping) : "",
              n.dithering ? "#define DITHERING" : "",
              n.format === Xe ? "#define OPAQUE" : "",
              ua.encodings_pars_fragment,
              n.map ? us("mapTexelToLinear", n.mapEncoding) : "",
              n.matcap ? us("matcapTexelToLinear", n.matcapEncoding) : "",
              n.envMap ? us("envMapTexelToLinear", n.envMapEncoding) : "",
              n.emissiveMap
                ? us("emissiveMapTexelToLinear", n.emissiveMapEncoding)
                : "",
              n.specularTintMap
                ? us("specularTintMapTexelToLinear", n.specularTintMapEncoding)
                : "",
              n.lightMap ? us("lightMapTexelToLinear", n.lightMapEncoding) : "",
              hs("linearToOutputTexel", n.outputEncoding),
              n.depthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
              "\n",
            ]
              .filter(ps)
              .join("\n"))),
          (o = vs(o)),
          (o = ms(o, n)),
          (o = fs(o, n)),
          (s = vs(s)),
          (s = ms(s, n)),
          (s = fs(s, n)),
          (o = _s(o)),
          (s = _s(s)),
          n.isWebGL2 &&
            !0 !== n.isRawShaderMaterial &&
            ((y = "#version 300 es\n"),
            (g =
              [
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture",
              ].join("\n") +
              "\n" +
              g),
            (v =
              [
                "#define varying in",
                n.glslVersion === mn ? "" : "out highp vec4 pc_fragColor;",
                n.glslVersion === mn ? "" : "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad",
              ].join("\n") +
              "\n" +
              v));
        const x = y + v + s,
          b = os(r, 35633, y + g + o),
          _ = os(r, 35632, x);
        if (
          (r.attachShader(f, b),
          r.attachShader(f, _),
          void 0 !== n.index0AttributeName
            ? r.bindAttribLocation(f, 0, n.index0AttributeName)
            : !0 === n.morphTargets && r.bindAttribLocation(f, 0, "position"),
          r.linkProgram(f),
          e.debug.checkShaderErrors)
        ) {
          const e = r.getProgramInfoLog(f).trim(),
            t = r.getShaderInfoLog(b).trim(),
            n = r.getShaderInfoLog(_).trim();
          let i = !0,
            a = !0;
          if (!1 === r.getProgramParameter(f, 35714)) {
            i = !1;
            const t = cs(r, b, "vertex"),
              n = cs(r, _, "fragment");
            console.error(
              "THREE.WebGLProgram: Shader Error " +
                r.getError() +
                " - VALIDATE_STATUS " +
                r.getProgramParameter(f, 35715) +
                "\n\nProgram Info Log: " +
                e +
                "\n" +
                t +
                "\n" +
                n
            );
          } else
            "" !== e
              ? console.warn("THREE.WebGLProgram: Program Info Log:", e)
              : ("" !== t && "" !== n) || (a = !1);
          a &&
            (this.diagnostics = {
              runnable: i,
              programLog: e,
              vertexShader: { log: t, prefix: g },
              fragmentShader: { log: n, prefix: v },
            });
        }
        let w, M;
        return (
          r.deleteShader(b),
          r.deleteShader(_),
          (this.getUniforms = function () {
            return void 0 === w && (w = new as(r, f)), w;
          }),
          (this.getAttributes = function () {
            return (
              void 0 === M &&
                (M = (function (e, t) {
                  const n = {},
                    i = e.getProgramParameter(t, 35721);
                  for (let r = 0; r < i; r++) {
                    const i = e.getActiveAttrib(t, r),
                      a = i.name;
                    let o = 1;
                    35674 === i.type && (o = 2),
                      35675 === i.type && (o = 3),
                      35676 === i.type && (o = 4),
                      (n[a] = {
                        type: i.type,
                        location: e.getAttribLocation(t, a),
                        locationSize: o,
                      });
                  }
                  return n;
                })(r, f)),
              M
            );
          }),
          (this.destroy = function () {
            i.releaseStatesOfProgram(this),
              r.deleteProgram(f),
              (this.program = void 0);
          }),
          (this.name = n.shaderName),
          (this.id = ss++),
          (this.cacheKey = t),
          (this.usedTimes = 1),
          (this.program = f),
          (this.vertexShader = b),
          (this.fragmentShader = _),
          this
        );
      }
      function Es(e, t, n, i, r, a, o) {
        const s = [],
          l = r.isWebGL2,
          c = r.logarithmicDepthBuffer,
          u = r.floatVertexTextures,
          h = r.maxVertexUniforms,
          d = r.vertexTextures;
        let p = r.precision;
        const m = {
            MeshDepthMaterial: "depth",
            MeshDistanceMaterial: "distanceRGBA",
            MeshNormalMaterial: "normal",
            MeshBasicMaterial: "basic",
            MeshLambertMaterial: "lambert",
            MeshPhongMaterial: "phong",
            MeshToonMaterial: "toon",
            MeshStandardMaterial: "physical",
            MeshPhysicalMaterial: "physical",
            MeshMatcapMaterial: "matcap",
            LineBasicMaterial: "basic",
            LineDashedMaterial: "dashed",
            PointsMaterial: "points",
            ShadowMaterial: "shadow",
            SpriteMaterial: "sprite",
          },
          f = [
            "precision",
            "isWebGL2",
            "supportsVertexTextures",
            "outputEncoding",
            "instancing",
            "instancingColor",
            "map",
            "mapEncoding",
            "matcap",
            "matcapEncoding",
            "envMap",
            "envMapMode",
            "envMapEncoding",
            "envMapCubeUV",
            "lightMap",
            "lightMapEncoding",
            "aoMap",
            "emissiveMap",
            "emissiveMapEncoding",
            "bumpMap",
            "normalMap",
            "objectSpaceNormalMap",
            "tangentSpaceNormalMap",
            "clearcoat",
            "clearcoatMap",
            "clearcoatRoughnessMap",
            "clearcoatNormalMap",
            "displacementMap",
            "specularMap",
            "specularIntensityMap",
            "specularTintMap",
            "specularTintMapEncoding",
            "roughnessMap",
            "metalnessMap",
            "gradientMap",
            "alphaMap",
            "alphaTest",
            "combine",
            "vertexColors",
            "vertexAlphas",
            "vertexTangents",
            "vertexUvs",
            "uvsVertexOnly",
            "fog",
            "useFog",
            "fogExp2",
            "flatShading",
            "sizeAttenuation",
            "logarithmicDepthBuffer",
            "skinning",
            "maxBones",
            "useVertexTexture",
            "morphTargets",
            "morphNormals",
            "premultipliedAlpha",
            "numDirLights",
            "numPointLights",
            "numSpotLights",
            "numHemiLights",
            "numRectAreaLights",
            "numDirLightShadows",
            "numPointLightShadows",
            "numSpotLightShadows",
            "shadowMapEnabled",
            "shadowMapType",
            "toneMapping",
            "physicallyCorrectLights",
            "doubleSided",
            "flipSided",
            "numClippingPlanes",
            "numClipIntersection",
            "depthPacking",
            "dithering",
            "format",
            "sheenTint",
            "transmission",
            "transmissionMap",
            "thicknessMap",
          ];
        function g(e) {
          let t;
          return (
            e && e.isTexture
              ? (t = e.encoding)
              : e && e.isWebGLRenderTarget
              ? (console.warn(
                  "THREE.WebGLPrograms.getTextureEncodingFromMap: don't use render targets as textures. Use their .texture property instead."
                ),
                (t = e.texture.encoding))
              : (t = $t),
            t
          );
        }
        return {
          getParameters: function (a, s, f, v, y) {
            const x = v.fog,
              b = a.isMeshStandardMaterial ? v.environment : null,
              _ = (a.isMeshStandardMaterial ? n : t).get(a.envMap || b),
              w = m[a.type],
              M = y.isSkinnedMesh
                ? (function (e) {
                    const t = e.skeleton.bones;
                    if (u) return 1024;
                    {
                      const e = h,
                        n = Math.floor((e - 20) / 4),
                        i = Math.min(n, t.length);
                      return i < t.length
                        ? (console.warn(
                            "THREE.WebGLRenderer: Skeleton has " +
                              t.length +
                              " bones. This GPU supports " +
                              i +
                              "."
                          ),
                          0)
                        : i;
                    }
                  })(y)
                : 0;
            let S, T;
            if (
              (null !== a.precision &&
                ((p = r.getMaxPrecision(a.precision)),
                p !== a.precision &&
                  console.warn(
                    "THREE.WebGLProgram.getParameters:",
                    a.precision,
                    "not supported, using",
                    p,
                    "instead."
                  )),
              w)
            ) {
              const e = da[w];
              (S = e.vertexShader), (T = e.fragmentShader);
            } else (S = a.vertexShader), (T = a.fragmentShader);
            const E = e.getRenderTarget(),
              A = a.alphaTest > 0,
              L = a.clearcoat > 0;
            return {
              isWebGL2: l,
              shaderID: w,
              shaderName: a.type,
              vertexShader: S,
              fragmentShader: T,
              defines: a.defines,
              isRawShaderMaterial: !0 === a.isRawShaderMaterial,
              glslVersion: a.glslVersion,
              precision: p,
              instancing: !0 === y.isInstancedMesh,
              instancingColor:
                !0 === y.isInstancedMesh && null !== y.instanceColor,
              supportsVertexTextures: d,
              outputEncoding: null !== E ? g(E.texture) : e.outputEncoding,
              map: !!a.map,
              mapEncoding: g(a.map),
              matcap: !!a.matcap,
              matcapEncoding: g(a.matcap),
              envMap: !!_,
              envMapMode: _ && _.mapping,
              envMapEncoding: g(_),
              envMapCubeUV: !!_ && (_.mapping === we || _.mapping === Me),
              lightMap: !!a.lightMap,
              lightMapEncoding: g(a.lightMap),
              aoMap: !!a.aoMap,
              emissiveMap: !!a.emissiveMap,
              emissiveMapEncoding: g(a.emissiveMap),
              bumpMap: !!a.bumpMap,
              normalMap: !!a.normalMap,
              objectSpaceNormalMap: a.normalMapType === un,
              tangentSpaceNormalMap: a.normalMapType === cn,
              clearcoat: L,
              clearcoatMap: L && !!a.clearcoatMap,
              clearcoatRoughnessMap: L && !!a.clearcoatRoughnessMap,
              clearcoatNormalMap: L && !!a.clearcoatNormalMap,
              displacementMap: !!a.displacementMap,
              roughnessMap: !!a.roughnessMap,
              metalnessMap: !!a.metalnessMap,
              specularMap: !!a.specularMap,
              specularIntensityMap: !!a.specularIntensityMap,
              specularTintMap: !!a.specularTintMap,
              specularTintMapEncoding: g(a.specularTintMap),
              alphaMap: !!a.alphaMap,
              alphaTest: A,
              gradientMap: !!a.gradientMap,
              sheenTint:
                !!a.sheenTint &&
                (a.sheenTint.r > 0 || a.sheenTint.g > 0 || a.sheenTint.b > 0),
              transmission: a.transmission > 0,
              transmissionMap: !!a.transmissionMap,
              thicknessMap: !!a.thicknessMap,
              combine: a.combine,
              vertexTangents:
                !!a.normalMap &&
                !!y.geometry &&
                !!y.geometry.attributes.tangent,
              vertexColors: a.vertexColors,
              vertexAlphas:
                !0 === a.vertexColors &&
                !!y.geometry &&
                !!y.geometry.attributes.color &&
                4 === y.geometry.attributes.color.itemSize,
              vertexUvs: !!(
                a.map ||
                a.bumpMap ||
                a.normalMap ||
                a.specularMap ||
                a.alphaMap ||
                a.emissiveMap ||
                a.roughnessMap ||
                a.metalnessMap ||
                a.clearcoatMap ||
                a.clearcoatRoughnessMap ||
                a.clearcoatNormalMap ||
                a.displacementMap ||
                a.transmissionMap ||
                a.thicknessMap ||
                a.specularIntensityMap ||
                a.specularTintMap
              ),
              uvsVertexOnly: !(
                a.map ||
                a.bumpMap ||
                a.normalMap ||
                a.specularMap ||
                a.alphaMap ||
                a.emissiveMap ||
                a.roughnessMap ||
                a.metalnessMap ||
                a.clearcoatNormalMap ||
                a.transmission > 0 ||
                a.transmissionMap ||
                a.thicknessMap ||
                a.specularIntensityMap ||
                a.specularTintMap ||
                !a.displacementMap
              ),
              fog: !!x,
              useFog: a.fog,
              fogExp2: x && x.isFogExp2,
              flatShading: !!a.flatShading,
              sizeAttenuation: a.sizeAttenuation,
              logarithmicDepthBuffer: c,
              skinning: !0 === y.isSkinnedMesh && M > 0,
              maxBones: M,
              useVertexTexture: u,
              morphTargets:
                !!y.geometry && !!y.geometry.morphAttributes.position,
              morphNormals: !!y.geometry && !!y.geometry.morphAttributes.normal,
              numDirLights: s.directional.length,
              numPointLights: s.point.length,
              numSpotLights: s.spot.length,
              numRectAreaLights: s.rectArea.length,
              numHemiLights: s.hemi.length,
              numDirLightShadows: s.directionalShadowMap.length,
              numPointLightShadows: s.pointShadowMap.length,
              numSpotLightShadows: s.spotShadowMap.length,
              numClippingPlanes: o.numPlanes,
              numClipIntersection: o.numIntersection,
              format: a.format,
              dithering: a.dithering,
              shadowMapEnabled: e.shadowMap.enabled && f.length > 0,
              shadowMapType: e.shadowMap.type,
              toneMapping: a.toneMapped ? e.toneMapping : de,
              physicallyCorrectLights: e.physicallyCorrectLights,
              premultipliedAlpha: a.premultipliedAlpha,
              doubleSided: a.side === I,
              flipSided: a.side === C,
              depthPacking: void 0 !== a.depthPacking && a.depthPacking,
              index0AttributeName: a.index0AttributeName,
              extensionDerivatives: a.extensions && a.extensions.derivatives,
              extensionFragDepth: a.extensions && a.extensions.fragDepth,
              extensionDrawBuffers: a.extensions && a.extensions.drawBuffers,
              extensionShaderTextureLOD:
                a.extensions && a.extensions.shaderTextureLOD,
              rendererExtensionFragDepth: l || i.has("EXT_frag_depth"),
              rendererExtensionDrawBuffers: l || i.has("WEBGL_draw_buffers"),
              rendererExtensionShaderTextureLod:
                l || i.has("EXT_shader_texture_lod"),
              customProgramCacheKey: a.customProgramCacheKey(),
            };
          },
          getProgramCacheKey: function (t) {
            const n = [];
            if (
              (t.shaderID
                ? n.push(t.shaderID)
                : (n.push(t.fragmentShader), n.push(t.vertexShader)),
              void 0 !== t.defines)
            )
              for (const e in t.defines) n.push(e), n.push(t.defines[e]);
            if (!1 === t.isRawShaderMaterial) {
              for (let e = 0; e < f.length; e++) n.push(t[f[e]]);
              n.push(e.outputEncoding), n.push(e.gammaFactor);
            }
            return n.push(t.customProgramCacheKey), n.join();
          },
          getUniforms: function (e) {
            const t = m[e.type];
            let n;
            if (t) {
              const e = da[t];
              n = Xr.clone(e.uniforms);
            } else n = e.uniforms;
            return n;
          },
          acquireProgram: function (t, n) {
            let i;
            for (let e = 0, t = s.length; e < t; e++) {
              const t = s[e];
              if (t.cacheKey === n) {
                (i = t), ++i.usedTimes;
                break;
              }
            }
            return void 0 === i && ((i = new Ts(e, n, t, a)), s.push(i)), i;
          },
          releaseProgram: function (e) {
            if (0 == --e.usedTimes) {
              const t = s.indexOf(e);
              (s[t] = s[s.length - 1]), s.pop(), e.destroy();
            }
          },
          programs: s,
        };
      }
      function As() {
        let e = new WeakMap();
        return {
          get: function (t) {
            let n = e.get(t);
            return void 0 === n && ((n = {}), e.set(t, n)), n;
          },
          remove: function (t) {
            e.delete(t);
          },
          update: function (t, n, i) {
            e.get(t)[n] = i;
          },
          dispose: function () {
            e = new WeakMap();
          },
        };
      }
      function Ls(e, t) {
        return e.groupOrder !== t.groupOrder
          ? e.groupOrder - t.groupOrder
          : e.renderOrder !== t.renderOrder
          ? e.renderOrder - t.renderOrder
          : e.program !== t.program
          ? e.program.id - t.program.id
          : e.material.id !== t.material.id
          ? e.material.id - t.material.id
          : e.z !== t.z
          ? e.z - t.z
          : e.id - t.id;
      }
      function Ps(e, t) {
        return e.groupOrder !== t.groupOrder
          ? e.groupOrder - t.groupOrder
          : e.renderOrder !== t.renderOrder
          ? e.renderOrder - t.renderOrder
          : e.z !== t.z
          ? t.z - e.z
          : e.id - t.id;
      }
      function Rs(e) {
        const t = [];
        let n = 0;
        const i = [],
          r = [],
          a = [],
          o = { id: -1 };
        function s(i, r, a, s, l, c) {
          let u = t[n];
          const h = e.get(a);
          return (
            void 0 === u
              ? ((u = {
                  id: i.id,
                  object: i,
                  geometry: r,
                  material: a,
                  program: h.program || o,
                  groupOrder: s,
                  renderOrder: i.renderOrder,
                  z: l,
                  group: c,
                }),
                (t[n] = u))
              : ((u.id = i.id),
                (u.object = i),
                (u.geometry = r),
                (u.material = a),
                (u.program = h.program || o),
                (u.groupOrder = s),
                (u.renderOrder = i.renderOrder),
                (u.z = l),
                (u.group = c)),
            n++,
            u
          );
        }
        return {
          opaque: i,
          transmissive: r,
          transparent: a,
          init: function () {
            (n = 0), (i.length = 0), (r.length = 0), (a.length = 0);
          },
          push: function (e, t, n, o, l, c) {
            const u = s(e, t, n, o, l, c);
            n.transmission > 0
              ? r.push(u)
              : !0 === n.transparent
              ? a.push(u)
              : i.push(u);
          },
          unshift: function (e, t, n, o, l, c) {
            const u = s(e, t, n, o, l, c);
            n.transmission > 0
              ? r.unshift(u)
              : !0 === n.transparent
              ? a.unshift(u)
              : i.unshift(u);
          },
          finish: function () {
            for (let e = n, i = t.length; e < i; e++) {
              const n = t[e];
              if (null === n.id) break;
              (n.id = null),
                (n.object = null),
                (n.geometry = null),
                (n.material = null),
                (n.program = null),
                (n.group = null);
            }
          },
          sort: function (e, t) {
            i.length > 1 && i.sort(e || Ls),
              r.length > 1 && r.sort(t || Ps),
              a.length > 1 && a.sort(t || Ps);
          },
        };
      }
      function Cs(e) {
        let t = new WeakMap();
        return {
          get: function (n, i) {
            let r;
            return (
              !1 === t.has(n)
                ? ((r = new Rs(e)), t.set(n, [r]))
                : i >= t.get(n).length
                ? ((r = new Rs(e)), t.get(n).push(r))
                : (r = t.get(n)[i]),
              r
            );
          },
          dispose: function () {
            t = new WeakMap();
          },
        };
      }
      function Is() {
        const e = {};
        return {
          get: function (t) {
            if (void 0 !== e[t.id]) return e[t.id];
            let n;
            switch (t.type) {
              case "DirectionalLight":
                n = { direction: new zn(), color: new sr() };
                break;
              case "SpotLight":
                n = {
                  position: new zn(),
                  direction: new zn(),
                  color: new sr(),
                  distance: 0,
                  coneCos: 0,
                  penumbraCos: 0,
                  decay: 0,
                };
                break;
              case "PointLight":
                n = {
                  position: new zn(),
                  color: new sr(),
                  distance: 0,
                  decay: 0,
                };
                break;
              case "HemisphereLight":
                n = {
                  direction: new zn(),
                  skyColor: new sr(),
                  groundColor: new sr(),
                };
                break;
              case "RectAreaLight":
                n = {
                  color: new sr(),
                  position: new zn(),
                  halfWidth: new zn(),
                  halfHeight: new zn(),
                };
            }
            return (e[t.id] = n), n;
          },
        };
      }
      let Ns = 0;
      function Ds(e, t) {
        return (t.castShadow ? 1 : 0) - (e.castShadow ? 1 : 0);
      }
      function Os(e, t) {
        const n = new Is(),
          i = (function () {
            const e = {};
            return {
              get: function (t) {
                if (void 0 !== e[t.id]) return e[t.id];
                let n;
                switch (t.type) {
                  case "DirectionalLight":
                  case "SpotLight":
                    n = {
                      shadowBias: 0,
                      shadowNormalBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new Ln(),
                    };
                    break;
                  case "PointLight":
                    n = {
                      shadowBias: 0,
                      shadowNormalBias: 0,
                      shadowRadius: 1,
                      shadowMapSize: new Ln(),
                      shadowCameraNear: 1,
                      shadowCameraFar: 1e3,
                    };
                }
                return (e[t.id] = n), n;
              },
            };
          })(),
          r = {
            version: 0,
            hash: {
              directionalLength: -1,
              pointLength: -1,
              spotLength: -1,
              rectAreaLength: -1,
              hemiLength: -1,
              numDirectionalShadows: -1,
              numPointShadows: -1,
              numSpotShadows: -1,
            },
            ambient: [0, 0, 0],
            probe: [],
            directional: [],
            directionalShadow: [],
            directionalShadowMap: [],
            directionalShadowMatrix: [],
            spot: [],
            spotShadow: [],
            spotShadowMap: [],
            spotShadowMatrix: [],
            rectArea: [],
            rectAreaLTC1: null,
            rectAreaLTC2: null,
            point: [],
            pointShadow: [],
            pointShadowMap: [],
            pointShadowMatrix: [],
            hemi: [],
          };
        for (let e = 0; e < 9; e++) r.probe.push(new zn());
        const a = new zn(),
          o = new gi(),
          s = new gi();
        return {
          setup: function (a, o) {
            let s = 0,
              l = 0,
              c = 0;
            for (let e = 0; e < 9; e++) r.probe[e].set(0, 0, 0);
            let u = 0,
              h = 0,
              d = 0,
              p = 0,
              m = 0,
              f = 0,
              g = 0,
              v = 0;
            a.sort(Ds);
            const y = !0 !== o ? Math.PI : 1;
            for (let e = 0, t = a.length; e < t; e++) {
              const t = a[e],
                o = t.color,
                x = t.intensity,
                b = t.distance,
                _ = t.shadow && t.shadow.map ? t.shadow.map.texture : null;
              if (t.isAmbientLight)
                (s += o.r * x * y), (l += o.g * x * y), (c += o.b * x * y);
              else if (t.isLightProbe)
                for (let e = 0; e < 9; e++)
                  r.probe[e].addScaledVector(t.sh.coefficients[e], x);
              else if (t.isDirectionalLight) {
                const e = n.get(t);
                if (
                  (e.color.copy(t.color).multiplyScalar(t.intensity * y),
                  t.castShadow)
                ) {
                  const e = t.shadow,
                    n = i.get(t);
                  (n.shadowBias = e.bias),
                    (n.shadowNormalBias = e.normalBias),
                    (n.shadowRadius = e.radius),
                    (n.shadowMapSize = e.mapSize),
                    (r.directionalShadow[u] = n),
                    (r.directionalShadowMap[u] = _),
                    (r.directionalShadowMatrix[u] = t.shadow.matrix),
                    f++;
                }
                (r.directional[u] = e), u++;
              } else if (t.isSpotLight) {
                const e = n.get(t);
                if (
                  (e.position.setFromMatrixPosition(t.matrixWorld),
                  e.color.copy(o).multiplyScalar(x * y),
                  (e.distance = b),
                  (e.coneCos = Math.cos(t.angle)),
                  (e.penumbraCos = Math.cos(t.angle * (1 - t.penumbra))),
                  (e.decay = t.decay),
                  t.castShadow)
                ) {
                  const e = t.shadow,
                    n = i.get(t);
                  (n.shadowBias = e.bias),
                    (n.shadowNormalBias = e.normalBias),
                    (n.shadowRadius = e.radius),
                    (n.shadowMapSize = e.mapSize),
                    (r.spotShadow[d] = n),
                    (r.spotShadowMap[d] = _),
                    (r.spotShadowMatrix[d] = t.shadow.matrix),
                    v++;
                }
                (r.spot[d] = e), d++;
              } else if (t.isRectAreaLight) {
                const e = n.get(t);
                e.color.copy(o).multiplyScalar(x),
                  e.halfWidth.set(0.5 * t.width, 0, 0),
                  e.halfHeight.set(0, 0.5 * t.height, 0),
                  (r.rectArea[p] = e),
                  p++;
              } else if (t.isPointLight) {
                const e = n.get(t);
                if (
                  (e.color.copy(t.color).multiplyScalar(t.intensity * y),
                  (e.distance = t.distance),
                  (e.decay = t.decay),
                  t.castShadow)
                ) {
                  const e = t.shadow,
                    n = i.get(t);
                  (n.shadowBias = e.bias),
                    (n.shadowNormalBias = e.normalBias),
                    (n.shadowRadius = e.radius),
                    (n.shadowMapSize = e.mapSize),
                    (n.shadowCameraNear = e.camera.near),
                    (n.shadowCameraFar = e.camera.far),
                    (r.pointShadow[h] = n),
                    (r.pointShadowMap[h] = _),
                    (r.pointShadowMatrix[h] = t.shadow.matrix),
                    g++;
                }
                (r.point[h] = e), h++;
              } else if (t.isHemisphereLight) {
                const e = n.get(t);
                e.skyColor.copy(t.color).multiplyScalar(x * y),
                  e.groundColor.copy(t.groundColor).multiplyScalar(x * y),
                  (r.hemi[m] = e),
                  m++;
              }
            }
            p > 0 &&
              (t.isWebGL2 || !0 === e.has("OES_texture_float_linear")
                ? ((r.rectAreaLTC1 = ha.LTC_FLOAT_1),
                  (r.rectAreaLTC2 = ha.LTC_FLOAT_2))
                : !0 === e.has("OES_texture_half_float_linear")
                ? ((r.rectAreaLTC1 = ha.LTC_HALF_1),
                  (r.rectAreaLTC2 = ha.LTC_HALF_2))
                : console.error(
                    "THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions."
                  )),
              (r.ambient[0] = s),
              (r.ambient[1] = l),
              (r.ambient[2] = c);
            const x = r.hash;
            (x.directionalLength === u &&
              x.pointLength === h &&
              x.spotLength === d &&
              x.rectAreaLength === p &&
              x.hemiLength === m &&
              x.numDirectionalShadows === f &&
              x.numPointShadows === g &&
              x.numSpotShadows === v) ||
              ((r.directional.length = u),
              (r.spot.length = d),
              (r.rectArea.length = p),
              (r.point.length = h),
              (r.hemi.length = m),
              (r.directionalShadow.length = f),
              (r.directionalShadowMap.length = f),
              (r.pointShadow.length = g),
              (r.pointShadowMap.length = g),
              (r.spotShadow.length = v),
              (r.spotShadowMap.length = v),
              (r.directionalShadowMatrix.length = f),
              (r.pointShadowMatrix.length = g),
              (r.spotShadowMatrix.length = v),
              (x.directionalLength = u),
              (x.pointLength = h),
              (x.spotLength = d),
              (x.rectAreaLength = p),
              (x.hemiLength = m),
              (x.numDirectionalShadows = f),
              (x.numPointShadows = g),
              (x.numSpotShadows = v),
              (r.version = Ns++));
          },
          setupView: function (e, t) {
            let n = 0,
              i = 0,
              l = 0,
              c = 0,
              u = 0;
            const h = t.matrixWorldInverse;
            for (let t = 0, d = e.length; t < d; t++) {
              const d = e[t];
              if (d.isDirectionalLight) {
                const e = r.directional[n];
                e.direction.setFromMatrixPosition(d.matrixWorld),
                  a.setFromMatrixPosition(d.target.matrixWorld),
                  e.direction.sub(a),
                  e.direction.transformDirection(h),
                  n++;
              } else if (d.isSpotLight) {
                const e = r.spot[l];
                e.position.setFromMatrixPosition(d.matrixWorld),
                  e.position.applyMatrix4(h),
                  e.direction.setFromMatrixPosition(d.matrixWorld),
                  a.setFromMatrixPosition(d.target.matrixWorld),
                  e.direction.sub(a),
                  e.direction.transformDirection(h),
                  l++;
              } else if (d.isRectAreaLight) {
                const e = r.rectArea[c];
                e.position.setFromMatrixPosition(d.matrixWorld),
                  e.position.applyMatrix4(h),
                  s.identity(),
                  o.copy(d.matrixWorld),
                  o.premultiply(h),
                  s.extractRotation(o),
                  e.halfWidth.set(0.5 * d.width, 0, 0),
                  e.halfHeight.set(0, 0.5 * d.height, 0),
                  e.halfWidth.applyMatrix4(s),
                  e.halfHeight.applyMatrix4(s),
                  c++;
              } else if (d.isPointLight) {
                const e = r.point[i];
                e.position.setFromMatrixPosition(d.matrixWorld),
                  e.position.applyMatrix4(h),
                  i++;
              } else if (d.isHemisphereLight) {
                const e = r.hemi[u];
                e.direction.setFromMatrixPosition(d.matrixWorld),
                  e.direction.transformDirection(h),
                  e.direction.normalize(),
                  u++;
              }
            }
          },
          state: r,
        };
      }
      function Fs(e, t) {
        const n = new Os(e, t),
          i = [],
          r = [];
        return {
          init: function () {
            (i.length = 0), (r.length = 0);
          },
          state: { lightsArray: i, shadowsArray: r, lights: n },
          setupLights: function (e) {
            n.setup(i, e);
          },
          setupLightsView: function (e) {
            n.setupView(i, e);
          },
          pushLight: function (e) {
            i.push(e);
          },
          pushShadow: function (e) {
            r.push(e);
          },
        };
      }
      function ks(e, t) {
        let n = new WeakMap();
        return {
          get: function (i, r = 0) {
            let a;
            return (
              !1 === n.has(i)
                ? ((a = new Fs(e, t)), n.set(i, [a]))
                : r >= n.get(i).length
                ? ((a = new Fs(e, t)), n.get(i).push(a))
                : (a = n.get(i)[r]),
              a
            );
          },
          dispose: function () {
            n = new WeakMap();
          },
        };
      }
      class Hs extends er {
        constructor(e) {
          super(),
            (this.type = "MeshDepthMaterial"),
            (this.depthPacking = 3200),
            (this.map = null),
            (this.alphaMap = null),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.fog = !1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.depthPacking = e.depthPacking),
            (this.map = e.map),
            (this.alphaMap = e.alphaMap),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            this
          );
        }
      }
      Hs.prototype.isMeshDepthMaterial = !0;
      class zs extends er {
        constructor(e) {
          super(),
            (this.type = "MeshDistanceMaterial"),
            (this.referencePosition = new zn()),
            (this.nearDistance = 1),
            (this.farDistance = 1e3),
            (this.map = null),
            (this.alphaMap = null),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.fog = !1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.referencePosition.copy(e.referencePosition),
            (this.nearDistance = e.nearDistance),
            (this.farDistance = e.farDistance),
            (this.map = e.map),
            (this.alphaMap = e.alphaMap),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            this
          );
        }
      }
      zs.prototype.isMeshDistanceMaterial = !0;
      var Us =
          "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nuniform float samples;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}",
        Bs = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
      function Gs(e, t, n) {
        let i = new oa();
        const r = new Ln(),
          a = new Ln(),
          o = new On(),
          s = new Hs({ depthPacking: ln }),
          l = new zs(),
          c = {},
          u = n.maxTextureSize,
          h = { 0: C, 1: R, 2: I },
          d = new qr({
            uniforms: {
              shadow_pass: { value: null },
              resolution: { value: new Ln() },
              radius: { value: 4 },
              samples: { value: 8 },
            },
            vertexShader: Bs,
            fragmentShader: Us,
          }),
          p = d.clone();
        p.defines.HORIZONTAL_PASS = 1;
        const m = new Mr();
        m.setAttribute(
          "position",
          new hr(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3)
        );
        const f = new Br(m, d),
          g = this;
        function v(n, i) {
          const r = t.update(f);
          (d.uniforms.shadow_pass.value = n.map.texture),
            (d.uniforms.resolution.value = n.mapSize),
            (d.uniforms.radius.value = n.radius),
            (d.uniforms.samples.value = n.blurSamples),
            e.setRenderTarget(n.mapPass),
            e.clear(),
            e.renderBufferDirect(i, null, r, d, f, null),
            (p.uniforms.shadow_pass.value = n.mapPass.texture),
            (p.uniforms.resolution.value = n.mapSize),
            (p.uniforms.radius.value = n.radius),
            (p.uniforms.samples.value = n.blurSamples),
            e.setRenderTarget(n.map),
            e.clear(),
            e.renderBufferDirect(i, null, r, p, f, null);
        }
        function y(t, n, i, r, a, o, u) {
          let d = null;
          const p =
            !0 === r.isPointLight
              ? t.customDistanceMaterial
              : t.customDepthMaterial;
          if (
            ((d = void 0 !== p ? p : !0 === r.isPointLight ? l : s),
            (e.localClippingEnabled &&
              !0 === i.clipShadows &&
              0 !== i.clippingPlanes.length) ||
              (i.displacementMap && 0 !== i.displacementScale) ||
              (i.alphaMap && i.alphaTest > 0))
          ) {
            const e = d.uuid,
              t = i.uuid;
            let n = c[e];
            void 0 === n && ((n = {}), (c[e] = n));
            let r = n[t];
            void 0 === r && ((r = d.clone()), (n[t] = r)), (d = r);
          }
          return (
            (d.visible = i.visible),
            (d.wireframe = i.wireframe),
            (d.side =
              u === P
                ? null !== i.shadowSide
                  ? i.shadowSide
                  : i.side
                : null !== i.shadowSide
                ? i.shadowSide
                : h[i.side]),
            (d.alphaMap = i.alphaMap),
            (d.alphaTest = i.alphaTest),
            (d.clipShadows = i.clipShadows),
            (d.clippingPlanes = i.clippingPlanes),
            (d.clipIntersection = i.clipIntersection),
            (d.displacementMap = i.displacementMap),
            (d.displacementScale = i.displacementScale),
            (d.displacementBias = i.displacementBias),
            (d.wireframeLinewidth = i.wireframeLinewidth),
            (d.linewidth = i.linewidth),
            !0 === r.isPointLight &&
              !0 === d.isMeshDistanceMaterial &&
              (d.referencePosition.setFromMatrixPosition(r.matrixWorld),
              (d.nearDistance = a),
              (d.farDistance = o)),
            d
          );
        }
        function x(n, r, a, o, s) {
          if (!1 === n.visible) return;
          if (
            n.layers.test(r.layers) &&
            (n.isMesh || n.isLine || n.isPoints) &&
            (n.castShadow || (n.receiveShadow && s === P)) &&
            (!n.frustumCulled || i.intersectsObject(n))
          ) {
            n.modelViewMatrix.multiplyMatrices(
              a.matrixWorldInverse,
              n.matrixWorld
            );
            const i = t.update(n),
              r = n.material;
            if (Array.isArray(r)) {
              const t = i.groups;
              for (let l = 0, c = t.length; l < c; l++) {
                const c = t[l],
                  u = r[c.materialIndex];
                if (u && u.visible) {
                  const t = y(n, 0, u, o, a.near, a.far, s);
                  e.renderBufferDirect(a, null, i, t, n, c);
                }
              }
            } else if (r.visible) {
              const t = y(n, 0, r, o, a.near, a.far, s);
              e.renderBufferDirect(a, null, i, t, n, null);
            }
          }
          const l = n.children;
          for (let e = 0, t = l.length; e < t; e++) x(l[e], r, a, o, s);
        }
        (this.enabled = !1),
          (this.autoUpdate = !0),
          (this.needsUpdate = !1),
          (this.type = A),
          (this.render = function (t, n, s) {
            if (!1 === g.enabled) return;
            if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
            if (0 === t.length) return;
            const l = e.getRenderTarget(),
              c = e.getActiveCubeFace(),
              h = e.getActiveMipmapLevel(),
              d = e.state;
            d.setBlending(N),
              d.buffers.color.setClear(1, 1, 1, 1),
              d.buffers.depth.setTest(!0),
              d.setScissorTest(!1);
            for (let l = 0, c = t.length; l < c; l++) {
              const c = t[l],
                h = c.shadow;
              if (void 0 === h) {
                console.warn("THREE.WebGLShadowMap:", c, "has no shadow.");
                continue;
              }
              if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
              r.copy(h.mapSize);
              const p = h.getFrameExtents();
              if (
                (r.multiply(p),
                a.copy(h.mapSize),
                (r.x > u || r.y > u) &&
                  (r.x > u &&
                    ((a.x = Math.floor(u / p.x)),
                    (r.x = a.x * p.x),
                    (h.mapSize.x = a.x)),
                  r.y > u &&
                    ((a.y = Math.floor(u / p.y)),
                    (r.y = a.y * p.y),
                    (h.mapSize.y = a.y))),
                null === h.map && !h.isPointLightShadow && this.type === P)
              ) {
                const e = { minFilter: Re, magFilter: Re, format: qe };
                (h.map = new Fn(r.x, r.y, e)),
                  (h.map.texture.name = c.name + ".shadowMap"),
                  (h.mapPass = new Fn(r.x, r.y, e)),
                  h.camera.updateProjectionMatrix();
              }
              if (null === h.map) {
                const e = { minFilter: Ae, magFilter: Ae, format: qe };
                (h.map = new Fn(r.x, r.y, e)),
                  (h.map.texture.name = c.name + ".shadowMap"),
                  h.camera.updateProjectionMatrix();
              }
              e.setRenderTarget(h.map), e.clear();
              const m = h.getViewportCount();
              for (let e = 0; e < m; e++) {
                const t = h.getViewport(e);
                o.set(a.x * t.x, a.y * t.y, a.x * t.z, a.y * t.w),
                  d.viewport(o),
                  h.updateMatrices(c, e),
                  (i = h.getFrustum()),
                  x(n, s, h.camera, c, this.type);
              }
              h.isPointLightShadow || this.type !== P || v(h, s),
                (h.needsUpdate = !1);
            }
            (g.needsUpdate = !1), e.setRenderTarget(l, c, h);
          });
      }
      function Vs(e, t, n) {
        const i = n.isWebGL2;
        const r = new (function () {
            let t = !1;
            const n = new On();
            let i = null;
            const r = new On(0, 0, 0, 0);
            return {
              setMask: function (n) {
                i === n || t || (e.colorMask(n, n, n, n), (i = n));
              },
              setLocked: function (e) {
                t = e;
              },
              setClear: function (t, i, a, o, s) {
                !0 === s && ((t *= o), (i *= o), (a *= o)),
                  n.set(t, i, a, o),
                  !1 === r.equals(n) && (e.clearColor(t, i, a, o), r.copy(n));
              },
              reset: function () {
                (t = !1), (i = null), r.set(-1, 0, 0, 0);
              },
            };
          })(),
          a = new (function () {
            let t = !1,
              n = null,
              i = null,
              r = null;
            return {
              setTest: function (e) {
                e ? ye(2929) : xe(2929);
              },
              setMask: function (i) {
                n === i || t || (e.depthMask(i), (n = i));
              },
              setFunc: function (t) {
                if (i !== t) {
                  if (t)
                    switch (t) {
                      case te:
                        e.depthFunc(512);
                        break;
                      case ne:
                        e.depthFunc(519);
                        break;
                      case ie:
                        e.depthFunc(513);
                        break;
                      case re:
                        e.depthFunc(515);
                        break;
                      case ae:
                        e.depthFunc(514);
                        break;
                      case oe:
                        e.depthFunc(518);
                        break;
                      case se:
                        e.depthFunc(516);
                        break;
                      case le:
                        e.depthFunc(517);
                        break;
                      default:
                        e.depthFunc(515);
                    }
                  else e.depthFunc(515);
                  i = t;
                }
              },
              setLocked: function (e) {
                t = e;
              },
              setClear: function (t) {
                r !== t && (e.clearDepth(t), (r = t));
              },
              reset: function () {
                (t = !1), (n = null), (i = null), (r = null);
              },
            };
          })(),
          o = new (function () {
            let t = !1,
              n = null,
              i = null,
              r = null,
              a = null,
              o = null,
              s = null,
              l = null,
              c = null;
            return {
              setTest: function (e) {
                t || (e ? ye(2960) : xe(2960));
              },
              setMask: function (i) {
                n === i || t || (e.stencilMask(i), (n = i));
              },
              setFunc: function (t, n, o) {
                (i === t && r === n && a === o) ||
                  (e.stencilFunc(t, n, o), (i = t), (r = n), (a = o));
              },
              setOp: function (t, n, i) {
                (o === t && s === n && l === i) ||
                  (e.stencilOp(t, n, i), (o = t), (s = n), (l = i));
              },
              setLocked: function (e) {
                t = e;
              },
              setClear: function (t) {
                c !== t && (e.clearStencil(t), (c = t));
              },
              reset: function () {
                (t = !1),
                  (n = null),
                  (i = null),
                  (r = null),
                  (a = null),
                  (o = null),
                  (s = null),
                  (l = null),
                  (c = null);
              },
            };
          })();
        let s = {},
          l = null,
          c = {},
          u = null,
          h = !1,
          d = null,
          p = null,
          m = null,
          f = null,
          g = null,
          v = null,
          y = null,
          x = !1,
          b = null,
          _ = null,
          w = null,
          M = null,
          A = null;
        const L = e.getParameter(35661);
        let P = !1,
          R = 0;
        const ce = e.getParameter(7938);
        -1 !== ce.indexOf("WebGL")
          ? ((R = parseFloat(/^WebGL (\d)/.exec(ce)[1])), (P = R >= 1))
          : -1 !== ce.indexOf("OpenGL ES") &&
            ((R = parseFloat(/^OpenGL ES (\d)/.exec(ce)[1])), (P = R >= 2));
        let ue = null,
          he = {};
        const de = e.getParameter(3088),
          pe = e.getParameter(2978),
          me = new On().fromArray(de),
          fe = new On().fromArray(pe);
        function ge(t, n, i) {
          const r = new Uint8Array(4),
            a = e.createTexture();
          e.bindTexture(t, a),
            e.texParameteri(t, 10241, 9728),
            e.texParameteri(t, 10240, 9728);
          for (let t = 0; t < i; t++)
            e.texImage2D(n + t, 0, 6408, 1, 1, 0, 6408, 5121, r);
          return a;
        }
        const ve = {};
        function ye(t) {
          !0 !== s[t] && (e.enable(t), (s[t] = !0));
        }
        function xe(t) {
          !1 !== s[t] && (e.disable(t), (s[t] = !1));
        }
        (ve[3553] = ge(3553, 3553, 1)),
          (ve[34067] = ge(34067, 34069, 6)),
          r.setClear(0, 0, 0, 1),
          a.setClear(1),
          o.setClear(0),
          ye(2929),
          a.setFunc(re),
          Me(!1),
          Se(T),
          ye(2884),
          we(N);
        const be = { [z]: 32774, [U]: 32778, [B]: 32779 };
        if (i) (be[G] = 32775), (be[V] = 32776);
        else {
          const e = t.get("EXT_blend_minmax");
          null !== e && ((be[G] = e.MIN_EXT), (be[V] = e.MAX_EXT));
        }
        const _e = {
          [W]: 0,
          [j]: 1,
          [X]: 768,
          [Y]: 770,
          [ee]: 776,
          [Q]: 774,
          [Z]: 772,
          [q]: 769,
          [K]: 771,
          [$]: 775,
          [J]: 773,
        };
        function we(t, n, i, r, a, o, s, l) {
          if (t !== N) {
            if ((!1 === h && (ye(3042), (h = !0)), t === H))
              (a = a || n),
                (o = o || i),
                (s = s || r),
                (n === p && a === g) ||
                  (e.blendEquationSeparate(be[n], be[a]), (p = n), (g = a)),
                (i === m && r === f && o === v && s === y) ||
                  (e.blendFuncSeparate(_e[i], _e[r], _e[o], _e[s]),
                  (m = i),
                  (f = r),
                  (v = o),
                  (y = s)),
                (d = t),
                (x = null);
            else if (t !== d || l !== x) {
              if (
                ((p === z && g === z) ||
                  (e.blendEquation(32774), (p = z), (g = z)),
                l)
              )
                switch (t) {
                  case D:
                    e.blendFuncSeparate(1, 771, 1, 771);
                    break;
                  case O:
                    e.blendFunc(1, 1);
                    break;
                  case F:
                    e.blendFuncSeparate(0, 0, 769, 771);
                    break;
                  case k:
                    e.blendFuncSeparate(0, 768, 0, 770);
                    break;
                  default:
                    console.error("THREE.WebGLState: Invalid blending: ", t);
                }
              else
                switch (t) {
                  case D:
                    e.blendFuncSeparate(770, 771, 1, 771);
                    break;
                  case O:
                    e.blendFunc(770, 1);
                    break;
                  case F:
                    e.blendFunc(0, 769);
                    break;
                  case k:
                    e.blendFunc(0, 768);
                    break;
                  default:
                    console.error("THREE.WebGLState: Invalid blending: ", t);
                }
              (m = null), (f = null), (v = null), (y = null), (d = t), (x = l);
            }
          } else !0 === h && (xe(3042), (h = !1));
        }
        function Me(t) {
          b !== t && (t ? e.frontFace(2304) : e.frontFace(2305), (b = t));
        }
        function Se(t) {
          t !== S
            ? (ye(2884),
              t !== _ &&
                (t === T
                  ? e.cullFace(1029)
                  : t === E
                  ? e.cullFace(1028)
                  : e.cullFace(1032)))
            : xe(2884),
            (_ = t);
        }
        function Te(t, n, i) {
          t
            ? (ye(32823),
              (M === n && A === i) || (e.polygonOffset(n, i), (M = n), (A = i)))
            : xe(32823);
        }
        function Ee(t) {
          void 0 === t && (t = 33984 + L - 1),
            ue !== t && (e.activeTexture(t), (ue = t));
        }
        return {
          buffers: { color: r, depth: a, stencil: o },
          enable: ye,
          disable: xe,
          bindFramebuffer: function (t, n) {
            return (
              null === n && null !== l && (n = l),
              c[t] !== n &&
                (e.bindFramebuffer(t, n),
                (c[t] = n),
                i &&
                  (36009 === t && (c[36160] = n),
                  36160 === t && (c[36009] = n)),
                !0)
            );
          },
          bindXRFramebuffer: function (t) {
            t !== l && (e.bindFramebuffer(36160, t), (l = t));
          },
          useProgram: function (t) {
            return u !== t && (e.useProgram(t), (u = t), !0);
          },
          setBlending: we,
          setMaterial: function (e, t) {
            e.side === I ? xe(2884) : ye(2884);
            let n = e.side === C;
            t && (n = !n),
              Me(n),
              e.blending === D && !1 === e.transparent
                ? we(N)
                : we(
                    e.blending,
                    e.blendEquation,
                    e.blendSrc,
                    e.blendDst,
                    e.blendEquationAlpha,
                    e.blendSrcAlpha,
                    e.blendDstAlpha,
                    e.premultipliedAlpha
                  ),
              a.setFunc(e.depthFunc),
              a.setTest(e.depthTest),
              a.setMask(e.depthWrite),
              r.setMask(e.colorWrite);
            const i = e.stencilWrite;
            o.setTest(i),
              i &&
                (o.setMask(e.stencilWriteMask),
                o.setFunc(e.stencilFunc, e.stencilRef, e.stencilFuncMask),
                o.setOp(e.stencilFail, e.stencilZFail, e.stencilZPass)),
              Te(e.polygonOffset, e.polygonOffsetFactor, e.polygonOffsetUnits),
              !0 === e.alphaToCoverage ? ye(32926) : xe(32926);
          },
          setFlipSided: Me,
          setCullFace: Se,
          setLineWidth: function (t) {
            t !== w && (P && e.lineWidth(t), (w = t));
          },
          setPolygonOffset: Te,
          setScissorTest: function (e) {
            e ? ye(3089) : xe(3089);
          },
          activeTexture: Ee,
          bindTexture: function (t, n) {
            null === ue && Ee();
            let i = he[ue];
            void 0 === i &&
              ((i = { type: void 0, texture: void 0 }), (he[ue] = i)),
              (i.type === t && i.texture === n) ||
                (e.bindTexture(t, n || ve[t]), (i.type = t), (i.texture = n));
          },
          unbindTexture: function () {
            const t = he[ue];
            void 0 !== t &&
              void 0 !== t.type &&
              (e.bindTexture(t.type, null),
              (t.type = void 0),
              (t.texture = void 0));
          },
          compressedTexImage2D: function () {
            try {
              e.compressedTexImage2D.apply(e, arguments);
            } catch (e) {
              console.error("THREE.WebGLState:", e);
            }
          },
          texImage2D: function () {
            try {
              e.texImage2D.apply(e, arguments);
            } catch (e) {
              console.error("THREE.WebGLState:", e);
            }
          },
          texImage3D: function () {
            try {
              e.texImage3D.apply(e, arguments);
            } catch (e) {
              console.error("THREE.WebGLState:", e);
            }
          },
          scissor: function (t) {
            !1 === me.equals(t) && (e.scissor(t.x, t.y, t.z, t.w), me.copy(t));
          },
          viewport: function (t) {
            !1 === fe.equals(t) && (e.viewport(t.x, t.y, t.z, t.w), fe.copy(t));
          },
          reset: function () {
            e.disable(3042),
              e.disable(2884),
              e.disable(2929),
              e.disable(32823),
              e.disable(3089),
              e.disable(2960),
              e.disable(32926),
              e.blendEquation(32774),
              e.blendFunc(1, 0),
              e.blendFuncSeparate(1, 0, 1, 0),
              e.colorMask(!0, !0, !0, !0),
              e.clearColor(0, 0, 0, 0),
              e.depthMask(!0),
              e.depthFunc(513),
              e.clearDepth(1),
              e.stencilMask(4294967295),
              e.stencilFunc(519, 0, 4294967295),
              e.stencilOp(7680, 7680, 7680),
              e.clearStencil(0),
              e.cullFace(1029),
              e.frontFace(2305),
              e.polygonOffset(0, 0),
              e.activeTexture(33984),
              e.bindFramebuffer(36160, null),
              !0 === i &&
                (e.bindFramebuffer(36009, null),
                e.bindFramebuffer(36008, null)),
              e.useProgram(null),
              e.lineWidth(1),
              e.scissor(0, 0, e.canvas.width, e.canvas.height),
              e.viewport(0, 0, e.canvas.width, e.canvas.height),
              (s = {}),
              (ue = null),
              (he = {}),
              (l = null),
              (c = {}),
              (u = null),
              (h = !1),
              (d = null),
              (p = null),
              (m = null),
              (f = null),
              (g = null),
              (v = null),
              (y = null),
              (x = !1),
              (b = null),
              (_ = null),
              (w = null),
              (M = null),
              (A = null),
              me.set(0, 0, e.canvas.width, e.canvas.height),
              fe.set(0, 0, e.canvas.width, e.canvas.height),
              r.reset(),
              a.reset(),
              o.reset();
          },
        };
      }
      function Ws(e, t, n, i, r, a, o) {
        const s = r.isWebGL2,
          l = r.maxTextures,
          c = r.maxCubemapSize,
          u = r.maxTextureSize,
          h = r.maxSamples,
          d = new WeakMap();
        let p,
          m = !1;
        try {
          m =
            "undefined" != typeof OffscreenCanvas &&
            null !== new OffscreenCanvas(1, 1).getContext("2d");
        } catch (e) {}
        function f(e, t) {
          return m
            ? new OffscreenCanvas(e, t)
            : document.createElementNS(
                "http://www.w3.org/1999/xhtml",
                "canvas"
              );
        }
        function g(e, t, n, i) {
          let r = 1;
          if (
            ((e.width > i || e.height > i) &&
              (r = i / Math.max(e.width, e.height)),
            r < 1 || !0 === t)
          ) {
            if (
              ("undefined" != typeof HTMLImageElement &&
                e instanceof HTMLImageElement) ||
              ("undefined" != typeof HTMLCanvasElement &&
                e instanceof HTMLCanvasElement) ||
              ("undefined" != typeof ImageBitmap && e instanceof ImageBitmap)
            ) {
              const i = t ? En : Math.floor,
                a = i(r * e.width),
                o = i(r * e.height);
              void 0 === p && (p = f(a, o));
              const s = n ? f(a, o) : p;
              (s.width = a), (s.height = o);
              return (
                s.getContext("2d").drawImage(e, 0, 0, a, o),
                console.warn(
                  "THREE.WebGLRenderer: Texture has been resized from (" +
                    e.width +
                    "x" +
                    e.height +
                    ") to (" +
                    a +
                    "x" +
                    o +
                    ")."
                ),
                s
              );
            }
            return (
              "data" in e &&
                console.warn(
                  "THREE.WebGLRenderer: Image in DataTexture is too big (" +
                    e.width +
                    "x" +
                    e.height +
                    ")."
                ),
              e
            );
          }
          return e;
        }
        function v(e) {
          return Sn(e.width) && Sn(e.height);
        }
        function y(e, t) {
          return (
            e.generateMipmaps && t && e.minFilter !== Ae && e.minFilter !== Re
          );
        }
        function x(t, n, r, a, o = 1) {
          e.generateMipmap(t);
          i.get(n).__maxMipLevel = Math.log2(Math.max(r, a, o));
        }
        function b(n, i, r) {
          if (!1 === s) return i;
          if (null !== n) {
            if (void 0 !== e[n]) return e[n];
            console.warn(
              "THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" +
                n +
                "'"
            );
          }
          let a = i;
          return (
            6403 === i &&
              (5126 === r && (a = 33326),
              5131 === r && (a = 33325),
              5121 === r && (a = 33321)),
            6407 === i &&
              (5126 === r && (a = 34837),
              5131 === r && (a = 34843),
              5121 === r && (a = 32849)),
            6408 === i &&
              (5126 === r && (a = 34836),
              5131 === r && (a = 34842),
              5121 === r && (a = 32856)),
            (33325 !== a && 33326 !== a && 34842 !== a && 34836 !== a) ||
              t.get("EXT_color_buffer_float"),
            a
          );
        }
        function _(e) {
          return e === Ae || e === Le || e === Pe ? 9728 : 9729;
        }
        function w(t) {
          const n = t.target;
          n.removeEventListener("dispose", w),
            (function (t) {
              const n = i.get(t);
              if (void 0 === n.__webglInit) return;
              e.deleteTexture(n.__webglTexture), i.remove(t);
            })(n),
            n.isVideoTexture && d.delete(n),
            o.memory.textures--;
        }
        function M(t) {
          const n = t.target;
          n.removeEventListener("dispose", M),
            (function (t) {
              const n = t.texture,
                r = i.get(t),
                a = i.get(n);
              if (!t) return;
              void 0 !== a.__webglTexture &&
                (e.deleteTexture(a.__webglTexture), o.memory.textures--);
              t.depthTexture && t.depthTexture.dispose();
              if (t.isWebGLCubeRenderTarget)
                for (let t = 0; t < 6; t++)
                  e.deleteFramebuffer(r.__webglFramebuffer[t]),
                    r.__webglDepthbuffer &&
                      e.deleteRenderbuffer(r.__webglDepthbuffer[t]);
              else
                e.deleteFramebuffer(r.__webglFramebuffer),
                  r.__webglDepthbuffer &&
                    e.deleteRenderbuffer(r.__webglDepthbuffer),
                  r.__webglMultisampledFramebuffer &&
                    e.deleteFramebuffer(r.__webglMultisampledFramebuffer),
                  r.__webglColorRenderbuffer &&
                    e.deleteRenderbuffer(r.__webglColorRenderbuffer),
                  r.__webglDepthRenderbuffer &&
                    e.deleteRenderbuffer(r.__webglDepthRenderbuffer);
              if (t.isWebGLMultipleRenderTargets)
                for (let t = 0, r = n.length; t < r; t++) {
                  const r = i.get(n[t]);
                  r.__webglTexture &&
                    (e.deleteTexture(r.__webglTexture), o.memory.textures--),
                    i.remove(n[t]);
                }
              i.remove(n), i.remove(t);
            })(n);
        }
        let S = 0;
        function T(e, t) {
          const r = i.get(e);
          if (
            (e.isVideoTexture &&
              (function (e) {
                const t = o.render.frame;
                d.get(e) !== t && (d.set(e, t), e.update());
              })(e),
            e.version > 0 && r.__version !== e.version)
          ) {
            const n = e.image;
            if (void 0 === n)
              console.warn(
                "THREE.WebGLRenderer: Texture marked for update but image is undefined"
              );
            else {
              if (!1 !== n.complete) return void C(r, e, t);
              console.warn(
                "THREE.WebGLRenderer: Texture marked for update but image is incomplete"
              );
            }
          }
          n.activeTexture(33984 + t), n.bindTexture(3553, r.__webglTexture);
        }
        function E(t, r) {
          const o = i.get(t);
          t.version > 0 && o.__version !== t.version
            ? (function (t, i, r) {
                if (6 !== i.image.length) return;
                R(t, i),
                  n.activeTexture(33984 + r),
                  n.bindTexture(34067, t.__webglTexture),
                  e.pixelStorei(37440, i.flipY),
                  e.pixelStorei(37441, i.premultiplyAlpha),
                  e.pixelStorei(3317, i.unpackAlignment),
                  e.pixelStorei(37443, 0);
                const o =
                    i &&
                    (i.isCompressedTexture || i.image[0].isCompressedTexture),
                  l = i.image[0] && i.image[0].isDataTexture,
                  u = [];
                for (let e = 0; e < 6; e++)
                  u[e] =
                    o || l
                      ? l
                        ? i.image[e].image
                        : i.image[e]
                      : g(i.image[e], !1, !0, c);
                const h = u[0],
                  d = v(h) || s,
                  p = a.convert(i.format),
                  m = a.convert(i.type),
                  f = b(i.internalFormat, p, m);
                let _;
                if ((P(34067, i, d), o)) {
                  for (let e = 0; e < 6; e++) {
                    _ = u[e].mipmaps;
                    for (let t = 0; t < _.length; t++) {
                      const r = _[t];
                      i.format !== qe && i.format !== Xe
                        ? null !== p
                          ? n.compressedTexImage2D(
                              34069 + e,
                              t,
                              f,
                              r.width,
                              r.height,
                              0,
                              r.data
                            )
                          : console.warn(
                              "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()"
                            )
                        : n.texImage2D(
                            34069 + e,
                            t,
                            f,
                            r.width,
                            r.height,
                            0,
                            p,
                            m,
                            r.data
                          );
                    }
                  }
                  t.__maxMipLevel = _.length - 1;
                } else {
                  _ = i.mipmaps;
                  for (let e = 0; e < 6; e++)
                    if (l) {
                      n.texImage2D(
                        34069 + e,
                        0,
                        f,
                        u[e].width,
                        u[e].height,
                        0,
                        p,
                        m,
                        u[e].data
                      );
                      for (let t = 0; t < _.length; t++) {
                        const i = _[t].image[e].image;
                        n.texImage2D(
                          34069 + e,
                          t + 1,
                          f,
                          i.width,
                          i.height,
                          0,
                          p,
                          m,
                          i.data
                        );
                      }
                    } else {
                      n.texImage2D(34069 + e, 0, f, p, m, u[e]);
                      for (let t = 0; t < _.length; t++) {
                        const i = _[t];
                        n.texImage2D(34069 + e, t + 1, f, p, m, i.image[e]);
                      }
                    }
                  t.__maxMipLevel = _.length;
                }
                y(i, d) && x(34067, i, h.width, h.height);
                (t.__version = i.version), i.onUpdate && i.onUpdate(i);
              })(o, t, r)
            : (n.activeTexture(33984 + r),
              n.bindTexture(34067, o.__webglTexture));
        }
        const A = { [Se]: 10497, [Te]: 33071, [Ee]: 33648 },
          L = {
            [Ae]: 9728,
            [Le]: 9984,
            [Pe]: 9986,
            [Re]: 9729,
            [Ce]: 9985,
            [Ie]: 9987,
          };
        function P(n, a, o) {
          if (
            (o
              ? (e.texParameteri(n, 10242, A[a.wrapS]),
                e.texParameteri(n, 10243, A[a.wrapT]),
                (32879 !== n && 35866 !== n) ||
                  e.texParameteri(n, 32882, A[a.wrapR]),
                e.texParameteri(n, 10240, L[a.magFilter]),
                e.texParameteri(n, 10241, L[a.minFilter]))
              : (e.texParameteri(n, 10242, 33071),
                e.texParameteri(n, 10243, 33071),
                (32879 !== n && 35866 !== n) ||
                  e.texParameteri(n, 32882, 33071),
                (a.wrapS === Te && a.wrapT === Te) ||
                  console.warn(
                    "THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."
                  ),
                e.texParameteri(n, 10240, _(a.magFilter)),
                e.texParameteri(n, 10241, _(a.minFilter)),
                a.minFilter !== Ae &&
                  a.minFilter !== Re &&
                  console.warn(
                    "THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter."
                  )),
            !0 === t.has("EXT_texture_filter_anisotropic"))
          ) {
            const o = t.get("EXT_texture_filter_anisotropic");
            if (a.type === ze && !1 === t.has("OES_texture_float_linear"))
              return;
            if (
              !1 === s &&
              a.type === Ue &&
              !1 === t.has("OES_texture_half_float_linear")
            )
              return;
            (a.anisotropy > 1 || i.get(a).__currentAnisotropy) &&
              (e.texParameterf(
                n,
                o.TEXTURE_MAX_ANISOTROPY_EXT,
                Math.min(a.anisotropy, r.getMaxAnisotropy())
              ),
              (i.get(a).__currentAnisotropy = a.anisotropy));
          }
        }
        function R(t, n) {
          void 0 === t.__webglInit &&
            ((t.__webglInit = !0),
            n.addEventListener("dispose", w),
            (t.__webglTexture = e.createTexture()),
            o.memory.textures++);
        }
        function C(t, i, r) {
          let o = 3553;
          i.isDataTexture2DArray && (o = 35866),
            i.isDataTexture3D && (o = 32879),
            R(t, i),
            n.activeTexture(33984 + r),
            n.bindTexture(o, t.__webglTexture),
            e.pixelStorei(37440, i.flipY),
            e.pixelStorei(37441, i.premultiplyAlpha),
            e.pixelStorei(3317, i.unpackAlignment),
            e.pixelStorei(37443, 0);
          const l =
              (function (e) {
                return (
                  !s &&
                  (e.wrapS !== Te ||
                    e.wrapT !== Te ||
                    (e.minFilter !== Ae && e.minFilter !== Re))
                );
              })(i) && !1 === v(i.image),
            c = g(i.image, l, !1, u),
            h = v(c) || s,
            d = a.convert(i.format);
          let p,
            m = a.convert(i.type),
            f = b(i.internalFormat, d, m);
          P(o, i, h);
          const _ = i.mipmaps;
          if (i.isDepthTexture)
            (f = 6402),
              s
                ? (f =
                    i.type === ze
                      ? 36012
                      : i.type === He
                      ? 33190
                      : i.type === We
                      ? 35056
                      : 33189)
                : i.type === ze &&
                  console.error(
                    "WebGLRenderer: Floating point depth texture requires WebGL2."
                  ),
              i.format === Je &&
                6402 === f &&
                i.type !== Fe &&
                i.type !== He &&
                (console.warn(
                  "THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."
                ),
                (i.type = Fe),
                (m = a.convert(i.type))),
              i.format === Qe &&
                6402 === f &&
                ((f = 34041),
                i.type !== We &&
                  (console.warn(
                    "THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."
                  ),
                  (i.type = We),
                  (m = a.convert(i.type)))),
              n.texImage2D(3553, 0, f, c.width, c.height, 0, d, m, null);
          else if (i.isDataTexture)
            if (_.length > 0 && h) {
              for (let e = 0, t = _.length; e < t; e++)
                (p = _[e]),
                  n.texImage2D(3553, e, f, p.width, p.height, 0, d, m, p.data);
              (i.generateMipmaps = !1), (t.__maxMipLevel = _.length - 1);
            } else
              n.texImage2D(3553, 0, f, c.width, c.height, 0, d, m, c.data),
                (t.__maxMipLevel = 0);
          else if (i.isCompressedTexture) {
            for (let e = 0, t = _.length; e < t; e++)
              (p = _[e]),
                i.format !== qe && i.format !== Xe
                  ? null !== d
                    ? n.compressedTexImage2D(
                        3553,
                        e,
                        f,
                        p.width,
                        p.height,
                        0,
                        p.data
                      )
                    : console.warn(
                        "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"
                      )
                  : n.texImage2D(
                      3553,
                      e,
                      f,
                      p.width,
                      p.height,
                      0,
                      d,
                      m,
                      p.data
                    );
            t.__maxMipLevel = _.length - 1;
          } else if (i.isDataTexture2DArray)
            n.texImage3D(
              35866,
              0,
              f,
              c.width,
              c.height,
              c.depth,
              0,
              d,
              m,
              c.data
            ),
              (t.__maxMipLevel = 0);
          else if (i.isDataTexture3D)
            n.texImage3D(
              32879,
              0,
              f,
              c.width,
              c.height,
              c.depth,
              0,
              d,
              m,
              c.data
            ),
              (t.__maxMipLevel = 0);
          else if (_.length > 0 && h) {
            for (let e = 0, t = _.length; e < t; e++)
              (p = _[e]), n.texImage2D(3553, e, f, d, m, p);
            (i.generateMipmaps = !1), (t.__maxMipLevel = _.length - 1);
          } else n.texImage2D(3553, 0, f, d, m, c), (t.__maxMipLevel = 0);
          y(i, h) && x(o, i, c.width, c.height),
            (t.__version = i.version),
            i.onUpdate && i.onUpdate(i);
        }
        function I(t, r, o, s, l) {
          const c = a.convert(o.format),
            u = a.convert(o.type),
            h = b(o.internalFormat, c, u);
          32879 === l || 35866 === l
            ? n.texImage3D(l, 0, h, r.width, r.height, r.depth, 0, c, u, null)
            : n.texImage2D(l, 0, h, r.width, r.height, 0, c, u, null),
            n.bindFramebuffer(36160, t),
            e.framebufferTexture2D(36160, s, l, i.get(o).__webglTexture, 0),
            n.bindFramebuffer(36160, null);
        }
        function N(t, n, i) {
          if (
            (e.bindRenderbuffer(36161, t), n.depthBuffer && !n.stencilBuffer)
          ) {
            let r = 33189;
            if (i) {
              const t = n.depthTexture;
              t &&
                t.isDepthTexture &&
                (t.type === ze ? (r = 36012) : t.type === He && (r = 33190));
              const i = O(n);
              e.renderbufferStorageMultisample(36161, i, r, n.width, n.height);
            } else e.renderbufferStorage(36161, r, n.width, n.height);
            e.framebufferRenderbuffer(36160, 36096, 36161, t);
          } else if (n.depthBuffer && n.stencilBuffer) {
            if (i) {
              const t = O(n);
              e.renderbufferStorageMultisample(
                36161,
                t,
                35056,
                n.width,
                n.height
              );
            } else e.renderbufferStorage(36161, 34041, n.width, n.height);
            e.framebufferRenderbuffer(36160, 33306, 36161, t);
          } else {
            const t =
                !0 === n.isWebGLMultipleRenderTargets
                  ? n.texture[0]
                  : n.texture,
              r = a.convert(t.format),
              o = a.convert(t.type),
              s = b(t.internalFormat, r, o);
            if (i) {
              const t = O(n);
              e.renderbufferStorageMultisample(36161, t, s, n.width, n.height);
            } else e.renderbufferStorage(36161, s, n.width, n.height);
          }
          e.bindRenderbuffer(36161, null);
        }
        function D(t) {
          const r = i.get(t),
            a = !0 === t.isWebGLCubeRenderTarget;
          if (t.depthTexture) {
            if (a)
              throw new Error(
                "target.depthTexture not supported in Cube render targets"
              );
            !(function (t, r) {
              if (r && r.isWebGLCubeRenderTarget)
                throw new Error(
                  "Depth Texture with cube render targets is not supported"
                );
              if (
                (n.bindFramebuffer(36160, t),
                !r.depthTexture || !r.depthTexture.isDepthTexture)
              )
                throw new Error(
                  "renderTarget.depthTexture must be an instance of THREE.DepthTexture"
                );
              (i.get(r.depthTexture).__webglTexture &&
                r.depthTexture.image.width === r.width &&
                r.depthTexture.image.height === r.height) ||
                ((r.depthTexture.image.width = r.width),
                (r.depthTexture.image.height = r.height),
                (r.depthTexture.needsUpdate = !0)),
                T(r.depthTexture, 0);
              const a = i.get(r.depthTexture).__webglTexture;
              if (r.depthTexture.format === Je)
                e.framebufferTexture2D(36160, 36096, 3553, a, 0);
              else {
                if (r.depthTexture.format !== Qe)
                  throw new Error("Unknown depthTexture format");
                e.framebufferTexture2D(36160, 33306, 3553, a, 0);
              }
            })(r.__webglFramebuffer, t);
          } else if (a) {
            r.__webglDepthbuffer = [];
            for (let i = 0; i < 6; i++)
              n.bindFramebuffer(36160, r.__webglFramebuffer[i]),
                (r.__webglDepthbuffer[i] = e.createRenderbuffer()),
                N(r.__webglDepthbuffer[i], t, !1);
          } else
            n.bindFramebuffer(36160, r.__webglFramebuffer),
              (r.__webglDepthbuffer = e.createRenderbuffer()),
              N(r.__webglDepthbuffer, t, !1);
          n.bindFramebuffer(36160, null);
        }
        function O(e) {
          return s && e.isWebGLMultisampleRenderTarget
            ? Math.min(h, e.samples)
            : 0;
        }
        let F = !1,
          k = !1;
        (this.allocateTextureUnit = function () {
          const e = S;
          return (
            e >= l &&
              console.warn(
                "THREE.WebGLTextures: Trying to use " +
                  e +
                  " texture units while this GPU supports only " +
                  l
              ),
            (S += 1),
            e
          );
        }),
          (this.resetTextureUnits = function () {
            S = 0;
          }),
          (this.setTexture2D = T),
          (this.setTexture2DArray = function (e, t) {
            const r = i.get(e);
            e.version > 0 && r.__version !== e.version
              ? C(r, e, t)
              : (n.activeTexture(33984 + t),
                n.bindTexture(35866, r.__webglTexture));
          }),
          (this.setTexture3D = function (e, t) {
            const r = i.get(e);
            e.version > 0 && r.__version !== e.version
              ? C(r, e, t)
              : (n.activeTexture(33984 + t),
                n.bindTexture(32879, r.__webglTexture));
          }),
          (this.setTextureCube = E),
          (this.setupRenderTarget = function (t) {
            const l = t.texture,
              c = i.get(t),
              u = i.get(l);
            t.addEventListener("dispose", M),
              !0 !== t.isWebGLMultipleRenderTargets &&
                ((u.__webglTexture = e.createTexture()),
                (u.__version = l.version),
                o.memory.textures++);
            const h = !0 === t.isWebGLCubeRenderTarget,
              d = !0 === t.isWebGLMultipleRenderTargets,
              p = !0 === t.isWebGLMultisampleRenderTarget,
              m = l.isDataTexture3D || l.isDataTexture2DArray,
              f = v(t) || s;
            if (
              (!s ||
                l.format !== Xe ||
                (l.type !== ze && l.type !== Ue) ||
                ((l.format = qe),
                console.warn(
                  "THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead."
                )),
              h)
            ) {
              c.__webglFramebuffer = [];
              for (let t = 0; t < 6; t++)
                c.__webglFramebuffer[t] = e.createFramebuffer();
            } else if (((c.__webglFramebuffer = e.createFramebuffer()), d))
              if (r.drawBuffers) {
                const n = t.texture;
                for (let t = 0, r = n.length; t < r; t++) {
                  const r = i.get(n[t]);
                  void 0 === r.__webglTexture &&
                    ((r.__webglTexture = e.createTexture()),
                    o.memory.textures++);
                }
              } else
                console.warn(
                  "THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension."
                );
            else if (p)
              if (s) {
                (c.__webglMultisampledFramebuffer = e.createFramebuffer()),
                  (c.__webglColorRenderbuffer = e.createRenderbuffer()),
                  e.bindRenderbuffer(36161, c.__webglColorRenderbuffer);
                const i = a.convert(l.format),
                  r = a.convert(l.type),
                  o = b(l.internalFormat, i, r),
                  s = O(t);
                e.renderbufferStorageMultisample(
                  36161,
                  s,
                  o,
                  t.width,
                  t.height
                ),
                  n.bindFramebuffer(36160, c.__webglMultisampledFramebuffer),
                  e.framebufferRenderbuffer(
                    36160,
                    36064,
                    36161,
                    c.__webglColorRenderbuffer
                  ),
                  e.bindRenderbuffer(36161, null),
                  t.depthBuffer &&
                    ((c.__webglDepthRenderbuffer = e.createRenderbuffer()),
                    N(c.__webglDepthRenderbuffer, t, !0)),
                  n.bindFramebuffer(36160, null);
              } else
                console.warn(
                  "THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2."
                );
            if (h) {
              n.bindTexture(34067, u.__webglTexture), P(34067, l, f);
              for (let e = 0; e < 6; e++)
                I(c.__webglFramebuffer[e], t, l, 36064, 34069 + e);
              y(l, f) && x(34067, l, t.width, t.height), n.unbindTexture();
            } else if (d) {
              const e = t.texture;
              for (let r = 0, a = e.length; r < a; r++) {
                const a = e[r],
                  o = i.get(a);
                n.bindTexture(3553, o.__webglTexture),
                  P(3553, a, f),
                  I(c.__webglFramebuffer, t, a, 36064 + r, 3553),
                  y(a, f) && x(3553, a, t.width, t.height);
              }
              n.unbindTexture();
            } else {
              let e = 3553;
              if (m)
                if (s) {
                  e = l.isDataTexture3D ? 32879 : 35866;
                } else
                  console.warn(
                    "THREE.DataTexture3D and THREE.DataTexture2DArray only supported with WebGL2."
                  );
              n.bindTexture(e, u.__webglTexture),
                P(e, l, f),
                I(c.__webglFramebuffer, t, l, 36064, e),
                y(l, f) && x(e, l, t.width, t.height, t.depth),
                n.unbindTexture();
            }
            t.depthBuffer && D(t);
          }),
          (this.updateRenderTargetMipmap = function (e) {
            const t = v(e) || s,
              r =
                !0 === e.isWebGLMultipleRenderTargets ? e.texture : [e.texture];
            for (let a = 0, o = r.length; a < o; a++) {
              const o = r[a];
              if (y(o, t)) {
                const t = e.isWebGLCubeRenderTarget ? 34067 : 3553,
                  r = i.get(o).__webglTexture;
                n.bindTexture(t, r),
                  x(t, o, e.width, e.height),
                  n.unbindTexture();
              }
            }
          }),
          (this.updateMultisampleRenderTarget = function (t) {
            if (t.isWebGLMultisampleRenderTarget)
              if (s) {
                const r = t.width,
                  a = t.height;
                let o = 16384;
                t.depthBuffer && (o |= 256), t.stencilBuffer && (o |= 1024);
                const s = i.get(t);
                n.bindFramebuffer(36008, s.__webglMultisampledFramebuffer),
                  n.bindFramebuffer(36009, s.__webglFramebuffer),
                  e.blitFramebuffer(0, 0, r, a, 0, 0, r, a, o, 9728),
                  n.bindFramebuffer(36008, null),
                  n.bindFramebuffer(36009, s.__webglMultisampledFramebuffer);
              } else
                console.warn(
                  "THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2."
                );
          }),
          (this.safeSetTexture2D = function (e, t) {
            e &&
              e.isWebGLRenderTarget &&
              (!1 === F &&
                (console.warn(
                  "THREE.WebGLTextures.safeSetTexture2D: don't use render targets as textures. Use their .texture property instead."
                ),
                (F = !0)),
              (e = e.texture)),
              T(e, t);
          }),
          (this.safeSetTextureCube = function (e, t) {
            e &&
              e.isWebGLCubeRenderTarget &&
              (!1 === k &&
                (console.warn(
                  "THREE.WebGLTextures.safeSetTextureCube: don't use cube render targets as textures. Use their .texture property instead."
                ),
                (k = !0)),
              (e = e.texture)),
              E(e, t);
          });
      }
      function js(e, t, n) {
        const i = n.isWebGL2;
        return {
          convert: function (e) {
            let n;
            if (e === Ne) return 5121;
            if (e === Be) return 32819;
            if (e === Ge) return 32820;
            if (e === Ve) return 33635;
            if (e === De) return 5120;
            if (e === Oe) return 5122;
            if (e === Fe) return 5123;
            if (e === ke) return 5124;
            if (e === He) return 5125;
            if (e === ze) return 5126;
            if (e === Ue)
              return i
                ? 5131
                : ((n = t.get("OES_texture_half_float")),
                  null !== n ? n.HALF_FLOAT_OES : null);
            if (e === je) return 6406;
            if (e === Xe) return 6407;
            if (e === qe) return 6408;
            if (e === Ye) return 6409;
            if (e === Ke) return 6410;
            if (e === Je) return 6402;
            if (e === Qe) return 34041;
            if (e === $e) return 6403;
            if (e === et) return 36244;
            if (e === tt) return 33319;
            if (e === nt) return 33320;
            if (e === it) return 36248;
            if (e === rt) return 36249;
            if (e === at || e === ot || e === st || e === lt) {
              if (((n = t.get("WEBGL_compressed_texture_s3tc")), null === n))
                return null;
              if (e === at) return n.COMPRESSED_RGB_S3TC_DXT1_EXT;
              if (e === ot) return n.COMPRESSED_RGBA_S3TC_DXT1_EXT;
              if (e === st) return n.COMPRESSED_RGBA_S3TC_DXT3_EXT;
              if (e === lt) return n.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            }
            if (e === ct || e === ut || e === ht || e === dt) {
              if (((n = t.get("WEBGL_compressed_texture_pvrtc")), null === n))
                return null;
              if (e === ct) return n.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
              if (e === ut) return n.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
              if (e === ht) return n.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
              if (e === dt) return n.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            }
            if (e === pt)
              return (
                (n = t.get("WEBGL_compressed_texture_etc1")),
                null !== n ? n.COMPRESSED_RGB_ETC1_WEBGL : null
              );
            if (
              (e === mt || e === ft) &&
              ((n = t.get("WEBGL_compressed_texture_etc")), null !== n)
            ) {
              if (e === mt) return n.COMPRESSED_RGB8_ETC2;
              if (e === ft) return n.COMPRESSED_RGBA8_ETC2_EAC;
            }
            return e === gt ||
              e === vt ||
              e === yt ||
              e === xt ||
              e === bt ||
              e === _t ||
              e === wt ||
              e === Mt ||
              e === St ||
              e === Tt ||
              e === Et ||
              e === At ||
              e === Lt ||
              e === Pt ||
              e === Ct ||
              e === It ||
              e === Nt ||
              e === Dt ||
              e === Ot ||
              e === Ft ||
              e === kt ||
              e === Ht ||
              e === zt ||
              e === Ut ||
              e === Bt ||
              e === Gt ||
              e === Vt ||
              e === Wt
              ? ((n = t.get("WEBGL_compressed_texture_astc")),
                null !== n ? e : null)
              : e === Rt
              ? ((n = t.get("EXT_texture_compression_bptc")),
                null !== n ? e : null)
              : e === We
              ? i
                ? 34042
                : ((n = t.get("WEBGL_depth_texture")),
                  null !== n ? n.UNSIGNED_INT_24_8_WEBGL : null)
              : void 0;
          },
        };
      }
      class Xs extends Kr {
        constructor(e = []) {
          super(), (this.cameras = e);
        }
      }
      Xs.prototype.isArrayCamera = !0;
      class qs extends Bi {
        constructor() {
          super(), (this.type = "Group");
        }
      }
      qs.prototype.isGroup = !0;
      const Ys = { type: "move" };
      class Ks {
        constructor() {
          (this._targetRay = null), (this._grip = null), (this._hand = null);
        }
        getHandSpace() {
          return (
            null === this._hand &&
              ((this._hand = new qs()),
              (this._hand.matrixAutoUpdate = !1),
              (this._hand.visible = !1),
              (this._hand.joints = {}),
              (this._hand.inputState = { pinching: !1 })),
            this._hand
          );
        }
        getTargetRaySpace() {
          return (
            null === this._targetRay &&
              ((this._targetRay = new qs()),
              (this._targetRay.matrixAutoUpdate = !1),
              (this._targetRay.visible = !1),
              (this._targetRay.hasLinearVelocity = !1),
              (this._targetRay.linearVelocity = new zn()),
              (this._targetRay.hasAngularVelocity = !1),
              (this._targetRay.angularVelocity = new zn())),
            this._targetRay
          );
        }
        getGripSpace() {
          return (
            null === this._grip &&
              ((this._grip = new qs()),
              (this._grip.matrixAutoUpdate = !1),
              (this._grip.visible = !1),
              (this._grip.hasLinearVelocity = !1),
              (this._grip.linearVelocity = new zn()),
              (this._grip.hasAngularVelocity = !1),
              (this._grip.angularVelocity = new zn())),
            this._grip
          );
        }
        dispatchEvent(e) {
          return (
            null !== this._targetRay && this._targetRay.dispatchEvent(e),
            null !== this._grip && this._grip.dispatchEvent(e),
            null !== this._hand && this._hand.dispatchEvent(e),
            this
          );
        }
        disconnect(e) {
          return (
            this.dispatchEvent({ type: "disconnected", data: e }),
            null !== this._targetRay && (this._targetRay.visible = !1),
            null !== this._grip && (this._grip.visible = !1),
            null !== this._hand && (this._hand.visible = !1),
            this
          );
        }
        update(e, t, n) {
          let i = null,
            r = null,
            a = null;
          const o = this._targetRay,
            s = this._grip,
            l = this._hand;
          if (e && "visible-blurred" !== t.session.visibilityState)
            if (
              (null !== o &&
                ((i = t.getPose(e.targetRaySpace, n)),
                null !== i &&
                  (o.matrix.fromArray(i.transform.matrix),
                  o.matrix.decompose(o.position, o.rotation, o.scale),
                  i.linearVelocity
                    ? ((o.hasLinearVelocity = !0),
                      o.linearVelocity.copy(i.linearVelocity))
                    : (o.hasLinearVelocity = !1),
                  i.angularVelocity
                    ? ((o.hasAngularVelocity = !0),
                      o.angularVelocity.copy(i.angularVelocity))
                    : (o.hasAngularVelocity = !1),
                  this.dispatchEvent(Ys))),
              l && e.hand)
            ) {
              a = !0;
              for (const i of e.hand.values()) {
                const e = t.getJointPose(i, n);
                if (void 0 === l.joints[i.jointName]) {
                  const e = new qs();
                  (e.matrixAutoUpdate = !1),
                    (e.visible = !1),
                    (l.joints[i.jointName] = e),
                    l.add(e);
                }
                const r = l.joints[i.jointName];
                null !== e &&
                  (r.matrix.fromArray(e.transform.matrix),
                  r.matrix.decompose(r.position, r.rotation, r.scale),
                  (r.jointRadius = e.radius)),
                  (r.visible = null !== e);
              }
              const i = l.joints["index-finger-tip"],
                r = l.joints["thumb-tip"],
                o = i.position.distanceTo(r.position),
                s = 0.02,
                c = 0.005;
              l.inputState.pinching && o > s + c
                ? ((l.inputState.pinching = !1),
                  this.dispatchEvent({
                    type: "pinchend",
                    handedness: e.handedness,
                    target: this,
                  }))
                : !l.inputState.pinching &&
                  o <= s - c &&
                  ((l.inputState.pinching = !0),
                  this.dispatchEvent({
                    type: "pinchstart",
                    handedness: e.handedness,
                    target: this,
                  }));
            } else
              null !== s &&
                e.gripSpace &&
                ((r = t.getPose(e.gripSpace, n)),
                null !== r &&
                  (s.matrix.fromArray(r.transform.matrix),
                  s.matrix.decompose(s.position, s.rotation, s.scale),
                  r.linearVelocity
                    ? ((s.hasLinearVelocity = !0),
                      s.linearVelocity.copy(r.linearVelocity))
                    : (s.hasLinearVelocity = !1),
                  r.angularVelocity
                    ? ((s.hasAngularVelocity = !0),
                      s.angularVelocity.copy(r.angularVelocity))
                    : (s.hasAngularVelocity = !1)));
          return (
            null !== o && (o.visible = null !== i),
            null !== s && (s.visible = null !== r),
            null !== l && (l.visible = null !== a),
            this
          );
        }
      }
      class Zs extends fn {
        constructor(e, t) {
          super();
          const n = this,
            i = e.state;
          let r = null,
            a = 1,
            o = null,
            s = "local-floor",
            l = null,
            c = null,
            u = null,
            h = null,
            d = null,
            p = !1,
            m = null,
            f = null,
            g = null,
            v = null,
            y = null,
            x = null;
          const b = [],
            _ = new Map(),
            w = new Kr();
          w.layers.enable(1), (w.viewport = new On());
          const M = new Kr();
          M.layers.enable(2), (M.viewport = new On());
          const S = [w, M],
            T = new Xs();
          T.layers.enable(1), T.layers.enable(2);
          let E = null,
            A = null;
          function L(e) {
            const t = _.get(e.inputSource);
            t && t.dispatchEvent({ type: e.type, data: e.inputSource });
          }
          function P() {
            _.forEach(function (e, t) {
              e.disconnect(t);
            }),
              _.clear(),
              (E = null),
              (A = null),
              i.bindXRFramebuffer(null),
              e.setRenderTarget(e.getRenderTarget()),
              u && t.deleteFramebuffer(u),
              m && t.deleteFramebuffer(m),
              f && t.deleteRenderbuffer(f),
              g && t.deleteRenderbuffer(g),
              (u = null),
              (m = null),
              (f = null),
              (g = null),
              (d = null),
              (h = null),
              (c = null),
              (r = null),
              O.stop(),
              (n.isPresenting = !1),
              n.dispatchEvent({ type: "sessionend" });
          }
          function R(e) {
            const t = r.inputSources;
            for (let e = 0; e < b.length; e++) _.set(t[e], b[e]);
            for (let t = 0; t < e.removed.length; t++) {
              const n = e.removed[t],
                i = _.get(n);
              i &&
                (i.dispatchEvent({ type: "disconnected", data: n }),
                _.delete(n));
            }
            for (let t = 0; t < e.added.length; t++) {
              const n = e.added[t],
                i = _.get(n);
              i && i.dispatchEvent({ type: "connected", data: n });
            }
          }
          (this.cameraAutoUpdate = !0),
            (this.enabled = !1),
            (this.isPresenting = !1),
            (this.getController = function (e) {
              let t = b[e];
              return (
                void 0 === t && ((t = new Ks()), (b[e] = t)),
                t.getTargetRaySpace()
              );
            }),
            (this.getControllerGrip = function (e) {
              let t = b[e];
              return (
                void 0 === t && ((t = new Ks()), (b[e] = t)), t.getGripSpace()
              );
            }),
            (this.getHand = function (e) {
              let t = b[e];
              return (
                void 0 === t && ((t = new Ks()), (b[e] = t)), t.getHandSpace()
              );
            }),
            (this.setFramebufferScaleFactor = function (e) {
              (a = e),
                !0 === n.isPresenting &&
                  console.warn(
                    "THREE.WebXRManager: Cannot change framebuffer scale while presenting."
                  );
            }),
            (this.setReferenceSpaceType = function (e) {
              (s = e),
                !0 === n.isPresenting &&
                  console.warn(
                    "THREE.WebXRManager: Cannot change reference space type while presenting."
                  );
            }),
            (this.getReferenceSpace = function () {
              return o;
            }),
            (this.getBaseLayer = function () {
              return null !== h ? h : d;
            }),
            (this.getBinding = function () {
              return c;
            }),
            (this.getFrame = function () {
              return v;
            }),
            (this.getSession = function () {
              return r;
            }),
            (this.setSession = async function (e) {
              if (((r = e), null !== r)) {
                r.addEventListener("select", L),
                  r.addEventListener("selectstart", L),
                  r.addEventListener("selectend", L),
                  r.addEventListener("squeeze", L),
                  r.addEventListener("squeezestart", L),
                  r.addEventListener("squeezeend", L),
                  r.addEventListener("end", P),
                  r.addEventListener("inputsourceschange", R);
                const e = t.getContextAttributes();
                if (
                  (!0 !== e.xrCompatible && (await t.makeXRCompatible()),
                  void 0 === r.renderState.layers)
                ) {
                  const n = {
                    antialias: e.antialias,
                    alpha: e.alpha,
                    depth: e.depth,
                    stencil: e.stencil,
                    framebufferScaleFactor: a,
                  };
                  (d = new XRWebGLLayer(r, t, n)),
                    r.updateRenderState({ baseLayer: d });
                } else if (t instanceof WebGLRenderingContext) {
                  const n = {
                    antialias: !0,
                    alpha: e.alpha,
                    depth: e.depth,
                    stencil: e.stencil,
                    framebufferScaleFactor: a,
                  };
                  (d = new XRWebGLLayer(r, t, n)),
                    r.updateRenderState({ layers: [d] });
                } else {
                  p = e.antialias;
                  let n = null;
                  e.depth &&
                    ((x = 256),
                    e.stencil && (x |= 1024),
                    (y = e.stencil ? 33306 : 36096),
                    (n = e.stencil ? 35056 : 33190));
                  const o = {
                    colorFormat: e.alpha ? 32856 : 32849,
                    depthFormat: n,
                    scaleFactor: a,
                  };
                  (c = new XRWebGLBinding(r, t)),
                    (h = c.createProjectionLayer(o)),
                    (u = t.createFramebuffer()),
                    r.updateRenderState({ layers: [h] }),
                    p &&
                      ((m = t.createFramebuffer()),
                      (f = t.createRenderbuffer()),
                      t.bindRenderbuffer(36161, f),
                      t.renderbufferStorageMultisample(
                        36161,
                        4,
                        32856,
                        h.textureWidth,
                        h.textureHeight
                      ),
                      i.bindFramebuffer(36160, m),
                      t.framebufferRenderbuffer(36160, 36064, 36161, f),
                      t.bindRenderbuffer(36161, null),
                      null !== n &&
                        ((g = t.createRenderbuffer()),
                        t.bindRenderbuffer(36161, g),
                        t.renderbufferStorageMultisample(
                          36161,
                          4,
                          n,
                          h.textureWidth,
                          h.textureHeight
                        ),
                        t.framebufferRenderbuffer(36160, y, 36161, g),
                        t.bindRenderbuffer(36161, null)),
                      i.bindFramebuffer(36160, null));
                }
                (o = await r.requestReferenceSpace(s)),
                  O.setContext(r),
                  O.start(),
                  (n.isPresenting = !0),
                  n.dispatchEvent({ type: "sessionstart" });
              }
            });
          const C = new zn(),
            I = new zn();
          function N(e, t) {
            null === t
              ? e.matrixWorld.copy(e.matrix)
              : e.matrixWorld.multiplyMatrices(t.matrixWorld, e.matrix),
              e.matrixWorldInverse.copy(e.matrixWorld).invert();
          }
          (this.updateCamera = function (e) {
            if (null === r) return;
            (T.near = M.near = w.near = e.near),
              (T.far = M.far = w.far = e.far),
              (E === T.near && A === T.far) ||
                (r.updateRenderState({ depthNear: T.near, depthFar: T.far }),
                (E = T.near),
                (A = T.far));
            const t = e.parent,
              n = T.cameras;
            N(T, t);
            for (let e = 0; e < n.length; e++) N(n[e], t);
            T.matrixWorld.decompose(T.position, T.quaternion, T.scale),
              e.position.copy(T.position),
              e.quaternion.copy(T.quaternion),
              e.scale.copy(T.scale),
              e.matrix.copy(T.matrix),
              e.matrixWorld.copy(T.matrixWorld);
            const i = e.children;
            for (let e = 0, t = i.length; e < t; e++)
              i[e].updateMatrixWorld(!0);
            2 === n.length
              ? (function (e, t, n) {
                  C.setFromMatrixPosition(t.matrixWorld),
                    I.setFromMatrixPosition(n.matrixWorld);
                  const i = C.distanceTo(I),
                    r = t.projectionMatrix.elements,
                    a = n.projectionMatrix.elements,
                    o = r[14] / (r[10] - 1),
                    s = r[14] / (r[10] + 1),
                    l = (r[9] + 1) / r[5],
                    c = (r[9] - 1) / r[5],
                    u = (r[8] - 1) / r[0],
                    h = (a[8] + 1) / a[0],
                    d = o * u,
                    p = o * h,
                    m = i / (-u + h),
                    f = m * -u;
                  t.matrixWorld.decompose(e.position, e.quaternion, e.scale),
                    e.translateX(f),
                    e.translateZ(m),
                    e.matrixWorld.compose(e.position, e.quaternion, e.scale),
                    e.matrixWorldInverse.copy(e.matrixWorld).invert();
                  const g = o + m,
                    v = s + m,
                    y = d - f,
                    x = p + (i - f),
                    b = ((l * s) / v) * g,
                    _ = ((c * s) / v) * g;
                  e.projectionMatrix.makePerspective(y, x, b, _, g, v);
                })(T, w, M)
              : T.projectionMatrix.copy(w.projectionMatrix);
          }),
            (this.getCamera = function () {
              return T;
            }),
            (this.getFoveation = function () {
              return null !== h
                ? h.fixedFoveation
                : null !== d
                ? d.fixedFoveation
                : void 0;
            }),
            (this.setFoveation = function (e) {
              null !== h && (h.fixedFoveation = e),
                null !== d &&
                  void 0 !== d.fixedFoveation &&
                  (d.fixedFoveation = e);
            });
          let D = null;
          const O = new sa();
          O.setAnimationLoop(function (e, n) {
            if (((l = n.getViewerPose(o)), (v = n), null !== l)) {
              const e = l.views;
              null !== d && i.bindXRFramebuffer(d.framebuffer);
              let n = !1;
              e.length !== T.cameras.length &&
                ((T.cameras.length = 0), (n = !0));
              for (let r = 0; r < e.length; r++) {
                const a = e[r];
                let o = null;
                if (null !== d) o = d.getViewport(a);
                else {
                  const e = c.getViewSubImage(h, a);
                  i.bindXRFramebuffer(u),
                    void 0 !== e.depthStencilTexture &&
                      t.framebufferTexture2D(
                        36160,
                        y,
                        3553,
                        e.depthStencilTexture,
                        0
                      ),
                    t.framebufferTexture2D(
                      36160,
                      36064,
                      3553,
                      e.colorTexture,
                      0
                    ),
                    (o = e.viewport);
                }
                const s = S[r];
                s.matrix.fromArray(a.transform.matrix),
                  s.projectionMatrix.fromArray(a.projectionMatrix),
                  s.viewport.set(o.x, o.y, o.width, o.height),
                  0 === r && T.matrix.copy(s.matrix),
                  !0 === n && T.cameras.push(s);
              }
              p && (i.bindXRFramebuffer(m), null !== x && t.clear(x));
            }
            const a = r.inputSources;
            for (let e = 0; e < b.length; e++) {
              const t = b[e],
                i = a[e];
              t.update(i, n, o);
            }
            if ((D && D(e, n), p)) {
              const e = h.textureWidth,
                n = h.textureHeight;
              i.bindFramebuffer(36008, m),
                i.bindFramebuffer(36009, u),
                t.invalidateFramebuffer(36008, [y]),
                t.invalidateFramebuffer(36009, [y]),
                t.blitFramebuffer(0, 0, e, n, 0, 0, e, n, 16384, 9728),
                t.invalidateFramebuffer(36008, [36064]),
                i.bindFramebuffer(36008, null),
                i.bindFramebuffer(36009, null),
                i.bindFramebuffer(36160, m);
            }
            v = null;
          }),
            (this.setAnimationLoop = function (e) {
              D = e;
            }),
            (this.dispose = function () {});
        }
      }
      function Js(e) {
        function t(t, n) {
          (t.opacity.value = n.opacity),
            n.color && t.diffuse.value.copy(n.color),
            n.emissive &&
              t.emissive.value
                .copy(n.emissive)
                .multiplyScalar(n.emissiveIntensity),
            n.map && (t.map.value = n.map),
            n.alphaMap && (t.alphaMap.value = n.alphaMap),
            n.specularMap && (t.specularMap.value = n.specularMap),
            n.alphaTest > 0 && (t.alphaTest.value = n.alphaTest);
          const i = e.get(n).envMap;
          if (i) {
            (t.envMap.value = i),
              (t.flipEnvMap.value =
                i.isCubeTexture && !1 === i.isRenderTargetTexture ? -1 : 1),
              (t.reflectivity.value = n.reflectivity),
              (t.ior.value = n.ior),
              (t.refractionRatio.value = n.refractionRatio);
            const r = e.get(i).__maxMipLevel;
            void 0 !== r && (t.maxMipLevel.value = r);
          }
          let r, a;
          n.lightMap &&
            ((t.lightMap.value = n.lightMap),
            (t.lightMapIntensity.value = n.lightMapIntensity)),
            n.aoMap &&
              ((t.aoMap.value = n.aoMap),
              (t.aoMapIntensity.value = n.aoMapIntensity)),
            n.map
              ? (r = n.map)
              : n.specularMap
              ? (r = n.specularMap)
              : n.displacementMap
              ? (r = n.displacementMap)
              : n.normalMap
              ? (r = n.normalMap)
              : n.bumpMap
              ? (r = n.bumpMap)
              : n.roughnessMap
              ? (r = n.roughnessMap)
              : n.metalnessMap
              ? (r = n.metalnessMap)
              : n.alphaMap
              ? (r = n.alphaMap)
              : n.emissiveMap
              ? (r = n.emissiveMap)
              : n.clearcoatMap
              ? (r = n.clearcoatMap)
              : n.clearcoatNormalMap
              ? (r = n.clearcoatNormalMap)
              : n.clearcoatRoughnessMap
              ? (r = n.clearcoatRoughnessMap)
              : n.specularIntensityMap
              ? (r = n.specularIntensityMap)
              : n.specularTintMap
              ? (r = n.specularTintMap)
              : n.transmissionMap
              ? (r = n.transmissionMap)
              : n.thicknessMap && (r = n.thicknessMap),
            void 0 !== r &&
              (r.isWebGLRenderTarget && (r = r.texture),
              !0 === r.matrixAutoUpdate && r.updateMatrix(),
              t.uvTransform.value.copy(r.matrix)),
            n.aoMap ? (a = n.aoMap) : n.lightMap && (a = n.lightMap),
            void 0 !== a &&
              (a.isWebGLRenderTarget && (a = a.texture),
              !0 === a.matrixAutoUpdate && a.updateMatrix(),
              t.uv2Transform.value.copy(a.matrix));
        }
        function n(t, n) {
          (t.roughness.value = n.roughness),
            (t.metalness.value = n.metalness),
            n.roughnessMap && (t.roughnessMap.value = n.roughnessMap),
            n.metalnessMap && (t.metalnessMap.value = n.metalnessMap),
            n.emissiveMap && (t.emissiveMap.value = n.emissiveMap),
            n.bumpMap &&
              ((t.bumpMap.value = n.bumpMap),
              (t.bumpScale.value = n.bumpScale),
              n.side === C && (t.bumpScale.value *= -1)),
            n.normalMap &&
              ((t.normalMap.value = n.normalMap),
              t.normalScale.value.copy(n.normalScale),
              n.side === C && t.normalScale.value.negate()),
            n.displacementMap &&
              ((t.displacementMap.value = n.displacementMap),
              (t.displacementScale.value = n.displacementScale),
              (t.displacementBias.value = n.displacementBias));
          e.get(n).envMap && (t.envMapIntensity.value = n.envMapIntensity);
        }
        return {
          refreshFogUniforms: function (e, t) {
            e.fogColor.value.copy(t.color),
              t.isFog
                ? ((e.fogNear.value = t.near), (e.fogFar.value = t.far))
                : t.isFogExp2 && (e.fogDensity.value = t.density);
          },
          refreshMaterialUniforms: function (e, i, r, a, o) {
            i.isMeshBasicMaterial
              ? t(e, i)
              : i.isMeshLambertMaterial
              ? (t(e, i),
                (function (e, t) {
                  t.emissiveMap && (e.emissiveMap.value = t.emissiveMap);
                })(e, i))
              : i.isMeshToonMaterial
              ? (t(e, i),
                (function (e, t) {
                  t.gradientMap && (e.gradientMap.value = t.gradientMap);
                  t.emissiveMap && (e.emissiveMap.value = t.emissiveMap);
                  t.bumpMap &&
                    ((e.bumpMap.value = t.bumpMap),
                    (e.bumpScale.value = t.bumpScale),
                    t.side === C && (e.bumpScale.value *= -1));
                  t.normalMap &&
                    ((e.normalMap.value = t.normalMap),
                    e.normalScale.value.copy(t.normalScale),
                    t.side === C && e.normalScale.value.negate());
                  t.displacementMap &&
                    ((e.displacementMap.value = t.displacementMap),
                    (e.displacementScale.value = t.displacementScale),
                    (e.displacementBias.value = t.displacementBias));
                })(e, i))
              : i.isMeshPhongMaterial
              ? (t(e, i),
                (function (e, t) {
                  e.specular.value.copy(t.specular),
                    (e.shininess.value = Math.max(t.shininess, 1e-4)),
                    t.emissiveMap && (e.emissiveMap.value = t.emissiveMap);
                  t.bumpMap &&
                    ((e.bumpMap.value = t.bumpMap),
                    (e.bumpScale.value = t.bumpScale),
                    t.side === C && (e.bumpScale.value *= -1));
                  t.normalMap &&
                    ((e.normalMap.value = t.normalMap),
                    e.normalScale.value.copy(t.normalScale),
                    t.side === C && e.normalScale.value.negate());
                  t.displacementMap &&
                    ((e.displacementMap.value = t.displacementMap),
                    (e.displacementScale.value = t.displacementScale),
                    (e.displacementBias.value = t.displacementBias));
                })(e, i))
              : i.isMeshStandardMaterial
              ? (t(e, i),
                i.isMeshPhysicalMaterial
                  ? (function (e, t, i) {
                      n(e, t),
                        (e.ior.value = t.ior),
                        t.sheenTint && e.sheenTint.value.copy(t.sheenTint);
                      t.clearcoat > 0 &&
                        ((e.clearcoat.value = t.clearcoat),
                        (e.clearcoatRoughness.value = t.clearcoatRoughness),
                        t.clearcoatMap &&
                          (e.clearcoatMap.value = t.clearcoatMap),
                        t.clearcoatRoughnessMap &&
                          (e.clearcoatRoughnessMap.value =
                            t.clearcoatRoughnessMap),
                        t.clearcoatNormalMap &&
                          (e.clearcoatNormalScale.value.copy(
                            t.clearcoatNormalScale
                          ),
                          (e.clearcoatNormalMap.value = t.clearcoatNormalMap),
                          t.side === C &&
                            e.clearcoatNormalScale.value.negate()));
                      t.transmission > 0 &&
                        ((e.transmission.value = t.transmission),
                        (e.transmissionSamplerMap.value = i.texture),
                        e.transmissionSamplerSize.value.set(i.width, i.height),
                        t.transmissionMap &&
                          (e.transmissionMap.value = t.transmissionMap),
                        (e.thickness.value = t.thickness),
                        t.thicknessMap &&
                          (e.thicknessMap.value = t.thicknessMap),
                        (e.attenuationDistance.value = t.attenuationDistance),
                        e.attenuationTint.value.copy(t.attenuationTint));
                      (e.specularIntensity.value = t.specularIntensity),
                        e.specularTint.value.copy(t.specularTint),
                        t.specularIntensityMap &&
                          (e.specularIntensityMap.value =
                            t.specularIntensityMap);
                      t.specularTintMap &&
                        (e.specularTintMap.value = t.specularTintMap);
                    })(e, i, o)
                  : n(e, i))
              : i.isMeshMatcapMaterial
              ? (t(e, i),
                (function (e, t) {
                  t.matcap && (e.matcap.value = t.matcap);
                  t.bumpMap &&
                    ((e.bumpMap.value = t.bumpMap),
                    (e.bumpScale.value = t.bumpScale),
                    t.side === C && (e.bumpScale.value *= -1));
                  t.normalMap &&
                    ((e.normalMap.value = t.normalMap),
                    e.normalScale.value.copy(t.normalScale),
                    t.side === C && e.normalScale.value.negate());
                  t.displacementMap &&
                    ((e.displacementMap.value = t.displacementMap),
                    (e.displacementScale.value = t.displacementScale),
                    (e.displacementBias.value = t.displacementBias));
                })(e, i))
              : i.isMeshDepthMaterial
              ? (t(e, i),
                (function (e, t) {
                  t.displacementMap &&
                    ((e.displacementMap.value = t.displacementMap),
                    (e.displacementScale.value = t.displacementScale),
                    (e.displacementBias.value = t.displacementBias));
                })(e, i))
              : i.isMeshDistanceMaterial
              ? (t(e, i),
                (function (e, t) {
                  t.displacementMap &&
                    ((e.displacementMap.value = t.displacementMap),
                    (e.displacementScale.value = t.displacementScale),
                    (e.displacementBias.value = t.displacementBias));
                  e.referencePosition.value.copy(t.referencePosition),
                    (e.nearDistance.value = t.nearDistance),
                    (e.farDistance.value = t.farDistance);
                })(e, i))
              : i.isMeshNormalMaterial
              ? (t(e, i),
                (function (e, t) {
                  t.bumpMap &&
                    ((e.bumpMap.value = t.bumpMap),
                    (e.bumpScale.value = t.bumpScale),
                    t.side === C && (e.bumpScale.value *= -1));
                  t.normalMap &&
                    ((e.normalMap.value = t.normalMap),
                    e.normalScale.value.copy(t.normalScale),
                    t.side === C && e.normalScale.value.negate());
                  t.displacementMap &&
                    ((e.displacementMap.value = t.displacementMap),
                    (e.displacementScale.value = t.displacementScale),
                    (e.displacementBias.value = t.displacementBias));
                })(e, i))
              : i.isLineBasicMaterial
              ? ((function (e, t) {
                  e.diffuse.value.copy(t.color), (e.opacity.value = t.opacity);
                })(e, i),
                i.isLineDashedMaterial &&
                  (function (e, t) {
                    (e.dashSize.value = t.dashSize),
                      (e.totalSize.value = t.dashSize + t.gapSize),
                      (e.scale.value = t.scale);
                  })(e, i))
              : i.isPointsMaterial
              ? (function (e, t, n, i) {
                  e.diffuse.value.copy(t.color),
                    (e.opacity.value = t.opacity),
                    (e.size.value = t.size * n),
                    (e.scale.value = 0.5 * i),
                    t.map && (e.map.value = t.map);
                  t.alphaMap && (e.alphaMap.value = t.alphaMap);
                  t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
                  let r;
                  t.map ? (r = t.map) : t.alphaMap && (r = t.alphaMap);
                  void 0 !== r &&
                    (!0 === r.matrixAutoUpdate && r.updateMatrix(),
                    e.uvTransform.value.copy(r.matrix));
                })(e, i, r, a)
              : i.isSpriteMaterial
              ? (function (e, t) {
                  e.diffuse.value.copy(t.color),
                    (e.opacity.value = t.opacity),
                    (e.rotation.value = t.rotation),
                    t.map && (e.map.value = t.map);
                  t.alphaMap && (e.alphaMap.value = t.alphaMap);
                  t.alphaTest > 0 && (e.alphaTest.value = t.alphaTest);
                  let n;
                  t.map ? (n = t.map) : t.alphaMap && (n = t.alphaMap);
                  void 0 !== n &&
                    (!0 === n.matrixAutoUpdate && n.updateMatrix(),
                    e.uvTransform.value.copy(n.matrix));
                })(e, i)
              : i.isShadowMaterial
              ? (e.color.value.copy(i.color), (e.opacity.value = i.opacity))
              : i.isShaderMaterial && (i.uniformsNeedUpdate = !1);
          },
        };
      }
      function Qs(e = {}) {
        const t =
            void 0 !== e.canvas
              ? e.canvas
              : (function () {
                  const e = document.createElementNS(
                    "http://www.w3.org/1999/xhtml",
                    "canvas"
                  );
                  return (e.style.display = "block"), e;
                })(),
          n = void 0 !== e.context ? e.context : null,
          i = void 0 !== e.alpha && e.alpha,
          r = void 0 === e.depth || e.depth,
          a = void 0 === e.stencil || e.stencil,
          o = void 0 !== e.antialias && e.antialias,
          s = void 0 === e.premultipliedAlpha || e.premultipliedAlpha,
          l = void 0 !== e.preserveDrawingBuffer && e.preserveDrawingBuffer,
          c = void 0 !== e.powerPreference ? e.powerPreference : "default",
          u =
            void 0 !== e.failIfMajorPerformanceCaveat &&
            e.failIfMajorPerformanceCaveat;
        let h = null,
          d = null;
        const p = [],
          m = [];
        (this.domElement = t),
          (this.debug = { checkShaderErrors: !0 }),
          (this.autoClear = !0),
          (this.autoClearColor = !0),
          (this.autoClearDepth = !0),
          (this.autoClearStencil = !0),
          (this.sortObjects = !0),
          (this.clippingPlanes = []),
          (this.localClippingEnabled = !1),
          (this.gammaFactor = 2),
          (this.outputEncoding = $t),
          (this.physicallyCorrectLights = !1),
          (this.toneMapping = de),
          (this.toneMappingExposure = 1);
        const f = this;
        let g = !1,
          v = 0,
          y = 0,
          x = null,
          b = -1,
          _ = null;
        const w = new On(),
          M = new On();
        let S = null,
          T = t.width,
          E = t.height,
          A = 1,
          L = null,
          P = null;
        const N = new On(0, 0, T, E),
          D = new On(0, 0, T, E);
        let O = !1;
        const F = [],
          k = new oa();
        let H = !1,
          z = !1,
          U = null;
        const B = new gi(),
          G = new zn(),
          V = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: !0,
          };
        function W() {
          return null === x ? A : 1;
        }
        let j,
          X,
          q,
          Y,
          K,
          Z,
          J,
          Q,
          $,
          ee,
          te,
          ne,
          ie,
          re,
          ae,
          oe,
          se,
          le,
          ce,
          ue,
          he,
          pe,
          me,
          fe = n;
        function ge(e, n) {
          for (let i = 0; i < e.length; i++) {
            const r = e[i],
              a = t.getContext(r, n);
            if (null !== a) return a;
          }
          return null;
        }
        try {
          const e = {
            alpha: i,
            depth: r,
            stencil: a,
            antialias: o,
            premultipliedAlpha: s,
            preserveDrawingBuffer: l,
            powerPreference: c,
            failIfMajorPerformanceCaveat: u,
          };
          if (
            (t.addEventListener("webglcontextlost", xe, !1),
            t.addEventListener("webglcontextrestored", be, !1),
            null === fe)
          ) {
            const t = ["webgl2", "webgl", "experimental-webgl"];
            if (
              (!0 === f.isWebGL1Renderer && t.shift(),
              (fe = ge(t, e)),
              null === fe)
            )
              throw ge(t)
                ? new Error(
                    "Error creating WebGL context with your selected attributes."
                  )
                : new Error("Error creating WebGL context.");
          }
          void 0 === fe.getShaderPrecisionFormat &&
            (fe.getShaderPrecisionFormat = function () {
              return { rangeMin: 1, rangeMax: 1, precision: 1 };
            });
        } catch (e) {
          throw (console.error("THREE.WebGLRenderer: " + e.message), e);
        }
        function ve() {
          (j = new qa(fe)),
            (X = new ga(fe, j, e)),
            j.init(X),
            (pe = new js(fe, j, X)),
            (q = new Vs(fe, j, X)),
            (F[0] = 1029),
            (Y = new Za(fe)),
            (K = new As()),
            (Z = new Ws(fe, j, q, K, X, pe, Y)),
            (J = new ya(f)),
            (Q = new Xa(f)),
            ($ = new la(fe, X)),
            (me = new ma(fe, j, $, X)),
            (ee = new Ya(fe, $, Y, me)),
            (te = new eo(fe, ee, $, Y)),
            (ce = new $a(fe)),
            (oe = new va(K)),
            (ne = new Es(f, J, Q, j, X, me, oe)),
            (ie = new Js(K)),
            (re = new Cs(K)),
            (ae = new ks(j, X)),
            (le = new pa(f, J, q, te, s)),
            (se = new Gs(f, te, X)),
            (ue = new fa(fe, j, Y, X)),
            (he = new Ka(fe, j, Y, X)),
            (Y.programs = ne.programs),
            (f.capabilities = X),
            (f.extensions = j),
            (f.properties = K),
            (f.renderLists = re),
            (f.shadowMap = se),
            (f.state = q),
            (f.info = Y);
        }
        ve();
        const ye = new Zs(f, fe);
        function xe(e) {
          e.preventDefault(),
            console.log("THREE.WebGLRenderer: Context Lost."),
            (g = !0);
        }
        function be() {
          console.log("THREE.WebGLRenderer: Context Restored."), (g = !1);
          const e = Y.autoReset,
            t = se.enabled,
            n = se.autoUpdate,
            i = se.needsUpdate,
            r = se.type;
          ve(),
            (Y.autoReset = e),
            (se.enabled = t),
            (se.autoUpdate = n),
            (se.needsUpdate = i),
            (se.type = r);
        }
        function _e(e) {
          const t = e.target;
          t.removeEventListener("dispose", _e),
            (function (e) {
              (function (e) {
                const t = K.get(e).programs;
                void 0 !== t &&
                  t.forEach(function (e) {
                    ne.releaseProgram(e);
                  });
              })(e),
                K.remove(e);
            })(t);
        }
        (this.xr = ye),
          (this.getContext = function () {
            return fe;
          }),
          (this.getContextAttributes = function () {
            return fe.getContextAttributes();
          }),
          (this.forceContextLoss = function () {
            const e = j.get("WEBGL_lose_context");
            e && e.loseContext();
          }),
          (this.forceContextRestore = function () {
            const e = j.get("WEBGL_lose_context");
            e && e.restoreContext();
          }),
          (this.getPixelRatio = function () {
            return A;
          }),
          (this.setPixelRatio = function (e) {
            void 0 !== e && ((A = e), this.setSize(T, E, !1));
          }),
          (this.getSize = function (e) {
            return e.set(T, E);
          }),
          (this.setSize = function (e, n, i) {
            ye.isPresenting
              ? console.warn(
                  "THREE.WebGLRenderer: Can't change size while VR device is presenting."
                )
              : ((T = e),
                (E = n),
                (t.width = Math.floor(e * A)),
                (t.height = Math.floor(n * A)),
                !1 !== i &&
                  ((t.style.width = e + "px"), (t.style.height = n + "px")),
                this.setViewport(0, 0, e, n));
          }),
          (this.getDrawingBufferSize = function (e) {
            return e.set(T * A, E * A).floor();
          }),
          (this.setDrawingBufferSize = function (e, n, i) {
            (T = e),
              (E = n),
              (A = i),
              (t.width = Math.floor(e * i)),
              (t.height = Math.floor(n * i)),
              this.setViewport(0, 0, e, n);
          }),
          (this.getCurrentViewport = function (e) {
            return e.copy(w);
          }),
          (this.getViewport = function (e) {
            return e.copy(N);
          }),
          (this.setViewport = function (e, t, n, i) {
            e.isVector4 ? N.set(e.x, e.y, e.z, e.w) : N.set(e, t, n, i),
              q.viewport(w.copy(N).multiplyScalar(A).floor());
          }),
          (this.getScissor = function (e) {
            return e.copy(D);
          }),
          (this.setScissor = function (e, t, n, i) {
            e.isVector4 ? D.set(e.x, e.y, e.z, e.w) : D.set(e, t, n, i),
              q.scissor(M.copy(D).multiplyScalar(A).floor());
          }),
          (this.getScissorTest = function () {
            return O;
          }),
          (this.setScissorTest = function (e) {
            q.setScissorTest((O = e));
          }),
          (this.setOpaqueSort = function (e) {
            L = e;
          }),
          (this.setTransparentSort = function (e) {
            P = e;
          }),
          (this.getClearColor = function (e) {
            return e.copy(le.getClearColor());
          }),
          (this.setClearColor = function () {
            le.setClearColor.apply(le, arguments);
          }),
          (this.getClearAlpha = function () {
            return le.getClearAlpha();
          }),
          (this.setClearAlpha = function () {
            le.setClearAlpha.apply(le, arguments);
          }),
          (this.clear = function (e, t, n) {
            let i = 0;
            (void 0 === e || e) && (i |= 16384),
              (void 0 === t || t) && (i |= 256),
              (void 0 === n || n) && (i |= 1024),
              fe.clear(i);
          }),
          (this.clearColor = function () {
            this.clear(!0, !1, !1);
          }),
          (this.clearDepth = function () {
            this.clear(!1, !0, !1);
          }),
          (this.clearStencil = function () {
            this.clear(!1, !1, !0);
          }),
          (this.dispose = function () {
            t.removeEventListener("webglcontextlost", xe, !1),
              t.removeEventListener("webglcontextrestored", be, !1),
              re.dispose(),
              ae.dispose(),
              K.dispose(),
              J.dispose(),
              Q.dispose(),
              te.dispose(),
              me.dispose(),
              ye.dispose(),
              ye.removeEventListener("sessionstart", Me),
              ye.removeEventListener("sessionend", Se),
              U && (U.dispose(), (U = null)),
              Ee.stop();
          }),
          (this.renderBufferImmediate = function (e, t) {
            me.initAttributes();
            const n = K.get(e);
            e.hasPositions && !n.position && (n.position = fe.createBuffer()),
              e.hasNormals && !n.normal && (n.normal = fe.createBuffer()),
              e.hasUvs && !n.uv && (n.uv = fe.createBuffer()),
              e.hasColors && !n.color && (n.color = fe.createBuffer());
            const i = t.getAttributes();
            e.hasPositions &&
              (fe.bindBuffer(34962, n.position),
              fe.bufferData(34962, e.positionArray, 35048),
              me.enableAttribute(i.position.location),
              fe.vertexAttribPointer(i.position.location, 3, 5126, !1, 0, 0)),
              e.hasNormals &&
                (fe.bindBuffer(34962, n.normal),
                fe.bufferData(34962, e.normalArray, 35048),
                me.enableAttribute(i.normal.location),
                fe.vertexAttribPointer(i.normal.location, 3, 5126, !1, 0, 0)),
              e.hasUvs &&
                (fe.bindBuffer(34962, n.uv),
                fe.bufferData(34962, e.uvArray, 35048),
                me.enableAttribute(i.uv.location),
                fe.vertexAttribPointer(i.uv.location, 2, 5126, !1, 0, 0)),
              e.hasColors &&
                (fe.bindBuffer(34962, n.color),
                fe.bufferData(34962, e.colorArray, 35048),
                me.enableAttribute(i.color.location),
                fe.vertexAttribPointer(i.color.location, 3, 5126, !1, 0, 0)),
              me.disableUnusedAttributes(),
              fe.drawArrays(4, 0, e.count),
              (e.count = 0);
          }),
          (this.renderBufferDirect = function (e, t, n, i, r, a) {
            null === t && (t = V);
            const o = r.isMesh && r.matrixWorld.determinant() < 0,
              s = Fe(e, t, i, r);
            q.setMaterial(i, o);
            let l = n.index;
            const c = n.attributes.position;
            if (null === l) {
              if (void 0 === c || 0 === c.count) return;
            } else if (0 === l.count) return;
            let u,
              h = 1;
            !0 === i.wireframe && ((l = ee.getWireframeAttribute(n)), (h = 2)),
              (void 0 === n.morphAttributes.position &&
                void 0 === n.morphAttributes.normal) ||
                ce.update(r, n, i, s),
              me.setup(r, i, s, n, l);
            let d = ue;
            null !== l && ((u = $.get(l)), (d = he), d.setIndex(u));
            const p = null !== l ? l.count : c.count,
              m = n.drawRange.start * h,
              f = n.drawRange.count * h,
              g = null !== a ? a.start * h : 0,
              v = null !== a ? a.count * h : 1 / 0,
              y = Math.max(m, g),
              x = Math.min(p, m + f, g + v) - 1,
              b = Math.max(0, x - y + 1);
            if (0 !== b) {
              if (r.isMesh)
                !0 === i.wireframe
                  ? (q.setLineWidth(i.wireframeLinewidth * W()), d.setMode(1))
                  : d.setMode(4);
              else if (r.isLine) {
                let e = i.linewidth;
                void 0 === e && (e = 1),
                  q.setLineWidth(e * W()),
                  r.isLineSegments
                    ? d.setMode(1)
                    : r.isLineLoop
                    ? d.setMode(2)
                    : d.setMode(3);
              } else r.isPoints ? d.setMode(0) : r.isSprite && d.setMode(4);
              if (r.isInstancedMesh) d.renderInstances(y, b, r.count);
              else if (n.isInstancedBufferGeometry) {
                const e = Math.min(n.instanceCount, n._maxInstanceCount);
                d.renderInstances(y, b, e);
              } else d.render(y, b);
            }
          }),
          (this.compile = function (e, t) {
            (d = ae.get(e)),
              d.init(),
              m.push(d),
              e.traverseVisible(function (e) {
                e.isLight &&
                  e.layers.test(t.layers) &&
                  (d.pushLight(e), e.castShadow && d.pushShadow(e));
              }),
              d.setupLights(f.physicallyCorrectLights),
              e.traverse(function (t) {
                const n = t.material;
                if (n)
                  if (Array.isArray(n))
                    for (let i = 0; i < n.length; i++) {
                      De(n[i], e, t);
                    }
                  else De(n, e, t);
              }),
              m.pop(),
              (d = null);
          });
        let we = null;
        function Me() {
          Ee.stop();
        }
        function Se() {
          Ee.start();
        }
        const Ee = new sa();
        function Le(e, t, n, i) {
          if (!1 === e.visible) return;
          if (e.layers.test(t.layers))
            if (e.isGroup) n = e.renderOrder;
            else if (e.isLOD) !0 === e.autoUpdate && e.update(t);
            else if (e.isLight) d.pushLight(e), e.castShadow && d.pushShadow(e);
            else if (e.isSprite) {
              if (!e.frustumCulled || k.intersectsSprite(e)) {
                i && G.setFromMatrixPosition(e.matrixWorld).applyMatrix4(B);
                const t = te.update(e),
                  r = e.material;
                r.visible && h.push(e, t, r, n, G.z, null);
              }
            } else if (e.isImmediateRenderObject)
              i && G.setFromMatrixPosition(e.matrixWorld).applyMatrix4(B),
                h.push(e, null, e.material, n, G.z, null);
            else if (
              (e.isMesh || e.isLine || e.isPoints) &&
              (e.isSkinnedMesh &&
                e.skeleton.frame !== Y.render.frame &&
                (e.skeleton.update(), (e.skeleton.frame = Y.render.frame)),
              !e.frustumCulled || k.intersectsObject(e))
            ) {
              i && G.setFromMatrixPosition(e.matrixWorld).applyMatrix4(B);
              const t = te.update(e),
                r = e.material;
              if (Array.isArray(r)) {
                const i = t.groups;
                for (let a = 0, o = i.length; a < o; a++) {
                  const o = i[a],
                    s = r[o.materialIndex];
                  s && s.visible && h.push(e, t, s, n, G.z, o);
                }
              } else r.visible && h.push(e, t, r, n, G.z, null);
            }
          const r = e.children;
          for (let e = 0, a = r.length; e < a; e++) Le(r[e], t, n, i);
        }
        function Pe(e, t, n, i) {
          const r = e.opaque,
            a = e.transmissive,
            s = e.transparent;
          d.setupLightsView(n),
            a.length > 0 &&
              (function (e, t, n) {
                if (null === U) {
                  const e = !0 === o && !0 === X.isWebGL2;
                  U = new (e ? kn : Fn)(1024, 1024, {
                    generateMipmaps: !0,
                    type: null !== pe.convert(Ue) ? Ue : Ne,
                    minFilter: Ie,
                    magFilter: Ae,
                    wrapS: Te,
                    wrapT: Te,
                  });
                }
                const i = f.getRenderTarget();
                f.setRenderTarget(U), f.clear();
                const r = f.toneMapping;
                (f.toneMapping = de),
                  Re(e, t, n),
                  (f.toneMapping = r),
                  Z.updateMultisampleRenderTarget(U),
                  Z.updateRenderTargetMipmap(U),
                  f.setRenderTarget(i);
              })(r, t, n),
            i && q.viewport(w.copy(i)),
            r.length > 0 && Re(r, t, n),
            a.length > 0 && Re(a, t, n),
            s.length > 0 && Re(s, t, n);
        }
        function Re(e, t, n) {
          const i = !0 === t.isScene ? t.overrideMaterial : null;
          for (let r = 0, a = e.length; r < a; r++) {
            const a = e[r],
              o = a.object,
              s = a.geometry,
              l = null === i ? a.material : i,
              c = a.group;
            o.layers.test(n.layers) && Ce(o, t, n, s, l, c);
          }
        }
        function Ce(e, t, n, i, r, a) {
          if (
            (e.onBeforeRender(f, t, n, i, r, a),
            e.modelViewMatrix.multiplyMatrices(
              n.matrixWorldInverse,
              e.matrixWorld
            ),
            e.normalMatrix.getNormalMatrix(e.modelViewMatrix),
            e.isImmediateRenderObject)
          ) {
            const i = Fe(n, t, r, e);
            q.setMaterial(r),
              me.reset(),
              (function (e, t) {
                e.render(function (e) {
                  f.renderBufferImmediate(e, t);
                });
              })(e, i);
          } else
            !0 === r.transparent && r.side === I
              ? ((r.side = C),
                (r.needsUpdate = !0),
                f.renderBufferDirect(n, t, i, r, e, a),
                (r.side = R),
                (r.needsUpdate = !0),
                f.renderBufferDirect(n, t, i, r, e, a),
                (r.side = I))
              : f.renderBufferDirect(n, t, i, r, e, a);
          e.onAfterRender(f, t, n, i, r, a);
        }
        function De(e, t, n) {
          !0 !== t.isScene && (t = V);
          const i = K.get(e),
            r = d.state.lights,
            a = d.state.shadowsArray,
            o = r.state.version,
            s = ne.getParameters(e, r.state, a, t, n),
            l = ne.getProgramCacheKey(s);
          let c = i.programs;
          (i.environment = e.isMeshStandardMaterial ? t.environment : null),
            (i.fog = t.fog),
            (i.envMap = (e.isMeshStandardMaterial ? Q : J).get(
              e.envMap || i.environment
            )),
            void 0 === c &&
              (e.addEventListener("dispose", _e),
              (c = new Map()),
              (i.programs = c));
          let u = c.get(l);
          if (void 0 !== u) {
            if (i.currentProgram === u && i.lightsStateVersion === o)
              return Oe(e, s), u;
          } else
            (s.uniforms = ne.getUniforms(e)),
              e.onBuild(s, f),
              e.onBeforeCompile(s, f),
              (u = ne.acquireProgram(s, l)),
              c.set(l, u),
              (i.uniforms = s.uniforms);
          const h = i.uniforms;
          ((e.isShaderMaterial || e.isRawShaderMaterial) &&
            !0 !== e.clipping) ||
            (h.clippingPlanes = oe.uniform),
            Oe(e, s),
            (i.needsLights = (function (e) {
              return (
                e.isMeshLambertMaterial ||
                e.isMeshToonMaterial ||
                e.isMeshPhongMaterial ||
                e.isMeshStandardMaterial ||
                e.isShadowMaterial ||
                (e.isShaderMaterial && !0 === e.lights)
              );
            })(e)),
            (i.lightsStateVersion = o),
            i.needsLights &&
              ((h.ambientLightColor.value = r.state.ambient),
              (h.lightProbe.value = r.state.probe),
              (h.directionalLights.value = r.state.directional),
              (h.directionalLightShadows.value = r.state.directionalShadow),
              (h.spotLights.value = r.state.spot),
              (h.spotLightShadows.value = r.state.spotShadow),
              (h.rectAreaLights.value = r.state.rectArea),
              (h.ltc_1.value = r.state.rectAreaLTC1),
              (h.ltc_2.value = r.state.rectAreaLTC2),
              (h.pointLights.value = r.state.point),
              (h.pointLightShadows.value = r.state.pointShadow),
              (h.hemisphereLights.value = r.state.hemi),
              (h.directionalShadowMap.value = r.state.directionalShadowMap),
              (h.directionalShadowMatrix.value =
                r.state.directionalShadowMatrix),
              (h.spotShadowMap.value = r.state.spotShadowMap),
              (h.spotShadowMatrix.value = r.state.spotShadowMatrix),
              (h.pointShadowMap.value = r.state.pointShadowMap),
              (h.pointShadowMatrix.value = r.state.pointShadowMatrix));
          const p = u.getUniforms(),
            m = as.seqWithValue(p.seq, h);
          return (i.currentProgram = u), (i.uniformsList = m), u;
        }
        function Oe(e, t) {
          const n = K.get(e);
          (n.outputEncoding = t.outputEncoding),
            (n.instancing = t.instancing),
            (n.skinning = t.skinning),
            (n.morphTargets = t.morphTargets),
            (n.morphNormals = t.morphNormals),
            (n.numClippingPlanes = t.numClippingPlanes),
            (n.numIntersection = t.numClipIntersection),
            (n.vertexAlphas = t.vertexAlphas),
            (n.vertexTangents = t.vertexTangents);
        }
        function Fe(e, t, n, i) {
          !0 !== t.isScene && (t = V), Z.resetTextureUnits();
          const r = t.fog,
            a = n.isMeshStandardMaterial ? t.environment : null,
            o = null === x ? f.outputEncoding : x.texture.encoding,
            s = (n.isMeshStandardMaterial ? Q : J).get(n.envMap || a),
            l =
              !0 === n.vertexColors &&
              !!i.geometry &&
              !!i.geometry.attributes.color &&
              4 === i.geometry.attributes.color.itemSize,
            c = !!i.geometry && !!i.geometry.attributes.tangent,
            u = !!i.geometry && !!i.geometry.morphAttributes.position,
            h = !!i.geometry && !!i.geometry.morphAttributes.normal,
            p = K.get(n),
            m = d.state.lights;
          if (!0 === H && (!0 === z || e !== _)) {
            const t = e === _ && n.id === b;
            oe.setState(n, e, t);
          }
          let g = !1;
          n.version === p.__version
            ? (p.needsLights && p.lightsStateVersion !== m.state.version) ||
              p.outputEncoding !== o ||
              (i.isInstancedMesh && !1 === p.instancing)
              ? (g = !0)
              : i.isInstancedMesh || !0 !== p.instancing
              ? i.isSkinnedMesh && !1 === p.skinning
                ? (g = !0)
                : i.isSkinnedMesh || !0 !== p.skinning
                ? p.envMap !== s || (n.fog && p.fog !== r)
                  ? (g = !0)
                  : void 0 === p.numClippingPlanes ||
                    (p.numClippingPlanes === oe.numPlanes &&
                      p.numIntersection === oe.numIntersection)
                  ? (p.vertexAlphas !== l ||
                      p.vertexTangents !== c ||
                      p.morphTargets !== u ||
                      p.morphNormals !== h) &&
                    (g = !0)
                  : (g = !0)
                : (g = !0)
              : (g = !0)
            : ((g = !0), (p.__version = n.version));
          let v = p.currentProgram;
          !0 === g && (v = De(n, t, i));
          let y = !1,
            w = !1,
            M = !1;
          const S = v.getUniforms(),
            T = p.uniforms;
          if (
            (q.useProgram(v.program) && ((y = !0), (w = !0), (M = !0)),
            n.id !== b && ((b = n.id), (w = !0)),
            y || _ !== e)
          ) {
            if (
              (S.setValue(fe, "projectionMatrix", e.projectionMatrix),
              X.logarithmicDepthBuffer &&
                S.setValue(
                  fe,
                  "logDepthBufFC",
                  2 / (Math.log(e.far + 1) / Math.LN2)
                ),
              _ !== e && ((_ = e), (w = !0), (M = !0)),
              n.isShaderMaterial ||
                n.isMeshPhongMaterial ||
                n.isMeshToonMaterial ||
                n.isMeshStandardMaterial ||
                n.envMap)
            ) {
              const t = S.map.cameraPosition;
              void 0 !== t &&
                t.setValue(fe, G.setFromMatrixPosition(e.matrixWorld));
            }
            (n.isMeshPhongMaterial ||
              n.isMeshToonMaterial ||
              n.isMeshLambertMaterial ||
              n.isMeshBasicMaterial ||
              n.isMeshStandardMaterial ||
              n.isShaderMaterial) &&
              S.setValue(fe, "isOrthographic", !0 === e.isOrthographicCamera),
              (n.isMeshPhongMaterial ||
                n.isMeshToonMaterial ||
                n.isMeshLambertMaterial ||
                n.isMeshBasicMaterial ||
                n.isMeshStandardMaterial ||
                n.isShaderMaterial ||
                n.isShadowMaterial ||
                i.isSkinnedMesh) &&
                S.setValue(fe, "viewMatrix", e.matrixWorldInverse);
          }
          if (i.isSkinnedMesh) {
            S.setOptional(fe, i, "bindMatrix"),
              S.setOptional(fe, i, "bindMatrixInverse");
            const e = i.skeleton;
            e &&
              (X.floatVertexTextures
                ? (null === e.boneTexture && e.computeBoneTexture(),
                  S.setValue(fe, "boneTexture", e.boneTexture, Z),
                  S.setValue(fe, "boneTextureSize", e.boneTextureSize))
                : S.setOptional(fe, e, "boneMatrices"));
          }
          var L, P;
          return (
            (w || p.receiveShadow !== i.receiveShadow) &&
              ((p.receiveShadow = i.receiveShadow),
              S.setValue(fe, "receiveShadow", i.receiveShadow)),
            w &&
              (S.setValue(fe, "toneMappingExposure", f.toneMappingExposure),
              p.needsLights &&
                ((P = M),
                ((L = T).ambientLightColor.needsUpdate = P),
                (L.lightProbe.needsUpdate = P),
                (L.directionalLights.needsUpdate = P),
                (L.directionalLightShadows.needsUpdate = P),
                (L.pointLights.needsUpdate = P),
                (L.pointLightShadows.needsUpdate = P),
                (L.spotLights.needsUpdate = P),
                (L.spotLightShadows.needsUpdate = P),
                (L.rectAreaLights.needsUpdate = P),
                (L.hemisphereLights.needsUpdate = P)),
              r && n.fog && ie.refreshFogUniforms(T, r),
              ie.refreshMaterialUniforms(T, n, A, E, U),
              as.upload(fe, p.uniformsList, T, Z)),
            n.isShaderMaterial &&
              !0 === n.uniformsNeedUpdate &&
              (as.upload(fe, p.uniformsList, T, Z),
              (n.uniformsNeedUpdate = !1)),
            n.isSpriteMaterial && S.setValue(fe, "center", i.center),
            S.setValue(fe, "modelViewMatrix", i.modelViewMatrix),
            S.setValue(fe, "normalMatrix", i.normalMatrix),
            S.setValue(fe, "modelMatrix", i.matrixWorld),
            v
          );
        }
        Ee.setAnimationLoop(function (e) {
          we && we(e);
        }),
          "undefined" != typeof window && Ee.setContext(window),
          (this.setAnimationLoop = function (e) {
            (we = e),
              ye.setAnimationLoop(e),
              null === e ? Ee.stop() : Ee.start();
          }),
          ye.addEventListener("sessionstart", Me),
          ye.addEventListener("sessionend", Se),
          (this.render = function (e, t) {
            if (void 0 !== t && !0 !== t.isCamera)
              return void console.error(
                "THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera."
              );
            if (!0 === g) return;
            !0 === e.autoUpdate && e.updateMatrixWorld(),
              null === t.parent && t.updateMatrixWorld(),
              !0 === ye.enabled &&
                !0 === ye.isPresenting &&
                (!0 === ye.cameraAutoUpdate && ye.updateCamera(t),
                (t = ye.getCamera())),
              !0 === e.isScene && e.onBeforeRender(f, e, t, x),
              (d = ae.get(e, m.length)),
              d.init(),
              m.push(d),
              B.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse),
              k.setFromProjectionMatrix(B),
              (z = this.localClippingEnabled),
              (H = oe.init(this.clippingPlanes, z, t)),
              (h = re.get(e, p.length)),
              h.init(),
              p.push(h),
              Le(e, t, 0, f.sortObjects),
              h.finish(),
              !0 === f.sortObjects && h.sort(L, P),
              !0 === H && oe.beginShadows();
            const n = d.state.shadowsArray;
            if (
              (se.render(n, e, t),
              !0 === H && oe.endShadows(),
              !0 === this.info.autoReset && this.info.reset(),
              le.render(h, e),
              d.setupLights(f.physicallyCorrectLights),
              t.isArrayCamera)
            ) {
              const n = t.cameras;
              for (let t = 0, i = n.length; t < i; t++) {
                const i = n[t];
                Pe(h, e, i, i.viewport);
              }
            } else Pe(h, e, t);
            null !== x &&
              (Z.updateMultisampleRenderTarget(x),
              Z.updateRenderTargetMipmap(x)),
              !0 === e.isScene && e.onAfterRender(f, e, t),
              q.buffers.depth.setTest(!0),
              q.buffers.depth.setMask(!0),
              q.buffers.color.setMask(!0),
              q.setPolygonOffset(!1),
              me.resetDefaultState(),
              (b = -1),
              (_ = null),
              m.pop(),
              (d = m.length > 0 ? m[m.length - 1] : null),
              p.pop(),
              (h = p.length > 0 ? p[p.length - 1] : null);
          }),
          (this.getActiveCubeFace = function () {
            return v;
          }),
          (this.getActiveMipmapLevel = function () {
            return y;
          }),
          (this.getRenderTarget = function () {
            return x;
          }),
          (this.setRenderTarget = function (e, t = 0, n = 0) {
            (x = e),
              (v = t),
              (y = n),
              e &&
                void 0 === K.get(e).__webglFramebuffer &&
                Z.setupRenderTarget(e);
            let i = null,
              r = !1,
              a = !1;
            if (e) {
              const n = e.texture;
              (n.isDataTexture3D || n.isDataTexture2DArray) && (a = !0);
              const o = K.get(e).__webglFramebuffer;
              e.isWebGLCubeRenderTarget
                ? ((i = o[t]), (r = !0))
                : (i = e.isWebGLMultisampleRenderTarget
                    ? K.get(e).__webglMultisampledFramebuffer
                    : o),
                w.copy(e.viewport),
                M.copy(e.scissor),
                (S = e.scissorTest);
            } else
              w.copy(N).multiplyScalar(A).floor(),
                M.copy(D).multiplyScalar(A).floor(),
                (S = O);
            if (q.bindFramebuffer(36160, i) && X.drawBuffers) {
              let t = !1;
              if (e)
                if (e.isWebGLMultipleRenderTargets) {
                  const n = e.texture;
                  if (F.length !== n.length || 36064 !== F[0]) {
                    for (let e = 0, t = n.length; e < t; e++) F[e] = 36064 + e;
                    (F.length = n.length), (t = !0);
                  }
                } else
                  (1 === F.length && 36064 === F[0]) ||
                    ((F[0] = 36064), (F.length = 1), (t = !0));
              else
                (1 === F.length && 1029 === F[0]) ||
                  ((F[0] = 1029), (F.length = 1), (t = !0));
              t &&
                (X.isWebGL2
                  ? fe.drawBuffers(F)
                  : j.get("WEBGL_draw_buffers").drawBuffersWEBGL(F));
            }
            if ((q.viewport(w), q.scissor(M), q.setScissorTest(S), r)) {
              const i = K.get(e.texture);
              fe.framebufferTexture2D(
                36160,
                36064,
                34069 + t,
                i.__webglTexture,
                n
              );
            } else if (a) {
              const i = K.get(e.texture),
                r = t || 0;
              fe.framebufferTextureLayer(
                36160,
                36064,
                i.__webglTexture,
                n || 0,
                r
              );
            }
            b = -1;
          }),
          (this.readRenderTargetPixels = function (e, t, n, i, r, a, o) {
            if (!e || !e.isWebGLRenderTarget)
              return void console.error(
                "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget."
              );
            let s = K.get(e).__webglFramebuffer;
            if ((e.isWebGLCubeRenderTarget && void 0 !== o && (s = s[o]), s)) {
              q.bindFramebuffer(36160, s);
              try {
                const o = e.texture,
                  s = o.format,
                  l = o.type;
                if (s !== qe && pe.convert(s) !== fe.getParameter(35739))
                  return void console.error(
                    "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format."
                  );
                const c =
                  l === Ue &&
                  (j.has("EXT_color_buffer_half_float") ||
                    (X.isWebGL2 && j.has("EXT_color_buffer_float")));
                if (
                  !(
                    l === Ne ||
                    pe.convert(l) === fe.getParameter(35738) ||
                    (l === ze &&
                      (X.isWebGL2 ||
                        j.has("OES_texture_float") ||
                        j.has("WEBGL_color_buffer_float"))) ||
                    c
                  )
                )
                  return void console.error(
                    "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type."
                  );
                36053 === fe.checkFramebufferStatus(36160)
                  ? t >= 0 &&
                    t <= e.width - i &&
                    n >= 0 &&
                    n <= e.height - r &&
                    fe.readPixels(t, n, i, r, pe.convert(s), pe.convert(l), a)
                  : console.error(
                      "THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete."
                    );
              } finally {
                const e = null !== x ? K.get(x).__webglFramebuffer : null;
                q.bindFramebuffer(36160, e);
              }
            }
          }),
          (this.copyFramebufferToTexture = function (e, t, n = 0) {
            const i = Math.pow(2, -n),
              r = Math.floor(t.image.width * i),
              a = Math.floor(t.image.height * i);
            let o = pe.convert(t.format);
            X.isWebGL2 &&
              (6407 === o && (o = 32849), 6408 === o && (o = 32856)),
              Z.setTexture2D(t, 0),
              fe.copyTexImage2D(3553, n, o, e.x, e.y, r, a, 0),
              q.unbindTexture();
          }),
          (this.copyTextureToTexture = function (e, t, n, i = 0) {
            const r = t.image.width,
              a = t.image.height,
              o = pe.convert(n.format),
              s = pe.convert(n.type);
            Z.setTexture2D(n, 0),
              fe.pixelStorei(37440, n.flipY),
              fe.pixelStorei(37441, n.premultiplyAlpha),
              fe.pixelStorei(3317, n.unpackAlignment),
              t.isDataTexture
                ? fe.texSubImage2D(3553, i, e.x, e.y, r, a, o, s, t.image.data)
                : t.isCompressedTexture
                ? fe.compressedTexSubImage2D(
                    3553,
                    i,
                    e.x,
                    e.y,
                    t.mipmaps[0].width,
                    t.mipmaps[0].height,
                    o,
                    t.mipmaps[0].data
                  )
                : fe.texSubImage2D(3553, i, e.x, e.y, o, s, t.image),
              0 === i && n.generateMipmaps && fe.generateMipmap(3553),
              q.unbindTexture();
          }),
          (this.copyTextureToTexture3D = function (e, t, n, i, r = 0) {
            if (f.isWebGL1Renderer)
              return void console.warn(
                "THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2."
              );
            const a = e.max.x - e.min.x + 1,
              o = e.max.y - e.min.y + 1,
              s = e.max.z - e.min.z + 1,
              l = pe.convert(i.format),
              c = pe.convert(i.type);
            let u;
            if (i.isDataTexture3D) Z.setTexture3D(i, 0), (u = 32879);
            else {
              if (!i.isDataTexture2DArray)
                return void console.warn(
                  "THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray."
                );
              Z.setTexture2DArray(i, 0), (u = 35866);
            }
            fe.pixelStorei(37440, i.flipY),
              fe.pixelStorei(37441, i.premultiplyAlpha),
              fe.pixelStorei(3317, i.unpackAlignment);
            const h = fe.getParameter(3314),
              d = fe.getParameter(32878),
              p = fe.getParameter(3316),
              m = fe.getParameter(3315),
              g = fe.getParameter(32877),
              v = n.isCompressedTexture ? n.mipmaps[0] : n.image;
            fe.pixelStorei(3314, v.width),
              fe.pixelStorei(32878, v.height),
              fe.pixelStorei(3316, e.min.x),
              fe.pixelStorei(3315, e.min.y),
              fe.pixelStorei(32877, e.min.z),
              n.isDataTexture || n.isDataTexture3D
                ? fe.texSubImage3D(u, r, t.x, t.y, t.z, a, o, s, l, c, v.data)
                : n.isCompressedTexture
                ? (console.warn(
                    "THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."
                  ),
                  fe.compressedTexSubImage3D(
                    u,
                    r,
                    t.x,
                    t.y,
                    t.z,
                    a,
                    o,
                    s,
                    l,
                    v.data
                  ))
                : fe.texSubImage3D(u, r, t.x, t.y, t.z, a, o, s, l, c, v),
              fe.pixelStorei(3314, h),
              fe.pixelStorei(32878, d),
              fe.pixelStorei(3316, p),
              fe.pixelStorei(3315, m),
              fe.pixelStorei(32877, g),
              0 === r && i.generateMipmaps && fe.generateMipmap(u),
              q.unbindTexture();
          }),
          (this.initTexture = function (e) {
            Z.setTexture2D(e, 0), q.unbindTexture();
          }),
          (this.resetState = function () {
            (v = 0), (y = 0), (x = null), q.reset(), me.reset();
          }),
          "undefined" != typeof __THREE_DEVTOOLS__ &&
            __THREE_DEVTOOLS__.dispatchEvent(
              new CustomEvent("observe", { detail: this })
            );
      }
      (class extends Qs {}).prototype.isWebGL1Renderer = !0;
      class $s {
        constructor(e, t = 25e-5) {
          (this.name = ""), (this.color = new sr(e)), (this.density = t);
        }
        clone() {
          return new $s(this.color, this.density);
        }
        toJSON() {
          return {
            type: "FogExp2",
            color: this.color.getHex(),
            density: this.density,
          };
        }
      }
      $s.prototype.isFogExp2 = !0;
      class el {
        constructor(e, t = 1, n = 1e3) {
          (this.name = ""),
            (this.color = new sr(e)),
            (this.near = t),
            (this.far = n);
        }
        clone() {
          return new el(this.color, this.near, this.far);
        }
        toJSON() {
          return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far,
          };
        }
      }
      el.prototype.isFog = !0;
      class tl extends Bi {
        constructor() {
          super(),
            (this.type = "Scene"),
            (this.background = null),
            (this.environment = null),
            (this.fog = null),
            (this.overrideMaterial = null),
            (this.autoUpdate = !0),
            "undefined" != typeof __THREE_DEVTOOLS__ &&
              __THREE_DEVTOOLS__.dispatchEvent(
                new CustomEvent("observe", { detail: this })
              );
        }
        copy(e, t) {
          return (
            super.copy(e, t),
            null !== e.background && (this.background = e.background.clone()),
            null !== e.environment &&
              (this.environment = e.environment.clone()),
            null !== e.fog && (this.fog = e.fog.clone()),
            null !== e.overrideMaterial &&
              (this.overrideMaterial = e.overrideMaterial.clone()),
            (this.autoUpdate = e.autoUpdate),
            (this.matrixAutoUpdate = e.matrixAutoUpdate),
            this
          );
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return null !== this.fog && (t.object.fog = this.fog.toJSON()), t;
        }
      }
      tl.prototype.isScene = !0;
      class nl {
        constructor(e, t) {
          (this.array = e),
            (this.stride = t),
            (this.count = void 0 !== e ? e.length / t : 0),
            (this.usage = dn),
            (this.updateRange = { offset: 0, count: -1 }),
            (this.version = 0),
            (this.uuid = bn());
        }
        onUploadCallback() {}
        set needsUpdate(e) {
          !0 === e && this.version++;
        }
        setUsage(e) {
          return (this.usage = e), this;
        }
        copy(e) {
          return (
            (this.array = new e.array.constructor(e.array)),
            (this.count = e.count),
            (this.stride = e.stride),
            (this.usage = e.usage),
            this
          );
        }
        copyAt(e, t, n) {
          (e *= this.stride), (n *= t.stride);
          for (let i = 0, r = this.stride; i < r; i++)
            this.array[e + i] = t.array[n + i];
          return this;
        }
        set(e, t = 0) {
          return this.array.set(e, t), this;
        }
        clone(e) {
          void 0 === e.arrayBuffers && (e.arrayBuffers = {}),
            void 0 === this.array.buffer._uuid &&
              (this.array.buffer._uuid = bn()),
            void 0 === e.arrayBuffers[this.array.buffer._uuid] &&
              (e.arrayBuffers[this.array.buffer._uuid] =
                this.array.slice(0).buffer);
          const t = new this.array.constructor(
              e.arrayBuffers[this.array.buffer._uuid]
            ),
            n = new this.constructor(t, this.stride);
          return n.setUsage(this.usage), n;
        }
        onUpload(e) {
          return (this.onUploadCallback = e), this;
        }
        toJSON(e) {
          return (
            void 0 === e.arrayBuffers && (e.arrayBuffers = {}),
            void 0 === this.array.buffer._uuid &&
              (this.array.buffer._uuid = bn()),
            void 0 === e.arrayBuffers[this.array.buffer._uuid] &&
              (e.arrayBuffers[this.array.buffer._uuid] =
                Array.prototype.slice.call(new Uint32Array(this.array.buffer))),
            {
              uuid: this.uuid,
              buffer: this.array.buffer._uuid,
              type: this.array.constructor.name,
              stride: this.stride,
            }
          );
        }
      }
      nl.prototype.isInterleavedBuffer = !0;
      const il = new zn();
      class rl {
        constructor(e, t, n, i = !1) {
          (this.name = ""),
            (this.data = e),
            (this.itemSize = t),
            (this.offset = n),
            (this.normalized = !0 === i);
        }
        get count() {
          return this.data.count;
        }
        get array() {
          return this.data.array;
        }
        set needsUpdate(e) {
          this.data.needsUpdate = e;
        }
        applyMatrix4(e) {
          for (let t = 0, n = this.data.count; t < n; t++)
            (il.x = this.getX(t)),
              (il.y = this.getY(t)),
              (il.z = this.getZ(t)),
              il.applyMatrix4(e),
              this.setXYZ(t, il.x, il.y, il.z);
          return this;
        }
        applyNormalMatrix(e) {
          for (let t = 0, n = this.count; t < n; t++)
            (il.x = this.getX(t)),
              (il.y = this.getY(t)),
              (il.z = this.getZ(t)),
              il.applyNormalMatrix(e),
              this.setXYZ(t, il.x, il.y, il.z);
          return this;
        }
        transformDirection(e) {
          for (let t = 0, n = this.count; t < n; t++)
            (il.x = this.getX(t)),
              (il.y = this.getY(t)),
              (il.z = this.getZ(t)),
              il.transformDirection(e),
              this.setXYZ(t, il.x, il.y, il.z);
          return this;
        }
        setX(e, t) {
          return (
            (this.data.array[e * this.data.stride + this.offset] = t), this
          );
        }
        setY(e, t) {
          return (
            (this.data.array[e * this.data.stride + this.offset + 1] = t), this
          );
        }
        setZ(e, t) {
          return (
            (this.data.array[e * this.data.stride + this.offset + 2] = t), this
          );
        }
        setW(e, t) {
          return (
            (this.data.array[e * this.data.stride + this.offset + 3] = t), this
          );
        }
        getX(e) {
          return this.data.array[e * this.data.stride + this.offset];
        }
        getY(e) {
          return this.data.array[e * this.data.stride + this.offset + 1];
        }
        getZ(e) {
          return this.data.array[e * this.data.stride + this.offset + 2];
        }
        getW(e) {
          return this.data.array[e * this.data.stride + this.offset + 3];
        }
        setXY(e, t, n) {
          return (
            (e = e * this.data.stride + this.offset),
            (this.data.array[e + 0] = t),
            (this.data.array[e + 1] = n),
            this
          );
        }
        setXYZ(e, t, n, i) {
          return (
            (e = e * this.data.stride + this.offset),
            (this.data.array[e + 0] = t),
            (this.data.array[e + 1] = n),
            (this.data.array[e + 2] = i),
            this
          );
        }
        setXYZW(e, t, n, i, r) {
          return (
            (e = e * this.data.stride + this.offset),
            (this.data.array[e + 0] = t),
            (this.data.array[e + 1] = n),
            (this.data.array[e + 2] = i),
            (this.data.array[e + 3] = r),
            this
          );
        }
        clone(e) {
          if (void 0 === e) {
            console.log(
              "THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data."
            );
            const e = [];
            for (let t = 0; t < this.count; t++) {
              const n = t * this.data.stride + this.offset;
              for (let t = 0; t < this.itemSize; t++)
                e.push(this.data.array[n + t]);
            }
            return new hr(
              new this.array.constructor(e),
              this.itemSize,
              this.normalized
            );
          }
          return (
            void 0 === e.interleavedBuffers && (e.interleavedBuffers = {}),
            void 0 === e.interleavedBuffers[this.data.uuid] &&
              (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)),
            new rl(
              e.interleavedBuffers[this.data.uuid],
              this.itemSize,
              this.offset,
              this.normalized
            )
          );
        }
        toJSON(e) {
          if (void 0 === e) {
            console.log(
              "THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data."
            );
            const e = [];
            for (let t = 0; t < this.count; t++) {
              const n = t * this.data.stride + this.offset;
              for (let t = 0; t < this.itemSize; t++)
                e.push(this.data.array[n + t]);
            }
            return {
              itemSize: this.itemSize,
              type: this.array.constructor.name,
              array: e,
              normalized: this.normalized,
            };
          }
          return (
            void 0 === e.interleavedBuffers && (e.interleavedBuffers = {}),
            void 0 === e.interleavedBuffers[this.data.uuid] &&
              (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)),
            {
              isInterleavedBufferAttribute: !0,
              itemSize: this.itemSize,
              data: this.data.uuid,
              offset: this.offset,
              normalized: this.normalized,
            }
          );
        }
      }
      rl.prototype.isInterleavedBufferAttribute = !0;
      class al extends er {
        constructor(e) {
          super(),
            (this.type = "SpriteMaterial"),
            (this.color = new sr(16777215)),
            (this.map = null),
            (this.alphaMap = null),
            (this.rotation = 0),
            (this.sizeAttenuation = !0),
            (this.transparent = !0),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.map = e.map),
            (this.alphaMap = e.alphaMap),
            (this.rotation = e.rotation),
            (this.sizeAttenuation = e.sizeAttenuation),
            this
          );
        }
      }
      let ol;
      al.prototype.isSpriteMaterial = !0;
      const sl = new zn(),
        ll = new zn(),
        cl = new zn(),
        ul = new Ln(),
        hl = new Ln(),
        dl = new gi(),
        pl = new zn(),
        ml = new zn(),
        fl = new zn(),
        gl = new Ln(),
        vl = new Ln(),
        yl = new Ln();
      class xl extends Bi {
        constructor(e) {
          if ((super(), (this.type = "Sprite"), void 0 === ol)) {
            ol = new Mr();
            const e = new Float32Array([
                -0.5, -0.5, 0, 0, 0, 0.5, -0.5, 0, 1, 0, 0.5, 0.5, 0, 1, 1,
                -0.5, 0.5, 0, 0, 1,
              ]),
              t = new nl(e, 5);
            ol.setIndex([0, 1, 2, 0, 2, 3]),
              ol.setAttribute("position", new rl(t, 3, 0, !1)),
              ol.setAttribute("uv", new rl(t, 2, 3, !1));
          }
          (this.geometry = ol),
            (this.material = void 0 !== e ? e : new al()),
            (this.center = new Ln(0.5, 0.5));
        }
        raycast(e, t) {
          null === e.camera &&
            console.error(
              'THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'
            ),
            ll.setFromMatrixScale(this.matrixWorld),
            dl.copy(e.camera.matrixWorld),
            this.modelViewMatrix.multiplyMatrices(
              e.camera.matrixWorldInverse,
              this.matrixWorld
            ),
            cl.setFromMatrixPosition(this.modelViewMatrix),
            e.camera.isPerspectiveCamera &&
              !1 === this.material.sizeAttenuation &&
              ll.multiplyScalar(-cl.z);
          const n = this.material.rotation;
          let i, r;
          0 !== n && ((r = Math.cos(n)), (i = Math.sin(n)));
          const a = this.center;
          bl(pl.set(-0.5, -0.5, 0), cl, a, ll, i, r),
            bl(ml.set(0.5, -0.5, 0), cl, a, ll, i, r),
            bl(fl.set(0.5, 0.5, 0), cl, a, ll, i, r),
            gl.set(0, 0),
            vl.set(1, 0),
            yl.set(1, 1);
          let o = e.ray.intersectTriangle(pl, ml, fl, !1, sl);
          if (
            null === o &&
            (bl(ml.set(-0.5, 0.5, 0), cl, a, ll, i, r),
            vl.set(0, 1),
            (o = e.ray.intersectTriangle(pl, fl, ml, !1, sl)),
            null === o)
          )
            return;
          const s = e.ray.origin.distanceTo(sl);
          s < e.near ||
            s > e.far ||
            t.push({
              distance: s,
              point: sl.clone(),
              uv: Qi.getUV(sl, pl, ml, fl, gl, vl, yl, new Ln()),
              face: null,
              object: this,
            });
        }
        copy(e) {
          return (
            super.copy(e),
            void 0 !== e.center && this.center.copy(e.center),
            (this.material = e.material),
            this
          );
        }
      }
      function bl(e, t, n, i, r, a) {
        ul.subVectors(e, n).addScalar(0.5).multiply(i),
          void 0 !== r
            ? ((hl.x = a * ul.x - r * ul.y), (hl.y = r * ul.x + a * ul.y))
            : hl.copy(ul),
          e.copy(t),
          (e.x += hl.x),
          (e.y += hl.y),
          e.applyMatrix4(dl);
      }
      xl.prototype.isSprite = !0;
      const _l = new zn(),
        wl = new On(),
        Ml = new On(),
        Sl = new zn(),
        Tl = new gi();
      class El extends Br {
        constructor(e, t) {
          super(e, t),
            (this.type = "SkinnedMesh"),
            (this.bindMode = "attached"),
            (this.bindMatrix = new gi()),
            (this.bindMatrixInverse = new gi());
        }
        copy(e) {
          return (
            super.copy(e),
            (this.bindMode = e.bindMode),
            this.bindMatrix.copy(e.bindMatrix),
            this.bindMatrixInverse.copy(e.bindMatrixInverse),
            (this.skeleton = e.skeleton),
            this
          );
        }
        bind(e, t) {
          (this.skeleton = e),
            void 0 === t &&
              (this.updateMatrixWorld(!0),
              this.skeleton.calculateInverses(),
              (t = this.matrixWorld)),
            this.bindMatrix.copy(t),
            this.bindMatrixInverse.copy(t).invert();
        }
        pose() {
          this.skeleton.pose();
        }
        normalizeSkinWeights() {
          const e = new On(),
            t = this.geometry.attributes.skinWeight;
          for (let n = 0, i = t.count; n < i; n++) {
            (e.x = t.getX(n)),
              (e.y = t.getY(n)),
              (e.z = t.getZ(n)),
              (e.w = t.getW(n));
            const i = 1 / e.manhattanLength();
            i !== 1 / 0 ? e.multiplyScalar(i) : e.set(1, 0, 0, 0),
              t.setXYZW(n, e.x, e.y, e.z, e.w);
          }
        }
        updateMatrixWorld(e) {
          super.updateMatrixWorld(e),
            "attached" === this.bindMode
              ? this.bindMatrixInverse.copy(this.matrixWorld).invert()
              : "detached" === this.bindMode
              ? this.bindMatrixInverse.copy(this.bindMatrix).invert()
              : console.warn(
                  "THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode
                );
        }
        boneTransform(e, t) {
          const n = this.skeleton,
            i = this.geometry;
          wl.fromBufferAttribute(i.attributes.skinIndex, e),
            Ml.fromBufferAttribute(i.attributes.skinWeight, e),
            _l
              .fromBufferAttribute(i.attributes.position, e)
              .applyMatrix4(this.bindMatrix),
            t.set(0, 0, 0);
          for (let e = 0; e < 4; e++) {
            const i = Ml.getComponent(e);
            if (0 !== i) {
              const r = wl.getComponent(e);
              Tl.multiplyMatrices(n.bones[r].matrixWorld, n.boneInverses[r]),
                t.addScaledVector(Sl.copy(_l).applyMatrix4(Tl), i);
            }
          }
          return t.applyMatrix4(this.bindMatrixInverse);
        }
      }
      El.prototype.isSkinnedMesh = !0;
      class Al extends Bi {
        constructor() {
          super(), (this.type = "Bone");
        }
      }
      Al.prototype.isBone = !0;
      class Ll extends Nn {
        constructor(
          e = null,
          t = 1,
          n = 1,
          i,
          r,
          a,
          o,
          s,
          l = Ae,
          c = Ae,
          u,
          h
        ) {
          super(null, a, o, s, l, c, i, r, u, h),
            (this.image = { data: e, width: t, height: n }),
            (this.magFilter = l),
            (this.minFilter = c),
            (this.generateMipmaps = !1),
            (this.flipY = !1),
            (this.unpackAlignment = 1),
            (this.needsUpdate = !0);
        }
      }
      Ll.prototype.isDataTexture = !0;
      const Pl = new gi(),
        Rl = new gi();
      class Cl {
        constructor(e = [], t = []) {
          (this.uuid = bn()),
            (this.bones = e.slice(0)),
            (this.boneInverses = t),
            (this.boneMatrices = null),
            (this.boneTexture = null),
            (this.boneTextureSize = 0),
            (this.frame = -1),
            this.init();
        }
        init() {
          const e = this.bones,
            t = this.boneInverses;
          if (
            ((this.boneMatrices = new Float32Array(16 * e.length)),
            0 === t.length)
          )
            this.calculateInverses();
          else if (e.length !== t.length) {
            console.warn(
              "THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."
            ),
              (this.boneInverses = []);
            for (let e = 0, t = this.bones.length; e < t; e++)
              this.boneInverses.push(new gi());
          }
        }
        calculateInverses() {
          this.boneInverses.length = 0;
          for (let e = 0, t = this.bones.length; e < t; e++) {
            const t = new gi();
            this.bones[e] && t.copy(this.bones[e].matrixWorld).invert(),
              this.boneInverses.push(t);
          }
        }
        pose() {
          for (let e = 0, t = this.bones.length; e < t; e++) {
            const t = this.bones[e];
            t && t.matrixWorld.copy(this.boneInverses[e]).invert();
          }
          for (let e = 0, t = this.bones.length; e < t; e++) {
            const t = this.bones[e];
            t &&
              (t.parent && t.parent.isBone
                ? (t.matrix.copy(t.parent.matrixWorld).invert(),
                  t.matrix.multiply(t.matrixWorld))
                : t.matrix.copy(t.matrixWorld),
              t.matrix.decompose(t.position, t.quaternion, t.scale));
          }
        }
        update() {
          const e = this.bones,
            t = this.boneInverses,
            n = this.boneMatrices,
            i = this.boneTexture;
          for (let i = 0, r = e.length; i < r; i++) {
            const r = e[i] ? e[i].matrixWorld : Rl;
            Pl.multiplyMatrices(r, t[i]), Pl.toArray(n, 16 * i);
          }
          null !== i && (i.needsUpdate = !0);
        }
        clone() {
          return new Cl(this.bones, this.boneInverses);
        }
        computeBoneTexture() {
          let e = Math.sqrt(4 * this.bones.length);
          (e = Tn(e)), (e = Math.max(e, 4));
          const t = new Float32Array(e * e * 4);
          t.set(this.boneMatrices);
          const n = new Ll(t, e, e, qe, ze);
          return (
            (this.boneMatrices = t),
            (this.boneTexture = n),
            (this.boneTextureSize = e),
            this
          );
        }
        getBoneByName(e) {
          for (let t = 0, n = this.bones.length; t < n; t++) {
            const n = this.bones[t];
            if (n.name === e) return n;
          }
        }
        dispose() {
          null !== this.boneTexture &&
            (this.boneTexture.dispose(), (this.boneTexture = null));
        }
        fromJSON(e, t) {
          this.uuid = e.uuid;
          for (let n = 0, i = e.bones.length; n < i; n++) {
            const i = e.bones[n];
            let r = t[i];
            void 0 === r &&
              (console.warn("THREE.Skeleton: No bone found with UUID:", i),
              (r = new Al())),
              this.bones.push(r),
              this.boneInverses.push(new gi().fromArray(e.boneInverses[n]));
          }
          return this.init(), this;
        }
        toJSON() {
          const e = {
            metadata: {
              version: 4.5,
              type: "Skeleton",
              generator: "Skeleton.toJSON",
            },
            bones: [],
            boneInverses: [],
          };
          e.uuid = this.uuid;
          const t = this.bones,
            n = this.boneInverses;
          for (let i = 0, r = t.length; i < r; i++) {
            const r = t[i];
            e.bones.push(r.uuid);
            const a = n[i];
            e.boneInverses.push(a.toArray());
          }
          return e;
        }
      }
      class Il extends hr {
        constructor(e, t, n, i = 1) {
          "number" == typeof n &&
            ((i = n),
            (n = !1),
            console.error(
              "THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument."
            )),
            super(e, t, n),
            (this.meshPerAttribute = i);
        }
        copy(e) {
          return (
            super.copy(e), (this.meshPerAttribute = e.meshPerAttribute), this
          );
        }
        toJSON() {
          const e = super.toJSON();
          return (
            (e.meshPerAttribute = this.meshPerAttribute),
            (e.isInstancedBufferAttribute = !0),
            e
          );
        }
      }
      Il.prototype.isInstancedBufferAttribute = !0;
      const Nl = new gi(),
        Dl = new gi(),
        Ol = [],
        Fl = new Br();
      class kl extends Br {
        constructor(e, t, n) {
          super(e, t),
            (this.instanceMatrix = new Il(new Float32Array(16 * n), 16)),
            (this.instanceColor = null),
            (this.count = n),
            (this.frustumCulled = !1);
        }
        copy(e) {
          return (
            super.copy(e),
            this.instanceMatrix.copy(e.instanceMatrix),
            null !== e.instanceColor &&
              (this.instanceColor = e.instanceColor.clone()),
            (this.count = e.count),
            this
          );
        }
        getColorAt(e, t) {
          t.fromArray(this.instanceColor.array, 3 * e);
        }
        getMatrixAt(e, t) {
          t.fromArray(this.instanceMatrix.array, 16 * e);
        }
        raycast(e, t) {
          const n = this.matrixWorld,
            i = this.count;
          if (
            ((Fl.geometry = this.geometry),
            (Fl.material = this.material),
            void 0 !== Fl.material)
          )
            for (let r = 0; r < i; r++) {
              this.getMatrixAt(r, Nl),
                Dl.multiplyMatrices(n, Nl),
                (Fl.matrixWorld = Dl),
                Fl.raycast(e, Ol);
              for (let e = 0, n = Ol.length; e < n; e++) {
                const n = Ol[e];
                (n.instanceId = r), (n.object = this), t.push(n);
              }
              Ol.length = 0;
            }
        }
        setColorAt(e, t) {
          null === this.instanceColor &&
            (this.instanceColor = new Il(
              new Float32Array(3 * this.instanceMatrix.count),
              3
            )),
            t.toArray(this.instanceColor.array, 3 * e);
        }
        setMatrixAt(e, t) {
          t.toArray(this.instanceMatrix.array, 16 * e);
        }
        updateMorphTargets() {}
        dispose() {
          this.dispatchEvent({ type: "dispose" });
        }
      }
      kl.prototype.isInstancedMesh = !0;
      class Hl extends er {
        constructor(e) {
          super(),
            (this.type = "LineBasicMaterial"),
            (this.color = new sr(16777215)),
            (this.linewidth = 1),
            (this.linecap = "round"),
            (this.linejoin = "round"),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.linewidth = e.linewidth),
            (this.linecap = e.linecap),
            (this.linejoin = e.linejoin),
            this
          );
        }
      }
      Hl.prototype.isLineBasicMaterial = !0;
      const zl = new zn(),
        Ul = new zn(),
        Bl = new gi(),
        Gl = new fi(),
        Vl = new si();
      class Wl extends Bi {
        constructor(e = new Mr(), t = new Hl()) {
          super(),
            (this.type = "Line"),
            (this.geometry = e),
            (this.material = t),
            this.updateMorphTargets();
        }
        copy(e) {
          return (
            super.copy(e),
            (this.material = e.material),
            (this.geometry = e.geometry),
            this
          );
        }
        computeLineDistances() {
          const e = this.geometry;
          if (e.isBufferGeometry)
            if (null === e.index) {
              const t = e.attributes.position,
                n = [0];
              for (let e = 1, i = t.count; e < i; e++)
                zl.fromBufferAttribute(t, e - 1),
                  Ul.fromBufferAttribute(t, e),
                  (n[e] = n[e - 1]),
                  (n[e] += zl.distanceTo(Ul));
              e.setAttribute("lineDistance", new mr(n, 1));
            } else
              console.warn(
                "THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry."
              );
          else
            e.isGeometry &&
              console.error(
                "THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead."
              );
          return this;
        }
        raycast(e, t) {
          const n = this.geometry,
            i = this.matrixWorld,
            r = e.params.Line.threshold,
            a = n.drawRange;
          if (
            (null === n.boundingSphere && n.computeBoundingSphere(),
            Vl.copy(n.boundingSphere),
            Vl.applyMatrix4(i),
            (Vl.radius += r),
            !1 === e.ray.intersectsSphere(Vl))
          )
            return;
          Bl.copy(i).invert(), Gl.copy(e.ray).applyMatrix4(Bl);
          const o = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
            s = o * o,
            l = new zn(),
            c = new zn(),
            u = new zn(),
            h = new zn(),
            d = this.isLineSegments ? 2 : 1;
          if (n.isBufferGeometry) {
            const i = n.index,
              r = n.attributes.position;
            if (null !== i) {
              for (
                let n = Math.max(0, a.start),
                  o = Math.min(i.count, a.start + a.count) - 1;
                n < o;
                n += d
              ) {
                const a = i.getX(n),
                  o = i.getX(n + 1);
                l.fromBufferAttribute(r, a), c.fromBufferAttribute(r, o);
                if (Gl.distanceSqToSegment(l, c, h, u) > s) continue;
                h.applyMatrix4(this.matrixWorld);
                const d = e.ray.origin.distanceTo(h);
                d < e.near ||
                  d > e.far ||
                  t.push({
                    distance: d,
                    point: u.clone().applyMatrix4(this.matrixWorld),
                    index: n,
                    face: null,
                    faceIndex: null,
                    object: this,
                  });
              }
            } else {
              for (
                let n = Math.max(0, a.start),
                  i = Math.min(r.count, a.start + a.count) - 1;
                n < i;
                n += d
              ) {
                l.fromBufferAttribute(r, n), c.fromBufferAttribute(r, n + 1);
                if (Gl.distanceSqToSegment(l, c, h, u) > s) continue;
                h.applyMatrix4(this.matrixWorld);
                const i = e.ray.origin.distanceTo(h);
                i < e.near ||
                  i > e.far ||
                  t.push({
                    distance: i,
                    point: u.clone().applyMatrix4(this.matrixWorld),
                    index: n,
                    face: null,
                    faceIndex: null,
                    object: this,
                  });
              }
            }
          } else
            n.isGeometry &&
              console.error(
                "THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead."
              );
        }
        updateMorphTargets() {
          const e = this.geometry;
          if (e.isBufferGeometry) {
            const t = e.morphAttributes,
              n = Object.keys(t);
            if (n.length > 0) {
              const e = t[n[0]];
              if (void 0 !== e) {
                (this.morphTargetInfluences = []),
                  (this.morphTargetDictionary = {});
                for (let t = 0, n = e.length; t < n; t++) {
                  const n = e[t].name || String(t);
                  this.morphTargetInfluences.push(0),
                    (this.morphTargetDictionary[n] = t);
                }
              }
            }
          } else {
            const t = e.morphTargets;
            void 0 !== t &&
              t.length > 0 &&
              console.error(
                "THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead."
              );
          }
        }
      }
      Wl.prototype.isLine = !0;
      const jl = new zn(),
        Xl = new zn();
      class ql extends Wl {
        constructor(e, t) {
          super(e, t), (this.type = "LineSegments");
        }
        computeLineDistances() {
          const e = this.geometry;
          if (e.isBufferGeometry)
            if (null === e.index) {
              const t = e.attributes.position,
                n = [];
              for (let e = 0, i = t.count; e < i; e += 2)
                jl.fromBufferAttribute(t, e),
                  Xl.fromBufferAttribute(t, e + 1),
                  (n[e] = 0 === e ? 0 : n[e - 1]),
                  (n[e + 1] = n[e] + jl.distanceTo(Xl));
              e.setAttribute("lineDistance", new mr(n, 1));
            } else
              console.warn(
                "THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry."
              );
          else
            e.isGeometry &&
              console.error(
                "THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead."
              );
          return this;
        }
      }
      ql.prototype.isLineSegments = !0;
      class Yl extends Wl {
        constructor(e, t) {
          super(e, t), (this.type = "LineLoop");
        }
      }
      Yl.prototype.isLineLoop = !0;
      class Kl extends er {
        constructor(e) {
          super(),
            (this.type = "PointsMaterial"),
            (this.color = new sr(16777215)),
            (this.map = null),
            (this.alphaMap = null),
            (this.size = 1),
            (this.sizeAttenuation = !0),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.map = e.map),
            (this.alphaMap = e.alphaMap),
            (this.size = e.size),
            (this.sizeAttenuation = e.sizeAttenuation),
            this
          );
        }
      }
      Kl.prototype.isPointsMaterial = !0;
      const Zl = new gi(),
        Jl = new fi(),
        Ql = new si(),
        $l = new zn();
      class ec extends Bi {
        constructor(e = new Mr(), t = new Kl()) {
          super(),
            (this.type = "Points"),
            (this.geometry = e),
            (this.material = t),
            this.updateMorphTargets();
        }
        copy(e) {
          return (
            super.copy(e),
            (this.material = e.material),
            (this.geometry = e.geometry),
            this
          );
        }
        raycast(e, t) {
          const n = this.geometry,
            i = this.matrixWorld,
            r = e.params.Points.threshold,
            a = n.drawRange;
          if (
            (null === n.boundingSphere && n.computeBoundingSphere(),
            Ql.copy(n.boundingSphere),
            Ql.applyMatrix4(i),
            (Ql.radius += r),
            !1 === e.ray.intersectsSphere(Ql))
          )
            return;
          Zl.copy(i).invert(), Jl.copy(e.ray).applyMatrix4(Zl);
          const o = r / ((this.scale.x + this.scale.y + this.scale.z) / 3),
            s = o * o;
          if (n.isBufferGeometry) {
            const r = n.index,
              o = n.attributes.position;
            if (null !== r) {
              for (
                let n = Math.max(0, a.start),
                  l = Math.min(r.count, a.start + a.count);
                n < l;
                n++
              ) {
                const a = r.getX(n);
                $l.fromBufferAttribute(o, a), tc($l, a, s, i, e, t, this);
              }
            } else {
              for (
                let n = Math.max(0, a.start),
                  r = Math.min(o.count, a.start + a.count);
                n < r;
                n++
              )
                $l.fromBufferAttribute(o, n), tc($l, n, s, i, e, t, this);
            }
          } else
            console.error(
              "THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead."
            );
        }
        updateMorphTargets() {
          const e = this.geometry;
          if (e.isBufferGeometry) {
            const t = e.morphAttributes,
              n = Object.keys(t);
            if (n.length > 0) {
              const e = t[n[0]];
              if (void 0 !== e) {
                (this.morphTargetInfluences = []),
                  (this.morphTargetDictionary = {});
                for (let t = 0, n = e.length; t < n; t++) {
                  const n = e[t].name || String(t);
                  this.morphTargetInfluences.push(0),
                    (this.morphTargetDictionary[n] = t);
                }
              }
            }
          } else {
            const t = e.morphTargets;
            void 0 !== t &&
              t.length > 0 &&
              console.error(
                "THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead."
              );
          }
        }
      }
      function tc(e, t, n, i, r, a, o) {
        const s = Jl.distanceSqToPoint(e);
        if (s < n) {
          const n = new zn();
          Jl.closestPointToPoint(e, n), n.applyMatrix4(i);
          const l = r.ray.origin.distanceTo(n);
          if (l < r.near || l > r.far) return;
          a.push({
            distance: l,
            distanceToRay: Math.sqrt(s),
            point: n,
            index: t,
            face: null,
            object: o,
          });
        }
      }
      ec.prototype.isPoints = !0;
      (class extends Nn {
        constructor(e, t, n, i, r, a, o, s, l) {
          super(e, t, n, i, r, a, o, s, l),
            (this.format = void 0 !== o ? o : Xe),
            (this.minFilter = void 0 !== a ? a : Re),
            (this.magFilter = void 0 !== r ? r : Re),
            (this.generateMipmaps = !1);
          const c = this;
          "requestVideoFrameCallback" in e &&
            e.requestVideoFrameCallback(function t() {
              (c.needsUpdate = !0), e.requestVideoFrameCallback(t);
            });
        }
        clone() {
          return new this.constructor(this.image).copy(this);
        }
        update() {
          const e = this.image;
          !1 === "requestVideoFrameCallback" in e &&
            e.readyState >= e.HAVE_CURRENT_DATA &&
            (this.needsUpdate = !0);
        }
      }).prototype.isVideoTexture = !0;
      class nc extends Nn {
        constructor(e, t, n, i, r, a, o, s, l, c, u, h) {
          super(null, a, o, s, l, c, i, r, u, h),
            (this.image = { width: t, height: n }),
            (this.mipmaps = e),
            (this.flipY = !1),
            (this.generateMipmaps = !1);
        }
      }
      nc.prototype.isCompressedTexture = !0;
      (class extends Nn {
        constructor(e, t, n, i, r, a, o, s, l) {
          super(e, t, n, i, r, a, o, s, l), (this.needsUpdate = !0);
        }
      }).prototype.isCanvasTexture = !0;
      (class extends Nn {
        constructor(e, t, n, i, r, a, o, s, l, c) {
          if ((c = void 0 !== c ? c : Je) !== Je && c !== Qe)
            throw new Error(
              "DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat"
            );
          void 0 === n && c === Je && (n = Fe),
            void 0 === n && c === Qe && (n = We),
            super(null, i, r, a, o, s, c, n, l),
            (this.image = { width: e, height: t }),
            (this.magFilter = void 0 !== o ? o : Ae),
            (this.minFilter = void 0 !== s ? s : Ae),
            (this.flipY = !1),
            (this.generateMipmaps = !1);
        }
      }).prototype.isDepthTexture = !0;
      new zn(), new zn(), new zn(), new Qi();
      class ic {
        constructor() {
          (this.type = "Curve"), (this.arcLengthDivisions = 200);
        }
        getPoint() {
          return (
            console.warn("THREE.Curve: .getPoint() not implemented."), null
          );
        }
        getPointAt(e, t) {
          const n = this.getUtoTmapping(e);
          return this.getPoint(n, t);
        }
        getPoints(e = 5) {
          const t = [];
          for (let n = 0; n <= e; n++) t.push(this.getPoint(n / e));
          return t;
        }
        getSpacedPoints(e = 5) {
          const t = [];
          for (let n = 0; n <= e; n++) t.push(this.getPointAt(n / e));
          return t;
        }
        getLength() {
          const e = this.getLengths();
          return e[e.length - 1];
        }
        getLengths(e = this.arcLengthDivisions) {
          if (
            this.cacheArcLengths &&
            this.cacheArcLengths.length === e + 1 &&
            !this.needsUpdate
          )
            return this.cacheArcLengths;
          this.needsUpdate = !1;
          const t = [];
          let n,
            i = this.getPoint(0),
            r = 0;
          t.push(0);
          for (let a = 1; a <= e; a++)
            (n = this.getPoint(a / e)),
              (r += n.distanceTo(i)),
              t.push(r),
              (i = n);
          return (this.cacheArcLengths = t), t;
        }
        updateArcLengths() {
          (this.needsUpdate = !0), this.getLengths();
        }
        getUtoTmapping(e, t) {
          const n = this.getLengths();
          let i = 0;
          const r = n.length;
          let a;
          a = t || e * n[r - 1];
          let o,
            s = 0,
            l = r - 1;
          for (; s <= l; )
            if (((i = Math.floor(s + (l - s) / 2)), (o = n[i] - a), o < 0))
              s = i + 1;
            else {
              if (!(o > 0)) {
                l = i;
                break;
              }
              l = i - 1;
            }
          if (((i = l), n[i] === a)) return i / (r - 1);
          const c = n[i];
          return (i + (a - c) / (n[i + 1] - c)) / (r - 1);
        }
        getTangent(e, t) {
          const n = 1e-4;
          let i = e - n,
            r = e + n;
          i < 0 && (i = 0), r > 1 && (r = 1);
          const a = this.getPoint(i),
            o = this.getPoint(r),
            s = t || (a.isVector2 ? new Ln() : new zn());
          return s.copy(o).sub(a).normalize(), s;
        }
        getTangentAt(e, t) {
          const n = this.getUtoTmapping(e);
          return this.getTangent(n, t);
        }
        computeFrenetFrames(e, t) {
          const n = new zn(),
            i = [],
            r = [],
            a = [],
            o = new zn(),
            s = new gi();
          for (let t = 0; t <= e; t++) {
            const n = t / e;
            (i[t] = this.getTangentAt(n, new zn())), i[t].normalize();
          }
          (r[0] = new zn()), (a[0] = new zn());
          let l = Number.MAX_VALUE;
          const c = Math.abs(i[0].x),
            u = Math.abs(i[0].y),
            h = Math.abs(i[0].z);
          c <= l && ((l = c), n.set(1, 0, 0)),
            u <= l && ((l = u), n.set(0, 1, 0)),
            h <= l && n.set(0, 0, 1),
            o.crossVectors(i[0], n).normalize(),
            r[0].crossVectors(i[0], o),
            a[0].crossVectors(i[0], r[0]);
          for (let t = 1; t <= e; t++) {
            if (
              ((r[t] = r[t - 1].clone()),
              (a[t] = a[t - 1].clone()),
              o.crossVectors(i[t - 1], i[t]),
              o.length() > Number.EPSILON)
            ) {
              o.normalize();
              const e = Math.acos(_n(i[t - 1].dot(i[t]), -1, 1));
              r[t].applyMatrix4(s.makeRotationAxis(o, e));
            }
            a[t].crossVectors(i[t], r[t]);
          }
          if (!0 === t) {
            let t = Math.acos(_n(r[0].dot(r[e]), -1, 1));
            (t /= e), i[0].dot(o.crossVectors(r[0], r[e])) > 0 && (t = -t);
            for (let n = 1; n <= e; n++)
              r[n].applyMatrix4(s.makeRotationAxis(i[n], t * n)),
                a[n].crossVectors(i[n], r[n]);
          }
          return { tangents: i, normals: r, binormals: a };
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          return (this.arcLengthDivisions = e.arcLengthDivisions), this;
        }
        toJSON() {
          const e = {
            metadata: {
              version: 4.5,
              type: "Curve",
              generator: "Curve.toJSON",
            },
          };
          return (
            (e.arcLengthDivisions = this.arcLengthDivisions),
            (e.type = this.type),
            e
          );
        }
        fromJSON(e) {
          return (this.arcLengthDivisions = e.arcLengthDivisions), this;
        }
      }
      class rc extends ic {
        constructor(
          e = 0,
          t = 0,
          n = 1,
          i = 1,
          r = 0,
          a = 2 * Math.PI,
          o = !1,
          s = 0
        ) {
          super(),
            (this.type = "EllipseCurve"),
            (this.aX = e),
            (this.aY = t),
            (this.xRadius = n),
            (this.yRadius = i),
            (this.aStartAngle = r),
            (this.aEndAngle = a),
            (this.aClockwise = o),
            (this.aRotation = s);
        }
        getPoint(e, t) {
          const n = t || new Ln(),
            i = 2 * Math.PI;
          let r = this.aEndAngle - this.aStartAngle;
          const a = Math.abs(r) < Number.EPSILON;
          for (; r < 0; ) r += i;
          for (; r > i; ) r -= i;
          r < Number.EPSILON && (r = a ? 0 : i),
            !0 !== this.aClockwise || a || (r === i ? (r = -i) : (r -= i));
          const o = this.aStartAngle + e * r;
          let s = this.aX + this.xRadius * Math.cos(o),
            l = this.aY + this.yRadius * Math.sin(o);
          if (0 !== this.aRotation) {
            const e = Math.cos(this.aRotation),
              t = Math.sin(this.aRotation),
              n = s - this.aX,
              i = l - this.aY;
            (s = n * e - i * t + this.aX), (l = n * t + i * e + this.aY);
          }
          return n.set(s, l);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.aX = e.aX),
            (this.aY = e.aY),
            (this.xRadius = e.xRadius),
            (this.yRadius = e.yRadius),
            (this.aStartAngle = e.aStartAngle),
            (this.aEndAngle = e.aEndAngle),
            (this.aClockwise = e.aClockwise),
            (this.aRotation = e.aRotation),
            this
          );
        }
        toJSON() {
          const e = super.toJSON();
          return (
            (e.aX = this.aX),
            (e.aY = this.aY),
            (e.xRadius = this.xRadius),
            (e.yRadius = this.yRadius),
            (e.aStartAngle = this.aStartAngle),
            (e.aEndAngle = this.aEndAngle),
            (e.aClockwise = this.aClockwise),
            (e.aRotation = this.aRotation),
            e
          );
        }
        fromJSON(e) {
          return (
            super.fromJSON(e),
            (this.aX = e.aX),
            (this.aY = e.aY),
            (this.xRadius = e.xRadius),
            (this.yRadius = e.yRadius),
            (this.aStartAngle = e.aStartAngle),
            (this.aEndAngle = e.aEndAngle),
            (this.aClockwise = e.aClockwise),
            (this.aRotation = e.aRotation),
            this
          );
        }
      }
      rc.prototype.isEllipseCurve = !0;
      class ac extends rc {
        constructor(e, t, n, i, r, a) {
          super(e, t, n, n, i, r, a), (this.type = "ArcCurve");
        }
      }
      function oc() {
        let e = 0,
          t = 0,
          n = 0,
          i = 0;
        function r(r, a, o, s) {
          (e = r),
            (t = o),
            (n = -3 * r + 3 * a - 2 * o - s),
            (i = 2 * r - 2 * a + o + s);
        }
        return {
          initCatmullRom: function (e, t, n, i, a) {
            r(t, n, a * (n - e), a * (i - t));
          },
          initNonuniformCatmullRom: function (e, t, n, i, a, o, s) {
            let l = (t - e) / a - (n - e) / (a + o) + (n - t) / o,
              c = (n - t) / o - (i - t) / (o + s) + (i - n) / s;
            (l *= o), (c *= o), r(t, n, l, c);
          },
          calc: function (r) {
            const a = r * r;
            return e + t * r + n * a + i * (a * r);
          },
        };
      }
      ac.prototype.isArcCurve = !0;
      const sc = new zn(),
        lc = new oc(),
        cc = new oc(),
        uc = new oc();
      class hc extends ic {
        constructor(e = [], t = !1, n = "centripetal", i = 0.5) {
          super(),
            (this.type = "CatmullRomCurve3"),
            (this.points = e),
            (this.closed = t),
            (this.curveType = n),
            (this.tension = i);
        }
        getPoint(e, t = new zn()) {
          const n = t,
            i = this.points,
            r = i.length,
            a = (r - (this.closed ? 0 : 1)) * e;
          let o,
            s,
            l = Math.floor(a),
            c = a - l;
          this.closed
            ? (l += l > 0 ? 0 : (Math.floor(Math.abs(l) / r) + 1) * r)
            : 0 === c && l === r - 1 && ((l = r - 2), (c = 1)),
            this.closed || l > 0
              ? (o = i[(l - 1) % r])
              : (sc.subVectors(i[0], i[1]).add(i[0]), (o = sc));
          const u = i[l % r],
            h = i[(l + 1) % r];
          if (
            (this.closed || l + 2 < r
              ? (s = i[(l + 2) % r])
              : (sc.subVectors(i[r - 1], i[r - 2]).add(i[r - 1]), (s = sc)),
            "centripetal" === this.curveType || "chordal" === this.curveType)
          ) {
            const e = "chordal" === this.curveType ? 0.5 : 0.25;
            let t = Math.pow(o.distanceToSquared(u), e),
              n = Math.pow(u.distanceToSquared(h), e),
              i = Math.pow(h.distanceToSquared(s), e);
            n < 1e-4 && (n = 1),
              t < 1e-4 && (t = n),
              i < 1e-4 && (i = n),
              lc.initNonuniformCatmullRom(o.x, u.x, h.x, s.x, t, n, i),
              cc.initNonuniformCatmullRom(o.y, u.y, h.y, s.y, t, n, i),
              uc.initNonuniformCatmullRom(o.z, u.z, h.z, s.z, t, n, i);
          } else
            "catmullrom" === this.curveType &&
              (lc.initCatmullRom(o.x, u.x, h.x, s.x, this.tension),
              cc.initCatmullRom(o.y, u.y, h.y, s.y, this.tension),
              uc.initCatmullRom(o.z, u.z, h.z, s.z, this.tension));
          return n.set(lc.calc(c), cc.calc(c), uc.calc(c)), n;
        }
        copy(e) {
          super.copy(e), (this.points = []);
          for (let t = 0, n = e.points.length; t < n; t++) {
            const n = e.points[t];
            this.points.push(n.clone());
          }
          return (
            (this.closed = e.closed),
            (this.curveType = e.curveType),
            (this.tension = e.tension),
            this
          );
        }
        toJSON() {
          const e = super.toJSON();
          e.points = [];
          for (let t = 0, n = this.points.length; t < n; t++) {
            const n = this.points[t];
            e.points.push(n.toArray());
          }
          return (
            (e.closed = this.closed),
            (e.curveType = this.curveType),
            (e.tension = this.tension),
            e
          );
        }
        fromJSON(e) {
          super.fromJSON(e), (this.points = []);
          for (let t = 0, n = e.points.length; t < n; t++) {
            const n = e.points[t];
            this.points.push(new zn().fromArray(n));
          }
          return (
            (this.closed = e.closed),
            (this.curveType = e.curveType),
            (this.tension = e.tension),
            this
          );
        }
      }
      function dc(e, t, n, i, r) {
        const a = 0.5 * (i - t),
          o = 0.5 * (r - n),
          s = e * e;
        return (
          (2 * n - 2 * i + a + o) * (e * s) +
          (-3 * n + 3 * i - 2 * a - o) * s +
          a * e +
          n
        );
      }
      function pc(e, t, n, i) {
        return (
          (function (e, t) {
            const n = 1 - e;
            return n * n * t;
          })(e, t) +
          (function (e, t) {
            return 2 * (1 - e) * e * t;
          })(e, n) +
          (function (e, t) {
            return e * e * t;
          })(e, i)
        );
      }
      function mc(e, t, n, i, r) {
        return (
          (function (e, t) {
            const n = 1 - e;
            return n * n * n * t;
          })(e, t) +
          (function (e, t) {
            const n = 1 - e;
            return 3 * n * n * e * t;
          })(e, n) +
          (function (e, t) {
            return 3 * (1 - e) * e * e * t;
          })(e, i) +
          (function (e, t) {
            return e * e * e * t;
          })(e, r)
        );
      }
      hc.prototype.isCatmullRomCurve3 = !0;
      class fc extends ic {
        constructor(e = new Ln(), t = new Ln(), n = new Ln(), i = new Ln()) {
          super(),
            (this.type = "CubicBezierCurve"),
            (this.v0 = e),
            (this.v1 = t),
            (this.v2 = n),
            (this.v3 = i);
        }
        getPoint(e, t = new Ln()) {
          const n = t,
            i = this.v0,
            r = this.v1,
            a = this.v2,
            o = this.v3;
          return n.set(mc(e, i.x, r.x, a.x, o.x), mc(e, i.y, r.y, a.y, o.y)), n;
        }
        copy(e) {
          return (
            super.copy(e),
            this.v0.copy(e.v0),
            this.v1.copy(e.v1),
            this.v2.copy(e.v2),
            this.v3.copy(e.v3),
            this
          );
        }
        toJSON() {
          const e = super.toJSON();
          return (
            (e.v0 = this.v0.toArray()),
            (e.v1 = this.v1.toArray()),
            (e.v2 = this.v2.toArray()),
            (e.v3 = this.v3.toArray()),
            e
          );
        }
        fromJSON(e) {
          return (
            super.fromJSON(e),
            this.v0.fromArray(e.v0),
            this.v1.fromArray(e.v1),
            this.v2.fromArray(e.v2),
            this.v3.fromArray(e.v3),
            this
          );
        }
      }
      fc.prototype.isCubicBezierCurve = !0;
      class gc extends ic {
        constructor(e = new zn(), t = new zn(), n = new zn(), i = new zn()) {
          super(),
            (this.type = "CubicBezierCurve3"),
            (this.v0 = e),
            (this.v1 = t),
            (this.v2 = n),
            (this.v3 = i);
        }
        getPoint(e, t = new zn()) {
          const n = t,
            i = this.v0,
            r = this.v1,
            a = this.v2,
            o = this.v3;
          return (
            n.set(
              mc(e, i.x, r.x, a.x, o.x),
              mc(e, i.y, r.y, a.y, o.y),
              mc(e, i.z, r.z, a.z, o.z)
            ),
            n
          );
        }
        copy(e) {
          return (
            super.copy(e),
            this.v0.copy(e.v0),
            this.v1.copy(e.v1),
            this.v2.copy(e.v2),
            this.v3.copy(e.v3),
            this
          );
        }
        toJSON() {
          const e = super.toJSON();
          return (
            (e.v0 = this.v0.toArray()),
            (e.v1 = this.v1.toArray()),
            (e.v2 = this.v2.toArray()),
            (e.v3 = this.v3.toArray()),
            e
          );
        }
        fromJSON(e) {
          return (
            super.fromJSON(e),
            this.v0.fromArray(e.v0),
            this.v1.fromArray(e.v1),
            this.v2.fromArray(e.v2),
            this.v3.fromArray(e.v3),
            this
          );
        }
      }
      gc.prototype.isCubicBezierCurve3 = !0;
      class vc extends ic {
        constructor(e = new Ln(), t = new Ln()) {
          super(), (this.type = "LineCurve"), (this.v1 = e), (this.v2 = t);
        }
        getPoint(e, t = new Ln()) {
          const n = t;
          return (
            1 === e
              ? n.copy(this.v2)
              : (n.copy(this.v2).sub(this.v1),
                n.multiplyScalar(e).add(this.v1)),
            n
          );
        }
        getPointAt(e, t) {
          return this.getPoint(e, t);
        }
        getTangent(e, t) {
          const n = t || new Ln();
          return n.copy(this.v2).sub(this.v1).normalize(), n;
        }
        copy(e) {
          return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
        }
        toJSON() {
          const e = super.toJSON();
          return (e.v1 = this.v1.toArray()), (e.v2 = this.v2.toArray()), e;
        }
        fromJSON(e) {
          return (
            super.fromJSON(e),
            this.v1.fromArray(e.v1),
            this.v2.fromArray(e.v2),
            this
          );
        }
      }
      vc.prototype.isLineCurve = !0;
      class yc extends ic {
        constructor(e = new Ln(), t = new Ln(), n = new Ln()) {
          super(),
            (this.type = "QuadraticBezierCurve"),
            (this.v0 = e),
            (this.v1 = t),
            (this.v2 = n);
        }
        getPoint(e, t = new Ln()) {
          const n = t,
            i = this.v0,
            r = this.v1,
            a = this.v2;
          return n.set(pc(e, i.x, r.x, a.x), pc(e, i.y, r.y, a.y)), n;
        }
        copy(e) {
          return (
            super.copy(e),
            this.v0.copy(e.v0),
            this.v1.copy(e.v1),
            this.v2.copy(e.v2),
            this
          );
        }
        toJSON() {
          const e = super.toJSON();
          return (
            (e.v0 = this.v0.toArray()),
            (e.v1 = this.v1.toArray()),
            (e.v2 = this.v2.toArray()),
            e
          );
        }
        fromJSON(e) {
          return (
            super.fromJSON(e),
            this.v0.fromArray(e.v0),
            this.v1.fromArray(e.v1),
            this.v2.fromArray(e.v2),
            this
          );
        }
      }
      yc.prototype.isQuadraticBezierCurve = !0;
      class xc extends ic {
        constructor(e = new zn(), t = new zn(), n = new zn()) {
          super(),
            (this.type = "QuadraticBezierCurve3"),
            (this.v0 = e),
            (this.v1 = t),
            (this.v2 = n);
        }
        getPoint(e, t = new zn()) {
          const n = t,
            i = this.v0,
            r = this.v1,
            a = this.v2;
          return (
            n.set(
              pc(e, i.x, r.x, a.x),
              pc(e, i.y, r.y, a.y),
              pc(e, i.z, r.z, a.z)
            ),
            n
          );
        }
        copy(e) {
          return (
            super.copy(e),
            this.v0.copy(e.v0),
            this.v1.copy(e.v1),
            this.v2.copy(e.v2),
            this
          );
        }
        toJSON() {
          const e = super.toJSON();
          return (
            (e.v0 = this.v0.toArray()),
            (e.v1 = this.v1.toArray()),
            (e.v2 = this.v2.toArray()),
            e
          );
        }
        fromJSON(e) {
          return (
            super.fromJSON(e),
            this.v0.fromArray(e.v0),
            this.v1.fromArray(e.v1),
            this.v2.fromArray(e.v2),
            this
          );
        }
      }
      xc.prototype.isQuadraticBezierCurve3 = !0;
      class bc extends ic {
        constructor(e = []) {
          super(), (this.type = "SplineCurve"), (this.points = e);
        }
        getPoint(e, t = new Ln()) {
          const n = t,
            i = this.points,
            r = (i.length - 1) * e,
            a = Math.floor(r),
            o = r - a,
            s = i[0 === a ? a : a - 1],
            l = i[a],
            c = i[a > i.length - 2 ? i.length - 1 : a + 1],
            u = i[a > i.length - 3 ? i.length - 1 : a + 2];
          return n.set(dc(o, s.x, l.x, c.x, u.x), dc(o, s.y, l.y, c.y, u.y)), n;
        }
        copy(e) {
          super.copy(e), (this.points = []);
          for (let t = 0, n = e.points.length; t < n; t++) {
            const n = e.points[t];
            this.points.push(n.clone());
          }
          return this;
        }
        toJSON() {
          const e = super.toJSON();
          e.points = [];
          for (let t = 0, n = this.points.length; t < n; t++) {
            const n = this.points[t];
            e.points.push(n.toArray());
          }
          return e;
        }
        fromJSON(e) {
          super.fromJSON(e), (this.points = []);
          for (let t = 0, n = e.points.length; t < n; t++) {
            const n = e.points[t];
            this.points.push(new Ln().fromArray(n));
          }
          return this;
        }
      }
      bc.prototype.isSplineCurve = !0;
      var _c = Object.freeze({
        __proto__: null,
        ArcCurve: ac,
        CatmullRomCurve3: hc,
        CubicBezierCurve: fc,
        CubicBezierCurve3: gc,
        EllipseCurve: rc,
        LineCurve: vc,
        LineCurve3: class extends ic {
          constructor(e = new zn(), t = new zn()) {
            super(),
              (this.type = "LineCurve3"),
              (this.isLineCurve3 = !0),
              (this.v1 = e),
              (this.v2 = t);
          }
          getPoint(e, t = new zn()) {
            const n = t;
            return (
              1 === e
                ? n.copy(this.v2)
                : (n.copy(this.v2).sub(this.v1),
                  n.multiplyScalar(e).add(this.v1)),
              n
            );
          }
          getPointAt(e, t) {
            return this.getPoint(e, t);
          }
          copy(e) {
            return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this;
          }
          toJSON() {
            const e = super.toJSON();
            return (e.v1 = this.v1.toArray()), (e.v2 = this.v2.toArray()), e;
          }
          fromJSON(e) {
            return (
              super.fromJSON(e),
              this.v1.fromArray(e.v1),
              this.v2.fromArray(e.v2),
              this
            );
          }
        },
        QuadraticBezierCurve: yc,
        QuadraticBezierCurve3: xc,
        SplineCurve: bc,
      });
      const wc = function (e, t, n = 2) {
        const i = t && t.length,
          r = i ? t[0] * n : e.length;
        let a = Mc(e, 0, r, n, !0);
        const o = [];
        if (!a || a.next === a.prev) return o;
        let s, l, c, u, h, d, p;
        if (
          (i &&
            (a = (function (e, t, n, i) {
              const r = [];
              let a, o, s, l, c;
              for (a = 0, o = t.length; a < o; a++)
                (s = t[a] * i),
                  (l = a < o - 1 ? t[a + 1] * i : e.length),
                  (c = Mc(e, s, l, i, !1)),
                  c === c.next && (c.steiner = !0),
                  r.push(Dc(c));
              for (r.sort(Rc), a = 0; a < r.length; a++)
                Cc(r[a], n), (n = Sc(n, n.next));
              return n;
            })(e, t, a, n)),
          e.length > 80 * n)
        ) {
          (s = c = e[0]), (l = u = e[1]);
          for (let t = n; t < r; t += n)
            (h = e[t]),
              (d = e[t + 1]),
              h < s && (s = h),
              d < l && (l = d),
              h > c && (c = h),
              d > u && (u = d);
          (p = Math.max(c - s, u - l)), (p = 0 !== p ? 1 / p : 0);
        }
        return Tc(a, o, n, s, l, p), o;
      };
      function Mc(e, t, n, i, r) {
        let a, o;
        if (
          r ===
          (function (e, t, n, i) {
            let r = 0;
            for (let a = t, o = n - i; a < n; a += i)
              (r += (e[o] - e[a]) * (e[a + 1] + e[o + 1])), (o = a);
            return r;
          })(e, t, n, i) >
            0
        )
          for (a = t; a < n; a += i) o = Wc(a, e[a], e[a + 1], o);
        else for (a = n - i; a >= t; a -= i) o = Wc(a, e[a], e[a + 1], o);
        return o && Hc(o, o.next) && (jc(o), (o = o.next)), o;
      }
      function Sc(e, t) {
        if (!e) return e;
        t || (t = e);
        let n,
          i = e;
        do {
          if (
            ((n = !1),
            i.steiner || (!Hc(i, i.next) && 0 !== kc(i.prev, i, i.next)))
          )
            i = i.next;
          else {
            if ((jc(i), (i = t = i.prev), i === i.next)) break;
            n = !0;
          }
        } while (n || i !== t);
        return t;
      }
      function Tc(e, t, n, i, r, a, o) {
        if (!e) return;
        !o &&
          a &&
          (function (e, t, n, i) {
            let r = e;
            do {
              null === r.z && (r.z = Nc(r.x, r.y, t, n, i)),
                (r.prevZ = r.prev),
                (r.nextZ = r.next),
                (r = r.next);
            } while (r !== e);
            (r.prevZ.nextZ = null),
              (r.prevZ = null),
              (function (e) {
                let t,
                  n,
                  i,
                  r,
                  a,
                  o,
                  s,
                  l,
                  c = 1;
                do {
                  for (n = e, e = null, a = null, o = 0; n; ) {
                    for (
                      o++, i = n, s = 0, t = 0;
                      t < c && (s++, (i = i.nextZ), i);
                      t++
                    );
                    for (l = c; s > 0 || (l > 0 && i); )
                      0 !== s && (0 === l || !i || n.z <= i.z)
                        ? ((r = n), (n = n.nextZ), s--)
                        : ((r = i), (i = i.nextZ), l--),
                        a ? (a.nextZ = r) : (e = r),
                        (r.prevZ = a),
                        (a = r);
                    n = i;
                  }
                  (a.nextZ = null), (c *= 2);
                } while (o > 1);
              })(r);
          })(e, i, r, a);
        let s,
          l,
          c = e;
        for (; e.prev !== e.next; )
          if (((s = e.prev), (l = e.next), a ? Ac(e, i, r, a) : Ec(e)))
            t.push(s.i / n),
              t.push(e.i / n),
              t.push(l.i / n),
              jc(e),
              (e = l.next),
              (c = l.next);
          else if ((e = l) === c) {
            o
              ? 1 === o
                ? Tc((e = Lc(Sc(e), t, n)), t, n, i, r, a, 2)
                : 2 === o && Pc(e, t, n, i, r, a)
              : Tc(Sc(e), t, n, i, r, a, 1);
            break;
          }
      }
      function Ec(e) {
        const t = e.prev,
          n = e,
          i = e.next;
        if (kc(t, n, i) >= 0) return !1;
        let r = e.next.next;
        for (; r !== e.prev; ) {
          if (
            Oc(t.x, t.y, n.x, n.y, i.x, i.y, r.x, r.y) &&
            kc(r.prev, r, r.next) >= 0
          )
            return !1;
          r = r.next;
        }
        return !0;
      }
      function Ac(e, t, n, i) {
        const r = e.prev,
          a = e,
          o = e.next;
        if (kc(r, a, o) >= 0) return !1;
        const s = r.x < a.x ? (r.x < o.x ? r.x : o.x) : a.x < o.x ? a.x : o.x,
          l = r.y < a.y ? (r.y < o.y ? r.y : o.y) : a.y < o.y ? a.y : o.y,
          c = r.x > a.x ? (r.x > o.x ? r.x : o.x) : a.x > o.x ? a.x : o.x,
          u = r.y > a.y ? (r.y > o.y ? r.y : o.y) : a.y > o.y ? a.y : o.y,
          h = Nc(s, l, t, n, i),
          d = Nc(c, u, t, n, i);
        let p = e.prevZ,
          m = e.nextZ;
        for (; p && p.z >= h && m && m.z <= d; ) {
          if (
            p !== e.prev &&
            p !== e.next &&
            Oc(r.x, r.y, a.x, a.y, o.x, o.y, p.x, p.y) &&
            kc(p.prev, p, p.next) >= 0
          )
            return !1;
          if (
            ((p = p.prevZ),
            m !== e.prev &&
              m !== e.next &&
              Oc(r.x, r.y, a.x, a.y, o.x, o.y, m.x, m.y) &&
              kc(m.prev, m, m.next) >= 0)
          )
            return !1;
          m = m.nextZ;
        }
        for (; p && p.z >= h; ) {
          if (
            p !== e.prev &&
            p !== e.next &&
            Oc(r.x, r.y, a.x, a.y, o.x, o.y, p.x, p.y) &&
            kc(p.prev, p, p.next) >= 0
          )
            return !1;
          p = p.prevZ;
        }
        for (; m && m.z <= d; ) {
          if (
            m !== e.prev &&
            m !== e.next &&
            Oc(r.x, r.y, a.x, a.y, o.x, o.y, m.x, m.y) &&
            kc(m.prev, m, m.next) >= 0
          )
            return !1;
          m = m.nextZ;
        }
        return !0;
      }
      function Lc(e, t, n) {
        let i = e;
        do {
          const r = i.prev,
            a = i.next.next;
          !Hc(r, a) &&
            zc(r, i, i.next, a) &&
            Gc(r, a) &&
            Gc(a, r) &&
            (t.push(r.i / n),
            t.push(i.i / n),
            t.push(a.i / n),
            jc(i),
            jc(i.next),
            (i = e = a)),
            (i = i.next);
        } while (i !== e);
        return Sc(i);
      }
      function Pc(e, t, n, i, r, a) {
        let o = e;
        do {
          let e = o.next.next;
          for (; e !== o.prev; ) {
            if (o.i !== e.i && Fc(o, e)) {
              let s = Vc(o, e);
              return (
                (o = Sc(o, o.next)),
                (s = Sc(s, s.next)),
                Tc(o, t, n, i, r, a),
                void Tc(s, t, n, i, r, a)
              );
            }
            e = e.next;
          }
          o = o.next;
        } while (o !== e);
      }
      function Rc(e, t) {
        return e.x - t.x;
      }
      function Cc(e, t) {
        if (
          ((t = (function (e, t) {
            let n = t;
            const i = e.x,
              r = e.y;
            let a,
              o = -1 / 0;
            do {
              if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                const e =
                  n.x + ((r - n.y) * (n.next.x - n.x)) / (n.next.y - n.y);
                if (e <= i && e > o) {
                  if (((o = e), e === i)) {
                    if (r === n.y) return n;
                    if (r === n.next.y) return n.next;
                  }
                  a = n.x < n.next.x ? n : n.next;
                }
              }
              n = n.next;
            } while (n !== t);
            if (!a) return null;
            if (i === o) return a;
            const s = a,
              l = a.x,
              c = a.y;
            let u,
              h = 1 / 0;
            n = a;
            do {
              i >= n.x &&
                n.x >= l &&
                i !== n.x &&
                Oc(r < c ? i : o, r, l, c, r < c ? o : i, r, n.x, n.y) &&
                ((u = Math.abs(r - n.y) / (i - n.x)),
                Gc(n, e) &&
                  (u < h ||
                    (u === h && (n.x > a.x || (n.x === a.x && Ic(a, n))))) &&
                  ((a = n), (h = u))),
                (n = n.next);
            } while (n !== s);
            return a;
          })(e, t)),
          t)
        ) {
          const n = Vc(t, e);
          Sc(t, t.next), Sc(n, n.next);
        }
      }
      function Ic(e, t) {
        return kc(e.prev, e, t.prev) < 0 && kc(t.next, e, e.next) < 0;
      }
      function Nc(e, t, n, i, r) {
        return (
          (e =
            1431655765 &
            ((e =
              858993459 &
              ((e =
                252645135 &
                ((e = 16711935 & ((e = 32767 * (e - n) * r) | (e << 8))) |
                  (e << 4))) |
                (e << 2))) |
              (e << 1))) |
          ((t =
            1431655765 &
            ((t =
              858993459 &
              ((t =
                252645135 &
                ((t = 16711935 & ((t = 32767 * (t - i) * r) | (t << 8))) |
                  (t << 4))) |
                (t << 2))) |
              (t << 1))) <<
            1)
        );
      }
      function Dc(e) {
        let t = e,
          n = e;
        do {
          (t.x < n.x || (t.x === n.x && t.y < n.y)) && (n = t), (t = t.next);
        } while (t !== e);
        return n;
      }
      function Oc(e, t, n, i, r, a, o, s) {
        return (
          (r - o) * (t - s) - (e - o) * (a - s) >= 0 &&
          (e - o) * (i - s) - (n - o) * (t - s) >= 0 &&
          (n - o) * (a - s) - (r - o) * (i - s) >= 0
        );
      }
      function Fc(e, t) {
        return (
          e.next.i !== t.i &&
          e.prev.i !== t.i &&
          !(function (e, t) {
            let n = e;
            do {
              if (
                n.i !== e.i &&
                n.next.i !== e.i &&
                n.i !== t.i &&
                n.next.i !== t.i &&
                zc(n, n.next, e, t)
              )
                return !0;
              n = n.next;
            } while (n !== e);
            return !1;
          })(e, t) &&
          ((Gc(e, t) &&
            Gc(t, e) &&
            (function (e, t) {
              let n = e,
                i = !1;
              const r = (e.x + t.x) / 2,
                a = (e.y + t.y) / 2;
              do {
                n.y > a != n.next.y > a &&
                  n.next.y !== n.y &&
                  r < ((n.next.x - n.x) * (a - n.y)) / (n.next.y - n.y) + n.x &&
                  (i = !i),
                  (n = n.next);
              } while (n !== e);
              return i;
            })(e, t) &&
            (kc(e.prev, e, t.prev) || kc(e, t.prev, t))) ||
            (Hc(e, t) &&
              kc(e.prev, e, e.next) > 0 &&
              kc(t.prev, t, t.next) > 0))
        );
      }
      function kc(e, t, n) {
        return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
      }
      function Hc(e, t) {
        return e.x === t.x && e.y === t.y;
      }
      function zc(e, t, n, i) {
        const r = Bc(kc(e, t, n)),
          a = Bc(kc(e, t, i)),
          o = Bc(kc(n, i, e)),
          s = Bc(kc(n, i, t));
        return (
          (r !== a && o !== s) ||
          !(0 !== r || !Uc(e, n, t)) ||
          !(0 !== a || !Uc(e, i, t)) ||
          !(0 !== o || !Uc(n, e, i)) ||
          !(0 !== s || !Uc(n, t, i))
        );
      }
      function Uc(e, t, n) {
        return (
          t.x <= Math.max(e.x, n.x) &&
          t.x >= Math.min(e.x, n.x) &&
          t.y <= Math.max(e.y, n.y) &&
          t.y >= Math.min(e.y, n.y)
        );
      }
      function Bc(e) {
        return e > 0 ? 1 : e < 0 ? -1 : 0;
      }
      function Gc(e, t) {
        return kc(e.prev, e, e.next) < 0
          ? kc(e, t, e.next) >= 0 && kc(e, e.prev, t) >= 0
          : kc(e, t, e.prev) < 0 || kc(e, e.next, t) < 0;
      }
      function Vc(e, t) {
        const n = new Xc(e.i, e.x, e.y),
          i = new Xc(t.i, t.x, t.y),
          r = e.next,
          a = t.prev;
        return (
          (e.next = t),
          (t.prev = e),
          (n.next = r),
          (r.prev = n),
          (i.next = n),
          (n.prev = i),
          (a.next = i),
          (i.prev = a),
          i
        );
      }
      function Wc(e, t, n, i) {
        const r = new Xc(e, t, n);
        return (
          i
            ? ((r.next = i.next), (r.prev = i), (i.next.prev = r), (i.next = r))
            : ((r.prev = r), (r.next = r)),
          r
        );
      }
      function jc(e) {
        (e.next.prev = e.prev),
          (e.prev.next = e.next),
          e.prevZ && (e.prevZ.nextZ = e.nextZ),
          e.nextZ && (e.nextZ.prevZ = e.prevZ);
      }
      function Xc(e, t, n) {
        (this.i = e),
          (this.x = t),
          (this.y = n),
          (this.prev = null),
          (this.next = null),
          (this.z = null),
          (this.prevZ = null),
          (this.nextZ = null),
          (this.steiner = !1);
      }
      class qc {
        static area(e) {
          const t = e.length;
          let n = 0;
          for (let i = t - 1, r = 0; r < t; i = r++)
            n += e[i].x * e[r].y - e[r].x * e[i].y;
          return 0.5 * n;
        }
        static isClockWise(e) {
          return qc.area(e) < 0;
        }
        static triangulateShape(e, t) {
          const n = [],
            i = [],
            r = [];
          Yc(e), Kc(n, e);
          let a = e.length;
          t.forEach(Yc);
          for (let e = 0; e < t.length; e++)
            i.push(a), (a += t[e].length), Kc(n, t[e]);
          const o = wc(n, i);
          for (let e = 0; e < o.length; e += 3) r.push(o.slice(e, e + 3));
          return r;
        }
      }
      function Yc(e) {
        const t = e.length;
        t > 2 && e[t - 1].equals(e[0]) && e.pop();
      }
      function Kc(e, t) {
        for (let n = 0; n < t.length; n++) e.push(t[n].x), e.push(t[n].y);
      }
      class Zc extends Mr {
        constructor(e, t) {
          super(),
            (this.type = "ExtrudeGeometry"),
            (this.parameters = { shapes: e, options: t }),
            (e = Array.isArray(e) ? e : [e]);
          const n = this,
            i = [],
            r = [];
          for (let t = 0, n = e.length; t < n; t++) {
            a(e[t]);
          }
          function a(e) {
            const a = [],
              o = void 0 !== t.curveSegments ? t.curveSegments : 12,
              s = void 0 !== t.steps ? t.steps : 1;
            let l = void 0 !== t.depth ? t.depth : 100,
              c = void 0 === t.bevelEnabled || t.bevelEnabled,
              u = void 0 !== t.bevelThickness ? t.bevelThickness : 6,
              h = void 0 !== t.bevelSize ? t.bevelSize : u - 2,
              d = void 0 !== t.bevelOffset ? t.bevelOffset : 0,
              p = void 0 !== t.bevelSegments ? t.bevelSegments : 3;
            const m = t.extrudePath,
              f = void 0 !== t.UVGenerator ? t.UVGenerator : Jc;
            void 0 !== t.amount &&
              (console.warn(
                "THREE.ExtrudeBufferGeometry: amount has been renamed to depth."
              ),
              (l = t.amount));
            let g,
              v,
              y,
              x,
              b,
              _ = !1;
            m &&
              ((g = m.getSpacedPoints(s)),
              (_ = !0),
              (c = !1),
              (v = m.computeFrenetFrames(s, !1)),
              (y = new zn()),
              (x = new zn()),
              (b = new zn())),
              c || ((p = 0), (u = 0), (h = 0), (d = 0));
            const w = e.extractPoints(o);
            let M = w.shape;
            const S = w.holes;
            if (!qc.isClockWise(M)) {
              M = M.reverse();
              for (let e = 0, t = S.length; e < t; e++) {
                const t = S[e];
                qc.isClockWise(t) && (S[e] = t.reverse());
              }
            }
            const T = qc.triangulateShape(M, S),
              E = M;
            for (let e = 0, t = S.length; e < t; e++) {
              const t = S[e];
              M = M.concat(t);
            }
            function A(e, t, n) {
              return (
                t || console.error("THREE.ExtrudeGeometry: vec does not exist"),
                t.clone().multiplyScalar(n).add(e)
              );
            }
            const L = M.length,
              P = T.length;
            function R(e, t, n) {
              let i, r, a;
              const o = e.x - t.x,
                s = e.y - t.y,
                l = n.x - e.x,
                c = n.y - e.y,
                u = o * o + s * s,
                h = o * c - s * l;
              if (Math.abs(h) > Number.EPSILON) {
                const h = Math.sqrt(u),
                  d = Math.sqrt(l * l + c * c),
                  p = t.x - s / h,
                  m = t.y + o / h,
                  f =
                    ((n.x - c / d - p) * c - (n.y + l / d - m) * l) /
                    (o * c - s * l);
                (i = p + o * f - e.x), (r = m + s * f - e.y);
                const g = i * i + r * r;
                if (g <= 2) return new Ln(i, r);
                a = Math.sqrt(g / 2);
              } else {
                let e = !1;
                o > Number.EPSILON
                  ? l > Number.EPSILON && (e = !0)
                  : o < -Number.EPSILON
                  ? l < -Number.EPSILON && (e = !0)
                  : Math.sign(s) === Math.sign(c) && (e = !0),
                  e
                    ? ((i = -s), (r = o), (a = Math.sqrt(u)))
                    : ((i = o), (r = s), (a = Math.sqrt(u / 2)));
              }
              return new Ln(i / a, r / a);
            }
            const C = [];
            for (
              let e = 0, t = E.length, n = t - 1, i = e + 1;
              e < t;
              e++, n++, i++
            )
              n === t && (n = 0),
                i === t && (i = 0),
                (C[e] = R(E[e], E[n], E[i]));
            const I = [];
            let N,
              D = C.concat();
            for (let e = 0, t = S.length; e < t; e++) {
              const t = S[e];
              N = [];
              for (
                let e = 0, n = t.length, i = n - 1, r = e + 1;
                e < n;
                e++, i++, r++
              )
                i === n && (i = 0),
                  r === n && (r = 0),
                  (N[e] = R(t[e], t[i], t[r]));
              I.push(N), (D = D.concat(N));
            }
            for (let e = 0; e < p; e++) {
              const t = e / p,
                n = u * Math.cos((t * Math.PI) / 2),
                i = h * Math.sin((t * Math.PI) / 2) + d;
              for (let e = 0, t = E.length; e < t; e++) {
                const t = A(E[e], C[e], i);
                k(t.x, t.y, -n);
              }
              for (let e = 0, t = S.length; e < t; e++) {
                const t = S[e];
                N = I[e];
                for (let e = 0, r = t.length; e < r; e++) {
                  const r = A(t[e], N[e], i);
                  k(r.x, r.y, -n);
                }
              }
            }
            const O = h + d;
            for (let e = 0; e < L; e++) {
              const t = c ? A(M[e], D[e], O) : M[e];
              _
                ? (x.copy(v.normals[0]).multiplyScalar(t.x),
                  y.copy(v.binormals[0]).multiplyScalar(t.y),
                  b.copy(g[0]).add(x).add(y),
                  k(b.x, b.y, b.z))
                : k(t.x, t.y, 0);
            }
            for (let e = 1; e <= s; e++)
              for (let t = 0; t < L; t++) {
                const n = c ? A(M[t], D[t], O) : M[t];
                _
                  ? (x.copy(v.normals[e]).multiplyScalar(n.x),
                    y.copy(v.binormals[e]).multiplyScalar(n.y),
                    b.copy(g[e]).add(x).add(y),
                    k(b.x, b.y, b.z))
                  : k(n.x, n.y, (l / s) * e);
              }
            for (let e = p - 1; e >= 0; e--) {
              const t = e / p,
                n = u * Math.cos((t * Math.PI) / 2),
                i = h * Math.sin((t * Math.PI) / 2) + d;
              for (let e = 0, t = E.length; e < t; e++) {
                const t = A(E[e], C[e], i);
                k(t.x, t.y, l + n);
              }
              for (let e = 0, t = S.length; e < t; e++) {
                const t = S[e];
                N = I[e];
                for (let e = 0, r = t.length; e < r; e++) {
                  const r = A(t[e], N[e], i);
                  _
                    ? k(r.x, r.y + g[s - 1].y, g[s - 1].x + n)
                    : k(r.x, r.y, l + n);
                }
              }
            }
            function F(e, t) {
              let n = e.length;
              for (; --n >= 0; ) {
                const i = n;
                let r = n - 1;
                r < 0 && (r = e.length - 1);
                for (let e = 0, n = s + 2 * p; e < n; e++) {
                  const n = L * e,
                    a = L * (e + 1);
                  z(t + i + n, t + r + n, t + r + a, t + i + a);
                }
              }
            }
            function k(e, t, n) {
              a.push(e), a.push(t), a.push(n);
            }
            function H(e, t, r) {
              U(e), U(t), U(r);
              const a = i.length / 3,
                o = f.generateTopUV(n, i, a - 3, a - 2, a - 1);
              B(o[0]), B(o[1]), B(o[2]);
            }
            function z(e, t, r, a) {
              U(e), U(t), U(a), U(t), U(r), U(a);
              const o = i.length / 3,
                s = f.generateSideWallUV(n, i, o - 6, o - 3, o - 2, o - 1);
              B(s[0]), B(s[1]), B(s[3]), B(s[1]), B(s[2]), B(s[3]);
            }
            function U(e) {
              i.push(a[3 * e + 0]), i.push(a[3 * e + 1]), i.push(a[3 * e + 2]);
            }
            function B(e) {
              r.push(e.x), r.push(e.y);
            }
            !(function () {
              const e = i.length / 3;
              if (c) {
                let e = 0,
                  t = L * e;
                for (let e = 0; e < P; e++) {
                  const n = T[e];
                  H(n[2] + t, n[1] + t, n[0] + t);
                }
                (e = s + 2 * p), (t = L * e);
                for (let e = 0; e < P; e++) {
                  const n = T[e];
                  H(n[0] + t, n[1] + t, n[2] + t);
                }
              } else {
                for (let e = 0; e < P; e++) {
                  const t = T[e];
                  H(t[2], t[1], t[0]);
                }
                for (let e = 0; e < P; e++) {
                  const t = T[e];
                  H(t[0] + L * s, t[1] + L * s, t[2] + L * s);
                }
              }
              n.addGroup(e, i.length / 3 - e, 0);
            })(),
              (function () {
                const e = i.length / 3;
                let t = 0;
                F(E, t), (t += E.length);
                for (let e = 0, n = S.length; e < n; e++) {
                  const n = S[e];
                  F(n, t), (t += n.length);
                }
                n.addGroup(e, i.length / 3 - e, 1);
              })();
          }
          this.setAttribute("position", new mr(i, 3)),
            this.setAttribute("uv", new mr(r, 2)),
            this.computeVertexNormals();
        }
        toJSON() {
          const e = super.toJSON();
          return (function (e, t, n) {
            if (((n.shapes = []), Array.isArray(e)))
              for (let t = 0, i = e.length; t < i; t++) {
                const i = e[t];
                n.shapes.push(i.uuid);
              }
            else n.shapes.push(e.uuid);
            void 0 !== t.extrudePath &&
              (n.options.extrudePath = t.extrudePath.toJSON());
            return n;
          })(this.parameters.shapes, this.parameters.options, e);
        }
        static fromJSON(e, t) {
          const n = [];
          for (let i = 0, r = e.shapes.length; i < r; i++) {
            const r = t[e.shapes[i]];
            n.push(r);
          }
          const i = e.options.extrudePath;
          return (
            void 0 !== i &&
              (e.options.extrudePath = new _c[i.type]().fromJSON(i)),
            new Zc(n, e.options)
          );
        }
      }
      const Jc = {
        generateTopUV: function (e, t, n, i, r) {
          const a = t[3 * n],
            o = t[3 * n + 1],
            s = t[3 * i],
            l = t[3 * i + 1],
            c = t[3 * r],
            u = t[3 * r + 1];
          return [new Ln(a, o), new Ln(s, l), new Ln(c, u)];
        },
        generateSideWallUV: function (e, t, n, i, r, a) {
          const o = t[3 * n],
            s = t[3 * n + 1],
            l = t[3 * n + 2],
            c = t[3 * i],
            u = t[3 * i + 1],
            h = t[3 * i + 2],
            d = t[3 * r],
            p = t[3 * r + 1],
            m = t[3 * r + 2],
            f = t[3 * a],
            g = t[3 * a + 1],
            v = t[3 * a + 2];
          return Math.abs(s - u) < Math.abs(o - c)
            ? [
                new Ln(o, 1 - l),
                new Ln(c, 1 - h),
                new Ln(d, 1 - m),
                new Ln(f, 1 - v),
              ]
            : [
                new Ln(s, 1 - l),
                new Ln(u, 1 - h),
                new Ln(p, 1 - m),
                new Ln(g, 1 - v),
              ];
        },
      };
      class Qc extends Mr {
        constructor(e, t = 12) {
          super(),
            (this.type = "ShapeGeometry"),
            (this.parameters = { shapes: e, curveSegments: t });
          const n = [],
            i = [],
            r = [],
            a = [];
          let o = 0,
            s = 0;
          if (!1 === Array.isArray(e)) l(e);
          else
            for (let t = 0; t < e.length; t++)
              l(e[t]), this.addGroup(o, s, t), (o += s), (s = 0);
          function l(e) {
            const o = i.length / 3,
              l = e.extractPoints(t);
            let c = l.shape;
            const u = l.holes;
            !1 === qc.isClockWise(c) && (c = c.reverse());
            for (let e = 0, t = u.length; e < t; e++) {
              const t = u[e];
              !0 === qc.isClockWise(t) && (u[e] = t.reverse());
            }
            const h = qc.triangulateShape(c, u);
            for (let e = 0, t = u.length; e < t; e++) {
              const t = u[e];
              c = c.concat(t);
            }
            for (let e = 0, t = c.length; e < t; e++) {
              const t = c[e];
              i.push(t.x, t.y, 0), r.push(0, 0, 1), a.push(t.x, t.y);
            }
            for (let e = 0, t = h.length; e < t; e++) {
              const t = h[e],
                i = t[0] + o,
                r = t[1] + o,
                a = t[2] + o;
              n.push(i, r, a), (s += 3);
            }
          }
          this.setIndex(n),
            this.setAttribute("position", new mr(i, 3)),
            this.setAttribute("normal", new mr(r, 3)),
            this.setAttribute("uv", new mr(a, 2));
        }
        toJSON() {
          const e = super.toJSON();
          return (function (e, t) {
            if (((t.shapes = []), Array.isArray(e)))
              for (let n = 0, i = e.length; n < i; n++) {
                const i = e[n];
                t.shapes.push(i.uuid);
              }
            else t.shapes.push(e.uuid);
            return t;
          })(this.parameters.shapes, e);
        }
        static fromJSON(e, t) {
          const n = [];
          for (let i = 0, r = e.shapes.length; i < r; i++) {
            const r = t[e.shapes[i]];
            n.push(r);
          }
          return new Qc(n, e.curveSegments);
        }
      }
      class $c extends er {
        constructor(e) {
          super(),
            (this.type = "ShadowMaterial"),
            (this.color = new sr(0)),
            (this.transparent = !0),
            this.setValues(e);
        }
        copy(e) {
          return super.copy(e), this.color.copy(e.color), this;
        }
      }
      $c.prototype.isShadowMaterial = !0;
      class eu extends er {
        constructor(e) {
          super(),
            (this.defines = { STANDARD: "" }),
            (this.type = "MeshStandardMaterial"),
            (this.color = new sr(16777215)),
            (this.roughness = 1),
            (this.metalness = 0),
            (this.map = null),
            (this.lightMap = null),
            (this.lightMapIntensity = 1),
            (this.aoMap = null),
            (this.aoMapIntensity = 1),
            (this.emissive = new sr(0)),
            (this.emissiveIntensity = 1),
            (this.emissiveMap = null),
            (this.bumpMap = null),
            (this.bumpScale = 1),
            (this.normalMap = null),
            (this.normalMapType = cn),
            (this.normalScale = new Ln(1, 1)),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.roughnessMap = null),
            (this.metalnessMap = null),
            (this.alphaMap = null),
            (this.envMap = null),
            (this.envMapIntensity = 1),
            (this.refractionRatio = 0.98),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.wireframeLinecap = "round"),
            (this.wireframeLinejoin = "round"),
            (this.flatShading = !1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.defines = { STANDARD: "" }),
            this.color.copy(e.color),
            (this.roughness = e.roughness),
            (this.metalness = e.metalness),
            (this.map = e.map),
            (this.lightMap = e.lightMap),
            (this.lightMapIntensity = e.lightMapIntensity),
            (this.aoMap = e.aoMap),
            (this.aoMapIntensity = e.aoMapIntensity),
            this.emissive.copy(e.emissive),
            (this.emissiveMap = e.emissiveMap),
            (this.emissiveIntensity = e.emissiveIntensity),
            (this.bumpMap = e.bumpMap),
            (this.bumpScale = e.bumpScale),
            (this.normalMap = e.normalMap),
            (this.normalMapType = e.normalMapType),
            this.normalScale.copy(e.normalScale),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            (this.roughnessMap = e.roughnessMap),
            (this.metalnessMap = e.metalnessMap),
            (this.alphaMap = e.alphaMap),
            (this.envMap = e.envMap),
            (this.envMapIntensity = e.envMapIntensity),
            (this.refractionRatio = e.refractionRatio),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.wireframeLinecap = e.wireframeLinecap),
            (this.wireframeLinejoin = e.wireframeLinejoin),
            (this.flatShading = e.flatShading),
            this
          );
        }
      }
      eu.prototype.isMeshStandardMaterial = !0;
      class tu extends eu {
        constructor(e) {
          super(),
            (this.defines = { STANDARD: "", PHYSICAL: "" }),
            (this.type = "MeshPhysicalMaterial"),
            (this.clearcoatMap = null),
            (this.clearcoatRoughness = 0),
            (this.clearcoatRoughnessMap = null),
            (this.clearcoatNormalScale = new Ln(1, 1)),
            (this.clearcoatNormalMap = null),
            (this.ior = 1.5),
            Object.defineProperty(this, "reflectivity", {
              get: function () {
                return _n((2.5 * (this.ior - 1)) / (this.ior + 1), 0, 1);
              },
              set: function (e) {
                this.ior = (1 + 0.4 * e) / (1 - 0.4 * e);
              },
            }),
            (this.sheenTint = new sr(0)),
            (this.transmission = 0),
            (this.transmissionMap = null),
            (this.thickness = 0.01),
            (this.thicknessMap = null),
            (this.attenuationDistance = 0),
            (this.attenuationTint = new sr(1, 1, 1)),
            (this.specularIntensity = 1),
            (this.specularIntensityMap = null),
            (this.specularTint = new sr(1, 1, 1)),
            (this.specularTintMap = null),
            (this._clearcoat = 0),
            (this._transmission = 0),
            this.setValues(e);
        }
        get clearcoat() {
          return this._clearcoat;
        }
        set clearcoat(e) {
          this._clearcoat > 0 != e > 0 && this.version++, (this._clearcoat = e);
        }
        get transmission() {
          return this._transmission;
        }
        set transmission(e) {
          this._transmission > 0 != e > 0 && this.version++,
            (this._transmission = e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.defines = { STANDARD: "", PHYSICAL: "" }),
            (this.clearcoat = e.clearcoat),
            (this.clearcoatMap = e.clearcoatMap),
            (this.clearcoatRoughness = e.clearcoatRoughness),
            (this.clearcoatRoughnessMap = e.clearcoatRoughnessMap),
            (this.clearcoatNormalMap = e.clearcoatNormalMap),
            this.clearcoatNormalScale.copy(e.clearcoatNormalScale),
            (this.ior = e.ior),
            this.sheenTint.copy(e.sheenTint),
            (this.transmission = e.transmission),
            (this.transmissionMap = e.transmissionMap),
            (this.thickness = e.thickness),
            (this.thicknessMap = e.thicknessMap),
            (this.attenuationDistance = e.attenuationDistance),
            this.attenuationTint.copy(e.attenuationTint),
            (this.specularIntensity = e.specularIntensity),
            (this.specularIntensityMap = e.specularIntensityMap),
            this.specularTint.copy(e.specularTint),
            (this.specularTintMap = e.specularTintMap),
            this
          );
        }
      }
      tu.prototype.isMeshPhysicalMaterial = !0;
      class nu extends er {
        constructor(e) {
          super(),
            (this.type = "MeshPhongMaterial"),
            (this.color = new sr(16777215)),
            (this.specular = new sr(1118481)),
            (this.shininess = 30),
            (this.map = null),
            (this.lightMap = null),
            (this.lightMapIntensity = 1),
            (this.aoMap = null),
            (this.aoMapIntensity = 1),
            (this.emissive = new sr(0)),
            (this.emissiveIntensity = 1),
            (this.emissiveMap = null),
            (this.bumpMap = null),
            (this.bumpScale = 1),
            (this.normalMap = null),
            (this.normalMapType = cn),
            (this.normalScale = new Ln(1, 1)),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.specularMap = null),
            (this.alphaMap = null),
            (this.envMap = null),
            (this.combine = ce),
            (this.reflectivity = 1),
            (this.refractionRatio = 0.98),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.wireframeLinecap = "round"),
            (this.wireframeLinejoin = "round"),
            (this.flatShading = !1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            this.specular.copy(e.specular),
            (this.shininess = e.shininess),
            (this.map = e.map),
            (this.lightMap = e.lightMap),
            (this.lightMapIntensity = e.lightMapIntensity),
            (this.aoMap = e.aoMap),
            (this.aoMapIntensity = e.aoMapIntensity),
            this.emissive.copy(e.emissive),
            (this.emissiveMap = e.emissiveMap),
            (this.emissiveIntensity = e.emissiveIntensity),
            (this.bumpMap = e.bumpMap),
            (this.bumpScale = e.bumpScale),
            (this.normalMap = e.normalMap),
            (this.normalMapType = e.normalMapType),
            this.normalScale.copy(e.normalScale),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            (this.specularMap = e.specularMap),
            (this.alphaMap = e.alphaMap),
            (this.envMap = e.envMap),
            (this.combine = e.combine),
            (this.reflectivity = e.reflectivity),
            (this.refractionRatio = e.refractionRatio),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.wireframeLinecap = e.wireframeLinecap),
            (this.wireframeLinejoin = e.wireframeLinejoin),
            (this.flatShading = e.flatShading),
            this
          );
        }
      }
      nu.prototype.isMeshPhongMaterial = !0;
      class iu extends er {
        constructor(e) {
          super(),
            (this.defines = { TOON: "" }),
            (this.type = "MeshToonMaterial"),
            (this.color = new sr(16777215)),
            (this.map = null),
            (this.gradientMap = null),
            (this.lightMap = null),
            (this.lightMapIntensity = 1),
            (this.aoMap = null),
            (this.aoMapIntensity = 1),
            (this.emissive = new sr(0)),
            (this.emissiveIntensity = 1),
            (this.emissiveMap = null),
            (this.bumpMap = null),
            (this.bumpScale = 1),
            (this.normalMap = null),
            (this.normalMapType = cn),
            (this.normalScale = new Ln(1, 1)),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.alphaMap = null),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.wireframeLinecap = "round"),
            (this.wireframeLinejoin = "round"),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.map = e.map),
            (this.gradientMap = e.gradientMap),
            (this.lightMap = e.lightMap),
            (this.lightMapIntensity = e.lightMapIntensity),
            (this.aoMap = e.aoMap),
            (this.aoMapIntensity = e.aoMapIntensity),
            this.emissive.copy(e.emissive),
            (this.emissiveMap = e.emissiveMap),
            (this.emissiveIntensity = e.emissiveIntensity),
            (this.bumpMap = e.bumpMap),
            (this.bumpScale = e.bumpScale),
            (this.normalMap = e.normalMap),
            (this.normalMapType = e.normalMapType),
            this.normalScale.copy(e.normalScale),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            (this.alphaMap = e.alphaMap),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.wireframeLinecap = e.wireframeLinecap),
            (this.wireframeLinejoin = e.wireframeLinejoin),
            this
          );
        }
      }
      iu.prototype.isMeshToonMaterial = !0;
      class ru extends er {
        constructor(e) {
          super(),
            (this.type = "MeshNormalMaterial"),
            (this.bumpMap = null),
            (this.bumpScale = 1),
            (this.normalMap = null),
            (this.normalMapType = cn),
            (this.normalScale = new Ln(1, 1)),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.fog = !1),
            (this.flatShading = !1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.bumpMap = e.bumpMap),
            (this.bumpScale = e.bumpScale),
            (this.normalMap = e.normalMap),
            (this.normalMapType = e.normalMapType),
            this.normalScale.copy(e.normalScale),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.flatShading = e.flatShading),
            this
          );
        }
      }
      ru.prototype.isMeshNormalMaterial = !0;
      class au extends er {
        constructor(e) {
          super(),
            (this.type = "MeshLambertMaterial"),
            (this.color = new sr(16777215)),
            (this.map = null),
            (this.lightMap = null),
            (this.lightMapIntensity = 1),
            (this.aoMap = null),
            (this.aoMapIntensity = 1),
            (this.emissive = new sr(0)),
            (this.emissiveIntensity = 1),
            (this.emissiveMap = null),
            (this.specularMap = null),
            (this.alphaMap = null),
            (this.envMap = null),
            (this.combine = ce),
            (this.reflectivity = 1),
            (this.refractionRatio = 0.98),
            (this.wireframe = !1),
            (this.wireframeLinewidth = 1),
            (this.wireframeLinecap = "round"),
            (this.wireframeLinejoin = "round"),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.map = e.map),
            (this.lightMap = e.lightMap),
            (this.lightMapIntensity = e.lightMapIntensity),
            (this.aoMap = e.aoMap),
            (this.aoMapIntensity = e.aoMapIntensity),
            this.emissive.copy(e.emissive),
            (this.emissiveMap = e.emissiveMap),
            (this.emissiveIntensity = e.emissiveIntensity),
            (this.specularMap = e.specularMap),
            (this.alphaMap = e.alphaMap),
            (this.envMap = e.envMap),
            (this.combine = e.combine),
            (this.reflectivity = e.reflectivity),
            (this.refractionRatio = e.refractionRatio),
            (this.wireframe = e.wireframe),
            (this.wireframeLinewidth = e.wireframeLinewidth),
            (this.wireframeLinecap = e.wireframeLinecap),
            (this.wireframeLinejoin = e.wireframeLinejoin),
            this
          );
        }
      }
      au.prototype.isMeshLambertMaterial = !0;
      class ou extends er {
        constructor(e) {
          super(),
            (this.defines = { MATCAP: "" }),
            (this.type = "MeshMatcapMaterial"),
            (this.color = new sr(16777215)),
            (this.matcap = null),
            (this.map = null),
            (this.bumpMap = null),
            (this.bumpScale = 1),
            (this.normalMap = null),
            (this.normalMapType = cn),
            (this.normalScale = new Ln(1, 1)),
            (this.displacementMap = null),
            (this.displacementScale = 1),
            (this.displacementBias = 0),
            (this.alphaMap = null),
            (this.flatShading = !1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.defines = { MATCAP: "" }),
            this.color.copy(e.color),
            (this.matcap = e.matcap),
            (this.map = e.map),
            (this.bumpMap = e.bumpMap),
            (this.bumpScale = e.bumpScale),
            (this.normalMap = e.normalMap),
            (this.normalMapType = e.normalMapType),
            this.normalScale.copy(e.normalScale),
            (this.displacementMap = e.displacementMap),
            (this.displacementScale = e.displacementScale),
            (this.displacementBias = e.displacementBias),
            (this.alphaMap = e.alphaMap),
            (this.flatShading = e.flatShading),
            this
          );
        }
      }
      ou.prototype.isMeshMatcapMaterial = !0;
      class su extends Hl {
        constructor(e) {
          super(),
            (this.type = "LineDashedMaterial"),
            (this.scale = 1),
            (this.dashSize = 3),
            (this.gapSize = 1),
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.scale = e.scale),
            (this.dashSize = e.dashSize),
            (this.gapSize = e.gapSize),
            this
          );
        }
      }
      su.prototype.isLineDashedMaterial = !0;
      const lu = {
        arraySlice: function (e, t, n) {
          return lu.isTypedArray(e)
            ? new e.constructor(e.subarray(t, void 0 !== n ? n : e.length))
            : e.slice(t, n);
        },
        convertArray: function (e, t, n) {
          return !e || (!n && e.constructor === t)
            ? e
            : "number" == typeof t.BYTES_PER_ELEMENT
            ? new t(e)
            : Array.prototype.slice.call(e);
        },
        isTypedArray: function (e) {
          return ArrayBuffer.isView(e) && !(e instanceof DataView);
        },
        getKeyframeOrder: function (e) {
          const t = e.length,
            n = new Array(t);
          for (let e = 0; e !== t; ++e) n[e] = e;
          return (
            n.sort(function (t, n) {
              return e[t] - e[n];
            }),
            n
          );
        },
        sortedArray: function (e, t, n) {
          const i = e.length,
            r = new e.constructor(i);
          for (let a = 0, o = 0; o !== i; ++a) {
            const i = n[a] * t;
            for (let n = 0; n !== t; ++n) r[o++] = e[i + n];
          }
          return r;
        },
        flattenJSON: function (e, t, n, i) {
          let r = 1,
            a = e[0];
          for (; void 0 !== a && void 0 === a[i]; ) a = e[r++];
          if (void 0 === a) return;
          let o = a[i];
          if (void 0 !== o)
            if (Array.isArray(o))
              do {
                (o = a[i]),
                  void 0 !== o && (t.push(a.time), n.push.apply(n, o)),
                  (a = e[r++]);
              } while (void 0 !== a);
            else if (void 0 !== o.toArray)
              do {
                (o = a[i]),
                  void 0 !== o && (t.push(a.time), o.toArray(n, n.length)),
                  (a = e[r++]);
              } while (void 0 !== a);
            else
              do {
                (o = a[i]),
                  void 0 !== o && (t.push(a.time), n.push(o)),
                  (a = e[r++]);
              } while (void 0 !== a);
        },
        subclip: function (e, t, n, i, r = 30) {
          const a = e.clone();
          a.name = t;
          const o = [];
          for (let e = 0; e < a.tracks.length; ++e) {
            const t = a.tracks[e],
              s = t.getValueSize(),
              l = [],
              c = [];
            for (let e = 0; e < t.times.length; ++e) {
              const a = t.times[e] * r;
              if (!(a < n || a >= i)) {
                l.push(t.times[e]);
                for (let n = 0; n < s; ++n) c.push(t.values[e * s + n]);
              }
            }
            0 !== l.length &&
              ((t.times = lu.convertArray(l, t.times.constructor)),
              (t.values = lu.convertArray(c, t.values.constructor)),
              o.push(t));
          }
          a.tracks = o;
          let s = 1 / 0;
          for (let e = 0; e < a.tracks.length; ++e)
            s > a.tracks[e].times[0] && (s = a.tracks[e].times[0]);
          for (let e = 0; e < a.tracks.length; ++e) a.tracks[e].shift(-1 * s);
          return a.resetDuration(), a;
        },
        makeClipAdditive: function (e, t = 0, n = e, i = 30) {
          i <= 0 && (i = 30);
          const r = n.tracks.length,
            a = t / i;
          for (let t = 0; t < r; ++t) {
            const i = n.tracks[t],
              r = i.ValueTypeName;
            if ("bool" === r || "string" === r) continue;
            const o = e.tracks.find(function (e) {
              return e.name === i.name && e.ValueTypeName === r;
            });
            if (void 0 === o) continue;
            let s = 0;
            const l = i.getValueSize();
            i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline &&
              (s = l / 3);
            let c = 0;
            const u = o.getValueSize();
            o.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline &&
              (c = u / 3);
            const h = i.times.length - 1;
            let d;
            if (a <= i.times[0]) {
              const e = s,
                t = l - s;
              d = lu.arraySlice(i.values, e, t);
            } else if (a >= i.times[h]) {
              const e = h * l + s,
                t = e + l - s;
              d = lu.arraySlice(i.values, e, t);
            } else {
              const e = i.createInterpolant(),
                t = s,
                n = l - s;
              e.evaluate(a), (d = lu.arraySlice(e.resultBuffer, t, n));
            }
            if ("quaternion" === r) {
              new Hn().fromArray(d).normalize().conjugate().toArray(d);
            }
            const p = o.times.length;
            for (let e = 0; e < p; ++e) {
              const t = e * u + c;
              if ("quaternion" === r)
                Hn.multiplyQuaternionsFlat(o.values, t, d, 0, o.values, t);
              else {
                const e = u - 2 * c;
                for (let n = 0; n < e; ++n) o.values[t + n] -= d[n];
              }
            }
          }
          return (e.blendMode = 2501), e;
        },
      };
      class cu {
        constructor(e, t, n, i) {
          (this.parameterPositions = e),
            (this._cachedIndex = 0),
            (this.resultBuffer = void 0 !== i ? i : new t.constructor(n)),
            (this.sampleValues = t),
            (this.valueSize = n),
            (this.settings = null),
            (this.DefaultSettings_ = {});
        }
        evaluate(e) {
          const t = this.parameterPositions;
          let n = this._cachedIndex,
            i = t[n],
            r = t[n - 1];
          e: {
            t: {
              let a;
              n: {
                i: if (!(e < i)) {
                  for (let a = n + 2; ; ) {
                    if (void 0 === i) {
                      if (e < r) break i;
                      return (
                        (n = t.length),
                        (this._cachedIndex = n),
                        this.afterEnd_(n - 1, e, r)
                      );
                    }
                    if (n === a) break;
                    if (((r = i), (i = t[++n]), e < i)) break t;
                  }
                  a = t.length;
                  break n;
                }
                if (e >= r) break e;
                {
                  const o = t[1];
                  e < o && ((n = 2), (r = o));
                  for (let a = n - 2; ; ) {
                    if (void 0 === r)
                      return (
                        (this._cachedIndex = 0), this.beforeStart_(0, e, i)
                      );
                    if (n === a) break;
                    if (((i = r), (r = t[--n - 1]), e >= r)) break t;
                  }
                  (a = n), (n = 0);
                }
              }
              for (; n < a; ) {
                const i = (n + a) >>> 1;
                e < t[i] ? (a = i) : (n = i + 1);
              }
              if (((i = t[n]), (r = t[n - 1]), void 0 === r))
                return (this._cachedIndex = 0), this.beforeStart_(0, e, i);
              if (void 0 === i)
                return (
                  (n = t.length),
                  (this._cachedIndex = n),
                  this.afterEnd_(n - 1, r, e)
                );
            }
            (this._cachedIndex = n), this.intervalChanged_(n, r, i);
          }
          return this.interpolate_(n, r, e, i);
        }
        getSettings_() {
          return this.settings || this.DefaultSettings_;
        }
        copySampleValue_(e) {
          const t = this.resultBuffer,
            n = this.sampleValues,
            i = this.valueSize,
            r = e * i;
          for (let e = 0; e !== i; ++e) t[e] = n[r + e];
          return t;
        }
        interpolate_() {
          throw new Error("call to abstract method");
        }
        intervalChanged_() {}
      }
      (cu.prototype.beforeStart_ = cu.prototype.copySampleValue_),
        (cu.prototype.afterEnd_ = cu.prototype.copySampleValue_);
      class uu extends cu {
        constructor(e, t, n, i) {
          super(e, t, n, i),
            (this._weightPrev = -0),
            (this._offsetPrev = -0),
            (this._weightNext = -0),
            (this._offsetNext = -0),
            (this.DefaultSettings_ = { endingStart: Yt, endingEnd: Yt });
        }
        intervalChanged_(e, t, n) {
          const i = this.parameterPositions;
          let r = e - 2,
            a = e + 1,
            o = i[r],
            s = i[a];
          if (void 0 === o)
            switch (this.getSettings_().endingStart) {
              case Kt:
                (r = e), (o = 2 * t - n);
                break;
              case Zt:
                (r = i.length - 2), (o = t + i[r] - i[r + 1]);
                break;
              default:
                (r = e), (o = n);
            }
          if (void 0 === s)
            switch (this.getSettings_().endingEnd) {
              case Kt:
                (a = e), (s = 2 * n - t);
                break;
              case Zt:
                (a = 1), (s = n + i[1] - i[0]);
                break;
              default:
                (a = e - 1), (s = t);
            }
          const l = 0.5 * (n - t),
            c = this.valueSize;
          (this._weightPrev = l / (t - o)),
            (this._weightNext = l / (s - n)),
            (this._offsetPrev = r * c),
            (this._offsetNext = a * c);
        }
        interpolate_(e, t, n, i) {
          const r = this.resultBuffer,
            a = this.sampleValues,
            o = this.valueSize,
            s = e * o,
            l = s - o,
            c = this._offsetPrev,
            u = this._offsetNext,
            h = this._weightPrev,
            d = this._weightNext,
            p = (n - t) / (i - t),
            m = p * p,
            f = m * p,
            g = -h * f + 2 * h * m - h * p,
            v = (1 + h) * f + (-1.5 - 2 * h) * m + (-0.5 + h) * p + 1,
            y = (-1 - d) * f + (1.5 + d) * m + 0.5 * p,
            x = d * f - d * m;
          for (let e = 0; e !== o; ++e)
            r[e] = g * a[c + e] + v * a[l + e] + y * a[s + e] + x * a[u + e];
          return r;
        }
      }
      class hu extends cu {
        constructor(e, t, n, i) {
          super(e, t, n, i);
        }
        interpolate_(e, t, n, i) {
          const r = this.resultBuffer,
            a = this.sampleValues,
            o = this.valueSize,
            s = e * o,
            l = s - o,
            c = (n - t) / (i - t),
            u = 1 - c;
          for (let e = 0; e !== o; ++e) r[e] = a[l + e] * u + a[s + e] * c;
          return r;
        }
      }
      class du extends cu {
        constructor(e, t, n, i) {
          super(e, t, n, i);
        }
        interpolate_(e) {
          return this.copySampleValue_(e - 1);
        }
      }
      class pu {
        constructor(e, t, n, i) {
          if (void 0 === e)
            throw new Error("THREE.KeyframeTrack: track name is undefined");
          if (void 0 === t || 0 === t.length)
            throw new Error(
              "THREE.KeyframeTrack: no keyframes in track named " + e
            );
          (this.name = e),
            (this.times = lu.convertArray(t, this.TimeBufferType)),
            (this.values = lu.convertArray(n, this.ValueBufferType)),
            this.setInterpolation(i || this.DefaultInterpolation);
        }
        static toJSON(e) {
          const t = e.constructor;
          let n;
          if (t.toJSON !== this.toJSON) n = t.toJSON(e);
          else {
            n = {
              name: e.name,
              times: lu.convertArray(e.times, Array),
              values: lu.convertArray(e.values, Array),
            };
            const t = e.getInterpolation();
            t !== e.DefaultInterpolation && (n.interpolation = t);
          }
          return (n.type = e.ValueTypeName), n;
        }
        InterpolantFactoryMethodDiscrete(e) {
          return new du(this.times, this.values, this.getValueSize(), e);
        }
        InterpolantFactoryMethodLinear(e) {
          return new hu(this.times, this.values, this.getValueSize(), e);
        }
        InterpolantFactoryMethodSmooth(e) {
          return new uu(this.times, this.values, this.getValueSize(), e);
        }
        setInterpolation(e) {
          let t;
          switch (e) {
            case jt:
              t = this.InterpolantFactoryMethodDiscrete;
              break;
            case Xt:
              t = this.InterpolantFactoryMethodLinear;
              break;
            case qt:
              t = this.InterpolantFactoryMethodSmooth;
          }
          if (void 0 === t) {
            const t =
              "unsupported interpolation for " +
              this.ValueTypeName +
              " keyframe track named " +
              this.name;
            if (void 0 === this.createInterpolant) {
              if (e === this.DefaultInterpolation) throw new Error(t);
              this.setInterpolation(this.DefaultInterpolation);
            }
            return console.warn("THREE.KeyframeTrack:", t), this;
          }
          return (this.createInterpolant = t), this;
        }
        getInterpolation() {
          switch (this.createInterpolant) {
            case this.InterpolantFactoryMethodDiscrete:
              return jt;
            case this.InterpolantFactoryMethodLinear:
              return Xt;
            case this.InterpolantFactoryMethodSmooth:
              return qt;
          }
        }
        getValueSize() {
          return this.values.length / this.times.length;
        }
        shift(e) {
          if (0 !== e) {
            const t = this.times;
            for (let n = 0, i = t.length; n !== i; ++n) t[n] += e;
          }
          return this;
        }
        scale(e) {
          if (1 !== e) {
            const t = this.times;
            for (let n = 0, i = t.length; n !== i; ++n) t[n] *= e;
          }
          return this;
        }
        trim(e, t) {
          const n = this.times,
            i = n.length;
          let r = 0,
            a = i - 1;
          for (; r !== i && n[r] < e; ) ++r;
          for (; -1 !== a && n[a] > t; ) --a;
          if ((++a, 0 !== r || a !== i)) {
            r >= a && ((a = Math.max(a, 1)), (r = a - 1));
            const e = this.getValueSize();
            (this.times = lu.arraySlice(n, r, a)),
              (this.values = lu.arraySlice(this.values, r * e, a * e));
          }
          return this;
        }
        validate() {
          let e = !0;
          const t = this.getValueSize();
          t - Math.floor(t) != 0 &&
            (console.error(
              "THREE.KeyframeTrack: Invalid value size in track.",
              this
            ),
            (e = !1));
          const n = this.times,
            i = this.values,
            r = n.length;
          0 === r &&
            (console.error("THREE.KeyframeTrack: Track is empty.", this),
            (e = !1));
          let a = null;
          for (let t = 0; t !== r; t++) {
            const i = n[t];
            if ("number" == typeof i && isNaN(i)) {
              console.error(
                "THREE.KeyframeTrack: Time is not a valid number.",
                this,
                t,
                i
              ),
                (e = !1);
              break;
            }
            if (null !== a && a > i) {
              console.error(
                "THREE.KeyframeTrack: Out of order keys.",
                this,
                t,
                i,
                a
              ),
                (e = !1);
              break;
            }
            a = i;
          }
          if (void 0 !== i && lu.isTypedArray(i))
            for (let t = 0, n = i.length; t !== n; ++t) {
              const n = i[t];
              if (isNaN(n)) {
                console.error(
                  "THREE.KeyframeTrack: Value is not a valid number.",
                  this,
                  t,
                  n
                ),
                  (e = !1);
                break;
              }
            }
          return e;
        }
        optimize() {
          const e = lu.arraySlice(this.times),
            t = lu.arraySlice(this.values),
            n = this.getValueSize(),
            i = this.getInterpolation() === qt,
            r = e.length - 1;
          let a = 1;
          for (let o = 1; o < r; ++o) {
            let r = !1;
            const s = e[o];
            if (s !== e[o + 1] && (1 !== o || s !== e[0]))
              if (i) r = !0;
              else {
                const e = o * n,
                  i = e - n,
                  a = e + n;
                for (let o = 0; o !== n; ++o) {
                  const n = t[e + o];
                  if (n !== t[i + o] || n !== t[a + o]) {
                    r = !0;
                    break;
                  }
                }
              }
            if (r) {
              if (o !== a) {
                e[a] = e[o];
                const i = o * n,
                  r = a * n;
                for (let e = 0; e !== n; ++e) t[r + e] = t[i + e];
              }
              ++a;
            }
          }
          if (r > 0) {
            e[a] = e[r];
            for (let e = r * n, i = a * n, o = 0; o !== n; ++o)
              t[i + o] = t[e + o];
            ++a;
          }
          return (
            a !== e.length
              ? ((this.times = lu.arraySlice(e, 0, a)),
                (this.values = lu.arraySlice(t, 0, a * n)))
              : ((this.times = e), (this.values = t)),
            this
          );
        }
        clone() {
          const e = lu.arraySlice(this.times, 0),
            t = lu.arraySlice(this.values, 0),
            n = new (0, this.constructor)(this.name, e, t);
          return (n.createInterpolant = this.createInterpolant), n;
        }
      }
      (pu.prototype.TimeBufferType = Float32Array),
        (pu.prototype.ValueBufferType = Float32Array),
        (pu.prototype.DefaultInterpolation = Xt);
      class mu extends pu {}
      (mu.prototype.ValueTypeName = "bool"),
        (mu.prototype.ValueBufferType = Array),
        (mu.prototype.DefaultInterpolation = jt),
        (mu.prototype.InterpolantFactoryMethodLinear = void 0),
        (mu.prototype.InterpolantFactoryMethodSmooth = void 0);
      class fu extends pu {}
      fu.prototype.ValueTypeName = "color";
      class gu extends pu {}
      gu.prototype.ValueTypeName = "number";
      class vu extends cu {
        constructor(e, t, n, i) {
          super(e, t, n, i);
        }
        interpolate_(e, t, n, i) {
          const r = this.resultBuffer,
            a = this.sampleValues,
            o = this.valueSize,
            s = (n - t) / (i - t);
          let l = e * o;
          for (let e = l + o; l !== e; l += 4)
            Hn.slerpFlat(r, 0, a, l - o, a, l, s);
          return r;
        }
      }
      class yu extends pu {
        InterpolantFactoryMethodLinear(e) {
          return new vu(this.times, this.values, this.getValueSize(), e);
        }
      }
      (yu.prototype.ValueTypeName = "quaternion"),
        (yu.prototype.DefaultInterpolation = Xt),
        (yu.prototype.InterpolantFactoryMethodSmooth = void 0);
      class xu extends pu {}
      (xu.prototype.ValueTypeName = "string"),
        (xu.prototype.ValueBufferType = Array),
        (xu.prototype.DefaultInterpolation = jt),
        (xu.prototype.InterpolantFactoryMethodLinear = void 0),
        (xu.prototype.InterpolantFactoryMethodSmooth = void 0);
      class bu extends pu {}
      bu.prototype.ValueTypeName = "vector";
      class _u {
        constructor(e, t = -1, n, i = 2500) {
          (this.name = e),
            (this.tracks = n),
            (this.duration = t),
            (this.blendMode = i),
            (this.uuid = bn()),
            this.duration < 0 && this.resetDuration();
        }
        static parse(e) {
          const t = [],
            n = e.tracks,
            i = 1 / (e.fps || 1);
          for (let e = 0, r = n.length; e !== r; ++e) t.push(wu(n[e]).scale(i));
          const r = new this(e.name, e.duration, t, e.blendMode);
          return (r.uuid = e.uuid), r;
        }
        static toJSON(e) {
          const t = [],
            n = e.tracks,
            i = {
              name: e.name,
              duration: e.duration,
              tracks: t,
              uuid: e.uuid,
              blendMode: e.blendMode,
            };
          for (let e = 0, i = n.length; e !== i; ++e) t.push(pu.toJSON(n[e]));
          return i;
        }
        static CreateFromMorphTargetSequence(e, t, n, i) {
          const r = t.length,
            a = [];
          for (let e = 0; e < r; e++) {
            let o = [],
              s = [];
            o.push((e + r - 1) % r, e, (e + 1) % r), s.push(0, 1, 0);
            const l = lu.getKeyframeOrder(o);
            (o = lu.sortedArray(o, 1, l)),
              (s = lu.sortedArray(s, 1, l)),
              i || 0 !== o[0] || (o.push(r), s.push(s[0])),
              a.push(
                new gu(".morphTargetInfluences[" + t[e].name + "]", o, s).scale(
                  1 / n
                )
              );
          }
          return new this(e, -1, a);
        }
        static findByName(e, t) {
          let n = e;
          if (!Array.isArray(e)) {
            const t = e;
            n = (t.geometry && t.geometry.animations) || t.animations;
          }
          for (let e = 0; e < n.length; e++) if (n[e].name === t) return n[e];
          return null;
        }
        static CreateClipsFromMorphTargetSequences(e, t, n) {
          const i = {},
            r = /^([\w-]*?)([\d]+)$/;
          for (let t = 0, n = e.length; t < n; t++) {
            const n = e[t],
              a = n.name.match(r);
            if (a && a.length > 1) {
              const e = a[1];
              let t = i[e];
              t || (i[e] = t = []), t.push(n);
            }
          }
          const a = [];
          for (const e in i)
            a.push(this.CreateFromMorphTargetSequence(e, i[e], t, n));
          return a;
        }
        static parseAnimation(e, t) {
          if (!e)
            return (
              console.error(
                "THREE.AnimationClip: No animation in JSONLoader data."
              ),
              null
            );
          const n = function (e, t, n, i, r) {
              if (0 !== n.length) {
                const a = [],
                  o = [];
                lu.flattenJSON(n, a, o, i),
                  0 !== a.length && r.push(new e(t, a, o));
              }
            },
            i = [],
            r = e.name || "default",
            a = e.fps || 30,
            o = e.blendMode;
          let s = e.length || -1;
          const l = e.hierarchy || [];
          for (let e = 0; e < l.length; e++) {
            const r = l[e].keys;
            if (r && 0 !== r.length)
              if (r[0].morphTargets) {
                const e = {};
                let t;
                for (t = 0; t < r.length; t++)
                  if (r[t].morphTargets)
                    for (let n = 0; n < r[t].morphTargets.length; n++)
                      e[r[t].morphTargets[n]] = -1;
                for (const n in e) {
                  const e = [],
                    a = [];
                  for (let i = 0; i !== r[t].morphTargets.length; ++i) {
                    const i = r[t];
                    e.push(i.time), a.push(i.morphTarget === n ? 1 : 0);
                  }
                  i.push(new gu(".morphTargetInfluence[" + n + "]", e, a));
                }
                s = e.length * (a || 1);
              } else {
                const a = ".bones[" + t[e].name + "]";
                n(bu, a + ".position", r, "pos", i),
                  n(yu, a + ".quaternion", r, "rot", i),
                  n(bu, a + ".scale", r, "scl", i);
              }
          }
          if (0 === i.length) return null;
          return new this(r, s, i, o);
        }
        resetDuration() {
          let e = 0;
          for (let t = 0, n = this.tracks.length; t !== n; ++t) {
            const n = this.tracks[t];
            e = Math.max(e, n.times[n.times.length - 1]);
          }
          return (this.duration = e), this;
        }
        trim() {
          for (let e = 0; e < this.tracks.length; e++)
            this.tracks[e].trim(0, this.duration);
          return this;
        }
        validate() {
          let e = !0;
          for (let t = 0; t < this.tracks.length; t++)
            e = e && this.tracks[t].validate();
          return e;
        }
        optimize() {
          for (let e = 0; e < this.tracks.length; e++)
            this.tracks[e].optimize();
          return this;
        }
        clone() {
          const e = [];
          for (let t = 0; t < this.tracks.length; t++)
            e.push(this.tracks[t].clone());
          return new this.constructor(
            this.name,
            this.duration,
            e,
            this.blendMode
          );
        }
        toJSON() {
          return this.constructor.toJSON(this);
        }
      }
      function wu(e) {
        if (void 0 === e.type)
          throw new Error(
            "THREE.KeyframeTrack: track type undefined, can not parse"
          );
        const t = (function (e) {
          switch (e.toLowerCase()) {
            case "scalar":
            case "double":
            case "float":
            case "number":
            case "integer":
              return gu;
            case "vector":
            case "vector2":
            case "vector3":
            case "vector4":
              return bu;
            case "color":
              return fu;
            case "quaternion":
              return yu;
            case "bool":
            case "boolean":
              return mu;
            case "string":
              return xu;
          }
          throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + e);
        })(e.type);
        if (void 0 === e.times) {
          const t = [],
            n = [];
          lu.flattenJSON(e.keys, t, n, "value"), (e.times = t), (e.values = n);
        }
        return void 0 !== t.parse
          ? t.parse(e)
          : new t(e.name, e.times, e.values, e.interpolation);
      }
      const Mu = {
        enabled: !1,
        files: {},
        add: function (e, t) {
          !1 !== this.enabled && (this.files[e] = t);
        },
        get: function (e) {
          if (!1 !== this.enabled) return this.files[e];
        },
        remove: function (e) {
          delete this.files[e];
        },
        clear: function () {
          this.files = {};
        },
      };
      class Su {
        constructor(e, t, n) {
          const i = this;
          let r,
            a = !1,
            o = 0,
            s = 0;
          const l = [];
          (this.onStart = void 0),
            (this.onLoad = e),
            (this.onProgress = t),
            (this.onError = n),
            (this.itemStart = function (e) {
              s++,
                !1 === a && void 0 !== i.onStart && i.onStart(e, o, s),
                (a = !0);
            }),
            (this.itemEnd = function (e) {
              o++,
                void 0 !== i.onProgress && i.onProgress(e, o, s),
                o === s && ((a = !1), void 0 !== i.onLoad && i.onLoad());
            }),
            (this.itemError = function (e) {
              void 0 !== i.onError && i.onError(e);
            }),
            (this.resolveURL = function (e) {
              return r ? r(e) : e;
            }),
            (this.setURLModifier = function (e) {
              return (r = e), this;
            }),
            (this.addHandler = function (e, t) {
              return l.push(e, t), this;
            }),
            (this.removeHandler = function (e) {
              const t = l.indexOf(e);
              return -1 !== t && l.splice(t, 2), this;
            }),
            (this.getHandler = function (e) {
              for (let t = 0, n = l.length; t < n; t += 2) {
                const n = l[t],
                  i = l[t + 1];
                if ((n.global && (n.lastIndex = 0), n.test(e))) return i;
              }
              return null;
            });
        }
      }
      const Tu = new Su();
      class Eu {
        constructor(e) {
          (this.manager = void 0 !== e ? e : Tu),
            (this.crossOrigin = "anonymous"),
            (this.withCredentials = !1),
            (this.path = ""),
            (this.resourcePath = ""),
            (this.requestHeader = {});
        }
        load() {}
        loadAsync(e, t) {
          const n = this;
          return new Promise(function (i, r) {
            n.load(e, i, t, r);
          });
        }
        parse() {}
        setCrossOrigin(e) {
          return (this.crossOrigin = e), this;
        }
        setWithCredentials(e) {
          return (this.withCredentials = e), this;
        }
        setPath(e) {
          return (this.path = e), this;
        }
        setResourcePath(e) {
          return (this.resourcePath = e), this;
        }
        setRequestHeader(e) {
          return (this.requestHeader = e), this;
        }
      }
      const Au = {};
      class Lu extends Eu {
        constructor(e) {
          super(e);
        }
        load(e, t, n, i) {
          void 0 === e && (e = ""),
            void 0 !== this.path && (e = this.path + e),
            (e = this.manager.resolveURL(e));
          const r = this,
            a = Mu.get(e);
          if (void 0 !== a)
            return (
              r.manager.itemStart(e),
              setTimeout(function () {
                t && t(a), r.manager.itemEnd(e);
              }, 0),
              a
            );
          if (void 0 !== Au[e])
            return void Au[e].push({ onLoad: t, onProgress: n, onError: i });
          const o = e.match(/^data:(.*?)(;base64)?,(.*)$/);
          let s;
          if (o) {
            const n = o[1],
              a = !!o[2];
            let s = o[3];
            (s = decodeURIComponent(s)), a && (s = atob(s));
            try {
              let i;
              const a = (this.responseType || "").toLowerCase();
              switch (a) {
                case "arraybuffer":
                case "blob":
                  const e = new Uint8Array(s.length);
                  for (let t = 0; t < s.length; t++) e[t] = s.charCodeAt(t);
                  i =
                    "blob" === a ? new Blob([e.buffer], { type: n }) : e.buffer;
                  break;
                case "document":
                  const t = new DOMParser();
                  i = t.parseFromString(s, n);
                  break;
                case "json":
                  i = JSON.parse(s);
                  break;
                default:
                  i = s;
              }
              setTimeout(function () {
                t && t(i), r.manager.itemEnd(e);
              }, 0);
            } catch (t) {
              setTimeout(function () {
                i && i(t), r.manager.itemError(e), r.manager.itemEnd(e);
              }, 0);
            }
          } else {
            (Au[e] = []),
              Au[e].push({ onLoad: t, onProgress: n, onError: i }),
              (s = new XMLHttpRequest()),
              s.open("GET", e, !0),
              s.addEventListener(
                "load",
                function (t) {
                  const n = this.response,
                    i = Au[e];
                  if (
                    (delete Au[e], 200 === this.status || 0 === this.status)
                  ) {
                    0 === this.status &&
                      console.warn("THREE.FileLoader: HTTP Status 0 received."),
                      Mu.add(e, n);
                    for (let e = 0, t = i.length; e < t; e++) {
                      const t = i[e];
                      t.onLoad && t.onLoad(n);
                    }
                    r.manager.itemEnd(e);
                  } else {
                    for (let e = 0, n = i.length; e < n; e++) {
                      const n = i[e];
                      n.onError && n.onError(t);
                    }
                    r.manager.itemError(e), r.manager.itemEnd(e);
                  }
                },
                !1
              ),
              s.addEventListener(
                "progress",
                function (t) {
                  const n = Au[e];
                  for (let e = 0, i = n.length; e < i; e++) {
                    const i = n[e];
                    i.onProgress && i.onProgress(t);
                  }
                },
                !1
              ),
              s.addEventListener(
                "error",
                function (t) {
                  const n = Au[e];
                  delete Au[e];
                  for (let e = 0, i = n.length; e < i; e++) {
                    const i = n[e];
                    i.onError && i.onError(t);
                  }
                  r.manager.itemError(e), r.manager.itemEnd(e);
                },
                !1
              ),
              s.addEventListener(
                "abort",
                function (t) {
                  const n = Au[e];
                  delete Au[e];
                  for (let e = 0, i = n.length; e < i; e++) {
                    const i = n[e];
                    i.onError && i.onError(t);
                  }
                  r.manager.itemError(e), r.manager.itemEnd(e);
                },
                !1
              ),
              void 0 !== this.responseType &&
                (s.responseType = this.responseType),
              void 0 !== this.withCredentials &&
                (s.withCredentials = this.withCredentials),
              s.overrideMimeType &&
                s.overrideMimeType(
                  void 0 !== this.mimeType ? this.mimeType : "text/plain"
                );
            for (const e in this.requestHeader)
              s.setRequestHeader(e, this.requestHeader[e]);
            s.send(null);
          }
          return r.manager.itemStart(e), s;
        }
        setResponseType(e) {
          return (this.responseType = e), this;
        }
        setMimeType(e) {
          return (this.mimeType = e), this;
        }
      }
      class Pu extends Eu {
        constructor(e) {
          super(e);
        }
        load(e, t, n, i) {
          void 0 !== this.path && (e = this.path + e),
            (e = this.manager.resolveURL(e));
          const r = this,
            a = Mu.get(e);
          if (void 0 !== a)
            return (
              r.manager.itemStart(e),
              setTimeout(function () {
                t && t(a), r.manager.itemEnd(e);
              }, 0),
              a
            );
          const o = document.createElementNS(
            "http://www.w3.org/1999/xhtml",
            "img"
          );
          function s() {
            o.removeEventListener("load", s, !1),
              o.removeEventListener("error", l, !1),
              Mu.add(e, this),
              t && t(this),
              r.manager.itemEnd(e);
          }
          function l(t) {
            o.removeEventListener("load", s, !1),
              o.removeEventListener("error", l, !1),
              i && i(t),
              r.manager.itemError(e),
              r.manager.itemEnd(e);
          }
          return (
            o.addEventListener("load", s, !1),
            o.addEventListener("error", l, !1),
            "data:" !== e.substr(0, 5) &&
              void 0 !== this.crossOrigin &&
              (o.crossOrigin = this.crossOrigin),
            r.manager.itemStart(e),
            (o.src = e),
            o
          );
        }
      }
      class Ru extends Eu {
        constructor(e) {
          super(e);
        }
        load(e, t, n, i) {
          const r = new Qr(),
            a = new Pu(this.manager);
          a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
          let o = 0;
          function s(n) {
            a.load(
              e[n],
              function (e) {
                (r.images[n] = e),
                  o++,
                  6 === o && ((r.needsUpdate = !0), t && t(r));
              },
              void 0,
              i
            );
          }
          for (let t = 0; t < e.length; ++t) s(t);
          return r;
        }
      }
      class Cu extends Eu {
        constructor(e) {
          super(e);
        }
        load(e, t, n, i) {
          const r = this,
            a = new Ll(),
            o = new Lu(this.manager);
          return (
            o.setResponseType("arraybuffer"),
            o.setRequestHeader(this.requestHeader),
            o.setPath(this.path),
            o.setWithCredentials(r.withCredentials),
            o.load(
              e,
              function (e) {
                const n = r.parse(e);
                n &&
                  (void 0 !== n.image
                    ? (a.image = n.image)
                    : void 0 !== n.data &&
                      ((a.image.width = n.width),
                      (a.image.height = n.height),
                      (a.image.data = n.data)),
                  (a.wrapS = void 0 !== n.wrapS ? n.wrapS : Te),
                  (a.wrapT = void 0 !== n.wrapT ? n.wrapT : Te),
                  (a.magFilter = void 0 !== n.magFilter ? n.magFilter : Re),
                  (a.minFilter = void 0 !== n.minFilter ? n.minFilter : Re),
                  (a.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1),
                  void 0 !== n.encoding && (a.encoding = n.encoding),
                  void 0 !== n.flipY && (a.flipY = n.flipY),
                  void 0 !== n.format && (a.format = n.format),
                  void 0 !== n.type && (a.type = n.type),
                  void 0 !== n.mipmaps &&
                    ((a.mipmaps = n.mipmaps), (a.minFilter = Ie)),
                  1 === n.mipmapCount && (a.minFilter = Re),
                  void 0 !== n.generateMipmaps &&
                    (a.generateMipmaps = n.generateMipmaps),
                  (a.needsUpdate = !0),
                  t && t(a, n));
              },
              n,
              i
            ),
            a
          );
        }
      }
      class Iu extends Eu {
        constructor(e) {
          super(e);
        }
        load(e, t, n, i) {
          const r = new Nn(),
            a = new Pu(this.manager);
          return (
            a.setCrossOrigin(this.crossOrigin),
            a.setPath(this.path),
            a.load(
              e,
              function (n) {
                r.image = n;
                const i =
                  e.search(/\.jpe?g($|\?)/i) > 0 ||
                  0 === e.search(/^data\:image\/jpeg/);
                (r.format = i ? Xe : qe),
                  (r.needsUpdate = !0),
                  void 0 !== t && t(r);
              },
              n,
              i
            ),
            r
          );
        }
      }
      class Nu extends ic {
        constructor() {
          super(),
            (this.type = "CurvePath"),
            (this.curves = []),
            (this.autoClose = !1);
        }
        add(e) {
          this.curves.push(e);
        }
        closePath() {
          const e = this.curves[0].getPoint(0),
            t = this.curves[this.curves.length - 1].getPoint(1);
          e.equals(t) || this.curves.push(new vc(t, e));
        }
        getPoint(e) {
          const t = e * this.getLength(),
            n = this.getCurveLengths();
          let i = 0;
          for (; i < n.length; ) {
            if (n[i] >= t) {
              const e = n[i] - t,
                r = this.curves[i],
                a = r.getLength(),
                o = 0 === a ? 0 : 1 - e / a;
              return r.getPointAt(o);
            }
            i++;
          }
          return null;
        }
        getLength() {
          const e = this.getCurveLengths();
          return e[e.length - 1];
        }
        updateArcLengths() {
          (this.needsUpdate = !0),
            (this.cacheLengths = null),
            this.getCurveLengths();
        }
        getCurveLengths() {
          if (
            this.cacheLengths &&
            this.cacheLengths.length === this.curves.length
          )
            return this.cacheLengths;
          const e = [];
          let t = 0;
          for (let n = 0, i = this.curves.length; n < i; n++)
            (t += this.curves[n].getLength()), e.push(t);
          return (this.cacheLengths = e), e;
        }
        getSpacedPoints(e = 40) {
          const t = [];
          for (let n = 0; n <= e; n++) t.push(this.getPoint(n / e));
          return this.autoClose && t.push(t[0]), t;
        }
        getPoints(e = 12) {
          const t = [];
          let n;
          for (let i = 0, r = this.curves; i < r.length; i++) {
            const a = r[i],
              o =
                a && a.isEllipseCurve
                  ? 2 * e
                  : a && (a.isLineCurve || a.isLineCurve3)
                  ? 1
                  : a && a.isSplineCurve
                  ? e * a.points.length
                  : e,
              s = a.getPoints(o);
            for (let e = 0; e < s.length; e++) {
              const i = s[e];
              (n && n.equals(i)) || (t.push(i), (n = i));
            }
          }
          return (
            this.autoClose &&
              t.length > 1 &&
              !t[t.length - 1].equals(t[0]) &&
              t.push(t[0]),
            t
          );
        }
        copy(e) {
          super.copy(e), (this.curves = []);
          for (let t = 0, n = e.curves.length; t < n; t++) {
            const n = e.curves[t];
            this.curves.push(n.clone());
          }
          return (this.autoClose = e.autoClose), this;
        }
        toJSON() {
          const e = super.toJSON();
          (e.autoClose = this.autoClose), (e.curves = []);
          for (let t = 0, n = this.curves.length; t < n; t++) {
            const n = this.curves[t];
            e.curves.push(n.toJSON());
          }
          return e;
        }
        fromJSON(e) {
          super.fromJSON(e), (this.autoClose = e.autoClose), (this.curves = []);
          for (let t = 0, n = e.curves.length; t < n; t++) {
            const n = e.curves[t];
            this.curves.push(new _c[n.type]().fromJSON(n));
          }
          return this;
        }
      }
      class Du extends Nu {
        constructor(e) {
          super(),
            (this.type = "Path"),
            (this.currentPoint = new Ln()),
            e && this.setFromPoints(e);
        }
        setFromPoints(e) {
          this.moveTo(e[0].x, e[0].y);
          for (let t = 1, n = e.length; t < n; t++) this.lineTo(e[t].x, e[t].y);
          return this;
        }
        moveTo(e, t) {
          return this.currentPoint.set(e, t), this;
        }
        lineTo(e, t) {
          const n = new vc(this.currentPoint.clone(), new Ln(e, t));
          return this.curves.push(n), this.currentPoint.set(e, t), this;
        }
        quadraticCurveTo(e, t, n, i) {
          const r = new yc(
            this.currentPoint.clone(),
            new Ln(e, t),
            new Ln(n, i)
          );
          return this.curves.push(r), this.currentPoint.set(n, i), this;
        }
        bezierCurveTo(e, t, n, i, r, a) {
          const o = new fc(
            this.currentPoint.clone(),
            new Ln(e, t),
            new Ln(n, i),
            new Ln(r, a)
          );
          return this.curves.push(o), this.currentPoint.set(r, a), this;
        }
        splineThru(e) {
          const t = [this.currentPoint.clone()].concat(e),
            n = new bc(t);
          return (
            this.curves.push(n), this.currentPoint.copy(e[e.length - 1]), this
          );
        }
        arc(e, t, n, i, r, a) {
          const o = this.currentPoint.x,
            s = this.currentPoint.y;
          return this.absarc(e + o, t + s, n, i, r, a), this;
        }
        absarc(e, t, n, i, r, a) {
          return this.absellipse(e, t, n, n, i, r, a), this;
        }
        ellipse(e, t, n, i, r, a, o, s) {
          const l = this.currentPoint.x,
            c = this.currentPoint.y;
          return this.absellipse(e + l, t + c, n, i, r, a, o, s), this;
        }
        absellipse(e, t, n, i, r, a, o, s) {
          const l = new rc(e, t, n, i, r, a, o, s);
          if (this.curves.length > 0) {
            const e = l.getPoint(0);
            e.equals(this.currentPoint) || this.lineTo(e.x, e.y);
          }
          this.curves.push(l);
          const c = l.getPoint(1);
          return this.currentPoint.copy(c), this;
        }
        copy(e) {
          return super.copy(e), this.currentPoint.copy(e.currentPoint), this;
        }
        toJSON() {
          const e = super.toJSON();
          return (e.currentPoint = this.currentPoint.toArray()), e;
        }
        fromJSON(e) {
          return (
            super.fromJSON(e), this.currentPoint.fromArray(e.currentPoint), this
          );
        }
      }
      class Ou extends Du {
        constructor(e) {
          super(e),
            (this.uuid = bn()),
            (this.type = "Shape"),
            (this.holes = []);
        }
        getPointsHoles(e) {
          const t = [];
          for (let n = 0, i = this.holes.length; n < i; n++)
            t[n] = this.holes[n].getPoints(e);
          return t;
        }
        extractPoints(e) {
          return { shape: this.getPoints(e), holes: this.getPointsHoles(e) };
        }
        copy(e) {
          super.copy(e), (this.holes = []);
          for (let t = 0, n = e.holes.length; t < n; t++) {
            const n = e.holes[t];
            this.holes.push(n.clone());
          }
          return this;
        }
        toJSON() {
          const e = super.toJSON();
          (e.uuid = this.uuid), (e.holes = []);
          for (let t = 0, n = this.holes.length; t < n; t++) {
            const n = this.holes[t];
            e.holes.push(n.toJSON());
          }
          return e;
        }
        fromJSON(e) {
          super.fromJSON(e), (this.uuid = e.uuid), (this.holes = []);
          for (let t = 0, n = e.holes.length; t < n; t++) {
            const n = e.holes[t];
            this.holes.push(new Du().fromJSON(n));
          }
          return this;
        }
      }
      class Fu extends Bi {
        constructor(e, t = 1) {
          super(),
            (this.type = "Light"),
            (this.color = new sr(e)),
            (this.intensity = t);
        }
        dispose() {}
        copy(e) {
          return (
            super.copy(e),
            this.color.copy(e.color),
            (this.intensity = e.intensity),
            this
          );
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return (
            (t.object.color = this.color.getHex()),
            (t.object.intensity = this.intensity),
            void 0 !== this.groundColor &&
              (t.object.groundColor = this.groundColor.getHex()),
            void 0 !== this.distance && (t.object.distance = this.distance),
            void 0 !== this.angle && (t.object.angle = this.angle),
            void 0 !== this.decay && (t.object.decay = this.decay),
            void 0 !== this.penumbra && (t.object.penumbra = this.penumbra),
            void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON()),
            t
          );
        }
      }
      Fu.prototype.isLight = !0;
      class ku extends Fu {
        constructor(e, t, n) {
          super(e, n),
            (this.type = "HemisphereLight"),
            this.position.copy(Bi.DefaultUp),
            this.updateMatrix(),
            (this.groundColor = new sr(t));
        }
        copy(e) {
          return (
            Fu.prototype.copy.call(this, e),
            this.groundColor.copy(e.groundColor),
            this
          );
        }
      }
      ku.prototype.isHemisphereLight = !0;
      const Hu = new gi(),
        zu = new zn(),
        Uu = new zn();
      class Bu {
        constructor(e) {
          (this.camera = e),
            (this.bias = 0),
            (this.normalBias = 0),
            (this.radius = 1),
            (this.blurSamples = 8),
            (this.mapSize = new Ln(512, 512)),
            (this.map = null),
            (this.mapPass = null),
            (this.matrix = new gi()),
            (this.autoUpdate = !0),
            (this.needsUpdate = !1),
            (this._frustum = new oa()),
            (this._frameExtents = new Ln(1, 1)),
            (this._viewportCount = 1),
            (this._viewports = [new On(0, 0, 1, 1)]);
        }
        getViewportCount() {
          return this._viewportCount;
        }
        getFrustum() {
          return this._frustum;
        }
        updateMatrices(e) {
          const t = this.camera,
            n = this.matrix;
          zu.setFromMatrixPosition(e.matrixWorld),
            t.position.copy(zu),
            Uu.setFromMatrixPosition(e.target.matrixWorld),
            t.lookAt(Uu),
            t.updateMatrixWorld(),
            Hu.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse),
            this._frustum.setFromProjectionMatrix(Hu),
            n.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1),
            n.multiply(t.projectionMatrix),
            n.multiply(t.matrixWorldInverse);
        }
        getViewport(e) {
          return this._viewports[e];
        }
        getFrameExtents() {
          return this._frameExtents;
        }
        dispose() {
          this.map && this.map.dispose(),
            this.mapPass && this.mapPass.dispose();
        }
        copy(e) {
          return (
            (this.camera = e.camera.clone()),
            (this.bias = e.bias),
            (this.radius = e.radius),
            this.mapSize.copy(e.mapSize),
            this
          );
        }
        clone() {
          return new this.constructor().copy(this);
        }
        toJSON() {
          const e = {};
          return (
            0 !== this.bias && (e.bias = this.bias),
            0 !== this.normalBias && (e.normalBias = this.normalBias),
            1 !== this.radius && (e.radius = this.radius),
            (512 === this.mapSize.x && 512 === this.mapSize.y) ||
              (e.mapSize = this.mapSize.toArray()),
            (e.camera = this.camera.toJSON(!1).object),
            delete e.camera.matrix,
            e
          );
        }
      }
      class Gu extends Bu {
        constructor() {
          super(new Kr(50, 1, 0.5, 500)), (this.focus = 1);
        }
        updateMatrices(e) {
          const t = this.camera,
            n = 2 * xn * e.angle * this.focus,
            i = this.mapSize.width / this.mapSize.height,
            r = e.distance || t.far;
          (n === t.fov && i === t.aspect && r === t.far) ||
            ((t.fov = n),
            (t.aspect = i),
            (t.far = r),
            t.updateProjectionMatrix()),
            super.updateMatrices(e);
        }
        copy(e) {
          return super.copy(e), (this.focus = e.focus), this;
        }
      }
      Gu.prototype.isSpotLightShadow = !0;
      class Vu extends Fu {
        constructor(e, t, n = 0, i = Math.PI / 3, r = 0, a = 1) {
          super(e, t),
            (this.type = "SpotLight"),
            this.position.copy(Bi.DefaultUp),
            this.updateMatrix(),
            (this.target = new Bi()),
            (this.distance = n),
            (this.angle = i),
            (this.penumbra = r),
            (this.decay = a),
            (this.shadow = new Gu());
        }
        get power() {
          return this.intensity * Math.PI;
        }
        set power(e) {
          this.intensity = e / Math.PI;
        }
        dispose() {
          this.shadow.dispose();
        }
        copy(e) {
          return (
            super.copy(e),
            (this.distance = e.distance),
            (this.angle = e.angle),
            (this.penumbra = e.penumbra),
            (this.decay = e.decay),
            (this.target = e.target.clone()),
            (this.shadow = e.shadow.clone()),
            this
          );
        }
      }
      Vu.prototype.isSpotLight = !0;
      const Wu = new gi(),
        ju = new zn(),
        Xu = new zn();
      class qu extends Bu {
        constructor() {
          super(new Kr(90, 1, 0.5, 500)),
            (this._frameExtents = new Ln(4, 2)),
            (this._viewportCount = 6),
            (this._viewports = [
              new On(2, 1, 1, 1),
              new On(0, 1, 1, 1),
              new On(3, 1, 1, 1),
              new On(1, 1, 1, 1),
              new On(3, 0, 1, 1),
              new On(1, 0, 1, 1),
            ]),
            (this._cubeDirections = [
              new zn(1, 0, 0),
              new zn(-1, 0, 0),
              new zn(0, 0, 1),
              new zn(0, 0, -1),
              new zn(0, 1, 0),
              new zn(0, -1, 0),
            ]),
            (this._cubeUps = [
              new zn(0, 1, 0),
              new zn(0, 1, 0),
              new zn(0, 1, 0),
              new zn(0, 1, 0),
              new zn(0, 0, 1),
              new zn(0, 0, -1),
            ]);
        }
        updateMatrices(e, t = 0) {
          const n = this.camera,
            i = this.matrix,
            r = e.distance || n.far;
          r !== n.far && ((n.far = r), n.updateProjectionMatrix()),
            ju.setFromMatrixPosition(e.matrixWorld),
            n.position.copy(ju),
            Xu.copy(n.position),
            Xu.add(this._cubeDirections[t]),
            n.up.copy(this._cubeUps[t]),
            n.lookAt(Xu),
            n.updateMatrixWorld(),
            i.makeTranslation(-ju.x, -ju.y, -ju.z),
            Wu.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse),
            this._frustum.setFromProjectionMatrix(Wu);
        }
      }
      qu.prototype.isPointLightShadow = !0;
      class Yu extends Fu {
        constructor(e, t, n = 0, i = 1) {
          super(e, t),
            (this.type = "PointLight"),
            (this.distance = n),
            (this.decay = i),
            (this.shadow = new qu());
        }
        get power() {
          return 4 * this.intensity * Math.PI;
        }
        set power(e) {
          this.intensity = e / (4 * Math.PI);
        }
        dispose() {
          this.shadow.dispose();
        }
        copy(e) {
          return (
            super.copy(e),
            (this.distance = e.distance),
            (this.decay = e.decay),
            (this.shadow = e.shadow.clone()),
            this
          );
        }
      }
      Yu.prototype.isPointLight = !0;
      class Ku extends Bu {
        constructor() {
          super(new xa(-5, 5, 5, -5, 0.5, 500));
        }
      }
      Ku.prototype.isDirectionalLightShadow = !0;
      class Zu extends Fu {
        constructor(e, t) {
          super(e, t),
            (this.type = "DirectionalLight"),
            this.position.copy(Bi.DefaultUp),
            this.updateMatrix(),
            (this.target = new Bi()),
            (this.shadow = new Ku());
        }
        dispose() {
          this.shadow.dispose();
        }
        copy(e) {
          return (
            super.copy(e),
            (this.target = e.target.clone()),
            (this.shadow = e.shadow.clone()),
            this
          );
        }
      }
      Zu.prototype.isDirectionalLight = !0;
      class Ju extends Fu {
        constructor(e, t) {
          super(e, t), (this.type = "AmbientLight");
        }
      }
      Ju.prototype.isAmbientLight = !0;
      class Qu extends Fu {
        constructor(e, t, n = 10, i = 10) {
          super(e, t),
            (this.type = "RectAreaLight"),
            (this.width = n),
            (this.height = i);
        }
        get power() {
          return this.intensity * this.width * this.height * Math.PI;
        }
        set power(e) {
          this.intensity = e / (this.width * this.height * Math.PI);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.width = e.width),
            (this.height = e.height),
            this
          );
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return (
            (t.object.width = this.width), (t.object.height = this.height), t
          );
        }
      }
      Qu.prototype.isRectAreaLight = !0;
      class $u {
        constructor() {
          this.coefficients = [];
          for (let e = 0; e < 9; e++) this.coefficients.push(new zn());
        }
        set(e) {
          for (let t = 0; t < 9; t++) this.coefficients[t].copy(e[t]);
          return this;
        }
        zero() {
          for (let e = 0; e < 9; e++) this.coefficients[e].set(0, 0, 0);
          return this;
        }
        getAt(e, t) {
          const n = e.x,
            i = e.y,
            r = e.z,
            a = this.coefficients;
          return (
            t.copy(a[0]).multiplyScalar(0.282095),
            t.addScaledVector(a[1], 0.488603 * i),
            t.addScaledVector(a[2], 0.488603 * r),
            t.addScaledVector(a[3], 0.488603 * n),
            t.addScaledVector(a[4], n * i * 1.092548),
            t.addScaledVector(a[5], i * r * 1.092548),
            t.addScaledVector(a[6], 0.315392 * (3 * r * r - 1)),
            t.addScaledVector(a[7], n * r * 1.092548),
            t.addScaledVector(a[8], 0.546274 * (n * n - i * i)),
            t
          );
        }
        getIrradianceAt(e, t) {
          const n = e.x,
            i = e.y,
            r = e.z,
            a = this.coefficients;
          return (
            t.copy(a[0]).multiplyScalar(0.886227),
            t.addScaledVector(a[1], 1.023328 * i),
            t.addScaledVector(a[2], 1.023328 * r),
            t.addScaledVector(a[3], 1.023328 * n),
            t.addScaledVector(a[4], 0.858086 * n * i),
            t.addScaledVector(a[5], 0.858086 * i * r),
            t.addScaledVector(a[6], 0.743125 * r * r - 0.247708),
            t.addScaledVector(a[7], 0.858086 * n * r),
            t.addScaledVector(a[8], 0.429043 * (n * n - i * i)),
            t
          );
        }
        add(e) {
          for (let t = 0; t < 9; t++)
            this.coefficients[t].add(e.coefficients[t]);
          return this;
        }
        addScaledSH(e, t) {
          for (let n = 0; n < 9; n++)
            this.coefficients[n].addScaledVector(e.coefficients[n], t);
          return this;
        }
        scale(e) {
          for (let t = 0; t < 9; t++) this.coefficients[t].multiplyScalar(e);
          return this;
        }
        lerp(e, t) {
          for (let n = 0; n < 9; n++)
            this.coefficients[n].lerp(e.coefficients[n], t);
          return this;
        }
        equals(e) {
          for (let t = 0; t < 9; t++)
            if (!this.coefficients[t].equals(e.coefficients[t])) return !1;
          return !0;
        }
        copy(e) {
          return this.set(e.coefficients);
        }
        clone() {
          return new this.constructor().copy(this);
        }
        fromArray(e, t = 0) {
          const n = this.coefficients;
          for (let i = 0; i < 9; i++) n[i].fromArray(e, t + 3 * i);
          return this;
        }
        toArray(e = [], t = 0) {
          const n = this.coefficients;
          for (let i = 0; i < 9; i++) n[i].toArray(e, t + 3 * i);
          return e;
        }
        static getBasisAt(e, t) {
          const n = e.x,
            i = e.y,
            r = e.z;
          (t[0] = 0.282095),
            (t[1] = 0.488603 * i),
            (t[2] = 0.488603 * r),
            (t[3] = 0.488603 * n),
            (t[4] = 1.092548 * n * i),
            (t[5] = 1.092548 * i * r),
            (t[6] = 0.315392 * (3 * r * r - 1)),
            (t[7] = 1.092548 * n * r),
            (t[8] = 0.546274 * (n * n - i * i));
        }
      }
      $u.prototype.isSphericalHarmonics3 = !0;
      class eh extends Fu {
        constructor(e = new $u(), t = 1) {
          super(void 0, t), (this.sh = e);
        }
        copy(e) {
          return super.copy(e), this.sh.copy(e.sh), this;
        }
        fromJSON(e) {
          return (this.intensity = e.intensity), this.sh.fromArray(e.sh), this;
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return (t.object.sh = this.sh.toArray()), t;
        }
      }
      eh.prototype.isLightProbe = !0;
      class th {
        static decodeText(e) {
          if ("undefined" != typeof TextDecoder)
            return new TextDecoder().decode(e);
          let t = "";
          for (let n = 0, i = e.length; n < i; n++)
            t += String.fromCharCode(e[n]);
          try {
            return decodeURIComponent(escape(t));
          } catch (e) {
            return t;
          }
        }
        static extractUrlBase(e) {
          const t = e.lastIndexOf("/");
          return -1 === t ? "./" : e.substr(0, t + 1);
        }
      }
      class nh extends Mr {
        constructor() {
          super(),
            (this.type = "InstancedBufferGeometry"),
            (this.instanceCount = 1 / 0);
        }
        copy(e) {
          return super.copy(e), (this.instanceCount = e.instanceCount), this;
        }
        clone() {
          return new this.constructor().copy(this);
        }
        toJSON() {
          const e = super.toJSON(this);
          return (
            (e.instanceCount = this.instanceCount),
            (e.isInstancedBufferGeometry = !0),
            e
          );
        }
      }
      nh.prototype.isInstancedBufferGeometry = !0;
      class ih extends Eu {
        constructor(e) {
          super(e),
            "undefined" == typeof createImageBitmap &&
              console.warn(
                "THREE.ImageBitmapLoader: createImageBitmap() not supported."
              ),
            "undefined" == typeof fetch &&
              console.warn("THREE.ImageBitmapLoader: fetch() not supported."),
            (this.options = { premultiplyAlpha: "none" });
        }
        setOptions(e) {
          return (this.options = e), this;
        }
        load(e, t, n, i) {
          void 0 === e && (e = ""),
            void 0 !== this.path && (e = this.path + e),
            (e = this.manager.resolveURL(e));
          const r = this,
            a = Mu.get(e);
          if (void 0 !== a)
            return (
              r.manager.itemStart(e),
              setTimeout(function () {
                t && t(a), r.manager.itemEnd(e);
              }, 0),
              a
            );
          const o = {};
          (o.credentials =
            "anonymous" === this.crossOrigin ? "same-origin" : "include"),
            (o.headers = this.requestHeader),
            fetch(e, o)
              .then(function (e) {
                return e.blob();
              })
              .then(function (e) {
                return createImageBitmap(
                  e,
                  Object.assign(r.options, { colorSpaceConversion: "none" })
                );
              })
              .then(function (n) {
                Mu.add(e, n), t && t(n), r.manager.itemEnd(e);
              })
              .catch(function (t) {
                i && i(t), r.manager.itemError(e), r.manager.itemEnd(e);
              }),
            r.manager.itemStart(e);
        }
      }
      ih.prototype.isImageBitmapLoader = !0;
      class rh {
        constructor() {
          (this.type = "ShapePath"),
            (this.color = new sr()),
            (this.subPaths = []),
            (this.currentPath = null);
        }
        moveTo(e, t) {
          return (
            (this.currentPath = new Du()),
            this.subPaths.push(this.currentPath),
            this.currentPath.moveTo(e, t),
            this
          );
        }
        lineTo(e, t) {
          return this.currentPath.lineTo(e, t), this;
        }
        quadraticCurveTo(e, t, n, i) {
          return this.currentPath.quadraticCurveTo(e, t, n, i), this;
        }
        bezierCurveTo(e, t, n, i, r, a) {
          return this.currentPath.bezierCurveTo(e, t, n, i, r, a), this;
        }
        splineThru(e) {
          return this.currentPath.splineThru(e), this;
        }
        toShapes(e, t) {
          function n(e) {
            const t = [];
            for (let n = 0, i = e.length; n < i; n++) {
              const i = e[n],
                r = new Ou();
              (r.curves = i.curves), t.push(r);
            }
            return t;
          }
          function i(e, t) {
            const n = t.length;
            let i = !1;
            for (let r = n - 1, a = 0; a < n; r = a++) {
              let n = t[r],
                o = t[a],
                s = o.x - n.x,
                l = o.y - n.y;
              if (Math.abs(l) > Number.EPSILON) {
                if (
                  (l < 0 && ((n = t[a]), (s = -s), (o = t[r]), (l = -l)),
                  e.y < n.y || e.y > o.y)
                )
                  continue;
                if (e.y === n.y) {
                  if (e.x === n.x) return !0;
                } else {
                  const t = l * (e.x - n.x) - s * (e.y - n.y);
                  if (0 === t) return !0;
                  if (t < 0) continue;
                  i = !i;
                }
              } else {
                if (e.y !== n.y) continue;
                if ((o.x <= e.x && e.x <= n.x) || (n.x <= e.x && e.x <= o.x))
                  return !0;
              }
            }
            return i;
          }
          const r = qc.isClockWise,
            a = this.subPaths;
          if (0 === a.length) return [];
          if (!0 === t) return n(a);
          let o, s, l;
          const c = [];
          if (1 === a.length)
            return (
              (s = a[0]), (l = new Ou()), (l.curves = s.curves), c.push(l), c
            );
          let u = !r(a[0].getPoints());
          u = e ? !u : u;
          const h = [],
            d = [];
          let p,
            m,
            f = [],
            g = 0;
          (d[g] = void 0), (f[g] = []);
          for (let t = 0, n = a.length; t < n; t++)
            (s = a[t]),
              (p = s.getPoints()),
              (o = r(p)),
              (o = e ? !o : o),
              o
                ? (!u && d[g] && g++,
                  (d[g] = { s: new Ou(), p }),
                  (d[g].s.curves = s.curves),
                  u && g++,
                  (f[g] = []))
                : f[g].push({ h: s, p: p[0] });
          if (!d[0]) return n(a);
          if (d.length > 1) {
            let e = !1;
            const t = [];
            for (let e = 0, t = d.length; e < t; e++) h[e] = [];
            for (let n = 0, r = d.length; n < r; n++) {
              const r = f[n];
              for (let a = 0; a < r.length; a++) {
                const o = r[a];
                let s = !0;
                for (let r = 0; r < d.length; r++)
                  i(o.p, d[r].p) &&
                    (n !== r && t.push({ froms: n, tos: r, hole: a }),
                    s ? ((s = !1), h[r].push(o)) : (e = !0));
                s && h[n].push(o);
              }
            }
            t.length > 0 && (e || (f = h));
          }
          for (let e = 0, t = d.length; e < t; e++) {
            (l = d[e].s), c.push(l), (m = f[e]);
            for (let e = 0, t = m.length; e < t; e++) l.holes.push(m[e].h);
          }
          return c;
        }
      }
      class ah {
        constructor(e) {
          (this.type = "Font"), (this.data = e);
        }
        generateShapes(e, t = 100) {
          const n = [],
            i = (function (e, t, n) {
              const i = Array.from(e),
                r = t / n.resolution,
                a =
                  (n.boundingBox.yMax -
                    n.boundingBox.yMin +
                    n.underlineThickness) *
                  r,
                o = [];
              let s = 0,
                l = 0;
              for (let e = 0; e < i.length; e++) {
                const t = i[e];
                if ("\n" === t) (s = 0), (l -= a);
                else {
                  const e = oh(t, r, s, l, n);
                  (s += e.offsetX), o.push(e.path);
                }
              }
              return o;
            })(e, t, this.data);
          for (let e = 0, t = i.length; e < t; e++)
            Array.prototype.push.apply(n, i[e].toShapes());
          return n;
        }
      }
      function oh(e, t, n, i, r) {
        const a = r.glyphs[e] || r.glyphs["?"];
        if (!a)
          return void console.error(
            'THREE.Font: character "' +
              e +
              '" does not exists in font family ' +
              r.familyName +
              "."
          );
        const o = new rh();
        let s, l, c, u, h, d, p, m;
        if (a.o) {
          const e = a._cachedOutline || (a._cachedOutline = a.o.split(" "));
          for (let r = 0, a = e.length; r < a; ) {
            switch (e[r++]) {
              case "m":
                (s = e[r++] * t + n), (l = e[r++] * t + i), o.moveTo(s, l);
                break;
              case "l":
                (s = e[r++] * t + n), (l = e[r++] * t + i), o.lineTo(s, l);
                break;
              case "q":
                (c = e[r++] * t + n),
                  (u = e[r++] * t + i),
                  (h = e[r++] * t + n),
                  (d = e[r++] * t + i),
                  o.quadraticCurveTo(h, d, c, u);
                break;
              case "b":
                (c = e[r++] * t + n),
                  (u = e[r++] * t + i),
                  (h = e[r++] * t + n),
                  (d = e[r++] * t + i),
                  (p = e[r++] * t + n),
                  (m = e[r++] * t + i),
                  o.bezierCurveTo(h, d, p, m, c, u);
            }
          }
        }
        return { offsetX: a.ha * t, path: o };
      }
      ah.prototype.isFont = !0;
      let sh;
      const lh = function () {
        return (
          void 0 === sh &&
            (sh = new (window.AudioContext || window.webkitAudioContext)()),
          sh
        );
      };
      class ch extends Eu {
        constructor(e) {
          super(e);
        }
        load(e, t, n, i) {
          const r = this,
            a = new Lu(this.manager);
          a.setResponseType("arraybuffer"),
            a.setPath(this.path),
            a.setRequestHeader(this.requestHeader),
            a.setWithCredentials(this.withCredentials),
            a.load(
              e,
              function (n) {
                try {
                  const e = n.slice(0);
                  lh().decodeAudioData(e, function (e) {
                    t(e);
                  });
                } catch (t) {
                  i ? i(t) : console.error(t), r.manager.itemError(e);
                }
              },
              n,
              i
            );
        }
      }
      (class extends eh {
        constructor(e, t, n = 1) {
          super(void 0, n);
          const i = new sr().set(e),
            r = new sr().set(t),
            a = new zn(i.r, i.g, i.b),
            o = new zn(r.r, r.g, r.b),
            s = Math.sqrt(Math.PI),
            l = s * Math.sqrt(0.75);
          this.sh.coefficients[0].copy(a).add(o).multiplyScalar(s),
            this.sh.coefficients[1].copy(a).sub(o).multiplyScalar(l);
        }
      }).prototype.isHemisphereLightProbe = !0;
      (class extends eh {
        constructor(e, t = 1) {
          super(void 0, t);
          const n = new sr().set(e);
          this.sh.coefficients[0]
            .set(n.r, n.g, n.b)
            .multiplyScalar(2 * Math.sqrt(Math.PI));
        }
      }).prototype.isAmbientLightProbe = !0;
      class uh extends Bi {
        constructor(e) {
          super(),
            (this.type = "Audio"),
            (this.listener = e),
            (this.context = e.context),
            (this.gain = this.context.createGain()),
            this.gain.connect(e.getInput()),
            (this.autoplay = !1),
            (this.buffer = null),
            (this.detune = 0),
            (this.loop = !1),
            (this.loopStart = 0),
            (this.loopEnd = 0),
            (this.offset = 0),
            (this.duration = void 0),
            (this.playbackRate = 1),
            (this.isPlaying = !1),
            (this.hasPlaybackControl = !0),
            (this.source = null),
            (this.sourceType = "empty"),
            (this._startedAt = 0),
            (this._progress = 0),
            (this._connected = !1),
            (this.filters = []);
        }
        getOutput() {
          return this.gain;
        }
        setNodeSource(e) {
          return (
            (this.hasPlaybackControl = !1),
            (this.sourceType = "audioNode"),
            (this.source = e),
            this.connect(),
            this
          );
        }
        setMediaElementSource(e) {
          return (
            (this.hasPlaybackControl = !1),
            (this.sourceType = "mediaNode"),
            (this.source = this.context.createMediaElementSource(e)),
            this.connect(),
            this
          );
        }
        setMediaStreamSource(e) {
          return (
            (this.hasPlaybackControl = !1),
            (this.sourceType = "mediaStreamNode"),
            (this.source = this.context.createMediaStreamSource(e)),
            this.connect(),
            this
          );
        }
        setBuffer(e) {
          return (
            (this.buffer = e),
            (this.sourceType = "buffer"),
            this.autoplay && this.play(),
            this
          );
        }
        play(e = 0) {
          if (!0 === this.isPlaying)
            return void console.warn("THREE.Audio: Audio is already playing.");
          if (!1 === this.hasPlaybackControl)
            return void console.warn(
              "THREE.Audio: this Audio has no playback control."
            );
          this._startedAt = this.context.currentTime + e;
          const t = this.context.createBufferSource();
          return (
            (t.buffer = this.buffer),
            (t.loop = this.loop),
            (t.loopStart = this.loopStart),
            (t.loopEnd = this.loopEnd),
            (t.onended = this.onEnded.bind(this)),
            t.start(
              this._startedAt,
              this._progress + this.offset,
              this.duration
            ),
            (this.isPlaying = !0),
            (this.source = t),
            this.setDetune(this.detune),
            this.setPlaybackRate(this.playbackRate),
            this.connect()
          );
        }
        pause() {
          if (!1 !== this.hasPlaybackControl)
            return (
              !0 === this.isPlaying &&
                ((this._progress +=
                  Math.max(this.context.currentTime - this._startedAt, 0) *
                  this.playbackRate),
                !0 === this.loop &&
                  (this._progress =
                    this._progress % (this.duration || this.buffer.duration)),
                this.source.stop(),
                (this.source.onended = null),
                (this.isPlaying = !1)),
              this
            );
          console.warn("THREE.Audio: this Audio has no playback control.");
        }
        stop() {
          if (!1 !== this.hasPlaybackControl)
            return (
              (this._progress = 0),
              this.source.stop(),
              (this.source.onended = null),
              (this.isPlaying = !1),
              this
            );
          console.warn("THREE.Audio: this Audio has no playback control.");
        }
        connect() {
          if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for (let e = 1, t = this.filters.length; e < t; e++)
              this.filters[e - 1].connect(this.filters[e]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
          } else this.source.connect(this.getOutput());
          return (this._connected = !0), this;
        }
        disconnect() {
          if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for (let e = 1, t = this.filters.length; e < t; e++)
              this.filters[e - 1].disconnect(this.filters[e]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
          } else this.source.disconnect(this.getOutput());
          return (this._connected = !1), this;
        }
        getFilters() {
          return this.filters;
        }
        setFilters(e) {
          return (
            e || (e = []),
            !0 === this._connected
              ? (this.disconnect(), (this.filters = e.slice()), this.connect())
              : (this.filters = e.slice()),
            this
          );
        }
        setDetune(e) {
          if (((this.detune = e), void 0 !== this.source.detune))
            return (
              !0 === this.isPlaying &&
                this.source.detune.setTargetAtTime(
                  this.detune,
                  this.context.currentTime,
                  0.01
                ),
              this
            );
        }
        getDetune() {
          return this.detune;
        }
        getFilter() {
          return this.getFilters()[0];
        }
        setFilter(e) {
          return this.setFilters(e ? [e] : []);
        }
        setPlaybackRate(e) {
          if (!1 !== this.hasPlaybackControl)
            return (
              (this.playbackRate = e),
              !0 === this.isPlaying &&
                this.source.playbackRate.setTargetAtTime(
                  this.playbackRate,
                  this.context.currentTime,
                  0.01
                ),
              this
            );
          console.warn("THREE.Audio: this Audio has no playback control.");
        }
        getPlaybackRate() {
          return this.playbackRate;
        }
        onEnded() {
          this.isPlaying = !1;
        }
        getLoop() {
          return !1 === this.hasPlaybackControl
            ? (console.warn("THREE.Audio: this Audio has no playback control."),
              !1)
            : this.loop;
        }
        setLoop(e) {
          if (!1 !== this.hasPlaybackControl)
            return (
              (this.loop = e),
              !0 === this.isPlaying && (this.source.loop = this.loop),
              this
            );
          console.warn("THREE.Audio: this Audio has no playback control.");
        }
        setLoopStart(e) {
          return (this.loopStart = e), this;
        }
        setLoopEnd(e) {
          return (this.loopEnd = e), this;
        }
        getVolume() {
          return this.gain.gain.value;
        }
        setVolume(e) {
          return (
            this.gain.gain.setTargetAtTime(e, this.context.currentTime, 0.01),
            this
          );
        }
      }
      class hh {
        constructor(e, t, n) {
          let i, r, a;
          switch (((this.binding = e), (this.valueSize = n), t)) {
            case "quaternion":
              (i = this._slerp),
                (r = this._slerpAdditive),
                (a = this._setAdditiveIdentityQuaternion),
                (this.buffer = new Float64Array(6 * n)),
                (this._workIndex = 5);
              break;
            case "string":
            case "bool":
              (i = this._select),
                (r = this._select),
                (a = this._setAdditiveIdentityOther),
                (this.buffer = new Array(5 * n));
              break;
            default:
              (i = this._lerp),
                (r = this._lerpAdditive),
                (a = this._setAdditiveIdentityNumeric),
                (this.buffer = new Float64Array(5 * n));
          }
          (this._mixBufferRegion = i),
            (this._mixBufferRegionAdditive = r),
            (this._setIdentity = a),
            (this._origIndex = 3),
            (this._addIndex = 4),
            (this.cumulativeWeight = 0),
            (this.cumulativeWeightAdditive = 0),
            (this.useCount = 0),
            (this.referenceCount = 0);
        }
        accumulate(e, t) {
          const n = this.buffer,
            i = this.valueSize,
            r = e * i + i;
          let a = this.cumulativeWeight;
          if (0 === a) {
            for (let e = 0; e !== i; ++e) n[r + e] = n[e];
            a = t;
          } else {
            a += t;
            const e = t / a;
            this._mixBufferRegion(n, r, 0, e, i);
          }
          this.cumulativeWeight = a;
        }
        accumulateAdditive(e) {
          const t = this.buffer,
            n = this.valueSize,
            i = n * this._addIndex;
          0 === this.cumulativeWeightAdditive && this._setIdentity(),
            this._mixBufferRegionAdditive(t, i, 0, e, n),
            (this.cumulativeWeightAdditive += e);
        }
        apply(e) {
          const t = this.valueSize,
            n = this.buffer,
            i = e * t + t,
            r = this.cumulativeWeight,
            a = this.cumulativeWeightAdditive,
            o = this.binding;
          if (
            ((this.cumulativeWeight = 0),
            (this.cumulativeWeightAdditive = 0),
            r < 1)
          ) {
            const e = t * this._origIndex;
            this._mixBufferRegion(n, i, e, 1 - r, t);
          }
          a > 0 &&
            this._mixBufferRegionAdditive(n, i, this._addIndex * t, 1, t);
          for (let e = t, r = t + t; e !== r; ++e)
            if (n[e] !== n[e + t]) {
              o.setValue(n, i);
              break;
            }
        }
        saveOriginalState() {
          const e = this.binding,
            t = this.buffer,
            n = this.valueSize,
            i = n * this._origIndex;
          e.getValue(t, i);
          for (let e = n, r = i; e !== r; ++e) t[e] = t[i + (e % n)];
          this._setIdentity(),
            (this.cumulativeWeight = 0),
            (this.cumulativeWeightAdditive = 0);
        }
        restoreOriginalState() {
          const e = 3 * this.valueSize;
          this.binding.setValue(this.buffer, e);
        }
        _setAdditiveIdentityNumeric() {
          const e = this._addIndex * this.valueSize,
            t = e + this.valueSize;
          for (let n = e; n < t; n++) this.buffer[n] = 0;
        }
        _setAdditiveIdentityQuaternion() {
          this._setAdditiveIdentityNumeric(),
            (this.buffer[this._addIndex * this.valueSize + 3] = 1);
        }
        _setAdditiveIdentityOther() {
          const e = this._origIndex * this.valueSize,
            t = this._addIndex * this.valueSize;
          for (let n = 0; n < this.valueSize; n++)
            this.buffer[t + n] = this.buffer[e + n];
        }
        _select(e, t, n, i, r) {
          if (i >= 0.5) for (let i = 0; i !== r; ++i) e[t + i] = e[n + i];
        }
        _slerp(e, t, n, i) {
          Hn.slerpFlat(e, t, e, t, e, n, i);
        }
        _slerpAdditive(e, t, n, i, r) {
          const a = this._workIndex * r;
          Hn.multiplyQuaternionsFlat(e, a, e, t, e, n),
            Hn.slerpFlat(e, t, e, t, e, a, i);
        }
        _lerp(e, t, n, i, r) {
          const a = 1 - i;
          for (let o = 0; o !== r; ++o) {
            const r = t + o;
            e[r] = e[r] * a + e[n + o] * i;
          }
        }
        _lerpAdditive(e, t, n, i, r) {
          for (let a = 0; a !== r; ++a) {
            const r = t + a;
            e[r] = e[r] + e[n + a] * i;
          }
        }
      }
      const dh = "\\[\\]\\.:\\/",
        ph = new RegExp("[" + dh + "]", "g"),
        mh = "[^" + dh + "]",
        fh = "[^" + dh.replace("\\.", "") + "]",
        gh = /((?:WC+[\/:])*)/.source.replace("WC", mh),
        vh = /(WCOD+)?/.source.replace("WCOD", fh),
        yh = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", mh),
        xh = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", mh),
        bh = new RegExp("^" + gh + vh + yh + xh + "$"),
        _h = ["material", "materials", "bones"];
      class wh {
        constructor(e, t, n) {
          (this.path = t),
            (this.parsedPath = n || wh.parseTrackName(t)),
            (this.node = wh.findNode(e, this.parsedPath.nodeName) || e),
            (this.rootNode = e),
            (this.getValue = this._getValue_unbound),
            (this.setValue = this._setValue_unbound);
        }
        static create(e, t, n) {
          return e && e.isAnimationObjectGroup
            ? new wh.Composite(e, t, n)
            : new wh(e, t, n);
        }
        static sanitizeNodeName(e) {
          return e.replace(/\s/g, "_").replace(ph, "");
        }
        static parseTrackName(e) {
          const t = bh.exec(e);
          if (!t)
            throw new Error("PropertyBinding: Cannot parse trackName: " + e);
          const n = {
              nodeName: t[2],
              objectName: t[3],
              objectIndex: t[4],
              propertyName: t[5],
              propertyIndex: t[6],
            },
            i = n.nodeName && n.nodeName.lastIndexOf(".");
          if (void 0 !== i && -1 !== i) {
            const e = n.nodeName.substring(i + 1);
            -1 !== _h.indexOf(e) &&
              ((n.nodeName = n.nodeName.substring(0, i)), (n.objectName = e));
          }
          if (null === n.propertyName || 0 === n.propertyName.length)
            throw new Error(
              "PropertyBinding: can not parse propertyName from trackName: " + e
            );
          return n;
        }
        static findNode(e, t) {
          if (
            !t ||
            "" === t ||
            "." === t ||
            -1 === t ||
            t === e.name ||
            t === e.uuid
          )
            return e;
          if (e.skeleton) {
            const n = e.skeleton.getBoneByName(t);
            if (void 0 !== n) return n;
          }
          if (e.children) {
            const n = function (e) {
                for (let i = 0; i < e.length; i++) {
                  const r = e[i];
                  if (r.name === t || r.uuid === t) return r;
                  const a = n(r.children);
                  if (a) return a;
                }
                return null;
              },
              i = n(e.children);
            if (i) return i;
          }
          return null;
        }
        _getValue_unavailable() {}
        _setValue_unavailable() {}
        _getValue_direct(e, t) {
          e[t] = this.targetObject[this.propertyName];
        }
        _getValue_array(e, t) {
          const n = this.resolvedProperty;
          for (let i = 0, r = n.length; i !== r; ++i) e[t++] = n[i];
        }
        _getValue_arrayElement(e, t) {
          e[t] = this.resolvedProperty[this.propertyIndex];
        }
        _getValue_toArray(e, t) {
          this.resolvedProperty.toArray(e, t);
        }
        _setValue_direct(e, t) {
          this.targetObject[this.propertyName] = e[t];
        }
        _setValue_direct_setNeedsUpdate(e, t) {
          (this.targetObject[this.propertyName] = e[t]),
            (this.targetObject.needsUpdate = !0);
        }
        _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
          (this.targetObject[this.propertyName] = e[t]),
            (this.targetObject.matrixWorldNeedsUpdate = !0);
        }
        _setValue_array(e, t) {
          const n = this.resolvedProperty;
          for (let i = 0, r = n.length; i !== r; ++i) n[i] = e[t++];
        }
        _setValue_array_setNeedsUpdate(e, t) {
          const n = this.resolvedProperty;
          for (let i = 0, r = n.length; i !== r; ++i) n[i] = e[t++];
          this.targetObject.needsUpdate = !0;
        }
        _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
          const n = this.resolvedProperty;
          for (let i = 0, r = n.length; i !== r; ++i) n[i] = e[t++];
          this.targetObject.matrixWorldNeedsUpdate = !0;
        }
        _setValue_arrayElement(e, t) {
          this.resolvedProperty[this.propertyIndex] = e[t];
        }
        _setValue_arrayElement_setNeedsUpdate(e, t) {
          (this.resolvedProperty[this.propertyIndex] = e[t]),
            (this.targetObject.needsUpdate = !0);
        }
        _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
          (this.resolvedProperty[this.propertyIndex] = e[t]),
            (this.targetObject.matrixWorldNeedsUpdate = !0);
        }
        _setValue_fromArray(e, t) {
          this.resolvedProperty.fromArray(e, t);
        }
        _setValue_fromArray_setNeedsUpdate(e, t) {
          this.resolvedProperty.fromArray(e, t),
            (this.targetObject.needsUpdate = !0);
        }
        _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
          this.resolvedProperty.fromArray(e, t),
            (this.targetObject.matrixWorldNeedsUpdate = !0);
        }
        _getValue_unbound(e, t) {
          this.bind(), this.getValue(e, t);
        }
        _setValue_unbound(e, t) {
          this.bind(), this.setValue(e, t);
        }
        bind() {
          let e = this.node;
          const t = this.parsedPath,
            n = t.objectName,
            i = t.propertyName;
          let r = t.propertyIndex;
          if (
            (e ||
              ((e = wh.findNode(this.rootNode, t.nodeName) || this.rootNode),
              (this.node = e)),
            (this.getValue = this._getValue_unavailable),
            (this.setValue = this._setValue_unavailable),
            !e)
          )
            return void console.error(
              "THREE.PropertyBinding: Trying to update node for track: " +
                this.path +
                " but it wasn't found."
            );
          if (n) {
            let i = t.objectIndex;
            switch (n) {
              case "materials":
                if (!e.material)
                  return void console.error(
                    "THREE.PropertyBinding: Can not bind to material as node does not have a material.",
                    this
                  );
                if (!e.material.materials)
                  return void console.error(
                    "THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.",
                    this
                  );
                e = e.material.materials;
                break;
              case "bones":
                if (!e.skeleton)
                  return void console.error(
                    "THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.",
                    this
                  );
                e = e.skeleton.bones;
                for (let t = 0; t < e.length; t++)
                  if (e[t].name === i) {
                    i = t;
                    break;
                  }
                break;
              default:
                if (void 0 === e[n])
                  return void console.error(
                    "THREE.PropertyBinding: Can not bind to objectName of node undefined.",
                    this
                  );
                e = e[n];
            }
            if (void 0 !== i) {
              if (void 0 === e[i])
                return void console.error(
                  "THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.",
                  this,
                  e
                );
              e = e[i];
            }
          }
          const a = e[i];
          if (void 0 === a) {
            const n = t.nodeName;
            return void console.error(
              "THREE.PropertyBinding: Trying to update property for track: " +
                n +
                "." +
                i +
                " but it wasn't found.",
              e
            );
          }
          let o = this.Versioning.None;
          (this.targetObject = e),
            void 0 !== e.needsUpdate
              ? (o = this.Versioning.NeedsUpdate)
              : void 0 !== e.matrixWorldNeedsUpdate &&
                (o = this.Versioning.MatrixWorldNeedsUpdate);
          let s = this.BindingType.Direct;
          if (void 0 !== r) {
            if ("morphTargetInfluences" === i) {
              if (!e.geometry)
                return void console.error(
                  "THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.",
                  this
                );
              if (!e.geometry.isBufferGeometry)
                return void console.error(
                  "THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.",
                  this
                );
              if (!e.geometry.morphAttributes)
                return void console.error(
                  "THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.",
                  this
                );
              void 0 !== e.morphTargetDictionary[r] &&
                (r = e.morphTargetDictionary[r]);
            }
            (s = this.BindingType.ArrayElement),
              (this.resolvedProperty = a),
              (this.propertyIndex = r);
          } else
            void 0 !== a.fromArray && void 0 !== a.toArray
              ? ((s = this.BindingType.HasFromToArray),
                (this.resolvedProperty = a))
              : Array.isArray(a)
              ? ((s = this.BindingType.EntireArray),
                (this.resolvedProperty = a))
              : (this.propertyName = i);
          (this.getValue = this.GetterByBindingType[s]),
            (this.setValue = this.SetterByBindingTypeAndVersioning[s][o]);
        }
        unbind() {
          (this.node = null),
            (this.getValue = this._getValue_unbound),
            (this.setValue = this._setValue_unbound);
        }
      }
      (wh.Composite = class {
        constructor(e, t, n) {
          const i = n || wh.parseTrackName(t);
          (this._targetGroup = e), (this._bindings = e.subscribe_(t, i));
        }
        getValue(e, t) {
          this.bind();
          const n = this._targetGroup.nCachedObjects_,
            i = this._bindings[n];
          void 0 !== i && i.getValue(e, t);
        }
        setValue(e, t) {
          const n = this._bindings;
          for (
            let i = this._targetGroup.nCachedObjects_, r = n.length;
            i !== r;
            ++i
          )
            n[i].setValue(e, t);
        }
        bind() {
          const e = this._bindings;
          for (
            let t = this._targetGroup.nCachedObjects_, n = e.length;
            t !== n;
            ++t
          )
            e[t].bind();
        }
        unbind() {
          const e = this._bindings;
          for (
            let t = this._targetGroup.nCachedObjects_, n = e.length;
            t !== n;
            ++t
          )
            e[t].unbind();
        }
      }),
        (wh.prototype.BindingType = {
          Direct: 0,
          EntireArray: 1,
          ArrayElement: 2,
          HasFromToArray: 3,
        }),
        (wh.prototype.Versioning = {
          None: 0,
          NeedsUpdate: 1,
          MatrixWorldNeedsUpdate: 2,
        }),
        (wh.prototype.GetterByBindingType = [
          wh.prototype._getValue_direct,
          wh.prototype._getValue_array,
          wh.prototype._getValue_arrayElement,
          wh.prototype._getValue_toArray,
        ]),
        (wh.prototype.SetterByBindingTypeAndVersioning = [
          [
            wh.prototype._setValue_direct,
            wh.prototype._setValue_direct_setNeedsUpdate,
            wh.prototype._setValue_direct_setMatrixWorldNeedsUpdate,
          ],
          [
            wh.prototype._setValue_array,
            wh.prototype._setValue_array_setNeedsUpdate,
            wh.prototype._setValue_array_setMatrixWorldNeedsUpdate,
          ],
          [
            wh.prototype._setValue_arrayElement,
            wh.prototype._setValue_arrayElement_setNeedsUpdate,
            wh.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate,
          ],
          [
            wh.prototype._setValue_fromArray,
            wh.prototype._setValue_fromArray_setNeedsUpdate,
            wh.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate,
          ],
        ]);
      class Mh {
        constructor(e, t, n = null, i = t.blendMode) {
          (this._mixer = e),
            (this._clip = t),
            (this._localRoot = n),
            (this.blendMode = i);
          const r = t.tracks,
            a = r.length,
            o = new Array(a),
            s = { endingStart: Yt, endingEnd: Yt };
          for (let e = 0; e !== a; ++e) {
            const t = r[e].createInterpolant(null);
            (o[e] = t), (t.settings = s);
          }
          (this._interpolantSettings = s),
            (this._interpolants = o),
            (this._propertyBindings = new Array(a)),
            (this._cacheIndex = null),
            (this._byClipCacheIndex = null),
            (this._timeScaleInterpolant = null),
            (this._weightInterpolant = null),
            (this.loop = 2201),
            (this._loopCount = -1),
            (this._startTime = null),
            (this.time = 0),
            (this.timeScale = 1),
            (this._effectiveTimeScale = 1),
            (this.weight = 1),
            (this._effectiveWeight = 1),
            (this.repetitions = 1 / 0),
            (this.paused = !1),
            (this.enabled = !0),
            (this.clampWhenFinished = !1),
            (this.zeroSlopeAtStart = !0),
            (this.zeroSlopeAtEnd = !0);
        }
        play() {
          return this._mixer._activateAction(this), this;
        }
        stop() {
          return this._mixer._deactivateAction(this), this.reset();
        }
        reset() {
          return (
            (this.paused = !1),
            (this.enabled = !0),
            (this.time = 0),
            (this._loopCount = -1),
            (this._startTime = null),
            this.stopFading().stopWarping()
          );
        }
        isRunning() {
          return (
            this.enabled &&
            !this.paused &&
            0 !== this.timeScale &&
            null === this._startTime &&
            this._mixer._isActiveAction(this)
          );
        }
        isScheduled() {
          return this._mixer._isActiveAction(this);
        }
        startAt(e) {
          return (this._startTime = e), this;
        }
        setLoop(e, t) {
          return (this.loop = e), (this.repetitions = t), this;
        }
        setEffectiveWeight(e) {
          return (
            (this.weight = e),
            (this._effectiveWeight = this.enabled ? e : 0),
            this.stopFading()
          );
        }
        getEffectiveWeight() {
          return this._effectiveWeight;
        }
        fadeIn(e) {
          return this._scheduleFading(e, 0, 1);
        }
        fadeOut(e) {
          return this._scheduleFading(e, 1, 0);
        }
        crossFadeFrom(e, t, n) {
          if ((e.fadeOut(t), this.fadeIn(t), n)) {
            const n = this._clip.duration,
              i = e._clip.duration,
              r = i / n,
              a = n / i;
            e.warp(1, r, t), this.warp(a, 1, t);
          }
          return this;
        }
        crossFadeTo(e, t, n) {
          return e.crossFadeFrom(this, t, n);
        }
        stopFading() {
          const e = this._weightInterpolant;
          return (
            null !== e &&
              ((this._weightInterpolant = null),
              this._mixer._takeBackControlInterpolant(e)),
            this
          );
        }
        setEffectiveTimeScale(e) {
          return (
            (this.timeScale = e),
            (this._effectiveTimeScale = this.paused ? 0 : e),
            this.stopWarping()
          );
        }
        getEffectiveTimeScale() {
          return this._effectiveTimeScale;
        }
        setDuration(e) {
          return (this.timeScale = this._clip.duration / e), this.stopWarping();
        }
        syncWith(e) {
          return (
            (this.time = e.time),
            (this.timeScale = e.timeScale),
            this.stopWarping()
          );
        }
        halt(e) {
          return this.warp(this._effectiveTimeScale, 0, e);
        }
        warp(e, t, n) {
          const i = this._mixer,
            r = i.time,
            a = this.timeScale;
          let o = this._timeScaleInterpolant;
          null === o &&
            ((o = i._lendControlInterpolant()),
            (this._timeScaleInterpolant = o));
          const s = o.parameterPositions,
            l = o.sampleValues;
          return (
            (s[0] = r), (s[1] = r + n), (l[0] = e / a), (l[1] = t / a), this
          );
        }
        stopWarping() {
          const e = this._timeScaleInterpolant;
          return (
            null !== e &&
              ((this._timeScaleInterpolant = null),
              this._mixer._takeBackControlInterpolant(e)),
            this
          );
        }
        getMixer() {
          return this._mixer;
        }
        getClip() {
          return this._clip;
        }
        getRoot() {
          return this._localRoot || this._mixer._root;
        }
        _update(e, t, n, i) {
          if (!this.enabled) return void this._updateWeight(e);
          const r = this._startTime;
          if (null !== r) {
            const i = (e - r) * n;
            if (i < 0 || 0 === n) return;
            (this._startTime = null), (t = n * i);
          }
          t *= this._updateTimeScale(e);
          const a = this._updateTime(t),
            o = this._updateWeight(e);
          if (o > 0) {
            const e = this._interpolants,
              t = this._propertyBindings;
            if (2501 === this.blendMode)
              for (let n = 0, i = e.length; n !== i; ++n)
                e[n].evaluate(a), t[n].accumulateAdditive(o);
            else
              for (let n = 0, r = e.length; n !== r; ++n)
                e[n].evaluate(a), t[n].accumulate(i, o);
          }
        }
        _updateWeight(e) {
          let t = 0;
          if (this.enabled) {
            t = this.weight;
            const n = this._weightInterpolant;
            if (null !== n) {
              const i = n.evaluate(e)[0];
              (t *= i),
                e > n.parameterPositions[1] &&
                  (this.stopFading(), 0 === i && (this.enabled = !1));
            }
          }
          return (this._effectiveWeight = t), t;
        }
        _updateTimeScale(e) {
          let t = 0;
          if (!this.paused) {
            t = this.timeScale;
            const n = this._timeScaleInterpolant;
            if (null !== n) {
              (t *= n.evaluate(e)[0]),
                e > n.parameterPositions[1] &&
                  (this.stopWarping(),
                  0 === t ? (this.paused = !0) : (this.timeScale = t));
            }
          }
          return (this._effectiveTimeScale = t), t;
        }
        _updateTime(e) {
          const t = this._clip.duration,
            n = this.loop;
          let i = this.time + e,
            r = this._loopCount;
          const a = 2202 === n;
          if (0 === e) return -1 === r ? i : a && 1 == (1 & r) ? t - i : i;
          if (2200 === n) {
            -1 === r && ((this._loopCount = 0), this._setEndings(!0, !0, !1));
            e: {
              if (i >= t) i = t;
              else {
                if (!(i < 0)) {
                  this.time = i;
                  break e;
                }
                i = 0;
              }
              this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
                (this.time = i),
                this._mixer.dispatchEvent({
                  type: "finished",
                  action: this,
                  direction: e < 0 ? -1 : 1,
                });
            }
          } else {
            if (
              (-1 === r &&
                (e >= 0
                  ? ((r = 0), this._setEndings(!0, 0 === this.repetitions, a))
                  : this._setEndings(0 === this.repetitions, !0, a)),
              i >= t || i < 0)
            ) {
              const n = Math.floor(i / t);
              (i -= t * n), (r += Math.abs(n));
              const o = this.repetitions - r;
              if (o <= 0)
                this.clampWhenFinished
                  ? (this.paused = !0)
                  : (this.enabled = !1),
                  (i = e > 0 ? t : 0),
                  (this.time = i),
                  this._mixer.dispatchEvent({
                    type: "finished",
                    action: this,
                    direction: e > 0 ? 1 : -1,
                  });
              else {
                if (1 === o) {
                  const t = e < 0;
                  this._setEndings(t, !t, a);
                } else this._setEndings(!1, !1, a);
                (this._loopCount = r),
                  (this.time = i),
                  this._mixer.dispatchEvent({
                    type: "loop",
                    action: this,
                    loopDelta: n,
                  });
              }
            } else this.time = i;
            if (a && 1 == (1 & r)) return t - i;
          }
          return i;
        }
        _setEndings(e, t, n) {
          const i = this._interpolantSettings;
          n
            ? ((i.endingStart = Kt), (i.endingEnd = Kt))
            : ((i.endingStart = e ? (this.zeroSlopeAtStart ? Kt : Yt) : Zt),
              (i.endingEnd = t ? (this.zeroSlopeAtEnd ? Kt : Yt) : Zt));
        }
        _scheduleFading(e, t, n) {
          const i = this._mixer,
            r = i.time;
          let a = this._weightInterpolant;
          null === a &&
            ((a = i._lendControlInterpolant()), (this._weightInterpolant = a));
          const o = a.parameterPositions,
            s = a.sampleValues;
          return (o[0] = r), (s[0] = t), (o[1] = r + e), (s[1] = n), this;
        }
      }
      (class extends fn {
        constructor(e) {
          super(),
            (this._root = e),
            this._initMemoryManager(),
            (this._accuIndex = 0),
            (this.time = 0),
            (this.timeScale = 1);
        }
        _bindAction(e, t) {
          const n = e._localRoot || this._root,
            i = e._clip.tracks,
            r = i.length,
            a = e._propertyBindings,
            o = e._interpolants,
            s = n.uuid,
            l = this._bindingsByRootAndName;
          let c = l[s];
          void 0 === c && ((c = {}), (l[s] = c));
          for (let e = 0; e !== r; ++e) {
            const r = i[e],
              l = r.name;
            let u = c[l];
            if (void 0 !== u) a[e] = u;
            else {
              if (((u = a[e]), void 0 !== u)) {
                null === u._cacheIndex &&
                  (++u.referenceCount, this._addInactiveBinding(u, s, l));
                continue;
              }
              const i = t && t._propertyBindings[e].binding.parsedPath;
              (u = new hh(
                wh.create(n, l, i),
                r.ValueTypeName,
                r.getValueSize()
              )),
                ++u.referenceCount,
                this._addInactiveBinding(u, s, l),
                (a[e] = u);
            }
            o[e].resultBuffer = u.buffer;
          }
        }
        _activateAction(e) {
          if (!this._isActiveAction(e)) {
            if (null === e._cacheIndex) {
              const t = (e._localRoot || this._root).uuid,
                n = e._clip.uuid,
                i = this._actionsByClip[n];
              this._bindAction(e, i && i.knownActions[0]),
                this._addInactiveAction(e, n, t);
            }
            const t = e._propertyBindings;
            for (let e = 0, n = t.length; e !== n; ++e) {
              const n = t[e];
              0 == n.useCount++ &&
                (this._lendBinding(n), n.saveOriginalState());
            }
            this._lendAction(e);
          }
        }
        _deactivateAction(e) {
          if (this._isActiveAction(e)) {
            const t = e._propertyBindings;
            for (let e = 0, n = t.length; e !== n; ++e) {
              const n = t[e];
              0 == --n.useCount &&
                (n.restoreOriginalState(), this._takeBackBinding(n));
            }
            this._takeBackAction(e);
          }
        }
        _initMemoryManager() {
          (this._actions = []),
            (this._nActiveActions = 0),
            (this._actionsByClip = {}),
            (this._bindings = []),
            (this._nActiveBindings = 0),
            (this._bindingsByRootAndName = {}),
            (this._controlInterpolants = []),
            (this._nActiveControlInterpolants = 0);
          const e = this;
          this.stats = {
            actions: {
              get total() {
                return e._actions.length;
              },
              get inUse() {
                return e._nActiveActions;
              },
            },
            bindings: {
              get total() {
                return e._bindings.length;
              },
              get inUse() {
                return e._nActiveBindings;
              },
            },
            controlInterpolants: {
              get total() {
                return e._controlInterpolants.length;
              },
              get inUse() {
                return e._nActiveControlInterpolants;
              },
            },
          };
        }
        _isActiveAction(e) {
          const t = e._cacheIndex;
          return null !== t && t < this._nActiveActions;
        }
        _addInactiveAction(e, t, n) {
          const i = this._actions,
            r = this._actionsByClip;
          let a = r[t];
          if (void 0 === a)
            (a = { knownActions: [e], actionByRoot: {} }),
              (e._byClipCacheIndex = 0),
              (r[t] = a);
          else {
            const t = a.knownActions;
            (e._byClipCacheIndex = t.length), t.push(e);
          }
          (e._cacheIndex = i.length), i.push(e), (a.actionByRoot[n] = e);
        }
        _removeInactiveAction(e) {
          const t = this._actions,
            n = t[t.length - 1],
            i = e._cacheIndex;
          (n._cacheIndex = i), (t[i] = n), t.pop(), (e._cacheIndex = null);
          const r = e._clip.uuid,
            a = this._actionsByClip,
            o = a[r],
            s = o.knownActions,
            l = s[s.length - 1],
            c = e._byClipCacheIndex;
          (l._byClipCacheIndex = c),
            (s[c] = l),
            s.pop(),
            (e._byClipCacheIndex = null);
          delete o.actionByRoot[(e._localRoot || this._root).uuid],
            0 === s.length && delete a[r],
            this._removeInactiveBindingsForAction(e);
        }
        _removeInactiveBindingsForAction(e) {
          const t = e._propertyBindings;
          for (let e = 0, n = t.length; e !== n; ++e) {
            const n = t[e];
            0 == --n.referenceCount && this._removeInactiveBinding(n);
          }
        }
        _lendAction(e) {
          const t = this._actions,
            n = e._cacheIndex,
            i = this._nActiveActions++,
            r = t[i];
          (e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r);
        }
        _takeBackAction(e) {
          const t = this._actions,
            n = e._cacheIndex,
            i = --this._nActiveActions,
            r = t[i];
          (e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r);
        }
        _addInactiveBinding(e, t, n) {
          const i = this._bindingsByRootAndName,
            r = this._bindings;
          let a = i[t];
          void 0 === a && ((a = {}), (i[t] = a)),
            (a[n] = e),
            (e._cacheIndex = r.length),
            r.push(e);
        }
        _removeInactiveBinding(e) {
          const t = this._bindings,
            n = e.binding,
            i = n.rootNode.uuid,
            r = n.path,
            a = this._bindingsByRootAndName,
            o = a[i],
            s = t[t.length - 1],
            l = e._cacheIndex;
          (s._cacheIndex = l),
            (t[l] = s),
            t.pop(),
            delete o[r],
            0 === Object.keys(o).length && delete a[i];
        }
        _lendBinding(e) {
          const t = this._bindings,
            n = e._cacheIndex,
            i = this._nActiveBindings++,
            r = t[i];
          (e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r);
        }
        _takeBackBinding(e) {
          const t = this._bindings,
            n = e._cacheIndex,
            i = --this._nActiveBindings,
            r = t[i];
          (e._cacheIndex = i), (t[i] = e), (r._cacheIndex = n), (t[n] = r);
        }
        _lendControlInterpolant() {
          const e = this._controlInterpolants,
            t = this._nActiveControlInterpolants++;
          let n = e[t];
          return (
            void 0 === n &&
              ((n = new hu(
                new Float32Array(2),
                new Float32Array(2),
                1,
                this._controlInterpolantsResultBuffer
              )),
              (n.__cacheIndex = t),
              (e[t] = n)),
            n
          );
        }
        _takeBackControlInterpolant(e) {
          const t = this._controlInterpolants,
            n = e.__cacheIndex,
            i = --this._nActiveControlInterpolants,
            r = t[i];
          (e.__cacheIndex = i), (t[i] = e), (r.__cacheIndex = n), (t[n] = r);
        }
        clipAction(e, t, n) {
          const i = t || this._root,
            r = i.uuid;
          let a = "string" == typeof e ? _u.findByName(i, e) : e;
          const o = null !== a ? a.uuid : e,
            s = this._actionsByClip[o];
          let l = null;
          if (
            (void 0 === n && (n = null !== a ? a.blendMode : Jt), void 0 !== s)
          ) {
            const e = s.actionByRoot[r];
            if (void 0 !== e && e.blendMode === n) return e;
            (l = s.knownActions[0]), null === a && (a = l._clip);
          }
          if (null === a) return null;
          const c = new Mh(this, a, t, n);
          return this._bindAction(c, l), this._addInactiveAction(c, o, r), c;
        }
        existingAction(e, t) {
          const n = t || this._root,
            i = n.uuid,
            r = "string" == typeof e ? _u.findByName(n, e) : e,
            a = r ? r.uuid : e,
            o = this._actionsByClip[a];
          return (void 0 !== o && o.actionByRoot[i]) || null;
        }
        stopAllAction() {
          const e = this._actions;
          for (let t = this._nActiveActions - 1; t >= 0; --t) e[t].stop();
          return this;
        }
        update(e) {
          e *= this.timeScale;
          const t = this._actions,
            n = this._nActiveActions,
            i = (this.time += e),
            r = Math.sign(e),
            a = (this._accuIndex ^= 1);
          for (let o = 0; o !== n; ++o) {
            t[o]._update(i, e, r, a);
          }
          const o = this._bindings,
            s = this._nActiveBindings;
          for (let e = 0; e !== s; ++e) o[e].apply(a);
          return this;
        }
        setTime(e) {
          this.time = 0;
          for (let e = 0; e < this._actions.length; e++)
            this._actions[e].time = 0;
          return this.update(e);
        }
        getRoot() {
          return this._root;
        }
        uncacheClip(e) {
          const t = this._actions,
            n = e.uuid,
            i = this._actionsByClip,
            r = i[n];
          if (void 0 !== r) {
            const e = r.knownActions;
            for (let n = 0, i = e.length; n !== i; ++n) {
              const i = e[n];
              this._deactivateAction(i);
              const r = i._cacheIndex,
                a = t[t.length - 1];
              (i._cacheIndex = null),
                (i._byClipCacheIndex = null),
                (a._cacheIndex = r),
                (t[r] = a),
                t.pop(),
                this._removeInactiveBindingsForAction(i);
            }
            delete i[n];
          }
        }
        uncacheRoot(e) {
          const t = e.uuid,
            n = this._actionsByClip;
          for (const e in n) {
            const i = n[e].actionByRoot[t];
            void 0 !== i &&
              (this._deactivateAction(i), this._removeInactiveAction(i));
          }
          const i = this._bindingsByRootAndName[t];
          if (void 0 !== i)
            for (const e in i) {
              const t = i[e];
              t.restoreOriginalState(), this._removeInactiveBinding(t);
            }
        }
        uncacheAction(e, t) {
          const n = this.existingAction(e, t);
          null !== n &&
            (this._deactivateAction(n), this._removeInactiveAction(n));
        }
      }).prototype._controlInterpolantsResultBuffer = new Float32Array(1);
      class Sh {
        constructor(e) {
          "string" == typeof e &&
            (console.warn("THREE.Uniform: Type parameter is no longer needed."),
            (e = arguments[1])),
            (this.value = e);
        }
        clone() {
          return new Sh(
            void 0 === this.value.clone ? this.value : this.value.clone()
          );
        }
      }
      (class extends nl {
        constructor(e, t, n = 1) {
          super(e, t), (this.meshPerAttribute = n);
        }
        copy(e) {
          return (
            super.copy(e), (this.meshPerAttribute = e.meshPerAttribute), this
          );
        }
        clone(e) {
          const t = super.clone(e);
          return (t.meshPerAttribute = this.meshPerAttribute), t;
        }
        toJSON(e) {
          const t = super.toJSON(e);
          return (
            (t.isInstancedInterleavedBuffer = !0),
            (t.meshPerAttribute = this.meshPerAttribute),
            t
          );
        }
      }).prototype.isInstancedInterleavedBuffer = !0;
      class Th {
        constructor(e = 1, t = 0, n = 0) {
          return (this.radius = e), (this.phi = t), (this.theta = n), this;
        }
        set(e, t, n) {
          return (this.radius = e), (this.phi = t), (this.theta = n), this;
        }
        copy(e) {
          return (
            (this.radius = e.radius),
            (this.phi = e.phi),
            (this.theta = e.theta),
            this
          );
        }
        makeSafe() {
          const e = 1e-6;
          return (
            (this.phi = Math.max(e, Math.min(Math.PI - e, this.phi))), this
          );
        }
        setFromVector3(e) {
          return this.setFromCartesianCoords(e.x, e.y, e.z);
        }
        setFromCartesianCoords(e, t, n) {
          return (
            (this.radius = Math.sqrt(e * e + t * t + n * n)),
            0 === this.radius
              ? ((this.theta = 0), (this.phi = 0))
              : ((this.theta = Math.atan2(e, n)),
                (this.phi = Math.acos(_n(t / this.radius, -1, 1)))),
            this
          );
        }
        clone() {
          return new this.constructor().copy(this);
        }
      }
      const Eh = new Ln();
      class Ah {
        constructor(e = new Ln(1 / 0, 1 / 0), t = new Ln(-1 / 0, -1 / 0)) {
          (this.min = e), (this.max = t);
        }
        set(e, t) {
          return this.min.copy(e), this.max.copy(t), this;
        }
        setFromPoints(e) {
          this.makeEmpty();
          for (let t = 0, n = e.length; t < n; t++) this.expandByPoint(e[t]);
          return this;
        }
        setFromCenterAndSize(e, t) {
          const n = Eh.copy(t).multiplyScalar(0.5);
          return this.min.copy(e).sub(n), this.max.copy(e).add(n), this;
        }
        clone() {
          return new this.constructor().copy(this);
        }
        copy(e) {
          return this.min.copy(e.min), this.max.copy(e.max), this;
        }
        makeEmpty() {
          return (
            (this.min.x = this.min.y = 1 / 0),
            (this.max.x = this.max.y = -1 / 0),
            this
          );
        }
        isEmpty() {
          return this.max.x < this.min.x || this.max.y < this.min.y;
        }
        getCenter(e) {
          return this.isEmpty()
            ? e.set(0, 0)
            : e.addVectors(this.min, this.max).multiplyScalar(0.5);
        }
        getSize(e) {
          return this.isEmpty()
            ? e.set(0, 0)
            : e.subVectors(this.max, this.min);
        }
        expandByPoint(e) {
          return this.min.min(e), this.max.max(e), this;
        }
        expandByVector(e) {
          return this.min.sub(e), this.max.add(e), this;
        }
        expandByScalar(e) {
          return this.min.addScalar(-e), this.max.addScalar(e), this;
        }
        containsPoint(e) {
          return !(
            e.x < this.min.x ||
            e.x > this.max.x ||
            e.y < this.min.y ||
            e.y > this.max.y
          );
        }
        containsBox(e) {
          return (
            this.min.x <= e.min.x &&
            e.max.x <= this.max.x &&
            this.min.y <= e.min.y &&
            e.max.y <= this.max.y
          );
        }
        getParameter(e, t) {
          return t.set(
            (e.x - this.min.x) / (this.max.x - this.min.x),
            (e.y - this.min.y) / (this.max.y - this.min.y)
          );
        }
        intersectsBox(e) {
          return !(
            e.max.x < this.min.x ||
            e.min.x > this.max.x ||
            e.max.y < this.min.y ||
            e.min.y > this.max.y
          );
        }
        clampPoint(e, t) {
          return t.copy(e).clamp(this.min, this.max);
        }
        distanceToPoint(e) {
          return Eh.copy(e).clamp(this.min, this.max).sub(e).length();
        }
        intersect(e) {
          return this.min.max(e.min), this.max.min(e.max), this;
        }
        union(e) {
          return this.min.min(e.min), this.max.max(e.max), this;
        }
        translate(e) {
          return this.min.add(e), this.max.add(e), this;
        }
        equals(e) {
          return e.min.equals(this.min) && e.max.equals(this.max);
        }
      }
      Ah.prototype.isBox2 = !0;
      (class extends Bi {
        constructor(e) {
          super(),
            (this.material = e),
            (this.render = function () {}),
            (this.hasPositions = !1),
            (this.hasNormals = !1),
            (this.hasColors = !1),
            (this.hasUvs = !1),
            (this.positionArray = null),
            (this.normalArray = null),
            (this.colorArray = null),
            (this.uvArray = null),
            (this.count = 0);
        }
      }).prototype.isImmediateRenderObject = !0;
      const Lh = new zn(),
        Ph = new gi(),
        Rh = new gi();
      function Ch(e) {
        const t = [];
        e && e.isBone && t.push(e);
        for (let n = 0; n < e.children.length; n++)
          t.push.apply(t, Ch(e.children[n]));
        return t;
      }
      const Ih = new Float32Array(1),
        Nh = new Int32Array(Ih.buffer);
      class Dh {
        static toHalfFloat(e) {
          Ih[0] = e;
          const t = Nh[0];
          let n = (t >> 16) & 32768,
            i = (t >> 12) & 2047;
          const r = (t >> 23) & 255;
          return r < 103
            ? n
            : r > 142
            ? ((n |= 31744), (n |= (255 == r ? 0 : 1) && 8388607 & t), n)
            : r < 113
            ? ((i |= 2048), (n |= (i >> (114 - r)) + ((i >> (113 - r)) & 1)), n)
            : ((n |= ((r - 112) << 10) | (i >> 1)), (n += 1 & i), n);
        }
      }
      (ic.create = function (e, t) {
        return (
          console.log("THREE.Curve.create() has been deprecated"),
          (e.prototype = Object.create(ic.prototype)),
          (e.prototype.constructor = e),
          (e.prototype.getPoint = t),
          e
        );
      }),
        (Du.prototype.fromPoints = function (e) {
          return (
            console.warn(
              "THREE.Path: .fromPoints() has been renamed to .setFromPoints()."
            ),
            this.setFromPoints(e)
          );
        }),
        (class extends ql {
          constructor(e = 10, t = 10, n = 4473924, i = 8947848) {
            (n = new sr(n)), (i = new sr(i));
            const r = t / 2,
              a = e / t,
              o = e / 2,
              s = [],
              l = [];
            for (let e = 0, c = 0, u = -o; e <= t; e++, u += a) {
              s.push(-o, 0, u, o, 0, u), s.push(u, 0, -o, u, 0, o);
              const t = e === r ? n : i;
              t.toArray(l, c),
                (c += 3),
                t.toArray(l, c),
                (c += 3),
                t.toArray(l, c),
                (c += 3),
                t.toArray(l, c),
                (c += 3);
            }
            const c = new Mr();
            c.setAttribute("position", new mr(s, 3)),
              c.setAttribute("color", new mr(l, 3));
            super(c, new Hl({ vertexColors: !0, toneMapped: !1 })),
              (this.type = "GridHelper");
          }
        }.prototype.setColors = function () {
          console.error(
            "THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead."
          );
        }),
        (class extends ql {
          constructor(e) {
            const t = Ch(e),
              n = new Mr(),
              i = [],
              r = [],
              a = new sr(0, 0, 1),
              o = new sr(0, 1, 0);
            for (let e = 0; e < t.length; e++) {
              const n = t[e];
              n.parent &&
                n.parent.isBone &&
                (i.push(0, 0, 0),
                i.push(0, 0, 0),
                r.push(a.r, a.g, a.b),
                r.push(o.r, o.g, o.b));
            }
            n.setAttribute("position", new mr(i, 3)),
              n.setAttribute("color", new mr(r, 3));
            super(
              n,
              new Hl({
                vertexColors: !0,
                depthTest: !1,
                depthWrite: !1,
                toneMapped: !1,
                transparent: !0,
              })
            ),
              (this.type = "SkeletonHelper"),
              (this.isSkeletonHelper = !0),
              (this.root = e),
              (this.bones = t),
              (this.matrix = e.matrixWorld),
              (this.matrixAutoUpdate = !1);
          }
          updateMatrixWorld(e) {
            const t = this.bones,
              n = this.geometry,
              i = n.getAttribute("position");
            Rh.copy(this.root.matrixWorld).invert();
            for (let e = 0, n = 0; e < t.length; e++) {
              const r = t[e];
              r.parent &&
                r.parent.isBone &&
                (Ph.multiplyMatrices(Rh, r.matrixWorld),
                Lh.setFromMatrixPosition(Ph),
                i.setXYZ(n, Lh.x, Lh.y, Lh.z),
                Ph.multiplyMatrices(Rh, r.parent.matrixWorld),
                Lh.setFromMatrixPosition(Ph),
                i.setXYZ(n + 1, Lh.x, Lh.y, Lh.z),
                (n += 2));
            }
            (n.getAttribute("position").needsUpdate = !0),
              super.updateMatrixWorld(e);
          }
        }.prototype.update = function () {
          console.error(
            "THREE.SkeletonHelper: update() no longer needs to be called."
          );
        }),
        (Eu.prototype.extractUrlBase = function (e) {
          return (
            console.warn(
              "THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead."
            ),
            th.extractUrlBase(e)
          );
        }),
        (Eu.Handlers = {
          add: function () {
            console.error(
              "THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead."
            );
          },
          get: function () {
            console.error(
              "THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead."
            );
          },
        }),
        (Ah.prototype.center = function (e) {
          return (
            console.warn(
              "THREE.Box2: .center() has been renamed to .getCenter()."
            ),
            this.getCenter(e)
          );
        }),
        (Ah.prototype.empty = function () {
          return (
            console.warn(
              "THREE.Box2: .empty() has been renamed to .isEmpty()."
            ),
            this.isEmpty()
          );
        }),
        (Ah.prototype.isIntersectionBox = function (e) {
          return (
            console.warn(
              "THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox()."
            ),
            this.intersectsBox(e)
          );
        }),
        (Ah.prototype.size = function (e) {
          return (
            console.warn("THREE.Box2: .size() has been renamed to .getSize()."),
            this.getSize(e)
          );
        }),
        (Gn.prototype.center = function (e) {
          return (
            console.warn(
              "THREE.Box3: .center() has been renamed to .getCenter()."
            ),
            this.getCenter(e)
          );
        }),
        (Gn.prototype.empty = function () {
          return (
            console.warn(
              "THREE.Box3: .empty() has been renamed to .isEmpty()."
            ),
            this.isEmpty()
          );
        }),
        (Gn.prototype.isIntersectionBox = function (e) {
          return (
            console.warn(
              "THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox()."
            ),
            this.intersectsBox(e)
          );
        }),
        (Gn.prototype.isIntersectionSphere = function (e) {
          return (
            console.warn(
              "THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere()."
            ),
            this.intersectsSphere(e)
          );
        }),
        (Gn.prototype.size = function (e) {
          return (
            console.warn("THREE.Box3: .size() has been renamed to .getSize()."),
            this.getSize(e)
          );
        }),
        (si.prototype.empty = function () {
          return (
            console.warn(
              "THREE.Sphere: .empty() has been renamed to .isEmpty()."
            ),
            this.isEmpty()
          );
        }),
        (oa.prototype.setFromMatrix = function (e) {
          return (
            console.warn(
              "THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix()."
            ),
            this.setFromProjectionMatrix(e)
          );
        }),
        (Pn.prototype.flattenToArrayOffset = function (e, t) {
          return (
            console.warn(
              "THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."
            ),
            this.toArray(e, t)
          );
        }),
        (Pn.prototype.multiplyVector3 = function (e) {
          return (
            console.warn(
              "THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead."
            ),
            e.applyMatrix3(this)
          );
        }),
        (Pn.prototype.multiplyVector3Array = function () {
          console.error(
            "THREE.Matrix3: .multiplyVector3Array() has been removed."
          );
        }),
        (Pn.prototype.applyToBufferAttribute = function (e) {
          return (
            console.warn(
              "THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead."
            ),
            e.applyMatrix3(this)
          );
        }),
        (Pn.prototype.applyToVector3Array = function () {
          console.error(
            "THREE.Matrix3: .applyToVector3Array() has been removed."
          );
        }),
        (Pn.prototype.getInverse = function (e) {
          return (
            console.warn(
              "THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."
            ),
            this.copy(e).invert()
          );
        }),
        (gi.prototype.extractPosition = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .extractPosition() has been renamed to .copyPosition()."
            ),
            this.copyPosition(e)
          );
        }),
        (gi.prototype.flattenToArrayOffset = function (e, t) {
          return (
            console.warn(
              "THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead."
            ),
            this.toArray(e, t)
          );
        }),
        (gi.prototype.getPosition = function () {
          return (
            console.warn(
              "THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead."
            ),
            new zn().setFromMatrixColumn(this, 3)
          );
        }),
        (gi.prototype.setRotationFromQuaternion = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion()."
            ),
            this.makeRotationFromQuaternion(e)
          );
        }),
        (gi.prototype.multiplyToArray = function () {
          console.warn("THREE.Matrix4: .multiplyToArray() has been removed.");
        }),
        (gi.prototype.multiplyVector3 = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead."
            ),
            e.applyMatrix4(this)
          );
        }),
        (gi.prototype.multiplyVector4 = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead."
            ),
            e.applyMatrix4(this)
          );
        }),
        (gi.prototype.multiplyVector3Array = function () {
          console.error(
            "THREE.Matrix4: .multiplyVector3Array() has been removed."
          );
        }),
        (gi.prototype.rotateAxis = function (e) {
          console.warn(
            "THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead."
          ),
            e.transformDirection(this);
        }),
        (gi.prototype.crossVector = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead."
            ),
            e.applyMatrix4(this)
          );
        }),
        (gi.prototype.translate = function () {
          console.error("THREE.Matrix4: .translate() has been removed.");
        }),
        (gi.prototype.rotateX = function () {
          console.error("THREE.Matrix4: .rotateX() has been removed.");
        }),
        (gi.prototype.rotateY = function () {
          console.error("THREE.Matrix4: .rotateY() has been removed.");
        }),
        (gi.prototype.rotateZ = function () {
          console.error("THREE.Matrix4: .rotateZ() has been removed.");
        }),
        (gi.prototype.rotateByAxis = function () {
          console.error("THREE.Matrix4: .rotateByAxis() has been removed.");
        }),
        (gi.prototype.applyToBufferAttribute = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead."
            ),
            e.applyMatrix4(this)
          );
        }),
        (gi.prototype.applyToVector3Array = function () {
          console.error(
            "THREE.Matrix4: .applyToVector3Array() has been removed."
          );
        }),
        (gi.prototype.makeFrustum = function (e, t, n, i, r, a) {
          return (
            console.warn(
              "THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead."
            ),
            this.makePerspective(e, t, i, n, r, a)
          );
        }),
        (gi.prototype.getInverse = function (e) {
          return (
            console.warn(
              "THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead."
            ),
            this.copy(e).invert()
          );
        }),
        (ia.prototype.isIntersectionLine = function (e) {
          return (
            console.warn(
              "THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine()."
            ),
            this.intersectsLine(e)
          );
        }),
        (Hn.prototype.multiplyVector3 = function (e) {
          return (
            console.warn(
              "THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead."
            ),
            e.applyQuaternion(this)
          );
        }),
        (Hn.prototype.inverse = function () {
          return (
            console.warn(
              "THREE.Quaternion: .inverse() has been renamed to invert()."
            ),
            this.invert()
          );
        }),
        (fi.prototype.isIntersectionBox = function (e) {
          return (
            console.warn(
              "THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox()."
            ),
            this.intersectsBox(e)
          );
        }),
        (fi.prototype.isIntersectionPlane = function (e) {
          return (
            console.warn(
              "THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane()."
            ),
            this.intersectsPlane(e)
          );
        }),
        (fi.prototype.isIntersectionSphere = function (e) {
          return (
            console.warn(
              "THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere()."
            ),
            this.intersectsSphere(e)
          );
        }),
        (Qi.prototype.area = function () {
          return (
            console.warn(
              "THREE.Triangle: .area() has been renamed to .getArea()."
            ),
            this.getArea()
          );
        }),
        (Qi.prototype.barycoordFromPoint = function (e, t) {
          return (
            console.warn(
              "THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."
            ),
            this.getBarycoord(e, t)
          );
        }),
        (Qi.prototype.midpoint = function (e) {
          return (
            console.warn(
              "THREE.Triangle: .midpoint() has been renamed to .getMidpoint()."
            ),
            this.getMidpoint(e)
          );
        }),
        (Qi.prototypenormal = function (e) {
          return (
            console.warn(
              "THREE.Triangle: .normal() has been renamed to .getNormal()."
            ),
            this.getNormal(e)
          );
        }),
        (Qi.prototype.plane = function (e) {
          return (
            console.warn(
              "THREE.Triangle: .plane() has been renamed to .getPlane()."
            ),
            this.getPlane(e)
          );
        }),
        (Qi.barycoordFromPoint = function (e, t, n, i, r) {
          return (
            console.warn(
              "THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord()."
            ),
            Qi.getBarycoord(e, t, n, i, r)
          );
        }),
        (Qi.normal = function (e, t, n, i) {
          return (
            console.warn(
              "THREE.Triangle: .normal() has been renamed to .getNormal()."
            ),
            Qi.getNormal(e, t, n, i)
          );
        }),
        (Ou.prototype.extractAllPoints = function (e) {
          return (
            console.warn(
              "THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead."
            ),
            this.extractPoints(e)
          );
        }),
        (Ou.prototype.extrude = function (e) {
          return (
            console.warn(
              "THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead."
            ),
            new Zc(this, e)
          );
        }),
        (Ou.prototype.makeGeometry = function (e) {
          return (
            console.warn(
              "THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead."
            ),
            new Qc(this, e)
          );
        }),
        (Ln.prototype.fromAttribute = function (e, t, n) {
          return (
            console.warn(
              "THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute()."
            ),
            this.fromBufferAttribute(e, t, n)
          );
        }),
        (Ln.prototype.distanceToManhattan = function (e) {
          return (
            console.warn(
              "THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."
            ),
            this.manhattanDistanceTo(e)
          );
        }),
        (Ln.prototype.lengthManhattan = function () {
          return (
            console.warn(
              "THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength()."
            ),
            this.manhattanLength()
          );
        }),
        (zn.prototype.setEulerFromRotationMatrix = function () {
          console.error(
            "THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead."
          );
        }),
        (zn.prototype.setEulerFromQuaternion = function () {
          console.error(
            "THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead."
          );
        }),
        (zn.prototype.getPositionFromMatrix = function (e) {
          return (
            console.warn(
              "THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition()."
            ),
            this.setFromMatrixPosition(e)
          );
        }),
        (zn.prototype.getScaleFromMatrix = function (e) {
          return (
            console.warn(
              "THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale()."
            ),
            this.setFromMatrixScale(e)
          );
        }),
        (zn.prototype.getColumnFromMatrix = function (e, t) {
          return (
            console.warn(
              "THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn()."
            ),
            this.setFromMatrixColumn(t, e)
          );
        }),
        (zn.prototype.applyProjection = function (e) {
          return (
            console.warn(
              "THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead."
            ),
            this.applyMatrix4(e)
          );
        }),
        (zn.prototype.fromAttribute = function (e, t, n) {
          return (
            console.warn(
              "THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute()."
            ),
            this.fromBufferAttribute(e, t, n)
          );
        }),
        (zn.prototype.distanceToManhattan = function (e) {
          return (
            console.warn(
              "THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo()."
            ),
            this.manhattanDistanceTo(e)
          );
        }),
        (zn.prototype.lengthManhattan = function () {
          return (
            console.warn(
              "THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength()."
            ),
            this.manhattanLength()
          );
        }),
        (On.prototype.fromAttribute = function (e, t, n) {
          return (
            console.warn(
              "THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute()."
            ),
            this.fromBufferAttribute(e, t, n)
          );
        }),
        (On.prototype.lengthManhattan = function () {
          return (
            console.warn(
              "THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength()."
            ),
            this.manhattanLength()
          );
        }),
        (Bi.prototype.getChildByName = function (e) {
          return (
            console.warn(
              "THREE.Object3D: .getChildByName() has been renamed to .getObjectByName()."
            ),
            this.getObjectByName(e)
          );
        }),
        (Bi.prototype.renderDepth = function () {
          console.warn(
            "THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead."
          );
        }),
        (Bi.prototype.translate = function (e, t) {
          return (
            console.warn(
              "THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead."
            ),
            this.translateOnAxis(t, e)
          );
        }),
        (Bi.prototype.getWorldRotation = function () {
          console.error(
            "THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead."
          );
        }),
        (Bi.prototype.applyMatrix = function (e) {
          return (
            console.warn(
              "THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4()."
            ),
            this.applyMatrix4(e)
          );
        }),
        Object.defineProperties(Bi.prototype, {
          eulerOrder: {
            get: function () {
              return (
                console.warn(
                  "THREE.Object3D: .eulerOrder is now .rotation.order."
                ),
                this.rotation.order
              );
            },
            set: function (e) {
              console.warn(
                "THREE.Object3D: .eulerOrder is now .rotation.order."
              ),
                (this.rotation.order = e);
            },
          },
          useQuaternion: {
            get: function () {
              console.warn(
                "THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default."
              );
            },
            set: function () {
              console.warn(
                "THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default."
              );
            },
          },
        }),
        (Br.prototype.setDrawMode = function () {
          console.error(
            "THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary."
          );
        }),
        Object.defineProperties(Br.prototype, {
          drawMode: {
            get: function () {
              return (
                console.error(
                  "THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode."
                ),
                0
              );
            },
            set: function () {
              console.error(
                "THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary."
              );
            },
          },
        }),
        (El.prototype.initBones = function () {
          console.error("THREE.SkinnedMesh: initBones() has been removed.");
        }),
        (Kr.prototype.setLens = function (e, t) {
          console.warn(
            "THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup."
          ),
            void 0 !== t && (this.filmGauge = t),
            this.setFocalLength(e);
        }),
        Object.defineProperties(Fu.prototype, {
          onlyShadow: {
            set: function () {
              console.warn("THREE.Light: .onlyShadow has been removed.");
            },
          },
          shadowCameraFov: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraFov is now .shadow.camera.fov."
              ),
                (this.shadow.camera.fov = e);
            },
          },
          shadowCameraLeft: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraLeft is now .shadow.camera.left."
              ),
                (this.shadow.camera.left = e);
            },
          },
          shadowCameraRight: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraRight is now .shadow.camera.right."
              ),
                (this.shadow.camera.right = e);
            },
          },
          shadowCameraTop: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraTop is now .shadow.camera.top."
              ),
                (this.shadow.camera.top = e);
            },
          },
          shadowCameraBottom: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom."
              ),
                (this.shadow.camera.bottom = e);
            },
          },
          shadowCameraNear: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraNear is now .shadow.camera.near."
              ),
                (this.shadow.camera.near = e);
            },
          },
          shadowCameraFar: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowCameraFar is now .shadow.camera.far."
              ),
                (this.shadow.camera.far = e);
            },
          },
          shadowCameraVisible: {
            set: function () {
              console.warn(
                "THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead."
              );
            },
          },
          shadowBias: {
            set: function (e) {
              console.warn("THREE.Light: .shadowBias is now .shadow.bias."),
                (this.shadow.bias = e);
            },
          },
          shadowDarkness: {
            set: function () {
              console.warn("THREE.Light: .shadowDarkness has been removed.");
            },
          },
          shadowMapWidth: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowMapWidth is now .shadow.mapSize.width."
              ),
                (this.shadow.mapSize.width = e);
            },
          },
          shadowMapHeight: {
            set: function (e) {
              console.warn(
                "THREE.Light: .shadowMapHeight is now .shadow.mapSize.height."
              ),
                (this.shadow.mapSize.height = e);
            },
          },
        }),
        Object.defineProperties(hr.prototype, {
          length: {
            get: function () {
              return (
                console.warn(
                  "THREE.BufferAttribute: .length has been deprecated. Use .count instead."
                ),
                this.array.length
              );
            },
          },
          dynamic: {
            get: function () {
              return (
                console.warn(
                  "THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."
                ),
                this.usage === pn
              );
            },
            set: function () {
              console.warn(
                "THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead."
              ),
                this.setUsage(pn);
            },
          },
        }),
        (hr.prototype.setDynamic = function (e) {
          return (
            console.warn(
              "THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead."
            ),
            this.setUsage(!0 === e ? pn : dn),
            this
          );
        }),
        (hr.prototype.copyIndicesArray = function () {
          console.error(
            "THREE.BufferAttribute: .copyIndicesArray() has been removed."
          );
        }),
        (hr.prototype.setArray = function () {
          console.error(
            "THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers"
          );
        }),
        (Mr.prototype.addIndex = function (e) {
          console.warn(
            "THREE.BufferGeometry: .addIndex() has been renamed to .setIndex()."
          ),
            this.setIndex(e);
        }),
        (Mr.prototype.addAttribute = function (e, t) {
          return (
            console.warn(
              "THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute()."
            ),
            (t && t.isBufferAttribute) || (t && t.isInterleavedBufferAttribute)
              ? "index" === e
                ? (console.warn(
                    "THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute."
                  ),
                  this.setIndex(t),
                  this)
                : this.setAttribute(e, t)
              : (console.warn(
                  "THREE.BufferGeometry: .addAttribute() now expects ( name, attribute )."
                ),
                this.setAttribute(e, new hr(arguments[1], arguments[2])))
          );
        }),
        (Mr.prototype.addDrawCall = function (e, t, n) {
          void 0 !== n &&
            console.warn(
              "THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset."
            ),
            console.warn(
              "THREE.BufferGeometry: .addDrawCall() is now .addGroup()."
            ),
            this.addGroup(e, t);
        }),
        (Mr.prototype.clearDrawCalls = function () {
          console.warn(
            "THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups()."
          ),
            this.clearGroups();
        }),
        (Mr.prototype.computeOffsets = function () {
          console.warn(
            "THREE.BufferGeometry: .computeOffsets() has been removed."
          );
        }),
        (Mr.prototype.removeAttribute = function (e) {
          return (
            console.warn(
              "THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute()."
            ),
            this.deleteAttribute(e)
          );
        }),
        (Mr.prototype.applyMatrix = function (e) {
          return (
            console.warn(
              "THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4()."
            ),
            this.applyMatrix4(e)
          );
        }),
        Object.defineProperties(Mr.prototype, {
          drawcalls: {
            get: function () {
              return (
                console.error(
                  "THREE.BufferGeometry: .drawcalls has been renamed to .groups."
                ),
                this.groups
              );
            },
          },
          offsets: {
            get: function () {
              return (
                console.warn(
                  "THREE.BufferGeometry: .offsets has been renamed to .groups."
                ),
                this.groups
              );
            },
          },
        }),
        (nl.prototype.setDynamic = function (e) {
          return (
            console.warn(
              "THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead."
            ),
            this.setUsage(!0 === e ? pn : dn),
            this
          );
        }),
        (nl.prototype.setArray = function () {
          console.error(
            "THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers"
          );
        }),
        (Zc.prototype.getArrays = function () {
          console.error(
            "THREE.ExtrudeGeometry: .getArrays() has been removed."
          );
        }),
        (Zc.prototype.addShapeList = function () {
          console.error(
            "THREE.ExtrudeGeometry: .addShapeList() has been removed."
          );
        }),
        (Zc.prototype.addShape = function () {
          console.error("THREE.ExtrudeGeometry: .addShape() has been removed.");
        }),
        (tl.prototype.dispose = function () {
          console.error("THREE.Scene: .dispose() has been removed.");
        }),
        (Sh.prototype.onUpdate = function () {
          return (
            console.warn(
              "THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead."
            ),
            this
          );
        }),
        Object.defineProperties(er.prototype, {
          wrapAround: {
            get: function () {
              console.warn("THREE.Material: .wrapAround has been removed.");
            },
            set: function () {
              console.warn("THREE.Material: .wrapAround has been removed.");
            },
          },
          overdraw: {
            get: function () {
              console.warn("THREE.Material: .overdraw has been removed.");
            },
            set: function () {
              console.warn("THREE.Material: .overdraw has been removed.");
            },
          },
          wrapRGB: {
            get: function () {
              return (
                console.warn("THREE.Material: .wrapRGB has been removed."),
                new sr()
              );
            },
          },
          shading: {
            get: function () {
              console.error(
                "THREE." +
                  this.type +
                  ": .shading has been removed. Use the boolean .flatShading instead."
              );
            },
            set: function (e) {
              console.warn(
                "THREE." +
                  this.type +
                  ": .shading has been removed. Use the boolean .flatShading instead."
              ),
                (this.flatShading = 1 === e);
            },
          },
          stencilMask: {
            get: function () {
              return (
                console.warn(
                  "THREE." +
                    this.type +
                    ": .stencilMask has been removed. Use .stencilFuncMask instead."
                ),
                this.stencilFuncMask
              );
            },
            set: function (e) {
              console.warn(
                "THREE." +
                  this.type +
                  ": .stencilMask has been removed. Use .stencilFuncMask instead."
              ),
                (this.stencilFuncMask = e);
            },
          },
          vertexTangents: {
            get: function () {
              console.warn(
                "THREE." + this.type + ": .vertexTangents has been removed."
              );
            },
            set: function () {
              console.warn(
                "THREE." + this.type + ": .vertexTangents has been removed."
              );
            },
          },
        }),
        Object.defineProperties(qr.prototype, {
          derivatives: {
            get: function () {
              return (
                console.warn(
                  "THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives."
                ),
                this.extensions.derivatives
              );
            },
            set: function (e) {
              console.warn(
                "THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives."
              ),
                (this.extensions.derivatives = e);
            },
          },
        }),
        (Qs.prototype.clearTarget = function (e, t, n, i) {
          console.warn(
            "THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead."
          ),
            this.setRenderTarget(e),
            this.clear(t, n, i);
        }),
        (Qs.prototype.animate = function (e) {
          console.warn(
            "THREE.WebGLRenderer: .animate() is now .setAnimationLoop()."
          ),
            this.setAnimationLoop(e);
        }),
        (Qs.prototype.getCurrentRenderTarget = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget()."
            ),
            this.getRenderTarget()
          );
        }),
        (Qs.prototype.getMaxAnisotropy = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy()."
            ),
            this.capabilities.getMaxAnisotropy()
          );
        }),
        (Qs.prototype.getPrecision = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision."
            ),
            this.capabilities.precision
          );
        }),
        (Qs.prototype.resetGLState = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .resetGLState() is now .state.reset()."
            ),
            this.state.reset()
          );
        }),
        (Qs.prototype.supportsFloatTextures = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( 'OES_texture_float' )."
            ),
            this.extensions.get("OES_texture_float")
          );
        }),
        (Qs.prototype.supportsHalfFloatTextures = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( 'OES_texture_half_float' )."
            ),
            this.extensions.get("OES_texture_half_float")
          );
        }),
        (Qs.prototype.supportsStandardDerivatives = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( 'OES_standard_derivatives' )."
            ),
            this.extensions.get("OES_standard_derivatives")
          );
        }),
        (Qs.prototype.supportsCompressedTextureS3TC = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( 'WEBGL_compressed_texture_s3tc' )."
            ),
            this.extensions.get("WEBGL_compressed_texture_s3tc")
          );
        }),
        (Qs.prototype.supportsCompressedTexturePVRTC = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( 'WEBGL_compressed_texture_pvrtc' )."
            ),
            this.extensions.get("WEBGL_compressed_texture_pvrtc")
          );
        }),
        (Qs.prototype.supportsBlendMinMax = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( 'EXT_blend_minmax' )."
            ),
            this.extensions.get("EXT_blend_minmax")
          );
        }),
        (Qs.prototype.supportsVertexTextures = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures."
            ),
            this.capabilities.vertexTextures
          );
        }),
        (Qs.prototype.supportsInstancedArrays = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( 'ANGLE_instanced_arrays' )."
            ),
            this.extensions.get("ANGLE_instanced_arrays")
          );
        }),
        (Qs.prototype.enableScissorTest = function (e) {
          console.warn(
            "THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest()."
          ),
            this.setScissorTest(e);
        }),
        (Qs.prototype.initMaterial = function () {
          console.warn(
            "THREE.WebGLRenderer: .initMaterial() has been removed."
          );
        }),
        (Qs.prototype.addPrePlugin = function () {
          console.warn(
            "THREE.WebGLRenderer: .addPrePlugin() has been removed."
          );
        }),
        (Qs.prototype.addPostPlugin = function () {
          console.warn(
            "THREE.WebGLRenderer: .addPostPlugin() has been removed."
          );
        }),
        (Qs.prototype.updateShadowMap = function () {
          console.warn(
            "THREE.WebGLRenderer: .updateShadowMap() has been removed."
          );
        }),
        (Qs.prototype.setFaceCulling = function () {
          console.warn(
            "THREE.WebGLRenderer: .setFaceCulling() has been removed."
          );
        }),
        (Qs.prototype.allocTextureUnit = function () {
          console.warn(
            "THREE.WebGLRenderer: .allocTextureUnit() has been removed."
          );
        }),
        (Qs.prototype.setTexture = function () {
          console.warn("THREE.WebGLRenderer: .setTexture() has been removed.");
        }),
        (Qs.prototype.setTexture2D = function () {
          console.warn(
            "THREE.WebGLRenderer: .setTexture2D() has been removed."
          );
        }),
        (Qs.prototype.setTextureCube = function () {
          console.warn(
            "THREE.WebGLRenderer: .setTextureCube() has been removed."
          );
        }),
        (Qs.prototype.getActiveMipMapLevel = function () {
          return (
            console.warn(
              "THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel()."
            ),
            this.getActiveMipmapLevel()
          );
        }),
        Object.defineProperties(Qs.prototype, {
          shadowMapEnabled: {
            get: function () {
              return this.shadowMap.enabled;
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled."
              ),
                (this.shadowMap.enabled = e);
            },
          },
          shadowMapType: {
            get: function () {
              return this.shadowMap.type;
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type."
              ),
                (this.shadowMap.type = e);
            },
          },
          shadowMapCullFace: {
            get: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead."
              );
            },
            set: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead."
              );
            },
          },
          context: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderer: .context has been removed. Use .getContext() instead."
                ),
                this.getContext()
              );
            },
          },
          vr: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderer: .vr has been renamed to .xr"
                ),
                this.xr
              );
            },
          },
          gammaInput: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead."
                ),
                !1
              );
            },
            set: function () {
              console.warn(
                "THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead."
              );
            },
          },
          gammaOutput: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."
                ),
                !1
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead."
              ),
                (this.outputEncoding = !0 === e ? en : $t);
            },
          },
          toneMappingWhitePoint: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderer: .toneMappingWhitePoint has been removed."
                ),
                1
              );
            },
            set: function () {
              console.warn(
                "THREE.WebGLRenderer: .toneMappingWhitePoint has been removed."
              );
            },
          },
        }),
        Object.defineProperties(Gs.prototype, {
          cullFace: {
            get: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead."
              );
            },
            set: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead."
              );
            },
          },
          renderReverseSided: {
            get: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead."
              );
            },
            set: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead."
              );
            },
          },
          renderSingleSided: {
            get: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead."
              );
            },
            set: function () {
              console.warn(
                "THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead."
              );
            },
          },
        }),
        Object.defineProperties(Fn.prototype, {
          wrapS: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."
                ),
                this.texture.wrapS
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS."
              ),
                (this.texture.wrapS = e);
            },
          },
          wrapT: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."
                ),
                this.texture.wrapT
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT."
              ),
                (this.texture.wrapT = e);
            },
          },
          magFilter: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."
                ),
                this.texture.magFilter
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter."
              ),
                (this.texture.magFilter = e);
            },
          },
          minFilter: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."
                ),
                this.texture.minFilter
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter."
              ),
                (this.texture.minFilter = e);
            },
          },
          anisotropy: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."
                ),
                this.texture.anisotropy
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy."
              ),
                (this.texture.anisotropy = e);
            },
          },
          offset: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .offset is now .texture.offset."
                ),
                this.texture.offset
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .offset is now .texture.offset."
              ),
                (this.texture.offset = e);
            },
          },
          repeat: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .repeat is now .texture.repeat."
                ),
                this.texture.repeat
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .repeat is now .texture.repeat."
              ),
                (this.texture.repeat = e);
            },
          },
          format: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .format is now .texture.format."
                ),
                this.texture.format
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .format is now .texture.format."
              ),
                (this.texture.format = e);
            },
          },
          type: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .type is now .texture.type."
                ),
                this.texture.type
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .type is now .texture.type."
              ),
                (this.texture.type = e);
            },
          },
          generateMipmaps: {
            get: function () {
              return (
                console.warn(
                  "THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."
                ),
                this.texture.generateMipmaps
              );
            },
            set: function (e) {
              console.warn(
                "THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps."
              ),
                (this.texture.generateMipmaps = e);
            },
          },
        }),
        (uh.prototype.load = function (e) {
          console.warn(
            "THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead."
          );
          const t = this;
          return (
            new ch().load(e, function (e) {
              t.setBuffer(e);
            }),
            this
          );
        }),
        (Jr.prototype.updateCubeMap = function (e, t) {
          return (
            console.warn(
              "THREE.CubeCamera: .updateCubeMap() is now .update()."
            ),
            this.update(e, t)
          );
        }),
        (Jr.prototype.clear = function (e, t, n, i) {
          return (
            console.warn(
              "THREE.CubeCamera: .clear() is now .renderTarget.clear()."
            ),
            this.renderTarget.clear(e, t, n, i)
          );
        }),
        (Cn.crossOrigin = void 0),
        (Cn.loadTexture = function (e, t, n, i) {
          console.warn(
            "THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead."
          );
          const r = new Iu();
          r.setCrossOrigin(this.crossOrigin);
          const a = r.load(e, n, void 0, i);
          return t && (a.mapping = t), a;
        }),
        (Cn.loadTextureCube = function (e, t, n, i) {
          console.warn(
            "THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead."
          );
          const r = new Ru();
          r.setCrossOrigin(this.crossOrigin);
          const a = r.load(e, n, void 0, i);
          return t && (a.mapping = t), a;
        }),
        (Cn.loadCompressedTexture = function () {
          console.error(
            "THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead."
          );
        }),
        (Cn.loadCompressedTextureCube = function () {
          console.error(
            "THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead."
          );
        });
      "undefined" != typeof __THREE_DEVTOOLS__ &&
        __THREE_DEVTOOLS__.dispatchEvent(
          new CustomEvent("register", { detail: { revision: "132" } })
        ),
        "undefined" != typeof window &&
          (window.__THREE__
            ? console.warn(
                "WARNING: Multiple instances of Three.js being imported."
              )
            : (window.__THREE__ = "132"));
      const Oh = { type: "change" },
        Fh = { type: "start" },
        kh = { type: "end" };
      class Hh extends fn {
        constructor(e, t) {
          super(),
            void 0 === t &&
              console.warn(
                'THREE.OrbitControls: The second parameter "domElement" is now mandatory.'
              ),
            t === document &&
              console.error(
                'THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.'
              ),
            (this.object = e),
            (this.domElement = t),
            (this.domElement.style.touchAction = "none"),
            (this.enabled = !0),
            (this.target = new zn()),
            (this.minDistance = 0),
            (this.maxDistance = 1 / 0),
            (this.minZoom = 0),
            (this.maxZoom = 1 / 0),
            (this.minPolarAngle = 0),
            (this.maxPolarAngle = Math.PI),
            (this.minAzimuthAngle = -1 / 0),
            (this.maxAzimuthAngle = 1 / 0),
            (this.enableDamping = !1),
            (this.dampingFactor = 0.05),
            (this.enableZoom = !0),
            (this.zoomSpeed = 1),
            (this.enableRotate = !0),
            (this.rotateSpeed = 1),
            (this.enablePan = !0),
            (this.panSpeed = 1),
            (this.screenSpacePanning = !0),
            (this.keyPanSpeed = 7),
            (this.autoRotate = !1),
            (this.autoRotateSpeed = 2),
            (this.keys = {
              LEFT: "ArrowLeft",
              UP: "ArrowUp",
              RIGHT: "ArrowRight",
              BOTTOM: "ArrowDown",
            }),
            (this.mouseButtons = { LEFT: v, MIDDLE: y, RIGHT: x }),
            (this.touches = { ONE: b, TWO: w }),
            (this.target0 = this.target.clone()),
            (this.position0 = this.object.position.clone()),
            (this.zoom0 = this.object.zoom),
            (this._domElementKeyEvents = null),
            (this.getPolarAngle = function () {
              return o.phi;
            }),
            (this.getAzimuthalAngle = function () {
              return o.theta;
            }),
            (this.getDistance = function () {
              return this.object.position.distanceTo(this.target);
            }),
            (this.listenToKeyEvents = function (e) {
              e.addEventListener("keydown", Z), (this._domElementKeyEvents = e);
            }),
            (this.saveState = function () {
              n.target0.copy(n.target),
                n.position0.copy(n.object.position),
                (n.zoom0 = n.object.zoom);
            }),
            (this.reset = function () {
              n.target.copy(n.target0),
                n.object.position.copy(n.position0),
                (n.object.zoom = n.zoom0),
                n.object.updateProjectionMatrix(),
                n.dispatchEvent(Oh),
                n.update(),
                (r = i.NONE);
            }),
            (this.update = (function () {
              const t = new zn(),
                h = new Hn().setFromUnitVectors(e.up, new zn(0, 1, 0)),
                d = h.clone().invert(),
                p = new zn(),
                m = new Hn(),
                f = 2 * Math.PI;
              return function () {
                const e = n.object.position;
                t.copy(e).sub(n.target),
                  t.applyQuaternion(h),
                  o.setFromVector3(t),
                  n.autoRotate &&
                    r === i.NONE &&
                    R(((2 * Math.PI) / 60 / 60) * n.autoRotateSpeed),
                  n.enableDamping
                    ? ((o.theta += s.theta * n.dampingFactor),
                      (o.phi += s.phi * n.dampingFactor))
                    : ((o.theta += s.theta), (o.phi += s.phi));
                let g = n.minAzimuthAngle,
                  v = n.maxAzimuthAngle;
                return (
                  isFinite(g) &&
                    isFinite(v) &&
                    (g < -Math.PI ? (g += f) : g > Math.PI && (g -= f),
                    v < -Math.PI ? (v += f) : v > Math.PI && (v -= f),
                    (o.theta =
                      g <= v
                        ? Math.max(g, Math.min(v, o.theta))
                        : o.theta > (g + v) / 2
                        ? Math.max(g, o.theta)
                        : Math.min(v, o.theta))),
                  (o.phi = Math.max(
                    n.minPolarAngle,
                    Math.min(n.maxPolarAngle, o.phi)
                  )),
                  o.makeSafe(),
                  (o.radius *= l),
                  (o.radius = Math.max(
                    n.minDistance,
                    Math.min(n.maxDistance, o.radius)
                  )),
                  !0 === n.enableDamping
                    ? n.target.addScaledVector(c, n.dampingFactor)
                    : n.target.add(c),
                  t.setFromSpherical(o),
                  t.applyQuaternion(d),
                  e.copy(n.target).add(t),
                  n.object.lookAt(n.target),
                  !0 === n.enableDamping
                    ? ((s.theta *= 1 - n.dampingFactor),
                      (s.phi *= 1 - n.dampingFactor),
                      c.multiplyScalar(1 - n.dampingFactor))
                    : (s.set(0, 0, 0), c.set(0, 0, 0)),
                  (l = 1),
                  !!(
                    u ||
                    p.distanceToSquared(n.object.position) > a ||
                    8 * (1 - m.dot(n.object.quaternion)) > a
                  ) &&
                    (n.dispatchEvent(Oh),
                    p.copy(n.object.position),
                    m.copy(n.object.quaternion),
                    (u = !1),
                    !0)
                );
              };
            })()),
            (this.dispose = function () {
              n.domElement.removeEventListener("contextmenu", J),
                n.domElement.removeEventListener("pointerdown", j),
                n.domElement.removeEventListener("pointercancel", Y),
                n.domElement.removeEventListener("wheel", K),
                n.domElement.removeEventListener("pointermove", X),
                n.domElement.removeEventListener("pointerup", q),
                null !== n._domElementKeyEvents &&
                  n._domElementKeyEvents.removeEventListener("keydown", Z);
            });
          const n = this,
            i = {
              NONE: -1,
              ROTATE: 0,
              DOLLY: 1,
              PAN: 2,
              TOUCH_ROTATE: 3,
              TOUCH_PAN: 4,
              TOUCH_DOLLY_PAN: 5,
              TOUCH_DOLLY_ROTATE: 6,
            };
          let r = i.NONE;
          const a = 1e-6,
            o = new Th(),
            s = new Th();
          let l = 1;
          const c = new zn();
          let u = !1;
          const h = new Ln(),
            d = new Ln(),
            p = new Ln(),
            m = new Ln(),
            f = new Ln(),
            g = new Ln(),
            S = new Ln(),
            T = new Ln(),
            E = new Ln(),
            A = [],
            L = {};
          function P() {
            return Math.pow(0.95, n.zoomSpeed);
          }
          function R(e) {
            s.theta -= e;
          }
          function C(e) {
            s.phi -= e;
          }
          const I = (function () {
              const e = new zn();
              return function (t, n) {
                e.setFromMatrixColumn(n, 0), e.multiplyScalar(-t), c.add(e);
              };
            })(),
            N = (function () {
              const e = new zn();
              return function (t, i) {
                !0 === n.screenSpacePanning
                  ? e.setFromMatrixColumn(i, 1)
                  : (e.setFromMatrixColumn(i, 0),
                    e.crossVectors(n.object.up, e)),
                  e.multiplyScalar(t),
                  c.add(e);
              };
            })(),
            D = (function () {
              const e = new zn();
              return function (t, i) {
                const r = n.domElement;
                if (n.object.isPerspectiveCamera) {
                  const a = n.object.position;
                  e.copy(a).sub(n.target);
                  let o = e.length();
                  (o *= Math.tan(((n.object.fov / 2) * Math.PI) / 180)),
                    I((2 * t * o) / r.clientHeight, n.object.matrix),
                    N((2 * i * o) / r.clientHeight, n.object.matrix);
                } else
                  n.object.isOrthographicCamera
                    ? (I(
                        (t * (n.object.right - n.object.left)) /
                          n.object.zoom /
                          r.clientWidth,
                        n.object.matrix
                      ),
                      N(
                        (i * (n.object.top - n.object.bottom)) /
                          n.object.zoom /
                          r.clientHeight,
                        n.object.matrix
                      ))
                    : (console.warn(
                        "WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."
                      ),
                      (n.enablePan = !1));
              };
            })();
          function O(e) {
            n.object.isPerspectiveCamera
              ? (l /= e)
              : n.object.isOrthographicCamera
              ? ((n.object.zoom = Math.max(
                  n.minZoom,
                  Math.min(n.maxZoom, n.object.zoom * e)
                )),
                n.object.updateProjectionMatrix(),
                (u = !0))
              : (console.warn(
                  "WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."
                ),
                (n.enableZoom = !1));
          }
          function F(e) {
            n.object.isPerspectiveCamera
              ? (l *= e)
              : n.object.isOrthographicCamera
              ? ((n.object.zoom = Math.max(
                  n.minZoom,
                  Math.min(n.maxZoom, n.object.zoom / e)
                )),
                n.object.updateProjectionMatrix(),
                (u = !0))
              : (console.warn(
                  "WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."
                ),
                (n.enableZoom = !1));
          }
          function k(e) {
            h.set(e.clientX, e.clientY);
          }
          function H(e) {
            m.set(e.clientX, e.clientY);
          }
          function z() {
            if (1 === A.length) h.set(A[0].pageX, A[0].pageY);
            else {
              const e = 0.5 * (A[0].pageX + A[1].pageX),
                t = 0.5 * (A[0].pageY + A[1].pageY);
              h.set(e, t);
            }
          }
          function U() {
            if (1 === A.length) m.set(A[0].pageX, A[0].pageY);
            else {
              const e = 0.5 * (A[0].pageX + A[1].pageX),
                t = 0.5 * (A[0].pageY + A[1].pageY);
              m.set(e, t);
            }
          }
          function B() {
            const e = A[0].pageX - A[1].pageX,
              t = A[0].pageY - A[1].pageY,
              n = Math.sqrt(e * e + t * t);
            S.set(0, n);
          }
          function G(e) {
            if (1 == A.length) d.set(e.pageX, e.pageY);
            else {
              const t = ee(e),
                n = 0.5 * (e.pageX + t.x),
                i = 0.5 * (e.pageY + t.y);
              d.set(n, i);
            }
            p.subVectors(d, h).multiplyScalar(n.rotateSpeed);
            const t = n.domElement;
            R((2 * Math.PI * p.x) / t.clientHeight),
              C((2 * Math.PI * p.y) / t.clientHeight),
              h.copy(d);
          }
          function V(e) {
            if (1 === A.length) f.set(e.pageX, e.pageY);
            else {
              const t = ee(e),
                n = 0.5 * (e.pageX + t.x),
                i = 0.5 * (e.pageY + t.y);
              f.set(n, i);
            }
            g.subVectors(f, m).multiplyScalar(n.panSpeed),
              D(g.x, g.y),
              m.copy(f);
          }
          function W(e) {
            const t = ee(e),
              i = e.pageX - t.x,
              r = e.pageY - t.y,
              a = Math.sqrt(i * i + r * r);
            T.set(0, a),
              E.set(0, Math.pow(T.y / S.y, n.zoomSpeed)),
              O(E.y),
              S.copy(T);
          }
          function j(e) {
            !1 !== n.enabled &&
              (0 === A.length &&
                (n.domElement.setPointerCapture(e.pointerId),
                n.domElement.addEventListener("pointermove", X),
                n.domElement.addEventListener("pointerup", q)),
              (function (e) {
                A.push(e);
              })(e),
              "touch" === e.pointerType
                ? (function (e) {
                    switch (($(e), A.length)) {
                      case 1:
                        switch (n.touches.ONE) {
                          case b:
                            if (!1 === n.enableRotate) return;
                            z(), (r = i.TOUCH_ROTATE);
                            break;
                          case _:
                            if (!1 === n.enablePan) return;
                            U(), (r = i.TOUCH_PAN);
                            break;
                          default:
                            r = i.NONE;
                        }
                        break;
                      case 2:
                        switch (n.touches.TWO) {
                          case w:
                            if (!1 === n.enableZoom && !1 === n.enablePan)
                              return;
                            n.enableZoom && B(),
                              n.enablePan && U(),
                              (r = i.TOUCH_DOLLY_PAN);
                            break;
                          case M:
                            if (!1 === n.enableZoom && !1 === n.enableRotate)
                              return;
                            n.enableZoom && B(),
                              n.enableRotate && z(),
                              (r = i.TOUCH_DOLLY_ROTATE);
                            break;
                          default:
                            r = i.NONE;
                        }
                        break;
                      default:
                        r = i.NONE;
                    }
                    r !== i.NONE && n.dispatchEvent(Fh);
                  })(e)
                : (function (e) {
                    let t;
                    switch (e.button) {
                      case 0:
                        t = n.mouseButtons.LEFT;
                        break;
                      case 1:
                        t = n.mouseButtons.MIDDLE;
                        break;
                      case 2:
                        t = n.mouseButtons.RIGHT;
                        break;
                      default:
                        t = -1;
                    }
                    switch (t) {
                      case y:
                        if (!1 === n.enableZoom) return;
                        !(function (e) {
                          S.set(e.clientX, e.clientY);
                        })(e),
                          (r = i.DOLLY);
                        break;
                      case v:
                        if (e.ctrlKey || e.metaKey || e.shiftKey) {
                          if (!1 === n.enablePan) return;
                          H(e), (r = i.PAN);
                        } else {
                          if (!1 === n.enableRotate) return;
                          k(e), (r = i.ROTATE);
                        }
                        break;
                      case x:
                        if (e.ctrlKey || e.metaKey || e.shiftKey) {
                          if (!1 === n.enableRotate) return;
                          k(e), (r = i.ROTATE);
                        } else {
                          if (!1 === n.enablePan) return;
                          H(e), (r = i.PAN);
                        }
                        break;
                      default:
                        r = i.NONE;
                    }
                    r !== i.NONE && n.dispatchEvent(Fh);
                  })(e));
          }
          function X(e) {
            !1 !== n.enabled &&
              ("touch" === e.pointerType
                ? (function (e) {
                    switch (($(e), r)) {
                      case i.TOUCH_ROTATE:
                        if (!1 === n.enableRotate) return;
                        G(e), n.update();
                        break;
                      case i.TOUCH_PAN:
                        if (!1 === n.enablePan) return;
                        V(e), n.update();
                        break;
                      case i.TOUCH_DOLLY_PAN:
                        if (!1 === n.enableZoom && !1 === n.enablePan) return;
                        !(function (e) {
                          n.enableZoom && W(e), n.enablePan && V(e);
                        })(e),
                          n.update();
                        break;
                      case i.TOUCH_DOLLY_ROTATE:
                        if (!1 === n.enableZoom && !1 === n.enableRotate)
                          return;
                        !(function (e) {
                          n.enableZoom && W(e), n.enableRotate && G(e);
                        })(e),
                          n.update();
                        break;
                      default:
                        r = i.NONE;
                    }
                  })(e)
                : (function (e) {
                    if (!1 === n.enabled) return;
                    switch (r) {
                      case i.ROTATE:
                        if (!1 === n.enableRotate) return;
                        !(function (e) {
                          d.set(e.clientX, e.clientY),
                            p.subVectors(d, h).multiplyScalar(n.rotateSpeed);
                          const t = n.domElement;
                          R((2 * Math.PI * p.x) / t.clientHeight),
                            C((2 * Math.PI * p.y) / t.clientHeight),
                            h.copy(d),
                            n.update();
                        })(e);
                        break;
                      case i.DOLLY:
                        if (!1 === n.enableZoom) return;
                        !(function (e) {
                          T.set(e.clientX, e.clientY),
                            E.subVectors(T, S),
                            E.y > 0 ? O(P()) : E.y < 0 && F(P()),
                            S.copy(T),
                            n.update();
                        })(e);
                        break;
                      case i.PAN:
                        if (!1 === n.enablePan) return;
                        !(function (e) {
                          f.set(e.clientX, e.clientY),
                            g.subVectors(f, m).multiplyScalar(n.panSpeed),
                            D(g.x, g.y),
                            m.copy(f),
                            n.update();
                        })(e);
                    }
                  })(e));
          }
          function q(e) {
            !1 !== n.enabled &&
              (e.pointerType,
              n.dispatchEvent(kh),
              (r = i.NONE),
              Q(e),
              0 === A.length &&
                (n.domElement.releasePointerCapture(e.pointerId),
                n.domElement.removeEventListener("pointermove", X),
                n.domElement.removeEventListener("pointerup", q)));
          }
          function Y(e) {
            Q(e);
          }
          function K(e) {
            !1 === n.enabled ||
              !1 === n.enableZoom ||
              (r !== i.NONE && r !== i.ROTATE) ||
              (e.preventDefault(),
              n.dispatchEvent(Fh),
              (function (e) {
                e.deltaY < 0 ? F(P()) : e.deltaY > 0 && O(P()), n.update();
              })(e),
              n.dispatchEvent(kh));
          }
          function Z(e) {
            !1 !== n.enabled &&
              !1 !== n.enablePan &&
              (function (e) {
                let t = !1;
                switch (e.code) {
                  case n.keys.UP:
                    D(0, n.keyPanSpeed), (t = !0);
                    break;
                  case n.keys.BOTTOM:
                    D(0, -n.keyPanSpeed), (t = !0);
                    break;
                  case n.keys.LEFT:
                    D(n.keyPanSpeed, 0), (t = !0);
                    break;
                  case n.keys.RIGHT:
                    D(-n.keyPanSpeed, 0), (t = !0);
                }
                t && (e.preventDefault(), n.update());
              })(e);
          }
          function J(e) {
            !1 !== n.enabled && e.preventDefault();
          }
          function Q(e) {
            delete L[e.pointerId];
            for (let t = 0; t < A.length; t++)
              if (A[t].pointerId == e.pointerId) return void A.splice(t, 1);
          }
          function $(e) {
            let t = L[e.pointerId];
            void 0 === t && ((t = new Ln()), (L[e.pointerId] = t)),
              t.set(e.pageX, e.pageY);
          }
          function ee(e) {
            const t = e.pointerId === A[0].pointerId ? A[1] : A[0];
            return L[t.pointerId];
          }
          n.domElement.addEventListener("contextmenu", J),
            n.domElement.addEventListener("pointerdown", j),
            n.domElement.addEventListener("pointercancel", Y),
            n.domElement.addEventListener("wheel", K, { passive: !1 }),
            this.update();
        }
      }
      class zh extends Eu {
        constructor(e) {
          super(e),
            (this.dracoLoader = null),
            (this.ktx2Loader = null),
            (this.meshoptDecoder = null),
            (this.pluginCallbacks = []),
            this.register(function (e) {
              return new Wh(e);
            }),
            this.register(function (e) {
              return new Kh(e);
            }),
            this.register(function (e) {
              return new Zh(e);
            }),
            this.register(function (e) {
              return new jh(e);
            }),
            this.register(function (e) {
              return new Xh(e);
            }),
            this.register(function (e) {
              return new qh(e);
            }),
            this.register(function (e) {
              return new Yh(e);
            }),
            this.register(function (e) {
              return new Gh(e);
            }),
            this.register(function (e) {
              return new Jh(e);
            });
        }
        load(e, t, n, i) {
          const r = this;
          let a;
          (a =
            "" !== this.resourcePath
              ? this.resourcePath
              : "" !== this.path
              ? this.path
              : th.extractUrlBase(e)),
            this.manager.itemStart(e);
          const o = function (t) {
              i ? i(t) : console.error(t),
                r.manager.itemError(e),
                r.manager.itemEnd(e);
            },
            s = new Lu(this.manager);
          s.setPath(this.path),
            s.setResponseType("arraybuffer"),
            s.setRequestHeader(this.requestHeader),
            s.setWithCredentials(this.withCredentials),
            s.load(
              e,
              function (n) {
                try {
                  r.parse(
                    n,
                    a,
                    function (n) {
                      t(n), r.manager.itemEnd(e);
                    },
                    o
                  );
                } catch (e) {
                  o(e);
                }
              },
              n,
              o
            );
        }
        setDRACOLoader(e) {
          return (this.dracoLoader = e), this;
        }
        setDDSLoader() {
          throw new Error(
            'THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".'
          );
        }
        setKTX2Loader(e) {
          return (this.ktx2Loader = e), this;
        }
        setMeshoptDecoder(e) {
          return (this.meshoptDecoder = e), this;
        }
        register(e) {
          return (
            -1 === this.pluginCallbacks.indexOf(e) &&
              this.pluginCallbacks.push(e),
            this
          );
        }
        unregister(e) {
          return (
            -1 !== this.pluginCallbacks.indexOf(e) &&
              this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1),
            this
          );
        }
        parse(e, t, n, i) {
          let r;
          const a = {},
            o = {};
          if ("string" == typeof e) r = e;
          else {
            if (th.decodeText(new Uint8Array(e, 0, 4)) === Qh) {
              try {
                a[Bh.KHR_BINARY_GLTF] = new td(e);
              } catch (e) {
                return void (i && i(e));
              }
              r = a[Bh.KHR_BINARY_GLTF].content;
            } else r = th.decodeText(new Uint8Array(e));
          }
          const s = JSON.parse(r);
          if (void 0 === s.asset || s.asset.version[0] < 2)
            return void (
              i &&
              i(
                new Error(
                  "THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."
                )
              )
            );
          const l = new Dd(s, {
            path: t || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder,
          });
          l.fileLoader.setRequestHeader(this.requestHeader);
          for (let e = 0; e < this.pluginCallbacks.length; e++) {
            const t = this.pluginCallbacks[e](l);
            (o[t.name] = t), (a[t.name] = !0);
          }
          if (s.extensionsUsed)
            for (let e = 0; e < s.extensionsUsed.length; ++e) {
              const t = s.extensionsUsed[e],
                n = s.extensionsRequired || [];
              switch (t) {
                case Bh.KHR_MATERIALS_UNLIT:
                  a[t] = new Vh();
                  break;
                case Bh.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
                  a[t] = new ad();
                  break;
                case Bh.KHR_DRACO_MESH_COMPRESSION:
                  a[t] = new nd(s, this.dracoLoader);
                  break;
                case Bh.KHR_TEXTURE_TRANSFORM:
                  a[t] = new id();
                  break;
                case Bh.KHR_MESH_QUANTIZATION:
                  a[t] = new od();
                  break;
                default:
                  n.indexOf(t) >= 0 &&
                    void 0 === o[t] &&
                    console.warn(
                      'THREE.GLTFLoader: Unknown extension "' + t + '".'
                    );
              }
            }
          l.setExtensions(a), l.setPlugins(o), l.parse(n, i);
        }
      }
      function Uh() {
        let e = {};
        return {
          get: function (t) {
            return e[t];
          },
          add: function (t, n) {
            e[t] = n;
          },
          remove: function (t) {
            delete e[t];
          },
          removeAll: function () {
            e = {};
          },
        };
      }
      const Bh = {
        KHR_BINARY_GLTF: "KHR_binary_glTF",
        KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
        KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
        KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
        KHR_MATERIALS_IOR: "KHR_materials_ior",
        KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS:
          "KHR_materials_pbrSpecularGlossiness",
        KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
        KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
        KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
        KHR_MATERIALS_VOLUME: "KHR_materials_volume",
        KHR_TEXTURE_BASISU: "KHR_texture_basisu",
        KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
        KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
        EXT_TEXTURE_WEBP: "EXT_texture_webp",
        EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
      };
      class Gh {
        constructor(e) {
          (this.parser = e),
            (this.name = Bh.KHR_LIGHTS_PUNCTUAL),
            (this.cache = { refs: {}, uses: {} });
        }
        _markDefs() {
          const e = this.parser,
            t = this.parser.json.nodes || [];
          for (let n = 0, i = t.length; n < i; n++) {
            const i = t[n];
            i.extensions &&
              i.extensions[this.name] &&
              void 0 !== i.extensions[this.name].light &&
              e._addNodeRef(this.cache, i.extensions[this.name].light);
          }
        }
        _loadLight(e) {
          const t = this.parser,
            n = "light:" + e;
          let i = t.cache.get(n);
          if (i) return i;
          const r = t.json,
            a = (((r.extensions && r.extensions[this.name]) || {}).lights ||
              [])[e];
          let o;
          const s = new sr(16777215);
          void 0 !== a.color && s.fromArray(a.color);
          const l = void 0 !== a.range ? a.range : 0;
          switch (a.type) {
            case "directional":
              (o = new Zu(s)), o.target.position.set(0, 0, -1), o.add(o.target);
              break;
            case "point":
              (o = new Yu(s)), (o.distance = l);
              break;
            case "spot":
              (o = new Vu(s)),
                (o.distance = l),
                (a.spot = a.spot || {}),
                (a.spot.innerConeAngle =
                  void 0 !== a.spot.innerConeAngle ? a.spot.innerConeAngle : 0),
                (a.spot.outerConeAngle =
                  void 0 !== a.spot.outerConeAngle
                    ? a.spot.outerConeAngle
                    : Math.PI / 4),
                (o.angle = a.spot.outerConeAngle),
                (o.penumbra =
                  1 - a.spot.innerConeAngle / a.spot.outerConeAngle),
                o.target.position.set(0, 0, -1),
                o.add(o.target);
              break;
            default:
              throw new Error(
                "THREE.GLTFLoader: Unexpected light type: " + a.type
              );
          }
          return (
            o.position.set(0, 0, 0),
            (o.decay = 2),
            void 0 !== a.intensity && (o.intensity = a.intensity),
            (o.name = t.createUniqueName(a.name || "light_" + e)),
            (i = Promise.resolve(o)),
            t.cache.add(n, i),
            i
          );
        }
        createNodeAttachment(e) {
          const t = this,
            n = this.parser,
            i = n.json.nodes[e],
            r = ((i.extensions && i.extensions[this.name]) || {}).light;
          return void 0 === r
            ? null
            : this._loadLight(r).then(function (e) {
                return n._getNodeRef(t.cache, r, e);
              });
        }
      }
      class Vh {
        constructor() {
          this.name = Bh.KHR_MATERIALS_UNLIT;
        }
        getMaterialType() {
          return lr;
        }
        extendParams(e, t, n) {
          const i = [];
          (e.color = new sr(1, 1, 1)), (e.opacity = 1);
          const r = t.pbrMetallicRoughness;
          if (r) {
            if (Array.isArray(r.baseColorFactor)) {
              const t = r.baseColorFactor;
              e.color.fromArray(t), (e.opacity = t[3]);
            }
            void 0 !== r.baseColorTexture &&
              i.push(n.assignTexture(e, "map", r.baseColorTexture));
          }
          return Promise.all(i);
        }
      }
      class Wh {
        constructor(e) {
          (this.parser = e), (this.name = Bh.KHR_MATERIALS_CLEARCOAT);
        }
        getMaterialType(e) {
          const t = this.parser.json.materials[e];
          return t.extensions && t.extensions[this.name] ? tu : null;
        }
        extendMaterialParams(e, t) {
          const n = this.parser,
            i = n.json.materials[e];
          if (!i.extensions || !i.extensions[this.name])
            return Promise.resolve();
          const r = [],
            a = i.extensions[this.name];
          if (
            (void 0 !== a.clearcoatFactor && (t.clearcoat = a.clearcoatFactor),
            void 0 !== a.clearcoatTexture &&
              r.push(n.assignTexture(t, "clearcoatMap", a.clearcoatTexture)),
            void 0 !== a.clearcoatRoughnessFactor &&
              (t.clearcoatRoughness = a.clearcoatRoughnessFactor),
            void 0 !== a.clearcoatRoughnessTexture &&
              r.push(
                n.assignTexture(
                  t,
                  "clearcoatRoughnessMap",
                  a.clearcoatRoughnessTexture
                )
              ),
            void 0 !== a.clearcoatNormalTexture &&
              (r.push(
                n.assignTexture(
                  t,
                  "clearcoatNormalMap",
                  a.clearcoatNormalTexture
                )
              ),
              void 0 !== a.clearcoatNormalTexture.scale))
          ) {
            const e = a.clearcoatNormalTexture.scale;
            t.clearcoatNormalScale = new Ln(e, -e);
          }
          return Promise.all(r);
        }
      }
      class jh {
        constructor(e) {
          (this.parser = e), (this.name = Bh.KHR_MATERIALS_TRANSMISSION);
        }
        getMaterialType(e) {
          const t = this.parser.json.materials[e];
          return t.extensions && t.extensions[this.name] ? tu : null;
        }
        extendMaterialParams(e, t) {
          const n = this.parser,
            i = n.json.materials[e];
          if (!i.extensions || !i.extensions[this.name])
            return Promise.resolve();
          const r = [],
            a = i.extensions[this.name];
          return (
            void 0 !== a.transmissionFactor &&
              (t.transmission = a.transmissionFactor),
            void 0 !== a.transmissionTexture &&
              r.push(
                n.assignTexture(t, "transmissionMap", a.transmissionTexture)
              ),
            Promise.all(r)
          );
        }
      }
      class Xh {
        constructor(e) {
          (this.parser = e), (this.name = Bh.KHR_MATERIALS_VOLUME);
        }
        getMaterialType(e) {
          const t = this.parser.json.materials[e];
          return t.extensions && t.extensions[this.name] ? tu : null;
        }
        extendMaterialParams(e, t) {
          const n = this.parser,
            i = n.json.materials[e];
          if (!i.extensions || !i.extensions[this.name])
            return Promise.resolve();
          const r = [],
            a = i.extensions[this.name];
          (t.thickness = void 0 !== a.thicknessFactor ? a.thicknessFactor : 0),
            void 0 !== a.thicknessTexture &&
              r.push(n.assignTexture(t, "thicknessMap", a.thicknessTexture)),
            (t.attenuationDistance = a.attenuationDistance || 0);
          const o = a.attenuationColor || [1, 1, 1];
          return (t.attenuationTint = new sr(o[0], o[1], o[2])), Promise.all(r);
        }
      }
      class qh {
        constructor(e) {
          (this.parser = e), (this.name = Bh.KHR_MATERIALS_IOR);
        }
        getMaterialType(e) {
          const t = this.parser.json.materials[e];
          return t.extensions && t.extensions[this.name] ? tu : null;
        }
        extendMaterialParams(e, t) {
          const n = this.parser.json.materials[e];
          if (!n.extensions || !n.extensions[this.name])
            return Promise.resolve();
          const i = n.extensions[this.name];
          return (t.ior = void 0 !== i.ior ? i.ior : 1.5), Promise.resolve();
        }
      }
      class Yh {
        constructor(e) {
          (this.parser = e), (this.name = Bh.KHR_MATERIALS_SPECULAR);
        }
        getMaterialType(e) {
          const t = this.parser.json.materials[e];
          return t.extensions && t.extensions[this.name] ? tu : null;
        }
        extendMaterialParams(e, t) {
          const n = this.parser,
            i = n.json.materials[e];
          if (!i.extensions || !i.extensions[this.name])
            return Promise.resolve();
          const r = [],
            a = i.extensions[this.name];
          (t.specularIntensity =
            void 0 !== a.specularFactor ? a.specularFactor : 1),
            void 0 !== a.specularTexture &&
              r.push(
                n.assignTexture(t, "specularIntensityMap", a.specularTexture)
              );
          const o = a.specularColorFactor || [1, 1, 1];
          return (
            (t.specularTint = new sr(o[0], o[1], o[2])),
            void 0 !== a.specularColorTexture &&
              r.push(
                n
                  .assignTexture(t, "specularTintMap", a.specularColorTexture)
                  .then(function (e) {
                    e.encoding = en;
                  })
              ),
            Promise.all(r)
          );
        }
      }
      class Kh {
        constructor(e) {
          (this.parser = e), (this.name = Bh.KHR_TEXTURE_BASISU);
        }
        loadTexture(e) {
          const t = this.parser,
            n = t.json,
            i = n.textures[e];
          if (!i.extensions || !i.extensions[this.name]) return null;
          const r = i.extensions[this.name],
            a = n.images[r.source],
            o = t.options.ktx2Loader;
          if (!o) {
            if (
              n.extensionsRequired &&
              n.extensionsRequired.indexOf(this.name) >= 0
            )
              throw new Error(
                "THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures"
              );
            return null;
          }
          return t.loadTextureImage(e, a, o);
        }
      }
      class Zh {
        constructor(e) {
          (this.parser = e),
            (this.name = Bh.EXT_TEXTURE_WEBP),
            (this.isSupported = null);
        }
        loadTexture(e) {
          const t = this.name,
            n = this.parser,
            i = n.json,
            r = i.textures[e];
          if (!r.extensions || !r.extensions[t]) return null;
          const a = r.extensions[t],
            o = i.images[a.source];
          let s = n.textureLoader;
          if (o.uri) {
            const e = n.options.manager.getHandler(o.uri);
            null !== e && (s = e);
          }
          return this.detectSupport().then(function (r) {
            if (r) return n.loadTextureImage(e, o, s);
            if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0)
              throw new Error(
                "THREE.GLTFLoader: WebP required by asset but unsupported."
              );
            return n.loadTexture(e);
          });
        }
        detectSupport() {
          return (
            this.isSupported ||
              (this.isSupported = new Promise(function (e) {
                const t = new Image();
                (t.src =
                  "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA"),
                  (t.onload = t.onerror =
                    function () {
                      e(1 === t.height);
                    });
              })),
            this.isSupported
          );
        }
      }
      class Jh {
        constructor(e) {
          (this.name = Bh.EXT_MESHOPT_COMPRESSION), (this.parser = e);
        }
        loadBufferView(e) {
          const t = this.parser.json,
            n = t.bufferViews[e];
          if (n.extensions && n.extensions[this.name]) {
            const e = n.extensions[this.name],
              i = this.parser.getDependency("buffer", e.buffer),
              r = this.parser.options.meshoptDecoder;
            if (!r || !r.supported) {
              if (
                t.extensionsRequired &&
                t.extensionsRequired.indexOf(this.name) >= 0
              )
                throw new Error(
                  "THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files"
                );
              return null;
            }
            return Promise.all([i, r.ready]).then(function (t) {
              const n = e.byteOffset || 0,
                i = e.byteLength || 0,
                a = e.count,
                o = e.byteStride,
                s = new ArrayBuffer(a * o),
                l = new Uint8Array(t[0], n, i);
              return (
                r.decodeGltfBuffer(
                  new Uint8Array(s),
                  a,
                  o,
                  l,
                  e.mode,
                  e.filter
                ),
                s
              );
            });
          }
          return null;
        }
      }
      const Qh = "glTF",
        $h = 1313821514,
        ed = 5130562;
      class td {
        constructor(e) {
          (this.name = Bh.KHR_BINARY_GLTF),
            (this.content = null),
            (this.body = null);
          const t = new DataView(e, 0, 12);
          if (
            ((this.header = {
              magic: th.decodeText(new Uint8Array(e.slice(0, 4))),
              version: t.getUint32(4, !0),
              length: t.getUint32(8, !0),
            }),
            this.header.magic !== Qh)
          )
            throw new Error(
              "THREE.GLTFLoader: Unsupported glTF-Binary header."
            );
          if (this.header.version < 2)
            throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
          const n = this.header.length - 12,
            i = new DataView(e, 12);
          let r = 0;
          for (; r < n; ) {
            const t = i.getUint32(r, !0);
            r += 4;
            const n = i.getUint32(r, !0);
            if (((r += 4), n === $h)) {
              const n = new Uint8Array(e, 12 + r, t);
              this.content = th.decodeText(n);
            } else if (n === ed) {
              const n = 12 + r;
              this.body = e.slice(n, n + t);
            }
            r += t;
          }
          if (null === this.content)
            throw new Error("THREE.GLTFLoader: JSON content not found.");
        }
      }
      class nd {
        constructor(e, t) {
          if (!t)
            throw new Error(
              "THREE.GLTFLoader: No DRACOLoader instance provided."
            );
          (this.name = Bh.KHR_DRACO_MESH_COMPRESSION),
            (this.json = e),
            (this.dracoLoader = t),
            this.dracoLoader.preload();
        }
        decodePrimitive(e, t) {
          const n = this.json,
            i = this.dracoLoader,
            r = e.extensions[this.name].bufferView,
            a = e.extensions[this.name].attributes,
            o = {},
            s = {},
            l = {};
          for (const e in a) {
            const t = _d[e] || e.toLowerCase();
            o[t] = a[e];
          }
          for (const t in e.attributes) {
            const i = _d[t] || t.toLowerCase();
            if (void 0 !== a[t]) {
              const r = n.accessors[e.attributes[t]],
                a = vd[r.componentType];
              (l[i] = a), (s[i] = !0 === r.normalized);
            }
          }
          return t.getDependency("bufferView", r).then(function (e) {
            return new Promise(function (t) {
              i.decodeDracoFile(
                e,
                function (e) {
                  for (const t in e.attributes) {
                    const n = e.attributes[t],
                      i = s[t];
                    void 0 !== i && (n.normalized = i);
                  }
                  t(e);
                },
                o,
                l
              );
            });
          });
        }
      }
      class id {
        constructor() {
          this.name = Bh.KHR_TEXTURE_TRANSFORM;
        }
        extendTexture(e, t) {
          return (
            void 0 !== t.texCoord &&
              console.warn(
                'THREE.GLTFLoader: Custom UV sets in "' +
                  this.name +
                  '" extension not yet supported.'
              ),
            (void 0 === t.offset &&
              void 0 === t.rotation &&
              void 0 === t.scale) ||
              ((e = e.clone()),
              void 0 !== t.offset && e.offset.fromArray(t.offset),
              void 0 !== t.rotation && (e.rotation = t.rotation),
              void 0 !== t.scale && e.repeat.fromArray(t.scale),
              (e.needsUpdate = !0)),
            e
          );
        }
      }
      class rd extends eu {
        constructor(e) {
          super(), (this.isGLTFSpecularGlossinessMaterial = !0);
          const t = [
              "#ifdef USE_SPECULARMAP",
              "\tuniform sampler2D specularMap;",
              "#endif",
            ].join("\n"),
            n = [
              "#ifdef USE_GLOSSINESSMAP",
              "\tuniform sampler2D glossinessMap;",
              "#endif",
            ].join("\n"),
            i = [
              "vec3 specularFactor = specular;",
              "#ifdef USE_SPECULARMAP",
              "\tvec4 texelSpecular = texture2D( specularMap, vUv );",
              "\ttexelSpecular = sRGBToLinear( texelSpecular );",
              "\t// reads channel RGB, compatible with a glTF Specular-Glossiness (RGBA) texture",
              "\tspecularFactor *= texelSpecular.rgb;",
              "#endif",
            ].join("\n"),
            r = [
              "float glossinessFactor = glossiness;",
              "#ifdef USE_GLOSSINESSMAP",
              "\tvec4 texelGlossiness = texture2D( glossinessMap, vUv );",
              "\t// reads channel A, compatible with a glTF Specular-Glossiness (RGBA) texture",
              "\tglossinessFactor *= texelGlossiness.a;",
              "#endif",
            ].join("\n"),
            a = [
              "PhysicalMaterial material;",
              "material.diffuseColor = diffuseColor.rgb * ( 1. - max( specularFactor.r, max( specularFactor.g, specularFactor.b ) ) );",
              "vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );",
              "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );",
              "material.roughness = max( 1.0 - glossinessFactor, 0.0525 ); // 0.0525 corresponds to the base mip of a 256 cubemap.",
              "material.roughness += geometryRoughness;",
              "material.roughness = min( material.roughness, 1.0 );",
              "material.specularColor = specularFactor;",
            ].join("\n"),
            o = {
              specular: { value: new sr().setHex(16777215) },
              glossiness: { value: 1 },
              specularMap: { value: null },
              glossinessMap: { value: null },
            };
          (this._extraUniforms = o),
            (this.onBeforeCompile = function (e) {
              for (const t in o) e.uniforms[t] = o[t];
              e.fragmentShader = e.fragmentShader
                .replace("uniform float roughness;", "uniform vec3 specular;")
                .replace(
                  "uniform float metalness;",
                  "uniform float glossiness;"
                )
                .replace("#include <roughnessmap_pars_fragment>", t)
                .replace("#include <metalnessmap_pars_fragment>", n)
                .replace("#include <roughnessmap_fragment>", i)
                .replace("#include <metalnessmap_fragment>", r)
                .replace("#include <lights_physical_fragment>", a);
            }),
            Object.defineProperties(this, {
              specular: {
                get: function () {
                  return o.specular.value;
                },
                set: function (e) {
                  o.specular.value = e;
                },
              },
              specularMap: {
                get: function () {
                  return o.specularMap.value;
                },
                set: function (e) {
                  (o.specularMap.value = e),
                    e
                      ? (this.defines.USE_SPECULARMAP = "")
                      : delete this.defines.USE_SPECULARMAP;
                },
              },
              glossiness: {
                get: function () {
                  return o.glossiness.value;
                },
                set: function (e) {
                  o.glossiness.value = e;
                },
              },
              glossinessMap: {
                get: function () {
                  return o.glossinessMap.value;
                },
                set: function (e) {
                  (o.glossinessMap.value = e),
                    e
                      ? ((this.defines.USE_GLOSSINESSMAP = ""),
                        (this.defines.USE_UV = ""))
                      : (delete this.defines.USE_GLOSSINESSMAP,
                        delete this.defines.USE_UV);
                },
              },
            }),
            delete this.metalness,
            delete this.roughness,
            delete this.metalnessMap,
            delete this.roughnessMap,
            this.setValues(e);
        }
        copy(e) {
          return (
            super.copy(e),
            (this.specularMap = e.specularMap),
            this.specular.copy(e.specular),
            (this.glossinessMap = e.glossinessMap),
            (this.glossiness = e.glossiness),
            delete this.metalness,
            delete this.roughness,
            delete this.metalnessMap,
            delete this.roughnessMap,
            this
          );
        }
      }
      class ad {
        constructor() {
          (this.name = Bh.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS),
            (this.specularGlossinessParams = [
              "color",
              "map",
              "lightMap",
              "lightMapIntensity",
              "aoMap",
              "aoMapIntensity",
              "emissive",
              "emissiveIntensity",
              "emissiveMap",
              "bumpMap",
              "bumpScale",
              "normalMap",
              "normalMapType",
              "displacementMap",
              "displacementScale",
              "displacementBias",
              "specularMap",
              "specular",
              "glossinessMap",
              "glossiness",
              "alphaMap",
              "envMap",
              "envMapIntensity",
              "refractionRatio",
            ]);
        }
        getMaterialType() {
          return rd;
        }
        extendParams(e, t, n) {
          const i = t.extensions[this.name];
          (e.color = new sr(1, 1, 1)), (e.opacity = 1);
          const r = [];
          if (Array.isArray(i.diffuseFactor)) {
            const t = i.diffuseFactor;
            e.color.fromArray(t), (e.opacity = t[3]);
          }
          if (
            (void 0 !== i.diffuseTexture &&
              r.push(n.assignTexture(e, "map", i.diffuseTexture)),
            (e.emissive = new sr(0, 0, 0)),
            (e.glossiness =
              void 0 !== i.glossinessFactor ? i.glossinessFactor : 1),
            (e.specular = new sr(1, 1, 1)),
            Array.isArray(i.specularFactor) &&
              e.specular.fromArray(i.specularFactor),
            void 0 !== i.specularGlossinessTexture)
          ) {
            const t = i.specularGlossinessTexture;
            r.push(n.assignTexture(e, "glossinessMap", t)),
              r.push(n.assignTexture(e, "specularMap", t));
          }
          return Promise.all(r);
        }
        createMaterial(e) {
          const t = new rd(e);
          return (
            (t.fog = !0),
            (t.color = e.color),
            (t.map = void 0 === e.map ? null : e.map),
            (t.lightMap = null),
            (t.lightMapIntensity = 1),
            (t.aoMap = void 0 === e.aoMap ? null : e.aoMap),
            (t.aoMapIntensity = 1),
            (t.emissive = e.emissive),
            (t.emissiveIntensity = 1),
            (t.emissiveMap = void 0 === e.emissiveMap ? null : e.emissiveMap),
            (t.bumpMap = void 0 === e.bumpMap ? null : e.bumpMap),
            (t.bumpScale = 1),
            (t.normalMap = void 0 === e.normalMap ? null : e.normalMap),
            (t.normalMapType = cn),
            e.normalScale && (t.normalScale = e.normalScale),
            (t.displacementMap = null),
            (t.displacementScale = 1),
            (t.displacementBias = 0),
            (t.specularMap = void 0 === e.specularMap ? null : e.specularMap),
            (t.specular = e.specular),
            (t.glossinessMap =
              void 0 === e.glossinessMap ? null : e.glossinessMap),
            (t.glossiness = e.glossiness),
            (t.alphaMap = null),
            (t.envMap = void 0 === e.envMap ? null : e.envMap),
            (t.envMapIntensity = 1),
            (t.refractionRatio = 0.98),
            t
          );
        }
      }
      class od {
        constructor() {
          this.name = Bh.KHR_MESH_QUANTIZATION;
        }
      }
      class sd extends cu {
        constructor(e, t, n, i) {
          super(e, t, n, i);
        }
        copySampleValue_(e) {
          const t = this.resultBuffer,
            n = this.sampleValues,
            i = this.valueSize,
            r = e * i * 3 + i;
          for (let e = 0; e !== i; e++) t[e] = n[r + e];
          return t;
        }
      }
      (sd.prototype.beforeStart_ = sd.prototype.copySampleValue_),
        (sd.prototype.afterEnd_ = sd.prototype.copySampleValue_),
        (sd.prototype.interpolate_ = function (e, t, n, i) {
          const r = this.resultBuffer,
            a = this.sampleValues,
            o = this.valueSize,
            s = 2 * o,
            l = 3 * o,
            c = i - t,
            u = (n - t) / c,
            h = u * u,
            d = h * u,
            p = e * l,
            m = p - l,
            f = -2 * d + 3 * h,
            g = d - h,
            v = 1 - f,
            y = g - h + u;
          for (let e = 0; e !== o; e++) {
            const t = a[m + e + o],
              n = a[m + e + s] * c,
              i = a[p + e + o],
              l = a[p + e] * c;
            r[e] = v * t + y * n + f * i + g * l;
          }
          return r;
        });
      const ld = new Hn();
      class cd extends sd {
        interpolate_(e, t, n, i) {
          const r = super.interpolate_(e, t, n, i);
          return ld.fromArray(r).normalize().toArray(r), r;
        }
      }
      const ud = 0,
        hd = 1,
        dd = 2,
        pd = 3,
        md = 4,
        fd = 5,
        gd = 6,
        vd = {
          5120: Int8Array,
          5121: Uint8Array,
          5122: Int16Array,
          5123: Uint16Array,
          5125: Uint32Array,
          5126: Float32Array,
        },
        yd = { 9728: Ae, 9729: Re, 9984: Le, 9985: Ce, 9986: Pe, 9987: Ie },
        xd = { 33071: Te, 33648: Ee, 10497: Se },
        bd = {
          SCALAR: 1,
          VEC2: 2,
          VEC3: 3,
          VEC4: 4,
          MAT2: 4,
          MAT3: 9,
          MAT4: 16,
        },
        _d = {
          POSITION: "position",
          NORMAL: "normal",
          TANGENT: "tangent",
          TEXCOORD_0: "uv",
          TEXCOORD_1: "uv2",
          COLOR_0: "color",
          WEIGHTS_0: "skinWeight",
          JOINTS_0: "skinIndex",
        },
        wd = {
          scale: "scale",
          translation: "position",
          rotation: "quaternion",
          weights: "morphTargetInfluences",
        },
        Md = { CUBICSPLINE: void 0, LINEAR: Xt, STEP: jt },
        Sd = "OPAQUE",
        Td = "MASK",
        Ed = "BLEND";
      function Ad(e, t) {
        return "string" != typeof e || "" === e
          ? ""
          : (/^https?:\/\//i.test(t) &&
              /^\//.test(e) &&
              (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")),
            /^(https?:)?\/\//i.test(e) ||
            /^data:.*,.*$/i.test(e) ||
            /^blob:.*$/i.test(e)
              ? e
              : t + e);
      }
      function Ld(e, t, n) {
        for (const i in n.extensions)
          void 0 === e[i] &&
            ((t.userData.gltfExtensions = t.userData.gltfExtensions || {}),
            (t.userData.gltfExtensions[i] = n.extensions[i]));
      }
      function Pd(e, t) {
        void 0 !== t.extras &&
          ("object" == typeof t.extras
            ? Object.assign(e.userData, t.extras)
            : console.warn(
                "THREE.GLTFLoader: Ignoring primitive type .extras, " + t.extras
              ));
      }
      function Rd(e, t) {
        if ((e.updateMorphTargets(), void 0 !== t.weights))
          for (let n = 0, i = t.weights.length; n < i; n++)
            e.morphTargetInfluences[n] = t.weights[n];
        if (t.extras && Array.isArray(t.extras.targetNames)) {
          const n = t.extras.targetNames;
          if (e.morphTargetInfluences.length === n.length) {
            e.morphTargetDictionary = {};
            for (let t = 0, i = n.length; t < i; t++)
              e.morphTargetDictionary[n[t]] = t;
          } else
            console.warn(
              "THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names."
            );
        }
      }
      function Cd(e) {
        const t = e.extensions && e.extensions[Bh.KHR_DRACO_MESH_COMPRESSION];
        let n;
        return (
          (n = t
            ? "draco:" + t.bufferView + ":" + t.indices + ":" + Id(t.attributes)
            : e.indices + ":" + Id(e.attributes) + ":" + e.mode),
          n
        );
      }
      function Id(e) {
        let t = "";
        const n = Object.keys(e).sort();
        for (let i = 0, r = n.length; i < r; i++)
          t += n[i] + ":" + e[n[i]] + ";";
        return t;
      }
      function Nd(e) {
        switch (e) {
          case Int8Array:
            return 1 / 127;
          case Uint8Array:
            return 1 / 255;
          case Int16Array:
            return 1 / 32767;
          case Uint16Array:
            return 1 / 65535;
          default:
            throw new Error(
              "THREE.GLTFLoader: Unsupported normalized accessor component type."
            );
        }
      }
      class Dd {
        constructor(e = {}, t = {}) {
          (this.json = e),
            (this.extensions = {}),
            (this.plugins = {}),
            (this.options = t),
            (this.cache = new Uh()),
            (this.associations = new Map()),
            (this.primitiveCache = {}),
            (this.meshCache = { refs: {}, uses: {} }),
            (this.cameraCache = { refs: {}, uses: {} }),
            (this.lightCache = { refs: {}, uses: {} }),
            (this.textureCache = {}),
            (this.nodeNamesUsed = {}),
            "undefined" != typeof createImageBitmap &&
            !1 === /Firefox/.test(navigator.userAgent)
              ? (this.textureLoader = new ih(this.options.manager))
              : (this.textureLoader = new Iu(this.options.manager)),
            this.textureLoader.setCrossOrigin(this.options.crossOrigin),
            this.textureLoader.setRequestHeader(this.options.requestHeader),
            (this.fileLoader = new Lu(this.options.manager)),
            this.fileLoader.setResponseType("arraybuffer"),
            "use-credentials" === this.options.crossOrigin &&
              this.fileLoader.setWithCredentials(!0);
        }
        setExtensions(e) {
          this.extensions = e;
        }
        setPlugins(e) {
          this.plugins = e;
        }
        parse(e, t) {
          const n = this,
            i = this.json,
            r = this.extensions;
          this.cache.removeAll(),
            this._invokeAll(function (e) {
              return e._markDefs && e._markDefs();
            }),
            Promise.all(
              this._invokeAll(function (e) {
                return e.beforeRoot && e.beforeRoot();
              })
            )
              .then(function () {
                return Promise.all([
                  n.getDependencies("scene"),
                  n.getDependencies("animation"),
                  n.getDependencies("camera"),
                ]);
              })
              .then(function (t) {
                const a = {
                  scene: t[0][i.scene || 0],
                  scenes: t[0],
                  animations: t[1],
                  cameras: t[2],
                  asset: i.asset,
                  parser: n,
                  userData: {},
                };
                Ld(r, a, i),
                  Pd(a, i),
                  Promise.all(
                    n._invokeAll(function (e) {
                      return e.afterRoot && e.afterRoot(a);
                    })
                  ).then(function () {
                    e(a);
                  });
              })
              .catch(t);
        }
        _markDefs() {
          const e = this.json.nodes || [],
            t = this.json.skins || [],
            n = this.json.meshes || [];
          for (let n = 0, i = t.length; n < i; n++) {
            const i = t[n].joints;
            for (let t = 0, n = i.length; t < n; t++) e[i[t]].isBone = !0;
          }
          for (let t = 0, i = e.length; t < i; t++) {
            const i = e[t];
            void 0 !== i.mesh &&
              (this._addNodeRef(this.meshCache, i.mesh),
              void 0 !== i.skin && (n[i.mesh].isSkinnedMesh = !0)),
              void 0 !== i.camera &&
                this._addNodeRef(this.cameraCache, i.camera);
          }
        }
        _addNodeRef(e, t) {
          void 0 !== t &&
            (void 0 === e.refs[t] && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
        }
        _getNodeRef(e, t, n) {
          if (e.refs[t] <= 1) return n;
          const i = n.clone();
          return (i.name += "_instance_" + e.uses[t]++), i;
        }
        _invokeOne(e) {
          const t = Object.values(this.plugins);
          t.push(this);
          for (let n = 0; n < t.length; n++) {
            const i = e(t[n]);
            if (i) return i;
          }
          return null;
        }
        _invokeAll(e) {
          const t = Object.values(this.plugins);
          t.unshift(this);
          const n = [];
          for (let i = 0; i < t.length; i++) {
            const r = e(t[i]);
            r && n.push(r);
          }
          return n;
        }
        getDependency(e, t) {
          const n = e + ":" + t;
          let i = this.cache.get(n);
          if (!i) {
            switch (e) {
              case "scene":
                i = this.loadScene(t);
                break;
              case "node":
                i = this.loadNode(t);
                break;
              case "mesh":
                i = this._invokeOne(function (e) {
                  return e.loadMesh && e.loadMesh(t);
                });
                break;
              case "accessor":
                i = this.loadAccessor(t);
                break;
              case "bufferView":
                i = this._invokeOne(function (e) {
                  return e.loadBufferView && e.loadBufferView(t);
                });
                break;
              case "buffer":
                i = this.loadBuffer(t);
                break;
              case "material":
                i = this._invokeOne(function (e) {
                  return e.loadMaterial && e.loadMaterial(t);
                });
                break;
              case "texture":
                i = this._invokeOne(function (e) {
                  return e.loadTexture && e.loadTexture(t);
                });
                break;
              case "skin":
                i = this.loadSkin(t);
                break;
              case "animation":
                i = this.loadAnimation(t);
                break;
              case "camera":
                i = this.loadCamera(t);
                break;
              default:
                throw new Error("Unknown type: " + e);
            }
            this.cache.add(n, i);
          }
          return i;
        }
        getDependencies(e) {
          let t = this.cache.get(e);
          if (!t) {
            const n = this,
              i = this.json[e + ("mesh" === e ? "es" : "s")] || [];
            (t = Promise.all(
              i.map(function (t, i) {
                return n.getDependency(e, i);
              })
            )),
              this.cache.add(e, t);
          }
          return t;
        }
        loadBuffer(e) {
          const t = this.json.buffers[e],
            n = this.fileLoader;
          if (t.type && "arraybuffer" !== t.type)
            throw new Error(
              "THREE.GLTFLoader: " + t.type + " buffer type is not supported."
            );
          if (void 0 === t.uri && 0 === e)
            return Promise.resolve(this.extensions[Bh.KHR_BINARY_GLTF].body);
          const i = this.options;
          return new Promise(function (e, r) {
            n.load(Ad(t.uri, i.path), e, void 0, function () {
              r(
                new Error(
                  'THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'
                )
              );
            });
          });
        }
        loadBufferView(e) {
          const t = this.json.bufferViews[e];
          return this.getDependency("buffer", t.buffer).then(function (e) {
            const n = t.byteLength || 0,
              i = t.byteOffset || 0;
            return e.slice(i, i + n);
          });
        }
        loadAccessor(e) {
          const t = this,
            n = this.json,
            i = this.json.accessors[e];
          if (void 0 === i.bufferView && void 0 === i.sparse)
            return Promise.resolve(null);
          const r = [];
          return (
            void 0 !== i.bufferView
              ? r.push(this.getDependency("bufferView", i.bufferView))
              : r.push(null),
            void 0 !== i.sparse &&
              (r.push(
                this.getDependency("bufferView", i.sparse.indices.bufferView)
              ),
              r.push(
                this.getDependency("bufferView", i.sparse.values.bufferView)
              )),
            Promise.all(r).then(function (e) {
              const r = e[0],
                a = bd[i.type],
                o = vd[i.componentType],
                s = o.BYTES_PER_ELEMENT,
                l = s * a,
                c = i.byteOffset || 0,
                u =
                  void 0 !== i.bufferView
                    ? n.bufferViews[i.bufferView].byteStride
                    : void 0,
                h = !0 === i.normalized;
              let d, p;
              if (u && u !== l) {
                const e = Math.floor(c / u),
                  n =
                    "InterleavedBuffer:" +
                    i.bufferView +
                    ":" +
                    i.componentType +
                    ":" +
                    e +
                    ":" +
                    i.count;
                let l = t.cache.get(n);
                l ||
                  ((d = new o(r, e * u, (i.count * u) / s)),
                  (l = new nl(d, u / s)),
                  t.cache.add(n, l)),
                  (p = new rl(l, a, (c % u) / s, h));
              } else (d = null === r ? new o(i.count * a) : new o(r, c, i.count * a)), (p = new hr(d, a, h));
              if (void 0 !== i.sparse) {
                const t = bd.SCALAR,
                  n = vd[i.sparse.indices.componentType],
                  s = i.sparse.indices.byteOffset || 0,
                  l = i.sparse.values.byteOffset || 0,
                  c = new n(e[1], s, i.sparse.count * t),
                  u = new o(e[2], l, i.sparse.count * a);
                null !== r &&
                  (p = new hr(p.array.slice(), p.itemSize, p.normalized));
                for (let e = 0, t = c.length; e < t; e++) {
                  const t = c[e];
                  if (
                    (p.setX(t, u[e * a]),
                    a >= 2 && p.setY(t, u[e * a + 1]),
                    a >= 3 && p.setZ(t, u[e * a + 2]),
                    a >= 4 && p.setW(t, u[e * a + 3]),
                    a >= 5)
                  )
                    throw new Error(
                      "THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute."
                    );
                }
              }
              return p;
            })
          );
        }
        loadTexture(e) {
          const t = this.json,
            n = this.options,
            i = t.textures[e],
            r = t.images[i.source];
          let a = this.textureLoader;
          if (r.uri) {
            const e = n.manager.getHandler(r.uri);
            null !== e && (a = e);
          }
          return this.loadTextureImage(e, r, a);
        }
        loadTextureImage(e, t, n) {
          const i = this,
            r = this.json,
            a = this.options,
            o = r.textures[e],
            s = (t.uri || t.bufferView) + ":" + o.sampler;
          if (this.textureCache[s]) return this.textureCache[s];
          const l = self.URL || self.webkitURL;
          let c = t.uri || "",
            u = !1,
            h = !0;
          const d =
            c.search(/\.jpe?g($|\?)/i) > 0 ||
            0 === c.search(/^data\:image\/jpeg/);
          if (
            (("image/jpeg" === t.mimeType || d) && (h = !1),
            void 0 !== t.bufferView)
          )
            c = i.getDependency("bufferView", t.bufferView).then(function (e) {
              if ("image/png" === t.mimeType) {
                const t = new DataView(e, 25, 1).getUint8(0, !1);
                h = 6 === t || 4 === t || 3 === t;
              }
              u = !0;
              const n = new Blob([e], { type: t.mimeType });
              return (c = l.createObjectURL(n)), c;
            });
          else if (void 0 === t.uri)
            throw new Error(
              "THREE.GLTFLoader: Image " + e + " is missing URI and bufferView"
            );
          const p = Promise.resolve(c)
            .then(function (e) {
              return new Promise(function (t, i) {
                let r = t;
                !0 === n.isImageBitmapLoader &&
                  (r = function (e) {
                    const n = new Nn(e);
                    (n.needsUpdate = !0), t(n);
                  }),
                  n.load(Ad(e, a.path), r, void 0, i);
              });
            })
            .then(function (t) {
              !0 === u && l.revokeObjectURL(c),
                (t.flipY = !1),
                o.name && (t.name = o.name),
                h || (t.format = Xe);
              const n = (r.samplers || {})[o.sampler] || {};
              return (
                (t.magFilter = yd[n.magFilter] || Re),
                (t.minFilter = yd[n.minFilter] || Ie),
                (t.wrapS = xd[n.wrapS] || Se),
                (t.wrapT = xd[n.wrapT] || Se),
                i.associations.set(t, { type: "textures", index: e }),
                t
              );
            })
            .catch(function () {
              return (
                console.error("THREE.GLTFLoader: Couldn't load texture", c),
                null
              );
            });
          return (this.textureCache[s] = p), p;
        }
        assignTexture(e, t, n) {
          const i = this;
          return this.getDependency("texture", n.index).then(function (r) {
            if (
              (void 0 === n.texCoord ||
                0 == n.texCoord ||
                ("aoMap" === t && 1 == n.texCoord) ||
                console.warn(
                  "THREE.GLTFLoader: Custom UV set " +
                    n.texCoord +
                    " for texture " +
                    t +
                    " not yet supported."
                ),
              i.extensions[Bh.KHR_TEXTURE_TRANSFORM])
            ) {
              const e =
                void 0 !== n.extensions
                  ? n.extensions[Bh.KHR_TEXTURE_TRANSFORM]
                  : void 0;
              if (e) {
                const t = i.associations.get(r);
                (r = i.extensions[Bh.KHR_TEXTURE_TRANSFORM].extendTexture(
                  r,
                  e
                )),
                  i.associations.set(r, t);
              }
            }
            return (e[t] = r), r;
          });
        }
        assignFinalMaterial(e) {
          const t = e.geometry;
          let n = e.material;
          const i = void 0 !== t.attributes.tangent,
            r = void 0 !== t.attributes.color,
            a = void 0 === t.attributes.normal;
          if (e.isPoints) {
            const e = "PointsMaterial:" + n.uuid;
            let t = this.cache.get(e);
            t ||
              ((t = new Kl()),
              er.prototype.copy.call(t, n),
              t.color.copy(n.color),
              (t.map = n.map),
              (t.sizeAttenuation = !1),
              this.cache.add(e, t)),
              (n = t);
          } else if (e.isLine) {
            const e = "LineBasicMaterial:" + n.uuid;
            let t = this.cache.get(e);
            t ||
              ((t = new Hl()),
              er.prototype.copy.call(t, n),
              t.color.copy(n.color),
              this.cache.add(e, t)),
              (n = t);
          }
          if (i || r || a) {
            let e = "ClonedMaterial:" + n.uuid + ":";
            n.isGLTFSpecularGlossinessMaterial && (e += "specular-glossiness:"),
              i && (e += "vertex-tangents:"),
              r && (e += "vertex-colors:"),
              a && (e += "flat-shading:");
            let t = this.cache.get(e);
            t ||
              ((t = n.clone()),
              r && (t.vertexColors = !0),
              a && (t.flatShading = !0),
              i &&
                (t.normalScale && (t.normalScale.y *= -1),
                t.clearcoatNormalScale && (t.clearcoatNormalScale.y *= -1)),
              this.cache.add(e, t),
              this.associations.set(t, this.associations.get(n))),
              (n = t);
          }
          n.aoMap &&
            void 0 === t.attributes.uv2 &&
            void 0 !== t.attributes.uv &&
            t.setAttribute("uv2", t.attributes.uv),
            (e.material = n);
        }
        getMaterialType() {
          return eu;
        }
        loadMaterial(e) {
          const t = this,
            n = this.json,
            i = this.extensions,
            r = n.materials[e];
          let a;
          const o = {},
            s = r.extensions || {},
            l = [];
          if (s[Bh.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS]) {
            const e = i[Bh.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS];
            (a = e.getMaterialType()), l.push(e.extendParams(o, r, t));
          } else if (s[Bh.KHR_MATERIALS_UNLIT]) {
            const e = i[Bh.KHR_MATERIALS_UNLIT];
            (a = e.getMaterialType()), l.push(e.extendParams(o, r, t));
          } else {
            const n = r.pbrMetallicRoughness || {};
            if (
              ((o.color = new sr(1, 1, 1)),
              (o.opacity = 1),
              Array.isArray(n.baseColorFactor))
            ) {
              const e = n.baseColorFactor;
              o.color.fromArray(e), (o.opacity = e[3]);
            }
            void 0 !== n.baseColorTexture &&
              l.push(t.assignTexture(o, "map", n.baseColorTexture)),
              (o.metalness =
                void 0 !== n.metallicFactor ? n.metallicFactor : 1),
              (o.roughness =
                void 0 !== n.roughnessFactor ? n.roughnessFactor : 1),
              void 0 !== n.metallicRoughnessTexture &&
                (l.push(
                  t.assignTexture(o, "metalnessMap", n.metallicRoughnessTexture)
                ),
                l.push(
                  t.assignTexture(o, "roughnessMap", n.metallicRoughnessTexture)
                )),
              (a = this._invokeOne(function (t) {
                return t.getMaterialType && t.getMaterialType(e);
              })),
              l.push(
                Promise.all(
                  this._invokeAll(function (t) {
                    return (
                      t.extendMaterialParams && t.extendMaterialParams(e, o)
                    );
                  })
                )
              );
          }
          !0 === r.doubleSided && (o.side = I);
          const c = r.alphaMode || Sd;
          return (
            c === Ed
              ? ((o.transparent = !0), (o.depthWrite = !1))
              : ((o.format = Xe),
                (o.transparent = !1),
                c === Td &&
                  (o.alphaTest =
                    void 0 !== r.alphaCutoff ? r.alphaCutoff : 0.5)),
            void 0 !== r.normalTexture &&
              a !== lr &&
              (l.push(t.assignTexture(o, "normalMap", r.normalTexture)),
              (o.normalScale = new Ln(1, -1)),
              void 0 !== r.normalTexture.scale &&
                o.normalScale.set(
                  r.normalTexture.scale,
                  -r.normalTexture.scale
                )),
            void 0 !== r.occlusionTexture &&
              a !== lr &&
              (l.push(t.assignTexture(o, "aoMap", r.occlusionTexture)),
              void 0 !== r.occlusionTexture.strength &&
                (o.aoMapIntensity = r.occlusionTexture.strength)),
            void 0 !== r.emissiveFactor &&
              a !== lr &&
              (o.emissive = new sr().fromArray(r.emissiveFactor)),
            void 0 !== r.emissiveTexture &&
              a !== lr &&
              l.push(t.assignTexture(o, "emissiveMap", r.emissiveTexture)),
            Promise.all(l).then(function () {
              let n;
              return (
                (n =
                  a === rd
                    ? i[
                        Bh.KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS
                      ].createMaterial(o)
                    : new a(o)),
                r.name && (n.name = r.name),
                n.map && (n.map.encoding = en),
                n.emissiveMap && (n.emissiveMap.encoding = en),
                Pd(n, r),
                t.associations.set(n, { type: "materials", index: e }),
                r.extensions && Ld(i, n, r),
                n
              );
            })
          );
        }
        createUniqueName(e) {
          const t = wh.sanitizeNodeName(e || "");
          let n = t;
          for (let e = 1; this.nodeNamesUsed[n]; ++e) n = t + "_" + e;
          return (this.nodeNamesUsed[n] = !0), n;
        }
        loadGeometries(e) {
          const t = this,
            n = this.extensions,
            i = this.primitiveCache;
          function r(e) {
            return n[Bh.KHR_DRACO_MESH_COMPRESSION]
              .decodePrimitive(e, t)
              .then(function (n) {
                return Fd(n, e, t);
              });
          }
          const a = [];
          for (let n = 0, o = e.length; n < o; n++) {
            const o = e[n],
              s = Cd(o),
              l = i[s];
            if (l) a.push(l.promise);
            else {
              let e;
              (e =
                o.extensions && o.extensions[Bh.KHR_DRACO_MESH_COMPRESSION]
                  ? r(o)
                  : Fd(new Mr(), o, t)),
                (i[s] = { primitive: o, promise: e }),
                a.push(e);
            }
          }
          return Promise.all(a);
        }
        loadMesh(e) {
          const t = this,
            n = this.json,
            i = this.extensions,
            r = n.meshes[e],
            a = r.primitives,
            o = [];
          for (let e = 0, t = a.length; e < t; e++) {
            const t =
              void 0 === a[e].material
                ? (void 0 === (s = this.cache).DefaultMaterial &&
                    (s.DefaultMaterial = new eu({
                      color: 16777215,
                      emissive: 0,
                      metalness: 1,
                      roughness: 1,
                      transparent: !1,
                      depthTest: !0,
                      side: R,
                    })),
                  s.DefaultMaterial)
                : this.getDependency("material", a[e].material);
            o.push(t);
          }
          var s;
          return (
            o.push(t.loadGeometries(a)),
            Promise.all(o).then(function (n) {
              const o = n.slice(0, n.length - 1),
                s = n[n.length - 1],
                l = [];
              for (let n = 0, c = s.length; n < c; n++) {
                const c = s[n],
                  u = a[n];
                let h;
                const d = o[n];
                if (
                  u.mode === md ||
                  u.mode === fd ||
                  u.mode === gd ||
                  void 0 === u.mode
                )
                  (h = !0 === r.isSkinnedMesh ? new El(c, d) : new Br(c, d)),
                    !0 !== h.isSkinnedMesh ||
                      h.geometry.attributes.skinWeight.normalized ||
                      h.normalizeSkinWeights(),
                    u.mode === fd
                      ? (h.geometry = kd(h.geometry, 1))
                      : u.mode === gd && (h.geometry = kd(h.geometry, Qt));
                else if (u.mode === hd) h = new ql(c, d);
                else if (u.mode === pd) h = new Wl(c, d);
                else if (u.mode === dd) h = new Yl(c, d);
                else {
                  if (u.mode !== ud)
                    throw new Error(
                      "THREE.GLTFLoader: Primitive mode unsupported: " + u.mode
                    );
                  h = new ec(c, d);
                }
                Object.keys(h.geometry.morphAttributes).length > 0 && Rd(h, r),
                  (h.name = t.createUniqueName(r.name || "mesh_" + e)),
                  Pd(h, r),
                  u.extensions && Ld(i, h, u),
                  t.assignFinalMaterial(h),
                  l.push(h);
              }
              if (1 === l.length) return l[0];
              const c = new qs();
              for (let e = 0, t = l.length; e < t; e++) c.add(l[e]);
              return c;
            })
          );
        }
        loadCamera(e) {
          let t;
          const n = this.json.cameras[e],
            i = n[n.type];
          if (i)
            return (
              "perspective" === n.type
                ? (t = new Kr(
                    An.radToDeg(i.yfov),
                    i.aspectRatio || 1,
                    i.znear || 1,
                    i.zfar || 2e6
                  ))
                : "orthographic" === n.type &&
                  (t = new xa(
                    -i.xmag,
                    i.xmag,
                    i.ymag,
                    -i.ymag,
                    i.znear,
                    i.zfar
                  )),
              n.name && (t.name = this.createUniqueName(n.name)),
              Pd(t, n),
              Promise.resolve(t)
            );
          console.warn("THREE.GLTFLoader: Missing camera parameters.");
        }
        loadSkin(e) {
          const t = this.json.skins[e],
            n = { joints: t.joints };
          return void 0 === t.inverseBindMatrices
            ? Promise.resolve(n)
            : this.getDependency("accessor", t.inverseBindMatrices).then(
                function (e) {
                  return (n.inverseBindMatrices = e), n;
                }
              );
        }
        loadAnimation(e) {
          const t = this.json.animations[e],
            n = [],
            i = [],
            r = [],
            a = [],
            o = [];
          for (let e = 0, s = t.channels.length; e < s; e++) {
            const s = t.channels[e],
              l = t.samplers[s.sampler],
              c = s.target,
              u = void 0 !== c.node ? c.node : c.id,
              h = void 0 !== t.parameters ? t.parameters[l.input] : l.input,
              d = void 0 !== t.parameters ? t.parameters[l.output] : l.output;
            n.push(this.getDependency("node", u)),
              i.push(this.getDependency("accessor", h)),
              r.push(this.getDependency("accessor", d)),
              a.push(l),
              o.push(c);
          }
          return Promise.all([
            Promise.all(n),
            Promise.all(i),
            Promise.all(r),
            Promise.all(a),
            Promise.all(o),
          ]).then(function (n) {
            const i = n[0],
              r = n[1],
              a = n[2],
              o = n[3],
              s = n[4],
              l = [];
            for (let e = 0, t = i.length; e < t; e++) {
              const t = i[e],
                n = r[e],
                c = a[e],
                u = o[e],
                h = s[e];
              if (void 0 === t) continue;
              let d;
              switch (
                (t.updateMatrix(), (t.matrixAutoUpdate = !0), wd[h.path])
              ) {
                case wd.weights:
                  d = gu;
                  break;
                case wd.rotation:
                  d = yu;
                  break;
                default:
                  d = bu;
              }
              const p = t.name ? t.name : t.uuid,
                m = void 0 !== u.interpolation ? Md[u.interpolation] : Xt,
                f = [];
              wd[h.path] === wd.weights
                ? t.traverse(function (e) {
                    !0 === e.isMesh &&
                      e.morphTargetInfluences &&
                      f.push(e.name ? e.name : e.uuid);
                  })
                : f.push(p);
              let g = c.array;
              if (c.normalized) {
                const e = Nd(g.constructor),
                  t = new Float32Array(g.length);
                for (let n = 0, i = g.length; n < i; n++) t[n] = g[n] * e;
                g = t;
              }
              for (let e = 0, t = f.length; e < t; e++) {
                const t = new d(f[e] + "." + wd[h.path], n.array, g, m);
                "CUBICSPLINE" === u.interpolation &&
                  ((t.createInterpolant = function (e) {
                    return new (this instanceof yu ? cd : sd)(
                      this.times,
                      this.values,
                      this.getValueSize() / 3,
                      e
                    );
                  }),
                  (t.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline =
                    !0)),
                  l.push(t);
              }
            }
            const c = t.name ? t.name : "animation_" + e;
            return new _u(c, void 0, l);
          });
        }
        createNodeMesh(e) {
          const t = this.json,
            n = this,
            i = t.nodes[e];
          return void 0 === i.mesh
            ? null
            : n.getDependency("mesh", i.mesh).then(function (e) {
                const t = n._getNodeRef(n.meshCache, i.mesh, e);
                return (
                  void 0 !== i.weights &&
                    t.traverse(function (e) {
                      if (e.isMesh)
                        for (let t = 0, n = i.weights.length; t < n; t++)
                          e.morphTargetInfluences[t] = i.weights[t];
                    }),
                  t
                );
              });
        }
        loadNode(e) {
          const t = this.json,
            n = this.extensions,
            i = this,
            r = t.nodes[e],
            a = r.name ? i.createUniqueName(r.name) : "";
          return (function () {
            const t = [],
              n = i._invokeOne(function (t) {
                return t.createNodeMesh && t.createNodeMesh(e);
              });
            return (
              n && t.push(n),
              void 0 !== r.camera &&
                t.push(
                  i.getDependency("camera", r.camera).then(function (e) {
                    return i._getNodeRef(i.cameraCache, r.camera, e);
                  })
                ),
              i
                ._invokeAll(function (t) {
                  return t.createNodeAttachment && t.createNodeAttachment(e);
                })
                .forEach(function (e) {
                  t.push(e);
                }),
              Promise.all(t)
            );
          })().then(function (t) {
            let o;
            if (
              ((o =
                !0 === r.isBone
                  ? new Al()
                  : t.length > 1
                  ? new qs()
                  : 1 === t.length
                  ? t[0]
                  : new Bi()),
              o !== t[0])
            )
              for (let e = 0, n = t.length; e < n; e++) o.add(t[e]);
            if (
              (r.name && ((o.userData.name = r.name), (o.name = a)),
              Pd(o, r),
              r.extensions && Ld(n, o, r),
              void 0 !== r.matrix)
            ) {
              const e = new gi();
              e.fromArray(r.matrix), o.applyMatrix4(e);
            } else void 0 !== r.translation && o.position.fromArray(r.translation), void 0 !== r.rotation && o.quaternion.fromArray(r.rotation), void 0 !== r.scale && o.scale.fromArray(r.scale);
            return i.associations.set(o, { type: "nodes", index: e }), o;
          });
        }
        loadScene(e) {
          const t = this.json,
            n = this.extensions,
            i = this.json.scenes[e],
            r = this,
            a = new qs();
          i.name && (a.name = r.createUniqueName(i.name)),
            Pd(a, i),
            i.extensions && Ld(n, a, i);
          const o = i.nodes || [],
            s = [];
          for (let e = 0, n = o.length; e < n; e++) s.push(Od(o[e], a, t, r));
          return Promise.all(s).then(function () {
            return a;
          });
        }
      }
      function Od(e, t, n, i) {
        const r = n.nodes[e];
        return i
          .getDependency("node", e)
          .then(function (e) {
            if (void 0 === r.skin) return e;
            let t;
            return i
              .getDependency("skin", r.skin)
              .then(function (e) {
                t = e;
                const n = [];
                for (let e = 0, r = t.joints.length; e < r; e++)
                  n.push(i.getDependency("node", t.joints[e]));
                return Promise.all(n);
              })
              .then(function (n) {
                return (
                  e.traverse(function (e) {
                    if (!e.isMesh) return;
                    const i = [],
                      r = [];
                    for (let e = 0, a = n.length; e < a; e++) {
                      const a = n[e];
                      if (a) {
                        i.push(a);
                        const n = new gi();
                        void 0 !== t.inverseBindMatrices &&
                          n.fromArray(t.inverseBindMatrices.array, 16 * e),
                          r.push(n);
                      } else
                        console.warn(
                          'THREE.GLTFLoader: Joint "%s" could not be found.',
                          t.joints[e]
                        );
                    }
                    e.bind(new Cl(i, r), e.matrixWorld);
                  }),
                  e
                );
              });
          })
          .then(function (e) {
            t.add(e);
            const a = [];
            if (r.children) {
              const t = r.children;
              for (let r = 0, o = t.length; r < o; r++) {
                const o = t[r];
                a.push(Od(o, e, n, i));
              }
            }
            return Promise.all(a);
          });
      }
      function Fd(e, t, n) {
        const i = t.attributes,
          r = [];
        function a(t, i) {
          return n.getDependency("accessor", t).then(function (t) {
            e.setAttribute(i, t);
          });
        }
        for (const t in i) {
          const n = _d[t] || t.toLowerCase();
          n in e.attributes || r.push(a(i[t], n));
        }
        if (void 0 !== t.indices && !e.index) {
          const i = n.getDependency("accessor", t.indices).then(function (t) {
            e.setIndex(t);
          });
          r.push(i);
        }
        return (
          Pd(e, t),
          (function (e, t, n) {
            const i = t.attributes,
              r = new Gn();
            if (void 0 === i.POSITION) return;
            {
              const e = n.json.accessors[i.POSITION],
                t = e.min,
                a = e.max;
              if (void 0 === t || void 0 === a)
                return void console.warn(
                  "THREE.GLTFLoader: Missing min/max properties for accessor POSITION."
                );
              if (
                (r.set(new zn(t[0], t[1], t[2]), new zn(a[0], a[1], a[2])),
                e.normalized)
              ) {
                const t = Nd(vd[e.componentType]);
                r.min.multiplyScalar(t), r.max.multiplyScalar(t);
              }
            }
            const a = t.targets;
            if (void 0 !== a) {
              const e = new zn(),
                t = new zn();
              for (let i = 0, r = a.length; i < r; i++) {
                const r = a[i];
                if (void 0 !== r.POSITION) {
                  const i = n.json.accessors[r.POSITION],
                    a = i.min,
                    o = i.max;
                  if (void 0 !== a && void 0 !== o) {
                    if (
                      (t.setX(Math.max(Math.abs(a[0]), Math.abs(o[0]))),
                      t.setY(Math.max(Math.abs(a[1]), Math.abs(o[1]))),
                      t.setZ(Math.max(Math.abs(a[2]), Math.abs(o[2]))),
                      i.normalized)
                    ) {
                      const e = Nd(vd[i.componentType]);
                      t.multiplyScalar(e);
                    }
                    e.max(t);
                  } else
                    console.warn(
                      "THREE.GLTFLoader: Missing min/max properties for accessor POSITION."
                    );
                }
              }
              r.expandByVector(e);
            }
            e.boundingBox = r;
            const o = new si();
            r.getCenter(o.center),
              (o.radius = r.min.distanceTo(r.max) / 2),
              (e.boundingSphere = o);
          })(e, t, n),
          Promise.all(r).then(function () {
            return void 0 !== t.targets
              ? (function (e, t, n) {
                  let i = !1,
                    r = !1;
                  for (let e = 0, n = t.length; e < n; e++) {
                    const n = t[e];
                    if (
                      (void 0 !== n.POSITION && (i = !0),
                      void 0 !== n.NORMAL && (r = !0),
                      i && r)
                    )
                      break;
                  }
                  if (!i && !r) return Promise.resolve(e);
                  const a = [],
                    o = [];
                  for (let s = 0, l = t.length; s < l; s++) {
                    const l = t[s];
                    if (i) {
                      const t =
                        void 0 !== l.POSITION
                          ? n.getDependency("accessor", l.POSITION)
                          : e.attributes.position;
                      a.push(t);
                    }
                    if (r) {
                      const t =
                        void 0 !== l.NORMAL
                          ? n.getDependency("accessor", l.NORMAL)
                          : e.attributes.normal;
                      o.push(t);
                    }
                  }
                  return Promise.all([Promise.all(a), Promise.all(o)]).then(
                    function (t) {
                      const n = t[0],
                        a = t[1];
                      return (
                        i && (e.morphAttributes.position = n),
                        r && (e.morphAttributes.normal = a),
                        (e.morphTargetsRelative = !0),
                        e
                      );
                    }
                  );
                })(e, t.targets, n)
              : e;
          })
        );
      }
      function kd(e, t) {
        let n = e.getIndex();
        if (null === n) {
          const t = [],
            i = e.getAttribute("position");
          if (void 0 === i)
            return (
              console.error(
                "THREE.GLTFLoader.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."
              ),
              e
            );
          for (let e = 0; e < i.count; e++) t.push(e);
          e.setIndex(t), (n = e.getIndex());
        }
        const i = n.count - 2,
          r = [];
        if (t === Qt)
          for (let e = 1; e <= i; e++)
            r.push(n.getX(0)), r.push(n.getX(e)), r.push(n.getX(e + 1));
        else
          for (let e = 0; e < i; e++)
            e % 2 == 0
              ? (r.push(n.getX(e)),
                r.push(n.getX(e + 1)),
                r.push(n.getX(e + 2)))
              : (r.push(n.getX(e + 2)),
                r.push(n.getX(e + 1)),
                r.push(n.getX(e)));
        r.length / 3 !== i &&
          console.error(
            "THREE.GLTFLoader.toTrianglesDrawMode(): Unable to generate correct amount of triangles."
          );
        const a = e.clone();
        return a.setIndex(r), a;
      }
      class Hd extends Cu {
        constructor(e) {
          super(e), (this.type = Ue);
        }
        parse(e) {
          const t = function (e, t) {
              switch (e) {
                case 1:
                  console.error("THREE.RGBELoader Read Error: " + (t || ""));
                  break;
                case 2:
                  console.error("THREE.RGBELoader Write Error: " + (t || ""));
                  break;
                case 3:
                  console.error(
                    "THREE.RGBELoader Bad File Format: " + (t || "")
                  );
                  break;
                default:
                  console.error("THREE.RGBELoader: Error: " + (t || ""));
              }
              return -1;
            },
            n = function (e, t, n) {
              t = t || 1024;
              let i = e.pos,
                r = -1,
                a = 0,
                o = "",
                s = String.fromCharCode.apply(
                  null,
                  new Uint16Array(e.subarray(i, i + 128))
                );
              for (; 0 > (r = s.indexOf("\n")) && a < t && i < e.byteLength; )
                (o += s),
                  (a += s.length),
                  (i += 128),
                  (s += String.fromCharCode.apply(
                    null,
                    new Uint16Array(e.subarray(i, i + 128))
                  ));
              return (
                -1 < r && (!1 !== n && (e.pos += a + r + 1), o + s.slice(0, r))
              );
            },
            i = function (e, t, n, i) {
              const r = e[t + 3],
                a = Math.pow(2, r - 128) / 255;
              (n[i + 0] = e[t + 0] * a),
                (n[i + 1] = e[t + 1] * a),
                (n[i + 2] = e[t + 2] * a);
            },
            r = function (e, t, n, i) {
              const r = e[t + 3],
                a = Math.pow(2, r - 128) / 255;
              (n[i + 0] = Dh.toHalfFloat(e[t + 0] * a)),
                (n[i + 1] = Dh.toHalfFloat(e[t + 1] * a)),
                (n[i + 2] = Dh.toHalfFloat(e[t + 2] * a));
            },
            a = new Uint8Array(e);
          a.pos = 0;
          const o = (function (e) {
            const i = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/,
              r = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/,
              a = /^\s*FORMAT=(\S+)\s*$/,
              o = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/,
              s = {
                valid: 0,
                string: "",
                comments: "",
                programtype: "RGBE",
                format: "",
                gamma: 1,
                exposure: 1,
                width: 0,
                height: 0,
              };
            let l, c;
            if (e.pos >= e.byteLength || !(l = n(e)))
              return t(1, "no header found");
            if (!(c = l.match(/^#\?(\S+)/))) return t(3, "bad initial token");
            for (
              s.valid |= 1, s.programtype = c[1], s.string += l + "\n";
              (l = n(e)), !1 !== l;

            )
              if (((s.string += l + "\n"), "#" !== l.charAt(0))) {
                if (
                  ((c = l.match(i)) && (s.gamma = parseFloat(c[1], 10)),
                  (c = l.match(r)) && (s.exposure = parseFloat(c[1], 10)),
                  (c = l.match(a)) && ((s.valid |= 2), (s.format = c[1])),
                  (c = l.match(o)) &&
                    ((s.valid |= 4),
                    (s.height = parseInt(c[1], 10)),
                    (s.width = parseInt(c[2], 10))),
                  2 & s.valid && 4 & s.valid)
                )
                  break;
              } else s.comments += l + "\n";
            return 2 & s.valid
              ? 4 & s.valid
                ? s
                : t(3, "missing image size specifier")
              : t(3, "missing format specifier");
          })(a);
          if (-1 !== o) {
            const e = o.width,
              n = o.height,
              s = (function (e, n, i) {
                const r = n;
                if (
                  r < 8 ||
                  r > 32767 ||
                  2 !== e[0] ||
                  2 !== e[1] ||
                  128 & e[2]
                )
                  return new Uint8Array(e);
                if (r !== ((e[2] << 8) | e[3]))
                  return t(3, "wrong scanline width");
                const a = new Uint8Array(4 * n * i);
                if (!a.length) return t(4, "unable to allocate buffer space");
                let o = 0,
                  s = 0;
                const l = 4 * r,
                  c = new Uint8Array(4),
                  u = new Uint8Array(l);
                let h = i;
                for (; h > 0 && s < e.byteLength; ) {
                  if (s + 4 > e.byteLength) return t(1);
                  if (
                    ((c[0] = e[s++]),
                    (c[1] = e[s++]),
                    (c[2] = e[s++]),
                    (c[3] = e[s++]),
                    2 != c[0] || 2 != c[1] || ((c[2] << 8) | c[3]) != r)
                  )
                    return t(3, "bad rgbe scanline format");
                  let n,
                    i = 0;
                  for (; i < l && s < e.byteLength; ) {
                    n = e[s++];
                    const r = n > 128;
                    if ((r && (n -= 128), 0 === n || i + n > l))
                      return t(3, "bad scanline data");
                    if (r) {
                      const t = e[s++];
                      for (let e = 0; e < n; e++) u[i++] = t;
                    } else u.set(e.subarray(s, s + n), i), (i += n), (s += n);
                  }
                  const d = r;
                  for (let e = 0; e < d; e++) {
                    let t = 0;
                    (a[o] = u[e + t]),
                      (t += r),
                      (a[o + 1] = u[e + t]),
                      (t += r),
                      (a[o + 2] = u[e + t]),
                      (t += r),
                      (a[o + 3] = u[e + t]),
                      (o += 4);
                  }
                  h--;
                }
                return a;
              })(a.subarray(a.pos), e, n);
            if (-1 !== s) {
              let t, a, l, c;
              switch (this.type) {
                case Ne:
                  (t = s), (a = Ze), (l = Ne);
                  break;
                case ze:
                  c = s.length / 4;
                  const e = new Float32Array(3 * c);
                  for (let t = 0; t < c; t++) i(s, 4 * t, e, 3 * t);
                  (t = e), (a = Xe), (l = ze);
                  break;
                case Ue:
                  c = s.length / 4;
                  const n = new Uint16Array(3 * c);
                  for (let e = 0; e < c; e++) r(s, 4 * e, n, 3 * e);
                  (t = n), (a = Xe), (l = Ue);
                  break;
                default:
                  console.error(
                    "THREE.RGBELoader: unsupported type: ",
                    this.type
                  );
              }
              return {
                width: e,
                height: n,
                data: t,
                header: o.string,
                gamma: o.gamma,
                exposure: o.exposure,
                format: a,
                type: l,
              };
            }
          }
          return null;
        }
        setDataType(e) {
          return (this.type = e), this;
        }
        load(e, t, n, i) {
          return super.load(
            e,
            function (e, n) {
              switch (e.type) {
                case Ne:
                  (e.encoding = nn),
                    (e.minFilter = Ae),
                    (e.magFilter = Ae),
                    (e.generateMipmaps = !1),
                    (e.flipY = !0);
                  break;
                case ze:
                case Ue:
                  (e.encoding = $t),
                    (e.minFilter = Re),
                    (e.magFilter = Re),
                    (e.generateMipmaps = !1),
                    (e.flipY = !0);
              }
              t && t(e, n);
            },
            n,
            i
          );
        }
      }
      function zd(e) {
        return (
          (zd =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          zd(e)
        );
      }
      function Ud(e) {
        return (
          (function (e) {
            if (Array.isArray(e)) return Bd(e);
          })(e) ||
          (function (e) {
            if (
              ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
              null != e["@@iterator"]
            )
              return Array.from(e);
          })(e) ||
          (function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return Bd(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(e);
            if (
              "Arguments" === n ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return Bd(e, t);
          })(e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function Bd(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      function Gd(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          t &&
            (i = i.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, i);
        }
        return n;
      }
      function Vd(e, t, n) {
        return (
          (t = jd(t)) in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      function Wd(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(e, jd(i.key), i);
        }
      }
      function jd(e) {
        var t = (function (e, t) {
          if ("object" !== zd(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var i = n.call(e, t || "default");
            if ("object" !== zd(i)) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        })(e, "string");
        return "symbol" === zd(t) ? t : String(t);
      }
      var Xd = (function () {
        function e() {
          if (
            ((function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e),
            (this.adapters = []),
            Object.prototype.hasOwnProperty.call(e, "$singleton"))
          )
            return e.$s;
          Object.defineProperty(e, "$singleton", {
            value: this,
            enumerable: !1,
            writable: !1,
            configurable: !1,
          });
        }
        var t, n, i;
        return (
          (t = e),
          (n = [
            {
              key: "addAdapter",
              value: function (e) {
                return (
                  this.adapters.push(
                    (function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2
                          ? Gd(Object(n), !0).forEach(function (t) {
                              Vd(e, t, n[t]);
                            })
                          : Object.getOwnPropertyDescriptors
                          ? Object.defineProperties(
                              e,
                              Object.getOwnPropertyDescriptors(n)
                            )
                          : Gd(Object(n)).forEach(function (t) {
                              Object.defineProperty(
                                e,
                                t,
                                Object.getOwnPropertyDescriptor(n, t)
                              );
                            });
                      }
                      return e;
                    })({}, e)
                  ),
                  this
                );
              },
            },
            {
              key: "broadcast",
              value: function () {
                this._handleBroadcast.apply(this, arguments);
              },
            },
            {
              key: "_handleBroadcast",
              value: function () {
                var e = arguments;
                this.adapters.forEach(function (t) {
                  return t.emit(t.remap.apply(t, Ud(e)));
                });
              },
            },
            {
              key: "logger",
              value: function () {
                this._handleLogger.apply(this, arguments);
              },
            },
            {
              key: "_handleLogger",
              value: function () {
                this.adapters.forEach(function (e) {});
              },
            },
          ]),
          n && Wd(t.prototype, n),
          i && Wd(t, i),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function qd(e) {
        return (
          (qd =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          qd(e)
        );
      }
      function Yd(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          t &&
            (i = i.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, i);
        }
        return n;
      }
      function Kd(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Yd(Object(n), !0).forEach(function (t) {
                Zd(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Yd(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function Zd(e, t, n) {
        return (
          (t = (function (e) {
            var t = (function (e, t) {
              if ("object" !== qd(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 !== n) {
                var i = n.call(e, t || "default");
                if ("object" !== qd(i)) return i;
                throw new TypeError(
                  "@@toPrimitive must return a primitive value."
                );
              }
              return ("string" === t ? String : Number)(e);
            })(e, "string");
            return "symbol" === qd(t) ? t : String(t);
          })(t)) in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      var Jd = new Date().getTime(),
        Qd = {
          remap: function () {
            var e = ""
                .concat(arguments.length <= 0 ? void 0 : arguments[0], ":")
                .concat(arguments.length <= 1 ? void 0 : arguments[1]),
              t = arguments.length <= 2 ? void 0 : arguments[2],
              n = new Date().getTime(),
              i = n - Jd;
            return (Jd = n), { key: e, time: n, diff: i, payload: t };
          },
          emit: function (e) {
            var t = new CustomEvent("3dpv:event", { detail: Kd({}, e) });
            window.dispatchEvent(t);
          },
          log: function (e) {
            console.log("Apple360Spin :: ".concat(e));
          },
        };
      const $d = new Xd().addAdapter(Qd);
      function ep(e) {
        return (
          (ep =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          ep(e)
        );
      }
      function tp(e, t) {
        for (var n = 0; n < t.length; n++) {
          var i = t[n];
          (i.enumerable = i.enumerable || !1),
            (i.configurable = !0),
            "value" in i && (i.writable = !0),
            Object.defineProperty(
              e,
              ((r = i.key),
              (a = void 0),
              (a = (function (e, t) {
                if ("object" !== ep(e) || null === e) return e;
                var n = e[Symbol.toPrimitive];
                if (void 0 !== n) {
                  var i = n.call(e, t || "default");
                  if ("object" !== ep(i)) return i;
                  throw new TypeError(
                    "@@toPrimitive must return a primitive value."
                  );
                }
                return ("string" === t ? String : Number)(e);
              })(r, "string")),
              "symbol" === ep(a) ? a : String(a)),
              i
            );
        }
        var r, a;
      }
      var np = (function () {
        function e(t) {
          return (
            (function (e, t) {
              if (!(e instanceof t))
                throw new TypeError("Cannot call a class as a function");
            })(this, e),
            Object.prototype.hasOwnProperty.call(e, "$s") ||
              (Object.defineProperty(e, "$s", {
                value: this,
                enumerable: !1,
                writable: !1,
                configurable: !1,
              }),
              e.$s.create(t),
              e.$s.update()),
            e.$s
          );
        }
        var t, n, i;
        return (
          (t = e),
          (n = [
            {
              key: "create",
              value: function (e) {
                (this.camera = e.camera),
                  (this.clampBy = 15),
                  (this.x = 0),
                  (this.y = 0),
                  (this.cX = 0),
                  (this.cY = 0),
                  (this.pX = 0),
                  (this.pY = 0),
                  (this.cpX = 0),
                  (this.xpY = 0);
              },
            },
            {
              key: "update",
              value: function () {
                var e = new zn();
                this.camera.getWorldDirection(e),
                  (this.x = An.radToDeg(Math.atan2(e.x, e.z))),
                  (this.y = An.radToDeg(Math.atan2(e.y, e.z))),
                  (this.cX = this.getClampedCoordinate(this.x)),
                  (this.cY = this.getClampedCoordinate(this.y)),
                  this.checkForChanges(),
                  this.emitAngleChange();
              },
            },
            {
              key: "checkForChanges",
              value: function () {
                (this.x === this.pX && this.y === this.pY) ||
                  ((this.dirX = this.x - this.pX < 0 ? 1 : -1),
                  (this.dirY = this.y - this.pY < 0 ? 1 : -1),
                  (this.pX = this.x),
                  (this.pY = this.y));
              },
            },
            {
              key: "onAngleChanged",
              value: function () {
                $d.logger(
                  "Voiceover Coordinates: "
                    .concat(this.dirX, ", ")
                    .concat(this.cX, ", ")
                    .concat(this.dirX, ", ")
                    .concat(this.cY)
                );
                var e = document.getElementById(
                  "channel-3d-product-viewer-canvas-container"
                );
                e &&
                  e.setAttribute(
                    "aria-label",
                    "iPhone at "
                      .concat(this.cX, " degrees by ")
                      .concat(this.cY, " degrees")
                  );
              },
            },
            {
              key: "emitAngleChange",
              value: function () {
                (this.cX === this.cpX && this.cY === this.cpY) ||
                  (this.onAngleChanged(),
                  (this.cpX = this.cX),
                  (this.cpY = this.cY));
              },
            },
            {
              key: "getClampedCoordinate",
              value: function (e) {
                return 0 === e
                  ? e
                  : Math.round(e / this.clampBy) * this.clampBy;
              },
            },
          ]),
          n && tp(t.prototype, n),
          i && tp(t, i),
          Object.defineProperty(t, "prototype", { writable: !1 }),
          e
        );
      })();
      function ip(e, t) {
        var n =
          ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
          e["@@iterator"];
        if (!n) {
          if (
            Array.isArray(e) ||
            (n = (function (e, t) {
              if (!e) return;
              if ("string" == typeof e) return rp(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              "Object" === n && e.constructor && (n = e.constructor.name);
              if ("Map" === n || "Set" === n) return Array.from(e);
              if (
                "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              )
                return rp(e, t);
            })(e)) ||
            (t && e && "number" == typeof e.length)
          ) {
            n && (e = n);
            var i = 0,
              r = function () {};
            return {
              s: r,
              n: function () {
                return i >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[i++] };
              },
              e: function (e) {
                throw e;
              },
              f: r,
            };
          }
          throw new TypeError(
            "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        }
        var a,
          o = !0,
          s = !1;
        return {
          s: function () {
            n = n.call(e);
          },
          n: function () {
            var e = n.next();
            return (o = e.done), e;
          },
          e: function (e) {
            (s = !0), (a = e);
          },
          f: function () {
            try {
              o || null == n.return || n.return();
            } finally {
              if (s) throw a;
            }
          },
        };
      }
      function rp(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      var ap = 16;
      function op(e, t, n, i, r, a) {
        var o = this,
          s = {},
          l = !1,
          c = !1;
        (this.initializing = !1),
          (this.loaded = !1),
          (this.shouldModelRender = !0),
          (this.paused = !1),
          (this.scene = null),
          (this.camera = null),
          (this.renderer = null),
          (this.controls = null),
          (this.changeVector = new Hn()),
          (this.renderFPS = ap),
          (this.progressIndicator = n),
          (this.keyControlDistance = i || 15),
          (this.pathTextures = r || "/textures"),
          (this.pathModels = a || "/models"),
          (this.toneMappingOptions = {
            None: de,
            Linear: pe,
            Reinhard: me,
            Cineon: fe,
            ACESFilmic: ge,
            Custom: ve,
          }),
          $d.broadcast("load", "start", { event: this.changeVector }),
          (this.constructScene = function (t) {
            $d.logger("Initializing Product Viewer Environment..."),
              (o.initializing = !0),
              (o.scene = new tl()),
              (o.camera = new Kr(45, e.clientWidth / e.clientHeight, 1, 1e3)),
              o.camera.position.set(
                (null == t ? void 0 : t.x) || 0,
                (null == t ? void 0 : t.y) || 0,
                (null == t ? void 0 : t.z) || 30
              );
          }),
          (this.renderScene = function (t, n, i, r, a) {
            $d.logger("Rendering Scene"),
              (o.renderer = new Qs({ antialias: !0 })),
              o.renderer.setPixelRatio(window.devicePixelRatio),
              o.renderer.setSize(e.clientWidth, e.clientHeight),
              o.renderer.setClearColor(16777215, 1),
              (o.renderer.toneMapping = o.toneMappingOptions[i]),
              (o.renderer.toneMappingExposure = r),
              (o.renderer.outputEncoding = en),
              o.renderer.domElement.classList.add(
                "channel-3d-product-viewer_canvas"
              ),
              (o.renderer.domElement.tabIndex = 0),
              o.renderer.domElement.setAttribute("role", "img"),
              o.renderer.domElement.setAttribute(
                "aria-label",
                "3D view for ".concat(a)
              ),
              o.renderer.domElement.setAttribute(
                "aria-description",
                "Drag to rotate"
              ),
              e.appendChild(o.renderer.domElement);
            var s = new ka(o.renderer);
            s.compileEquirectangularShader(),
              $d.logger(
                "LOADING IBL FILE: "
                  .concat(o.pathTextures)
                  .concat(t || "ibl.hdr")
              ),
              new Hd().setPath(o.pathTextures).load(
                t || "ibl.hdr",
                function (e) {
                  var t = this;
                  $d.logger("IBL File Loaded");
                  var i = s.fromEquirectangular(e).texture;
                  (this.scene.environment = i),
                    e.dispose(),
                    s.dispose(),
                    n &&
                      this.loadModel(n, function () {
                        t.progressIndicator.classList.contains("visible") &&
                          (t.progressIndicator.classList.remove("visible"),
                          $d.logger(
                            "Hiding Progress Indicator from loadModel"
                          )),
                          $d.logger("Scene Rendered");
                      });
                }.bind(o),
                void 0,
                function () {
                  $d.logger(
                    "ERROR FINDING IBL FILE: "
                      .concat(this.pathTextures)
                      .concat(t || "ibl.hdr")
                  );
                }.bind(o)
              );
          }),
          (this.loadModel = function (n, i) {
            var r,
              a =
                arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            Object.prototype.hasOwnProperty.call(s, n)
              ? (!a && $d.logger("LOADING MODEL FROM CACHE: ".concat(n)),
                null === (r = o.scene) || void 0 === r || r.add(s[n].clone()),
                u(n, i, a))
              : ($d.logger(
                  "LOADING NEW MODEL: ".concat(o.pathModels).concat(n)
                ),
                o.progressIndicator.classList.contains("visible") ||
                  (o.progressIndicator.classList.add("visible"),
                  $d.logger("Displaying Progress Indicator from loadModel")),
                new zh().setPath(o.pathModels).load(
                  n,
                  function (r) {
                    this.initializing &&
                      ($d.logger("Initial Load Detected"),
                      (this.initializing = !1));
                    var a,
                      o = r.scene;
                    ((s[n] = o), this.shouldModelRender)
                      ? (null === (a = this.scene) || void 0 === a || a.add(o),
                        this.loaded ||
                          (this.onWindowResize(),
                          (this.loaded = !0),
                          e.classList.add("channel-3d-product-viewer_fade-in"),
                          t.classList.add("channel-3d-product-viewer_fade-up")),
                        $d.logger("Model Loaded"),
                        u(n, i))
                      : ((this.shouldModelRender = !0), i && i());
                  }.bind(o),
                  void 0,
                  function () {
                    var e = this;
                    $d.logger(
                      "ERROR FINDING MODEL FILE: "
                        .concat(this.pathModels)
                        .concat(n)
                    ),
                      setTimeout(function () {
                        $d.logger("Trying Again..."), e.loadModel(n, i);
                      }, 5e3);
                  }.bind(o)
                ));
          });
        var u = function (t, n, i) {
          (e.dataset.asset = t),
            !i && $d.logger("Rendering After Load"),
            o.render(),
            !i && $d.logger("Model Rendered"),
            n && n();
        };
        (this.addControls = function (e, t, n) {
          $d.logger("Adding ThreeJS Controls"),
            (o.controls = new Hh(o.camera, o.renderer.domElement)),
            o.controls.addEventListener(
              "change",
              o.requestRenderIfNotRequested
            ),
            o.controls.addEventListener("change", o.trackOrbit),
            o.controls.addEventListener("start", o.startOrbit),
            o.controls.addEventListener("end", o.endOrbit),
            (o.voiceover = new np({ camera: o.camera })),
            (o.controls.minDistance = e || 6),
            (o.controls.maxDistance = t || 30),
            (o.controls.enableDamping = !0),
            (o.controls.dampingFactor = n || 0.35),
            (o.controls.enablePan = !1),
            o.controls.saveState(),
            o.controls.update();
        }),
          (this.handleAutoRotate = function (e, t) {
            (o.controls.autoRotate = e),
              e &&
                ($d.logger("Auto Rotate Detected"),
                (o.renderFPS = 33),
                (o.controls.autoRotateSpeed = t || -5)),
              o.controls.update();
          }),
          (this.pause = function (e) {
            o.paused = e;
          }),
          (this.render = function () {
            o.paused ||
              ((c = !1),
              (e.dataset.coordinates = "{\n      x: "
                .concat(o.camera.position.x.toFixed(2), ",\n      y: ")
                .concat(o.camera.position.y.toFixed(2), ",\n      z: ")
                .concat(o.camera.position.z.toFixed(2), "\n    }")),
              o.controls.update(),
              o.renderer.render(o.scene, o.camera));
          }),
          (this.trackOrbit = function () {
            o.camera.getWorldQuaternion(o.changeVector), o.voiceover.update();
          }),
          (this.startOrbit = function () {
            $d.broadcast("click", "start-rotation", { event: o.changeVector });
          }),
          (this.endOrbit = function () {
            $d.broadcast("click", "end-rotation", { event: o.changeVector });
          }),
          (this.requestRenderIfNotRequested = function () {
            c ||
              ((c = !0),
              setTimeout(function () {
                requestAnimationFrame(o.render);
              }, o.renderFPS));
          }),
          (this.onWindowResize = function (t) {
            t &&
              (o.progressIndicator.classList.contains("visible") ||
                (o.progressIndicator.classList.add("visible"),
                $d.logger(
                  "Displaying Progress Indicator from onWindowResize showSpinner: ".concat(
                    t
                  )
                ))),
              (o.renderer.domElement.style.display = "none"),
              l && clearTimeout(l),
              (l = setTimeout(function () {
                (o.camera.aspect = e.clientWidth / e.clientHeight),
                  o.camera.updateProjectionMatrix(),
                  o.renderer.setSize(e.clientWidth, e.clientHeight),
                  o.render(),
                  t &&
                    o.progressIndicator.classList.contains("visible") &&
                    (o.progressIndicator.classList.remove("visible"),
                    $d.logger(
                      "Hiding Progress Indicator from onWindowResize showSpinner: ".concat(
                        t
                      )
                    )),
                  (o.renderer.domElement.style.display = "block");
              }, 500));
          });
        var h = function (e, t) {
            return Math.round(e / t) * t + t;
          },
          d = function (e) {
            var t = o.camera.position,
              n = (t.z < 0 ? -1 : 1) * e;
            Math.round(t.x) == -30 * n
              ? (t.setZ(-1 * t.z), t.setX(h(t.x, n * o.keyControlDistance)))
              : t.setX(h(t.x, n * -o.keyControlDistance));
          };
        (this.handleKeyDown = function (e) {
          var t = e.key,
            n = o.camera.position,
            i = !0;
          switch (t) {
            case "ArrowUp":
              n.setY(h(n.y, -o.keyControlDistance));
              break;
            case "ArrowDown":
              n.setY(h(n.y, o.keyControlDistance));
              break;
            case "ArrowRight":
              d(1);
              break;
            case "ArrowLeft":
              d(-1);
              break;
            default:
              i = !1;
          }
          if (i) {
            var r = document.querySelector(".channel-3d-product-viewer_prompt");
            null == r ||
              r.classList.remove("channel-3d-product-viewer_fade-in"),
              null == r ||
                r.classList.add("channel-3d-product-viewer_fade-out"),
              o.camera.updateProjectionMatrix(),
              o.controls.update(),
              o.voiceover.update();
          }
        }),
          (this.reset = function (e, t, n) {
            $d.logger("Resetting Modal...");
            var i = o.scene.getObjectByName("Scene");
            o.scene.remove(i),
              o.loadModel(e.modelFileData[t].filename, null, !0),
              o.controls.reset(),
              n && n(),
              $d.logger("Modal Reset");
          }),
          (this.destroy = function () {
            (o.initializing = !1),
              (o.loaded = !1),
              (o.shouldModelRender = !0),
              (c = !1),
              (o.scene = null),
              (o.camera = null),
              (o.renderer = null),
              (o.controls = null);
            var e,
              t = ip(Object.getOwnPropertyNames(s));
            try {
              for (t.s(); !(e = t.n()).done; ) {
                var n = e.value;
                delete s[n];
              }
            } catch (e) {
              t.e(e);
            } finally {
              t.f();
            }
          });
      }
      var sp = n(8010),
        lp = n.n(sp),
        cp = n(44),
        up = n.n(cp),
        hp = n(4472);
      const dp = {
        PageOverlay: { ClassNames: ["modal-page-overlay"] },
        FullBleed: { ClassNames: ["modal-full-bleed"] },
        Open: {
          Document: { ClassNames: ["has-modal"] },
          Container: { ClassNames: ["modal-open"] },
        },
        Close: { Selector: "[data-modal-close]" },
        Elements: {
          container: {
            Attributes: { class: "modal" },
            Template:
              '<div class="modal" data-modal-element-container data-modal-close>\n\t<div class="modal-overlay-container" data-modal-element-overlay-container data-modal-close>\n\t\t<div class="modal-overlay" data-modal-element-overlay data-modal-close-button-parent>\n\t\t\t<div class="modal-content-container" data-modal-element-content-container></div>\n\t\t</div>\n\t</div>\n</div>',
          },
          contentContainer: {
            Selector: "[data-modal-element-content-container]",
          },
          closeButton: {
            Attributes: {
              class: "modal-close-button",
              "data-modal-close": "",
              "aria-label": "Close",
            },
            ParentSelector: "[data-modal-close-button-parent]",
            Template:
              '<button data-modal-element-close-button>\n\t<span data-modal-element-close-icon><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.12,10l4.07-4.06a1.5,1.5,0,1,0-2.11-2.12L10,7.88,5.94,3.81A1.5,1.5,0,1,0,3.82,5.93L7.88,10,3.81,14.06a1.5,1.5,0,0,0,0,2.12,1.51,1.51,0,0,0,2.13,0L10,12.12l4.06,4.07a1.45,1.45,0,0,0,1.06.44,1.5,1.5,0,0,0,1.06-2.56Z"/></svg></span>\n</button>',
          },
          closeIcon: {
            Attributes: { class: "modal-close-icon", "data-modal-close": "" },
          },
        },
        DialogRole: {
          Selector: "[data-modal-element-overlay]",
          Attributes: {
            "aria-modal": "true",
            role: "dialog",
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        Keyboard: { close: { keys: [n.n(hp)().ESCAPE] }, open: { keys: [] } },
        Events: {
          CONTENT_APPENDED: "contentappended",
          RENDERED: "rendered",
          WILLOPEN: "willopen",
          OPEN: "open",
          WILLCLOSE: "willclose",
          CLOSE: "close",
          CONTENT_REMOVED: "contentremoved",
        },
      };
      var pp = n(9946),
        mp = n.n(pp);
      const fp = {
          beforeCreate() {
            document.body._animInfo
              ? ((this.anim = document.body._animInfo.group.anim),
                this._setViewport(this.anim.model.pageMetrics))
              : ((this.viewportEmitterMicro = new (mp())()),
                (this.viewportEmitterMicro.CHANGE_EVENTS = mp().CHANGE_EVENTS),
                this._setViewport(this.viewportEmitterMicro));
          },
          onBreakpointChange(e) {
            this._setViewport(e), this._setPreviousViewport(e);
          },
          onOpen() {
            this.opened = !0;
          },
          onClose() {
            this.opened = !1;
          },
          _setViewport(e) {
            this._viewport = this.anim
              ? this._getValidViewport(e.breakpoint)
              : this._getValidViewport(e.viewport);
          },
          _setPreviousViewport(e) {
            this._previousViewport = this.anim
              ? this._getValidViewport(e.previousBreakpoint)
              : this._getValidViewport(e.oldViewport);
          },
          _getValidViewport(e) {
            const t = { X: "L", L: "L", M: "M", S: "S" };
            if (!Object.keys(t).includes(e))
              throw `The viewport ${e} is not valid. Valid viewports are: ${Object.keys(
                t
              )}`;
            return t[e] || "";
          },
        },
        gp = {
          created() {
            this._createModalElements();
          },
          beforeMount() {
            this._setDialogAriaLabel(), this.appendModalElements();
          },
          destroy() {
            document.body.removeChild(this.elements.container),
              this._releaseEvents();
            for (let e in this)
              Object.prototype.hasOwnProperty.call(this, e) && (this[e] = null);
          },
          getModalElementKey(e) {
            let t;
            for (const n in e.dataset)
              if (n.includes("modalElement")) {
                const e = n.substring("modalElement".length);
                t = e[0].toLowerCase() + e.slice(1);
              }
            return t;
          },
          appendContentElement() {
            this.appendContent(
              this.elements.content,
              this.elements.contentContainer
            ),
              this.trigger(this.model.Events.CONTENT_APPENDED);
          },
          appendModalElements() {
            document.body.appendChild(this.elements.container),
              this.trigger(this.model.Events.RENDERED);
          },
          _createModalElements() {
            this._createTemplates(), this._createElementsFromTemplate();
            for (const e in this.templates)
              this._setChildElements(this.elements[e]);
            this._setDialogRoleElement(),
              this._setElementAttributes(),
              this.appendContentElement();
          },
          _createTemplates() {
            for (const e in this.model.Elements) {
              const t = this.model.Elements[e].Template;
              t && !this.templates[e] && (this.templates[e] = t);
            }
          },
          _createElementsFromTemplate() {
            for (const e in this.templates)
              this.elements[e] = new DOMParser().parseFromString(
                this.templates[e],
                "text/html"
              ).body.childNodes[0];
          },
          _setChildElements(e) {
            [...e.children].forEach((e) => {
              this.getModalElementKey(e) &&
                (this.elements[this.getModalElementKey(e)] = e),
                this._setChildElements(e);
            });
          },
          _setDialogRoleElement() {
            this.dialogRoleElement ||
              (this.dialogRoleElement =
                this.elements.container.querySelector(
                  this.model.DialogRole.Selector
                ) || this.elements.container);
            for (const e in this.model.DialogRole.Attributes)
              this.dialogRoleElement.setAttribute(
                e,
                this.model.DialogRole.Attributes[e]
              );
          },
          _setElementAttributes() {
            let e = {},
              t = {};
            for (const t in this.model.Elements)
              this.model.Elements[t].Attributes &&
                (e[t] = this.model.Elements[t].Attributes);
            for (const n in e) {
              t[n] = Object.assign({}, e[n], this.options.attributes[n]);
              for (const n in this.options.attributes)
                "undefined" !== t[n] &&
                  (t[n] = Object.assign({}, e[n], this.options.attributes[n]));
            }
            for (const e in t)
              for (const n in t[e]) {
                let i = t[e][n];
                if (!this.elements[e]) return;
                if ("class" === n)
                  Array.isArray(i) && (i = i.join(" ")),
                    (this.elements[e].className =
                      `${this.elements[e].className} ${i}`.trim());
                else this.elements[e].setAttribute(n, i);
              }
          },
          _setDialogAriaLabel() {
            if (
              this.elements.content &&
              this.elements.content.dataset.modalDialogLabel
            ) {
              let e = this.elements.content.dataset.modalDialogLabel;
              this.dialogRoleElement.setAttribute("aria-label", e);
            } else
              this.dialogRoleElement.hasAttribute("aria-label") ||
                this.dialogRoleElement.hasAttribute("aria-labelledby") ||
                this.dialogRoleElement.setAttribute("aria-label", "Modal");
          },
        },
        vp = {
          created() {
            this.options.gum ||
              this._isVue ||
              (this.anim
                ? (this.anim.on(
                    this.anim.model.PageEvents.ON_RESIZE_IMMEDIATE,
                    this.onResizeImmediate
                  ),
                  this.anim.on(
                    this.anim.model.PageEvents.ON_RESIZE_DEBOUNCED,
                    this.onResizeDebounced
                  ),
                  this.anim.on(
                    this.anim.model.PageEvents.ON_BREAKPOINT_CHANGE,
                    this.onBreakpointChange
                  ))
                : (window.addEventListener("resize", this.onResizeImmediate),
                  this.viewportEmitterMicro.on(
                    this.viewportEmitterMicro.CHANGE_EVENTS.VIEWPORT,
                    this.onBreakpointChange
                  )),
              (this._mountedRaf = requestAnimationFrame(this.mounted)));
          },
          onResizeImmediate() {
            this.anim ||
              (window.clearTimeout(this._resizeTimeout),
              (this._resizeTimeout = window.setTimeout(
                this.onResizeDebounced,
                250
              )));
          },
          destroy() {
            cancelAnimationFrame(this._mountedRaf),
              this.anim
                ? (this.anim.off(
                    this.anim.model.PageEvents.ON_RESIZE_IMMEDIATE,
                    this.onResizeImmediate
                  ),
                  this.anim.off(
                    this.anim.model.PageEvents.ON_RESIZE_DEBOUNCED,
                    this.onResizeDebounced
                  ),
                  this.anim.off(
                    this.anim.model.PageEvents.ON_BREAKPOINT_CHANGE,
                    this.onBreakpointChange
                  ))
                : (window.removeEventListener("resize", this.onResizeImmediate),
                  this.viewportEmitterMicro.off(
                    this.viewportEmitterMicro.CHANGE_EVENTS.VIEWPORT,
                    this.onBreakpointChange
                  ));
          },
        },
        yp = [
          "beforeCreate",
          "created",
          "beforeMount",
          "mounted",
          "onWillOpen",
          "onOpen",
          "onWillClose",
          "onClose",
          "onResizeImmediate",
          "onBreakpointChange",
          "onResizeDebounced",
          "destroy",
        ],
        xp = { attributes: {} };
      class bp extends lp() {
        constructor(e, t = xp) {
          super(t),
            (this.elements = {}),
            (this.elements.content = e),
            (this.options = t),
            (this.opened = !1),
            (this.model = Object.assign({}, JSON.parse(JSON.stringify(dp)))),
            (this.templates = {}),
            yp.forEach((e) => {
              this[e] = (...t) => {
                this[`__${e}`] &&
                  this[`__${e}`].forEach((e) => e.apply(this, t));
              };
            }),
            this._bindEvents(),
            ["beforeCreate", "created", "beforeMount"].forEach((e) =>
              this[e](t)
            );
        }
        appendContent(e, t) {
          up()(e) &&
            (t = t && up()(t) ? t : this.elements.contentContainer).appendChild(
              e
            );
        }
        removeContent(e) {
          e
            ? (this.elements.container.contains(e) && e.remove(),
              this.trigger(this.model.Events.CONTENT_REMOVED))
            : this._emptyContent();
        }
        scrollToModalTop() {
          this.elements.container.scrollTop = 0;
        }
        _emptyContent() {
          this.elements.contentContainer.innerHTML = "";
        }
        _bindEvents() {
          this.on(this.model.Events.WILLOPEN, this.onWillOpen),
            this.on(this.model.Events.OPEN, this.onOpen),
            this.on(this.model.Events.WILLCLOSE, this.onWillClose),
            this.on(this.model.Events.CLOSE, this.onClose);
        }
        _releaseEvents() {
          this.off(this.model.Events.WILLOPEN, this.onWillOpen),
            this.off(this.model.Events.OPEN, this.onOpen),
            this.off(this.model.Events.WILLCLOSE, this.onwillClose),
            this.off(this.model.Events.CLOSE, this.onClose);
        }
        static withMixins(...e) {
          const t = class extends bp {},
            n = t.prototype;
          return (
            [fp, ...e, vp, gp].forEach((e) => {
              for (const t in e)
                yp.includes(t)
                  ? ((n[`__${t}`] = n[`__${t}`] || []), n[`__${t}`].push(e[t]))
                  : (n[t] = e[t]);
            }),
            t
          );
        }
      }
      const _p = bp,
        wp = {
          created() {
            this.close = this.close.bind(this);
          },
          onWillOpen() {
            this._attachCloseEvents();
          },
          onClose() {
            this._removeCloseEvents(),
              document.documentElement.classList.remove(
                ...this.model.Open.Document.ClassNames
              ),
              this.elements.container.classList.remove(
                ...this.model.Open.Container.ClassNames
              );
          },
          mounted() {
            this.close.elements = Array.from(
              document.querySelectorAll(this.model.Close.Selector)
            );
          },
          destroy() {
            this.close();
          },
          close(e) {
            this.opened &&
              ((e &&
                "click" === e.type &&
                !this.close.elements.includes(e.target)) ||
                (this.trigger(this.model.Events.WILLCLOSE),
                this.trigger(this.model.Events.CLOSE)));
          },
          _removeCloseEvents() {
            this.elements.container &&
              this.elements.container.removeEventListener("click", this.close);
          },
          _attachCloseEvents() {
            this.elements.container &&
              this.elements.container.addEventListener("click", this.close);
          },
        },
        Mp = {
          created() {
            this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
          },
          beforeMount() {
            this._setCloseAriaLabel(), this.appendCloseButton();
          },
          mounted() {
            this.elements.closeButton.addEventListener(
              "click",
              this.onCloseButtonClick
            );
          },
          destroy() {
            this.elements.closeButton.removeEventListener(
              "click",
              this.onCloseButtonClick
            );
          },
          appendCloseButton() {
            (
              this.elements.container.querySelector(
                this.model.Elements.closeButton.ParentSelector
              ) || this.elements.container
            ).appendChild(this.elements.closeButton);
          },
          onCloseButtonClick(e) {
            this.close(e);
          },
          _setCloseAriaLabel() {
            if (
              this.elements.content &&
              this.elements.content.dataset.modalCloseLabel
            ) {
              let e = this.elements.content.dataset.modalCloseLabel;
              this.elements.closeButton.setAttribute("aria-label", e);
            }
          },
        };
      var Sp = n(8142),
        Tp = n.n(Sp),
        Ep = n(9697),
        Ap = n.n(Ep);
      const Lp = {
          created() {
            this.scrollToModalTop = this.scrollToModalTop.bind(this);
          },
          mounted() {
            Ap().getTabbableElements(this.dialogRoleElement).length &&
              (this._circularTab = new (Tp())(this.dialogRoleElement));
          },
          onOpen() {
            this._giveModalFocus();
          },
          onWillClose() {
            this._removeModalFocus();
          },
          destroy() {
            clearTimeout(this._focusTimeout),
              this._removeModalFocus(),
              this._circularTab && this._circularTab.destroy();
          },
          _giveModalFocus() {
            this.dialogRoleElement.removeAttribute("aria-hidden"),
              this.elements.container.classList.add("modal-touch-lock"),
              (this._activeElement = document.activeElement),
              this._circularTab && this._circularTab.start(!0),
              this.elements.container.addEventListener(
                "scroll",
                this.scrollToModalTop
              ),
              (this._focusTimeout = setTimeout(() => {
                this.dialogRoleElement.focus({ preventScroll: !0 }),
                  requestAnimationFrame(() => {
                    this.elements.container.removeEventListener(
                      "scroll",
                      this.scrollToModalTop
                    ),
                      this.elements.container.classList.remove(
                        "modal-touch-lock"
                      );
                  });
              }, 300));
          },
          _removeModalFocus() {
            this._circularTab && this._circularTab.stop(),
              this.dialogRoleElement.setAttribute("aria-hidden", "true"),
              this.elements.container.removeEventListener(
                "scroll",
                this.scrollToModalTop
              ),
              this._activeElement &&
                (this._activeElement.focus(), (this._activeElement = null));
          },
        },
        Pp = {
          beforeCreate() {
            this.model.Open.Document.ClassNames.push("has-modal-full-bleed");
          },
          beforeMount() {
            this.elements.container.classList.add(
              ...this.model.FullBleed.ClassNames
            );
          },
          destroy() {
            this.elements.container.classList.remove(
              ...this.model.FullBleed.ClassNames
            );
          },
        };
      var Rp = n(2405),
        Cp = n.n(Rp);
      const Ip = {
          created() {
            this.open = this.open.bind(this);
          },
          onWillOpen() {
            document.documentElement.classList.add(
              ...this.model.Open.Document.ClassNames
            ),
              this.elements.container.classList.add(
                ...this.model.Open.Container.ClassNames
              ),
              this.scrollToModalTop();
          },
          open() {
            this.opened ||
              (this.trigger(this.model.Events.WILLOPEN),
              this.trigger(this.model.Events.OPEN));
          },
        },
        Np = {
          beforeCreate() {
            this.model.Open.Document.ClassNames.push("has-modal-page-overlay"),
              (this._scrollBarWidth = 0);
          },
          beforeMount() {
            this.elements.container.classList.add(
              ...this.model.PageOverlay.ClassNames
            );
          },
          mounted() {
            this._saveScrollBarWidth();
          },
          onResizeDebounced() {
            this.opened || this._saveScrollBarWidth();
          },
          onWillOpen() {
            document.documentElement.style.setProperty(
              "--modal-scrollbar-buffer",
              this._scrollBarWidth
            );
          },
          onClose() {
            document.documentElement.style.removeProperty(
              "--modal-scrollbar-buffer"
            );
          },
          destroy() {
            this.elements.container.classList.remove(
              ...this.model.PageOverlay.ClassNames
            );
          },
          _saveScrollBarWidth() {
            this._scrollBarWidth =
              window.innerWidth - document.body.clientWidth + "px";
          },
        },
        Dp = {
          created() {
            (this._scrollX = 0), (this._scrollY = 0);
          },
          onWillOpen() {
            this._saveScrollPosition();
          },
          onClose() {
            this._restoreScrollPosition();
          },
          _saveScrollPosition() {
            (this._scrollX = document.documentElement.scrollLeft),
              (this._scrollY = document.documentElement.scrollTop);
          },
          _restoreScrollPosition() {
            window.scrollTo(this._scrollX, this._scrollY);
          },
        },
        Op = [wp, Mp],
        Fp = [...Op, Lp, Cp(), Ip, Pp, Dp];
      Cp();
      function kp(e, t) {
        return (
          (function (e) {
            if (Array.isArray(e)) return e;
          })(e) ||
          (function (e, t) {
            var n =
              null == e
                ? null
                : ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
                  e["@@iterator"];
            if (null != n) {
              var i,
                r,
                a,
                o,
                s = [],
                l = !0,
                c = !1;
              try {
                if (((a = (n = n.call(e)).next), 0 === t)) {
                  if (Object(n) !== n) return;
                  l = !1;
                } else
                  for (
                    ;
                    !(l = (i = a.call(n)).done) &&
                    (s.push(i.value), s.length !== t);
                    l = !0
                  );
              } catch (e) {
                (c = !0), (r = e);
              } finally {
                try {
                  if (
                    !l &&
                    null != n.return &&
                    ((o = n.return()), Object(o) !== o)
                  )
                    return;
                } finally {
                  if (c) throw r;
                }
              }
              return s;
            }
          })(e, t) ||
          zp(e, t) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function Hp(e) {
        return (
          (function (e) {
            if (Array.isArray(e)) return Up(e);
          })(e) ||
          (function (e) {
            if (
              ("undefined" != typeof Symbol && null != e[Symbol.iterator]) ||
              null != e["@@iterator"]
            )
              return Array.from(e);
          })(e) ||
          zp(e) ||
          (function () {
            throw new TypeError(
              "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          })()
        );
      }
      function zp(e, t) {
        if (e) {
          if ("string" == typeof e) return Up(e, t);
          var n = Object.prototype.toString.call(e).slice(8, -1);
          return (
            "Object" === n && e.constructor && (n = e.constructor.name),
            "Map" === n || "Set" === n
              ? Array.from(e)
              : "Arguments" === n ||
                /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
              ? Up(e, t)
              : void 0
          );
        }
      }
      function Up(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i;
      }
      function Bp(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var i = Object.getOwnPropertySymbols(e);
          t &&
            (i = i.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, i);
        }
        return n;
      }
      function Gp(e, t, n) {
        return (
          (t = (function (e) {
            var t = (function (e, t) {
              if ("object" !== Vp(e) || null === e) return e;
              var n = e[Symbol.toPrimitive];
              if (void 0 !== n) {
                var i = n.call(e, t || "default");
                if ("object" !== Vp(i)) return i;
                throw new TypeError(
                  "@@toPrimitive must return a primitive value."
                );
              }
              return ("string" === t ? String : Number)(e);
            })(e, "string");
            return "symbol" === Vp(t) ? t : String(t);
          })(t)) in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      function Vp(e) {
        return (
          (Vp =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          Vp(e)
        );
      }
      var Wp,
        jp,
        Xp,
        qp,
        Yp,
        Kp,
        Zp,
        Jp,
        Qp = null,
        $p = null,
        em = null,
        tm = null,
        nm = null,
        im = function () {
          var e,
            t = rm(
              window.__CHANNEL_HTML_3D_CONFIG__,
              JSON.parse(
                (null === (e = document.querySelector("[data-3d-config]")) ||
                void 0 === e
                  ? void 0
                  : e.dataset["3dConfig"]) || !1
              )
            );
          t
            ? ($d.logger(
                window.__CHANNEL_HTML_3D_CONFIG__
                  ? "Received Config Data From A File"
                  : "Received Config Data From Dataset Attribute"
              ),
              um(t))
            : $d.logger("Content data could not be found");
        },
        rm = function e(t, n) {
          if ("object" !== Vp(n) || "object" !== Vp(t)) return t;
          var i = (function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2
                ? Bp(Object(n), !0).forEach(function (t) {
                    Gp(e, t, n[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(
                    e,
                    Object.getOwnPropertyDescriptors(n)
                  )
                : Bp(Object(n)).forEach(function (t) {
                    Object.defineProperty(
                      e,
                      t,
                      Object.getOwnPropertyDescriptor(n, t)
                    );
                  });
            }
            return e;
          })({}, t);
          return (
            Object.keys(n).forEach(function (r) {
              "object" !== Vp(n[r]) ||
              !t.hasOwnProperty(r) ||
              Array.isArray(n[r])
                ? Array.isArray(n[r]) && 0 === n[r].length
                  ? (i[r] = t[r])
                  : (i[r] = n[r])
                : (i[r] = e(t[r], n[r]));
            }),
            i
          );
        },
        am = function (e) {
          var t = document.createElement("div");
          return (
            t.classList.add("channel-3d-product-viewer_progress-indicator"),
            (t.innerHTML =
              '<div class="channel-3d-product-viewer_progress-indicator_container">\n    <div class="channel-3d-product-viewer_progress-indicator_spoke1"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke2"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke3"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke4"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke5"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke6"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke7"></div>\n    <div class="channel-3d-product-viewer_progress-indicator_spoke8"></div>\n  </div>'),
            e ? e.appendChild(t) : document.body.appendChild(t),
            t
          );
        },
        om = function (e, t) {
          var n = g.prefersReducedMotion();
          $d.logger("Initializing Modal...");
          var i = {
            onOpen: function () {
              var e, t, n;
              ($d.logger("Modal Opened"),
              null !== (e = Qp) && void 0 !== e && e.initializing)
                ? Qp && (Qp.shouldModelRender = !0)
                : (null !== (t = Qp) && void 0 !== t && t.loaded
                    ? (Yp.classList.add("channel-3d-product-viewer_fade-in"),
                      Kp.classList.add("channel-3d-product-viewer_fade-up"))
                    : cm(),
                  lm(),
                  null === (n = Qp) || void 0 === n || n.onWindowResize());
            },
            onClose: function () {
              var e;
              $d.logger("Modal Closed"),
                lm(),
                Qp && (Qp.shouldModelRender = !1),
                null === (e = Qp) ||
                  void 0 === e ||
                  e.reset(Wp, Xp, function () {
                    var e, t;
                    document
                      .querySelectorAll(".colornav input")
                      .forEach(function (e) {
                        var t = e.dataset.index == Xp;
                        (e.checked = t), (e.ariaChecked = "".concat(t));
                      }),
                      Yp.classList.remove("channel-3d-product-viewer_fade-in"),
                      Kp.classList.remove("channel-3d-product-viewer_fade-up"),
                      null === (e = $p) ||
                        void 0 === e ||
                        e.classList.remove(
                          "channel-3d-product-viewer_fade-out"
                        ),
                      null === (t = $p) ||
                        void 0 === t ||
                        t.classList.remove("channel-3d-product-viewer_fade-in");
                  }),
                (
                  Wp.modalData.customModalEntryID &&
                  document.querySelector(
                    "#".concat(Wp.modalData.customModalEntryID)
                  )
                ).focus();
            },
          };
          tm = _p.withMixins.apply(_p, Hp(Fp).concat([i]));
          var r = document.createElement("div"),
            a =
              !!t.customModalEntryID &&
              document.querySelector("#".concat(t.customModalEntryID));
          r.classList.add("channel-3d-product-viewer_modal-content"),
            r.setAttribute(
              "data-modal-dialog-label",
              "".concat(Wp.axDeviceName, " 3D view")
            ),
            r.setAttribute("data-modal-close-label", "3D viewer close button"),
            r.appendChild(qp),
            a ||
              ((a = document.createElement("button")).classList.add(
                "channel-3d-product-viewer_modal-entry"
              ),
              a.setAttribute("id", "apple360Spin"),
              (a.innerText = t.defaultModalEntryText || "Open 3D Modal"),
              a.setAttribute(
                "aria-label",
                "Show 3D view for ".concat(Wp.axDeviceName)
              ),
              n && a.setAttribute("disabled", ""),
              e ? e.appendChild(a) : document.body.appendChild(a));
          var o = new tm(r, {
            attributes: {
              container: { class: "channel-3d-product-viewer_modal" },
            },
          });
          a.addEventListener("click", function (e) {
            $d.broadcast("click", "modal-open", { event: e }),
              o.open(),
              o.elements.closeButton.addEventListener("click", function (e) {
                $d.broadcast("click", "modal-close", { event: e });
              });
          }),
            (em = am(r)),
            $d.logger("Modal Setup Done!");
        },
        sm = function (e) {
          var t = document.querySelector(
              ".channel-3d-product-viewer_progress-indicator.visible"
            ),
            n = e.currentTarget.dataset.index;
          if (
            ($d.broadcast("click", "swatch:".concat(e.currentTarget.value), {
              event: e,
            }),
            document
              .querySelectorAll(".channel-3d-product-viewer_colornav-value")
              .forEach(function (e) {
                (e.disabled = !0), (e.ariaChecked = "false");
              }),
            Qp && (Qp.shouldModelRender = !0),
            (e.currentTarget.ariaChecked = "true"),
            !t && n)
          ) {
            var i = Qp.scene.getObjectByName("Scene");
            Qp.scene.remove(i),
              Qp.loadModel(
                jp.find(function (e) {
                  return e.index == n;
                }).filename,
                function () {
                  em.classList.contains("visible") &&
                    (em.classList.remove("visible"),
                    $d.logger(
                      "Hiding Progress Indicator from handleColorSwitch"
                    )),
                    document
                      .querySelectorAll(
                        ".channel-3d-product-viewer_colornav-value"
                      )
                      .forEach(function (e) {
                        return (e.disabled = !1);
                      });
                }
              );
          }
        },
        lm = function () {
          var e = document.documentElement.querySelector(
            ".channel-3d-product-viewer_canvas"
          );
          g.isHandheld() && window.innerWidth > window.innerHeight
            ? (Qp.pause(!0),
              document.documentElement.classList.add("channel-3d-is-landscape"),
              e && ((e.style.width = 0), (e.style.height = 0)))
            : (document.documentElement.classList.remove(
                "channel-3d-is-landscape"
              ),
              Qp && (Qp.pause(!1), Qp.onWindowResize()));
        },
        cm = function () {
          (Qp = new op(
            Yp,
            Kp,
            em,
            Wp.keyControlDistance,
            Wp.pathTextures,
            Wp.pathModels
          )).constructScene(Wp.cameraPosition),
            Qp.renderScene(
              Wp.iblFilename,
              Zp
                ? jp.find(function (e) {
                    return e.index === Xp;
                  }).filename
                : jp.filename,
              Wp.toneMapping,
              Wp.exposure,
              Wp.axDeviceName
            ),
            Qp.addControls(Wp.minDistance, Wp.maxDistance, Wp.dampingFactor),
            Qp.handleAutoRotate(Wp.autoRotate, Wp.autoRotateSpeed),
            Qp.renderer.domElement.addEventListener(
              "pointerdown",
              function (e) {
                var t, n;
                e.preventDefault(),
                  null === (t = $p) ||
                    void 0 === t ||
                    t.classList.remove("channel-3d-product-viewer_fade-in"),
                  null === (n = $p) ||
                    void 0 === n ||
                    n.classList.add("channel-3d-product-viewer_fade-out"),
                  ($p.ariaHidden = !0),
                  (e.currentTarget.style.cursor = "grabbing"),
                  Qp.handleAutoRotate(!1),
                  (Qp.renderFPS = ap);
              }
            ),
            Qp.renderer.domElement.addEventListener("pointerup", function (e) {
              e.currentTarget.style.cursor = "grab";
            }),
            ["orientationchange", "resize"].forEach(function (e) {
              window.addEventListener(e, function () {
                $d.logger("Event Detected: ".concat(e)),
                  lm(),
                  Qp.onWindowResize(!0);
              });
            }),
            lm(),
            (document.onkeydown = Qp.handleKeyDown),
            (function () {
              var e;
              function t() {
                var e, t, n;
                null !== (e = $p) &&
                  void 0 !== e &&
                  e.classList.contains("channel-3d-product-viewer_fade-out") &&
                  (null === (t = $p) ||
                    void 0 === t ||
                    t.classList.remove("channel-3d-product-viewer_fade-out"),
                  null === (n = $p) ||
                    void 0 === n ||
                    n.classList.add("channel-3d-product-viewer_fade-in"),
                  ($p.ariaHidden = !1));
              }
              function n() {
                var n = Jp;
                n > 0 && (clearTimeout(e), (e = setTimeout(t, 1e3 * n)));
              }
              (window.onload = n),
                (window.onmousemove = n),
                (window.onmousedown = n),
                (window.ontouchstart = n),
                (window.onclick = n),
                (window.onkeyup = n),
                Qp.controls.addEventListener("change", n);
            })(),
            $d.logger("Product Viewer Environment and Controls Setup Done!");
        },
        um = function (e) {
          $d.logger("Initializing Apple360Spin Setup..."),
            ((Wp = e).axDeviceName = Wp.axDeviceName || "iPhone"),
            (Wp.toneMapping = Wp.toneMapping || "None"),
            (Wp.exposure = Wp.exposure || 1);
          var t,
            n,
            i,
            r,
            a = g.prefersReducedMotion();
          (Zp = Array.isArray(Wp.modelFileData)),
            (t = Wp.className),
            (n = Wp.containerClass),
            (i = Wp.modalData),
            (r = !!n && document.querySelector(".".concat(n))),
            $d.logger("Creating Containers"),
            (qp = document.querySelector(
              ".channel-3d-product-viewer_section"
            )) ||
              (qp = document.createElement("section")).classList.add(
                "channel-3d-product-viewer_section"
              ),
            (Yp = document.createElement("div")).classList.add(
              "channel-3d-product-viewer_view-container",
              t || "channel-3d-product-viewer"
            ),
            (Kp = document.createElement("div")).classList.add(
              "channel-3d-product-viewer_ui-container"
            ),
            Yp.setAttribute("role", "img"),
            Yp.setAttribute("aria-label", "iPhone at 0 degrees by 0 degrees"),
            Yp.setAttribute("id", "channel-3d-product-viewer-canvas-container"),
            Yp.setAttribute("aria-live", "polite"),
            qp.appendChild(Yp),
            qp.appendChild(Kp),
            null != i && i.isModal
              ? om(r, i)
              : (r ? r.appendChild(qp) : document.body.appendChild(qp),
                (em = am(r)));
          var o,
            s,
            l =
              Wp.modalData.customModalEntryID &&
              document.querySelector(
                "#".concat(Wp.modalData.customModalEntryID)
              );
          ((Wp.pathTextures = l.dataset.texturesPath || Wp.pathTextures),
          (Wp.pathModels = l.dataset.modelsPath || Wp.pathModels),
          nm) ||
            (nm =
              null == l ||
              null === (o = l.dataset.selectedColor) ||
              void 0 === o
                ? void 0
                : o.toLowerCase().replace(" ", ""));
          if (a)
            $d.logger("Reduce Motion Detected"),
              Yp.classList.remove("channel-3d-product-viewer_spinner"),
              Yp.classList.add("channel-3d-product-viewer_fade-in"),
              (Yp.innerHTML = "<div>Reduced Motion feature is enabled.</div>");
          else {
            (Jp = Wp.idleResetTime || 10),
              Wp.modelNumberDetection &&
                Object.keys(Wp.modelNumberDetection).forEach(function (e) {
                  navigator.userAgent.includes(e) &&
                    Object.keys(Wp.modelNumberDetection[e]).forEach(function (
                      t
                    ) {
                      Wp[t] = Wp.modelNumberDetection[e][t];
                    });
                });
            var c = kp(
              (function (e, t) {
                $d.logger("Checking OS");
                var n = Object.keys(f.os).find(function (e) {
                  return !0 === f.os[e] && "version" !== e;
                });
                if (
                  ("osx" === n && navigator.maxTouchPoints > 1 && (n = "ios"),
                  $d.logger("OS found: ".concat(n)),
                  !e ||
                    Object.getPrototypeOf(e) !== Object.prototype ||
                    0 === Object.keys(e).length ||
                    !Object.prototype.hasOwnProperty.call(e, n))
                )
                  return [t, 0];
                var i = e[n].defaultSelectedModelIndex || 0,
                  r = e[n].order,
                  a = Hp(t);
                return (
                  r &&
                    r.length > 0 &&
                    (a = a
                      .filter(function (e) {
                        return r.indexOf(e.index) >= 0;
                      })
                      .sort(function (e, t) {
                        return r.indexOf(e.index) - r.indexOf(t.index);
                      })),
                  [a, i]
                );
              })(Wp.osDetection, Wp.modelFileData),
              2
            );
            if (((jp = c[0]), (Xp = c[1]), nm)) {
              var u = Wp.modelFileData.find(function (e) {
                return e.label.toLowerCase().replace(" ", "").includes(nm);
              });
              u && (Xp = u.index);
            }
            if (Wp.actionPromptDesktop || Wp.actionPromptMobile) {
              var h,
                d,
                p =
                  null !==
                    (h =
                      null !== (d = l.dataset.svgPath) && void 0 !== d
                        ? d
                        : Wp.svgPath) && void 0 !== h
                    ? h
                    : window.assetPath + "/rotate.svg";
              ($p = document.createElement("span")).classList.add(
                "channel-3d-product-viewer_prompt"
              ),
                $p.style.setProperty(
                  "--background",
                  "url(".concat(p, ") 0 0 no-repeat")
                ),
                ($p.tabIndex = -1),
                ($p.innerText =
                  f.os.ios ||
                  f.os.android ||
                  (f.os.osx && navigator.maxTouchPoints > 1) ||
                  g.touchAvailable()
                    ? Wp.actionPromptMobile || Wp.actionPromptDesktop
                    : Wp.actionPromptDesktop || Wp.actionPromptMobile),
                Kp.prepend($p);
            }
            Zp &&
              (function () {
                $d.logger("Adding Color Options");
                var e = document.createElement("fieldset");
                e.classList.add(
                  "colornav",
                  "channel-3d-product-viewer_colornav"
                ),
                  (e.innerHTML =
                    '\n  <legend class="channel-3d-product-viewer-legend">'
                      .concat(
                        Wp.axDeviceName,
                        ' Colors</legend>\n    <ul class="colornav-items channel-3d-product-viewer_colornav-items">\n    '
                      )
                      .concat(
                        jp
                          .map(function (e) {
                            var t = e.label.toLowerCase().replace(" ", "-");
                            return '\n        <li class="colornav-item channel-3d-product-viewer_colornav-item">\n          <input\n            type="radio"\n            name="colornav-value"\n            class="colornav-value channel-3d-product-viewer_colornav-value"\n            id="colornav-value-'
                              .concat(t, '"\n            value="')
                              .concat(t, '"\n            ')
                              .concat(
                                e.index === Xp ? " checked" : "",
                                '\n            aria-checked="'
                              )
                              .concat(
                                e.index === Xp ? "true" : "false",
                                '"\n            data-index="'
                              )
                              .concat(
                                e.index,
                                '" />\n          <label for="colornav-value-'
                              )
                              .concat(
                                t,
                                '" class="colornav-link channel-3d-product-viewer_colornav-link">\n            <span class="channel-3d-product-viewer_swatch-'
                              )
                              .concat(
                                t,
                                ' colornav-swatch">\n                <span class="colornav-label channel-3d-product-viewer_colornav-label">\n                  '
                              )
                              .concat(
                                e.labelName,
                                "\n                </span>\n            </span>\n          </label>\n        </li>"
                              );
                          })
                          .join(""),
                        "\n    </ul>"
                      )),
                  Kp.appendChild(e),
                  jp.forEach(function (e) {
                    if (e.color) {
                      var t = document.querySelector(
                        ".channel-3d-product-viewer_swatch-".concat(
                          e.label.toLowerCase().replace(" ", "-")
                        )
                      );
                      t && (t.style.backgroundColor = e.color);
                    }
                  }),
                  document
                    .querySelectorAll(
                      ".channel-3d-product-viewer_colornav-value"
                    )
                    .forEach(function (e) {
                      e.onclick = sm;
                    });
              })(),
              (s = document.createElement("div")).classList.add(
                "channel-3d-product-viewer_landscape-alert"
              ),
              (s.innerHTML = "Rotate your device<br>to view this experience"),
              qp.appendChild(s),
              lm(),
              !Wp.modalData.isModal && cm();
          }
          $d.logger("Apple360Spin Setup Done!");
        },
        hm = function () {
          (qp.innerHTML = ""),
            Qp && (Qp.destroy(), (Qp = null)),
            tm &&
              ((tm = null),
              document
                .querySelector(".channel-3d-product-viewer_modal")
                .remove());
        },
        dm = function () {
          hm(), im();
        };
      window.addEventListener("channel-html:3djs:init", im),
        window.addEventListener("channel-html:3djs:destroy", hm),
        window.addEventListener("channel-html:3djs:reset", dm),
        window.addEventListener(
          "channel-html:3djs:changeDefaultSelected",
          function (e) {
            var t, n;
            (nm =
              null === (t = e.detail) ||
              void 0 === t ||
              null === (n = t.selectedColor) ||
              void 0 === n
                ? void 0
                : n.toLowerCase().replace(" ", "")),
              dm();
          }
        ),
        document.currentScript.hasAttribute("data-self-init") &&
          window.addEventListener("DOMContentLoaded", function () {
            var e = new CustomEvent("channel-html:3djs:init");
            window.dispatchEvent(e);
          });
    })(),
    (window.__CHANNEL_HTML_3D_CONFIG__ = {
      className: "",
      axDeviceName: "iPhone 15 Plus",
      pathTextures: window.assetPath,
      pathModels: window.modelPath,
      containerClass: "apple360spin-container",
      svgPath: window.assetPath + "/rotate.svg",
      modalData: {
        isModal: !0,
        customModalEntryID: "apple360Spin",
        defaultModalEntryText: "",
      },
      modelFileData: [
        {
          label: "Pink",
          labelName: "Pink",
          color: "#F9DCDD",
          filename: "iphone_15-plus_no5g_pink.gltf",
          index: 0,
        },
        {
          label: "Yellow",
          labelName: "Yellow",
          color: "#F5EDC5",
          filename: "iphone_15-plus_no5g_yellow.gltf",
          index: 1,
        },
        {
          label: "Green",
          labelName: "Green",
          color: "#E2E8D3",
          filename: "iphone_15-plus_no5g_green.gltf",
          index: 2,
        },
        {
          label: "Blue",
          labelName: "Blue",
          color: "#8FBDD7",
          filename: "iphone_15-plus_no5g_blue.gltf",
          index: 3,
        },
        {
          label: "Black",
          labelName: "Black",
          color: "#353738",
          filename: "iphone_15-plus_no5g_black.gltf",
          index: 4,
        },
      ],
      iblFilename: "",
      toneMapping: "Linear",
      exposure: 1,
      cameraPosition: { x: 0, y: 0, z: -30 },
      minDistance: 30,
      maxDistance: 30,
      autoRotate: !1,
      autoRotateSpeed: -5,
      dampingFactor: 0.35,
      keyControlDistance: 15,
      actionPromptDesktop: "Drag to rotate",
      actionPromptMobile: "Swipe to rotate",
      idleResetTime: 10,
    });
})();
